/* THIS IS A GENERATED FILE - DO NOT MODIFY */
/* eslint-disable */
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/client/react/components';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AddDeliveryEventInput = {
  eventTypeId: Scalars['String']['input'];
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddLineDriveInput = {
  enabledDaysOfWeek: Array<Scalars['Int']['input']>;
  endHubId: Scalars['Int']['input'];
  endTime: TimeInput;
  startHubId: Scalars['Int']['input'];
  startTime: TimeInput;
};

export type AddOnItem = {
  __typename?: 'AddOnItem';
  addonType: AddOnItemType;
  displayText: Scalars['String']['output'];
  extraText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
};

export enum AddOnItemType {
  Donation = 'DONATION',
  Side = 'SIDE'
}

export type AddUserFromHubInput = {
  hubIds: Array<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  archived: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  linkedSubscriptionId?: Maybe<Scalars['String']['output']>;
  longitude: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  phone: Scalars['String']['output'];
  province: Scalars['String']['output'];
  route?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  streetNumber?: Maybe<Scalars['String']['output']>;
  timeWindows: Array<TimeWindow>;
  unit?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
  zipCodeInfo?: Maybe<ZipCode>;
};


export type AddressTimeWindowsArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  province: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type AdminAddGroupOrderResult = MutationResponse & {
  __typename?: 'AdminAddGroupOrderResult';
  groupOrder?: Maybe<GroupOrder>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminBulkGiftCardsInput = {
  emails: Array<Scalars['String']['input']>;
  month: Scalars['String']['input'];
  valueInCents: Scalars['Int']['input'];
};

export type AdminBulkPartnerGiftCardsInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  giftCodeNames: Array<Scalars['String']['input']>;
  valueInCents: Scalars['Int']['input'];
};

export type AdminBulkRechargeGiftCardsInput = {
  addedValueInCents: Scalars['Int']['input'];
  giftCodeNames: Array<Scalars['String']['input']>;
};

export type AdminBulkShefGiftCardsInput = {
  message: Scalars['String']['input'];
  shefUserIds: Array<Scalars['String']['input']>;
  valueInCents: Scalars['Int']['input'];
};

export type AdminCreateEventConfig = {
  destination?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
  sampleRate: Scalars['Float']['input'];
};

export type AdminModifyGroupOrderInput = {
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  orderStatus?: InputMaybe<OrderStatus>;
  phone?: InputMaybe<Scalars['String']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminOrganizationsResults = {
  __typename?: 'AdminOrganizationsResults';
  organizations: Array<Organization>;
  pagination: Pagination;
};

export type AdminPromoCodeResults = {
  __typename?: 'AdminPromoCodeResults';
  pagination: Pagination;
  promoCodes: Array<PromoCode>;
};

export type AdminShefApplicationUpdateInput = {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  archiveReason?: InputMaybe<Scalars['String']['input']>;
  bioEditedAt?: InputMaybe<Scalars['DateTime']['input']>;
  informationSessionCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  menuWebinarCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  offWaitlistAt?: InputMaybe<Scalars['DateTime']['input']>;
  orientationCallCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  orientationCallMissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  orientationCallScheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  profilePhotoRejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  starterKitPickedUpAt?: InputMaybe<Scalars['DateTime']['input']>;
  tastingMarkedMissingAt?: InputMaybe<Scalars['DateTime']['input']>;
  tastingReceivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tastingResult?: InputMaybe<Scalars['String']['input']>;
  tastingResultReceivedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminShefFoodhandlersResults = {
  __typename?: 'AdminShefFoodhandlersResults';
  pagination: Pagination;
  shefs: Array<User>;
};

export type AdminShefResults = {
  __typename?: 'AdminShefResults';
  pagination: Pagination;
  shefs: Array<User>;
};

export type AdminSkipMealPlanGroupOrderInput = {
  deliveryDate: Scalars['String']['input'];
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AdminSkipMealPlanGroupOrderResponse = MutationResponse & {
  __typename?: 'AdminSkipMealPlanGroupOrderResponse';
  groupOrderId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminUpdateEventConfig = {
  destination?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
  sampleRate: Scalars['Float']['input'];
};

export type AdminUserResults = {
  __typename?: 'AdminUserResults';
  pagination: Pagination;
  users: Array<User>;
};

export type AlgoliaPaginationResult = {
  __typename?: 'AlgoliaPaginationResult';
  isEnd: Scalars['Boolean']['output'];
  nbHits?: Maybe<Scalars['Int']['output']>;
  queryIdx: Scalars['Int']['output'];
};

export type AlgoliaPaginationState = {
  isEnd: Scalars['Boolean']['input'];
  nbHits?: InputMaybe<Scalars['Int']['input']>;
  queryIdx: Scalars['Int']['input'];
};

export enum ApplicationStatus {
  FoodTastingConfirmed = 'FOOD_TASTING_CONFIRMED',
  FoodTastingReminded = 'FOOD_TASTING_REMINDED',
  FoodTastingScheduled = 'FOOD_TASTING_SCHEDULED',
  OnboardingCallScheduled = 'ONBOARDING_CALL_SCHEDULED',
  Open = 'OPEN',
  OrientationCallScheduled = 'ORIENTATION_CALL_SCHEDULED'
}

export enum AuditFitnessFunction {
  Baseline = 'BASELINE',
  CuisineType = 'CUISINE_TYPE',
  FieldsChanged = 'FIELDS_CHANGED',
  ShefPopularity = 'SHEF_POPULARITY'
}

export enum AuditStatus {
  Failure = 'FAILURE',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Success = 'SUCCESS'
}

export type AuthResult = AuthResults & {
  __typename?: 'AuthResult';
  isExistingUser: Scalars['Boolean']['output'];
  isImpersonatedUser?: Maybe<Scalars['Boolean']['output']>;
  token: Scalars['String']['output'];
  user: User;
};

export type AuthResult3 = AuthResults & {
  __typename?: 'AuthResult3';
  isExistingUser?: Maybe<Scalars['Boolean']['output']>;
  isImpersonatedUser?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type AuthResults = {
  isExistingUser?: Maybe<Scalars['Boolean']['output']>;
  isImpersonatedUser?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum AuthRole {
  Admin = 'ADMIN',
  ApprovedShef = 'APPROVED_SHEF',
  CustomLogicOnResolver = 'CUSTOM_LOGIC_ON_RESOLVER',
  MenuCurator = 'MENU_CURATOR',
  Owner = 'OWNER',
  PhotoEditor = 'PHOTO_EDITOR',
  Public = 'PUBLIC',
  RelatedShef = 'RELATED_SHEF',
  Shef = 'SHEF'
}

export type AvailableSubcuisine = {
  __typename?: 'AvailableSubcuisine';
  shefCount: Scalars['Int']['output'];
  subcuisine: CuisineCategory;
};

export enum BrowseFilter {
  Cuisine = 'CUISINE',
  Dietary = 'DIETARY',
  Protein = 'PROTEIN'
}

export type BulkAdminShefApplicationUpdateInput = {
  shefApplicationUpdateInput: AdminShefApplicationUpdateInput;
  shefId: Scalars['String']['input'];
};

export type BulkDiscountTier = {
  __typename?: 'BulkDiscountTier';
  discountRate: Scalars['Float']['output'];
  maxSubtotal?: Maybe<Scalars['Int']['output']>;
  minSubtotal: Scalars['Int']['output'];
};

export type BundleFoodItem = {
  __typename?: 'BundleFoodItem';
  foodItem: FoodItem;
  foodItemId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type CacheOptionsInput = {
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  staleWhileRevalidate?: InputMaybe<Scalars['Int']['input']>;
};

export enum CancelOrderNotificationFrequency {
  AllOrders = 'ALL_ORDERS',
  NeverNotify = 'NEVER_NOTIFY'
}

export type CartAddOnItem = {
  __typename?: 'CartAddOnItem';
  addOnItem: AddOnItem;
  addOnItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type CartDeliveryDateSpend = {
  __typename?: 'CartDeliveryDateSpend';
  deliveryDate: Scalars['String']['output'];
  spend: Scalars['Int']['output'];
};

export type CartLineItem = {
  __typename?: 'CartLineItem';
  createdAt: Scalars['String']['output'];
  customizationIds?: Maybe<Array<Scalars['String']['output']>>;
  foodItem: FoodItem;
  foodItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  shef: PublicShef;
  shefId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CartLineItemInput = {
  customizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  foodItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type CartResults = {
  __typename?: 'CartResults';
  addOnItems: Array<CartAddOnItem>;
  bulkDiscountTiers: Array<BulkDiscountTier>;
  deliveryDateSpend: Array<CartDeliveryDateSpend>;
  foodItems: Array<CartLineItem>;
  recentlyAdded: Scalars['Boolean']['output'];
};

export type CategoricalRatings = {
  __typename?: 'CategoricalRatings';
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type CategoricalRatingsResults = {
  __typename?: 'CategoricalRatingsResults';
  negativeRatings: Array<CategoricalRatings>;
  positiveRatings: Array<CategoricalRatings>;
};

export type CategoryPageContent = {
  __typename?: 'CategoryPageContent';
  fadeSegmentBackground?: Maybe<Scalars['Boolean']['output']>;
  heroBackgroundUrl?: Maybe<Scalars['String']['output']>;
  heroBackgroundUrlDesktop?: Maybe<Scalars['String']['output']>;
  heroBackgroundUrlTablet?: Maybe<Scalars['String']['output']>;
  illustrationUrl?: Maybe<Scalars['String']['output']>;
  moreCuisinesBackgroundUrl: Scalars['String']['output'];
  moreCuisinesBackgroundUrlDesktop?: Maybe<Scalars['String']['output']>;
  moreCuisinesBackgroundUrlTablet?: Maybe<Scalars['String']['output']>;
  pageType: CategoryPageType;
  patternedStripUrl: Scalars['String']['output'];
  referralStripBackgroundUrl: Scalars['String']['output'];
  referralStripBackgroundUrlDesktop?: Maybe<Scalars['String']['output']>;
  referralStripBackgroundUrlTablet?: Maybe<Scalars['String']['output']>;
  referralStripTextColor: ReferralStripTextColor;
  searchSuggestions?: Maybe<Array<CategoryPageSearchSuggestion>>;
  segmentBackgroundUrl: Scalars['String']['output'];
  segmentBackgroundUrlDesktop?: Maybe<Scalars['String']['output']>;
  segmentBackgroundUrlTablet?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CategoryPageRecentReviewResult = {
  __typename?: 'CategoryPageRecentReviewResult';
  recentReviews: Array<RecentReview>;
};

export type CategoryPageSearchSuggestion = {
  __typename?: 'CategoryPageSearchSuggestion';
  display: Scalars['String']['output'];
  searchQuery?: Maybe<Scalars['String']['output']>;
};

export enum CategoryPageType {
  SubCuisine = 'SUB_CUISINE',
  TopLevel = 'TOP_LEVEL'
}

export enum CelebrityEventType {
  BingingWithBabish = 'BINGING_WITH_BABISH',
  MasterChefNyesha = 'MASTER_CHEF_NYESHA'
}

export enum ChangeRequestChangeTypeFilter {
  All = 'ALL',
  HasPhoto = 'HAS_PHOTO',
  NoPhoto = 'NO_PHOTO'
}

export enum ChangeRequestFoodTypeFilter {
  All = 'ALL',
  Main = 'MAIN',
  Side = 'SIDE'
}

export enum ChangeRequestPhotoStatusFilter {
  All = 'ALL',
  Approved = 'APPROVED',
  NeedsPhotoEdits = 'NEEDS_PHOTO_EDITS',
  NeedsPhotoEditsReview = 'NEEDS_PHOTO_EDITS_REVIEW',
  New = 'NEW',
  Uneditable = 'UNEDITABLE'
}

export enum ChangeRequestShefTypeFilter {
  All = 'ALL',
  MarketplaceShef = 'MARKETPLACE_SHEF',
  MealPlanShef = 'MEAL_PLAN_SHEF'
}

export enum ChangeRequestUserTypeFilter {
  All = 'ALL',
  Applicants = 'APPLICANTS',
  Approved = 'APPROVED'
}

export type CityPageCity = {
  __typename?: 'CityPageCity';
  cityName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  publishedAt: Scalars['Date']['output'];
  source: Scalars['String']['output'];
  stateNameLong: Scalars['String']['output'];
  stateNameShort: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  zipCode: Scalars['String']['output'];
  zipCodeInfo: ZipCode;
};

export type CityPageContent = {
  __typename?: 'CityPageContent';
  dishes: Array<CityPageDish>;
  numDishes: Scalars['Int']['output'];
  shefs: Array<CityPageShef>;
};

export type CityPageDish = {
  __typename?: 'CityPageDish';
  averageRating: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  portion: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  ratingCount: Scalars['Int']['output'];
  shef: CityPageDishShefInfo;
  slug?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type CityPageDishShefInfo = {
  __typename?: 'CityPageDishShefInfo';
  businessName?: Maybe<Scalars['String']['output']>;
  formattedCuisineCategories?: Maybe<Scalars['String']['output']>;
  publicName: Scalars['String']['output'];
};

export type CityPageFilter = {
  __typename?: 'CityPageFilter';
  cuisineCategory?: Maybe<CuisineCategory>;
  cuisineCategoryId?: Maybe<Scalars['String']['output']>;
  dietaryFilter?: Maybe<Scalars['String']['output']>;
};

export type CityPageFilterInput = {
  cuisineCategoryId?: InputMaybe<Scalars['String']['input']>;
  dietaryFilter?: InputMaybe<Scalars['String']['input']>;
};

export type CityPageShef = {
  __typename?: 'CityPageShef';
  bio?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  formattedCuisineCategories?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  publicName: Scalars['String']['output'];
  rating?: Maybe<ShefRating>;
};

export type CombinedSearchResults = {
  __typename?: 'CombinedSearchResults';
  cuisineResults: Array<CuisineSearchResult>;
  dishResults: DishSearchResults;
  shefResults: ShefSearchResults;
  showGiftCardResult: Scalars['Boolean']['output'];
};

export type Config = {
  __typename?: 'Config';
  id: Scalars['Int']['output'];
  name: FeatureName;
  overrides: Array<ConfigOverride>;
  type: ConfigType;
  value: Scalars['String']['output'];
};

export type ConfigOverride = {
  __typename?: 'ConfigOverride';
  id: Scalars['Int']['output'];
  segment: Scalars['String']['output'];
  segmentValue?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ConfigOverrideInput = {
  segment: Scalars['String']['input'];
  segmentValue?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export enum ConfigSegmentValueType {
  Json = 'JSON'
}

export enum ConfigType {
  Bool = 'BOOL',
  Json = 'JSON',
  Number = 'NUMBER',
  String = 'STRING'
}

export type ConsumerModifyGroupOrderInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  addOnItemsSubtotal: Scalars['Int']['input'];
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  perShefOrders: Array<PerShefOrderModifyInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  replaceRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  shefTip: Scalars['Int']['input'];
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsumerModifyOrderInput = {
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  modifyLineItems?: InputMaybe<ModifyLineItemInput>;
  orderId: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  replaceRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsumerOrderResults = {
  __typename?: 'ConsumerOrderResults';
  count: Scalars['Int']['output'];
  orders: Array<Order>;
};

export enum ConsumerOrderStatus {
  Delivered = 'DELIVERED',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Received = 'RECEIVED',
  ShefCooking = 'SHEF_COOKING',
  ShefPrepping = 'SHEF_PREPPING'
}

export type ConsumerOrderTotal = {
  __typename?: 'ConsumerOrderTotal';
  deliveryFee: Scalars['Int']['output'];
  /**
   * Deprecated: Use `promoApplied`. This value will equal `promoApplied` for now
   * @deprecated Use promoApplied
   */
  discountApplied: Scalars['Int']['output'];
  /**
   * Deprecated: use `promoBalance`. This value will always equal `promoBalance`
   * @deprecated Use promoBalance
   */
  discountBalance: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  /** Temporary property to hold amount deducted via discounts */
  nonPromoDiscountApplied: Scalars['Int']['output'];
  /** Amount deducted from order using a promo code */
  promoApplied: Scalars['Int']['output'];
  /** Amount left that can be refunded to the promo code */
  promoBalance: Scalars['Int']['output'];
  refund: Scalars['Int']['output'];
  /** Amount left that can be refunded to the user's payment method */
  refundableBalance: Scalars['Int']['output'];
  salesTax: Scalars['Int']['output'];
  serviceFee: Scalars['Int']['output'];
  shefTip: Scalars['Int']['output'];
  smallOrderFee: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
};

export type ConsumerReferralInfo = {
  __typename?: 'ConsumerReferralInfo';
  adImageUrl?: Maybe<Scalars['String']['output']>;
  code?: Maybe<ReferralCode>;
  earningsInCents?: Maybe<Scalars['Int']['output']>;
  eligibleAt?: Maybe<Scalars['Date']['output']>;
  referredCount?: Maybe<Scalars['Int']['output']>;
  referredCountUnique?: Maybe<Scalars['Int']['output']>;
};

export type ContentItem = FoodItem | PublicShef;

export type CountMealPlanShefsForRegionIdResults = {
  __typename?: 'CountMealPlanShefsForRegionIdResults';
  shefCount: Scalars['Int']['output'];
};

export type CreateAddOnItemInput = {
  displayText: Scalars['String']['input'];
  extraText?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
};

export type CreateHeldMealPlanGroupOrderFromPerShefOrdersInput = {
  deliveryDate: Scalars['String']['input'];
  isAcceptingTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  isOptingIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  mealPlanId: Scalars['String']['input'];
  perShefOrders: Array<PerShefOrderInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  shouldCreatePlaceholder?: InputMaybe<Scalars['Boolean']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateHeldMealPlanGroupOrderFromPerShefOrdersResponse = MutationResponse & {
  __typename?: 'CreateHeldMealPlanGroupOrderFromPerShefOrdersResponse';
  groupOrder?: Maybe<GroupOrder>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateHeldMealPlanGroupOrderInput = {
  deliveryDate: Scalars['String']['input'];
  mealPlanId: Scalars['String']['input'];
};

export type CreateMerchandisePageTagFilterInput = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  pageId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type CuisineCategory = {
  __typename?: 'CuisineCategory';
  ancestorCuisines: Array<CuisineCategory>;
  categoryPageContent?: Maybe<CategoryPageContent>;
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  subcuisines: Array<CuisineCategory>;
  title: Scalars['String']['output'];
  type: CuisineCategoryType;
};

export enum CuisineCategoryType {
  Allergen = 'ALLERGEN',
  Dietary = 'DIETARY',
  FoodItemSpecialty = 'FOOD_ITEM_SPECIALTY',
  FoodStyle = 'FOOD_STYLE',
  Holiday = 'HOLIDAY',
  Internal = 'INTERNAL',
  Region = 'REGION',
  RegionCountry = 'REGION_COUNTRY',
  RegionStyle = 'REGION_STYLE',
  RegionSubregion = 'REGION_SUBREGION',
  Verified = 'VERIFIED'
}

export enum CuisineRegion {
  African = 'AFRICAN',
  American = 'AMERICAN',
  Asian = 'ASIAN',
  BakedGoods = 'BAKED_GOODS',
  Bangladeshi = 'BANGLADESHI',
  Caribbean = 'CARIBBEAN',
  Chinese = 'CHINESE',
  Donations = 'DONATIONS',
  EasternEuropean = 'EASTERN_EUROPEAN',
  European = 'EUROPEAN',
  French = 'FRENCH',
  Fusion = 'FUSION',
  Hungarian = 'HUNGARIAN',
  Indian = 'INDIAN',
  International = 'INTERNATIONAL',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  LatinAmerican = 'LATIN_AMERICAN',
  Mediterranean = 'MEDITERRANEAN',
  Mexican = 'MEXICAN',
  MiddleEastern = 'MIDDLE_EASTERN',
  NativeAmerican = 'NATIVE_AMERICAN',
  Nepalese = 'NEPALESE',
  Other = 'OTHER',
  Pakistani = 'PAKISTANI',
  Russian = 'RUSSIAN',
  SoutheastAsian = 'SOUTHEAST_ASIAN',
  Southern = 'SOUTHERN',
  SouthAsian = 'SOUTH_ASIAN',
  SouthPacific = 'SOUTH_PACIFIC',
  Specialty = 'SPECIALTY'
}

export type CuisineSearchResult = {
  __typename?: 'CuisineSearchResult';
  category: CuisineCategory;
  numDishes: Scalars['Int']['output'];
  numShefs: Scalars['Int']['output'];
};

export enum CustomizationCategory {
  ServingSize = 'SERVING_SIZE',
  SpiceLevel = 'SPICE_LEVEL'
}

export type DateRange = {
  __typename?: 'DateRange';
  begin?: Maybe<Scalars['DateTime']['output']>;
  bounds: Scalars['String']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
};

export type DayStats = {
  __typename?: 'DayStats';
  date?: Maybe<Scalars['DateTime']['output']>;
  grossSum?: Maybe<Scalars['Int']['output']>;
  orderCount?: Maybe<Scalars['Int']['output']>;
  valueSum?: Maybe<Scalars['Int']['output']>;
};

export type DeleteDeliveryEventInput = {
  eventTypeId: Scalars['String']['input'];
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
};

export type Delivery = {
  __typename?: 'Delivery';
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhone?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryTime?: Maybe<Scalars['DateTime']['output']>;
  estimatedPickupTime?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  tip?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum DeliveryDateChangePossible {
  No = 'NO',
  WithOrderChanges = 'WITH_ORDER_CHANGES',
  Yes = 'YES'
}

export type DeliveryDaysInput = {
  fridayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  mondayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  saturdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  sundayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  thursdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  tuesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  type: GeoInputType;
  wednesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeliveryEvent = {
  __typename?: 'DeliveryEvent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<User>;
  creatorUserId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  eventType?: Maybe<DeliveryEventType>;
  eventTypeId: Scalars['String']['output'];
  groupOrderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  meta?: Maybe<Scalars['JSON']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DeliveryEventType = {
  __typename?: 'DeliveryEventType';
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeliveryHub = {
  __typename?: 'DeliveryHub';
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  dropoffWindowEndTimeMinutesFromMidnight?: Maybe<Scalars['Int']['output']>;
  dropoffWindowStartTimeMinutesFromMidnight?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pickupInstructions: Scalars['String']['output'];
  province: Scalars['String']['output'];
  street: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type DeliveryPrice = {
  __typename?: 'DeliveryPrice';
  deliveryDiscount: Scalars['Int']['output'];
  finalDeliveryPrice: Scalars['Int']['output'];
  rawDeliveryCost: Scalars['Int']['output'];
};

export type DeliveryTimeRange = {
  __typename?: 'DeliveryTimeRange';
  endMinutesOffset: Scalars['Int']['output'];
  startMinutesOffset: Scalars['Int']['output'];
};

export type DeliveryWindow = {
  __typename?: 'DeliveryWindow';
  enabled: Scalars['Boolean']['output'];
  timeWindow?: Maybe<TimeWindow>;
  timeWindowId: Scalars['Int']['output'];
};

export enum DietType {
  Halal = 'halal',
  Omnivore = 'omnivore',
  Paleo = 'paleo',
  Pescatarian = 'pescatarian',
  Vegan = 'vegan',
  Vegetarian = 'vegetarian',
  Whole30 = 'whole30'
}

export type DietaryAnalysis = {
  __typename?: 'DietaryAnalysis';
  containsNuts?: Maybe<Scalars['Boolean']['output']>;
  dairyFree?: Maybe<Scalars['Boolean']['output']>;
  glutenFree?: Maybe<Scalars['Boolean']['output']>;
  lowFodmap?: Maybe<Scalars['Boolean']['output']>;
  paleo?: Maybe<Scalars['Boolean']['output']>;
  vegan?: Maybe<Scalars['Boolean']['output']>;
  vegetarian?: Maybe<Scalars['Boolean']['output']>;
  whole30?: Maybe<Scalars['Boolean']['output']>;
};

export type DietaryDetails = {
  __typename?: 'DietaryDetails';
  dietaryTag: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  responses: Array<VerifiedDietaryResponse>;
  summaryDisplay: Scalars['String']['output'];
  summaryExplanation?: Maybe<Scalars['String']['output']>;
  summaryId: Scalars['String']['output'];
};

export enum DietaryRestriction {
  DairyFree = 'dairyFree',
  GlutenFree = 'glutenFree'
}

/**
 * The different types of content in segments
 *
 * Note: if a new type is added to this union, you'll need to manually add it to the
 * `IDishFirstContentItem` type in './explore/dish-first/types'
 */
export type DishFirstContentItem = CuisineCategory | ExploreSegmentShef | FoodItem | PublicShef;

export enum DishFirstSegmentFilter {
  African = 'AFRICAN',
  All = 'ALL',
  American = 'AMERICAN',
  BakedGoods = 'BAKED_GOODS',
  BalancedMeals = 'BALANCED_MEALS',
  Bangladeshi = 'BANGLADESHI',
  BowlsAndPlates = 'BOWLS_AND_PLATES',
  BuyItAgain = 'BUY_IT_AGAIN',
  Caribbean = 'CARIBBEAN',
  Chinese = 'CHINESE',
  Classics = 'CLASSICS',
  ConsumerPackagedGoods = 'CONSUMER_PACKAGED_GOODS',
  Cuisines = 'CUISINES',
  Customizations = 'CUSTOMIZATIONS',
  Desserts = 'DESSERTS',
  FamilySize = 'FAMILY_SIZE',
  FarmersMarket = 'FARMERS_MARKET',
  Favorites = 'FAVORITES',
  French = 'FRENCH',
  Healthy = 'HEALTHY',
  Hungarian = 'HUNGARIAN',
  Indian = 'INDIAN',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  KidFriendly = 'KID_FRIENDLY',
  Korean = 'KOREAN',
  LatinAmerican = 'LATIN_AMERICAN',
  LocalIndianMarket = 'LOCAL_INDIAN_MARKET',
  LunarNewYear = 'LUNAR_NEW_YEAR',
  Mediterranean = 'MEDITERRANEAN',
  Mexican = 'MEXICAN',
  MiddleEastern = 'MIDDLE_EASTERN',
  MixedHalalKitchen = 'MIXED_HALAL_KITCHEN',
  MothersDay = 'MOTHERS_DAY',
  Nepalese = 'NEPALESE',
  New = 'NEW',
  NewShefs = 'NEW_SHEFS',
  NextDay = 'NEXT_DAY',
  Pakistani = 'PAKISTANI',
  Professional = 'PROFESSIONAL',
  Promos = 'PROMOS',
  RecommendedShefs = 'RECOMMENDED_SHEFS',
  Russian = 'RUSSIAN',
  ShefsYouFollow = 'SHEFS_YOU_FOLLOW',
  SoutheastAsian = 'SOUTHEAST_ASIAN',
  Southern = 'SOUTHERN',
  Specialty = 'SPECIALTY',
  StaffPicks = 'STAFF_PICKS',
  StrictHalalKitchen = 'STRICT_HALAL_KITCHEN',
  Trial = 'TRIAL',
  WalletFriendly = 'WALLET_FRIENDLY',
  Winter = 'WINTER'
}

export type DishSearchResults = {
  __typename?: 'DishSearchResults';
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  results: Array<FoodItem>;
};

export type DropOffScanInput = {
  droppedOffAt?: InputMaybe<Scalars['DateTime']['input']>;
  droppedOffWithinWindow: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
  scannedAtHubId: Scalars['Int']['input'];
};

export type DuplicateOrderToCartResponse = {
  __typename?: 'DuplicateOrderToCartResponse';
  addedItems: Array<CartLineItem>;
  success: Scalars['Boolean']['output'];
};

export type ExpectedPaginationInfoInput = {
  expectedPreviousPageFinalItemId: Scalars['String']['input'];
  expectedPreviousPageFinalSegmentId: Scalars['String']['input'];
};

export type Experiment = {
  __typename?: 'Experiment';
  name: Scalars['String']['output'];
  rollout?: Maybe<Scalars['Int']['output']>;
  selectedVariant?: Maybe<Scalars['String']['output']>;
  variants: Array<Variant>;
};

export type ExploreCuisineResults = {
  __typename?: 'ExploreCuisineResults';
  ancestorCuisinesAvailability: Array<CuisineSearchResult>;
  availableDeliveryDays: Array<Scalars['String']['output']>;
  segments: Array<ExploreSegment>;
};

export type ExploreFilterOptionsResults = {
  __typename?: 'ExploreFilterOptionsResults';
  availableDeliveryDays: Array<NumberAvailableShefsResult>;
  availableSegmentFilterIcons: Array<SegmentFilter>;
  availableSubcuisines: Array<AvailableSubcuisine>;
  isEcoFriendlyFilterAvailable: Scalars['Boolean']['output'];
};

export type ExploreFoodItemsContent = {
  __typename?: 'ExploreFoodItemsContent';
  isInPreview: Scalars['Boolean']['output'];
  items: Array<DishFirstContentItem>;
  total: Scalars['Int']['output'];
};

export type ExploreFoodItemsFilterInput = {
  availabilityDates?: InputMaybe<Array<Scalars['String']['input']>>;
  browseFilter?: InputMaybe<BrowseFilter>;
  cuisineFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  dishTypeFilters?: InputMaybe<Array<FoodTypeCoalesced>>;
  isEcoFriendlyPackaging?: InputMaybe<Scalars['Boolean']['input']>;
  minDishRating?: InputMaybe<Scalars['Int']['input']>;
  priceLevelFilters?: InputMaybe<Array<PriceLevel>>;
  proteinFilters?: InputMaybe<Array<Protein>>;
  segmentFilters?: InputMaybe<Array<DishFirstSegmentFilter>>;
  smallScreen?: InputMaybe<Scalars['Boolean']['input']>;
  spiceLevelFilters?: InputMaybe<Array<Scalars['Int']['input']>>;
  tagFilters?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExploreFoodItemsFilterOptionsResults = {
  __typename?: 'ExploreFoodItemsFilterOptionsResults';
  availableCuisines: Array<CuisineCategory>;
  availableDeliveryDays: Array<NumberAvailableDishesResult>;
  isEcoFriendlyFilterAvailable: Scalars['Boolean']['output'];
  totalShefs: Scalars['Int']['output'];
};

export type ExploreFoodItemsPreviewFilter = {
  __typename?: 'ExploreFoodItemsPreviewFilter';
  availabilityDates?: Maybe<Array<Scalars['String']['output']>>;
  cuisineFilters?: Maybe<Array<Scalars['String']['output']>>;
  dietaryFilters?: Maybe<Array<Scalars['String']['output']>>;
  dishTypeFilters?: Maybe<Array<FoodTypeCoalesced>>;
  isEcoFriendlyPackaging?: Maybe<Scalars['Boolean']['output']>;
  minDishRating?: Maybe<Scalars['Int']['output']>;
  priceLevelFilters?: Maybe<Array<PriceLevel>>;
  proteinFilters?: Maybe<Array<Protein>>;
  spiceLevelFilters?: Maybe<Array<Scalars['Int']['output']>>;
  tagFilters?: Maybe<Array<Scalars['String']['output']>>;
};

export type ExploreFoodItemsSegment = {
  __typename?: 'ExploreFoodItemsSegment';
  cacheKey: Scalars['String']['output'];
  categoryPageContent?: Maybe<CategoryPageContent>;
  content: ExploreFoodItemsContent;
  displayName: Scalars['String']['output'];
  heroImageSrc?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<SegmentIcon>;
  id: Scalars['String']['output'];
  layout: ExploreFoodItemsSegmentLayout;
  preview?: Maybe<ExploreFoodItemsSegmentPreview>;
  subtitle?: Maybe<Scalars['String']['output']>;
};


export type ExploreFoodItemsSegmentContentArgs = {
  filter?: InputMaybe<ExploreFoodItemsFilterInput>;
};

export enum ExploreFoodItemsSegmentLayout {
  Carousel = 'CAROUSEL',
  Cuisines = 'CUISINES',
  Generic = 'GENERIC'
}

export type ExploreFoodItemsSegmentPreview = {
  __typename?: 'ExploreFoodItemsSegmentPreview';
  seeAllFilter?: Maybe<ExploreFoodItemsPreviewFilter>;
  seeAllText: Scalars['String']['output'];
  showAllFiltersWhenExpanded: Scalars['Boolean']['output'];
};

export type ExploreMerchandisePage = {
  __typename?: 'ExploreMerchandisePage';
  excludeTagsOp: TaggedShefOp;
  heroPhotoUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  includeTagsOp: TaggedShefOp;
  pageName: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  tagFilters: Array<ExploreMerchandisePageTagFilter>;
  title: Scalars['String']['output'];
};

export type ExploreMerchandisePageInput = {
  excludeTagsOp: TaggedShefOp;
  heroPhotoUrl: Scalars['String']['input'];
  includeTagsOp: TaggedShefOp;
  pageName: Scalars['String']['input'];
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ExploreMerchandisePageTagFilter = {
  __typename?: 'ExploreMerchandisePageTagFilter';
  exclude?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tagId: Scalars['String']['output'];
};

export type ExploreMerchandiseResults = {
  __typename?: 'ExploreMerchandiseResults';
  availableDeliveryDays: Array<Scalars['String']['output']>;
  segments: Array<ExploreSegment>;
};

export type ExploreSegment = {
  __typename?: 'ExploreSegment';
  cacheKey: Scalars['String']['output'];
  content: ExploreSegmentContent;
  displayName: Scalars['String']['output'];
  icon?: Maybe<SegmentIcon>;
  id: Scalars['String']['output'];
  layout: SegmentLayout;
  preview?: Maybe<ExploreSegmentPreview>;
  subcuisineSegmentDetails?: Maybe<SubcuisineSegmentDetails>;
  subtitle?: Maybe<Scalars['String']['output']>;
};


export type ExploreSegmentContentArgs = {
  filter?: InputMaybe<ExploreSegmentsFilterInput>;
};

export type ExploreSegmentContent = {
  __typename?: 'ExploreSegmentContent';
  isInPreview: Scalars['Boolean']['output'];
  items: Array<ContentItem>;
  total: Scalars['Int']['output'];
};

export type ExploreSegmentPreview = {
  __typename?: 'ExploreSegmentPreview';
  seeAllText: Scalars['String']['output'];
  showAllFiltersWhenExpanded: Scalars['Boolean']['output'];
};

export type ExploreSegmentShef = {
  __typename?: 'ExploreSegmentShef';
  dishPreviewImage: Scalars['String']['output'];
  numDishes: Scalars['Int']['output'];
  shef: PublicShef;
};

export type ExploreSegmentsFilterInput = {
  cuisineFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryDays?: InputMaybe<Array<Scalars['String']['input']>>;
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  excludePromoSegment?: InputMaybe<Scalars['Boolean']['input']>;
  isEcoFriendlyPackaging?: InputMaybe<Scalars['Boolean']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  segmentFilters?: InputMaybe<Array<SegmentFilter>>;
  smallScreen: Scalars['Boolean']['input'];
  spiceLevelFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  zipCode: Scalars['String']['input'];
};

export type FacebookEvent = {
  data?: InputMaybe<Scalars['String']['input']>;
  eid: Scalars['String']['input'];
  fbc?: InputMaybe<Scalars['String']['input']>;
  fbp?: InputMaybe<Scalars['String']['input']>;
};

export enum FeatureName {
  AdminDeleteUsersKey = 'ADMIN_DELETE_USERS_KEY',
  ApiSyncEnabled = 'API_SYNC_ENABLED',
  ApplePay = 'APPLE_PAY',
  AppleSignInOnWebEnabled = 'APPLE_SIGN_IN_ON_WEB_ENABLED',
  BulkDiscountEnabled = 'BULK_DISCOUNT_ENABLED',
  CalendlyIgnoreEventList = 'CALENDLY_IGNORE_EVENT_LIST',
  CalendlyOrientationCallLink = 'CALENDLY_ORIENTATION_CALL_LINK',
  CalendlyShefMenuWebinarCallEventIds = 'CALENDLY_SHEF_MENU_WEBINAR_CALL_EVENT_IDS',
  CalendlyShefOnboardingCallEventIds = 'CALENDLY_SHEF_ONBOARDING_CALL_EVENT_IDS',
  CalendlyShefOrientationCallEventIds = 'CALENDLY_SHEF_ORIENTATION_CALL_EVENT_IDS',
  CancelDoordashDeliveryPhoneNumber = 'CANCEL_DOORDASH_DELIVERY_PHONE_NUMBER',
  ChatBusinessRiskKeywords = 'CHAT_BUSINESS_RISK_KEYWORDS',
  ChatCustomizationKeywords = 'CHAT_CUSTOMIZATION_KEYWORDS',
  ChatEnabled = 'CHAT_ENABLED',
  ChatFeedbackKeywords = 'CHAT_FEEDBACK_KEYWORDS',
  ChatSupportKeywords = 'CHAT_SUPPORT_KEYWORDS',
  ConsumerDeleteUserEnabled = 'CONSUMER_DELETE_USER_ENABLED',
  CpgUpsellItems = 'CPG_UPSELL_ITEMS',
  DayOfOrdersEmail = 'DAY_OF_ORDERS_EMAIL',
  DdDeliveryNotes = 'DD_DELIVERY_NOTES',
  DeliveryCostDirectViaNash = 'DELIVERY_COST_DIRECT_VIA_NASH',
  DeliveryCostFulflld = 'DELIVERY_COST_FULFLLD',
  DeliveryCostLalamove = 'DELIVERY_COST_LALAMOVE',
  DeliveryCostNash = 'DELIVERY_COST_NASH',
  DisabledFixedIntervalTasks = 'DISABLED_FIXED_INTERVAL_TASKS',
  DisableAdminPages = 'DISABLE_ADMIN_PAGES',
  DishwasherApiUrl = 'DISHWASHER_API_URL',
  DishwasherEnabled = 'DISHWASHER_ENABLED',
  DishCreationV2 = 'DISH_CREATION_V2',
  DishFirstNavEnabled = 'DISH_FIRST_NAV_ENABLED',
  DishFirstV3Rollout = 'DISH_FIRST_V3_ROLLOUT',
  DoordashDeliverySms = 'DOORDASH_DELIVERY_SMS',
  DoorDashTip = 'DOOR_DASH_TIP',
  DoorToDoorDeliveryDiscount = 'DOOR_TO_DOOR_DELIVERY_DISCOUNT',
  EmailBlockList = 'EMAIL_BLOCK_LIST',
  EmailFoodItemAuditCommentAdded = 'EMAIL_FOOD_ITEM_AUDIT_COMMENT_ADDED',
  EmailFoodItemChangesApproved = 'EMAIL_FOOD_ITEM_CHANGES_APPROVED',
  EmailFoodItemChangesRejected = 'EMAIL_FOOD_ITEM_CHANGES_REJECTED',
  EmailFoodItemCommentAdded = 'EMAIL_FOOD_ITEM_COMMENT_ADDED',
  EmailHeldOrderCanceled = 'EMAIL_HELD_ORDER_CANCELED',
  EmailLastAvailabilityReminder = 'EMAIL_LAST_AVAILABILITY_REMINDER',
  EmailMessageTransactionTask = 'EMAIL_MESSAGE_TRANSACTION_TASK',
  EmailOrderCancelled = 'EMAIL_ORDER_CANCELLED',
  EmailOrderRefunded = 'EMAIL_ORDER_REFUNDED',
  EmailOrderUpdated = 'EMAIL_ORDER_UPDATED',
  EmailReferralReward = 'EMAIL_REFERRAL_REWARD',
  EmailShefAvailabilityNotification = 'EMAIL_SHEF_AVAILABILITY_NOTIFICATION',
  EmailShefGiftCard = 'EMAIL_SHEF_GIFT_CARD',
  EmailTrialOrderCancelled = 'EMAIL_TRIAL_ORDER_CANCELLED',
  EmptyHeldOrdersEnabled = 'EMPTY_HELD_ORDERS_ENABLED',
  FavoriteShefs = 'FAVORITE_SHEFS',
  FixedIntervalShefSocialDigest = 'FIXED_INTERVAL_SHEF_SOCIAL_DIGEST',
  FlexibleSidesEnabled = 'FLEXIBLE_SIDES_ENABLED',
  FoodItemAudits = 'FOOD_ITEM_AUDITS',
  FoodItemEmbeddingsTask = 'FOOD_ITEM_EMBEDDINGS_TASK',
  FraudDetectionEnabled = 'FRAUD_DETECTION_ENABLED',
  FringeEnabledForShef = 'FRINGE_ENABLED_FOR_SHEF',
  FringeOverrideEnabled = 'FRINGE_OVERRIDE_ENABLED',
  GetNewFoodCommentMessagesTask = 'GET_NEW_FOOD_COMMENT_MESSAGES_TASK',
  GiftCardPurchaseEnabled = 'GIFT_CARD_PURCHASE_ENABLED',
  GiftCardRedemptionEnabled = 'GIFT_CARD_REDEMPTION_ENABLED',
  GooglePay = 'GOOGLE_PAY',
  GroupOrderMutationsEnabled = 'GROUP_ORDER_MUTATIONS_ENABLED',
  GroupOrderTotalsEnabled = 'GROUP_ORDER_TOTALS_ENABLED',
  GroupOrderVerificationEnabled = 'GROUP_ORDER_VERIFICATION_ENABLED',
  HolidayMenusEnabled = 'HOLIDAY_MENUS_ENABLED',
  IntervalReviewReminderEnabled = 'INTERVAL_REVIEW_REMINDER_ENABLED',
  IsIntakeRevampEnabled = 'IS_INTAKE_REVAMP_ENABLED',
  MealPlansAllergensEnabled = 'MEAL_PLANS_ALLERGENS_ENABLED',
  MealPlansBrowseAsGuest = 'MEAL_PLANS_BROWSE_AS_GUEST',
  MealPlansEnabled = 'MEAL_PLANS_ENABLED',
  MealPlanModificationEnabled = 'MEAL_PLAN_MODIFICATION_ENABLED',
  MultiOrderSameDayFreeShipping = 'MULTI_ORDER_SAME_DAY_FREE_SHIPPING',
  OrderDayOfEmailDd = 'ORDER_DAY_OF_EMAIL_DD',
  OrderDayOfEmailNotDd = 'ORDER_DAY_OF_EMAIL_NOT_DD',
  OrderDayOfEmailPickup = 'ORDER_DAY_OF_EMAIL_PICKUP',
  PersonalShefEnabled = 'PERSONAL_SHEF_ENABLED',
  PhonesBannedFromUsingPromos = 'PHONES_BANNED_FROM_USING_PROMOS',
  PhoneBlacklist = 'PHONE_BLACKLIST',
  PickupAddressEnabled = 'PICKUP_ADDRESS_ENABLED',
  ProfileDeliveryAddressesEnabled = 'PROFILE_DELIVERY_ADDRESSES_ENABLED',
  ProfilePaymentMethodsEnabled = 'PROFILE_PAYMENT_METHODS_ENABLED',
  RateRecentOrderPopupEnabled = 'RATE_RECENT_ORDER_POPUP_ENABLED',
  RegionalCusineDenyLists = 'REGIONAL_CUSINE_DENY_LISTS',
  RequestAppReviewsEnabled = 'REQUEST_APP_REVIEWS_ENABLED',
  ReusablePackagingEnabled = 'REUSABLE_PACKAGING_ENABLED',
  S2CCodeUsesPerUser = 'S2C_CODE_USES_PER_USER',
  S2CCodeValue = 'S2C_CODE_VALUE',
  S2CRewardValue = 'S2C_REWARD_VALUE',
  SameDeliveryDayPromoId = 'SAME_DELIVERY_DAY_PROMO_ID',
  SameDeliveryDayRetainedUsersPromoId = 'SAME_DELIVERY_DAY_RETAINED_USERS_PROMO_ID',
  ShefApplicationAlwaysEnableContinueInformationSessionVideo = 'SHEF_APPLICATION_ALWAYS_ENABLE_CONTINUE_INFORMATION_SESSION_VIDEO',
  ShefApplicationReceivedEmail = 'SHEF_APPLICATION_RECEIVED_EMAIL',
  ShefDashboardBanner = 'SHEF_DASHBOARD_BANNER',
  ShefDashboardInsights = 'SHEF_DASHBOARD_INSIGHTS',
  ShefDishCreationUpdates = 'SHEF_DISH_CREATION_UPDATES',
  ShefGrowYourBusinessEnabled = 'SHEF_GROW_YOUR_BUSINESS_ENABLED',
  ShefMenuChecklistEnabled = 'SHEF_MENU_CHECKLIST_ENABLED',
  ShefPlatformUsageQuestionnaire = 'SHEF_PLATFORM_USAGE_QUESTIONNAIRE',
  ShefPostsEnabled = 'SHEF_POSTS_ENABLED',
  ShefPromoCodeCreation = 'SHEF_PROMO_CODE_CREATION',
  ShefRating = 'SHEF_RATING',
  ShefRosterEnabled = 'SHEF_ROSTER_ENABLED',
  ShefSideCustomizations = 'SHEF_SIDE_CUSTOMIZATIONS',
  ShefSocialDigestTemplateId = 'SHEF_SOCIAL_DIGEST_TEMPLATE_ID',
  ShefToConsumerReferralTask = 'SHEF_TO_CONSUMER_REFERRAL_TASK',
  ShefUpcomingOrders = 'SHEF_UPCOMING_ORDERS',
  ShefZendesk = 'SHEF_ZENDESK',
  ShowManageMealPlans = 'SHOW_MANAGE_MEAL_PLANS',
  SmsMessageTransactionTask = 'SMS_MESSAGE_TRANSACTION_TASK',
  SubscriptionOrdersEnabled = 'SUBSCRIPTION_ORDERS_ENABLED',
  SubscriptionSignupEnabled = 'SUBSCRIPTION_SIGNUP_ENABLED',
  TaskPaymentCaptureEnabled = 'TASK_PAYMENT_CAPTURE_ENABLED',
  TaskShefPayoutEnabled = 'TASK_SHEF_PAYOUT_ENABLED',
  UpsellsEnabled = 'UPSELLS_ENABLED',
  WeeklyShefServiceMenuTemplateEnabled = 'WEEKLY_SHEF_SERVICE_MENU_TEMPLATE_ENABLED',
  ZendeskTextTask = 'ZENDESK_TEXT_TASK'
}

export type FilteredFoodItemResults = {
  __typename?: 'FilteredFoodItemResults';
  partialMatches: Array<FoodItem>;
  perfectMatches: Array<FoodItem>;
};

export type FoodItem = {
  __typename?: 'FoodItem';
  availability: Array<FoodItemAvailability>;
  availableFriday: Scalars['Boolean']['output'];
  availableMonday: Scalars['Boolean']['output'];
  availableSaturday: Scalars['Boolean']['output'];
  availableSunday: Scalars['Boolean']['output'];
  availableThursday: Scalars['Boolean']['output'];
  availableTuesday: Scalars['Boolean']['output'];
  availableWednesday: Scalars['Boolean']['output'];
  averageRating: Scalars['Int']['output'];
  bundleFoodItemIds?: Maybe<Array<Scalars['Int']['output']>>;
  bundleFoodItems2?: Maybe<Array<BundleFoodItem>>;
  capacity?: Maybe<Scalars['Int']['output']>;
  childrenPrefabFoodItems: Array<FoodItem>;
  containsEggs: Scalars['Boolean']['output'];
  containsNuts: Scalars['Boolean']['output'];
  containsShellfish: Scalars['Boolean']['output'];
  containsSoy: Scalars['Boolean']['output'];
  cuisineCategories: Array<CuisineCategory>;
  cuisineCategoryIds: Array<Scalars['String']['output']>;
  customizations?: Maybe<Array<FoodItemCustomization>>;
  dairyFree: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountForTakeRateShiftExperiment: Scalars['Float']['output'];
  endDate: Scalars['String']['output'];
  firstApprovedAt?: Maybe<Scalars['Date']['output']>;
  foodItemPairIds: Array<Scalars['Int']['output']>;
  foodType?: Maybe<FoodType>;
  glutenFree: Scalars['Boolean']['output'];
  hasUnreadComments: Scalars['Boolean']['output'];
  holiday?: Maybe<Holiday>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  ingredients?: Maybe<Scalars['String']['output']>;
  isHalal: Scalars['Boolean']['output'];
  isOrganic: Scalars['Boolean']['output'];
  isPopular?: Maybe<Scalars['Boolean']['output']>;
  isSoldOut: Scalars['Boolean']['output'];
  keto?: Maybe<Scalars['Boolean']['output']>;
  kosher?: Maybe<Scalars['Boolean']['output']>;
  lastPurchasedAt?: Maybe<Scalars['Date']['output']>;
  lowFodmap?: Maybe<Scalars['Boolean']['output']>;
  lowSodium?: Maybe<Scalars['Boolean']['output']>;
  mostRecentOpenChangeRequest?: Maybe<FoodItemChangeRequest>;
  name?: Maybe<Scalars['String']['output']>;
  needsSide?: Maybe<Scalars['Boolean']['output']>;
  numDaysBeforeExpires: Scalars['Int']['output'];
  numLabels?: Maybe<Scalars['Int']['output']>;
  numServings?: Maybe<Scalars['Int']['output']>;
  packaging: Packaging;
  pairings: Array<FoodItem>;
  paleo?: Maybe<Scalars['Boolean']['output']>;
  parentPrefabFoodItem?: Maybe<FoodItem>;
  portion?: Maybe<Scalars['String']['output']>;
  prefabFoodItemId?: Maybe<Scalars['Int']['output']>;
  prefabStats?: Maybe<PrefabFoodItemStats>;
  prepInstructions?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  ratingCount: Scalars['Int']['output'];
  resizedImageUrl?: Maybe<Scalars['String']['output']>;
  servingSize?: Maybe<Scalars['String']['output']>;
  servingSizeCustomizations?: Maybe<Array<FoodItemCustomization>>;
  shef: PublicShef;
  slug: Scalars['String']['output'];
  spiceLevel: Scalars['Int']['output'];
  spiceLevelCustomizations?: Maybe<Array<FoodItemCustomization>>;
  startDate: Scalars['String']['output'];
  status: FoodItemStatus;
  topPositiveTags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  upsell?: Maybe<Upsell>;
  upsellTierId?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  vegan?: Maybe<Scalars['Boolean']['output']>;
  vegetarian?: Maybe<Scalars['Boolean']['output']>;
  whole30?: Maybe<Scalars['Boolean']['output']>;
};


export type FoodItemAvailabilityArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
};


export type FoodItemChildrenPrefabFoodItemsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FoodItemIsSoldOutArgs = {
  filters: ExploreSegmentsFilterInput;
};


export type FoodItemResizedImageUrlArgs = {
  width: Scalars['Int']['input'];
};

export type FoodItemAuditRequest = {
  __typename?: 'FoodItemAuditRequest';
  auditFitnessScore: Scalars['Int']['output'];
  auditGroupId: Scalars['String']['output'];
  auditStatus: AuditStatus;
  changeRequestIds: Array<Scalars['Int']['output']>;
  currentFoodItem: FoodItem;
  foodItem?: Maybe<FoodItem>;
  foodItemChangeRequests: Array<FoodItemChangeRequest>;
  foodItemId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastCommentedBy?: Maybe<User>;
  reviewFitnessScore: Scalars['Int']['output'];
  startingFoodItem?: Maybe<FoodItem>;
  version: Scalars['Int']['output'];
};

export type FoodItemAuditRequestResults = {
  __typename?: 'FoodItemAuditRequestResults';
  auditRequests: Array<FoodItemAuditRequest>;
  pagination: Pagination;
};

export type FoodItemAvailability = {
  __typename?: 'FoodItemAvailability';
  availabilityDate: Scalars['DateTime']['output'];
  numAvailable?: Maybe<Scalars['Int']['output']>;
};

export type FoodItemCapacityForDeliveryDate = {
  __typename?: 'FoodItemCapacityForDeliveryDate';
  capacity: Scalars['Int']['output'];
  foodItemId: Scalars['Int']['output'];
};

export type FoodItemChangeRequest = {
  __typename?: 'FoodItemChangeRequest';
  changesets: Array<FoodItemChangeset>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  comments: Array<FoodItemChangeRequestComment>;
  foodItem: FoodItem;
  id: Scalars['Int']['output'];
  lastUpdatedBy: User;
  status: RequestStatus;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type FoodItemChangeRequestComment = {
  __typename?: 'FoodItemChangeRequestComment';
  changeRequest: FoodItemChangeRequest;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  user: User;
};

export type FoodItemChangeRequestResults = {
  __typename?: 'FoodItemChangeRequestResults';
  changeRequests: Array<FoodItemChangeRequest>;
  pagination: Pagination;
};

export type FoodItemChangeset = {
  __typename?: 'FoodItemChangeset';
  availableFriday?: Maybe<Scalars['Boolean']['output']>;
  availableMonday?: Maybe<Scalars['Boolean']['output']>;
  availableSaturday?: Maybe<Scalars['Boolean']['output']>;
  availableSunday?: Maybe<Scalars['Boolean']['output']>;
  availableThursday?: Maybe<Scalars['Boolean']['output']>;
  availableTuesday?: Maybe<Scalars['Boolean']['output']>;
  availableWednesday?: Maybe<Scalars['Boolean']['output']>;
  bundleFoodItemIds?: Maybe<Array<Scalars['Int']['output']>>;
  capacity?: Maybe<Scalars['Int']['output']>;
  changeRequest: FoodItemChangeRequest;
  containsEggs?: Maybe<Scalars['Boolean']['output']>;
  containsNuts?: Maybe<Scalars['Boolean']['output']>;
  containsShellfish?: Maybe<Scalars['Boolean']['output']>;
  containsSoy?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customizations?: Maybe<Array<FoodItemCustomization>>;
  dairyFree?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  foodType?: Maybe<FoodType>;
  glutenFree?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  ingredients?: Maybe<Scalars['String']['output']>;
  isHalal?: Maybe<Scalars['Boolean']['output']>;
  isOrganic?: Maybe<Scalars['Boolean']['output']>;
  keto?: Maybe<Scalars['Boolean']['output']>;
  kosher?: Maybe<Scalars['Boolean']['output']>;
  lowFodmap?: Maybe<Scalars['Boolean']['output']>;
  lowSodium?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsSide?: Maybe<Scalars['Boolean']['output']>;
  numDaysBeforeExpires?: Maybe<Scalars['Int']['output']>;
  numLabels?: Maybe<Scalars['Int']['output']>;
  numServings?: Maybe<Scalars['Int']['output']>;
  packaging?: Maybe<Packaging>;
  paleo?: Maybe<Scalars['Boolean']['output']>;
  portion?: Maybe<Scalars['String']['output']>;
  prepInstructions?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  servingSize?: Maybe<Scalars['String']['output']>;
  servingSizeCustomizations?: Maybe<Array<FoodItemCustomization>>;
  spiceLevel?: Maybe<Scalars['Int']['output']>;
  spiceLevelCustomizations?: Maybe<Array<FoodItemCustomization>>;
  startDate?: Maybe<Scalars['String']['output']>;
  upsellTierId?: Maybe<Scalars['Int']['output']>;
  user: User;
  vegan?: Maybe<Scalars['Boolean']['output']>;
  vegetarian?: Maybe<Scalars['Boolean']['output']>;
  whole30?: Maybe<Scalars['Boolean']['output']>;
};

export type FoodItemChangesetCustomizationInput = {
  customizationTypeId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  portion?: InputMaybe<Scalars['String']['input']>;
  priceFactor: Scalars['Int']['input'];
  priceFactorType: PriceFactorType;
};

export type FoodItemChangesetInput = {
  availableFriday?: InputMaybe<Scalars['Boolean']['input']>;
  availableMonday?: InputMaybe<Scalars['Boolean']['input']>;
  availableSaturday?: InputMaybe<Scalars['Boolean']['input']>;
  availableSunday?: InputMaybe<Scalars['Boolean']['input']>;
  availableThursday?: InputMaybe<Scalars['Boolean']['input']>;
  availableTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  availableWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  containsEggs?: InputMaybe<Scalars['Boolean']['input']>;
  containsNuts?: InputMaybe<Scalars['Boolean']['input']>;
  containsShellfish?: InputMaybe<Scalars['Boolean']['input']>;
  containsSoy?: InputMaybe<Scalars['Boolean']['input']>;
  cuisineCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customizations?: InputMaybe<Array<FoodItemChangesetCustomizationInput>>;
  dairyFree?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  foodItemPairIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  foodType?: InputMaybe<FoodType>;
  glutenFree?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  isHalal?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  keto?: InputMaybe<Scalars['Boolean']['input']>;
  kosher?: InputMaybe<Scalars['Boolean']['input']>;
  lowFodmap?: InputMaybe<Scalars['Boolean']['input']>;
  lowSodium?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsSide?: InputMaybe<Scalars['Boolean']['input']>;
  numDaysBeforeExpires?: InputMaybe<Scalars['Int']['input']>;
  numLabels?: InputMaybe<Scalars['Int']['input']>;
  numServings?: InputMaybe<Scalars['Int']['input']>;
  packaging?: InputMaybe<Packaging>;
  paleo?: InputMaybe<Scalars['Boolean']['input']>;
  portion?: InputMaybe<Scalars['String']['input']>;
  prefabFoodItemId?: InputMaybe<Scalars['Int']['input']>;
  prepInstructions?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  servingSize?: InputMaybe<Scalars['String']['input']>;
  spiceLevel?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  upsellTierId?: InputMaybe<Scalars['Int']['input']>;
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  vegetarian?: InputMaybe<Scalars['Boolean']['input']>;
  whole30?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FoodItemComment = {
  __typename?: 'FoodItemComment';
  auditId?: Maybe<Scalars['String']['output']>;
  commentText: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  foodItemId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Date']['output']>;
  senderId: Scalars['String']['output'];
  sentNotificationAt?: Maybe<Scalars['Date']['output']>;
};

export type FoodItemCommentInput = {
  auditId?: InputMaybe<Scalars['String']['input']>;
  commentText: Scalars['String']['input'];
  foodItemId: Scalars['Int']['input'];
  senderId: Scalars['String']['input'];
};

export type FoodItemCustomization = {
  __typename?: 'FoodItemCustomization';
  customizationType: FoodItemCustomizationType;
  customizationTypeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  portion?: Maybe<Scalars['String']['output']>;
  priceFactor: Scalars['Int']['output'];
  priceFactorType: PriceFactorType;
};

export type FoodItemCustomizationType = {
  __typename?: 'FoodItemCustomizationType';
  category: CustomizationCategory;
  dataType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FoodItemPopularity = {
  __typename?: 'FoodItemPopularity';
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numThumbsDown: Scalars['Int']['output'];
  numThumbsUp: Scalars['Int']['output'];
  tags?: Maybe<Array<FoodItemTagFrequency>>;
};

export type FoodItemPopularityResult = {
  __typename?: 'FoodItemPopularityResult';
  results: Array<FoodItemPopularity>;
};

export type FoodItemPriceRecommendationInput = {
  dishName: Scalars['String']['input'];
  foodItemId: Scalars['Int']['input'];
  foodType: FoodType;
  servingSize: Scalars['String']['input'];
  shefId: Scalars['String']['input'];
};

export type FoodItemPriceRecommendationResult = {
  __typename?: 'FoodItemPriceRecommendationResult';
  lowerPriceRange: Scalars['Int']['output'];
  recommendedPrice: Scalars['Int']['output'];
  upperPriceRange: Scalars['Int']['output'];
};

export type FoodItemQuantity = {
  __typename?: 'FoodItemQuantity';
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type FoodItemRating = {
  __typename?: 'FoodItemRating';
  comment?: Maybe<Scalars['String']['output']>;
  foodItem: FoodItem;
  foodItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  ratingPercent?: Maybe<Scalars['Int']['output']>;
  shefId: Scalars['String']['output'];
  tags?: Maybe<Array<FoodItemRatingTag>>;
  userId: Scalars['String']['output'];
};

export type FoodItemRatingInput = {
  foodItemId: Scalars['Int']['input'];
  ratingPercent?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FoodItemRatingTag = {
  __typename?: 'FoodItemRatingTag';
  foodItemId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  shefId: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type FoodItemResults = {
  __typename?: 'FoodItemResults';
  foodItems: Array<FoodItem>;
  pagination: Pagination;
};

export enum FoodItemStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT'
}

export type FoodItemTagFrequency = {
  __typename?: 'FoodItemTagFrequency';
  count: Scalars['Int']['output'];
  isPositive: Scalars['Boolean']['output'];
  tag: Scalars['String']['output'];
};

export type FoodItemTags = {
  foodItemId: Scalars['Int']['input'];
  score: Scalars['Int']['input'];
  tagId: Scalars['String']['input'];
};

export enum FoodType {
  Appetizer = 'appetizer',
  Beverage = 'beverage',
  Dessert = 'dessert',
  Kids = 'kids',
  Main = 'main',
  Side = 'side'
}

export enum FoodTypeCoalesced {
  Dessert = 'DESSERT',
  Main = 'MAIN',
  Side = 'SIDE'
}

export type FreeDeliveryModal = {
  __typename?: 'FreeDeliveryModal';
  enabled: Scalars['Boolean']['output'];
  isNashShef: Scalars['Boolean']['output'];
};

export type FulfillmentInput = {
  addressInput?: InputMaybe<AddressInput>;
  fulfillmentOption?: InputMaybe<Scalars['String']['input']>;
  timeWindowsSelectedByShef: Array<Scalars['Int']['input']>;
};

export type GeoConfigInput = {
  fridayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  mondayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  saturdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  sundayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  thursdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  tuesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  type: GeoInputType;
  wednesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GeoInputType {
  Hub = 'HUB',
  Region = 'REGION',
  Zip = 'ZIP'
}

export type GetForYouMealPlanCollectionsResponse = QueryResponse & {
  __typename?: 'GetForYouMealPlanCollectionsResponse';
  collections: Array<MealPlanCollection>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GetMealPlanDeliveriesInput = {
  userId: Scalars['String']['input'];
};

export type GetMealPlanDeliveriesResponse = QueryResponse & {
  __typename?: 'GetMealPlanDeliveriesResponse';
  deliveryDates: Array<Scalars['DateTime']['output']>;
  message: Scalars['String']['output'];
  orders: Array<Order>;
  success: Scalars['Boolean']['output'];
};

export type GetMealPlanUpcomingOrderInput = {
  userId: Scalars['String']['input'];
};

export type GetMealPlanUpcomingOrderResponse = QueryResponse & {
  __typename?: 'GetMealPlanUpcomingOrderResponse';
  mealPlanUpcomingOrder?: Maybe<MealPlanUpcomingOrder>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GetShefRosterResponse = QueryResponse & {
  __typename?: 'GetShefRosterResponse';
  message: Scalars['String']['output'];
  shefs: Array<PublicShef>;
  success: Scalars['Boolean']['output'];
};

export type GetTasteProfileInput = {
  userId: Scalars['String']['input'];
};

export type GetTasteProfileResponse = QueryResponse & {
  __typename?: 'GetTasteProfileResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tasteProfile?: Maybe<TasteProfile>;
};

export type GetUpcomingMealPlanGroupOrdersResponse = QueryResponse & {
  __typename?: 'GetUpcomingMealPlanGroupOrdersResponse';
  groupOrders?: Maybe<Array<GroupOrder>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GroupOrder = {
  __typename?: 'GroupOrder';
  addOnItems: Array<OrderAddOnItem>;
  canReviewOrder: Scalars['Boolean']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dayOfEmailScheduledTaskId?: Maybe<Scalars['Int']['output']>;
  delivery?: Maybe<Delivery>;
  deliveryAddress: Address;
  deliveryAddressId: Scalars['Int']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  deliveryId?: Maybe<Scalars['String']['output']>;
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  deliveryType: Scalars['String']['output'];
  formattedId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isFullyRefunded: Scalars['Boolean']['output'];
  isPartiallyRefunded: Scalars['Boolean']['output'];
  isSkipped: Scalars['Boolean']['output'];
  mealPlanId?: Maybe<Scalars['String']['output']>;
  mealPlanType?: Maybe<MealPlanType>;
  mealPlanTypeId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  orderTotals: ConsumerOrderTotal;
  orderType: OrderType;
  orders: Array<Order>;
  phone: Scalars['String']['output'];
  pickupAddress?: Maybe<Address>;
  pickupAddressId?: Maybe<Scalars['Int']['output']>;
  pickupDeliveryId?: Maybe<Scalars['Int']['output']>;
  promoCodes: Array<PromoCode>;
  refunds: Array<Refund>;
  regionId?: Maybe<Scalars['Int']['output']>;
  review: GroupOrderReview;
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  subscriptionInvoiceId?: Maybe<Scalars['String']['output']>;
  timeWindow: OrderTimeWindow;
  timeWindowId?: Maybe<Scalars['Int']['output']>;
  transactions: Array<Transaction>;
  user: User;
  userId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type GroupOrderConnection = {
  __typename?: 'GroupOrderConnection';
  edges: Array<GroupOrderEdge>;
  pageInfo: PageInfo;
};

export enum GroupOrderCustomerRefundReason {
  CustomerDidNotSpecify = 'CustomerDidNotSpecify',
  CustomerInitiatedForOneTime = 'CustomerInitiatedForOneTime',
  CustomerInitiatedForSubscription = 'CustomerInitiatedForSubscription',
  CustomerOrderError = 'CustomerOrderError',
  CustomerScheduleConflict = 'CustomerScheduleConflict',
  CustomerUnappyWithPriorOrder = 'CustomerUnappyWithPriorOrder',
  Other = 'Other'
}

export enum GroupOrderDeliveryPartnerRefundReason {
  DoorDash = 'DoorDash',
  Dropoff = 'Dropoff',
  Farias = 'Farias',
  Fulflld = 'Fulflld',
  GoFor = 'GoFor',
  Nash = 'Nash',
  Other = 'Other',
  Ups = 'UPS'
}

export type GroupOrderEdge = {
  __typename?: 'GroupOrderEdge';
  cursor: Scalars['ID']['output'];
  node: GroupOrder;
};

export type GroupOrderInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate: Scalars['DateTime']['input'];
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  expectedAdditionalDeliveryDateSpend?: InputMaybe<Scalars['Int']['input']>;
  isAcceptingTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  isMealPlanDiscountEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isMealPlanSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  isOptingIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<OrderStatus>;
  orderType?: InputMaybe<OrderType>;
  perShefOrders: Array<PerShefOrderInput>;
  phone: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recurringNotes?: InputMaybe<Scalars['String']['input']>;
  recurringPeriod?: InputMaybe<RecurringPeriod>;
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  shefTip: Scalars['Int']['input'];
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  subtotal: Scalars['Int']['input'];
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export enum GroupOrderInternalRefundReason {
  CustomerCourtesy = 'CustomerCourtesy',
  FoodQuality = 'FoodQuality',
  FoodSafety = 'FoodSafety',
  HubError = 'HubError',
  Other = 'Other',
  SupportError = 'SupportError',
  TechnicalIssueOrBug = 'TechnicalIssueOrBug'
}

export type GroupOrderLevelRefundInput = {
  groupOrderId: Scalars['String']['input'];
  orderLevelRefunds?: InputMaybe<Array<OrderLevelRefundInput>>;
  refundDetails?: InputMaybe<Scalars['String']['input']>;
  refundMessage?: InputMaybe<Scalars['String']['input']>;
  refundReason?: InputMaybe<RefundGroupOrderReasonInput>;
  refundType?: InputMaybe<GroupOrderRefundType>;
};

export type GroupOrderRatingInput = {
  groupOrderId: Scalars['String']['input'];
  ratings: Array<OrderRatingInput>;
};

export type GroupOrderRatingOutput = {
  __typename?: 'GroupOrderRatingOutput';
  customerMessage?: Maybe<Scalars['String']['output']>;
  groupOrder: GroupOrder;
  promo?: Maybe<PromoCode>;
};

export enum GroupOrderRefundType {
  Customer = 'Customer',
  DeliveryPartner = 'DeliveryPartner',
  Internal = 'Internal',
  Shef = 'Shef',
  System = 'System'
}

export type GroupOrderResult = {
  __typename?: 'GroupOrderResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
  groupOrder: GroupOrder;
};

export type GroupOrderResults = {
  __typename?: 'GroupOrderResults';
  groupOrders: Array<GroupOrder>;
  pagination: Pagination;
};

export type GroupOrderReview = {
  __typename?: 'GroupOrderReview';
  status: GroupOrderReviewStatus;
};

export enum GroupOrderReviewStatus {
  Completed = 'Completed',
  Started = 'Started',
  Unreviewable = 'Unreviewable',
  Unstarted = 'Unstarted'
}

export enum GroupOrderShefRefundReason {
  FoodSafety = 'FoodSafety',
  OrderValueOrCountTooLow = 'OrderValueOrCountTooLow',
  Other = 'Other',
  ShefDidNotSpecify = 'ShefDidNotSpecify',
  ShefEmergency = 'ShefEmergency',
  ShefErrorForFullOrder = 'ShefErrorForFullOrder',
  ShefErrorForItem = 'ShefErrorForItem',
  ShefRescheduleRefusedByCustomer = 'ShefRescheduleRefusedByCustomer',
  ShefUnavailable = 'ShefUnavailable',
  Weather = 'Weather'
}

export enum GroupOrderSystemRefundReason {
  CustomerModification = 'CustomerModification',
  FeesAndTaxes = 'FeesAndTaxes',
  RefundWindowExpired = 'RefundWindowExpired'
}

export type GroupOrderTotalsInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  addOnItemsSubtotal: Scalars['Int']['input'];
  /** Required at checkout for non-pickup orders */
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  expectedAdditionalDeliveryDateSpend?: InputMaybe<Scalars['Int']['input']>;
  lineItemsSubtotal: Scalars['Int']['input'];
  orderType?: InputMaybe<OrderType>;
  perShefOrders: Array<PerShefOrderInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recurringPeriod?: InputMaybe<RecurringPeriod>;
  shefTip: Scalars['Int']['input'];
  shefTipPercent?: InputMaybe<Scalars['Float']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if deliveryAddress is not provided for non-pickup orders.
   * Should only be used for estimations; always use `deliveryAddress`
   * when available for more accurate calculations.
   */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum Holiday {
  Christmas = 'CHRISTMAS',
  Diwali = 'DIWALI',
  Easter = 'EASTER',
  EidAlFitr = 'EID_AL_FITR',
  Hanukkah = 'HANUKKAH',
  Holi = 'HOLI',
  Kwanzaa = 'KWANZAA',
  LunarNewYear = 'LUNAR_NEW_YEAR',
  NewYear = 'NEW_YEAR',
  Nowruz = 'NOWRUZ',
  Ramadan = 'RAMADAN',
  Thanksgiving = 'THANKSGIVING',
  Valentines = 'VALENTINES',
  Vesak = 'VESAK'
}

export enum HouseholdGoals {
  AuthenticFlavors = 'authenticFlavors',
  FamilyFriendly = 'familyFriendly',
  FreshIngredients = 'freshIngredients',
  HealthyOptions = 'healthyOptions',
  TimeInKitchen = 'timeInKitchen'
}

export type HouseholdInput = {
  numAdults?: InputMaybe<Scalars['Int']['input']>;
  numBigEaters?: InputMaybe<Scalars['Int']['input']>;
  numLittleEaters?: InputMaybe<Scalars['Int']['input']>;
};

export type InitializeMealPlanInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate: Scalars['DateTime']['input'];
  isAcceptingTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  isMealPlanDiscountEligible: Scalars['Boolean']['input'];
  isOptingIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  isReusablePackaging: Scalars['Boolean']['input'];
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  mealsPerWeek: Scalars['Int']['input'];
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  numServings: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  selectedDishes: Array<MealPlanItem>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  timeWindowId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type InitializeMealPlanResponse = MutationResponse & {
  __typename?: 'InitializeMealPlanResponse';
  groupOrderId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type LineDrive = {
  __typename?: 'LineDrive';
  enabledDaysOfWeek: Array<Scalars['Int']['output']>;
  endHub: DeliveryHub;
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startHub: DeliveryHub;
  startTime: Scalars['String']['output'];
};

export type LineDriveFilterInput = {
  endHubId?: InputMaybe<Scalars['Int']['input']>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
  startHubId?: InputMaybe<Scalars['Int']['input']>;
};

export type Location = {
  __typename?: 'Location';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type MakeItAMealDishSuggestion = {
  __typename?: 'MakeItAMealDishSuggestion';
  affinityScore: Scalars['Float']['output'];
  foodItem: FoodItem;
  id: Scalars['Int']['output'];
  ranking: Scalars['Int']['output'];
};

export type MakeItAMealDishSuggestions = {
  __typename?: 'MakeItAMealDishSuggestions';
  id: Scalars['Int']['output'];
  suggestions: Array<MakeItAMealDishSuggestion>;
};

export type MealPlan = {
  __typename?: 'MealPlan';
  addressId: Scalars['Int']['output'];
  fridayDelivery: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isReusablePackagingPlan: Scalars['Boolean']['output'];
  mealPlanType: MealPlanType;
  mealPlanTypeId: Scalars['Int']['output'];
  mondayDelivery: Scalars['Boolean']['output'];
  nextDeliveryDate: Scalars['DateTime']['output'];
  paymentMethodId: Scalars['String']['output'];
  regionId: Scalars['Int']['output'];
  saturdayDelivery: Scalars['Boolean']['output'];
  status: MealPlanStatus;
  sundayDelivery: Scalars['Boolean']['output'];
  thursdayDelivery: Scalars['Boolean']['output'];
  tuesdayDelivery: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
  wednesdayDelivery: Scalars['Boolean']['output'];
};

export type MealPlanCategory = {
  __typename?: 'MealPlanCategory';
  dishes: Array<FoodItem>;
  id: Scalars['String']['output'];
  layout: MealPlanCollectionCategoryLayout;
  title: Scalars['String']['output'];
};

export type MealPlanCollection = {
  __typename?: 'MealPlanCollection';
  categories: Array<MealPlanCategory>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum MealPlanCollectionCategoryLayout {
  DoubleRowCarousel = 'DoubleRowCarousel',
  SingleRowCarousel = 'SingleRowCarousel'
}

export enum MealPlanFormat {
  CompleteMeal = 'COMPLETE_MEAL',
  FlexibleSides = 'FLEXIBLE_SIDES',
  MainsPlusSides = 'MAINS_PLUS_SIDES'
}

export type MealPlanGroupOrder = {
  __typename?: 'MealPlanGroupOrder';
  groupOrderId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Subscription>;
};

export type MealPlanItem = {
  foodItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  shefId?: InputMaybe<Scalars['String']['input']>;
};

export type MealPlanOrderSalesTax = {
  __typename?: 'MealPlanOrderSalesTax';
  salesTax: Scalars['Int']['output'];
};

export type MealPlanOrderSalesTaxInput = {
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryFee?: InputMaybe<Scalars['Int']['input']>;
  mealPlanOrderSubtotal: Scalars['Int']['input'];
  referenceShefId: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum MealPlanOrderStatus {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Skipped = 'SKIPPED'
}

export type MealPlanPreferences = {
  __typename?: 'MealPlanPreferences';
  addressId: Scalars['Int']['output'];
  adventureLevelPct: Scalars['Int']['output'];
  allergens?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  cuisinePreferences: Array<Scalars['String']['output']>;
  dietaryPreferences?: Maybe<Array<Scalars['String']['output']>>;
  format?: Maybe<MealPlanFormat>;
  id: Scalars['String']['output'];
  isReusablePackagingPlan: Scalars['Boolean']['output'];
  isVegan: Scalars['Boolean']['output'];
  isVegetarian: Scalars['Boolean']['output'];
  nextDeliveryDate: Scalars['DateTime']['output'];
  numMeals: Scalars['Int']['output'];
  numServings: Scalars['Int']['output'];
  oilinessPreferencePct?: Maybe<Scalars['Int']['output']>;
  paymentMethodId: Scalars['String']['output'];
  preferredProteins?: Maybe<Array<Protein>>;
  price: Scalars['Int']['output'];
  promoCode?: Maybe<Scalars['String']['output']>;
  recurringPeriodDays?: Maybe<Scalars['Int']['output']>;
  spiceLevels?: Maybe<Array<Scalars['Int']['output']>>;
  status: MealPlanStatus;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum MealPlanStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Hold = 'HOLD'
}

export type MealPlanSubscriptionInput = {
  adventureLevelPct: Scalars['Int']['input'];
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisinePreferences: Array<CuisineRegion>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  dietaryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  fridayDelivery: Scalars['Boolean']['input'];
  mealsPerWeek: Scalars['Int']['input'];
  mondayDelivery: Scalars['Boolean']['input'];
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  oilinessPreferencePct: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  recurringPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  saturdayDelivery: Scalars['Boolean']['input'];
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  servingsPerMeal: Scalars['Int']['input'];
  spiceLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  sundayDelivery: Scalars['Boolean']['input'];
  thursdayDelivery: Scalars['Boolean']['input'];
  tuesdayDelivery: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
  wednesdayDelivery: Scalars['Boolean']['input'];
};

export type MealPlanType = {
  __typename?: 'MealPlanType';
  displayName: Scalars['String']['output'];
  format?: Maybe<MealPlanFormat>;
  id: Scalars['Int']['output'];
  numServings: Scalars['Int']['output'];
  pricePerUnit: Scalars['Int']['output'];
  regionId?: Maybe<Scalars['Int']['output']>;
  unit: Scalars['Int']['output'];
  weeklyCost: Scalars['Int']['output'];
};

export type MealPlanTypeOption = {
  __typename?: 'MealPlanTypeOption';
  isDisabled: Scalars['Boolean']['output'];
  isRecommended?: Maybe<Scalars['Boolean']['output']>;
  mealPlanType: MealPlanType;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MealPlanUpcomingOrder = {
  __typename?: 'MealPlanUpcomingOrder';
  cartLineItemUnits?: Maybe<Array<FoodItemQuantity>>;
  foodItemCapacityForDeliveryDate?: Maybe<Array<FoodItemCapacityForDeliveryDate>>;
  mainDishes?: Maybe<Array<FoodItem>>;
  mealPlan: MealPlan;
  mealPlanGroupOrder: GroupOrder;
  mealPlanGroupOrderId?: Maybe<Scalars['String']['output']>;
  mealPlanOrderStatus?: Maybe<MealPlanOrderStatus>;
  nextDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  promoCodeApplied?: Maybe<PromoCode>;
  sideDishes?: Maybe<Array<FoodItem>>;
  sidesPerWeek: Scalars['Int']['output'];
};

export type MealPlanningMenu = {
  __typename?: 'MealPlanningMenu';
  mains: Array<ShefSegment>;
  shefSegments: Array<ShefSegment>;
  sides: Array<ShefSegment>;
  userPrefs?: Maybe<TasteProfile>;
};

export type MealPlanningPurchaseInput = {
  community: Scalars['String']['input'];
};

export type MealPlanningSubscriptionInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  adventureLevelPct: Scalars['Int']['input'];
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisinePreferences: Array<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate: Scalars['DateTime']['input'];
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  dietaryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  isAcceptingTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  isMealPlanDiscountEligible: Scalars['Boolean']['input'];
  isOptingIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  mealsPerWeek: Scalars['Int']['input'];
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oilinessPreferencePct: Scalars['Int']['input'];
  orderStatus?: InputMaybe<OrderStatus>;
  orderType?: InputMaybe<OrderType>;
  phone: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recurringNotes?: InputMaybe<Scalars['String']['input']>;
  recurringPeriod?: InputMaybe<RecurringPeriod>;
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  selectedDishes: Array<MealPlanItem>;
  servingsPerMeal: Scalars['Int']['input'];
  spiceLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  subtotal: Scalars['Int']['input'];
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type MealPlanningSubscriptionUpdateInput = {
  adventureLevelPct: Scalars['Int']['input'];
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisinePreferences: Array<CuisineRegion>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate: Scalars['DateTime']['input'];
  dietaryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  mealsPerWeek: Scalars['Int']['input'];
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  oilinessPreferencePct: Scalars['Int']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  recurringPeriod?: InputMaybe<RecurringPeriod>;
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  servingsPerMeal: Scalars['Int']['input'];
  spiceLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type Menu = {
  __typename?: 'Menu';
  dateRange: DateRange;
  holiday?: Maybe<Holiday>;
  id: Scalars['Int']['output'];
  shefId: Scalars['String']['output'];
};

export type MerchandisePageTagSlugFilterInput = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  pageId: Scalars['String']['input'];
  tagSlug: Scalars['String']['input'];
};

export type ModifyHeldGroupOrderInput = {
  id: Scalars['String']['input'];
  perShefOrders: Array<PerShefHeldOrderModifyInput>;
};

export type ModifyHeldGroupOrderResponse = MutationResponse & {
  __typename?: 'ModifyHeldGroupOrderResponse';
  message: Scalars['String']['output'];
  orders: Array<Order>;
  success: Scalars['Boolean']['output'];
};

export type ModifyInvoiceInput = {
  id: Scalars['String']['input'];
  orderInputs?: InputMaybe<Array<SubscriptionBuildOrderInput>>;
  timeWindows?: InputMaybe<Array<ModifyTimeWindow>>;
};

export type ModifyLineItemInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  addOnItemsTotal: Scalars['Int']['input'];
  lineItems: Array<OrderLineItemInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  shefTip: Scalars['Int']['input'];
  subtotal: Scalars['Int']['input'];
};

export type ModifyMealPlanInput = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<MealPlanStatus>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
  upcomingOrderToCancelDeliveryDate?: InputMaybe<Scalars['String']['input']>;
};

export type ModifyMealPlanResponse = MutationResponse & {
  __typename?: 'ModifyMealPlanResponse';
  mealPlan?: Maybe<MealPlan>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ModifyTimeWindow = {
  deliveryDate: Scalars['String']['input'];
  timeWindowId: Scalars['Int']['input'];
};

export enum MultiResponse {
  Medium = 'MEDIUM',
  Mixed = 'MIXED',
  Strict = 'STRICT'
}

export type Mutation = {
  __typename?: 'Mutation';
  addAdminUser: Scalars['Boolean']['output'];
  addBecomeAShefPhoneNumber: Scalars['Boolean']['output'];
  addExploreMerchandisePage: ExploreMerchandisePage;
  addFoodItem: FoodItem;
  addGroupOrder2: GroupOrderResult;
  addGroupOrderRating: GroupOrderRatingOutput;
  addLineDrive: LineDrive;
  addShefApplication: ShefApplicationResult;
  addShefPromoCode: PromoCode;
  addTasteProfile: TasteProfileMutationResponse;
  addUserToHubs: Scalars['Boolean']['output'];
  adminAddDeliveryEvent: DeliveryEvent;
  adminAddDeliveryEventType: DeliveryEventType;
  adminAddGroupOrder: AdminAddGroupOrderResult;
  adminAddPromoCodeTagType: PromoCodeTagType;
  adminBanUser: Scalars['Boolean']['output'];
  adminBulkAddEmployeeGiftCards: Array<PromoCode>;
  adminBulkAddPartnerGiftCards: Array<PromoCode>;
  adminBulkAddPromoCodes: Array<PromoCode>;
  adminBulkAddShefGiftCards: Array<PromoCode>;
  adminBulkAddZipCodes: Array<ZipCode>;
  adminBulkRechargeGiftCards: Scalars['Boolean']['output'];
  adminBulkUpdateApplication: Scalars['Boolean']['output'];
  adminBulkUpdateFoodItemChangeRequests: Array<FoodItemChangeRequest>;
  adminBulkUpdatePromoCodes: Array<PromoCode>;
  adminBulkUpdateZipCodes: Array<ZipCode>;
  adminCreateEventConfig: Scalars['Boolean']['output'];
  adminDeleteAllDeliveryEventsByOrder: Array<DeliveryEvent>;
  adminDeleteDeliveryEvent: DeliveryEvent;
  adminDeleteEventConfig: Scalars['Boolean']['output'];
  adminDeleteUser: User;
  adminDeleteZipCode: Scalars['Boolean']['output'];
  adminDisconnectShefStripe: Scalars['Boolean']['output'];
  adminEditDeliveryEventType: DeliveryEventType;
  adminEditPromoCodeTagType: PromoCodeTagType;
  adminImpersonateUser: AuthResult;
  adminModifyGroupOrder: GroupOrder;
  adminResetPassword: User;
  adminSetUserRoles: Array<UserRoleResult>;
  adminSkipMealPlanGroupOrder: AdminSkipMealPlanGroupOrderResponse;
  adminUnbanUser: Scalars['Boolean']['output'];
  adminUpdateApplication: Scalars['Boolean']['output'];
  adminUpdateEventConfig: Scalars['Boolean']['output'];
  adminUpdatePromoCodeTags: Array<PromoCodeTag>;
  approveFoodHandlerCertificate: Scalars['Boolean']['output'];
  archiveDeliveryAddress?: Maybe<Scalars['Boolean']['output']>;
  attemptMealPlanningPurchase: Scalars['Boolean']['output'];
  becomeATaster: User;
  bulkAddFoodItemComments?: Maybe<Scalars['Boolean']['output']>;
  bulkCreateMerchandisePageTagFiltersByTagId?: Maybe<Scalars['Boolean']['output']>;
  bulkCreateMerchandisePageTagFiltersByTagSlug?: Maybe<Scalars['Boolean']['output']>;
  bulkCreateNamsorDataForUsers?: Maybe<Scalars['Boolean']['output']>;
  bulkDeleteMerchandisePageTagFilterByTagFilterIds?: Maybe<Scalars['Boolean']['output']>;
  bulkDeleteMerchandisePageTagFilterByTagSlug?: Maybe<Scalars['Boolean']['output']>;
  bulkMakeFoodItemDraftStatus: Scalars['Boolean']['output'];
  bulkModifyShefProfile: Array<ShefProfile>;
  bulkReadFoodItemCommentsForFoodItem: Scalars['Boolean']['output'];
  bulkReindexFoodItems?: Maybe<Scalars['Boolean']['output']>;
  bulkSetShefPlatformPercents: Scalars['Boolean']['output'];
  bulkTagFoodItemsByIds: Scalars['Boolean']['output'];
  bulkTagShefsByIds: Scalars['Boolean']['output'];
  bulkTagShefsByTagIds: Scalars['Boolean']['output'];
  bulkTagShefsByTagSlugs: Scalars['Boolean']['output'];
  bulkUntagShefsBySlugs: Scalars['Boolean']['output'];
  bulkUntagShefsByTagIds: Scalars['Boolean']['output'];
  cancelGroupOrder: GroupOrder;
  cancelGroupOrderDelivery: Scalars['Boolean']['output'];
  cartClearItems: CartResults;
  cartSetLineItems: CartResults;
  claimPhotoEditRequest: PhotoEditRequest;
  clearCartItems?: Maybe<Scalars['Boolean']['output']>;
  consumerModifyGroupOrder: GroupOrder;
  createAddOnItem: AddOnItem;
  createFoodItemChangeRequest: FoodItemChangeRequest;
  createOrUpdateDeliveryHub?: Maybe<UpdateDeliveryHubResult>;
  createOrUpdateRegion?: Maybe<RegionInfo>;
  createShefAvailabilityNotification: Scalars['Boolean']['output'];
  createShefPost: Scalars['Boolean']['output'];
  createShefTag: ShefTagType;
  createStripeConnect: ShefStripeConnect;
  deleteExploreMerchandisePage: Scalars['Boolean']['output'];
  deleteFoodItem: Scalars['Boolean']['output'];
  deleteMerchandisePageTagFilter: Scalars['Boolean']['output'];
  deleteShefPost: Scalars['Boolean']['output'];
  deleteShefTag: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  disableFringe: Scalars['Boolean']['output'];
  disablePromoCode: PromoCode;
  duplicateOrderToCart: DuplicateOrderToCartResponse;
  editShefApplication: Scalars['Boolean']['output'];
  editShefApplicationCancelOnboardingCall: Scalars['Boolean']['output'];
  editShefApplicationCancelOrientationCall: Scalars['Boolean']['output'];
  editShefApplicationCancelTasting: Scalars['Boolean']['output'];
  editShefApplicationCompleteInformationSession: Scalars['Boolean']['output'];
  editShefApplicationConfirmTasting: Scalars['Boolean']['output'];
  editShefApplicationMenuWebinarCompletedAt: Scalars['Boolean']['output'];
  editShefApplicationMenuWebinarScheduledAt: Scalars['Boolean']['output'];
  flagRatingForReview?: Maybe<Scalars['Boolean']['output']>;
  followShef: PublicShef;
  getSignedUrl: SignedUrl;
  incrementShefPostClickCount: Scalars['Boolean']['output'];
  incrementShefPostViewCount: Scalars['Boolean']['output'];
  indexShefs: Scalars['Boolean']['output'];
  ingestAnalyticsEvent: Scalars['Boolean']['output'];
  ingestFacebookEvent: Scalars['Boolean']['output'];
  initializeMealPlan: InitializeMealPlanResponse;
  likeShefPost: Scalars['Boolean']['output'];
  login2: AuthResult;
  loginWithOAuth2: OAuthResult;
  makeFoodItemDraftStatus: Scalars['Boolean']['output'];
  markUserVisitedPreferencesPage: User;
  modifyDeliveryAddress: Address;
  modifyDeliveryDays: Scalars['Boolean']['output'];
  modifyFoodItemHolidayMenu: Scalars['Boolean']['output'];
  modifyGeoConfig: Scalars['Boolean']['output'];
  modifyHeldGroupOrder: ModifyHeldGroupOrderResponse;
  modifyMealPlan: ModifyMealPlanResponse;
  modifyShefAvailabilityRules?: Maybe<Scalars['Boolean']['output']>;
  modifyShefFulfillmentInfo: Scalars['Boolean']['output'];
  modifyShefPost: Scalars['Boolean']['output'];
  modifyShefProfile: ShefProfile;
  modifySubscription: SubscriptionModifyResult;
  modifyUser: User;
  modifyUserPhone: User;
  refundGroupOrder2: GroupOrder;
  register2: AuthResult;
  registerPushToken?: Maybe<Scalars['Boolean']['output']>;
  reindexFoodItem?: Maybe<Scalars['Boolean']['output']>;
  removeAdminUser: Scalars['Boolean']['output'];
  removeBackgroundFromPhoto: PhotoBackgroundRemovalsResult;
  removeCreditCard?: Maybe<Scalars['Boolean']['output']>;
  removeUserFromHubs: Scalars['Boolean']['output'];
  requestBulkGroupOrderDelivery?: Maybe<Scalars['Boolean']['output']>;
  requestGroupOrderDeliveries: RequestGroupOrderDeliveriesResults;
  resetChangePassword?: Maybe<Scalars['Boolean']['output']>;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  saveCreditCard?: Maybe<SavedCreditCard>;
  saveDeliveryAddress: Address;
  scanDropOffOrder: Order;
  setCartItem?: Maybe<CartLineItem>;
  setCartItems: Array<Maybe<CartLineItem>>;
  shefApplicationQuestionsCompleted: Scalars['Boolean']['output'];
  skipMealPlanGroupOrder: SkipMealPlanGroupOrderResponse;
  tagShefByTagId: Scalars['Boolean']['output'];
  tagShefByTagSlug: Scalars['Boolean']['output'];
  unclaimPhotoEditRequest: PhotoEditRequest;
  unfollowShef: Scalars['Boolean']['output'];
  unscanDropOffOrder: Order;
  unskipMealPlanGroupOrder: UnskipMealPlanGroupOrderResponse;
  updateAddOnItemStatus: Scalars['Boolean']['output'];
  updateAuditStatus: Scalars['Boolean']['output'];
  updateConfig?: Maybe<Config>;
  updateExploreMerchandisePage: ExploreMerchandisePage;
  updateExplorePagePromoCode?: Maybe<Array<Maybe<PromoCode>>>;
  updateFoodItemChangeRequest: FoodItemChangeRequest;
  updateMerchandisePageTagFilter: ExploreMerchandisePageTagFilter;
  updatePhotoEditRequest: PhotoEditRequest;
  updatePhotoEditStatus: PhotoEditRequest;
  updateShefApplicationProfileImages: Scalars['Boolean']['output'];
  updateShefOrderRatingCategory: Scalars['Boolean']['output'];
  updateShefTag: ShefTagType;
  updateShefZipCode: Scalars['Boolean']['output'];
  updateTasteProfile: TasteProfileMutationResponse;
  updateUserNotificationSettings: Array<UserNotificationSetting>;
};


export type MutationAddAdminUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAddBecomeAShefPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationAddExploreMerchandisePageArgs = {
  page: ExploreMerchandisePageInput;
};


export type MutationAddFoodItemArgs = {
  shefId: Scalars['String']['input'];
};


export type MutationAddGroupOrder2Args = {
  input: GroupOrderInput;
};


export type MutationAddGroupOrderRatingArgs = {
  input: GroupOrderRatingInput;
};


export type MutationAddLineDriveArgs = {
  input: AddLineDriveInput;
};


export type MutationAddShefApplicationArgs = {
  promoCode?: InputMaybe<Scalars['String']['input']>;
  shefApplicationInput: ShefApplicationInput;
};


export type MutationAddShefPromoCodeArgs = {
  promoCodeInput: ShefPromoCodeInput;
};


export type MutationAddTasteProfileArgs = {
  input: TasteProfileMutationInput;
};


export type MutationAddUserToHubsArgs = {
  input: AddUserFromHubInput;
};


export type MutationAdminAddDeliveryEventArgs = {
  input: AddDeliveryEventInput;
};


export type MutationAdminAddDeliveryEventTypeArgs = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminAddGroupOrderArgs = {
  input: GroupOrderInput;
};


export type MutationAdminAddPromoCodeTagTypeArgs = {
  tag: Scalars['String']['input'];
};


export type MutationAdminBanUserArgs = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminBulkAddEmployeeGiftCardsArgs = {
  input: AdminBulkGiftCardsInput;
};


export type MutationAdminBulkAddPartnerGiftCardsArgs = {
  input: AdminBulkPartnerGiftCardsInput;
};


export type MutationAdminBulkAddPromoCodesArgs = {
  input: Array<PromoCodeInput>;
};


export type MutationAdminBulkAddShefGiftCardsArgs = {
  input: AdminBulkShefGiftCardsInput;
};


export type MutationAdminBulkAddZipCodesArgs = {
  input: Array<ZipCodeInput>;
};


export type MutationAdminBulkRechargeGiftCardsArgs = {
  input: AdminBulkRechargeGiftCardsInput;
};


export type MutationAdminBulkUpdateApplicationArgs = {
  input: Array<BulkAdminShefApplicationUpdateInput>;
};


export type MutationAdminBulkUpdateFoodItemChangeRequestsArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  foodItemChangeRequestIds: Array<Scalars['Int']['input']>;
  status?: InputMaybe<RequestStatus>;
};


export type MutationAdminBulkUpdatePromoCodesArgs = {
  input: Array<UpdatePromoCodeInput>;
};


export type MutationAdminBulkUpdateZipCodesArgs = {
  input: Array<ZipCodeInput>;
};


export type MutationAdminCreateEventConfigArgs = {
  input: AdminCreateEventConfig;
};


export type MutationAdminDeleteAllDeliveryEventsByOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationAdminDeleteDeliveryEventArgs = {
  input: DeleteDeliveryEventInput;
};


export type MutationAdminDeleteEventConfigArgs = {
  destination?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
};


export type MutationAdminDeleteUserArgs = {
  confirmationCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminDeleteZipCodeArgs = {
  zipCode: Scalars['String']['input'];
};


export type MutationAdminDisconnectShefStripeArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAdminEditDeliveryEventTypeArgs = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['String']['input'];
};


export type MutationAdminEditPromoCodeTagTypeArgs = {
  tag: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};


export type MutationAdminImpersonateUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAdminModifyGroupOrderArgs = {
  input: AdminModifyGroupOrderInput;
};


export type MutationAdminResetPasswordArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminSetUserRolesArgs = {
  userId: Scalars['String']['input'];
  userRoles: Array<UserRoleInput>;
};


export type MutationAdminSkipMealPlanGroupOrderArgs = {
  input: AdminSkipMealPlanGroupOrderInput;
};


export type MutationAdminUnbanUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAdminUpdateApplicationArgs = {
  input: AdminShefApplicationUpdateInput;
  shefId: Scalars['String']['input'];
};


export type MutationAdminUpdateEventConfigArgs = {
  input: AdminUpdateEventConfig;
};


export type MutationAdminUpdatePromoCodeTagsArgs = {
  codeId: Scalars['Int']['input'];
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationApproveFoodHandlerCertificateArgs = {
  userId: Scalars['String']['input'];
};


export type MutationArchiveDeliveryAddressArgs = {
  addressId: Scalars['Int']['input'];
};


export type MutationAttemptMealPlanningPurchaseArgs = {
  input: MealPlanningPurchaseInput;
};


export type MutationBulkAddFoodItemCommentsArgs = {
  comments: Array<FoodItemCommentInput>;
};


export type MutationBulkCreateMerchandisePageTagFiltersByTagIdArgs = {
  tagFilters: Array<CreateMerchandisePageTagFilterInput>;
};


export type MutationBulkCreateMerchandisePageTagFiltersByTagSlugArgs = {
  tagFilters: Array<MerchandisePageTagSlugFilterInput>;
};


export type MutationBulkCreateNamsorDataForUsersArgs = {
  userIds: Array<Scalars['String']['input']>;
};


export type MutationBulkDeleteMerchandisePageTagFilterByTagFilterIdsArgs = {
  tagFilterIds: Array<Scalars['String']['input']>;
};


export type MutationBulkDeleteMerchandisePageTagFilterByTagSlugArgs = {
  pageId: Scalars['String']['input'];
  tagSlugs: Array<Scalars['String']['input']>;
};


export type MutationBulkMakeFoodItemDraftStatusArgs = {
  foodItemIds: Array<Scalars['Int']['input']>;
};


export type MutationBulkModifyShefProfileArgs = {
  shefProfileInputs: Array<ShefProfileInput>;
};


export type MutationBulkReadFoodItemCommentsForFoodItemArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type MutationBulkReindexFoodItemsArgs = {
  foodItemIds: Array<Scalars['Int']['input']>;
};


export type MutationBulkSetShefPlatformPercentsArgs = {
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  platformPercent?: InputMaybe<Scalars['Int']['input']>;
  shefIds: Array<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationBulkTagFoodItemsByIdsArgs = {
  foodItemTags: Array<FoodItemTags>;
};


export type MutationBulkTagShefsByIdsArgs = {
  shefTags: Array<ShefTags>;
};


export type MutationBulkTagShefsByTagIdsArgs = {
  shefIds: Array<Scalars['String']['input']>;
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationBulkTagShefsByTagSlugsArgs = {
  shefIds: Array<Scalars['String']['input']>;
  tagSlugs: Array<Scalars['String']['input']>;
};


export type MutationBulkUntagShefsBySlugsArgs = {
  shefIds: Array<Scalars['String']['input']>;
  tagSlugs: Array<Scalars['String']['input']>;
};


export type MutationBulkUntagShefsByTagIdsArgs = {
  shefIds: Array<Scalars['String']['input']>;
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationCancelGroupOrderArgs = {
  groupOrderId: Scalars['String']['input'];
};


export type MutationCancelGroupOrderDeliveryArgs = {
  groupOrderId: Scalars['String']['input'];
  regionId: Scalars['Int']['input'];
};


export type MutationCartClearItemsArgs = {
  shefIds: Array<Scalars['String']['input']>;
};


export type MutationCartSetLineItemsArgs = {
  cartLineItemInputs: Array<CartLineItemInput>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationClaimPhotoEditRequestArgs = {
  changeRequestId: Scalars['Int']['input'];
};


export type MutationClearCartItemsArgs = {
  shefIds: Array<Scalars['String']['input']>;
};


export type MutationConsumerModifyGroupOrderArgs = {
  input: ConsumerModifyGroupOrderInput;
};


export type MutationCreateAddOnItemArgs = {
  createAddOnItemInput: CreateAddOnItemInput;
};


export type MutationCreateFoodItemChangeRequestArgs = {
  autoApproveIfPossible?: InputMaybe<Scalars['Boolean']['input']>;
  changeset: FoodItemChangesetInput;
  comment?: InputMaybe<Scalars['String']['input']>;
  foodItemId: Scalars['Int']['input'];
  makeLive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateOrUpdateDeliveryHubArgs = {
  deliveryHubInput: UpdateDeliveryHubInput;
};


export type MutationCreateOrUpdateRegionArgs = {
  regionInfo: UpdateRegionInput;
};


export type MutationCreateShefAvailabilityNotificationArgs = {
  shefId: Scalars['String']['input'];
};


export type MutationCreateShefPostArgs = {
  input: ShefPostInput;
};


export type MutationCreateShefTagArgs = {
  tag: ShefTagInput;
};


export type MutationCreateStripeConnectArgs = {
  code: Scalars['String']['input'];
  stripeAccountType?: InputMaybe<StripeAccountType>;
  userId: Scalars['String']['input'];
};


export type MutationDeleteExploreMerchandisePageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFoodItemArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type MutationDeleteMerchandisePageTagFilterArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteShefPostArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteShefTagArgs = {
  tagId: Scalars['String']['input'];
};


export type MutationDisablePromoCodeArgs = {
  promoCodeId: Scalars['Int']['input'];
};


export type MutationDuplicateOrderToCartArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationArgs = {
  applicationId: Scalars['Int']['input'];
  shefApplicationInput: ShefApplicationInputStep2;
};


export type MutationEditShefApplicationCancelOnboardingCallArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationCancelOrientationCallArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationCancelTastingArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationCompleteInformationSessionArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationConfirmTastingArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationMenuWebinarCompletedAtArgs = {
  applicationId: Scalars['Int']['input'];
  dateInput?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationEditShefApplicationMenuWebinarScheduledAtArgs = {
  applicationId: Scalars['Int']['input'];
  dateInput?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationFlagRatingForReviewArgs = {
  ratingId: Scalars['Int']['input'];
};


export type MutationFollowShefArgs = {
  canRefollow?: InputMaybe<Scalars['Boolean']['input']>;
  shefId: Scalars['String']['input'];
};


export type MutationGetSignedUrlArgs = {
  input: SignedUrlInput;
};


export type MutationIncrementShefPostClickCountArgs = {
  id: Scalars['String']['input'];
};


export type MutationIncrementShefPostViewCountArgs = {
  id: Scalars['String']['input'];
};


export type MutationIngestAnalyticsEventArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
};


export type MutationIngestFacebookEventArgs = {
  event: FacebookEvent;
  eventName: Scalars['String']['input'];
};


export type MutationInitializeMealPlanArgs = {
  input: InitializeMealPlanInput;
};


export type MutationLikeShefPostArgs = {
  id: Scalars['String']['input'];
};


export type MutationLogin2Args = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginWithOAuth2Args = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oAuthLoginType: OAuthLoginType;
  phone?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  requireZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  signUpEntryPoint?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  utm?: InputMaybe<UtmInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMakeFoodItemDraftStatusArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type MutationModifyDeliveryAddressArgs = {
  addressId: Scalars['Int']['input'];
  addressInput?: InputMaybe<AddressInput>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationModifyDeliveryDaysArgs = {
  deliveryDaysInput: DeliveryDaysInput;
};


export type MutationModifyFoodItemHolidayMenuArgs = {
  foodItemId: Scalars['Int']['input'];
  holiday?: InputMaybe<Holiday>;
};


export type MutationModifyGeoConfigArgs = {
  input: GeoConfigInput;
};


export type MutationModifyHeldGroupOrderArgs = {
  input: ModifyHeldGroupOrderInput;
};


export type MutationModifyMealPlanArgs = {
  input: ModifyMealPlanInput;
};


export type MutationModifyShefAvailabilityRulesArgs = {
  add?: InputMaybe<Array<ShefAvailabilityRuleInput>>;
  availableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  daysOfWeek?: InputMaybe<ShefAvailabilityRuleDaysOfWeekInput>;
  end?: InputMaybe<Array<Scalars['String']['input']>>;
  shefId: Scalars['String']['input'];
  unavailableDates?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationModifyShefFulfillmentInfoArgs = {
  input: FulfillmentInput;
};


export type MutationModifyShefPostArgs = {
  id: Scalars['String']['input'];
  input: ShefPostInput;
};


export type MutationModifyShefProfileArgs = {
  shefProfileInput: ShefProfileInput;
};


export type MutationModifySubscriptionArgs = {
  input: SubscriptionModifyInput;
};


export type MutationModifyUserArgs = {
  userInput: UserInput;
};


export type MutationModifyUserPhoneArgs = {
  phone: Scalars['String']['input'];
};


export type MutationRefundGroupOrder2Args = {
  input: GroupOrderLevelRefundInput;
};


export type MutationRegister2Args = {
  platform?: InputMaybe<Platform>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  signUpEntryPoint?: InputMaybe<Scalars['String']['input']>;
  userInput: UserInput;
  utm?: InputMaybe<UtmInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterPushTokenArgs = {
  input: PushNotificationTokenInput;
};


export type MutationReindexFoodItemArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type MutationRemoveAdminUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRemoveBackgroundFromPhotoArgs = {
  input: PhotoBackgroundRemovalsInput;
};


export type MutationRemoveCreditCardArgs = {
  cardId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveUserFromHubsArgs = {
  input: AddUserFromHubInput;
};


export type MutationRequestBulkGroupOrderDeliveryArgs = {
  deliveryHubId?: InputMaybe<Scalars['Int']['input']>;
  forceRequest?: InputMaybe<Scalars['Boolean']['input']>;
  groupOrderIds: Array<Scalars['String']['input']>;
  tipOverride?: InputMaybe<Scalars['Int']['input']>;
  useTimeWindows?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRequestGroupOrderDeliveriesArgs = {
  forceRequest?: InputMaybe<Scalars['Boolean']['input']>;
  groupOrderIds: Array<Scalars['String']['input']>;
  hyperBatched?: InputMaybe<Scalars['Boolean']['input']>;
  tipOverride?: InputMaybe<Scalars['Int']['input']>;
  useTimeWindows?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResetChangePasswordArgs = {
  password: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSaveCreditCardArgs = {
  creditCardInput?: InputMaybe<SavedCreditCardInput>;
};


export type MutationSaveDeliveryAddressArgs = {
  addressInput: AddressInput;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationScanDropOffOrderArgs = {
  input: DropOffScanInput;
};


export type MutationSetCartItemArgs = {
  cartLineItemInput: CartLineItemInput;
};


export type MutationSetCartItemsArgs = {
  cartLineItemInputs: Array<CartLineItemInput>;
};


export type MutationSkipMealPlanGroupOrderArgs = {
  input: SkipMealPlanGroupOrderInput;
};


export type MutationTagShefByTagIdArgs = {
  shefId: Scalars['String']['input'];
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationTagShefByTagSlugArgs = {
  shefId: Scalars['String']['input'];
  tagSlugs: Array<Scalars['String']['input']>;
};


export type MutationUnclaimPhotoEditRequestArgs = {
  changeRequestId: Scalars['Int']['input'];
  unclaimReason: Scalars['String']['input'];
};


export type MutationUnfollowShefArgs = {
  shefId: Scalars['String']['input'];
};


export type MutationUnscanDropOffOrderArgs = {
  input: UnscanInput;
};


export type MutationUnskipMealPlanGroupOrderArgs = {
  input: UnskipMealPlanGroupOrderInput;
};


export type MutationUpdateAddOnItemStatusArgs = {
  active: Scalars['Boolean']['input'];
  addOnItemId: Scalars['Int']['input'];
  regionId: Scalars['Int']['input'];
};


export type MutationUpdateAuditStatusArgs = {
  auditGroupId: Scalars['String']['input'];
  status: AuditStatus;
};


export type MutationUpdateConfigArgs = {
  name: FeatureName;
  overrides: Array<ConfigOverrideInput>;
  value: Scalars['String']['input'];
};


export type MutationUpdateExploreMerchandisePageArgs = {
  id: Scalars['String']['input'];
  page: ExploreMerchandisePageInput;
};


export type MutationUpdateExplorePagePromoCodeArgs = {
  promoCodeId?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};


export type MutationUpdateFoodItemChangeRequestArgs = {
  autoApproveIfPossible?: InputMaybe<Scalars['Boolean']['input']>;
  changeset?: InputMaybe<FoodItemChangesetInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  foodItemChangeRequestId: Scalars['Int']['input'];
  photoEditRequestNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RequestStatus>;
};


export type MutationUpdateMerchandisePageTagFilterArgs = {
  tagFilter: UpdateMerchandisePageTagFilterInput;
};


export type MutationUpdatePhotoEditRequestArgs = {
  id: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
};


export type MutationUpdatePhotoEditStatusArgs = {
  changeRequestId: Scalars['Int']['input'];
  status: RequestStatus;
};


export type MutationUpdateShefApplicationProfileImagesArgs = {
  profileImageInput?: InputMaybe<ShefApplicationProfileInput>;
  shefId: Scalars['String']['input'];
};


export type MutationUpdateShefOrderRatingCategoryArgs = {
  category: OrderRatingCategory;
  ratingId: Scalars['Int']['input'];
};


export type MutationUpdateShefTagArgs = {
  tag: ShefTagInput;
  tagId: Scalars['String']['input'];
};


export type MutationUpdateShefZipCodeArgs = {
  newZipCode: Scalars['String']['input'];
};


export type MutationUpdateTasteProfileArgs = {
  input: TasteProfileMutationInput;
};


export type MutationUpdateUserNotificationSettingsArgs = {
  input: UserNotificationSettingUpdate;
};

export type MutationResponse = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum NewOrderNotificationFrequency {
  AllOrders = 'ALL_ORDERS',
  FirstOrderPerDeliveryDay = 'FIRST_ORDER_PER_DELIVERY_DAY',
  NeverNotify = 'NEVER_NOTIFY'
}

export enum NotificationCategory {
  Delivery = 'DELIVERY',
  Marketing = 'MARKETING'
}

export type NumberAvailableDishesResult = {
  __typename?: 'NumberAvailableDishesResult';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type NumberAvailableShefsResult = {
  __typename?: 'NumberAvailableShefsResult';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export enum OAuthLoginType {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  GoogleAndroid = 'GOOGLE_ANDROID',
  GoogleIos = 'GOOGLE_IOS',
  GoogleWeb = 'GOOGLE_WEB'
}

export type OAuthMissingFieldsResult = {
  __typename?: 'OAuthMissingFieldsResult';
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameIsMissing?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameIsMissing?: Maybe<Scalars['Boolean']['output']>;
  needsToAcceptTermsOfService?: Maybe<Scalars['Boolean']['output']>;
  phoneNumberIsMissing?: Maybe<Scalars['Boolean']['output']>;
  zipCodeIsMissing?: Maybe<Scalars['Boolean']['output']>;
};

export type OAuthResult = AuthResult | OAuthMissingFieldsResult;

export type Order = {
  __typename?: 'Order';
  addOnItems: Array<OrderAddOnItem>;
  addOnItemsTotal: Scalars['Int']['output'];
  address: Address;
  availableAddOnItems: Array<AddOnItem>;
  bagCount?: Maybe<Scalars['Int']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  consumerOrderStatus: ConsumerOrderStatus;
  correctedRefundReason?: Maybe<Scalars['String']['output']>;
  correctedRefundType?: Maybe<RefundType>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  delivery?: Maybe<Delivery>;
  deliveryAddressId: Scalars['Int']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  deliveryDiscount?: Maybe<Scalars['Int']['output']>;
  deliveryEditableCutoff?: Maybe<Scalars['DateTime']['output']>;
  deliveryFee: Scalars['Int']['output'];
  deliveryId?: Maybe<Scalars['String']['output']>;
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  deliveryOrderNumber?: Maybe<Scalars['Int']['output']>;
  deliveryType: Scalars['String']['output'];
  discountApplied: Scalars['Int']['output'];
  droppedOffAt?: Maybe<Scalars['DateTime']['output']>;
  droppedOffWithinWindow?: Maybe<Scalars['Boolean']['output']>;
  foodRating?: Maybe<ShefOrderRating>;
  fulfillmentDate: Scalars['DateTime']['output'];
  grandTotal: Scalars['Int']['output'];
  groupOrderId: Scalars['String']['output'];
  groupOrderItemCount: Scalars['Int']['output'];
  groupOrderSize: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isBackToBackOrder: Scalars['Boolean']['output'];
  isCancelable: Scalars['Boolean']['output'];
  isDeliveryEditable: Scalars['Boolean']['output'];
  isFirstOrder: Scalars['Boolean']['output'];
  isFollower: Scalars['Boolean']['output'];
  isLineItemsEditable: Scalars['Boolean']['output'];
  isReusablePackaging: Scalars['Boolean']['output'];
  isTasteTest: Scalars['Boolean']['output'];
  lineItems: Array<OrderLineItem>;
  lineItemsEditableCutoff?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numOrdersFromShef: Scalars['Int']['output'];
  orderStatus: OrderStatus;
  orderType: OrderType;
  orderVisibility: OrderVisibility;
  paymentProcessor: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  pickupAddress?: Maybe<Address>;
  pickupAddressId?: Maybe<Scalars['Int']['output']>;
  pickupDeliveryHub?: Maybe<DeliveryHub>;
  platformFee: Scalars['Int']['output'];
  platformPayment: Scalars['Int']['output'];
  possibleDeliveryDates: Array<PossibleDeliveryDate>;
  promoCode?: Maybe<PromoCode>;
  publicShef: PublicShef;
  qaCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  qaPhotoUrl?: Maybe<Scalars['String']['output']>;
  readyForPickupTimetamp?: Maybe<Scalars['DateTime']['output']>;
  recurringNotes?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Int']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
  refundMessage?: Maybe<Scalars['String']['output']>;
  refundNotes?: Maybe<Scalars['String']['output']>;
  refundReason?: Maybe<Scalars['String']['output']>;
  refundTimestamp?: Maybe<Scalars['DateTime']['output']>;
  refundType?: Maybe<RefundType>;
  region: RegionInfo;
  reversedShefPaymentAmount: Scalars['Int']['output'];
  salesTax: Scalars['Int']['output'];
  scannedAtHubId?: Maybe<Scalars['Int']['output']>;
  scannedById?: Maybe<Scalars['Int']['output']>;
  serviceFee: Scalars['Int']['output'];
  shef: User;
  shefFulfillmentTimeWindow: OrderTimeWindow;
  shefFulfillmentTimeWindowId?: Maybe<Scalars['Int']['output']>;
  shefId: Scalars['String']['output'];
  shefPayment: Scalars['Int']['output'];
  shefPlatformPercent: Scalars['Int']['output'];
  shefProfile: ShefProfile;
  shefTip?: Maybe<Scalars['Int']['output']>;
  smallOrderFee: Scalars['Int']['output'];
  subscription?: Maybe<Subscription>;
  subscriptionInvoiceId?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Int']['output'];
  timeWindow: OrderTimeWindow;
  timeWindowId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type OrderAddOnItem = {
  __typename?: 'OrderAddOnItem';
  addOnItem: AddOnItem;
  addOnItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  transactionLineItemId?: Maybe<Scalars['String']['output']>;
};

export type OrderAddOnItemInput = {
  addOnItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate: Scalars['DateTime']['input'];
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  expectedAdditionalDeliveryDateSpend?: InputMaybe<Scalars['Int']['input']>;
  lineItems: Array<OrderLineItemInput>;
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<OrderStatus>;
  orderType?: InputMaybe<OrderType>;
  phone: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recurringNotes?: InputMaybe<Scalars['String']['input']>;
  recurringPeriod?: InputMaybe<RecurringPeriod>;
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  shefId: Scalars['String']['input'];
  shefTip?: InputMaybe<Scalars['Int']['input']>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  subtotal: Scalars['Int']['input'];
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderLevelRefundInput = {
  orderId: Scalars['Int']['input'];
  orderLineItemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  refundDetails?: InputMaybe<Scalars['String']['input']>;
  refundReason: RefundGroupOrderReasonInput;
  refundType: GroupOrderRefundType;
};

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  customizationIds?: Maybe<Array<Scalars['String']['output']>>;
  customizations?: Maybe<Array<FoodItemCustomization>>;
  foodItem: FoodItem;
  foodItemId: Scalars['Int']['output'];
  foodItemSnapshot?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  rating?: Maybe<FoodItemRating>;
  slug: Scalars['String']['output'];
  upsellTierSnapshot?: Maybe<Scalars['JSONObject']['output']>;
  userId: Scalars['String']['output'];
};

export type OrderLineItemInput = {
  customizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  foodItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderModifyInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryFee?: InputMaybe<Scalars['Int']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  discountApplied?: InputMaybe<Scalars['Int']['input']>;
  grandTotal?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderStatus?: InputMaybe<OrderStatus>;
  orderType?: InputMaybe<OrderType>;
  paymentProcessor?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformFee?: InputMaybe<Scalars['Int']['input']>;
  platformPayment?: InputMaybe<Scalars['Int']['input']>;
  readyForPickupTimetamp?: InputMaybe<Scalars['DateTime']['input']>;
  refundAmount?: InputMaybe<Scalars['Int']['input']>;
  refundId?: InputMaybe<Scalars['String']['input']>;
  refundMessage?: InputMaybe<Scalars['String']['input']>;
  refundNotes?: InputMaybe<Scalars['String']['input']>;
  refundReason?: InputMaybe<Scalars['String']['input']>;
  refundTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  refundType?: InputMaybe<RefundType>;
  serviceFee?: InputMaybe<Scalars['Int']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
  shefPayment?: InputMaybe<Scalars['Int']['input']>;
  shefTip?: InputMaybe<Scalars['Int']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderRatingCategory {
  Delivery = 'DELIVERY',
  Food = 'FOOD'
}

export type OrderRatingInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  foodItemRatings?: InputMaybe<Array<FoodItemRatingInput>>;
  orderId: Scalars['Int']['input'];
  privateComment?: InputMaybe<Scalars['String']['input']>;
  shefId: Scalars['String']['input'];
};

export type OrderRatingTags = {
  __typename?: 'OrderRatingTags';
  ignoreFoodTags?: Maybe<Array<Scalars['String']['output']>>;
  negativeFoodTags: Array<Scalars['String']['output']>;
  positiveFoodTags: Array<Scalars['String']['output']>;
};

export type OrderRefundInput = {
  groupOrderId: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  refundAmount: Scalars['Int']['input'];
  refundMessage?: InputMaybe<Scalars['String']['input']>;
  refundNotes?: InputMaybe<Scalars['String']['input']>;
  refundReason: Scalars['String']['input'];
  refundType: RefundType;
};

export type OrderResult = {
  __typename?: 'OrderResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
  order: Order;
};

export type OrderResults = {
  __typename?: 'OrderResults';
  orders: Array<Order>;
  pagination: Pagination;
};

export enum OrderStatus {
  AwaitingPickup = 'AWAITING_PICKUP',
  Completed = 'COMPLETED',
  Held = 'HELD',
  InTransit = 'IN_TRANSIT',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Preparing = 'PREPARING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Refunded = 'REFUNDED',
  RequestingPickup = 'REQUESTING_PICKUP',
  Skipped = 'SKIPPED'
}

export type OrderTimeWindow = {
  __typename?: 'OrderTimeWindow';
  endMsAfterMidnight: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startMsAfterMidnight: Scalars['Int']['output'];
};

export type OrderTotals = {
  __typename?: 'OrderTotals';
  deliveryFee: Scalars['Int']['output'];
  /** Deprecated: Use `promoApplied`. This value will equal `promoApplied` for now */
  discountApplied: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  /** Temporary property to hold amount deducted via discounts */
  nonPromoDiscountApplied: Scalars['Int']['output'];
  /** Amount deducted from order using a promo code */
  promoApplied: Scalars['Int']['output'];
  remainingToRemoveSmallOrderFee: Scalars['Int']['output'];
  salesTax: Scalars['Int']['output'];
  serviceFee: Scalars['Int']['output'];
  shefTip: Scalars['Int']['output'];
  shefTipOptions: Array<TipOption>;
  smallOrderFee: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
};

export type OrderTotalsAddressInput2 = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  province: Scalars['String']['input'];
  street: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export enum OrderType {
  MealPlan = 'MEAL_PLAN',
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING'
}

export enum OrderVisibility {
  Full = 'FULL',
  SummaryOnly = 'SUMMARY_ONLY'
}

export type Organization = {
  __typename?: 'Organization';
  address?: Maybe<Address>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  promoCode?: Maybe<PromoCode>;
  slug: Scalars['String']['output'];
};

export enum Packaging {
  Compostable = 'COMPOSTABLE',
  Recylable = 'RECYLABLE',
  Reusable = 'REUSABLE',
  Unknown = 'UNKNOWN'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['ID']['output']>;
};

export type PaginatedPromoCodes = {
  __typename?: 'PaginatedPromoCodes';
  pagination: Pagination;
  promoCodes: Array<PromoCode>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  resultsPerPage: Scalars['Int']['output'];
};

export type PerShefHeldOrderModifyInput = {
  lineItems: Array<OrderLineItemInput>;
  shefId: Scalars['String']['input'];
};

export type PerShefOrderInput = {
  lineItems: Array<OrderLineItemInput>;
  lineItemsSubtotal?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};

export type PerShefOrderModifyInput = {
  lineItems: Array<OrderLineItemInput>;
  lineItemsSubtotal: Scalars['Int']['input'];
  shefId: Scalars['String']['input'];
};

export type PhotoBackgroundRemovals = {
  __typename?: 'PhotoBackgroundRemovals';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  newImageUrl: Scalars['String']['output'];
  oldImageUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploaderId: Scalars['String']['output'];
};

export type PhotoBackgroundRemovalsInput = {
  oldImageUrl: Scalars['String']['input'];
};

export type PhotoBackgroundRemovalsResult = {
  __typename?: 'PhotoBackgroundRemovalsResult';
  newImageUrl: Scalars['String']['output'];
};

export type PhotoEditRequest = {
  __typename?: 'PhotoEditRequest';
  editedImageUrl?: Maybe<Scalars['String']['output']>;
  editorUserId?: Maybe<Scalars['String']['output']>;
  foodItem: FoodItem;
  foodItemChangeRequest: FoodItemChangeRequest;
  foodItemChangeRequestId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  status: PhotoEditRequestStatus;
};

export type PhotoEditRequestResults = {
  __typename?: 'PhotoEditRequestResults';
  pagination: Pagination;
  photoEditRequests: Array<PhotoEditRequest>;
};

export enum PhotoEditRequestStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Open = 'OPEN',
  Rejected = 'REJECTED'
}

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PossibleDeliveryDate = {
  __typename?: 'PossibleDeliveryDate';
  date: Scalars['String']['output'];
  possible: DeliveryDateChangePossible;
  reason?: Maybe<Scalars['String']['output']>;
  unavailableItems: Array<UnavailableFoodItem>;
};

export type PossibleDeliveryHubsForShefInput = {
  shefId: Scalars['String']['input'];
};

export type PostCheckOutUpsellRecommendations = {
  __typename?: 'PostCheckOutUpsellRecommendations';
  foodItems: Array<FoodItem>;
  shefs: Array<PublicShef>;
};

export type PrefabFoodItemStats = {
  __typename?: 'PrefabFoodItemStats';
  copyCount: Scalars['Int']['output'];
  imageCopyCount: Scalars['Int']['output'];
  isDuplicatedInSameRegion: Scalars['Boolean']['output'];
  isImageDuplicatedInSameRegion: Scalars['Boolean']['output'];
  regionalCopyInfo: Array<PrefabRegionalCopyInfo>;
  sameRegionCopyCount: Scalars['Int']['output'];
  sameRegionImageCopyCount: Scalars['Int']['output'];
};

export type PrefabRegionalCopyInfo = {
  __typename?: 'PrefabRegionalCopyInfo';
  copyCount: Scalars['Int']['output'];
  imageCopyCount: Scalars['Int']['output'];
  regionId: Scalars['Int']['output'];
};

export enum PriceFactorType {
  Nominal = 'NOMINAL',
  Percentage = 'PERCENTAGE'
}

export enum PriceLevel {
  FourDollarSign = 'FOUR_DOLLAR_SIGN',
  OneDollarSign = 'ONE_DOLLAR_SIGN',
  ThreeDollarSign = 'THREE_DOLLAR_SIGN',
  TwoDollarSign = 'TWO_DOLLAR_SIGN'
}

export enum Printer {
  Dymo = 'DYMO',
  LaserOrInkjet = 'LASER_OR_INKJET'
}

export enum ProfilePhotoSubmissionStatus {
  Accepted = 'ACCEPTED',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED',
  Unsubmitted = 'UNSUBMITTED'
}

export type PromoCode = {
  __typename?: 'PromoCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  disabled: Scalars['Boolean']['output'];
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  doesBalanceCarryOver: Scalars['Boolean']['output'];
  endTimestamp?: Maybe<Scalars['DateTime']['output']>;
  firstPromoOnly: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isExplorePagePromo: Scalars['Boolean']['output'];
  isFreeDelivery: Scalars['Boolean']['output'];
  isPercentage: Scalars['Boolean']['output'];
  isShefToConsumerPromo: Scalars['Boolean']['output'];
  isUsed: Scalars['Boolean']['output'];
  maxUses?: Maybe<Scalars['Int']['output']>;
  maxUsesPerUser?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Int']['output']>;
  minOrderValue?: Maybe<Scalars['Int']['output']>;
  onlyUsableOnDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  promoCodeType: PromoCodeType;
  referee?: Maybe<User>;
  referrer?: Maybe<User>;
  restrictedToCuisineRegions?: Maybe<Array<Scalars['String']['output']>>;
  restrictedToEmailDomains?: Maybe<Array<Scalars['String']['output']>>;
  restrictedToRegionIds?: Maybe<Array<Scalars['Int']['output']>>;
  restrictedToShefId?: Maybe<Scalars['String']['output']>;
  restrictedToShefIds?: Maybe<Array<Scalars['String']['output']>>;
  restrictedToUserEmails?: Maybe<Array<Scalars['String']['output']>>;
  restrictedToUserIds?: Maybe<Array<Scalars['String']['output']>>;
  showsPersistentBanner?: Maybe<Scalars['Boolean']['output']>;
  startTimestamp?: Maybe<Scalars['DateTime']['output']>;
  uses: Scalars['Int']['output'];
  usesRemainingForUser?: Maybe<Scalars['Int']['output']>;
  value: Scalars['Int']['output'];
};

export type PromoCodeInput = {
  codeBase?: InputMaybe<Scalars['String']['input']>;
  doesBalanceCarryOver?: InputMaybe<Scalars['Boolean']['input']>;
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  firstPromoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  isUsableByShefsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  maxUsesPerUser?: InputMaybe<Scalars['Int']['input']>;
  maxValue?: InputMaybe<Scalars['Int']['input']>;
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  promoCodeType: PromoCodeType;
  restrictedToCuisineRegions?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedToEmailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedToRegionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  restrictedToShefIds?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedToUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedToUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  value: Scalars['Int']['input'];
};

export type PromoCodeResult = {
  __typename?: 'PromoCodeResult';
  code?: Maybe<PromoCode>;
  error?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  promoCodeString: Scalars['String']['output'];
  remainingUses?: Maybe<Scalars['Int']['output']>;
};


export type PromoCodeResultRemainingUsesArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PromoCodeTag = {
  __typename?: 'PromoCodeTag';
  codeId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  promoCode?: Maybe<PromoCode>;
  tag?: Maybe<PromoCodeTagType>;
  tagId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PromoCodeTagType = {
  __typename?: 'PromoCodeTagType';
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PromoCodeTagTypesResult = {
  __typename?: 'PromoCodeTagTypesResult';
  pagination: Pagination;
  promoCodeTagTypes: Array<PromoCodeTagType>;
};

export enum PromoCodeType {
  CustomerHappiness = 'CUSTOMER_HAPPINESS',
  GiftCard = 'GIFT_CARD',
  OrganizationInternal = 'ORGANIZATION_INTERNAL',
  Promotional = 'PROMOTIONAL',
  Recruiting = 'RECRUITING',
  Referral = 'REFERRAL',
  ReferralReward = 'REFERRAL_REWARD',
  ShefPromotional = 'SHEF_PROMOTIONAL',
  TasterReward = 'TASTER_REWARD'
}

export type PromoCodeUsage = {
  __typename?: 'PromoCodeUsage';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isVoid: Scalars['Boolean']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  promoCode?: Maybe<PromoCode>;
  promoCodeId: Scalars['Int']['output'];
  referee?: Maybe<User>;
  referrerRewardPromoCodeId?: Maybe<Scalars['Int']['output']>;
  referrerUserId?: Maybe<Scalars['String']['output']>;
  referrerValue?: Maybe<Scalars['Int']['output']>;
  stripeFingerprint?: Maybe<Scalars['String']['output']>;
  transactionLineItemId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export enum Protein {
  Beef = 'BEEF',
  Chicken = 'CHICKEN',
  Egg = 'EGG',
  Fish = 'FISH',
  Lamb = 'LAMB',
  Plant = 'PLANT',
  Pork = 'PORK',
  Seafood = 'SEAFOOD',
  Shellfish = 'SHELLFISH',
  Tofu = 'TOFU'
}

export type PublicOrder = {
  __typename?: 'PublicOrder';
  addOnItems: Array<OrderAddOnItem>;
  createdAt: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  lineItems: Array<OrderLineItem>;
  user: User;
  userId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PublicReviewResult = {
  __typename?: 'PublicReviewResult';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deliveryDate: Scalars['Date']['output'];
  dishes: Array<OrderLineItem>;
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  privateComment?: Maybe<Scalars['String']['output']>;
  user: ReviewUser;
};

export type PublicReviewResults = {
  __typename?: 'PublicReviewResults';
  reviews: Array<PublicReviewResult>;
  total: Scalars['Int']['output'];
};

export type PublicShef = {
  __typename?: 'PublicShef';
  activeFoodItems: Array<FoodItem>;
  activeHolidayFoodItems: Array<FoodItem>;
  allowedToChat: Scalars['Boolean']['output'];
  availability: Array<ShefAvailability>;
  celebrityEventType?: Maybe<CelebrityEventType>;
  cuisineCategories: Array<CuisineCategory>;
  deliveryPrice?: Maybe<DeliveryPrice>;
  firstName?: Maybe<Scalars['String']['output']>;
  flakeId: Scalars['String']['output'];
  hasEcoFriendlyPackaging: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isSoldOut: Scalars['Boolean']['output'];
  isTopShef: Scalars['Boolean']['output'];
  isTrialShef: Scalars['Boolean']['output'];
  mealPlanFoodItems: Array<FoodItem>;
  publicName: Scalars['String']['output'];
  rating?: Maybe<ShefRating>;
  regionalCuisineCategories: Array<CuisineCategory>;
  resizedImageUrl?: Maybe<Scalars['String']['output']>;
  shefProfile: ShefProfile;
  shefRosterStatus?: Maybe<ShefRosterStatus>;
  timeZone: Scalars['String']['output'];
  totalOrders: Scalars['Int']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type PublicShefActiveFoodItemsArgs = {
  dishFilters?: InputMaybe<ExploreFoodItemsFilterInput>;
  filters?: InputMaybe<ExploreSegmentsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PublicShefActiveHolidayFoodItemsArgs = {
  filters?: InputMaybe<ExploreSegmentsFilterInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type PublicShefAvailabilityArgs = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type PublicShefDeliveryPriceArgs = {
  destZipCode?: InputMaybe<Scalars['String']['input']>;
};


export type PublicShefIsSoldOutArgs = {
  filters: ExploreSegmentsFilterInput;
};


export type PublicShefMealPlanFoodItemsArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<MealPlanFormat>;
  includeSoldOutDishes?: InputMaybe<Scalars['Boolean']['input']>;
  tasteProfile?: InputMaybe<TasteProfileInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type PublicShefResizedImageUrlArgs = {
  width: Scalars['Int']['input'];
};


export type PublicShefShefRosterStatusArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  tasteProfile?: InputMaybe<TasteProfileInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type PushNotificationToken = {
  __typename?: 'PushNotificationToken';
  platform: PushPlatform;
  token: Scalars['String']['output'];
  tokenType: PushTokenType;
  userId: Scalars['String']['output'];
};

export type PushNotificationTokenInput = {
  platform: PushPlatform;
  token: Scalars['String']['input'];
  tokenType: PushTokenType;
  userId: Scalars['String']['input'];
};

export enum PushPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export enum PushTokenType {
  Apn = 'APN',
  Fcm = 'FCM'
}

export type Query = {
  __typename?: 'Query';
  activeSubscriptions: SubscriptionConnection;
  adminDeliveryEventTypes: Array<DeliveryEventType>;
  adminDeliveryEventsByOrder: Array<DeliveryEvent>;
  adminFoodItems: FoodItemResults;
  adminGroupOrders: GroupOrderResults;
  adminOrderMetrics: Array<Maybe<DayStats>>;
  adminOrders: OrderResults;
  adminOrganizations?: Maybe<AdminOrganizationsResults>;
  adminPromoCodeTagTypeAll: Array<PromoCodeTagType>;
  adminPromoCodeTagTypes: PromoCodeTagTypesResult;
  adminPromoCodes: AdminPromoCodeResults;
  adminShefFoodhandlers?: Maybe<AdminShefFoodhandlersResults>;
  adminShefs?: Maybe<AdminShefResults>;
  adminUsers?: Maybe<AdminUserResults>;
  allOverrideSegments: Array<Scalars['String']['output']>;
  attemptMealPlanningPurchase: Scalars['Boolean']['output'];
  availableAddOnItems: Array<AddOnItem>;
  availableDeliveryDays: Array<Scalars['String']['output']>;
  cart: Array<CartLineItem>;
  carts: CartResults;
  categoricalRatings2: CategoricalRatingsResults;
  categoryPageRecentReviews?: Maybe<CategoryPageRecentReviewResult>;
  celebrityEventPopularShefs: Array<ExploreSegmentShef>;
  chatToken: Scalars['String']['output'];
  checkoutExitIntentPromoCode?: Maybe<PromoCode>;
  cityPageCities: Array<CityPageCity>;
  cityPageContent: CityPageContent;
  cityPageContent2: CityPageContent;
  cityPageRegionContent: CityPageContent;
  combinedSearch: CombinedSearchResults;
  configs: Array<Config>;
  consumerFoodItems: Array<FoodItem>;
  countMealPlanShefsForRegionId?: Maybe<CountMealPlanShefsForRegionIdResults>;
  cuisineCategories: Array<CuisineCategory>;
  cuisineCategory: CuisineCategory;
  cuisineRegions: Array<CuisineRegion>;
  deliveryHubs: Array<DeliveryHub>;
  deliveryPrice?: Maybe<DeliveryPrice>;
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  dietaryAnalysis?: Maybe<DietaryAnalysis>;
  dietaryDetailsForShef: Array<DietaryDetails>;
  exploreCuisine: ExploreCuisineResults;
  exploreFilterOptions?: Maybe<ExploreFilterOptionsResults>;
  exploreFoodItems: Array<ExploreFoodItemsSegment>;
  exploreFoodItemsFilterOptions?: Maybe<ExploreFoodItemsFilterOptionsResults>;
  exploreMerchandise: ExploreMerchandiseResults;
  exploreMerchandisePage: ExploreMerchandisePage;
  exploreSegments2: Array<ExploreSegment>;
  filtersForDeliveryHub: Array<CityPageFilter>;
  filtersForZip: Array<CityPageFilter>;
  followingPosts: Array<ShefPost>;
  foodItem: FoodItem;
  foodItemAuditRequest: FoodItemAuditRequest;
  foodItemAuditRequests: FoodItemAuditRequestResults;
  foodItemChangeRequest: FoodItemChangeRequest;
  foodItemChangeRequests: FoodItemChangeRequestResults;
  foodItemComments: Array<FoodItemComment>;
  foodItemCustomizationTypes: Array<FoodItemCustomizationType>;
  foodItemOrderReviews: PublicReviewResults;
  foodItemPopularity: FoodItemPopularityResult;
  foodItemPriceRecommendations: FoodItemPriceRecommendationResult;
  foodItemQuantityAvailability: Scalars['Int']['output'];
  foodItemSuggestions: Array<FoodItem>;
  foodItems: Array<FoodItem>;
  fullUrl: ShortUrl;
  getActiveMealPlanForUser?: Maybe<MealPlan>;
  getAvailablePromoCodesForUser: Array<PromoCode>;
  getConfigValue?: Maybe<Scalars['String']['output']>;
  getForYouMealPlanCollections?: Maybe<GetForYouMealPlanCollectionsResponse>;
  getMealPlanDeliveries: GetMealPlanDeliveriesResponse;
  getMealPlanForUser?: Maybe<UserMealPlan>;
  getMealPlanType: MealPlanType;
  getMealPlanTypeOptions: Array<MealPlanTypeOption>;
  getMealPlanUpcomingOrder?: Maybe<GetMealPlanUpcomingOrderResponse>;
  getMealPlanningMenu?: Maybe<MealPlanningMenu>;
  getOrCreateShortUrl: ShortUrl;
  getRegisteredEmail?: Maybe<Scalars['String']['output']>;
  getSearchResults: SearchResults;
  getShefEarningsDashboardUrl: Scalars['String']['output'];
  getShefInsightsDashboardUrl: Scalars['String']['output'];
  getShefRatingsDashboardUrl: Scalars['String']['output'];
  getShefRoster?: Maybe<GetShefRosterResponse>;
  getTasteProfile: GetTasteProfileResponse;
  getTrendingSearches: Array<Scalars['String']['output']>;
  getUpcomingMealPlanGroupOrders?: Maybe<GetUpcomingMealPlanGroupOrdersResponse>;
  groupOrderTotals: OrderTotals;
  groupOrdersByFulfillmentDate: Array<GroupOrder>;
  groupOrdersByIds: Array<GroupOrder>;
  hello?: Maybe<Scalars['String']['output']>;
  helloAdmin?: Maybe<Scalars['String']['output']>;
  isFeatureOn: Scalars['Boolean']['output'];
  latestCelebrityEventForZipCode?: Maybe<ZipCodeCelebrityEventMetadata>;
  lineDrives: Array<LineDrive>;
  listChangesets: Array<FoodItemChangeset>;
  makeItAMealSuggestions: Array<MakeItAMealDishSuggestions>;
  me?: Maybe<User>;
  mealPlan: MealPlan;
  mealPlanOrderSalesTax: MealPlanOrderSalesTax;
  modifiedGroupOrderTotals: OrderTotals;
  newUserPromoCode?: Maybe<PromoCode>;
  order?: Maybe<Order>;
  orders: ConsumerOrderResults;
  ordersByDateString: Array<Order>;
  ordersByFulfillmentDate: Array<Order>;
  ordersById: Array<Order>;
  organization?: Maybe<Organization>;
  peopleAlsoOrderedRecommendations: Array<FoodItem>;
  photoEditRequest?: Maybe<PhotoEditRequest>;
  photoEditRequests: PhotoEditRequestResults;
  possibleDeliveryHubsForShef: Array<DeliveryHub>;
  postCheckoutOrderUpsellRecommendations: PostCheckOutUpsellRecommendations;
  preCheckoutOrderUpsellRecommendations: Array<FoodItem>;
  previousGroupOrders: GroupOrderConnection;
  printers?: Maybe<Array<Printer>>;
  promoCodeValue?: Maybe<PromoCodeResult>;
  promoCodeValues?: Maybe<Array<PromoCodeResult>>;
  publicOrderByUser?: Maybe<PublicOrder>;
  publicReviews: PublicReviewResults;
  recurringSubscriptionAvailability: RecurringSubscriptionAvailability;
  region: RegionInfo;
  regionAvailabilityForDeliveryDate: Array<Maybe<RegionAvailability>>;
  regionFromZip: RegionInfo;
  regionalShefCuisineCategories: Array<ShefCuisineCategory>;
  regions: Array<RegionInfo>;
  shef: PublicShef;
  shefApplication?: Maybe<ShefApplication>;
  shefApplicationTracker?: Maybe<ShefApplicationTracker>;
  shefAvailability: Array<Maybe<ShefAvailability>>;
  shefAvailabilityRules: Array<ShefAvailabilityRule>;
  shefDaysOfWeekAvailabilityRule?: Maybe<ShefAvailabilityRule>;
  shefFoodItems: FoodItemResults;
  shefMenuChecklist: Array<ShefMenuChecklistAction>;
  shefMenuFilteredItems: FilteredFoodItemResults;
  shefMenuSegments: Array<ExploreFoodItemsSegment>;
  shefPosts: Array<ShefPost>;
  shefProfile?: Maybe<ShefProfile>;
  shefProfileByConsumerReferral?: Maybe<ShefProfile>;
  shefTag?: Maybe<ShefTagType>;
  shefTags: Array<ShefTagType>;
  shefs: Array<PublicShef>;
  sluggedFoodItem?: Maybe<FoodItem>;
  stripeId?: Maybe<Scalars['String']['output']>;
  suggestedItemsFromMenu: Array<SuggestedItem>;
  taggedShefs: Array<ShefProfile>;
  tagsForConsumer: OrderRatingTags;
  tagsForShef: OrderRatingTags;
  timeWindowsForGroupOrder: Array<TimeWindow>;
  timeWindowsForOrder: Array<TimeWindow>;
  upcomingGroupOrders: GroupOrderConnection;
  upcomingOrders: Array<Order>;
  upsellPromo?: Maybe<PromoCode>;
  user?: Maybe<User>;
  userNotificationSettings: Array<UserNotificationSetting>;
  userSuggestions?: Maybe<Array<FoodItem>>;
  validDaysOfWeek: Array<Scalars['Int']['output']>;
  variant?: Maybe<Variant>;
  waitlistRanks: Array<WaitlistRank>;
  zipCode?: Maybe<ZipCode>;
  zipCodeCelebrityEventDetails: ZipCodeCelebrityEventMetadata;
  zipCodes: Array<Maybe<ZipCode>>;
};


export type QueryActiveSubscriptionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryAdminDeliveryEventsByOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryAdminFoodItemsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchString: Scalars['String']['input'];
};


export type QueryAdminGroupOrdersArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryHubIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminOrderMetricsArgs = {
  timeZoneOffset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminOrdersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminOrganizationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminPromoCodeTagTypesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  tagSearch?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminPromoCodesArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PromoCodeType>;
};


export type QueryAdminShefFoodhandlersArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  idFilter?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminShefsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  shefStatus?: InputMaybe<ShefStatus>;
};


export type QueryAdminUsersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttemptMealPlanningPurchaseArgs = {
  input: MealPlanningPurchaseInput;
};


export type QueryAvailableAddOnItemsArgs = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvailableDeliveryDaysArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryCartArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCartsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoricalRatings2Args = {
  limit: Scalars['Int']['input'];
  sqlLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoryPageRecentReviewsArgs = {
  regionId: Scalars['Int']['input'];
};


export type QueryCelebrityEventPopularShefsArgs = {
  filters: ExploreFoodItemsFilterInput;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckoutExitIntentPromoCodeArgs = {
  deliveryDate: Scalars['String']['input'];
  shefId: Scalars['String']['input'];
  subtotal: Scalars['Int']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCityPageContentArgs = {
  deliveryHubId: Scalars['Int']['input'];
  filter?: InputMaybe<CityPageFilterInput>;
};


export type QueryCityPageContent2Args = {
  filter?: InputMaybe<CityPageFilterInput>;
  zipCode: Scalars['String']['input'];
};


export type QueryCityPageRegionContentArgs = {
  filter?: InputMaybe<CityPageFilterInput>;
  regionId: Scalars['Int']['input'];
};


export type QueryCombinedSearchArgs = {
  searchInput: SearchInput;
};


export type QueryConsumerFoodItemsArgs = {
  availableDate?: InputMaybe<Scalars['DateTime']['input']>;
  shefId: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCountMealPlanShefsForRegionIdArgs = {
  mealPlanType: Scalars['String']['input'];
  regionId: Scalars['Int']['input'];
};


export type QueryCuisineCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryDeliveryPriceArgs = {
  destZipCode: Scalars['String']['input'];
};


export type QueryDeliveryStatusArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryDietaryAnalysisArgs = {
  ingredients: Scalars['String']['input'];
};


export type QueryDietaryDetailsForShefArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryExploreCuisineArgs = {
  cuisineTitle: Scalars['String']['input'];
  filters: ExploreSegmentsFilterInput;
  seed: Scalars['String']['input'];
};


export type QueryExploreFilterOptionsArgs = {
  filters?: InputMaybe<ExploreSegmentsFilterInput>;
  zipCode: Scalars['String']['input'];
};


export type QueryExploreFoodItemsArgs = {
  availableDeliveryDays?: InputMaybe<Array<Scalars['String']['input']>>;
  filters: ExploreFoodItemsFilterInput;
  isLilyPad?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  numVisiblePerSegment: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  useDynamicPreviewImage?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryExploreFoodItemsFilterOptionsArgs = {
  filters: ExploreFoodItemsFilterInput;
  query?: InputMaybe<Scalars['String']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryExploreMerchandiseArgs = {
  filters: ExploreSegmentsFilterInput;
  seed: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryExploreMerchandisePageArgs = {
  slug: Scalars['String']['input'];
};


export type QueryExploreSegments2Args = {
  expectedPaginationInfo?: InputMaybe<ExpectedPaginationInfoInput>;
  filters: ExploreSegmentsFilterInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  seed: Scalars['String']['input'];
};


export type QueryFiltersForDeliveryHubArgs = {
  deliveryHubId: Scalars['Int']['input'];
};


export type QueryFiltersForZipArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryFollowingPostsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryFoodItemArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type QueryFoodItemAuditRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryFoodItemAuditRequestsArgs = {
  filterAuditStatus?: InputMaybe<AuditStatus>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFoodItemChangeRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFoodItemChangeRequestsArgs = {
  filterChangeType?: InputMaybe<ChangeRequestChangeTypeFilter>;
  filterFoodType?: InputMaybe<ChangeRequestFoodTypeFilter>;
  filterPhotoStatus?: InputMaybe<ChangeRequestPhotoStatusFilter>;
  filterSearch?: InputMaybe<Scalars['String']['input']>;
  filterShefType?: InputMaybe<ChangeRequestShefTypeFilter>;
  filterUserType?: InputMaybe<ChangeRequestUserTypeFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFoodItemCommentsArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type QueryFoodItemOrderReviewsArgs = {
  foodItemId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryFoodItemPopularityArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sqlLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFoodItemPriceRecommendationsArgs = {
  foodItemInput: FoodItemPriceRecommendationInput;
};


export type QueryFoodItemQuantityAvailabilityArgs = {
  availableDate: Scalars['DateTime']['input'];
  foodItemId: Scalars['Int']['input'];
};


export type QueryFoodItemSuggestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryFoodItemsArgs = {
  foodItemIds: Array<Scalars['Int']['input']>;
};


export type QueryFullUrlArgs = {
  shortCode: Scalars['String']['input'];
};


export type QueryGetConfigValueArgs = {
  name: FeatureName;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetForYouMealPlanCollectionsArgs = {
  deliveryDate: Scalars['String']['input'];
  mealPlanTypeId: Scalars['Int']['input'];
  tasteProfile: TasteProfileInput;
  zipCode: Scalars['String']['input'];
};


export type QueryGetMealPlanDeliveriesArgs = {
  input: GetMealPlanDeliveriesInput;
};


export type QueryGetMealPlanForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetMealPlanTypeArgs = {
  mealPlanTypeId: Scalars['Int']['input'];
};


export type QueryGetMealPlanTypeOptionsArgs = {
  adults?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  littleEaters?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMealPlanUpcomingOrderArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetMealPlanningMenuArgs = {
  deliveryDate: Scalars['String']['input'];
  dietType?: InputMaybe<DietType>;
  dietaryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  includeFullCapacityShefs?: InputMaybe<Scalars['Boolean']['input']>;
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  menuDietaryRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  zipCode: Scalars['String']['input'];
};


export type QueryGetOrCreateShortUrlArgs = {
  fullUrl: Scalars['String']['input'];
};


export type QueryGetRegisteredEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetSearchResultsArgs = {
  deliveryDate: Scalars['String']['input'];
  filters: ExploreFoodItemsFilterInput;
  isPartialQuery: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  searchState: SearchStateInput;
  zipCode: Scalars['String']['input'];
};


export type QueryGetShefRosterArgs = {
  deliveryDate: Scalars['String']['input'];
  mealPlanTypeId: Scalars['Int']['input'];
  tasteProfile: TasteProfileInput;
  zipCode: Scalars['String']['input'];
};


export type QueryGetTasteProfileArgs = {
  input: GetTasteProfileInput;
};


export type QueryGetTrendingSearchesArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryGetUpcomingMealPlanGroupOrdersArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGroupOrderTotalsArgs = {
  groupOrderInput: GroupOrderTotalsInput;
};


export type QueryGroupOrdersByFulfillmentDateArgs = {
  dropoffHubId?: InputMaybe<Scalars['Int']['input']>;
  fulfillmentDate: Scalars['String']['input'];
  includeRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupOrdersByIdsArgs = {
  groupOrderIds: Array<Scalars['String']['input']>;
};


export type QueryIsFeatureOnArgs = {
  name: FeatureName;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLatestCelebrityEventForZipCodeArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryLineDrivesArgs = {
  filters: LineDriveFilterInput;
};


export type QueryListChangesetsArgs = {
  foodItemChangeRequestId: Scalars['Int']['input'];
};


export type QueryMakeItAMealSuggestionsArgs = {
  deliveryDate: Scalars['String']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  entreeIds: Array<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryMealPlanArgs = {
  mealPlanId: Scalars['String']['input'];
};


export type QueryMealPlanOrderSalesTaxArgs = {
  mealPlanOrderSalesTaxInput: MealPlanOrderSalesTaxInput;
};


export type QueryModifiedGroupOrderTotalsArgs = {
  input: ConsumerModifyGroupOrderInput;
};


export type QueryNewUserPromoCodeArgs = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  includeRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersByDateStringArgs = {
  deliveryDate: Scalars['String']['input'];
  includeRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersByFulfillmentDateArgs = {
  fulfillmentDate: Scalars['String']['input'];
  includeRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersByIdArgs = {
  orderIds: Array<InputMaybe<Scalars['Int']['input']>>;
  orderUuids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryOrganizationArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPeopleAlsoOrderedRecommendationsArgs = {
  cartFoodItemIds: Array<Scalars['Int']['input']>;
  deliveryDate: Scalars['String']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  zipCode: Scalars['String']['input'];
};


export type QueryPhotoEditRequestArgs = {
  changeRequestId: Scalars['Int']['input'];
};


export type QueryPhotoEditRequestsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPossibleDeliveryHubsForShefArgs = {
  input: PossibleDeliveryHubsForShefInput;
};


export type QueryPostCheckoutOrderUpsellRecommendationsArgs = {
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  groupOrderId: Scalars['String']['input'];
};


export type QueryPreCheckoutOrderUpsellRecommendationsArgs = {
  cartFoodItemIds: Array<Scalars['Int']['input']>;
  deliveryDate: Scalars['String']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  zipCode: Scalars['String']['input'];
};


export type QueryPreviousGroupOrdersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryPromoCodeValueArgs = {
  code: Scalars['String']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  shefSubtotals?: InputMaybe<Array<ShefSubtotal>>;
};


export type QueryPromoCodeValuesArgs = {
  codes: Array<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  shefSubtotals?: InputMaybe<Array<ShefSubtotal>>;
};


export type QueryPublicOrderByUserArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryPublicReviewsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  requireComments?: InputMaybe<Scalars['Boolean']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryRecurringSubscriptionAvailabilityArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryRegionArgs = {
  regionId: Scalars['Int']['input'];
};


export type QueryRegionAvailabilityForDeliveryDateArgs = {
  deliveryDate: Scalars['String']['input'];
  regionId: Scalars['Int']['input'];
};


export type QueryRegionFromZipArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryShefArgs = {
  userId: Scalars['String']['input'];
};


export type QueryShefApplicationArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShefApplicationTrackerArgs = {
  userId: Scalars['String']['input'];
};


export type QueryShefAvailabilityArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryShefAvailabilityRulesArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  shefId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  unavailable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryShefDaysOfWeekAvailabilityRuleArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryShefFoodItemsArgs = {
  availableOn?: InputMaybe<Scalars['String']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryShefMenuChecklistArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryShefMenuFilteredItemsArgs = {
  availableDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters: ExploreFoodItemsFilterInput;
  shefId: Scalars['String']['input'];
};


export type QueryShefMenuSegmentsArgs = {
  availableDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<ExploreFoodItemsFilterInput>;
  loadFoodItemDescription?: InputMaybe<Scalars['Boolean']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryShefPostsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryShefProfileArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShefProfileByConsumerReferralArgs = {
  code: Scalars['String']['input'];
};


export type QueryShefTagArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShefsArgs = {
  userIds: Array<Scalars['String']['input']>;
};


export type QuerySluggedFoodItemArgs = {
  shefId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QuerySuggestedItemsFromMenuArgs = {
  deliveryDate: Scalars['DateTime']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  foodItemId: Scalars['Int']['input'];
  numMains: Scalars['Int']['input'];
  shefTimeZone: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaggedShefsArgs = {
  excludeOp: TaggedShefOp;
  excludeSlugs: Array<Scalars['String']['input']>;
  includeOp: TaggedShefOp;
  includeSlugs: Array<Scalars['String']['input']>;
};


export type QueryTimeWindowsForGroupOrderArgs = {
  groupOrderId: Scalars['String']['input'];
};


export type QueryTimeWindowsForOrderArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUpcomingGroupOrdersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryUpsellPromoArgs = {
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserNotificationSettingsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserSuggestionsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryValidDaysOfWeekArgs = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVariantArgs = {
  experimentName: Scalars['String']['input'];
  logExposure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryZipCodeArgs = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryZipCodeCelebrityEventDetailsArgs = {
  celebrityEventType: CelebrityEventType;
  zipCode: Scalars['String']['input'];
};

export type QueryResponse = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RecentReview = {
  __typename?: 'RecentReview';
  review: PublicReviewResult;
  shef: PublicShef;
  user: User;
};

export type RecurringDeliveryPrefs = {
  __typename?: 'RecurringDeliveryPrefs';
  adventureLevelPct: Scalars['Int']['output'];
  allergens?: Maybe<Array<Scalars['String']['output']>>;
  cuisinePreferences?: Maybe<Array<Scalars['String']['output']>>;
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  dietaryPreferences?: Maybe<Array<Scalars['String']['output']>>;
  notes?: Maybe<Scalars['String']['output']>;
  oilinessPreferencePct?: Maybe<Scalars['Int']['output']>;
  preferredProteins?: Maybe<Array<Protein>>;
  spiceLevels?: Maybe<Array<Scalars['Int']['output']>>;
  userId?: Maybe<Scalars['String']['output']>;
  yafdinkAdditionalDietaryPrefs?: Maybe<Scalars['String']['output']>;
  yafdinkControlCalorieIntake?: Maybe<Scalars['Boolean']['output']>;
  yafdinkDinnersPerWeek?: Maybe<Scalars['Int']['output']>;
  yafdinkFoodGoals?: Maybe<Array<Scalars['String']['output']>>;
  yafdinkLunchesPerWeek?: Maybe<Scalars['Int']['output']>;
  yafdinkMealNeeds?: Maybe<Scalars['String']['output']>;
  yafdinkPrepareNutritionLabels?: Maybe<Scalars['Boolean']['output']>;
  yafdinkRequestedOrganicIngredients?: Maybe<Scalars['Boolean']['output']>;
  yafdinkTargetCalorieIntake?: Maybe<Scalars['String']['output']>;
  yafdinkTargetDiet?: Maybe<Scalars['String']['output']>;
  yafdinkTargetSpecificMacros?: Maybe<Scalars['Boolean']['output']>;
};

export type RecurringDeliveryPrefsInput = {
  adventureLevelPct: Scalars['Int']['input'];
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisinePreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  dietaryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oilinessPreferencePct?: InputMaybe<Scalars['Int']['input']>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  spiceLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  yafdinkAdditionalDietaryPrefs?: InputMaybe<Scalars['String']['input']>;
  yafdinkControlCalorieIntake?: InputMaybe<Scalars['Boolean']['input']>;
  yafdinkDinnersPerWeek?: InputMaybe<Scalars['Int']['input']>;
  yafdinkFoodGoals?: InputMaybe<Array<Scalars['String']['input']>>;
  yafdinkLunchesPerWeek?: InputMaybe<Scalars['Int']['input']>;
  yafdinkMealNeeds?: InputMaybe<Scalars['String']['input']>;
  yafdinkPrepareNutritionLabels?: InputMaybe<Scalars['Boolean']['input']>;
  yafdinkRequestedOrganicIngredients?: InputMaybe<Scalars['Boolean']['input']>;
  yafdinkTargetCalorieIntake?: InputMaybe<Scalars['String']['input']>;
  yafdinkTargetDiet?: InputMaybe<Scalars['String']['input']>;
  yafdinkTargetSpecificMacros?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RecurringPeriod {
  FourteenDays = 'FOURTEEN_DAYS',
  None = 'NONE',
  SevenDays = 'SEVEN_DAYS'
}

export type RecurringSubscriptionAvailability = {
  __typename?: 'RecurringSubscriptionAvailability';
  subscriptionOptions: Array<SubscriptionOption>;
};

export type ReferralCode = {
  __typename?: 'ReferralCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  getValue: Scalars['Int']['output'];
  giveValue: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isFreeDelivery: Scalars['Boolean']['output'];
  isPercentage: Scalars['Boolean']['output'];
  maxUsesPerUser?: Maybe<Scalars['Int']['output']>;
  minOrderValue?: Maybe<Scalars['Int']['output']>;
  uses: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export enum ReferralStripTextColor {
  Dark = 'dark',
  Light = 'light'
}

export type Refund = {
  __typename?: 'Refund';
  createdAt: Scalars['DateTime']['output'];
  groupOrderId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  refundReason: Scalars['String']['output'];
  refundType: Scalars['String']['output'];
  refunderUserId?: Maybe<Scalars['String']['output']>;
};

export type RefundGroupOrderInput = {
  id: Scalars['String']['input'];
  refundAmount: Scalars['Int']['input'];
  refundDetails?: InputMaybe<Scalars['String']['input']>;
  refundMessage?: InputMaybe<Scalars['String']['input']>;
  refundReason: RefundGroupOrderReasonInput;
  refundType: GroupOrderRefundType;
  reverseShefTransferAmounts?: InputMaybe<Array<ReverseShefTransferInput>>;
};

export type RefundGroupOrderReasonInput = {
  customer?: InputMaybe<GroupOrderCustomerRefundReason>;
  deliveryPartner?: InputMaybe<GroupOrderDeliveryPartnerRefundReason>;
  internal?: InputMaybe<GroupOrderInternalRefundReason>;
  shef?: InputMaybe<GroupOrderShefRefundReason>;
  system?: InputMaybe<GroupOrderSystemRefundReason>;
};

export enum RefundType {
  Doordash = 'DOORDASH',
  Internal = 'INTERNAL',
  Shef = 'SHEF',
  SubscriptionCancelled = 'SUBSCRIPTION_CANCELLED',
  UserCancelled = 'USER_CANCELLED'
}

export type RegionAvailability = {
  __typename?: 'RegionAvailability';
  endDate: Scalars['DateTime']['output'];
  isAvailable: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type RegionInfo = {
  __typename?: 'RegionInfo';
  deliveryEnabledAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  ecoPackagingEnabled: Scalars['Boolean']['output'];
  fridayDelivery: Scalars['Boolean']['output'];
  gsinEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isDeliveryByShefsEnabled: Scalars['Boolean']['output'];
  isDeliveryByThirdPartyEnabled: Scalars['Boolean']['output'];
  isHubless: Scalars['Boolean']['output'];
  isInWaitlist: Scalars['Boolean']['output'];
  isPickupEnabled: Scalars['Boolean']['output'];
  isVerifiedHalalEnabled: Scalars['Boolean']['output'];
  launchedAt: Scalars['DateTime']['output'];
  mondayDelivery: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  saturdayDelivery: Scalars['Boolean']['output'];
  sundayDelivery: Scalars['Boolean']['output'];
  thursdayDelivery: Scalars['Boolean']['output'];
  timeZone: Scalars['String']['output'];
  tuesdayDelivery: Scalars['Boolean']['output'];
  wednesdayDelivery: Scalars['Boolean']['output'];
};

export type RemoveUserFromHubInput = {
  hubIds: Array<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type RequestGroupOrderDeliveriesResults = {
  __typename?: 'RequestGroupOrderDeliveriesResults';
  fail: Array<Scalars['String']['output']>;
  success: Array<Scalars['String']['output']>;
};

export enum RequestStatus {
  ClosedAbandoned = 'CLOSED_ABANDONED',
  ClosedApprovedAuto = 'CLOSED_APPROVED_AUTO',
  ClosedApprovedManual = 'CLOSED_APPROVED_MANUAL',
  ClosedRejected = 'CLOSED_REJECTED',
  OpenPendingNewPhoto = 'OPEN_PENDING_NEW_PHOTO',
  OpenPendingPhotoDecision = 'OPEN_PENDING_PHOTO_DECISION',
  OpenPendingPhotoEdits = 'OPEN_PENDING_PHOTO_EDITS',
  OpenPendingPhotoEditsApproval = 'OPEN_PENDING_PHOTO_EDITS_APPROVAL',
  OpenPendingReview = 'OPEN_PENDING_REVIEW',
  OpenPendingShefReview = 'OPEN_PENDING_SHEF_REVIEW'
}

export type ReverseShefTransferInput = {
  orderId: Scalars['Int']['input'];
  reverseShefPaymentAmount: Scalars['Int']['input'];
};

export enum ReviewFitnessFunction {
  NewShef = 'NEW_SHEF',
  PhotoChange = 'PHOTO_CHANGE',
  TrialShef = 'TRIAL_SHEF'
}

export type ReviewUser = {
  __typename?: 'ReviewUser';
  flakeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
};

export type SavedCreditCard = {
  __typename?: 'SavedCreditCard';
  brand: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  lastFourDigits: Scalars['Int']['output'];
  lastUsedAt: Scalars['Date']['output'];
  linkedSubscriptionId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SavedCreditCardInput = {
  brand: Scalars['String']['input'];
  expiresAt: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastFourDigits: Scalars['Int']['input'];
  shouldSaveCard: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type SearchInput = {
  dishCursor?: InputMaybe<Scalars['String']['input']>;
  dishPageSize?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  shefCursor?: InputMaybe<Scalars['String']['input']>;
  shefPageSize?: InputMaybe<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};

export type SearchResults = {
  __typename?: 'SearchResults';
  cuisineResults: Array<CuisineSearchResult>;
  dishResults: Array<Array<FoodItem>>;
  offset: Scalars['Int']['output'];
  searchStateResult: SearchStateResult;
  shefResults: Array<ExploreSegmentShef>;
};

export type SearchStateInput = {
  paginationState: AlgoliaPaginationState;
  seenRecordIds: Array<Array<Scalars['Int']['input']>>;
};

export type SearchStateResult = {
  __typename?: 'SearchStateResult';
  paginationState: AlgoliaPaginationResult;
  seenRecordIds: Array<Array<Scalars['Int']['output']>>;
};

export enum SegmentFilter {
  African = 'AFRICAN',
  All = 'ALL',
  American = 'AMERICAN',
  BakedGoods = 'BAKED_GOODS',
  Bangladeshi = 'BANGLADESHI',
  Caribbean = 'CARIBBEAN',
  Chinese = 'CHINESE',
  Diwali = 'DIWALI',
  Donations = 'DONATIONS',
  Easter = 'EASTER',
  EidAlFitr = 'EID_AL_FITR',
  Favorites = 'FAVORITES',
  French = 'FRENCH',
  Holi = 'HOLI',
  Hungarian = 'HUNGARIAN',
  Indian = 'INDIAN',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  LatinAmerican = 'LATIN_AMERICAN',
  LunarNewYear = 'LUNAR_NEW_YEAR',
  Mediterranean = 'MEDITERRANEAN',
  Mexican = 'MEXICAN',
  MiddleEastern = 'MIDDLE_EASTERN',
  More = 'MORE',
  Nepalese = 'NEPALESE',
  NewYear = 'NEW_YEAR',
  NextDay = 'NEXT_DAY',
  Nowruz = 'NOWRUZ',
  Pakistani = 'PAKISTANI',
  Promos = 'PROMOS',
  Ramadan = 'RAMADAN',
  Referral = 'REFERRAL',
  Russian = 'RUSSIAN',
  SearchCuisineDishes = 'SEARCH_CUISINE_DISHES',
  SearchCuisineShefs = 'SEARCH_CUISINE_SHEFS',
  SearchDishes = 'SEARCH_DISHES',
  SearchShefs = 'SEARCH_SHEFS',
  ShefsYouFollow = 'SHEFS_YOU_FOLLOW',
  SoutheastAsian = 'SOUTHEAST_ASIAN',
  Southern = 'SOUTHERN',
  Specialty = 'SPECIALTY',
  Thanksgiving = 'THANKSGIVING',
  Trial = 'TRIAL',
  Valentines = 'VALENTINES',
  Vesak = 'VESAK',
  WinterHoliday = 'WINTER_HOLIDAY'
}

export type SegmentFilterInput = {
  cuisineRegion?: InputMaybe<CuisineRegion>;
  deliveryDays?: InputMaybe<Array<Scalars['String']['input']>>;
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  excludePromoSegment?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  segmentFilters?: InputMaybe<Array<SegmentFilter>>;
  zipCode: Scalars['String']['input'];
};

export enum SegmentIcon {
  Placeholder = 'PLACEHOLDER'
}

export enum SegmentLayout {
  Generic = 'GENERIC',
  GenericNoPreview = 'GENERIC_NO_PREVIEW',
  HorizontalScroll = 'HORIZONTAL_SCROLL',
  RoundedScroll = 'ROUNDED_SCROLL'
}

export type SegmentPaginationInput = {
  excludeSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ShefApplication = {
  __typename?: 'ShefApplication';
  bioCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  calendlyOrientationCallLink?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cuisines?: Maybe<Scalars['String']['output']>;
  foodTastingAt?: Maybe<Scalars['DateTime']['output']>;
  foodTastingReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  geographyAllowsCuisineType: Scalars['Boolean']['output'];
  geographyAllowsNewApplications: Scalars['Boolean']['output'];
  howDiscoveredShef?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  info?: Maybe<Scalars['String']['output']>;
  informationSessionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  informationWebinarAttendedAt?: Maybe<Scalars['DateTime']['output']>;
  initialQuestionsCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  isDcExperimentApplicant: Scalars['Boolean']['output'];
  isFoodTastingScheduled: Scalars['Boolean']['output'];
  isFoodTastingSchedulingEnabled: Scalars['Boolean']['output'];
  isInformationSessionApplicant: Scalars['Boolean']['output'];
  isPickupAddressEnabled: Scalars['Boolean']['output'];
  isWaitlisted?: Maybe<Scalars['Boolean']['output']>;
  menuWebinarCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  menuWebinarScheduledFor?: Maybe<Scalars['DateTime']['output']>;
  offWaitlistAt?: Maybe<Scalars['Date']['output']>;
  onboardingCallAt?: Maybe<Scalars['DateTime']['output']>;
  orientationCallCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  orientationCallScheduledFor?: Maybe<Scalars['DateTime']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profilePhotoAcceptedAt?: Maybe<Scalars['Date']['output']>;
  profilePhotoOptionA?: Maybe<Scalars['String']['output']>;
  profilePhotoOptionB?: Maybe<Scalars['String']['output']>;
  profilePhotoOptionC?: Maybe<Scalars['String']['output']>;
  profilePhotoRejectedAt?: Maybe<Scalars['Date']['output']>;
  profilePhotoSubmissionStatus?: Maybe<ProfilePhotoSubmissionStatus>;
  profilePhotoSubmittedAt?: Maybe<Scalars['Date']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionInfo?: Maybe<RegionInfo>;
  status: ApplicationStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  workAuthorization?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ShefApplicationInput = {
  cuisines?: InputMaybe<Scalars['String']['input']>;
  deviceLanguage?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  referral?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

export type ShefApplicationInputStep2 = {
  howDiscoveredShef: Scalars['String']['input'];
};

export type ShefApplicationProfileInput = {
  profilePhotoOptionA?: InputMaybe<Scalars['String']['input']>;
  profilePhotoOptionB?: InputMaybe<Scalars['String']['input']>;
  profilePhotoOptionC?: InputMaybe<Scalars['String']['input']>;
};

export type ShefApplicationResult = {
  __typename?: 'ShefApplicationResult';
  isExistingUser: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type ShefApplicationTracker = {
  __typename?: 'ShefApplicationTracker';
  addAddress?: Maybe<ShefApplicationTrackerItemStatus>;
  availability: ShefApplicationTrackerItemStatus;
  bio: ShefApplicationTrackerItemStatus;
  cuisine: ShefApplicationTrackerItemStatus;
  cuisineCategories?: Maybe<ShefApplicationTrackerItemStatus>;
  dropOffHub?: Maybe<ShefApplicationTrackerItemStatus>;
  foodHandlersCertificate: ShefApplicationTrackerItemStatus;
  informationSession: ShefApplicationTrackerItemStatus;
  menuItems: ShefApplicationTrackerItemStatus;
  optionalMenuItems?: Maybe<ShefApplicationTrackerItemStatus>;
  passTasting?: Maybe<ShefApplicationTrackerItemStatus>;
  personalInfo?: Maybe<ShefApplicationTrackerItemStatus>;
  profileImage: ShefApplicationTrackerItemStatus;
  scheduleCall?: Maybe<ShefApplicationTrackerItemStatus>;
  scheduleTasting?: Maybe<ShefApplicationTrackerItemStatus>;
  stripeConnect: ShefApplicationTrackerItemStatus;
  tryShefPromo?: Maybe<ShefApplicationTrackerItemStatus>;
};

export enum ShefApplicationTrackerItemStatus {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ShefAvailability = {
  __typename?: 'ShefAvailability';
  availabilityDate: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  isSoldOut: Scalars['Boolean']['output'];
  numDishesAvailable: Scalars['Int']['output'];
  numOrderedDishes: Scalars['Int']['output'];
  numOrdersAvailable: Scalars['Int']['output'];
  numOrdersPlaced: Scalars['Int']['output'];
  shefId: Scalars['String']['output'];
};


export type ShefAvailabilityIsSoldOutArgs = {
  cacheOptions?: InputMaybe<CacheOptionsInput>;
};

export type ShefAvailabilityRule = {
  __typename?: 'ShefAvailabilityRule';
  dateRange: DateRange;
  daysOfWeek?: Maybe<ShefAvailabilityRuleDaysOfWeek>;
  durationInMs: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  isDaysOfWeek: Scalars['Boolean']['output'];
  isPast?: Maybe<Scalars['Boolean']['output']>;
  isUpcoming?: Maybe<Scalars['Boolean']['output']>;
  recurrenceRule: Scalars['String']['output'];
  shefId: Scalars['String']['output'];
};

export type ShefAvailabilityRuleDaysOfWeek = {
  __typename?: 'ShefAvailabilityRuleDaysOfWeek';
  friday: Scalars['Boolean']['output'];
  monday: Scalars['Boolean']['output'];
  saturday: Scalars['Boolean']['output'];
  sunday: Scalars['Boolean']['output'];
  thursday: Scalars['Boolean']['output'];
  tuesday: Scalars['Boolean']['output'];
  wednesday: Scalars['Boolean']['output'];
};

export type ShefAvailabilityRuleDaysOfWeekInput = {
  friday: Scalars['Boolean']['input'];
  monday: Scalars['Boolean']['input'];
  saturday: Scalars['Boolean']['input'];
  sunday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export type ShefAvailabilityRuleInput = {
  endDate: Scalars['String']['input'];
  isAvailable: Scalars['Boolean']['input'];
  startDate: Scalars['String']['input'];
};

export type ShefCuisineCategory = {
  __typename?: 'ShefCuisineCategory';
  cuisineCategoryId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  shefId: Scalars['String']['output'];
};

export type ShefMenuChecklistAction = {
  __typename?: 'ShefMenuChecklistAction';
  completed: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum ShefMenuSegmentFilter {
  ShefPopular = 'SHEF_POPULAR'
}

export enum ShefOnboardingCookingExperience {
  CulinaryTraining = 'CULINARY_TRAINING',
  CurrentIndependentFoodBusiness = 'CURRENT_INDEPENDENT_FOOD_BUSINESS',
  NoExperience = 'NO_EXPERIENCE',
  PastIndependentFoodBusiness = 'PAST_INDEPENDENT_FOOD_BUSINESS'
}

export type ShefOrderRating = {
  __typename?: 'ShefOrderRating';
  category?: Maybe<OrderRatingCategory>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flaggedForReviewAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  privateComment?: Maybe<Scalars['String']['output']>;
  ratingPercent?: Maybe<Scalars['Int']['output']>;
  shefId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ShefPerformanceDashboardInput = {
  endDate: Scalars['String']['input'];
  numberOfShefsToShow: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export enum ShefPlatformDesiredEarnings {
  Above_1000 = 'ABOVE_1000',
  Below_100 = 'BELOW_100',
  Range_100_200 = 'RANGE_100_200',
  Range_200_300 = 'RANGE_200_300',
  Range_300_400 = 'RANGE_300_400',
  Range_400_500 = 'RANGE_400_500',
  Range_500_600 = 'RANGE_500_600',
  Range_600_700 = 'RANGE_600_700',
  Range_700_800 = 'RANGE_700_800',
  Range_800_900 = 'RANGE_800_900',
  Range_900_1000 = 'RANGE_900_1000'
}

export enum ShefPlatformNewDesiredEarnings {
  Day_50 = 'DAY_50',
  Day_100 = 'DAY_100',
  Day_150 = 'DAY_150',
  Day_200 = 'DAY_200',
  Day_250 = 'DAY_250',
  Day_300 = 'DAY_300',
  Day_400 = 'DAY_400',
  Day_500Plus = 'DAY_500_PLUS',
  Unimportant = 'UNIMPORTANT'
}

export enum ShefPlatformUsage {
  Evaluating = 'EVALUATING',
  FullTime = 'FULL_TIME',
  Hobby = 'HOBBY',
  PartTime = 'PART_TIME',
  PartTimeTurningFullTime = 'PART_TIME_TURNING_FULL_TIME'
}

export type ShefPost = {
  __typename?: 'ShefPost';
  clickCount: Scalars['Int']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  foodItemId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isLikedByUser?: Maybe<Scalars['Boolean']['output']>;
  mediaType?: Maybe<ShefPostMediaType>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  numLikes: Scalars['Int']['output'];
  promoCodeId?: Maybe<Scalars['Int']['output']>;
  promoCodeString?: Maybe<Scalars['String']['output']>;
  shefId: Scalars['String']['output'];
  viewCount: Scalars['Int']['output'];
};

export type ShefPostInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  foodItemId?: InputMaybe<Scalars['Int']['input']>;
  mediaType?: InputMaybe<ShefPostMediaType>;
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  promoCodeId?: InputMaybe<Scalars['Int']['input']>;
};

export enum ShefPostMediaType {
  Photo = 'PHOTO'
}

export type ShefProfile = {
  __typename?: 'ShefProfile';
  allowedToAcceptNextDay: Scalars['Boolean']['output'];
  allowedToChat: Scalars['Boolean']['output'];
  allowedToCreateSubscriptions?: Maybe<Scalars['Boolean']['output']>;
  approvedAt?: Maybe<Scalars['Date']['output']>;
  approximateLocation?: Maybe<Location>;
  availableFulfillmentOptions: Array<Scalars['String']['output']>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  canOptInToFringe: Scalars['Boolean']['output'];
  canOptOutOfFringe: Scalars['Boolean']['output'];
  cancelOrderNotificationFrequency?: Maybe<CancelOrderNotificationFrequency>;
  consumerReferralInfo: ConsumerReferralInfo;
  coverPhotoUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cuisineCategories: Array<CuisineCategory>;
  cuisineCategoryIds: Array<Scalars['String']['output']>;
  cuisineRegion?: Maybe<CuisineRegion>;
  cutoffMsBeforeDeliveryDate: Scalars['Int']['output'];
  defaultDropoffHub?: Maybe<DeliveryHub>;
  dishCapacity: Scalars['Int']['output'];
  dropOffHubFirstSetAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  explorePagePromoCode?: Maybe<PromoCode>;
  explorePagePromoCodeId?: Maybe<Scalars['String']['output']>;
  facebookHandle?: Maybe<Scalars['String']['output']>;
  featureShef?: Maybe<Scalars['Boolean']['output']>;
  fhcApprovedAt?: Maybe<Scalars['Date']['output']>;
  fhcExpiresAt?: Maybe<Scalars['Date']['output']>;
  fhcUploadRequiredBy?: Maybe<Scalars['Date']['output']>;
  fhcUploadedAt?: Maybe<Scalars['Date']['output']>;
  firstApprovedAt?: Maybe<Scalars['Date']['output']>;
  followerCount: Scalars['Int']['output'];
  followers: Array<User>;
  foodHandlersCertificate?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  freeDeliveryModal: FreeDeliveryModal;
  fulfillmentOption?: Maybe<Scalars['String']['output']>;
  geographyAllowsCuisineType: Scalars['Boolean']['output'];
  highlightedQuote?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramHandle?: Maybe<Scalars['String']['output']>;
  isBlockedDueToMissingFHC: Scalars['Boolean']['output'];
  isHubless: Scalars['Boolean']['output'];
  isMultiFulfillmentShef: Scalars['Boolean']['output'];
  isShefFollower: Scalars['Boolean']['output'];
  isTrialShef: Scalars['Boolean']['output'];
  linkedInHandle?: Maybe<Scalars['String']['output']>;
  maxDishCapacity: Scalars['Int']['output'];
  mehkoLicenseNumber?: Maybe<Scalars['String']['output']>;
  newOrderNotificationFrequency?: Maybe<NewOrderNotificationFrequency>;
  notes?: Maybe<Scalars['String']['output']>;
  onboardingCookingExperience?: Maybe<ShefOnboardingCookingExperience>;
  onboardingFormAnsweredAt?: Maybe<Scalars['DateTime']['output']>;
  onboardingPlatformUsage?: Maybe<ShefPlatformUsage>;
  phone?: Maybe<Scalars['String']['output']>;
  pickupAddressId?: Maybe<Scalars['Int']['output']>;
  pickupTimeWindows: Array<TimeWindow>;
  platformDesiredEarnings?: Maybe<ShefPlatformDesiredEarnings>;
  platformFormAnsweredAt?: Maybe<Scalars['DateTime']['output']>;
  platformNewDesiredEarnings?: Maybe<ShefPlatformNewDesiredEarnings>;
  platformNewFormAnsweredAt?: Maybe<Scalars['DateTime']['output']>;
  platformNewUsage?: Maybe<ShefPlatformUsage>;
  platformPercent: Scalars['Int']['output'];
  platformRecommendationScore?: Maybe<Scalars['Int']['output']>;
  platformUsage?: Maybe<ShefPlatformUsage>;
  previewFoodItem?: Maybe<FoodItem>;
  previewFoodItemId?: Maybe<Scalars['Int']['output']>;
  primaryRegion?: Maybe<RegionInfo>;
  printers?: Maybe<Array<Printer>>;
  profilePhotoAcceptedAt?: Maybe<Scalars['Date']['output']>;
  profilePhotoOptionA?: Maybe<Scalars['String']['output']>;
  profilePhotoOptionB?: Maybe<Scalars['String']['output']>;
  profilePhotoOptionC?: Maybe<Scalars['String']['output']>;
  profilePhotoRejectedAt?: Maybe<Scalars['Date']['output']>;
  profilePhotoSubmittedAt?: Maybe<Scalars['Date']['output']>;
  randomZip?: Maybe<Scalars['String']['output']>;
  resizedCoverPhotoUrl?: Maybe<Scalars['String']['output']>;
  setBadQualityAt?: Maybe<Scalars['DateTime']['output']>;
  shef: PublicShef;
  shefAddress?: Maybe<Address>;
  shefAddressId?: Maybe<Scalars['Int']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  tikTokHandle?: Maybe<Scalars['String']['output']>;
  timeWindowOptionsForShef: Array<TimeWindow>;
  timeWindowsSelectedByShef: Array<TimeWindow>;
  timeZone: Scalars['String']['output'];
  totalRatings: Scalars['Int']['output'];
  trialGradedAt?: Maybe<Scalars['DateTime']['output']>;
  trialStartedAt?: Maybe<Scalars['DateTime']['output']>;
  trialStatus?: Maybe<TrialStatus>;
  twitterHandle?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['String']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  youtubeHandle?: Maybe<Scalars['String']['output']>;
};


export type ShefProfileFollowersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type ShefProfileResizedCoverPhotoUrlArgs = {
  width: Scalars['Int']['input'];
};

export type ShefProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  cancelOrderNotificationFrequency?: InputMaybe<CancelOrderNotificationFrequency>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  cuisineCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisineRegion?: InputMaybe<CuisineRegion>;
  cutoffMsBeforeDeliveryDate?: InputMaybe<Scalars['Int']['input']>;
  defaultDropoffHubId?: InputMaybe<Scalars['Int']['input']>;
  dishCapacity?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookHandle?: InputMaybe<Scalars['String']['input']>;
  featureShef?: InputMaybe<Scalars['Boolean']['input']>;
  fhcExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  foodHandlersCertificate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  instagramHandle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInHandle?: InputMaybe<Scalars['String']['input']>;
  maxDishCapacity?: InputMaybe<Scalars['Int']['input']>;
  maxOrderCapacity?: InputMaybe<Scalars['Int']['input']>;
  newOrderNotificationFrequency?: InputMaybe<NewOrderNotificationFrequency>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onboardingCookingExperience?: InputMaybe<ShefOnboardingCookingExperience>;
  onboardingFormAnsweredAt?: InputMaybe<Scalars['DateTime']['input']>;
  onboardingPlatformUsage?: InputMaybe<ShefPlatformUsage>;
  orderCapacity?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pickupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  platformDesiredEarnings?: InputMaybe<ShefPlatformDesiredEarnings>;
  platformNewDesiredEarnings?: InputMaybe<ShefPlatformNewDesiredEarnings>;
  platformNewUsage?: InputMaybe<ShefPlatformUsage>;
  platformRecommendationScore?: InputMaybe<Scalars['Int']['input']>;
  platformUsage?: InputMaybe<ShefPlatformUsage>;
  previewFoodItemId?: InputMaybe<Scalars['Int']['input']>;
  printers?: InputMaybe<Array<Printer>>;
  resumeCommsAt?: InputMaybe<Scalars['Date']['input']>;
  setBadQualityAt?: InputMaybe<Scalars['DateTime']['input']>;
  shefStatus?: InputMaybe<ShefStatus>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  tikTokHandle?: InputMaybe<Scalars['String']['input']>;
  trialStatus?: InputMaybe<TrialStatus>;
  twitterHandle?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  youtubeHandle?: InputMaybe<Scalars['String']['input']>;
};

export type ShefPromoCodeInput = {
  codeBase: Scalars['String']['input'];
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  firstPromoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isExplorePagePromo?: InputMaybe<Scalars['Boolean']['input']>;
  isPercentage: Scalars['Boolean']['input'];
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  maxUsesPerUser?: InputMaybe<Scalars['Int']['input']>;
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  restrictedToUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  startTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['Int']['input'];
};

export type ShefRating = {
  __typename?: 'ShefRating';
  count: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
};

export enum ShefRosterStatus {
  Favorite = 'FAVORITE',
  None = 'NONE',
  Recommended = 'RECOMMENDED'
}

export type ShefSearchResults = {
  __typename?: 'ShefSearchResults';
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  results: Array<PublicShef>;
};

export type ShefSegment = {
  __typename?: 'ShefSegment';
  foodItems: Array<FoodItem>;
  shef: PublicShef;
  shefRemainingAvailability: Scalars['Int']['output'];
};

export enum ShefStatus {
  Applicant = 'APPLICANT',
  Approved = 'APPROVED',
  None = 'NONE',
  Trial = 'TRIAL',
  Unapproved = 'UNAPPROVED'
}

export type ShefStripeConnect = {
  __typename?: 'ShefStripeConnect';
  accessToken?: Maybe<Scalars['String']['output']>;
  accountType: StripeAccountType;
  createdAt: Scalars['DateTime']['output'];
  currentBalance?: Maybe<ShefStripeConnectBalance>;
  dashboardLoginLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  livemode?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  stripeUserId?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type ShefStripeConnectBalance = {
  __typename?: 'ShefStripeConnectBalance';
  available: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
};

export type ShefSubtotal = {
  shefId?: InputMaybe<Scalars['String']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
};

export type ShefTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type ShefTagType = {
  __typename?: 'ShefTagType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ShefTags = {
  score: Scalars['Int']['input'];
  shefId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type ShefTimeWindowSelector = {
  ids: Array<Scalars['Int']['input']>;
};

export type ShortUrl = {
  __typename?: 'ShortUrl';
  hits: Scalars['Int']['output'];
  longUrl: Scalars['String']['output'];
  shortUrl: Scalars['String']['output'];
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type SignedUrlInput = {
  bucket: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  operation: SignedUrlInputOperation;
  path?: InputMaybe<Scalars['String']['input']>;
};

export enum SignedUrlInputOperation {
  Get = 'GET',
  Put = 'PUT'
}

export type SkipMealPlanGroupOrderInput = {
  deliveryDate: Scalars['String']['input'];
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type SkipMealPlanGroupOrderResponse = MutationResponse & {
  __typename?: 'SkipMealPlanGroupOrderResponse';
  groupOrderId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum StripeAccountType {
  Express = 'EXPRESS',
  Standard = 'STANDARD'
}

export type SubcuisineSegmentDetails = {
  __typename?: 'SubcuisineSegmentDetails';
  rootCuisineRegion: Scalars['String']['output'];
  subcuisineId: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  addressId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  cuisinePreferences: Array<CuisineRegion>;
  fridayDelivery: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isVegan: Scalars['Boolean']['output'];
  isVegetarian: Scalars['Boolean']['output'];
  mondayDelivery: Scalars['Boolean']['output'];
  numMeals: Scalars['Int']['output'];
  numServings: Scalars['Int']['output'];
  orderTemplate?: Maybe<Order>;
  paymentMethodId: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  promoCode?: Maybe<Scalars['String']['output']>;
  recurringPeriodDays?: Maybe<Scalars['Int']['output']>;
  saturdayDelivery: Scalars['Boolean']['output'];
  status: SubscriptionStatus;
  sundayDelivery: Scalars['Boolean']['output'];
  thursdayDelivery: Scalars['Boolean']['output'];
  tuesdayDelivery: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
  wednesdayDelivery: Scalars['Boolean']['output'];
};

export type SubscriptionBuildOrderInput = {
  deliveryDate: Scalars['String']['input'];
  foodItemId: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscriptionConnection = {
  __typename?: 'SubscriptionConnection';
  edges: Array<SubscriptionEdge>;
  pageInfo: PageInfo;
};

export type SubscriptionCreateInput = {
  orderInputs?: InputMaybe<Array<SubscriptionOrderInput>>;
  subscriptionCycleId?: InputMaybe<Scalars['String']['input']>;
  subscriptionInput: SubscriptionInput;
  subscriptionPromoCode?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEdge = {
  __typename?: 'SubscriptionEdge';
  cursor: Scalars['ID']['output'];
  node: Subscription;
};

export type SubscriptionInput = {
  cuisinePreferences: Array<CuisineRegion>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  fridayDelivery: Scalars['Boolean']['input'];
  isMealPlan?: InputMaybe<Scalars['Boolean']['input']>;
  isVegan: Scalars['Boolean']['input'];
  isVegetarian: Scalars['Boolean']['input'];
  mondayDelivery: Scalars['Boolean']['input'];
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  orderTemplateId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recurringPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  saturdayDelivery: Scalars['Boolean']['input'];
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  subscriptionPriceId: Scalars['String']['input'];
  sundayDelivery: Scalars['Boolean']['input'];
  thursdayDelivery: Scalars['Boolean']['input'];
  tuesdayDelivery: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
  wednesdayDelivery: Scalars['Boolean']['input'];
};

export enum SubscriptionInvoiceStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Pause = 'PAUSE'
}

export type SubscriptionModifyInput = {
  cuisinePreferences?: InputMaybe<Array<CuisineRegion>>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  isVegan?: InputMaybe<Scalars['Boolean']['input']>;
  isVegetarian?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubscriptionStatus>;
  subscriptionPriceId?: InputMaybe<Scalars['String']['input']>;
  upcomingOrderToCancelDeliveryDate?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionModifyResult = {
  __typename?: 'SubscriptionModifyResult';
  subscription: Subscription;
};

export type SubscriptionOption = {
  __typename?: 'SubscriptionOption';
  displayText: Scalars['String']['output'];
  promoCode?: Maybe<PromoCode>;
  recurringPeriod: RecurringPeriod;
};

export type SubscriptionOrderInput = {
  deliveryDate: Scalars['String']['input'];
  foodItemId: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
  timeWindowId: Scalars['Int']['input'];
};

export type SubscriptionPauseInput = {
  deliveryDay?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  subscriptionCycleId?: InputMaybe<Scalars['String']['input']>;
  subscriptionInvoiceId: Scalars['String']['input'];
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Hold = 'HOLD'
}

export type SuggestedItem = {
  __typename?: 'SuggestedItem';
  foodItem: FoodItem;
  foodItemId: Scalars['Int']['output'];
  numAvailable?: Maybe<Scalars['Int']['output']>;
  orderAffinity: Scalars['Float']['output'];
};

export enum SurveyQuestion {
  AlcoholFree = 'ALCOHOL_FREE',
  CrossContaminationSecure = 'CROSS_CONTAMINATION_SECURE',
  GelatinFree = 'GELATIN_FREE',
  HalalDairy = 'HALAL_DAIRY',
  HalalMeats = 'HALAL_MEATS',
  PorkFree = 'PORK_FREE',
  Seafood = 'SEAFOOD'
}

export enum TagFilter {
  TopShef = 'TOP_SHEF'
}

export enum TaggedShefOp {
  And = 'AND',
  Or = 'OR'
}

export enum TaskStatus {
  Aborted = 'ABORTED',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED',
  Skipped = 'SKIPPED',
  Succeeded = 'SUCCEEDED'
}

export type TasteProfile = {
  __typename?: 'TasteProfile';
  cuisinePreferences?: Maybe<Array<Scalars['String']['output']>>;
  dietType?: Maybe<DietType>;
  id?: Maybe<Scalars['String']['output']>;
  menuDietaryRestrictions?: Maybe<Array<DietaryRestriction>>;
  numAdults?: Maybe<Scalars['Int']['output']>;
  numBigEaters?: Maybe<Scalars['Int']['output']>;
  numLittleEaters?: Maybe<Scalars['Int']['output']>;
  preferredProteins?: Maybe<Array<Protein>>;
  replacementDietaryRestrictions?: Maybe<Array<DietaryRestriction>>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type TasteProfileInput = {
  cuisinePreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  dietType?: InputMaybe<DietType>;
  menuDietaryRestrictions?: InputMaybe<Array<DietaryRestriction>>;
  numAdults?: InputMaybe<Scalars['Int']['input']>;
  numBigEaters?: InputMaybe<Scalars['Int']['input']>;
  numLittleEaters?: InputMaybe<Scalars['Int']['input']>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  replacementDietaryRestrictions?: InputMaybe<Array<DietaryRestriction>>;
};

export type TasteProfileMutationInput = {
  tasteProfile: TasteProfileInput;
  userId: Scalars['String']['input'];
};

export type TasteProfileMutationResponse = MutationResponse & {
  __typename?: 'TasteProfileMutationResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tasteProfile?: Maybe<TasteProfile>;
};

export type TimeInput = {
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
  second?: InputMaybe<Scalars['Float']['input']>;
};

export type TimeWindow = {
  __typename?: 'TimeWindow';
  endMsAfterMidnight: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startMsAfterMidnight: Scalars['Int']['output'];
};

export type TipOption = {
  __typename?: 'TipOption';
  label: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
  value: Scalars['Int']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  createdAt: Scalars['DateTime']['output'];
  groupOrderId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
  transactionLineItems: Array<TransactionLineItem>;
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type TransactionLineItem = {
  __typename?: 'TransactionLineItem';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum TrialStatus {
  Fail = 'FAIL',
  InProgress = 'IN_PROGRESS',
  None = 'NONE',
  Pass = 'PASS',
  Pretrial = 'PRETRIAL'
}

export type UnavailableFoodItem = {
  __typename?: 'UnavailableFoodItem';
  foodItem: FoodItem;
  quantityAvailable: Scalars['Int']['output'];
};

export type UnscanInput = {
  orderId: Scalars['Int']['input'];
};

export type UnskipMealPlanGroupOrderInput = {
  groupOrderId: Scalars['String']['input'];
};

export type UnskipMealPlanGroupOrderResponse = MutationResponse & {
  __typename?: 'UnskipMealPlanGroupOrderResponse';
  groupOrderId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateDeliveryHubInput = {
  city: Scalars['String']['input'];
  code: Scalars['String']['input'];
  disabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  dropoffWindowEndTimeMinutesFromMidnight?: InputMaybe<Scalars['Int']['input']>;
  dropoffWindowStartTimeMinutesFromMidnight?: InputMaybe<Scalars['Int']['input']>;
  fridayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isOutpost: Scalars['Boolean']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mondayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pickupInstructions: Scalars['String']['input'];
  province: Scalars['String']['input'];
  regionId: Scalars['Int']['input'];
  saturdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  street: Scalars['String']['input'];
  sundayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  thursdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  tuesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  wednesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UpdateDeliveryHubResult = {
  __typename?: 'UpdateDeliveryHubResult';
  id: Scalars['Int']['output'];
};

export type UpdateMerchandisePageTagFilterInput = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type UpdatePromoCodeInput = {
  disabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  maxValue?: InputMaybe<Scalars['Int']['input']>;
  restrictedToRegionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateRegionInput = {
  deliveryEnabledAt: Scalars['DateTime']['input'];
  displayName: Scalars['String']['input'];
  fridayDelivery: Scalars['Boolean']['input'];
  launchedAt: Scalars['DateTime']['input'];
  mondayDelivery: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  saturdayDelivery: Scalars['Boolean']['input'];
  sundayDelivery: Scalars['Boolean']['input'];
  thursdayDelivery: Scalars['Boolean']['input'];
  trialShefsEnabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  tuesdayDelivery: Scalars['Boolean']['input'];
  wednesdayDelivery: Scalars['Boolean']['input'];
};

export type Upsell = {
  __typename?: 'Upsell';
  id: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  tier: UpsellTier;
};

export enum UpsellTier {
  Premium = 'PREMIUM',
  PremiumPlus = 'PREMIUM_PLUS'
}

export type User = {
  __typename?: 'User';
  activeAddresses: Array<Address>;
  admin: Scalars['Boolean']['output'];
  banReason?: Maybe<Scalars['String']['output']>;
  banned: Scalars['Boolean']['output'];
  bannedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  favoriteShefs: Array<PublicShef>;
  firstName: Scalars['String']['output'];
  flakeId: Scalars['String']['output'];
  followedShefs: Array<PublicShef>;
  foodItemCount?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  groupOrders?: Maybe<Array<GroupOrder>>;
  hasActiveMealPlan?: Maybe<Scalars['Boolean']['output']>;
  hasActiveSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasDiscountedSubtotalFromExperiment: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  isMealPlanDiscountEligible: Scalars['Boolean']['output'];
  isMenuCurator: Scalars['Boolean']['output'];
  isPhotoEditor: Scalars['Boolean']['output'];
  isTasteTester: Scalars['Boolean']['output'];
  isWaitlisted?: Maybe<Scalars['Boolean']['output']>;
  lastDetectedAppOpenAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  lastOrder?: Maybe<Order>;
  lastOrderByFulfillmentDate?: Maybe<Order>;
  lastOrderPhoneNumber?: Maybe<Scalars['String']['output']>;
  lastSearchedRegionId?: Maybe<Scalars['Int']['output']>;
  lastSearchedZipCode?: Maybe<Scalars['String']['output']>;
  lastSearchedZipCodeIsAvailableToCustomers?: Maybe<Scalars['Boolean']['output']>;
  mealPlanLastFourDigits?: Maybe<Scalars['Int']['output']>;
  orderCount: Scalars['Int']['output'];
  orderCountFromShef: Scalars['Int']['output'];
  orders?: Maybe<Array<Maybe<Order>>>;
  organization?: Maybe<Organization>;
  pendingReferralRewards?: Maybe<Array<Maybe<PromoCodeUsage>>>;
  phone?: Maybe<Scalars['String']['output']>;
  promoCodes: PaginatedPromoCodes;
  publicName: Scalars['String']['output'];
  recentTasteTests: Scalars['Int']['output'];
  referralCode: ReferralCode;
  referralRewards?: Maybe<Array<Maybe<PromoCode>>>;
  savedCreditCards: Array<SavedCreditCard>;
  shefApplication?: Maybe<ShefApplication>;
  shefProfile?: Maybe<ShefProfile>;
  shefStatus: ShefStatus;
  shefStripeConnect?: Maybe<ShefStripeConnect>;
  tosLastAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  unlockedTrialShefDiscovery: Scalars['Boolean']['output'];
  unratedGroupOrder?: Maybe<GroupOrder>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  visitedMealPlanPreferences?: Maybe<Scalars['Boolean']['output']>;
};


export type UserActiveAddressesArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
};


export type UserHasDiscountedSubtotalFromExperimentArgs = {
  shefId: Scalars['String']['input'];
};


export type UserLastOrderByFulfillmentDateArgs = {
  deliveryDate: Scalars['String']['input'];
  shefId: Scalars['String']['input'];
};


export type UserOrderCountFromShefArgs = {
  shefId: Scalars['String']['input'];
};


export type UserUnlockedTrialShefDiscoveryArgs = {
  deliveryDates?: InputMaybe<Array<Scalars['String']['input']>>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserInput = {
  appleIdToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookIdToken?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  hasOptedIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UserMealPlan = {
  __typename?: 'UserMealPlan';
  mealPlan?: Maybe<MealPlan>;
  mealPlanRegionId?: Maybe<Scalars['Int']['output']>;
  mealPlanZipCode?: Maybe<Scalars['String']['output']>;
  nextDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  category: NotificationCategory;
  enabled: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserNotificationSettingInput = {
  category: NotificationCategory;
  enabled: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type UserNotificationSettingUpdate = {
  notificationSettings: Array<UserNotificationSettingInput>;
  userId: Scalars['String']['input'];
};

export type UserPayload = {
  __typename?: 'UserPayload';
  user: User;
};

export enum UserRoleEnum {
  Admin = 'ADMIN',
  MenuCurator = 'MENU_CURATOR',
  PhotoEditor = 'PHOTO_EDITOR'
}

export type UserRoleInput = {
  role: UserRoleEnum;
  value: Scalars['Boolean']['input'];
};

export type UserRoleResult = {
  __typename?: 'UserRoleResult';
  role: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type UtmInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  cuisine?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type Variant = {
  __typename?: 'Variant';
  name: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

export type VerifiedDietaryResponse = {
  __typename?: 'VerifiedDietaryResponse';
  questionId: Scalars['String']['output'];
  response: MultiResponse;
  responseDisplay?: Maybe<Scalars['String']['output']>;
  responseFreeText?: Maybe<Scalars['String']['output']>;
};

export enum WaitlistActionType {
  AppDownloaded = 'APP_DOWNLOADED',
  ConsumerPhoneAdded = 'CONSUMER_PHONE_ADDED',
  ConsumerReferralSignup = 'CONSUMER_REFERRAL_SIGNUP',
  ShefApplicationCreated = 'SHEF_APPLICATION_CREATED',
  ShefBioCompleted = 'SHEF_BIO_COMPLETED',
  ShefDishApproved = 'SHEF_DISH_APPROVED',
  ShefPhotoApproved = 'SHEF_PHOTO_APPROVED',
  ShefReferralApproved = 'SHEF_REFERRAL_APPROVED'
}

export type WaitlistRank = {
  __typename?: 'WaitlistRank';
  rank: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  waitlistType?: Maybe<WaitlistType>;
};

export enum WaitlistType {
  Consumer = 'CONSUMER',
  Shef = 'SHEF'
}

export type ZipCode = {
  __typename?: 'ZipCode';
  availableToCustomers: Scalars['Boolean']['output'];
  availableToSubscriptions: Scalars['Boolean']['output'];
  canMailFood: Scalars['Boolean']['output'];
  deliveryFee?: Maybe<Scalars['Int']['output']>;
  deliveryHubId?: Maybe<Scalars['Int']['output']>;
  deliveryTimeRange: DeliveryTimeRange;
  deliveryType: Scalars['String']['output'];
  discountedDeliveryFee: Scalars['Int']['output'];
  hasMilkmanRecycling: Scalars['Boolean']['output'];
  isHubless: Scalars['Boolean']['output'];
  mailableDeliveryFee?: Maybe<Scalars['Int']['output']>;
  minimumAmountForDiscountedShipping?: Maybe<Scalars['Int']['output']>;
  minimumAmountForFreeShipping?: Maybe<Scalars['Int']['output']>;
  orderLabelCode?: Maybe<Scalars['String']['output']>;
  region: RegionInfo;
  regionId: Scalars['Int']['output'];
  shefServesZipCode: Scalars['Boolean']['output'];
  timeToShipInDays?: Maybe<Scalars['Int']['output']>;
  timeWindows: Array<TimeWindow>;
  timeZone: Scalars['String']['output'];
  upfrontDeliveryFeeEnabled: Scalars['Boolean']['output'];
  zipCode: Scalars['String']['output'];
};


export type ZipCodeShefServesZipCodeArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  shefId: Scalars['String']['input'];
};


export type ZipCodeTimeWindowsArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
};

export type ZipCodeCelebrityEventMetadata = {
  __typename?: 'ZipCodeCelebrityEventMetadata';
  availabilityDate?: Maybe<Scalars['Date']['output']>;
  celebrityEventType?: Maybe<CelebrityEventType>;
  shefId?: Maybe<Scalars['String']['output']>;
};

export type ZipCodeInput = {
  deliveryFee?: InputMaybe<Scalars['Int']['input']>;
  deliveryHubId?: InputMaybe<Scalars['Int']['input']>;
  deliveryType: Scalars['String']['input'];
  orderLabelCode?: InputMaybe<Scalars['String']['input']>;
  regionId: Scalars['Int']['input'];
  timeWindowIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeZone: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type AddressRadioInputAddressFragment = { __typename?: 'Address', id: number, formattedAddress?: string | null };

export type AddressSelectorAddressFragment = { __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null };

type AuthResultFields_AuthResult_Fragment = { __typename?: 'AuthResult', token: string, isExistingUser: boolean, isImpersonatedUser?: boolean | null, user: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } };

type AuthResultFields_AuthResult3_Fragment = { __typename?: 'AuthResult3', token?: string | null, isExistingUser?: boolean | null, isImpersonatedUser?: boolean | null, user?: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } | null };

export type AuthResultFieldsFragment = AuthResultFields_AuthResult_Fragment | AuthResultFields_AuthResult3_Fragment;

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthResult', token: string, isExistingUser: boolean, isImpersonatedUser?: boolean | null, user: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } } };

export type RegisterMutationVariables = Exact<{
  userInput: UserInput;
  utm?: InputMaybe<UtmInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  signUpEntryPoint?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'AuthResult', token: string, isExistingUser: boolean, isImpersonatedUser?: boolean | null, user: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } } };

export type LoginWithOAuthMutationVariables = Exact<{
  oAuthLoginType: OAuthLoginType;
  token: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
  requireZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  utm?: InputMaybe<UtmInput>;
  signUpEntryPoint?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoginWithOAuthMutation = { __typename?: 'Mutation', login: { __typename: 'AuthResult', token: string, isExistingUser: boolean, isImpersonatedUser?: boolean | null, user: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } } | { __typename: 'OAuthMissingFieldsResult', firstName?: string | null, firstNameIsMissing?: boolean | null, lastName?: string | null, lastNameIsMissing?: boolean | null, zipCodeIsMissing?: boolean | null, needsToAcceptTermsOfService?: boolean | null } };

export type ResetPasswordMutationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordMutationMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type ResetChangePasswordMutationMutationVariables = Exact<{
  resetPasswordToken: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetChangePasswordMutationMutation = { __typename?: 'Mutation', resetChangePassword?: boolean | null };

export type GetRegisteredEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetRegisteredEmailQuery = { __typename?: 'Query', getRegisteredEmail?: string | null };

export type ConsumerOrderCartMobileQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ConsumerOrderCartMobileQuery = { __typename?: 'Query', shef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, publicName: string, timeZone: string, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, cuisineRegion?: CuisineRegion | null } }, carts: { __typename?: 'CartResults', recentlyAdded: boolean, foodItems: Array<{ __typename?: 'CartLineItem', id: number, shefId: string, foodItemId: number, quantity: number, createdAt: string, updatedAt: string, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } }>, addOnItems: Array<{ __typename?: 'CartAddOnItem', id: number, userId: string, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string } }> } };

export type CartOrderTotalFragment = { __typename?: 'OrderTotals', subtotal: number, discountApplied: number, promoApplied: number, nonPromoDiscountApplied: number, deliveryFee: number, smallOrderFee: number, remainingToRemoveSmallOrderFee: number, grandTotal: number };

export type CartTotalsQueryVariables = Exact<{
  cartInput: GroupOrderTotalsInput;
}>;


export type CartTotalsQuery = { __typename?: 'Query', cartTotals: { __typename?: 'OrderTotals', subtotal: number, discountApplied: number, promoApplied: number, nonPromoDiscountApplied: number, deliveryFee: number, smallOrderFee: number, remainingToRemoveSmallOrderFee: number, grandTotal: number } };

export type EditableOrderFragment = { __typename?: 'Order', id: number, groupOrderId: string, subtotal: number, deliveryDate: string, orderType: OrderType, orderStatus: OrderStatus, consumerOrderStatus: ConsumerOrderStatus, discountApplied: number, salesTax: number, deliveryFee: number, deliveryDiscount?: number | null, serviceFee: number, shefTip?: number | null, grandTotal: number, isCancelable: boolean, isDeliveryEditable: boolean, isLineItemsEditable: boolean, deliveryType: string, shefId: string, deliveryNotes?: string | null, deliveryAddressId: number, timeWindowId?: number | null, phone: string, createdAt: string, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, imageUrl: string, flakeId: string }, publicShef: { __typename?: 'PublicShef', id: string, flakeId: string, firstName?: string | null, publicName: string, imageUrl?: string | null, isTopShef: boolean, celebrityEventType?: CelebrityEventType | null, totalOrders: number, timeZone: string, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string, numDishesAvailable: number, isSoldOut: boolean }>, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, coverPhotoUrl?: string | null, specialty?: string | null, cuisineRegion?: CuisineRegion | null, bio?: string | null, videoUrl?: string | null, randomZip?: string | null, cutoffMsBeforeDeliveryDate: number, timeZone: string, dishCapacity: number, mehkoLicenseNumber?: string | null, allowedToChat: boolean, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, fulfillmentOption?: string | null, fhcApprovedAt?: string | null, isBlockedDueToMissingFHC: boolean, previewFoodItem?: { __typename?: 'FoodItem', imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, approximateLocation?: { __typename?: 'Location', latitude: number, longitude: number } | null }, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null }, promoCode?: { __typename?: 'PromoCode', promoCodeType: PromoCodeType, id: number, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, userId: string, foodItemId: number, quantity: number, price: number, customizationIds?: Array<string> | null, foodItemSnapshot?: any | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, name?: string | null, imageUrl?: string | null, spiceLevel: number, servingSize?: string | null, portion?: string | null, description?: string | null, ingredients?: string | null, price: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, shef: { __typename?: 'PublicShef', id: string, publicName: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', price: number, tier: UpsellTier } | null } }>, addOnItems: Array<{ __typename?: 'OrderAddOnItem', id: number, price: number, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, price: number, imageUrl: string, displayText: string, addonType: AddOnItemType, extraText?: string | null } }>, availableAddOnItems: Array<{ __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string }>, shefProfile: { __typename?: 'ShefProfile', id: number, timeZone: string, primaryRegion?: { __typename?: 'RegionInfo', id: number } | null }, address: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCode: string, phone: string, name?: string | null, userId?: string | null, archived: boolean, disabled?: boolean | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, country: string, latitude: number, longitude: number, deliveryNotes?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, regionId: number, timeZone: string, timeWindows: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> } | null }, possibleDeliveryDates: Array<{ __typename?: 'PossibleDeliveryDate', date: string, possible: DeliveryDateChangePossible, reason?: string | null, unavailableItems: Array<{ __typename?: 'UnavailableFoodItem', quantityAvailable: number, foodItem: { __typename?: 'FoodItem', id: number } }> }>, user: { __typename?: 'User', id: string, firstName: string, lastName: string, publicName: string, email: string }, timeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, delivery?: { __typename?: 'Delivery', id: string, estimatedDeliveryTime?: string | null, driverPhone?: string | null, driverName?: string | null } | null, pickupAddress?: { __typename?: 'Address', id: number, latitude: number, longitude: number, formattedAddress?: string | null, deliveryNotes?: string | null, phone: string } | null };

export type EditableOrderQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditableOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: number, groupOrderId: string, subtotal: number, deliveryDate: string, orderType: OrderType, orderStatus: OrderStatus, consumerOrderStatus: ConsumerOrderStatus, discountApplied: number, salesTax: number, deliveryFee: number, deliveryDiscount?: number | null, serviceFee: number, shefTip?: number | null, grandTotal: number, isCancelable: boolean, isDeliveryEditable: boolean, isLineItemsEditable: boolean, deliveryType: string, shefId: string, deliveryNotes?: string | null, deliveryAddressId: number, timeWindowId?: number | null, phone: string, createdAt: string, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, imageUrl: string, flakeId: string }, publicShef: { __typename?: 'PublicShef', id: string, flakeId: string, firstName?: string | null, publicName: string, imageUrl?: string | null, isTopShef: boolean, celebrityEventType?: CelebrityEventType | null, totalOrders: number, timeZone: string, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string, numDishesAvailable: number, isSoldOut: boolean }>, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, coverPhotoUrl?: string | null, specialty?: string | null, cuisineRegion?: CuisineRegion | null, bio?: string | null, videoUrl?: string | null, randomZip?: string | null, cutoffMsBeforeDeliveryDate: number, timeZone: string, dishCapacity: number, mehkoLicenseNumber?: string | null, allowedToChat: boolean, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, fulfillmentOption?: string | null, fhcApprovedAt?: string | null, isBlockedDueToMissingFHC: boolean, previewFoodItem?: { __typename?: 'FoodItem', imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, approximateLocation?: { __typename?: 'Location', latitude: number, longitude: number } | null }, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null }, promoCode?: { __typename?: 'PromoCode', promoCodeType: PromoCodeType, id: number, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, userId: string, foodItemId: number, quantity: number, price: number, customizationIds?: Array<string> | null, foodItemSnapshot?: any | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, name?: string | null, imageUrl?: string | null, spiceLevel: number, servingSize?: string | null, portion?: string | null, description?: string | null, ingredients?: string | null, price: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, shef: { __typename?: 'PublicShef', id: string, publicName: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', price: number, tier: UpsellTier } | null } }>, addOnItems: Array<{ __typename?: 'OrderAddOnItem', id: number, price: number, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, price: number, imageUrl: string, displayText: string, addonType: AddOnItemType, extraText?: string | null } }>, availableAddOnItems: Array<{ __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string }>, shefProfile: { __typename?: 'ShefProfile', id: number, timeZone: string, primaryRegion?: { __typename?: 'RegionInfo', id: number } | null }, address: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCode: string, phone: string, name?: string | null, userId?: string | null, archived: boolean, disabled?: boolean | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, country: string, latitude: number, longitude: number, deliveryNotes?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, regionId: number, timeZone: string, timeWindows: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> } | null }, possibleDeliveryDates: Array<{ __typename?: 'PossibleDeliveryDate', date: string, possible: DeliveryDateChangePossible, reason?: string | null, unavailableItems: Array<{ __typename?: 'UnavailableFoodItem', quantityAvailable: number, foodItem: { __typename?: 'FoodItem', id: number } }> }>, user: { __typename?: 'User', id: string, firstName: string, lastName: string, publicName: string, email: string }, timeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, delivery?: { __typename?: 'Delivery', id: string, estimatedDeliveryTime?: string | null, driverPhone?: string | null, driverName?: string | null } | null, pickupAddress?: { __typename?: 'Address', id: number, latitude: number, longitude: number, formattedAddress?: string | null, deliveryNotes?: string | null, phone: string } | null } | null };

export type EditableFoodItemAvailabilityQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type EditableFoodItemAvailabilityQuery = { __typename?: 'Query', consumerFoodItems: Array<{ __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }> };

export type EditableGroupOrderQueryVariables = Exact<{
  groupOrderId: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditableGroupOrderQuery = { __typename?: 'Query', groupOrdersByIds: Array<{ __typename?: 'GroupOrder', id: string, uuid: string, formattedId: string, orderType: OrderType, userId: string, phone: string, deliveryAddressId: number, pickupAddressId?: number | null, createdAt: string, cancelledAt?: string | null, deliveryDate: string, deliveryNotes?: string | null, deliveryType: string, pickupDeliveryId?: number | null, dayOfEmailScheduledTaskId?: number | null, subscriptionInvoiceId?: string | null, canReviewOrder: boolean, timeWindowId?: number | null, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, user: { __typename?: 'User', id: string, flakeId: string, publicName: string, email: string, activeAddresses: Array<{ __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null }> }, refunds: Array<{ __typename?: 'Refund', id: string, orderId?: number | null, createdAt: string, refundType: string, refundReason: string, notes?: string | null }>, delivery?: { __typename?: 'Delivery', id: string, estimatedDeliveryTime?: string | null, driverName?: string | null, driverPhone?: string | null, externalId?: string | null, type?: string | null, fee?: number | null } | null, pickupAddress?: { __typename?: 'Address', id: number, formattedAddress?: string | null, latitude: number, longitude: number, deliveryNotes?: string | null } | null, deliveryAddress: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, timeZone: string, region: { __typename?: 'RegionInfo', id: number, name: string } } | null }, orders: Array<{ __typename?: 'Order', createdAt: string, id: number, groupOrderId: string, subtotal: number, deliveryDate: string, orderType: OrderType, orderStatus: OrderStatus, consumerOrderStatus: ConsumerOrderStatus, discountApplied: number, salesTax: number, deliveryFee: number, deliveryDiscount?: number | null, serviceFee: number, shefTip?: number | null, grandTotal: number, isCancelable: boolean, isDeliveryEditable: boolean, isLineItemsEditable: boolean, deliveryType: string, shefId: string, deliveryNotes?: string | null, deliveryAddressId: number, timeWindowId?: number | null, phone: string, user: { __typename?: 'User', id: string, firstName: string, lastName: string, publicName: string, email: string }, timeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, imageUrl: string, flakeId: string }, publicShef: { __typename?: 'PublicShef', id: string, flakeId: string, firstName?: string | null, publicName: string, imageUrl?: string | null, isTopShef: boolean, celebrityEventType?: CelebrityEventType | null, totalOrders: number, timeZone: string, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string, numDishesAvailable: number, isSoldOut: boolean }>, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, coverPhotoUrl?: string | null, specialty?: string | null, cuisineRegion?: CuisineRegion | null, bio?: string | null, videoUrl?: string | null, randomZip?: string | null, cutoffMsBeforeDeliveryDate: number, timeZone: string, dishCapacity: number, mehkoLicenseNumber?: string | null, allowedToChat: boolean, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, fulfillmentOption?: string | null, fhcApprovedAt?: string | null, isBlockedDueToMissingFHC: boolean, previewFoodItem?: { __typename?: 'FoodItem', imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, approximateLocation?: { __typename?: 'Location', latitude: number, longitude: number } | null }, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null }, promoCode?: { __typename?: 'PromoCode', promoCodeType: PromoCodeType, id: number, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, userId: string, foodItemId: number, quantity: number, price: number, customizationIds?: Array<string> | null, foodItemSnapshot?: any | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, name?: string | null, imageUrl?: string | null, spiceLevel: number, servingSize?: string | null, portion?: string | null, description?: string | null, ingredients?: string | null, price: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, shef: { __typename?: 'PublicShef', id: string, publicName: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', price: number, tier: UpsellTier } | null } }>, addOnItems: Array<{ __typename?: 'OrderAddOnItem', id: number, price: number, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, price: number, imageUrl: string, displayText: string, addonType: AddOnItemType, extraText?: string | null } }>, availableAddOnItems: Array<{ __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string }>, shefProfile: { __typename?: 'ShefProfile', id: number, timeZone: string, primaryRegion?: { __typename?: 'RegionInfo', id: number } | null }, address: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCode: string, phone: string, name?: string | null, userId?: string | null, archived: boolean, disabled?: boolean | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, country: string, latitude: number, longitude: number, deliveryNotes?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, regionId: number, timeZone: string, timeWindows: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> } | null }, possibleDeliveryDates: Array<{ __typename?: 'PossibleDeliveryDate', date: string, possible: DeliveryDateChangePossible, reason?: string | null, unavailableItems: Array<{ __typename?: 'UnavailableFoodItem', quantityAvailable: number, foodItem: { __typename?: 'FoodItem', id: number } }> }>, delivery?: { __typename?: 'Delivery', id: string, estimatedDeliveryTime?: string | null, driverPhone?: string | null, driverName?: string | null } | null, pickupAddress?: { __typename?: 'Address', id: number, latitude: number, longitude: number, formattedAddress?: string | null, deliveryNotes?: string | null, phone: string } | null }>, promoCodes: Array<{ __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null }>, timeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, orderTotals: { __typename?: 'ConsumerOrderTotal', deliveryFee: number, promoApplied: number, nonPromoDiscountApplied: number, grandTotal: number, refund: number, salesTax: number, serviceFee: number, shefTip: number, smallOrderFee: number, subtotal: number, refundableBalance: number, promoBalance: number } }> };

export type ZipCodeCelebrityEventDetailsQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  celebrityEventType: CelebrityEventType;
}>;


export type ZipCodeCelebrityEventDetailsQuery = { __typename?: 'Query', zipCodeCelebrityEventDetails: { __typename?: 'ZipCodeCelebrityEventMetadata', shefId?: string | null, availabilityDate?: string | null } };

export type LatestCelebrityEventForZipCodeQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type LatestCelebrityEventForZipCodeQuery = { __typename?: 'Query', latestCelebrityEventForZipCode?: { __typename?: 'ZipCodeCelebrityEventMetadata', shefId?: string | null, availabilityDate?: string | null, celebrityEventType?: CelebrityEventType | null } | null };

export type CelebrityEventPopularShefsQueryVariables = Exact<{
  zipCode?: InputMaybe<Scalars['String']['input']>;
  filters: ExploreFoodItemsFilterInput;
}>;


export type CelebrityEventPopularShefsQuery = { __typename?: 'Query', celebrityEventPopularShefs: Array<{ __typename?: 'ExploreSegmentShef', dishPreviewImage: string, numDishes: number, shef: { __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, isTopShef: boolean, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null, name?: string | null }>, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string }>, shefProfile: { __typename?: 'ShefProfile', isShefFollower: boolean, id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } } }> };

export type ChatTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatTokenQuery = { __typename?: 'Query', chatToken: string };

export type AddOrderMutationVariables = Exact<{
  input: GroupOrderInput;
}>;


export type AddOrderMutation = { __typename?: 'Mutation', addGroupOrder: { __typename?: 'GroupOrderResult', groupOrder: { __typename?: 'GroupOrder', id: string, orders: Array<{ __typename?: 'Order', id: number, uuid: string }> } } };

export type ExplorePagePromoCodeFragment = { __typename?: 'PromoCode', id: number, code: string, promoCodeType: PromoCodeType, value: number };

export type ConsumerOrderFinalizeQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  shefIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  deliveryDate: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  noCurrentUser: Scalars['Boolean']['input'];
}>;


export type ConsumerOrderFinalizeQuery = { __typename?: 'Query', applePayEnabled: boolean, googlePayEnabled: boolean, me?: { __typename?: 'User', hasDiscountedSubtotalFromExperiment: boolean, id: string, fullName?: string | null, publicName: string, phone?: string | null, tosLastAcceptedAt?: string | null, lastOrder?: { __typename?: 'Order', id: number, deliveryAddressId: number, deliveryNotes?: string | null, phone: string, timeWindow: { __typename?: 'OrderTimeWindow', id: number } } | null, lastOrderByFulfillmentDate?: { __typename?: 'Order', timeWindowId?: number | null } | null, savedCreditCards: Array<{ __typename?: 'SavedCreditCard', id: string, lastFourDigits: number, expiresAt: string, brand: string, type: string, lastUsedAt: string }>, activeAddresses: Array<{ __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null, timeWindows: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }>, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, regionId: number } | null }> } | null, shefs: Array<{ __typename?: 'PublicShef', id: string, publicName: string, firstName?: string | null, imageUrl?: string | null, timeZone: string, celebrityEventType?: CelebrityEventType | null, shefProfile: { __typename?: 'ShefProfile', id: number, cuisineRegion?: CuisineRegion | null, fulfillmentOption?: string | null, primaryRegion?: { __typename?: 'RegionInfo', id: number } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, promoCodeType: PromoCodeType, value: number } | null, approximateLocation?: { __typename?: 'Location', latitude: number, longitude: number } | null, pickupTimeWindows: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> } }>, carts: { __typename?: 'CartResults', recentlyAdded: boolean, foodItems: Array<{ __typename?: 'CartLineItem', id: number, shefId: string, foodItemId: number, quantity: number, createdAt: string, updatedAt: string, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } }>, addOnItems: Array<{ __typename?: 'CartAddOnItem', id: number, userId: string, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string } }> }, userNotificationSettings?: Array<{ __typename?: 'UserNotificationSetting', userId: string, type: string, category: NotificationCategory, enabled: boolean }> };

export type NewAddressZipInfoQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewAddressZipInfoQuery = { __typename?: 'Query', validDaysOfWeek: Array<number>, shefProfile?: { __typename?: 'ShefProfile', pickupTimeWindows: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> } | null, zipCode?: { __typename?: 'ZipCode', zipCode: string, regionId: number, shefServesZipCode: boolean, isHubless: boolean, timeWindows: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> } | null };

export type ConsumerCheckoutExitIntentPromoCodeQueryVariables = Exact<{
  zipCode?: InputMaybe<Scalars['String']['input']>;
  shefId: Scalars['String']['input'];
  deliveryDate: Scalars['String']['input'];
  subtotal: Scalars['Int']['input'];
}>;


export type ConsumerCheckoutExitIntentPromoCodeQuery = { __typename?: 'Query', checkoutExitIntentPromoCode?: { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null };

export type RecurringSubscriptionAvailabilityQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type RecurringSubscriptionAvailabilityQuery = { __typename?: 'Query', recurringSubscriptionAvailability: { __typename?: 'RecurringSubscriptionAvailability', subscriptionOptions: Array<{ __typename?: 'SubscriptionOption', recurringPeriod: RecurringPeriod, displayText: string, promoCode?: { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null }> } };

export type EntireOrderTotalFragment = { __typename?: 'OrderTotals', subtotal: number, promoApplied: number, nonPromoDiscountApplied: number, salesTax: number, deliveryFee: number, smallOrderFee: number, remainingToRemoveSmallOrderFee: number, serviceFee: number, shefTip: number, grandTotal: number, shefTipOptions: Array<{ __typename?: 'TipOption', value: number, label: string, percent: number }> };

export type GroupOrderTotalsQueryVariables = Exact<{
  groupOrderInput: GroupOrderTotalsInput;
}>;


export type GroupOrderTotalsQuery = { __typename?: 'Query', groupOrderTotals: { __typename?: 'OrderTotals', subtotal: number, promoApplied: number, nonPromoDiscountApplied: number, salesTax: number, deliveryFee: number, smallOrderFee: number, remainingToRemoveSmallOrderFee: number, serviceFee: number, shefTip: number, grandTotal: number, shefTipOptions: Array<{ __typename?: 'TipOption', value: number, label: string, percent: number }> } };

export type ModifiedGroupOrderTotalsQueryVariables = Exact<{
  input: ConsumerModifyGroupOrderInput;
}>;


export type ModifiedGroupOrderTotalsQuery = { __typename?: 'Query', modifiedGroupOrderTotals: { __typename?: 'OrderTotals', subtotal: number, promoApplied: number, nonPromoDiscountApplied: number, salesTax: number, deliveryFee: number, smallOrderFee: number, remainingToRemoveSmallOrderFee: number, serviceFee: number, shefTip: number, grandTotal: number, shefTipOptions: Array<{ __typename?: 'TipOption', value: number, label: string, percent: number }> } };

export type MealPlanOrderSalesTaxQueryVariables = Exact<{
  mealPlanOrderSalesTaxInput: MealPlanOrderSalesTaxInput;
}>;


export type MealPlanOrderSalesTaxQuery = { __typename?: 'Query', mealPlanOrderSalesTax: { __typename?: 'MealPlanOrderSalesTax', salesTax: number } };

export type AdminCreateOrUpdateDeliveryHubMutationVariables = Exact<{
  deliveryHubInput: UpdateDeliveryHubInput;
}>;


export type AdminCreateOrUpdateDeliveryHubMutation = { __typename?: 'Mutation', createOrUpdateDeliveryHub?: { __typename?: 'UpdateDeliveryHubResult', id: number } | null };

export type GroupOrderIdForOrderQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GroupOrderIdForOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', groupOrderId: string } | null };

export type ConfigFieldsFragment = { __typename?: 'Config', id: number, type: ConfigType, name: FeatureName, value: string, overrides: Array<{ __typename?: 'ConfigOverride', id: number, segment: string, segmentValue?: string | null, value: string }> };

export type AdminListConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminListConfigsQuery = { __typename?: 'Query', allOverrideSegments: Array<string>, configs: Array<{ __typename?: 'Config', id: number, type: ConfigType, name: FeatureName, value: string, overrides: Array<{ __typename?: 'ConfigOverride', id: number, segment: string, segmentValue?: string | null, value: string }> }> };

export type AdminUpdateConfigMutationVariables = Exact<{
  name: FeatureName;
  value: Scalars['String']['input'];
  overrides: Array<ConfigOverrideInput> | ConfigOverrideInput;
}>;


export type AdminUpdateConfigMutation = { __typename?: 'Mutation', updateConfig?: { __typename?: 'Config', id: number, type: ConfigType, name: FeatureName, value: string, overrides: Array<{ __typename?: 'ConfigOverride', id: number, segment: string, segmentValue?: string | null, value: string }> } | null };

export type FoodItemAuditRequestRowFieldsFragment = { __typename?: 'FoodItemAuditRequest', id: string, auditGroupId: string, version: number, foodItemId: number, auditStatus: AuditStatus, auditFitnessScore: number, reviewFitnessScore: number, foodItem?: { __typename?: 'FoodItem', id: number, name?: string | null, user?: { __typename?: 'User', id: string, firstName: string } | null } | null, lastCommentedBy?: { __typename?: 'User', id: string, firstName: string } | null };

export type FoodItemAuditRequestsQueryVariables = Exact<{
  filterAuditStatus?: InputMaybe<AuditStatus>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FoodItemAuditRequestsQuery = { __typename?: 'Query', foodItemAuditRequests: { __typename?: 'FoodItemAuditRequestResults', auditRequests: Array<{ __typename?: 'FoodItemAuditRequest', id: string, auditGroupId: string, version: number, foodItemId: number, auditStatus: AuditStatus, auditFitnessScore: number, reviewFitnessScore: number, foodItem?: { __typename?: 'FoodItem', id: number, name?: string | null, user?: { __typename?: 'User', id: string, firstName: string } | null } | null, lastCommentedBy?: { __typename?: 'User', id: string, firstName: string } | null }>, pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number } } };

export type FoodItemAuditRequestFieldsFragment = { __typename?: 'FoodItemAuditRequest', id: string, auditGroupId: string, auditStatus: AuditStatus, foodItemChangeRequests: Array<{ __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, foodItem: { __typename?: 'FoodItem', hasUnreadComments: boolean, id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, user?: { __typename?: 'User', publicName: string } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, comments: Array<{ __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }> }>, startingFoodItem?: { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } | null, currentFoodItem: { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } };

export type FoodItemAuditRequestQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FoodItemAuditRequestQuery = { __typename?: 'Query', foodItemAuditRequest: { __typename?: 'FoodItemAuditRequest', id: string, auditGroupId: string, auditStatus: AuditStatus, foodItemChangeRequests: Array<{ __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, foodItem: { __typename?: 'FoodItem', hasUnreadComments: boolean, id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, user?: { __typename?: 'User', publicName: string } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, comments: Array<{ __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }> }>, startingFoodItem?: { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } | null, currentFoodItem: { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } }, foodItemCustomizationTypes: Array<{ __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string }> };

export type FoodItemCommentsQueryVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
}>;


export type FoodItemCommentsQuery = { __typename?: 'Query', foodItemComments: Array<{ __typename?: 'FoodItemComment', id: string, foodItemId: number, auditId?: string | null, senderId: string, commentText: string, createdAt?: string | null }> };

export type UpdateAuditStatusMutationVariables = Exact<{
  auditGroupId: Scalars['String']['input'];
  status: AuditStatus;
}>;


export type UpdateAuditStatusMutation = { __typename?: 'Mutation', updateAuditStatus: boolean };

export type BulkAddFoodItemCommentsMutationVariables = Exact<{
  comments: Array<FoodItemCommentInput> | FoodItemCommentInput;
}>;


export type BulkAddFoodItemCommentsMutation = { __typename?: 'Mutation', bulkAddFoodItemComments?: boolean | null };

export type BulkReadFoodItemCommentsForFoodItemMutationVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
}>;


export type BulkReadFoodItemCommentsForFoodItemMutation = { __typename?: 'Mutation', bulkReadFoodItemCommentsForFoodItem: boolean };

export type AdminModifyFoodItemMutationVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
  changeset: FoodItemChangesetInput;
  makeLive?: InputMaybe<Scalars['Boolean']['input']>;
  autoApproveIfPossible: Scalars['Boolean']['input'];
}>;


export type AdminModifyFoodItemMutation = { __typename?: 'Mutation', createFoodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus } };

export type MakeFoodItemNotLiveMutationVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
}>;


export type MakeFoodItemNotLiveMutation = { __typename?: 'Mutation', makeFoodItemDraftStatus: boolean };

export type PriceBreakdownQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type PriceBreakdownQuery = { __typename?: 'Query', shef: { __typename?: 'PublicShef', id: string, shefProfile: { __typename?: 'ShefProfile', id: number, platformPercent: number, fulfillmentOption?: string | null } } };

export type AdminAllChangeRequestsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  filterUserType?: InputMaybe<ChangeRequestUserTypeFilter>;
  filterChangeType?: InputMaybe<ChangeRequestChangeTypeFilter>;
  filterPhotoStatus?: InputMaybe<ChangeRequestPhotoStatusFilter>;
  filterFoodType?: InputMaybe<ChangeRequestFoodTypeFilter>;
  filterShefType?: InputMaybe<ChangeRequestShefTypeFilter>;
  filterSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminAllChangeRequestsQuery = { __typename?: 'Query', foodItemChangeRequests: { __typename?: 'FoodItemChangeRequestResults', pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number }, changeRequests: Array<{ __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, updatedAt: string, foodItem: { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, user: { __typename?: 'User', id: string, firstName: string, shefStatus: ShefStatus }, lastUpdatedBy: { __typename?: 'User', id: string, firstName: string }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }> }> } };

export type AdminApproveChangeRequestMutationVariables = Exact<{
  foodItemChangeRequestId: Scalars['Int']['input'];
  changeset?: InputMaybe<FoodItemChangesetInput>;
  comment: Scalars['String']['input'];
}>;


export type AdminApproveChangeRequestMutation = { __typename?: 'Mutation', updateFoodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus } };

export type AdminRejectChangeRequestMutationVariables = Exact<{
  foodItemChangeRequestId: Scalars['Int']['input'];
  changeset?: InputMaybe<FoodItemChangesetInput>;
  comment: Scalars['String']['input'];
}>;


export type AdminRejectChangeRequestMutation = { __typename?: 'Mutation', updateFoodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus } };

export type AdminBulkUpdatePhotoEditingStatusMutationVariables = Exact<{
  foodItemChangeRequestIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  status?: InputMaybe<RequestStatus>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminBulkUpdatePhotoEditingStatusMutation = { __typename?: 'Mutation', adminBulkUpdateFoodItemChangeRequests: Array<{ __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus }> };

export type AdminUpdatePhotoEditingStatusMutationVariables = Exact<{
  foodItemChangeRequestId: Scalars['Int']['input'];
  status?: InputMaybe<RequestStatus>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUpdatePhotoEditingStatusMutation = { __typename?: 'Mutation', updateFoodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus } };

export type FoodItemQueryQueryVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
}>;


export type FoodItemQueryQuery = { __typename?: 'Query', foodItem: { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, user?: { __typename?: 'User', id: string, publicName: string, fullName?: string | null, shefProfile?: { __typename?: 'ShefProfile', id: number, cuisineRegion?: CuisineRegion | null, cuisineCategoryIds: Array<string>, primaryRegion?: { __typename?: 'RegionInfo', id: number } | null } | null } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, foodItemCustomizationTypes: Array<{ __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string }> };

export type PhotoEditQueryVariables = Exact<{ [key: string]: never; }>;


export type PhotoEditQuery = { __typename?: 'Query', dishwasherApiUrl?: string | null };

export type DeleteFoodItemMutationVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
}>;


export type DeleteFoodItemMutation = { __typename?: 'Mutation', deleteFoodItem: boolean };

export type ChangesetViewFragment = { __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null };

export type ChangeRequestViewFragment = { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, foodItem: { __typename?: 'FoodItem', hasUnreadComments: boolean, id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, user?: { __typename?: 'User', publicName: string } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, comments: Array<{ __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }> };

export type ChangeRequestQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ChangeRequestQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } | null, foodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, updatedAt: string, foodItem: { __typename?: 'FoodItem', hasUnreadComments: boolean, id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, user?: { __typename?: 'User', publicName: string } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, comments: Array<{ __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }>, lastUpdatedBy: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }, photoEditRequest?: { __typename?: 'PhotoEditRequest', id: string, editedImageUrl?: string | null, editorUserId?: string | null } | null, foodItemCustomizationTypes: Array<{ __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string }> };

export type UpdateChangeRequestMutationVariables = Exact<{
  foodItemChangeRequestId: Scalars['Int']['input'];
  changeset?: InputMaybe<FoodItemChangesetInput>;
  comment: Scalars['String']['input'];
  autoApproveIfPossible?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateChangeRequestMutation = { __typename?: 'Mutation', updateFoodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus } };

export type ChangeRequestCommentThreadFragment = { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, updatedAt: string, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, comments: Array<{ __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }>, lastUpdatedBy: { __typename?: 'User', publicName: string, imageUrl: string, id: string } };

export type CustomizationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomizationTypesQuery = { __typename?: 'Query', foodItemCustomizationTypes: Array<{ __typename?: 'FoodItemCustomizationType', category: CustomizationCategory, id: string, name: string }> };

export type CuisineCategoriesQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type CuisineCategoriesQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', id: number, shef: { __typename?: 'PublicShef', id: string, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null, name?: string | null, foodType?: FoodType | null, pairings: Array<{ __typename?: 'FoodItem', id: number }> }> } } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> };

export type DietaryAnalysisQueryVariables = Exact<{
  ingredients: Scalars['String']['input'];
}>;


export type DietaryAnalysisQuery = { __typename?: 'Query', dietaryAnalysis?: { __typename?: 'DietaryAnalysis', vegan?: boolean | null, vegetarian?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, whole30?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsNuts?: boolean | null } | null };

export type FoodItemCustomizationTypeFieldsFragment = { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string };

export type FoodItemCustomizationFieldsFragment = { __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } };

export type EditableFoodItemFragment = { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null };

export type PriceRecommendationQueryVariables = Exact<{
  foodItemInput: FoodItemPriceRecommendationInput;
}>;


export type PriceRecommendationQuery = { __typename?: 'Query', foodItemPriceRecommendations: { __typename?: 'FoodItemPriceRecommendationResult', recommendedPrice: number, lowerPriceRange: number, upperPriceRange: number } };

export type GetPrefabFoodItemQueryVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
}>;


export type GetPrefabFoodItemQuery = { __typename?: 'Query', foodItem: { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } };

export type FoodItemSuggestionsQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FoodItemSuggestionsQuery = { __typename?: 'Query', foodItemSuggestions: Array<{ __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }> };

export type FoodItemEditNewQueryVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
}>;


export type FoodItemEditNewQuery = { __typename?: 'Query', foodItem: { __typename?: 'FoodItem', slug: string, hasUnreadComments: boolean, id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, mostRecentOpenChangeRequest?: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, updatedAt: string, foodItem: { __typename?: 'FoodItem', hasUnreadComments: boolean, id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, user?: { __typename?: 'User', publicName: string } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, comments: Array<{ __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }>, lastUpdatedBy: { __typename?: 'User', publicName: string, imageUrl: string, id: string } } | null, user?: { __typename?: 'User', id: string, shefProfile?: { __typename?: 'ShefProfile', id: number, cuisineRegion?: CuisineRegion | null, cuisineCategoryIds: Array<string>, primaryRegion?: { __typename?: 'RegionInfo', id: number } | null } | null } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, foodItemCustomizationTypes: Array<{ __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string }> };

export type ShefCreateChangeRequestMutationVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
  changeset: FoodItemChangesetInput;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShefCreateChangeRequestMutation = { __typename?: 'Mutation', createFoodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus } };

export type ShefUpdateChangeRequestMutationVariables = Exact<{
  foodItemChangeRequestId: Scalars['Int']['input'];
  changeset?: InputMaybe<FoodItemChangesetInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShefUpdateChangeRequestMutation = { __typename?: 'Mutation', updateFoodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus } };

export type ShefAbandonChangeRequestMutationVariables = Exact<{
  foodItemChangeRequestId: Scalars['Int']['input'];
  changeset?: InputMaybe<FoodItemChangesetInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShefAbandonChangeRequestMutation = { __typename?: 'Mutation', updateFoodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus } };

export type FoodItemTableFoodItemFragment = { __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, status: FoodItemStatus, numDaysBeforeExpires: number, portion?: string | null, servingSize?: string | null, holiday?: Holiday | null, hasUnreadComments: boolean, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, prepInstructions?: string | null, numLabels?: number | null, spiceLevel: number, user?: { __typename?: 'User', id: string, imageUrl: string, publicName: string } | null, mostRecentOpenChangeRequest?: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, foodItem: { __typename?: 'FoodItem', hasUnreadComments: boolean, id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, user?: { __typename?: 'User', publicName: string } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, comments: Array<{ __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }> } | null, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null };

export type ShefModifyFoodItemMutationVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
  changeset: FoodItemChangesetInput;
}>;


export type ShefModifyFoodItemMutation = { __typename?: 'Mutation', createFoodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus } };

export type AddFoodItemMutationVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type AddFoodItemMutation = { __typename?: 'Mutation', addFoodItem: { __typename?: 'FoodItem', id: number } };

export type ModifyFoodItemHolidayMenuMutationVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
  holiday?: InputMaybe<Holiday>;
}>;


export type ModifyFoodItemHolidayMenuMutation = { __typename?: 'Mutation', modifyFoodItemHolidayMenu: boolean };

export type ShefOrderLabelsOrdersFragment = { __typename?: 'Order', id: number, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, deliveryOrderNumber?: number | null, orderStatus: OrderStatus, deliveryNotes?: string | null, orderType: OrderType, createdAt: string, userId: string, phone: string, isFirstOrder: boolean, deliveryType: string, isReusablePackaging: boolean, address: { __typename?: 'Address', id: number, name?: string | null, company?: string | null, street: string, unit?: string | null, city: string, province: string, zipCode: string, country: string, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, orderLabelCode?: string | null, hasMilkmanRecycling: boolean, region: { __typename?: 'RegionInfo', name: string } } | null }, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number }, pickupDeliveryHub?: { __typename?: 'DeliveryHub', code: string } | null, user: { __typename?: 'User', id: string, fullName?: string | null, firstName: string, lastName: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, name: string, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, numLabels?: number | null, servingSize?: string | null, spiceLevel: number, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, shefProfile: { __typename?: 'ShefProfile', id: number, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, gsinEnabledAt?: string | null } | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null } };

export type ShefOrderLabelsShefFragment = { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, bio?: string | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null }, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null }> };

export type ShefOrderLabelsQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  deliveryDateString: Scalars['String']['input'];
}>;


export type ShefOrderLabelsQuery = { __typename?: 'Query', ordersByDate: Array<{ __typename?: 'Order', id: number, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, deliveryOrderNumber?: number | null, orderStatus: OrderStatus, deliveryNotes?: string | null, orderType: OrderType, createdAt: string, userId: string, phone: string, isFirstOrder: boolean, deliveryType: string, isReusablePackaging: boolean, address: { __typename?: 'Address', id: number, name?: string | null, company?: string | null, street: string, unit?: string | null, city: string, province: string, zipCode: string, country: string, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, orderLabelCode?: string | null, hasMilkmanRecycling: boolean, region: { __typename?: 'RegionInfo', name: string } } | null }, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number }, pickupDeliveryHub?: { __typename?: 'DeliveryHub', code: string } | null, user: { __typename?: 'User', id: string, fullName?: string | null, firstName: string, lastName: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, name: string, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, numLabels?: number | null, servingSize?: string | null, spiceLevel: number, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, shefProfile: { __typename?: 'ShefProfile', id: number, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, gsinEnabledAt?: string | null } | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null } }>, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, bio?: string | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null }, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null }> } };

export type SingleOrderLabelQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type SingleOrderLabelQuery = { __typename?: 'Query', order?: { __typename?: 'Order', deliveryDate: string, id: number, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, deliveryOrderNumber?: number | null, orderStatus: OrderStatus, deliveryNotes?: string | null, orderType: OrderType, createdAt: string, userId: string, phone: string, isFirstOrder: boolean, deliveryType: string, isReusablePackaging: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, bio?: string | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null }, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null }> }, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, gsinEnabledAt?: string | null } | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null }, address: { __typename?: 'Address', id: number, name?: string | null, company?: string | null, street: string, unit?: string | null, city: string, province: string, zipCode: string, country: string, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, orderLabelCode?: string | null, hasMilkmanRecycling: boolean, region: { __typename?: 'RegionInfo', name: string } } | null }, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number }, pickupDeliveryHub?: { __typename?: 'DeliveryHub', code: string } | null, user: { __typename?: 'User', id: string, fullName?: string | null, firstName: string, lastName: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, name: string, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, numLabels?: number | null, servingSize?: string | null, spiceLevel: number, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }> } | null };

export type SingleGroupOrderLabelQueryVariables = Exact<{
  groupOrderId: Scalars['String']['input'];
}>;


export type SingleGroupOrderLabelQuery = { __typename?: 'Query', groupOrdersByIds: Array<{ __typename?: 'GroupOrder', dayOfEmailScheduledTaskId?: number | null, deliveryAddressId: number, deliveryNotes?: string | null, isCancelled: boolean, isFullyRefunded: boolean, pickupAddressId?: number | null, pickupDeliveryId?: number | null, phone: string, timeWindowId?: number | null, subscriptionInvoiceId?: string | null, orderNumber?: number | null, id: string, uuid: string, userId: string, deliveryDate: string, deliveryType: string, orderType: OrderType, orders: Array<{ __typename?: 'Order', isReusablePackaging: boolean, isFirstOrder: boolean, orderType: OrderType, deliveryType: string, shefTip?: number | null, salesTax: number, serviceFee: number, deliveryFee: number, grandTotal: number, platformFee: number, shefPayment: number, reversedShefPaymentAmount: number, discountApplied: number, platformPayment: number, currency: string, deliveryAddressId: number, transactionId?: string | null, refundId?: string | null, refundTimestamp?: string | null, cancelledAt?: string | null, createdAt: string, notes?: string | null, deliveryNotes?: string | null, phone: string, fulfillmentDate: string, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, name: string, foodItemId: number, quantity: number, price: number, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, numLabels?: number | null, servingSize?: string | null, spiceLevel: number, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, address: { __typename?: 'Address', id: number, name?: string | null, company?: string | null, street: string, unit?: string | null, city: string, province: string, zipCode: string, country: string, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, orderLabelCode?: string | null, hasMilkmanRecycling: boolean, region: { __typename?: 'RegionInfo', name: string } } | null }, pickupDeliveryHub?: { __typename?: 'DeliveryHub', code: string } | null, delivery?: { __typename?: 'Delivery', id: string, externalId?: string | null } | null, user: { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null }, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null }, shefProfile: { __typename?: 'ShefProfile', id: number, mehkoLicenseNumber?: string | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, gsinEnabledAt?: string | null, name: string } | null }, promoCode?: { __typename?: 'PromoCode', code: string, isPercentage: boolean, promoCodeType: PromoCodeType, value: number } | null }> }> };

export type AdminFoodItemsQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminFoodItemsQuery = { __typename?: 'Query', adminFoodItems: { __typename?: 'FoodItemResults', foodItems: Array<{ __typename?: 'FoodItem', id: number, userId: string, name?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, imageUrl?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, endDate: string, startDate: string, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, packaging: Packaging, status: FoodItemStatus, portion?: string | null, servingSize?: string | null, holiday?: Holiday | null, hasUnreadComments: boolean, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, numLabels?: number | null, user?: { __typename?: 'User', id: string, fullName?: string | null, firstName: string, imageUrl: string, publicName: string } | null, mostRecentOpenChangeRequest?: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, foodItem: { __typename?: 'FoodItem', hasUnreadComments: boolean, id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, user?: { __typename?: 'User', publicName: string } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, comments: Array<{ __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }> } | null, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }>, pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number } } };

export type AdminOrderLabelsOrderFieldsFragment = { __typename?: 'Order', isReusablePackaging: boolean, isFirstOrder: boolean, orderType: OrderType, deliveryType: string, shefTip?: number | null, salesTax: number, serviceFee: number, deliveryFee: number, grandTotal: number, platformFee: number, shefPayment: number, reversedShefPaymentAmount: number, discountApplied: number, platformPayment: number, currency: string, deliveryAddressId: number, transactionId?: string | null, refundId?: string | null, refundTimestamp?: string | null, cancelledAt?: string | null, createdAt: string, notes?: string | null, deliveryNotes?: string | null, phone: string, fulfillmentDate: string, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, name: string, foodItemId: number, quantity: number, price: number, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, numLabels?: number | null, servingSize?: string | null, spiceLevel: number, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, address: { __typename?: 'Address', id: number, name?: string | null, company?: string | null, street: string, unit?: string | null, city: string, province: string, zipCode: string, country: string, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, orderLabelCode?: string | null, hasMilkmanRecycling: boolean, region: { __typename?: 'RegionInfo', name: string } } | null }, pickupDeliveryHub?: { __typename?: 'DeliveryHub', code: string } | null, delivery?: { __typename?: 'Delivery', id: string, externalId?: string | null } | null, user: { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null }, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null }, shefProfile: { __typename?: 'ShefProfile', id: number, mehkoLicenseNumber?: string | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, gsinEnabledAt?: string | null, name: string } | null }, promoCode?: { __typename?: 'PromoCode', code: string, isPercentage: boolean, promoCodeType: PromoCodeType, value: number } | null };

export type AdminOrderLabelFieldsFragment = { __typename?: 'GroupOrder', dayOfEmailScheduledTaskId?: number | null, deliveryAddressId: number, deliveryNotes?: string | null, isCancelled: boolean, isFullyRefunded: boolean, pickupAddressId?: number | null, pickupDeliveryId?: number | null, phone: string, timeWindowId?: number | null, subscriptionInvoiceId?: string | null, orderNumber?: number | null, id: string, uuid: string, userId: string, deliveryDate: string, deliveryType: string, orderType: OrderType, orders: Array<{ __typename?: 'Order', isReusablePackaging: boolean, isFirstOrder: boolean, orderType: OrderType, deliveryType: string, shefTip?: number | null, salesTax: number, serviceFee: number, deliveryFee: number, grandTotal: number, platformFee: number, shefPayment: number, reversedShefPaymentAmount: number, discountApplied: number, platformPayment: number, currency: string, deliveryAddressId: number, transactionId?: string | null, refundId?: string | null, refundTimestamp?: string | null, cancelledAt?: string | null, createdAt: string, notes?: string | null, deliveryNotes?: string | null, phone: string, fulfillmentDate: string, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, name: string, foodItemId: number, quantity: number, price: number, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, numLabels?: number | null, servingSize?: string | null, spiceLevel: number, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, address: { __typename?: 'Address', id: number, name?: string | null, company?: string | null, street: string, unit?: string | null, city: string, province: string, zipCode: string, country: string, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, orderLabelCode?: string | null, hasMilkmanRecycling: boolean, region: { __typename?: 'RegionInfo', name: string } } | null }, pickupDeliveryHub?: { __typename?: 'DeliveryHub', code: string } | null, delivery?: { __typename?: 'Delivery', id: string, externalId?: string | null } | null, user: { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null }, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null }, shefProfile: { __typename?: 'ShefProfile', id: number, mehkoLicenseNumber?: string | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, gsinEnabledAt?: string | null, name: string } | null }, promoCode?: { __typename?: 'PromoCode', code: string, isPercentage: boolean, promoCodeType: PromoCodeType, value: number } | null }> };

export type AdminOrderLabelsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  deliveryHubIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminOrderLabelsQuery = { __typename?: 'Query', adminGroupOrders: { __typename?: 'GroupOrderResults', pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number }, groupOrders: Array<{ __typename?: 'GroupOrder', dayOfEmailScheduledTaskId?: number | null, deliveryAddressId: number, deliveryNotes?: string | null, isCancelled: boolean, isFullyRefunded: boolean, pickupAddressId?: number | null, pickupDeliveryId?: number | null, phone: string, timeWindowId?: number | null, subscriptionInvoiceId?: string | null, orderNumber?: number | null, id: string, uuid: string, userId: string, deliveryDate: string, deliveryType: string, orderType: OrderType, orders: Array<{ __typename?: 'Order', isReusablePackaging: boolean, isFirstOrder: boolean, orderType: OrderType, deliveryType: string, shefTip?: number | null, salesTax: number, serviceFee: number, deliveryFee: number, grandTotal: number, platformFee: number, shefPayment: number, reversedShefPaymentAmount: number, discountApplied: number, platformPayment: number, currency: string, deliveryAddressId: number, transactionId?: string | null, refundId?: string | null, refundTimestamp?: string | null, cancelledAt?: string | null, createdAt: string, notes?: string | null, deliveryNotes?: string | null, phone: string, fulfillmentDate: string, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, name: string, foodItemId: number, quantity: number, price: number, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, numLabels?: number | null, servingSize?: string | null, spiceLevel: number, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, address: { __typename?: 'Address', id: number, name?: string | null, company?: string | null, street: string, unit?: string | null, city: string, province: string, zipCode: string, country: string, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, orderLabelCode?: string | null, hasMilkmanRecycling: boolean, region: { __typename?: 'RegionInfo', name: string } } | null }, pickupDeliveryHub?: { __typename?: 'DeliveryHub', code: string } | null, delivery?: { __typename?: 'Delivery', id: string, externalId?: string | null } | null, user: { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null }, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null }, shefProfile: { __typename?: 'ShefProfile', id: number, mehkoLicenseNumber?: string | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, gsinEnabledAt?: string | null, name: string } | null }, promoCode?: { __typename?: 'PromoCode', code: string, isPercentage: boolean, promoCodeType: PromoCodeType, value: number } | null }> }> } };

export type DeliveryHubsQueryVariables = Exact<{ [key: string]: never; }>;


export type DeliveryHubsQuery = { __typename?: 'Query', deliveryHubs: Array<{ __typename?: 'DeliveryHub', id: number, code: string, name: string, street: string, city: string, province: string, unit?: string | null, pickupInstructions: string, zipCode: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null }> };

export type AdminGroupOrderFieldsFragment = { __typename?: 'GroupOrder', id: string, formattedId: string, createdAt: string, deliveryDate: string, deliveryType: string, cancelledAt?: string | null, skippedAt?: string | null, phone: string, isFullyRefunded: boolean, isPartiallyRefunded: boolean, user: { __typename?: 'User', id: string, publicName: string, fullName?: string | null }, orders: Array<{ __typename?: 'Order', id: number, shefId: string }>, delivery?: { __typename?: 'Delivery', id: string, externalId?: string | null } | null, orderTotals: { __typename?: 'ConsumerOrderTotal', deliveryFee: number, promoApplied: number, nonPromoDiscountApplied: number, grandTotal: number, refund: number, salesTax: number, serviceFee: number, shefTip: number, refundableBalance: number, promoBalance: number } };

export type AdminGroupOrdersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminGroupOrdersQuery = { __typename?: 'Query', adminGroupOrders: { __typename?: 'GroupOrderResults', pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number }, groupOrders: Array<{ __typename?: 'GroupOrder', id: string, formattedId: string, createdAt: string, deliveryDate: string, deliveryType: string, cancelledAt?: string | null, skippedAt?: string | null, phone: string, isFullyRefunded: boolean, isPartiallyRefunded: boolean, user: { __typename?: 'User', id: string, publicName: string, fullName?: string | null }, orders: Array<{ __typename?: 'Order', id: number, shefId: string }>, delivery?: { __typename?: 'Delivery', id: string, externalId?: string | null } | null, orderTotals: { __typename?: 'ConsumerOrderTotal', deliveryFee: number, promoApplied: number, nonPromoDiscountApplied: number, grandTotal: number, refund: number, salesTax: number, serviceFee: number, shefTip: number, refundableBalance: number, promoBalance: number } }> } };

export type AdminGroupOrderEditQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminGroupOrderEditQuery = { __typename?: 'Query', groupOrdersByIds: Array<{ __typename?: 'GroupOrder', id: string, formattedId: string, userId: string, phone: string, deliveryAddressId: number, pickupAddressId?: number | null, createdAt: string, cancelledAt?: string | null, skippedAt?: string | null, deliveryDate: string, orderType: OrderType, deliveryNotes?: string | null, deliveryType: string, timeWindowId?: number | null, isFullyRefunded: boolean, isPartiallyRefunded: boolean, user: { __typename?: 'User', id: string, flakeId: string, publicName: string, email: string, activeAddresses: Array<{ __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null }> }, refunds: Array<{ __typename?: 'Refund', id: string, orderId?: number | null, createdAt: string, refundType: string, refundReason: string, notes?: string | null }>, delivery?: { __typename?: 'Delivery', externalId?: string | null, type?: string | null, fee?: number | null } | null, pickupAddress?: { __typename?: 'Address', id: number, formattedAddress?: string | null } | null, deliveryAddress: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, timeZone: string, region: { __typename?: 'RegionInfo', id: number, name: string } } | null }, orders: Array<{ __typename?: 'Order', id: number, shefId: string, grandTotal: number, promoCode?: { __typename?: 'PromoCode', code: string, isPercentage: boolean, promoCodeType: PromoCodeType, value: number } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, name: string, quantity: number, price: number, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, price: number, imageUrl?: string | null } }> }>, timeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, transactions: Array<{ __typename?: 'Transaction', id: string, type: string, status: string, createdAt: string, statusChangedAt?: string | null, transactionLineItems: Array<{ __typename?: 'TransactionLineItem', id: string, type: string, amount: number }> }>, orderTotals: { __typename?: 'ConsumerOrderTotal', deliveryFee: number, promoApplied: number, nonPromoDiscountApplied: number, grandTotal: number, refund: number, salesTax: number, serviceFee: number, shefTip: number, smallOrderFee: number, subtotal: number, refundableBalance: number, promoBalance: number } }>, timeWindowsForGroupOrder: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> };

export type AdminModifyGroupOrderMutationMutationVariables = Exact<{
  input: AdminModifyGroupOrderInput;
}>;


export type AdminModifyGroupOrderMutationMutation = { __typename?: 'Mutation', adminModifyGroupOrder: { __typename?: 'GroupOrder', id: string, timeWindowId?: number | null, phone: string, deliveryDate: string, deliveryAddressId: number } };

export type AdminRefundGroupOrderMutationMutationVariables = Exact<{
  input: GroupOrderLevelRefundInput;
}>;


export type AdminRefundGroupOrderMutationMutation = { __typename?: 'Mutation', refundGroupOrder2: { __typename?: 'GroupOrder', id: string } };

export type AdminAddGroupOrderMutationMutationVariables = Exact<{
  input: GroupOrderInput;
}>;


export type AdminAddGroupOrderMutationMutation = { __typename?: 'Mutation', adminAddGroupOrder: { __typename?: 'AdminAddGroupOrderResult', message: string, success: boolean } };

export type DisablePromoButtonMutationVariables = Exact<{
  promoCodeId: Scalars['Int']['input'];
}>;


export type DisablePromoButtonMutation = { __typename?: 'Mutation', disablePromoCode: { __typename?: 'PromoCode', id: number, disabled: boolean, disabledAt?: string | null } };

export type UpdateExplorePagePromoToggleMutationVariables = Exact<{
  shefId: Scalars['String']['input'];
  promoCodeId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateExplorePagePromoToggleMutation = { __typename?: 'Mutation', updateExplorePagePromoCode?: Array<{ __typename?: 'PromoCode', id: number, isExplorePagePromo: boolean } | null> | null };

export type AdminConsumersQueryQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminConsumersQueryQuery = { __typename?: 'Query', adminUsers?: { __typename?: 'AdminUserResults', pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number }, users: Array<{ __typename?: 'User', email: string, lastOrderPhoneNumber?: string | null, imageUrl: string, createdAt: string, shefStatus: ShefStatus, id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null, shefApplication?: { __typename?: 'ShefApplication', id: number } | null }> } | null };

export type FoodHandlerShefFragment = { __typename?: 'User', id: string, fullName?: string | null, admin: boolean, shefProfile?: { __typename?: 'ShefProfile', id: number, foodHandlersCertificate?: string | null, fhcUploadedAt?: string | null, fhcApprovedAt?: string | null } | null };

export type AdminFoodhandlersQueryVariables = Exact<{
  idFilter?: InputMaybe<Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminFoodhandlersQuery = { __typename?: 'Query', adminShefFoodhandlers?: { __typename?: 'AdminShefFoodhandlersResults', pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number }, shefs: Array<{ __typename?: 'User', id: string, fullName?: string | null, admin: boolean, shefProfile?: { __typename?: 'ShefProfile', id: number, foodHandlersCertificate?: string | null, fhcUploadedAt?: string | null, fhcApprovedAt?: string | null } | null }> } | null };

export type ApproveFhcMutationVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ApproveFhcMutation = { __typename?: 'Mutation', approveFoodHandlerCertificate: boolean };

export type AdminShefTotalsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AdminShefTotalsQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', id: number, timeZone: string } | null };

export type AdminShefsQueryQueryVariables = Exact<{
  shefStatus?: InputMaybe<ShefStatus>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminShefsQueryQuery = { __typename?: 'Query', adminShefs?: { __typename?: 'AdminShefResults', pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number }, shefs: Array<{ __typename?: 'User', id: string, fullName?: string | null, imageUrl: string, foodItemCount?: number | null, shefApplication?: { __typename?: 'ShefApplication', id: number } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, email?: string | null, formattedAddress?: string | null, phone?: string | null, bio?: string | null, notes?: string | null, dishCapacity: number, primaryRegion?: { __typename?: 'RegionInfo', displayName: string } | null } | null }> } | null };

export type AdminUserQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AdminUserQueryQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email: string, publicName: string, firstName: string, lastName: string, fullName?: string | null, createdAt: string, imageUrl: string, videoUrl?: string | null, banned: boolean, banReason?: string | null, bannedAt?: string | null, groupOrders?: Array<{ __typename?: 'GroupOrder', id: string, formattedId: string, createdAt: string, deliveryDate: string, deliveryType: string, cancelledAt?: string | null, skippedAt?: string | null, phone: string, isFullyRefunded: boolean, isPartiallyRefunded: boolean, user: { __typename?: 'User', id: string, publicName: string, fullName?: string | null }, orders: Array<{ __typename?: 'Order', id: number, shefId: string }>, delivery?: { __typename?: 'Delivery', id: string, externalId?: string | null } | null, orderTotals: { __typename?: 'ConsumerOrderTotal', deliveryFee: number, promoApplied: number, nonPromoDiscountApplied: number, grandTotal: number, refund: number, salesTax: number, serviceFee: number, shefTip: number, refundableBalance: number, promoBalance: number } }> | null } | null };

export type AdminUserResetPasswordMutationMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type AdminUserResetPasswordMutationMutation = { __typename?: 'Mutation', adminResetPassword: { __typename?: 'User', id: string } };

export type AdminDeleteUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  confirmationCode: Scalars['String']['input'];
}>;


export type AdminDeleteUserMutation = { __typename?: 'Mutation', adminDeleteUser: { __typename?: 'User', id: string } };

export type AdminImpersonateUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AdminImpersonateUserMutation = { __typename?: 'Mutation', adminImpersonateUser: { __typename?: 'AuthResult', token: string, isExistingUser: boolean, isImpersonatedUser?: boolean | null, user: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } } };

export type AdminBanUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type AdminBanUserMutation = { __typename?: 'Mutation', adminBanUser: boolean };

export type AdminUnbanUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AdminUnbanUserMutation = { __typename?: 'Mutation', adminUnbanUser: boolean };

export type RegionListFragmentFragment = { __typename?: 'RegionInfo', id: number, name: string };

export type CuisineCategoryItemFragment = { __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType, isPrimary: boolean };

export type AdminShefProfileQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AdminShefProfileQueryQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', foodHandlersCertificate?: string | null, cuisineCategoryIds: Array<string>, id: number, userId: string, email?: string | null, phone?: string | null, bio?: string | null, notes?: string | null, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, youtubeHandle?: string | null, specialty?: string | null, coverPhotoUrl?: string | null, videoUrl?: string | null, cuisineRegion?: CuisineRegion | null, featureShef?: boolean | null, trialStatus?: TrialStatus | null, dishCapacity: number, maxDishCapacity: number, shefAddressId?: number | null, previewFoodItemId?: number | null, cutoffMsBeforeDeliveryDate: number, fhcExpiresAt?: string | null, fhcUploadedAt?: string | null, fhcUploadRequiredBy?: string | null, newOrderNotificationFrequency?: NewOrderNotificationFrequency | null, cancelOrderNotificationFrequency?: CancelOrderNotificationFrequency | null, setBadQualityAt?: string | null, onboardingFormAnsweredAt?: string | null, fulfillmentOption?: string | null, isHubless: boolean, geographyAllowsCuisineType: boolean, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, user: { __typename?: 'User', publicName: string, createdAt: string, id: string, fullName?: string | null, email: string, shefStatus: ShefStatus, firstName: string, lastName: string, imageUrl: string, activeAddresses: Array<{ __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null }>, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number, stripeUserId?: string | null, userId: string, accountType: StripeAccountType, dashboardLoginLink?: string | null, createdAt: string, currentBalance?: { __typename?: 'ShefStripeConnectBalance', available: number, pending: number } | null } | null }, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, name: string, street: string, city: string, province: string, unit?: string | null, pickupInstructions: string, zipCode: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null } | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType, isPrimary: boolean }>, possibleDeliveryHubsForShef: Array<{ __typename?: 'DeliveryHub', id: number, name: string, street: string, city: string, province: string, unit?: string | null, pickupInstructions: string, zipCode: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null }> };

export type ViewChangeRequestFragment = { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, updatedAt: string, foodItem: { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, user: { __typename?: 'User', id: string, firstName: string, shefStatus: ShefStatus }, lastUpdatedBy: { __typename?: 'User', id: string, firstName: string }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }> };

export type FhcInfoQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type FhcInfoQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', fhcExpiresAt?: string | null } | null };

export type AvailabilityOrderFieldsFragment = { __typename?: 'Order', deliveryDate: string, fulfillmentDate: string, orderStatus: OrderStatus };

export type ShefHubInfoFragment = { __typename?: 'ShefProfile', defaultDropoffHub?: { __typename?: 'DeliveryHub', name: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null } | null };

export type ShefAvailabilityQueryQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  currentDate: Scalars['String']['input'];
}>;


export type ShefAvailabilityQueryQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', approvedAt?: string | null, timeZone: string, cutoffMsBeforeDeliveryDate: number, maxDishCapacity: number, isTrialShef: boolean, primaryRegion?: { __typename?: 'RegionInfo', mondayDelivery: boolean, tuesdayDelivery: boolean, wednesdayDelivery: boolean, thursdayDelivery: boolean, fridayDelivery: boolean, saturdayDelivery: boolean, sundayDelivery: boolean, deliveryEnabledAt: string, name: string } | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', name: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null } | null } | null, shefAvailability: Array<{ __typename?: 'ShefAvailability', id: number, availabilityDate: string, shefId: string } | null>, orders: { __typename?: 'ConsumerOrderResults', orders: Array<{ __typename?: 'Order', deliveryDate: string, fulfillmentDate: string, orderStatus: OrderStatus }> }, shefAvailabilityRules: Array<{ __typename?: 'ShefAvailabilityRule', id: string, recurrenceRule: string, isAvailable: boolean, durationInMs: number, dateRange: { __typename?: 'DateRange', begin?: string | null, end?: string | null, bounds: string } }>, shefUnavailabilityRules: Array<{ __typename?: 'ShefAvailabilityRule', id: string, recurrenceRule: string, isAvailable: boolean, durationInMs: number, dateRange: { __typename?: 'DateRange', begin?: string | null, end?: string | null, bounds: string } }>, shefDaysOfWeekAvailabilityRule?: { __typename?: 'ShefAvailabilityRule', id: string, isPast?: boolean | null, daysOfWeek?: { __typename?: 'ShefAvailabilityRuleDaysOfWeek', monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean, sunday: boolean } | null } | null };

export type ModifyShefAvailabilityRulesMutationMutationVariables = Exact<{
  shefId: Scalars['String']['input'];
  daysOfWeek?: InputMaybe<ShefAvailabilityRuleDaysOfWeekInput>;
  add?: InputMaybe<Array<ShefAvailabilityRuleInput> | ShefAvailabilityRuleInput>;
  end?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  unavailableDates?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ModifyShefAvailabilityRulesMutationMutation = { __typename?: 'Mutation', modifyShefAvailabilityRules?: boolean | null };

export type OrderBreakdownFragment = { __typename?: 'Order', id: number, orderStatus: OrderStatus, orderType: OrderType, subtotal: number, addOnItemsTotal: number, grandTotal: number, shefTip?: number | null, shefPayment: number, deliveryNotes?: string | null, deliveryType: string, createdAt: string, userId: string, refundReason?: string | null, refundAmount?: number | null, reversedShefPaymentAmount: number, isReusablePackaging: boolean, refundType?: RefundType | null, numOrdersFromShef: number, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, correctedRefundReason?: string | null, correctedRefundType?: RefundType | null, address: { __typename?: 'Address', id: number, zipCode: string, name?: string | null }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, foodItemId: number, quantity: number, name: string, price: number, foodItem: { __typename?: 'FoodItem', name?: string | null, portion?: string | null, servingSize?: string | null, spiceLevel: number }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, portion?: string | null, priceFactor: number, priceFactorType: PriceFactorType, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, shefFulfillmentTimeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, user: { __typename?: 'User', id: string, flakeId: string, publicName: string, fullName: string } };

export type ShefOrderBreakdownsQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  deliveryDateString: Scalars['String']['input'];
  includeRefunded: Scalars['Boolean']['input'];
}>;


export type ShefOrderBreakdownsQuery = { __typename?: 'Query', ordersByDate: Array<{ __typename?: 'Order', id: number, orderStatus: OrderStatus, orderType: OrderType, subtotal: number, addOnItemsTotal: number, grandTotal: number, shefTip?: number | null, shefPayment: number, deliveryNotes?: string | null, deliveryType: string, createdAt: string, userId: string, refundReason?: string | null, refundAmount?: number | null, reversedShefPaymentAmount: number, isReusablePackaging: boolean, refundType?: RefundType | null, numOrdersFromShef: number, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, correctedRefundReason?: string | null, correctedRefundType?: RefundType | null, promoCode?: { __typename?: 'PromoCode', code: string, isPercentage: boolean, promoCodeType: PromoCodeType, value: number } | null, address: { __typename?: 'Address', id: number, zipCode: string, name?: string | null }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, foodItemId: number, quantity: number, name: string, price: number, foodItem: { __typename?: 'FoodItem', name?: string | null, portion?: string | null, servingSize?: string | null, spiceLevel: number }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, portion?: string | null, priceFactor: number, priceFactorType: PriceFactorType, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, shefFulfillmentTimeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, user: { __typename?: 'User', id: string, flakeId: string, publicName: string, fullName: string } }>, shef: { __typename?: 'PublicShef', id: string, shefProfile: { __typename?: 'ShefProfile', id: number, cutoffMsBeforeDeliveryDate: number } } };

export type ShefOrderBreakdownsByFulfillmentDateQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  fulfillmentDate: Scalars['String']['input'];
  includeRefunded: Scalars['Boolean']['input'];
}>;


export type ShefOrderBreakdownsByFulfillmentDateQuery = { __typename?: 'Query', ordersByDate: Array<{ __typename?: 'Order', id: number, orderStatus: OrderStatus, orderType: OrderType, subtotal: number, addOnItemsTotal: number, grandTotal: number, shefTip?: number | null, shefPayment: number, deliveryNotes?: string | null, deliveryType: string, createdAt: string, userId: string, refundReason?: string | null, refundAmount?: number | null, reversedShefPaymentAmount: number, isReusablePackaging: boolean, refundType?: RefundType | null, numOrdersFromShef: number, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, correctedRefundReason?: string | null, correctedRefundType?: RefundType | null, promoCode?: { __typename?: 'PromoCode', code: string, isPercentage: boolean, promoCodeType: PromoCodeType, value: number } | null, address: { __typename?: 'Address', id: number, zipCode: string, name?: string | null }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, foodItemId: number, quantity: number, name: string, price: number, foodItem: { __typename?: 'FoodItem', name?: string | null, portion?: string | null, servingSize?: string | null, spiceLevel: number }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, portion?: string | null, priceFactor: number, priceFactorType: PriceFactorType, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, shefFulfillmentTimeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, user: { __typename?: 'User', id: string, flakeId: string, publicName: string, fullName: string } }>, shef: { __typename?: 'PublicShef', id: string, shefProfile: { __typename?: 'ShefProfile', id: number, cutoffMsBeforeDeliveryDate: number, isMultiFulfillmentShef: boolean, defaultDropoffHub?: { __typename?: 'DeliveryHub', name: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null } | null } } };

export type ShefProfileFulfillmentFlagsFragment = { __typename?: 'RegionInfo', isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean };

export type ShefProfileEditShefProfileFragment = { __typename?: 'ShefProfile', id: number, userId: string, email?: string | null, phone?: string | null, bio?: string | null, notes?: string | null, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, youtubeHandle?: string | null, specialty?: string | null, coverPhotoUrl?: string | null, videoUrl?: string | null, cuisineRegion?: CuisineRegion | null, cuisineCategoryIds: Array<string>, featureShef?: boolean | null, trialStatus?: TrialStatus | null, dishCapacity: number, maxDishCapacity: number, shefAddressId?: number | null, previewFoodItemId?: number | null, cutoffMsBeforeDeliveryDate: number, fhcExpiresAt?: string | null, fhcUploadedAt?: string | null, fhcUploadRequiredBy?: string | null, newOrderNotificationFrequency?: NewOrderNotificationFrequency | null, cancelOrderNotificationFrequency?: CancelOrderNotificationFrequency | null, setBadQualityAt?: string | null, onboardingFormAnsweredAt?: string | null, fulfillmentOption?: string | null, isHubless: boolean, geographyAllowsCuisineType: boolean, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, user: { __typename?: 'User', publicName: string, createdAt: string, id: string, fullName?: string | null, email: string, shefStatus: ShefStatus, firstName: string, lastName: string, imageUrl: string, activeAddresses: Array<{ __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null }>, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number, stripeUserId?: string | null, userId: string, accountType: StripeAccountType, dashboardLoginLink?: string | null, createdAt: string, currentBalance?: { __typename?: 'ShefStripeConnectBalance', available: number, pending: number } | null } | null }, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, name: string, street: string, city: string, province: string, unit?: string | null, pickupInstructions: string, zipCode: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null } | null };

export type ShefProfileEditDeliveryHubsFragment = { __typename?: 'DeliveryHub', id: number, name: string, street: string, city: string, province: string, unit?: string | null, pickupInstructions: string, zipCode: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null };

export type ShefProfilePictureFragment = { __typename?: 'ShefApplication', profilePhotoOptionA?: string | null, profilePhotoOptionB?: string | null, profilePhotoOptionC?: string | null, profilePhotoSubmittedAt?: string | null, profilePhotoRejectedAt?: string | null, profilePhotoSubmissionStatus?: ProfilePhotoSubmissionStatus | null };

export type ShefProfileQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ShefProfileQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', id: number, userId: string, email?: string | null, phone?: string | null, bio?: string | null, notes?: string | null, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, youtubeHandle?: string | null, specialty?: string | null, coverPhotoUrl?: string | null, videoUrl?: string | null, cuisineRegion?: CuisineRegion | null, cuisineCategoryIds: Array<string>, featureShef?: boolean | null, trialStatus?: TrialStatus | null, dishCapacity: number, maxDishCapacity: number, shefAddressId?: number | null, previewFoodItemId?: number | null, cutoffMsBeforeDeliveryDate: number, fhcExpiresAt?: string | null, fhcUploadedAt?: string | null, fhcUploadRequiredBy?: string | null, newOrderNotificationFrequency?: NewOrderNotificationFrequency | null, cancelOrderNotificationFrequency?: CancelOrderNotificationFrequency | null, setBadQualityAt?: string | null, onboardingFormAnsweredAt?: string | null, fulfillmentOption?: string | null, isHubless: boolean, geographyAllowsCuisineType: boolean, shef: { __typename?: 'PublicShef', id: string, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null, name?: string | null }> }, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, user: { __typename?: 'User', publicName: string, createdAt: string, id: string, fullName?: string | null, email: string, shefStatus: ShefStatus, firstName: string, lastName: string, imageUrl: string, activeAddresses: Array<{ __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null }>, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number, stripeUserId?: string | null, userId: string, accountType: StripeAccountType, dashboardLoginLink?: string | null, createdAt: string, currentBalance?: { __typename?: 'ShefStripeConnectBalance', available: number, pending: number } | null } | null }, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, name: string, street: string, city: string, province: string, unit?: string | null, pickupInstructions: string, zipCode: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null } | null } | null, shefApplication?: { __typename?: 'ShefApplication', isPickupAddressEnabled: boolean, profilePhotoOptionA?: string | null, profilePhotoOptionB?: string | null, profilePhotoOptionC?: string | null, profilePhotoSubmittedAt?: string | null, profilePhotoRejectedAt?: string | null, profilePhotoSubmissionStatus?: ProfilePhotoSubmissionStatus | null } | null, possibleDeliveryHubsForShef: Array<{ __typename?: 'DeliveryHub', id: number, name: string, street: string, city: string, province: string, unit?: string | null, pickupInstructions: string, zipCode: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> };

export type ShefProfileMutationMutationVariables = Exact<{
  shefProfileInput: ShefProfileInput;
}>;


export type ShefProfileMutationMutation = { __typename?: 'Mutation', modifyShefProfile: { __typename?: 'ShefProfile', id: number } };

export type AdminDisconnectShefStripeMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AdminDisconnectShefStripeMutation = { __typename?: 'Mutation', adminDisconnectShefStripe: boolean };

export type DisableFringeMutationVariables = Exact<{ [key: string]: never; }>;


export type DisableFringeMutation = { __typename?: 'Mutation', disableFringe: boolean };

export type UpdateShefApplicationProfileImagesMutationVariables = Exact<{
  shefId: Scalars['String']['input'];
  profileImageInput: ShefApplicationProfileInput;
}>;


export type UpdateShefApplicationProfileImagesMutation = { __typename?: 'Mutation', updateShefApplicationProfileImages: boolean };

export type GetNewLocationInfoQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type GetNewLocationInfoQuery = { __typename?: 'Query', zipCode?: { __typename?: 'ZipCode', zipCode: string, regionId: number, region: { __typename?: 'RegionInfo', isHubless: boolean, displayName: string, launchedAt: string } } | null };

export type UpdateShefLocationMutationVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type UpdateShefLocationMutation = { __typename?: 'Mutation', updateShefZipCode: boolean };

export type FringeDeliveryOptInQueryVariables = Exact<{ [key: string]: never; }>;


export type FringeDeliveryOptInQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', canOptInToFringe: boolean, timeWindowOptionsForShef: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> } | null };

export type ShefFulfillmentInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ShefFulfillmentInfoQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', fulfillmentOption?: string | null, availableFulfillmentOptions: Array<string>, canOptOutOfFringe: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', googlePlaceId?: string | null, id: number, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null } | null, timeWindowOptionsForShef: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }>, timeWindowsSelectedByShef: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }>, primaryRegion?: { __typename?: 'RegionInfo', id: number } | null } | null };

export type ModifyShefFulfillmentInfoMutationVariables = Exact<{
  input: FulfillmentInput;
}>;


export type ModifyShefFulfillmentInfoMutation = { __typename?: 'Mutation', modifyShefFulfillmentInfo: boolean };

export type ShefRegionQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ShefRegionQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', id: number, primaryRegion?: { __typename?: 'RegionInfo', id: number, isPickupEnabled: boolean } | null } | null };

export type CurrentUserFieldsFragment = { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } };

export type ConsumerGroupOrderRatingQueryVariables = Exact<{
  groupOrderIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ConsumerGroupOrderRatingQuery = { __typename?: 'Query', groupOrdersByIds: Array<{ __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } }>, tagsForConsumer: { __typename?: 'OrderRatingTags', positiveFoodTags: Array<string>, negativeFoodTags: Array<string>, ignoreFoodTags?: Array<string> | null } };

export type ConsumerSubmitGroupOrderRatingMutationVariables = Exact<{
  input: GroupOrderRatingInput;
}>;


export type ConsumerSubmitGroupOrderRatingMutation = { __typename?: 'Mutation', addGroupOrderRating: { __typename?: 'GroupOrderRatingOutput', groupOrder: { __typename?: 'GroupOrder', id: string, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }> } } };

export type ConsumerDeliveryAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsumerDeliveryAddressesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, publicName: string, activeAddresses: Array<{ __typename?: 'Address', id: number, formattedAddress?: string | null, phone: string, deliveryNotes?: string | null, linkedSubscriptionId?: string | null, company?: string | null, unit?: string | null, name?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, streetNumber?: string | null, route?: string | null, googlePlaceId?: string | null }> } | null };

export type ConsumerArchiveDeliveryAddressMutationVariables = Exact<{
  addressId: Scalars['Int']['input'];
}>;


export type ConsumerArchiveDeliveryAddressMutation = { __typename?: 'Mutation', archiveDeliveryAddress?: boolean | null };

export type ShefToMessageFragment = { __typename?: 'PublicShef', flakeId: string, publicName: string };

export type GetShefToMessageQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type GetShefToMessageQuery = { __typename?: 'Query', shef: { __typename?: 'PublicShef', flakeId: string, publicName: string } };

export type RegionAvailabilityForDeliveryDateQueryVariables = Exact<{
  regionId: Scalars['Int']['input'];
  deliveryDate: Scalars['String']['input'];
}>;


export type RegionAvailabilityForDeliveryDateQuery = { __typename?: 'Query', regionAvailabilityForDeliveryDate: Array<{ __typename?: 'RegionAvailability', startDate: string, endDate: string, isAvailable: boolean } | null> };

export type UpcomingOrderFieldsFragment = { __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> };

export type ConsumerGroupOrderFieldsFragment = { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } };

export type ActiveSubscriptionFieldsFragment = { __typename?: 'Subscription', id: string, recurringPeriodDays?: number | null, status: SubscriptionStatus, orderTemplate?: { __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> } | null };

export type UpcomingOrdersQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpcomingOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'ConsumerOrderResults', orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }> } };

export type PreviousGroupOrdersQueryVariables = Exact<{
  first?: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PreviousGroupOrdersQuery = { __typename?: 'Query', previousGroupOrders: { __typename?: 'GroupOrderConnection', edges: Array<{ __typename?: 'GroupOrderEdge', node: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type UpcomingGroupOrdersQueryVariables = Exact<{
  first?: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpcomingGroupOrdersQuery = { __typename?: 'Query', upcomingGroupOrders: { __typename?: 'GroupOrderConnection', edges: Array<{ __typename?: 'GroupOrderEdge', node: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type ActiveMealPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveMealPlanQuery = { __typename?: 'Query', getActiveMealPlanForUser?: { __typename?: 'MealPlan', id: string, status: MealPlanStatus, mealPlanType: { __typename?: 'MealPlanType', unit: number, numServings: number, weeklyCost: number, format?: MealPlanFormat | null } } | null };

export type ActiveSubscriptionsQueryVariables = Exact<{
  first?: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ActiveSubscriptionsQuery = { __typename?: 'Query', activeSubscriptions: { __typename?: 'SubscriptionConnection', edges: Array<{ __typename?: 'SubscriptionEdge', node: { __typename?: 'Subscription', id: string, recurringPeriodDays?: number | null, status: SubscriptionStatus, orderTemplate?: { __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type ConsumerCancelOrderMutationVariables = Exact<{
  groupOrderId: Scalars['String']['input'];
}>;


export type ConsumerCancelOrderMutation = { __typename?: 'Mutation', cancelGroupOrder: { __typename?: 'GroupOrder', id: string, orders: Array<{ __typename?: 'Order', id: number, orderStatus: OrderStatus }> } };

export type ReorderMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type ReorderMutation = { __typename?: 'Mutation', duplicateOrderToCart: { __typename?: 'DuplicateOrderToCartResponse', success: boolean } };

export type ConsumerSavedCardFieldsFragment = { __typename?: 'SavedCreditCard', id: string, lastFourDigits: number, expiresAt: string, brand: string, type: string, lastUsedAt: string, linkedSubscriptionId?: string | null };

export type ConsumerPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsumerPaymentMethodsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, savedCreditCards: Array<{ __typename?: 'SavedCreditCard', id: string, lastFourDigits: number, expiresAt: string, brand: string, type: string, lastUsedAt: string, linkedSubscriptionId?: string | null }> } | null };

export type ConsumerSaveCardMutationVariables = Exact<{
  creditCardInput?: InputMaybe<SavedCreditCardInput>;
}>;


export type ConsumerSaveCardMutation = { __typename?: 'Mutation', saveCreditCard?: { __typename?: 'SavedCreditCard', id: string } | null };

export type ConsumerRemoveCardMutationVariables = Exact<{
  cardId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConsumerRemoveCardMutation = { __typename?: 'Mutation', removeCreditCard?: boolean | null };

export type ConsumerDeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type ConsumerDeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type ConsumerUpcomingOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsumerUpcomingOrdersQuery = { __typename?: 'Query', upcomingOrders: Array<{ __typename?: 'Order', id: number }> };

export type ConsumerNotificationSettingsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ConsumerNotificationSettingsQuery = { __typename?: 'Query', userNotificationSettings: Array<{ __typename?: 'UserNotificationSetting', userId: string, type: string, category: NotificationCategory, enabled: boolean }> };

export type ConsumerUpdateUserNotificationSettingsMutationVariables = Exact<{
  input: UserNotificationSettingUpdate;
}>;


export type ConsumerUpdateUserNotificationSettingsMutation = { __typename?: 'Mutation', updateUserNotificationSettings: Array<{ __typename?: 'UserNotificationSetting', userId: string, type: string, category: NotificationCategory, enabled: boolean }> };

export type ConsumerUpdateSubscriptionMutationVariables = Exact<{
  input: SubscriptionModifyInput;
}>;


export type ConsumerUpdateSubscriptionMutation = { __typename?: 'Mutation', modifySubscription: { __typename?: 'SubscriptionModifyResult', subscription: { __typename?: 'Subscription', id: string, status: SubscriptionStatus } } };

export type ReferralRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralRewardsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, shefStatus: ShefStatus, referralRewards?: Array<{ __typename?: 'PromoCode', id: number, code: string, value: number, isUsed: boolean, createdAt: string, referee?: { __typename?: 'User', id: string, firstName: string } | null } | null> | null, pendingReferralRewards?: Array<{ __typename?: 'PromoCodeUsage', id: number, userId: string, createdAt: string, referee?: { __typename?: 'User', id: string, firstName: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, value: number, promoCodeType: PromoCodeType } | null } | null> | null } | null };

export type ReferShefQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ReferShefQuery = { __typename?: 'Query', shef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, firstName?: string | null } };

export type ReferFoodItemQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type ReferFoodItemQuery = { __typename?: 'Query', sluggedFoodItem?: { __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, slug: string, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', title: string }> } } | null };

export type ReferOrderQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
}>;


export type ReferOrderQuery = { __typename?: 'Query', publicOrderByUser?: { __typename?: 'PublicOrder', id: number, uuid: string, userId: string, deliveryDate: string, user: { __typename?: 'User', publicName: string }, lineItems: Array<{ __typename?: 'OrderLineItem', name: string, quantity: number, foodItem: { __typename?: 'FoodItem', resizedImageUrl?: string | null, deletedAt?: string | null, id: number, userId: string, imageUrl?: string | null, name?: string | null, slug: string, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, shef: { __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } }> } | null };

export type TasterFieldsFragment = { __typename?: 'User', isTasteTester: boolean, unlockedTrialShefDiscovery: boolean };

export type BecomeATasterInfoQueryVariables = Exact<{
  zipCode?: InputMaybe<Scalars['String']['input']>;
  deliveryDates?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BecomeATasterInfoQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, isTasteTester: boolean, unlockedTrialShefDiscovery: boolean } | null };

export type BecomeATasterMutationVariables = Exact<{ [key: string]: never; }>;


export type BecomeATasterMutation = { __typename?: 'Mutation', becomeATaster: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } };

export type GetAvailablePromoCodesForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailablePromoCodesForUserQuery = { __typename?: 'Query', getAvailablePromoCodesForUser: Array<{ __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null }> };

export type GetNewUserPromoCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewUserPromoCodeQuery = { __typename?: 'Query', newUserPromoCode?: { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null };

export type HeaderZipCodeQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type HeaderZipCodeQuery = { __typename?: 'Query', zipCode?: { __typename?: 'ZipCode', zipCode: string, availableToCustomers: boolean, region: { __typename?: 'RegionInfo', id: number, isPickupEnabled: boolean } } | null };

export type TrendingSearchesQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type TrendingSearchesQuery = { __typename?: 'Query', getTrendingSearches: Array<string> };

export type ShefSearchResultFragment = { __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, cuisineRegion?: CuisineRegion | null, specialty?: string | null, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } };

export type DishSearchResultFragment = { __typename?: 'FoodItem', id: number, userId: string, imageUrl?: string | null, name?: string | null, slug: string, ratingCount: number, averageRating: number, portion?: string | null, price: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, user?: { __typename?: 'User', publicName: string } | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, isTrialShef: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null };

export type CuisineSearchResultFieldsFragment = { __typename?: 'CuisineSearchResult', numShefs: number, numDishes: number, category: { __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean }> } };

export type ShefSearchResultsFieldsFragment = { __typename?: 'ShefSearchResults', hasMore: boolean, cursor?: string | null, results: Array<{ __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, cuisineRegion?: CuisineRegion | null, specialty?: string | null, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }> };

export type DishSearchResultsFieldsFragment = { __typename?: 'DishSearchResults', hasMore: boolean, cursor?: string | null, results: Array<{ __typename?: 'FoodItem', id: number, userId: string, imageUrl?: string | null, name?: string | null, slug: string, ratingCount: number, averageRating: number, portion?: string | null, price: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, user?: { __typename?: 'User', publicName: string } | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, isTrialShef: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }> };

export type CombinedSearchResultsFragment = { __typename?: 'CombinedSearchResults', showGiftCardResult: boolean, shefResults: { __typename?: 'ShefSearchResults', hasMore: boolean, cursor?: string | null, results: Array<{ __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, cuisineRegion?: CuisineRegion | null, specialty?: string | null, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }> }, dishResults: { __typename?: 'DishSearchResults', hasMore: boolean, cursor?: string | null, results: Array<{ __typename?: 'FoodItem', id: number, userId: string, imageUrl?: string | null, name?: string | null, slug: string, ratingCount: number, averageRating: number, portion?: string | null, price: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, user?: { __typename?: 'User', publicName: string } | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, isTrialShef: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }> }, cuisineResults: Array<{ __typename?: 'CuisineSearchResult', numShefs: number, numDishes: number, category: { __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean }> } }> };

export type SearchQueryVariables = Exact<{
  searchInput: SearchInput;
}>;


export type SearchQuery = { __typename?: 'Query', combinedSearch: { __typename?: 'CombinedSearchResults', showGiftCardResult: boolean, shefResults: { __typename?: 'ShefSearchResults', hasMore: boolean, cursor?: string | null, results: Array<{ __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, cuisineRegion?: CuisineRegion | null, specialty?: string | null, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }> }, dishResults: { __typename?: 'DishSearchResults', hasMore: boolean, cursor?: string | null, results: Array<{ __typename?: 'FoodItem', id: number, userId: string, imageUrl?: string | null, name?: string | null, slug: string, ratingCount: number, averageRating: number, portion?: string | null, price: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, user?: { __typename?: 'User', publicName: string } | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, isTrialShef: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }> }, cuisineResults: Array<{ __typename?: 'CuisineSearchResult', numShefs: number, numDishes: number, category: { __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean }> } }> } };

export type DishSearchResultNewFragment = { __typename?: 'FoodItem', id: number, userId: string, imageUrl?: string | null, name?: string | null, slug: string, ratingCount: number, averageRating: number, description?: string | null, isPopular?: boolean | null, lastPurchasedAt?: string | null, portion?: string | null, price: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, user?: { __typename?: 'User', publicName: string } | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, isTopShef: boolean, isTrialShef: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null };

export type SearchResultsFragment = { __typename?: 'SearchResults', shefResults: Array<{ __typename?: 'ExploreSegmentShef', dishPreviewImage: string, shef: { __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null }>, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, cuisineRegion?: CuisineRegion | null, specialty?: string | null, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } } }>, dishResults: Array<Array<{ __typename?: 'FoodItem', id: number, userId: string, imageUrl?: string | null, name?: string | null, slug: string, ratingCount: number, averageRating: number, description?: string | null, isPopular?: boolean | null, lastPurchasedAt?: string | null, portion?: string | null, price: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, user?: { __typename?: 'User', publicName: string } | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, isTopShef: boolean, isTrialShef: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }>>, cuisineResults: Array<{ __typename?: 'CuisineSearchResult', numShefs: number, numDishes: number, category: { __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean }> } }>, searchStateResult: { __typename?: 'SearchStateResult', seenRecordIds: Array<Array<number>>, paginationState: { __typename?: 'AlgoliaPaginationResult', isEnd: boolean, nbHits?: number | null, queryIdx: number } } };

export type GetSearchResultsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  deliveryDate: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  isPartialQuery: Scalars['Boolean']['input'];
  filters: ExploreFoodItemsFilterInput;
  searchState: SearchStateInput;
  offset: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSearchResultsQuery = { __typename?: 'Query', getSearchResults: { __typename?: 'SearchResults', shefResults: Array<{ __typename?: 'ExploreSegmentShef', dishPreviewImage: string, shef: { __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null }>, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, cuisineRegion?: CuisineRegion | null, specialty?: string | null, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } } }>, dishResults: Array<Array<{ __typename?: 'FoodItem', id: number, userId: string, imageUrl?: string | null, name?: string | null, slug: string, ratingCount: number, averageRating: number, description?: string | null, isPopular?: boolean | null, lastPurchasedAt?: string | null, portion?: string | null, price: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, user?: { __typename?: 'User', publicName: string } | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, isTopShef: boolean, isTrialShef: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }>>, cuisineResults: Array<{ __typename?: 'CuisineSearchResult', numShefs: number, numDishes: number, category: { __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean }> } }>, searchStateResult: { __typename?: 'SearchStateResult', seenRecordIds: Array<Array<number>>, paginationState: { __typename?: 'AlgoliaPaginationResult', isEnd: boolean, nbHits?: number | null, queryIdx: number } } } };

export type CartCardPublicShefFragment = { __typename?: 'PublicShef', id: string, imageUrl?: string | null, firstName?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, specialty?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } };

export type ConsumerCartPublicShefFragment = { __typename?: 'PublicShef', id: string, imageUrl?: string | null, firstName?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, cuisineRegion?: CuisineRegion | null, specialty?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } };

export type LocalCartShefsQueryVariables = Exact<{
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LocalCartShefsQuery = { __typename?: 'Query', shefs: Array<{ __typename?: 'PublicShef', id: string, imageUrl?: string | null, firstName?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, cuisineRegion?: CuisineRegion | null, specialty?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }> };

export type DishFirstFoodItemsSegmentFragment = { __typename?: 'ExploreFoodItemsSegment', cacheKey: string, id: string, layout: ExploreFoodItemsSegmentLayout, displayName: string, subtitle?: string | null, icon?: SegmentIcon | null, categoryPageContent?: { __typename?: 'CategoryPageContent', pageType: CategoryPageType, title: string, subTitle?: string | null, illustrationUrl?: string | null, fadeSegmentBackground?: boolean | null, segmentBackgroundUrl: string, segmentBackgroundUrlTablet?: string | null, segmentBackgroundUrlDesktop?: string | null, heroBackgroundUrl?: string | null, heroBackgroundUrlTablet?: string | null, heroBackgroundUrlDesktop?: string | null, patternedStripUrl: string, moreCuisinesBackgroundUrl: string, moreCuisinesBackgroundUrlTablet?: string | null, moreCuisinesBackgroundUrlDesktop?: string | null, referralStripTextColor: ReferralStripTextColor, referralStripBackgroundUrl: string, referralStripBackgroundUrlTablet?: string | null, referralStripBackgroundUrlDesktop?: string | null, searchSuggestions?: Array<{ __typename?: 'CategoryPageSearchSuggestion', display: string, searchQuery?: string | null }> | null } | null, content: { __typename?: 'ExploreFoodItemsContent', total: number, items: Array<{ __typename?: 'CuisineCategory' } | { __typename?: 'ExploreSegmentShef', dishPreviewImage: string, numDishes: number, shef: { __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, isTopShef: boolean, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null, name?: string | null }>, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string }>, shefProfile: { __typename?: 'ShefProfile', isShefFollower: boolean, id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } } } | { __typename?: 'FoodItem', name?: string | null, imageUrl?: string | null, slug: string, portion?: string | null, servingSize?: string | null, ratingCount: number, averageRating: number, price: number, foodType?: FoodType | null, isPopular?: boolean | null, lastPurchasedAt?: string | null, description?: string | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, celebrityEventType?: CelebrityEventType | null, isTopShef: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null } | { __typename?: 'PublicShef' }> }, preview?: { __typename?: 'ExploreFoodItemsSegmentPreview', seeAllText: string, showAllFiltersWhenExpanded: boolean, seeAllFilter?: { __typename?: 'ExploreFoodItemsPreviewFilter', availabilityDates?: Array<string> | null, cuisineFilters?: Array<string> | null, dietaryFilters?: Array<string> | null, dishTypeFilters?: Array<FoodTypeCoalesced> | null, isEcoFriendlyPackaging?: boolean | null, minDishRating?: number | null, priceLevelFilters?: Array<PriceLevel> | null, proteinFilters?: Array<Protein> | null, spiceLevelFilters?: Array<number> | null } | null } | null };

export type DishFirstExploreSegmentShefFragment = { __typename?: 'ExploreSegmentShef', dishPreviewImage: string, numDishes: number, shef: { __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, isTopShef: boolean, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null, name?: string | null }>, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string }>, shefProfile: { __typename?: 'ShefProfile', isShefFollower: boolean, id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } } };

export type DishFirstPreviewFilterFragment = { __typename?: 'ExploreFoodItemsPreviewFilter', availabilityDates?: Array<string> | null, cuisineFilters?: Array<string> | null, dietaryFilters?: Array<string> | null, dishTypeFilters?: Array<FoodTypeCoalesced> | null, isEcoFriendlyPackaging?: boolean | null, minDishRating?: number | null, priceLevelFilters?: Array<PriceLevel> | null, proteinFilters?: Array<Protein> | null, spiceLevelFilters?: Array<number> | null };

export type DishFirstShefProfileFragment = { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> };

export type DishFirstFoodItemPreviewFragment = { __typename?: 'FoodItem', name?: string | null, imageUrl?: string | null, slug: string, portion?: string | null, servingSize?: string | null, ratingCount: number, averageRating: number, price: number, foodType?: FoodType | null, isPopular?: boolean | null, lastPurchasedAt?: string | null, description?: string | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, celebrityEventType?: CelebrityEventType | null, isTopShef: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null };

export type DishFirstFoodItemFragment = { __typename?: 'FoodItem', userId: string, name?: string | null, imageUrl?: string | null, description?: string | null, slug: string, price: number, averageRating: number, ratingCount: number, topPositiveTags: Array<string>, foodType?: FoodType | null, vegan?: boolean | null, vegetarian?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, whole30?: boolean | null, glutenFree: boolean, dairyFree: boolean, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, packaging: Packaging, portion?: string | null, servingSize?: string | null, spiceLevel: number, ingredients?: string | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, celebrityEventType?: CelebrityEventType | null, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string, isSoldOut: boolean, numDishesAvailable: number }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null } };

export type DishFirstPublicShefFragment = { __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, isTopShef: boolean, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null, name?: string | null }>, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string }>, shefProfile: { __typename?: 'ShefProfile', isShefFollower: boolean, id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } };

export type CategoryPageContentFragment = { __typename?: 'CategoryPageContent', pageType: CategoryPageType, title: string, subTitle?: string | null, illustrationUrl?: string | null, fadeSegmentBackground?: boolean | null, segmentBackgroundUrl: string, segmentBackgroundUrlTablet?: string | null, segmentBackgroundUrlDesktop?: string | null, heroBackgroundUrl?: string | null, heroBackgroundUrlTablet?: string | null, heroBackgroundUrlDesktop?: string | null, patternedStripUrl: string, moreCuisinesBackgroundUrl: string, moreCuisinesBackgroundUrlTablet?: string | null, moreCuisinesBackgroundUrlDesktop?: string | null, referralStripTextColor: ReferralStripTextColor, referralStripBackgroundUrl: string, referralStripBackgroundUrlTablet?: string | null, referralStripBackgroundUrlDesktop?: string | null, searchSuggestions?: Array<{ __typename?: 'CategoryPageSearchSuggestion', display: string, searchQuery?: string | null }> | null };

export type AvailableDeliveryDayFragment = { __typename?: 'NumberAvailableDishesResult', date: string, count: number };

export type AvailableCuisineCategoryFragment = { __typename?: 'CuisineCategory', id: string, title: string, isPrimary: boolean, categoryPageContent?: { __typename?: 'CategoryPageContent', pageType: CategoryPageType, title: string, subTitle?: string | null, illustrationUrl?: string | null, fadeSegmentBackground?: boolean | null, segmentBackgroundUrl: string, segmentBackgroundUrlTablet?: string | null, segmentBackgroundUrlDesktop?: string | null, heroBackgroundUrl?: string | null, heroBackgroundUrlTablet?: string | null, heroBackgroundUrlDesktop?: string | null, patternedStripUrl: string, moreCuisinesBackgroundUrl: string, moreCuisinesBackgroundUrlTablet?: string | null, moreCuisinesBackgroundUrlDesktop?: string | null, referralStripTextColor: ReferralStripTextColor, referralStripBackgroundUrl: string, referralStripBackgroundUrlTablet?: string | null, referralStripBackgroundUrlDesktop?: string | null, searchSuggestions?: Array<{ __typename?: 'CategoryPageSearchSuggestion', display: string, searchQuery?: string | null }> | null } | null };

export type HierarchicalAvailableCuisineCategoryFragment = { __typename?: 'CuisineCategory', id: string, title: string, isPrimary: boolean, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean, title: string }>, subcuisines: Array<{ __typename?: 'CuisineCategory', id: string }>, categoryPageContent?: { __typename?: 'CategoryPageContent', pageType: CategoryPageType, title: string, subTitle?: string | null, illustrationUrl?: string | null, fadeSegmentBackground?: boolean | null, segmentBackgroundUrl: string, segmentBackgroundUrlTablet?: string | null, segmentBackgroundUrlDesktop?: string | null, heroBackgroundUrl?: string | null, heroBackgroundUrlTablet?: string | null, heroBackgroundUrlDesktop?: string | null, patternedStripUrl: string, moreCuisinesBackgroundUrl: string, moreCuisinesBackgroundUrlTablet?: string | null, moreCuisinesBackgroundUrlDesktop?: string | null, referralStripTextColor: ReferralStripTextColor, referralStripBackgroundUrl: string, referralStripBackgroundUrlTablet?: string | null, referralStripBackgroundUrlDesktop?: string | null, searchSuggestions?: Array<{ __typename?: 'CategoryPageSearchSuggestion', display: string, searchQuery?: string | null }> | null } | null };

export type DishFirstFilterOptionsFragment = { __typename?: 'ExploreFoodItemsFilterOptionsResults', isEcoFriendlyFilterAvailable: boolean, totalShefs: number, availableDeliveryDays: Array<{ __typename?: 'NumberAvailableDishesResult', date: string, count: number }>, availableCuisines: Array<{ __typename?: 'CuisineCategory', id: string, title: string, isPrimary: boolean, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean, title: string }>, subcuisines: Array<{ __typename?: 'CuisineCategory', id: string }>, categoryPageContent?: { __typename?: 'CategoryPageContent', pageType: CategoryPageType, title: string, subTitle?: string | null, illustrationUrl?: string | null, fadeSegmentBackground?: boolean | null, segmentBackgroundUrl: string, segmentBackgroundUrlTablet?: string | null, segmentBackgroundUrlDesktop?: string | null, heroBackgroundUrl?: string | null, heroBackgroundUrlTablet?: string | null, heroBackgroundUrlDesktop?: string | null, patternedStripUrl: string, moreCuisinesBackgroundUrl: string, moreCuisinesBackgroundUrlTablet?: string | null, moreCuisinesBackgroundUrlDesktop?: string | null, referralStripTextColor: ReferralStripTextColor, referralStripBackgroundUrl: string, referralStripBackgroundUrlTablet?: string | null, referralStripBackgroundUrlDesktop?: string | null, searchSuggestions?: Array<{ __typename?: 'CategoryPageSearchSuggestion', display: string, searchQuery?: string | null }> | null } | null }> };

export type ConsumerExploreDishFirstQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  numVisiblePerSegment: Scalars['Int']['input'];
  filters: ExploreFoodItemsFilterInput;
  loadFoodItemDescription: Scalars['Boolean']['input'];
  useDynamicPreviewImage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConsumerExploreDishFirstQuery = { __typename?: 'Query', exploreFoodItems: Array<{ __typename?: 'ExploreFoodItemsSegment', cacheKey: string, id: string, layout: ExploreFoodItemsSegmentLayout, displayName: string, subtitle?: string | null, icon?: SegmentIcon | null, categoryPageContent?: { __typename?: 'CategoryPageContent', pageType: CategoryPageType, title: string, subTitle?: string | null, illustrationUrl?: string | null, fadeSegmentBackground?: boolean | null, segmentBackgroundUrl: string, segmentBackgroundUrlTablet?: string | null, segmentBackgroundUrlDesktop?: string | null, heroBackgroundUrl?: string | null, heroBackgroundUrlTablet?: string | null, heroBackgroundUrlDesktop?: string | null, patternedStripUrl: string, moreCuisinesBackgroundUrl: string, moreCuisinesBackgroundUrlTablet?: string | null, moreCuisinesBackgroundUrlDesktop?: string | null, referralStripTextColor: ReferralStripTextColor, referralStripBackgroundUrl: string, referralStripBackgroundUrlTablet?: string | null, referralStripBackgroundUrlDesktop?: string | null, searchSuggestions?: Array<{ __typename?: 'CategoryPageSearchSuggestion', display: string, searchQuery?: string | null }> | null } | null, content: { __typename?: 'ExploreFoodItemsContent', total: number, items: Array<{ __typename?: 'CuisineCategory' } | { __typename?: 'ExploreSegmentShef', dishPreviewImage: string, numDishes: number, shef: { __typename?: 'PublicShef', id: string, publicName: string, imageUrl?: string | null, isTopShef: boolean, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, imageUrl?: string | null, name?: string | null }>, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string }>, shefProfile: { __typename?: 'ShefProfile', isShefFollower: boolean, id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } } } | { __typename?: 'FoodItem', name?: string | null, imageUrl?: string | null, slug: string, portion?: string | null, servingSize?: string | null, ratingCount: number, averageRating: number, price: number, foodType?: FoodType | null, isPopular?: boolean | null, lastPurchasedAt?: string | null, description?: string | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, celebrityEventType?: CelebrityEventType | null, isTopShef: boolean, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null } | { __typename?: 'PublicShef' }> }, preview?: { __typename?: 'ExploreFoodItemsSegmentPreview', seeAllText: string, showAllFiltersWhenExpanded: boolean, seeAllFilter?: { __typename?: 'ExploreFoodItemsPreviewFilter', availabilityDates?: Array<string> | null, cuisineFilters?: Array<string> | null, dietaryFilters?: Array<string> | null, dishTypeFilters?: Array<FoodTypeCoalesced> | null, isEcoFriendlyPackaging?: boolean | null, minDishRating?: number | null, priceLevelFilters?: Array<PriceLevel> | null, proteinFilters?: Array<Protein> | null, spiceLevelFilters?: Array<number> | null } | null } | null }> };

export type ConsumerExploreDishFirstFiltersQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  filters: ExploreFoodItemsFilterInput;
  query?: InputMaybe<Scalars['String']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConsumerExploreDishFirstFiltersQuery = { __typename?: 'Query', exploreFoodItemsFilterOptions?: { __typename?: 'ExploreFoodItemsFilterOptionsResults', isEcoFriendlyFilterAvailable: boolean, totalShefs: number, availableDeliveryDays: Array<{ __typename?: 'NumberAvailableDishesResult', date: string, count: number }>, availableCuisines: Array<{ __typename?: 'CuisineCategory', id: string, title: string, isPrimary: boolean, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean, title: string }>, subcuisines: Array<{ __typename?: 'CuisineCategory', id: string }>, categoryPageContent?: { __typename?: 'CategoryPageContent', pageType: CategoryPageType, title: string, subTitle?: string | null, illustrationUrl?: string | null, fadeSegmentBackground?: boolean | null, segmentBackgroundUrl: string, segmentBackgroundUrlTablet?: string | null, segmentBackgroundUrlDesktop?: string | null, heroBackgroundUrl?: string | null, heroBackgroundUrlTablet?: string | null, heroBackgroundUrlDesktop?: string | null, patternedStripUrl: string, moreCuisinesBackgroundUrl: string, moreCuisinesBackgroundUrlTablet?: string | null, moreCuisinesBackgroundUrlDesktop?: string | null, referralStripTextColor: ReferralStripTextColor, referralStripBackgroundUrl: string, referralStripBackgroundUrlTablet?: string | null, referralStripBackgroundUrlDesktop?: string | null, searchSuggestions?: Array<{ __typename?: 'CategoryPageSearchSuggestion', display: string, searchQuery?: string | null }> | null } | null }> } | null };

export type ConsumerExploreDishFirstZipCodeQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type ConsumerExploreDishFirstZipCodeQuery = { __typename?: 'Query', zipCode?: { __typename?: 'ZipCode', zipCode: string, timeZone: string, availableToCustomers: boolean, region: { __typename?: 'RegionInfo', id: number, isVerifiedHalalEnabled: boolean } } | null };

export type MoreDishesFromShefQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  availableDate?: InputMaybe<Scalars['DateTime']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoreDishesFromShefQuery = { __typename?: 'Query', consumerFoodItems: Array<{ __typename?: 'FoodItem', userId: string, name?: string | null, imageUrl?: string | null, description?: string | null, slug: string, price: number, averageRating: number, ratingCount: number, topPositiveTags: Array<string>, foodType?: FoodType | null, vegan?: boolean | null, vegetarian?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, whole30?: boolean | null, glutenFree: boolean, dairyFree: boolean, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, packaging: Packaging, portion?: string | null, servingSize?: string | null, spiceLevel: number, ingredients?: string | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, celebrityEventType?: CelebrityEventType | null, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string, isSoldOut: boolean, numDishesAvailable: number }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null } }> };

export type GetFoodItemQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFoodItemQuery = { __typename?: 'Query', sluggedFoodItem?: { __typename?: 'FoodItem', userId: string, name?: string | null, imageUrl?: string | null, description?: string | null, slug: string, price: number, averageRating: number, ratingCount: number, topPositiveTags: Array<string>, foodType?: FoodType | null, vegan?: boolean | null, vegetarian?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, whole30?: boolean | null, glutenFree: boolean, dairyFree: boolean, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, packaging: Packaging, portion?: string | null, servingSize?: string | null, spiceLevel: number, ingredients?: string | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, celebrityEventType?: CelebrityEventType | null, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string, isSoldOut: boolean, numDishesAvailable: number }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null } } | null };

export type PreCheckoutUpsellSuggestionsQueryVariables = Exact<{
  deliveryDate: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  cartFoodItemIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PreCheckoutUpsellSuggestionsQuery = { __typename?: 'Query', preCheckoutOrderUpsellRecommendations: Array<{ __typename?: 'FoodItem', userId: string, name?: string | null, imageUrl?: string | null, description?: string | null, slug: string, price: number, averageRating: number, ratingCount: number, topPositiveTags: Array<string>, foodType?: FoodType | null, vegan?: boolean | null, vegetarian?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, whole30?: boolean | null, glutenFree: boolean, dairyFree: boolean, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, packaging: Packaging, portion?: string | null, servingSize?: string | null, spiceLevel: number, ingredients?: string | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, celebrityEventType?: CelebrityEventType | null, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string, isSoldOut: boolean, numDishesAvailable: number }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null } }> };

export type CategoryPageRecentReviewsQueryVariables = Exact<{
  regionId: Scalars['Int']['input'];
}>;


export type CategoryPageRecentReviewsQuery = { __typename?: 'Query', categoryPageRecentReviews?: { __typename?: 'CategoryPageRecentReviewResult', recentReviews: Array<{ __typename?: 'RecentReview', user: { __typename?: 'User', firstName: string }, review: { __typename?: 'PublicReviewResult', comment?: string | null, createdAt: string }, shef: { __typename?: 'PublicShef', firstName?: string | null, imageUrl?: string | null, id: string } }> } | null };

export type ExploreCuisineQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  cuisineTitle: Scalars['String']['input'];
  seed: Scalars['String']['input'];
  filters: ExploreSegmentsFilterInput;
  numFoodItems: Scalars['Int']['input'];
}>;


export type ExploreCuisineQuery = { __typename?: 'Query', exploreCuisine: { __typename?: 'ExploreCuisineResults', availableDeliveryDays: Array<string>, segments: Array<{ __typename?: 'ExploreSegment', cacheKey: string, id: string, layout: SegmentLayout, displayName: string, subtitle?: string | null, icon?: SegmentIcon | null, subcuisineSegmentDetails?: { __typename?: 'SubcuisineSegmentDetails', rootCuisineRegion: string, subcuisineId: string } | null, preview?: { __typename?: 'ExploreSegmentPreview', seeAllText: string, showAllFiltersWhenExpanded: boolean } | null, content: { __typename?: 'ExploreSegmentContent', total: number, isInPreview: boolean, items: Array<{ __typename?: 'FoodItem', name?: string | null, imageUrl?: string | null, description?: string | null, slug: string, price: number, isSoldOut: boolean, foodItemId: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, specialty?: string | null, timeZone: string, isTrialShef: boolean }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null } } | { __typename?: 'PublicShef', id: string, publicName: string, firstName?: string | null, hasEcoFriendlyPackaging: boolean, imageUrl?: string | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, shefProfile: { __typename?: 'ShefProfile', id: number, cuisineRegion?: CuisineRegion | null, fulfillmentOption?: string | null, isTrialShef: boolean, featureShef?: boolean | null, coverPhotoUrl?: string | null, specialty?: string | null, timeZone: string, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null }, activeHolidayFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null }> } }>, ancestorCuisinesAvailability: Array<{ __typename?: 'CuisineSearchResult', numShefs: number, numDishes: number, category: { __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean }> } }> }, zipCode?: { __typename?: 'ZipCode', zipCode: string, timeZone: string, availableToCustomers: boolean, region: { __typename?: 'RegionInfo', id: number } } | null };

export type ExploreMerchandiseQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  seed: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  filters: ExploreSegmentsFilterInput;
  numFoodItems: Scalars['Int']['input'];
}>;


export type ExploreMerchandiseQuery = { __typename?: 'Query', exploreMerchandise: { __typename?: 'ExploreMerchandiseResults', availableDeliveryDays: Array<string>, segments: Array<{ __typename?: 'ExploreSegment', cacheKey: string, id: string, layout: SegmentLayout, displayName: string, subtitle?: string | null, icon?: SegmentIcon | null, subcuisineSegmentDetails?: { __typename?: 'SubcuisineSegmentDetails', rootCuisineRegion: string, subcuisineId: string } | null, preview?: { __typename?: 'ExploreSegmentPreview', seeAllText: string, showAllFiltersWhenExpanded: boolean } | null, content: { __typename?: 'ExploreSegmentContent', total: number, isInPreview: boolean, items: Array<{ __typename?: 'FoodItem', name?: string | null, imageUrl?: string | null, description?: string | null, slug: string, price: number, isSoldOut: boolean, foodItemId: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, specialty?: string | null, timeZone: string, isTrialShef: boolean }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null } } | { __typename?: 'PublicShef', id: string, publicName: string, firstName?: string | null, hasEcoFriendlyPackaging: boolean, imageUrl?: string | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, shefProfile: { __typename?: 'ShefProfile', id: number, cuisineRegion?: CuisineRegion | null, fulfillmentOption?: string | null, isTrialShef: boolean, featureShef?: boolean | null, coverPhotoUrl?: string | null, specialty?: string | null, timeZone: string, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null }, activeHolidayFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null }> } }> }, zipCode?: { __typename?: 'ZipCode', zipCode: string, timeZone: string, availableToCustomers: boolean, region: { __typename?: 'RegionInfo', id: number } } | null };

export type ExploreMerchandisePageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ExploreMerchandisePageQuery = { __typename?: 'Query', exploreMerchandisePage: { __typename?: 'ExploreMerchandisePage', id: string, slug: string, title: string, subtitle: string, pageName: string, heroPhotoUrl: string } };

export type ConsumerExplorePublicShefFragment = { __typename?: 'PublicShef', id: string, publicName: string, firstName?: string | null, hasEcoFriendlyPackaging: boolean, imageUrl?: string | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, shefProfile: { __typename?: 'ShefProfile', id: number, cuisineRegion?: CuisineRegion | null, fulfillmentOption?: string | null, isTrialShef: boolean, featureShef?: boolean | null, coverPhotoUrl?: string | null, specialty?: string | null, timeZone: string, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null }, activeHolidayFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null };

export type ConsumerExploreFoodItemFragment = { __typename?: 'FoodItem', name?: string | null, imageUrl?: string | null, description?: string | null, slug: string, price: number, isSoldOut: boolean, foodItemId: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, specialty?: string | null, timeZone: string, isTrialShef: boolean }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null } };

export type ConsumerExplore2ExploreSegmentFragment = { __typename?: 'ExploreSegment', cacheKey: string, id: string, layout: SegmentLayout, displayName: string, subtitle?: string | null, icon?: SegmentIcon | null, subcuisineSegmentDetails?: { __typename?: 'SubcuisineSegmentDetails', rootCuisineRegion: string, subcuisineId: string } | null, preview?: { __typename?: 'ExploreSegmentPreview', seeAllText: string, showAllFiltersWhenExpanded: boolean } | null, content: { __typename?: 'ExploreSegmentContent', total: number, isInPreview: boolean, items: Array<{ __typename?: 'FoodItem', name?: string | null, imageUrl?: string | null, description?: string | null, slug: string, price: number, isSoldOut: boolean, foodItemId: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, specialty?: string | null, timeZone: string, isTrialShef: boolean }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null } } | { __typename?: 'PublicShef', id: string, publicName: string, firstName?: string | null, hasEcoFriendlyPackaging: boolean, imageUrl?: string | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, shefProfile: { __typename?: 'ShefProfile', id: number, cuisineRegion?: CuisineRegion | null, fulfillmentOption?: string | null, isTrialShef: boolean, featureShef?: boolean | null, coverPhotoUrl?: string | null, specialty?: string | null, timeZone: string, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null }, activeHolidayFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null }> } };

export type ConsumerExploreShefPreviewFoodItemFragment = { __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string };

export type ConsumerExploreShefPreviewPublicShefFragment = { __typename?: 'PublicShef', id: string, firstName?: string | null, hasEcoFriendlyPackaging: boolean, publicName: string, imageUrl?: string | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, activeHolidayFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, featureShef?: boolean | null, coverPhotoUrl?: string | null, specialty?: string | null, timeZone: string, cutoffMsBeforeDeliveryDate: number, fulfillmentOption?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null };

export type CuisineRowPublicShefFragment = { __typename?: 'PublicShef', id: string, firstName?: string | null, hasEcoFriendlyPackaging: boolean, publicName: string, imageUrl?: string | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, activeHolidayFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, foodType?: FoodType | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string }>, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, featureShef?: boolean | null, coverPhotoUrl?: string | null, specialty?: string | null, timeZone: string, cutoffMsBeforeDeliveryDate: number, fulfillmentOption?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null } | null, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null };

export type FollowShefInfoFragment = { __typename?: 'PublicShef', id: string, publicName: string, cuisineCategories: Array<{ __typename?: 'CuisineCategory', title: string }> };

export type FollowShefMutationVariables = Exact<{
  shefId: Scalars['String']['input'];
  canRefollow?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FollowShefMutation = { __typename?: 'Mutation', followShef: { __typename?: 'PublicShef', id: string, publicName: string, cuisineCategories: Array<{ __typename?: 'CuisineCategory', title: string }> } };

export type UnfollowShefMutationVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type UnfollowShefMutation = { __typename?: 'Mutation', unfollowShef: boolean };

export type FollowedShefsQueryVariables = Exact<{ [key: string]: never; }>;


export type FollowedShefsQuery = { __typename?: 'Query', me?: { __typename?: 'User', followedShefs: Array<{ __typename?: 'PublicShef', id: string, publicName: string, cuisineCategories: Array<{ __typename?: 'CuisineCategory', title: string }> }> } | null };

export type FollowingPostsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FollowingPostsQuery = { __typename?: 'Query', followingPosts: Array<{ __typename?: 'ShefPost', id: string, shefId: string, mediaType?: ShefPostMediaType | null, mediaUrl?: string | null, foodItemId?: number | null, clickCount: number, isLikedByUser?: boolean | null, numLikes: number, promoCodeId?: number | null, promoCodeString?: string | null, comment?: string | null, createdAt: string, viewCount: number }> };

export type FollowedShefsListQueryVariables = Exact<{ [key: string]: never; }>;


export type FollowedShefsListQuery = { __typename?: 'Query', me?: { __typename?: 'User', followedShefs: Array<{ __typename?: 'PublicShef', flakeId: string, id: string, imageUrl?: string | null, publicName: string, resizedImageUrl?: string | null, rating?: { __typename?: 'ShefRating', count: number, score: number } | null, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, resizedImageUrl?: string | null }>, shefProfile: { __typename?: 'ShefProfile', id: number, coverPhotoUrl?: string | null, resizedCoverPhotoUrl?: string | null, previewFoodItem?: { __typename?: 'FoodItem', id: number, imageUrl?: string | null, resizedImageUrl?: string | null } | null }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }> } | null };

export type GetCuisineCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCuisineCategoriesQuery = { __typename?: 'Query', cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, parentId?: string | null, subcuisines: Array<{ __typename?: 'CuisineCategory', id: string }> }> };

export type GetRegionalShefCuisineCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionalShefCuisineCategoriesQuery = { __typename?: 'Query', regionalShefCuisineCategories: Array<{ __typename?: 'ShefCuisineCategory', cuisineCategoryId: string }> };

export type GetMealPlanTypeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetMealPlanTypeQuery = { __typename?: 'Query', getMealPlanType: { __typename?: 'MealPlanType', displayName: string, unit: number, weeklyCost: number, pricePerUnit: number, numServings: number } };

export type UserPrefsFragment = { __typename?: 'TasteProfile', userId?: string | null, preferredProteins?: Array<Protein> | null, cuisinePreferences?: Array<string> | null, replacementDietaryRestrictions?: Array<DietaryRestriction> | null, menuDietaryRestrictions?: Array<DietaryRestriction> | null, dietType?: DietType | null };

export type MealPlanDisplayShefFragment = { __typename?: 'PublicShef', id: string, publicName: string, totalOrders: number, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, shefProfile: { __typename?: 'ShefProfile', bio?: string | null, fhcApprovedAt?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string }> } };

export type ShefProfileComponentFragment = { __typename?: 'PublicShef', publicName: string, flakeId: string, imageUrl?: string | null, firstName?: string | null, shefRosterStatus?: ShefRosterStatus | null, zipCode?: string | null, totalOrders: number, shefProfile: { __typename?: 'ShefProfile', bio?: string | null, primaryRegion?: { __typename?: 'RegionInfo', name: string } | null }, mealPlanFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, ratingCount: number, averageRating: number, imageUrl?: string | null, spiceLevel: number, portion?: string | null, servingSize?: string | null, ingredients?: string | null, description?: string | null, price: number, vegetarian?: boolean | null, vegan?: boolean | null, glutenFree: boolean, dairyFree: boolean, isHalal: boolean, isOrganic: boolean, lowFodmap?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, kosher?: boolean | null, packaging: Packaging, slug: string, numLabels?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', publicName: string, id: string }, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }>, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, regionalCuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string }> };

export type MealPlanDisplayFoodItemFragment = { __typename?: 'FoodItem', id: number, name?: string | null, ratingCount: number, averageRating: number, imageUrl?: string | null, spiceLevel: number, portion?: string | null, servingSize?: string | null, ingredients?: string | null, description?: string | null, price: number, vegetarian?: boolean | null, vegan?: boolean | null, glutenFree: boolean, dairyFree: boolean, isHalal: boolean, isOrganic: boolean, lowFodmap?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, kosher?: boolean | null, packaging: Packaging, slug: string, numLabels?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', publicName: string, id: string }, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null };

export type GetShefRosterQueryVariables = Exact<{
  tasteProfile: TasteProfileInput;
  zipCode: Scalars['String']['input'];
  deliveryDate: Scalars['String']['input'];
  mealPlanTypeId: Scalars['Int']['input'];
}>;


export type GetShefRosterQuery = { __typename?: 'Query', getShefRoster?: { __typename?: 'GetShefRosterResponse', shefs: Array<{ __typename?: 'PublicShef', id: string, firstName?: string | null, imageUrl?: string | null, shefRosterStatus?: ShefRosterStatus | null }> } | null };

export type GetShefInfoForProfilePageQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  tasteProfile?: InputMaybe<TasteProfileInput>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<MealPlanFormat>;
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  includeSoldOutDishes?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetShefInfoForProfilePageQuery = { __typename?: 'Query', shef: { __typename?: 'PublicShef', publicName: string, flakeId: string, imageUrl?: string | null, firstName?: string | null, shefRosterStatus?: ShefRosterStatus | null, zipCode?: string | null, totalOrders: number, shefProfile: { __typename?: 'ShefProfile', bio?: string | null, primaryRegion?: { __typename?: 'RegionInfo', name: string } | null }, mealPlanFoodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, ratingCount: number, averageRating: number, imageUrl?: string | null, spiceLevel: number, portion?: string | null, servingSize?: string | null, ingredients?: string | null, description?: string | null, price: number, vegetarian?: boolean | null, vegan?: boolean | null, glutenFree: boolean, dairyFree: boolean, isHalal: boolean, isOrganic: boolean, lowFodmap?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, kosher?: boolean | null, packaging: Packaging, slug: string, numLabels?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', publicName: string, id: string }, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }>, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, regionalCuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string }> }, publicReviews: { __typename?: 'PublicReviewResults', total: number, reviews: Array<{ __typename?: 'PublicReviewResult', id: number, createdAt: string, comment?: string | null, deliveryDate: string, user: { __typename?: 'ReviewUser', id: string, publicName: string, imageUrl: string }, dishes: Array<{ __typename?: 'OrderLineItem', rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null } | null }> }> } };

export type GetMealPlanningMenuQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  deliveryDate: Scalars['String']['input'];
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  dietType?: InputMaybe<DietType>;
  preferredProteins?: InputMaybe<Array<Protein> | Protein>;
  menuDietaryRestrictions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeFullCapacityShefs?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMealPlanningMenuQuery = { __typename?: 'Query', getMealPlanningMenu?: { __typename?: 'MealPlanningMenu', shefSegments: Array<{ __typename?: 'ShefSegment', shefRemainingAvailability: number, shef: { __typename?: 'PublicShef', flakeId: string, id: string, publicName: string, totalOrders: number, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, shefProfile: { __typename?: 'ShefProfile', bio?: string | null, fhcApprovedAt?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string }> } }, foodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, ratingCount: number, averageRating: number, imageUrl?: string | null, spiceLevel: number, portion?: string | null, servingSize?: string | null, ingredients?: string | null, description?: string | null, price: number, vegetarian?: boolean | null, vegan?: boolean | null, glutenFree: boolean, dairyFree: boolean, isHalal: boolean, isOrganic: boolean, lowFodmap?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, kosher?: boolean | null, packaging: Packaging, slug: string, numLabels?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', publicName: string, id: string }, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }> }>, mains: Array<{ __typename?: 'ShefSegment', shefRemainingAvailability: number, shef: { __typename?: 'PublicShef', flakeId: string, id: string, publicName: string, totalOrders: number, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, shefProfile: { __typename?: 'ShefProfile', bio?: string | null, fhcApprovedAt?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string }> } }, foodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, ratingCount: number, averageRating: number, imageUrl?: string | null, spiceLevel: number, portion?: string | null, servingSize?: string | null, ingredients?: string | null, description?: string | null, price: number, vegetarian?: boolean | null, vegan?: boolean | null, glutenFree: boolean, dairyFree: boolean, isHalal: boolean, isOrganic: boolean, lowFodmap?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, kosher?: boolean | null, packaging: Packaging, slug: string, numLabels?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', publicName: string, id: string }, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }> }>, sides: Array<{ __typename?: 'ShefSegment', shefRemainingAvailability: number, shef: { __typename?: 'PublicShef', flakeId: string, id: string, publicName: string, totalOrders: number, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, shefProfile: { __typename?: 'ShefProfile', bio?: string | null, fhcApprovedAt?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string }> } }, foodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, ratingCount: number, averageRating: number, imageUrl?: string | null, spiceLevel: number, portion?: string | null, servingSize?: string | null, ingredients?: string | null, description?: string | null, price: number, vegetarian?: boolean | null, vegan?: boolean | null, glutenFree: boolean, dairyFree: boolean, isHalal: boolean, isOrganic: boolean, lowFodmap?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, kosher?: boolean | null, packaging: Packaging, slug: string, numLabels?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', publicName: string, id: string }, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }> }>, userPrefs?: { __typename?: 'TasteProfile', userId?: string | null, preferredProteins?: Array<Protein> | null, cuisinePreferences?: Array<string> | null, replacementDietaryRestrictions?: Array<DietaryRestriction> | null, menuDietaryRestrictions?: Array<DietaryRestriction> | null, dietType?: DietType | null } | null } | null };

export type MealPlanningPurchaseAttemptMutationVariables = Exact<{
  input: MealPlanningPurchaseInput;
}>;


export type MealPlanningPurchaseAttemptMutation = { __typename?: 'Mutation', attemptMealPlanningPurchase: boolean };

export type InitializeMealPlanMutationVariables = Exact<{
  input: InitializeMealPlanInput;
}>;


export type InitializeMealPlanMutation = { __typename?: 'Mutation', initializeMealPlan: { __typename?: 'InitializeMealPlanResponse', success: boolean, message: string, groupOrderId?: string | null } };

export type ModifyHeldGroupOrderMutationVariables = Exact<{
  input: ModifyHeldGroupOrderInput;
}>;


export type ModifyHeldGroupOrderMutation = { __typename?: 'Mutation', modifyHeldGroupOrder: { __typename?: 'ModifyHeldGroupOrderResponse', success: boolean, message: string, orders: Array<{ __typename?: 'Order', id: number }> } };

export type GetSubscriptionQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetSubscriptionQuery = { __typename?: 'Query', getMealPlanForUser?: { __typename?: 'UserMealPlan', nextDeliveryDate?: string | null, mealPlanRegionId?: number | null, mealPlanZipCode?: string | null, mealPlan?: { __typename?: 'MealPlan', id: string, isReusablePackagingPlan: boolean, mealPlanType: { __typename?: 'MealPlanType', unit: number, pricePerUnit: number, weeklyCost: number, numServings: number, id: number, displayName: string, format?: MealPlanFormat | null, regionId?: number | null } } | null } | null, getTasteProfile: { __typename?: 'GetTasteProfileResponse', tasteProfile?: { __typename?: 'TasteProfile', id?: string | null, dietType?: DietType | null, replacementDietaryRestrictions?: Array<DietaryRestriction> | null, menuDietaryRestrictions?: Array<DietaryRestriction> | null, preferredProteins?: Array<Protein> | null, cuisinePreferences?: Array<string> | null, numAdults?: number | null, numLittleEaters?: number | null, numBigEaters?: number | null } | null } };

export type MarkUserVisitedPreferencesPageMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkUserVisitedPreferencesPageMutation = { __typename?: 'Mutation', markUserVisitedPreferencesPage: { __typename?: 'User', id: string } };

export type UpdateTasteProfileMutationVariables = Exact<{
  input: TasteProfileMutationInput;
}>;


export type UpdateTasteProfileMutation = { __typename?: 'Mutation', updateTasteProfile: { __typename?: 'TasteProfileMutationResponse', tasteProfile?: { __typename?: 'TasteProfile', dietType?: DietType | null, replacementDietaryRestrictions?: Array<DietaryRestriction> | null, menuDietaryRestrictions?: Array<DietaryRestriction> | null, preferredProteins?: Array<Protein> | null, cuisinePreferences?: Array<string> | null } | null } };

export type GetTasteProfileQueryVariables = Exact<{
  input: GetTasteProfileInput;
}>;


export type GetTasteProfileQuery = { __typename?: 'Query', getTasteProfile: { __typename?: 'GetTasteProfileResponse', tasteProfile?: { __typename?: 'TasteProfile', id?: string | null, dietType?: DietType | null, replacementDietaryRestrictions?: Array<DietaryRestriction> | null, menuDietaryRestrictions?: Array<DietaryRestriction> | null, preferredProteins?: Array<Protein> | null, cuisinePreferences?: Array<string> | null } | null } };

export type MealPlanPromoCodeAppliedFragment = { __typename?: 'PromoCode', value: number, isPercentage: boolean };

export type GetMealEditDataQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetMealEditDataQuery = { __typename?: 'Query', getTasteProfile: { __typename?: 'GetTasteProfileResponse', tasteProfile?: { __typename?: 'TasteProfile', id?: string | null, cuisinePreferences?: Array<string> | null, menuDietaryRestrictions?: Array<DietaryRestriction> | null, dietType?: DietType | null, preferredProteins?: Array<Protein> | null } | null }, getMealPlanUpcomingOrder?: { __typename?: 'GetMealPlanUpcomingOrderResponse', mealPlanUpcomingOrder?: { __typename?: 'MealPlanUpcomingOrder', sidesPerWeek: number, mealPlanOrderStatus?: MealPlanOrderStatus | null, mealPlanGroupOrderId?: string | null, promoCodeApplied?: { __typename?: 'PromoCode', value: number, isPercentage: boolean } | null, mealPlanGroupOrder: { __typename?: 'GroupOrder', id: string, regionId?: number | null, deliveryDate: string, mealPlanType?: { __typename?: 'MealPlanType', unit: number, numServings: number, weeklyCost: number, format?: MealPlanFormat | null } | null, orders: Array<{ __typename?: 'Order', id: number, groupOrderId: string, deliveryDate: string, orderStatus: OrderStatus, publicShef: { __typename?: 'PublicShef', id: string, publicName: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, foodItem: { __typename?: 'FoodItem', id: number, imageUrl?: string | null, averageRating: number, ratingCount: number, price: number, spiceLevel: number, name?: string | null, foodType?: FoodType | null, shef: { __typename?: 'PublicShef', publicName: string, id: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } }> }>, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number } }, mainDishes?: Array<{ __typename?: 'FoodItem', id: number }> | null, sideDishes?: Array<{ __typename?: 'FoodItem', id: number }> | null } | null } | null };

export type GetShefCountForRegionQueryVariables = Exact<{
  regionId: Scalars['Int']['input'];
  mealPlanType: Scalars['String']['input'];
}>;


export type GetShefCountForRegionQuery = { __typename?: 'Query', countMealPlanShefsForRegionId?: { __typename?: 'CountMealPlanShefsForRegionIdResults', shefCount: number } | null };

export type SkipMealPlanGroupOrderMutationVariables = Exact<{
  deliveryDate: Scalars['String']['input'];
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SkipMealPlanGroupOrderMutation = { __typename?: 'Mutation', skipMealPlanGroupOrder: { __typename?: 'SkipMealPlanGroupOrderResponse', groupOrderId?: string | null, success: boolean, message: string } };

export type UnskipMealPlanGroupOrderMutationVariables = Exact<{
  groupOrderId: Scalars['String']['input'];
}>;


export type UnskipMealPlanGroupOrderMutation = { __typename?: 'Mutation', unskipMealPlanGroupOrder: { __typename?: 'UnskipMealPlanGroupOrderResponse', success: boolean, message: string } };

export type ConsumerModifyMealPlanMutationVariables = Exact<{
  input: ModifyMealPlanInput;
}>;


export type ConsumerModifyMealPlanMutation = { __typename?: 'Mutation', modifyMealPlan: { __typename?: 'ModifyMealPlanResponse', success: boolean, message: string } };

export type GetManageMealPlanPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManageMealPlanPageQuery = { __typename?: 'Query', getActiveMealPlanForUser?: { __typename?: 'MealPlan', id: string, mondayDelivery: boolean, tuesdayDelivery: boolean, wednesdayDelivery: boolean, thursdayDelivery: boolean, fridayDelivery: boolean, saturdayDelivery: boolean, sundayDelivery: boolean } | null };

export type ModifyMealPlanPageQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ModifyMealPlanPageQuery = { __typename?: 'Query', getMealPlanUpcomingOrder?: { __typename?: 'GetMealPlanUpcomingOrderResponse', mealPlanUpcomingOrder?: { __typename?: 'MealPlanUpcomingOrder', nextDeliveryDate?: string | null, mealPlanOrderStatus?: MealPlanOrderStatus | null, sidesPerWeek: number, promoCodeApplied?: { __typename?: 'PromoCode', value: number, isPercentage: boolean } | null } | null } | null };

export type ManagePlanScheduleFragment = { __typename?: 'Order', timeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number } };

export type GetManagePlanDeliveryScheduleQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  filters: ExploreFoodItemsFilterInput;
  deliveryDate: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetManagePlanDeliveryScheduleQuery = { __typename?: 'Query', upcomingOrders: Array<{ __typename?: 'Order', timeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number } }>, exploreFoodItemsFilterOptions?: { __typename?: 'ExploreFoodItemsFilterOptionsResults', isEcoFriendlyFilterAvailable: boolean, totalShefs: number, availableDeliveryDays: Array<{ __typename?: 'NumberAvailableDishesResult', date: string, count: number }>, availableCuisines: Array<{ __typename?: 'CuisineCategory', id: string, title: string, isPrimary: boolean, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean, title: string }>, subcuisines: Array<{ __typename?: 'CuisineCategory', id: string }>, categoryPageContent?: { __typename?: 'CategoryPageContent', pageType: CategoryPageType, title: string, subTitle?: string | null, illustrationUrl?: string | null, fadeSegmentBackground?: boolean | null, segmentBackgroundUrl: string, segmentBackgroundUrlTablet?: string | null, segmentBackgroundUrlDesktop?: string | null, heroBackgroundUrl?: string | null, heroBackgroundUrlTablet?: string | null, heroBackgroundUrlDesktop?: string | null, patternedStripUrl: string, moreCuisinesBackgroundUrl: string, moreCuisinesBackgroundUrlTablet?: string | null, moreCuisinesBackgroundUrlDesktop?: string | null, referralStripTextColor: ReferralStripTextColor, referralStripBackgroundUrl: string, referralStripBackgroundUrlTablet?: string | null, referralStripBackgroundUrlDesktop?: string | null, searchSuggestions?: Array<{ __typename?: 'CategoryPageSearchSuggestion', display: string, searchQuery?: string | null }> | null } | null }> } | null, zipCode?: { __typename?: 'ZipCode', zipCode: string, timeWindows: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> } | null, getUpcomingMealPlanGroupOrders?: { __typename?: 'GetUpcomingMealPlanGroupOrdersResponse', groupOrders?: Array<{ __typename?: 'GroupOrder', deliveryDate: string }> | null } | null, getActiveMealPlanForUser?: { __typename?: 'MealPlan', id: string, mondayDelivery: boolean, tuesdayDelivery: boolean, wednesdayDelivery: boolean, thursdayDelivery: boolean, fridayDelivery: boolean, saturdayDelivery: boolean, sundayDelivery: boolean } | null };

export type GetManagePlanServingsPageQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetManagePlanServingsPageQuery = { __typename?: 'Query', getMealPlanUpcomingOrder?: { __typename?: 'GetMealPlanUpcomingOrderResponse', mealPlanUpcomingOrder?: { __typename?: 'MealPlanUpcomingOrder', nextDeliveryDate?: string | null, mealPlanOrderStatus?: MealPlanOrderStatus | null, sidesPerWeek: number, promoCodeApplied?: { __typename?: 'PromoCode', value: number, isPercentage: boolean } | null } | null } | null, getMealPlanTypeOptions: Array<{ __typename?: 'MealPlanTypeOption', mealPlanType: { __typename?: 'MealPlanType', id: number, displayName: string, unit: number, weeklyCost: number, pricePerUnit: number, numServings: number, format?: MealPlanFormat | null, regionId?: number | null } }>, getActiveMealPlanForUser?: { __typename?: 'MealPlan', id: string, status: MealPlanStatus, mealPlanType: { __typename?: 'MealPlanType', displayName: string, id: number, pricePerUnit: number, unit: number, numServings: number, weeklyCost: number, format?: MealPlanFormat | null } } | null, getTasteProfile: { __typename?: 'GetTasteProfileResponse', tasteProfile?: { __typename?: 'TasteProfile', id?: string | null, dietType?: DietType | null, replacementDietaryRestrictions?: Array<DietaryRestriction> | null, menuDietaryRestrictions?: Array<DietaryRestriction> | null, preferredProteins?: Array<Protein> | null, cuisinePreferences?: Array<string> | null, numAdults?: number | null, numLittleEaters?: number | null, numBigEaters?: number | null } | null }, getUpcomingMealPlanGroupOrders?: { __typename?: 'GetUpcomingMealPlanGroupOrdersResponse', groupOrders?: Array<{ __typename?: 'GroupOrder', deliveryDate: string, mealPlanType?: { __typename?: 'MealPlanType', unit: number, numServings: number, weeklyCost: number, format?: MealPlanFormat | null } | null }> | null } | null };

export type GetDeliveryWindowsForZipCodeAndDateQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  deliveryDate: Scalars['String']['input'];
}>;


export type GetDeliveryWindowsForZipCodeAndDateQuery = { __typename?: 'Query', zipCode?: { __typename?: 'ZipCode', zipCode: string, timeWindows: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> } | null };

export type AddTasteProfileMutationVariables = Exact<{
  input: TasteProfileMutationInput;
}>;


export type AddTasteProfileMutation = { __typename?: 'Mutation', addTasteProfile: { __typename?: 'TasteProfileMutationResponse', message: string, success: boolean } };

export type GetMealPlanTypeOptionsQueryVariables = Exact<{
  adults?: InputMaybe<Scalars['Int']['input']>;
  littleEaters?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMealPlanTypeOptionsQuery = { __typename?: 'Query', getMealPlanTypeOptions: Array<{ __typename?: 'MealPlanTypeOption', title?: string | null, subtitle?: string | null, isRecommended?: boolean | null, isDisabled: boolean, mealPlanType: { __typename?: 'MealPlanType', unit: number, pricePerUnit: number, weeklyCost: number, numServings: number, id: number, displayName: string, format?: MealPlanFormat | null, regionId?: number | null } }> };

export type MealPlanDishCardFoodItemFragment = { __typename?: 'FoodItem', id: number, imageUrl?: string | null, averageRating: number, ratingCount: number, price: number, spiceLevel: number, name?: string | null, foodType?: FoodType | null, shef: { __typename?: 'PublicShef', publicName: string, id: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null };

export type MealPlanUpcomingOrderMealPlanFragment = { __typename?: 'MealPlan', id: string, status: MealPlanStatus, isReusablePackagingPlan: boolean, mealPlanType: { __typename?: 'MealPlanType', unit: number, numServings: number, format?: MealPlanFormat | null } };

export type MealPlanOliFragment = { __typename?: 'OrderLineItem', id: number, quantity: number, foodItem: { __typename?: 'FoodItem', id: number, imageUrl?: string | null, averageRating: number, ratingCount: number, price: number, spiceLevel: number, name?: string | null, foodType?: FoodType | null, shef: { __typename?: 'PublicShef', publicName: string, id: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } };

export type MealPlanUpcomingOrderFragment = { __typename?: 'Order', id: number, groupOrderId: string, deliveryDate: string, orderStatus: OrderStatus, publicShef: { __typename?: 'PublicShef', id: string, publicName: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, foodItem: { __typename?: 'FoodItem', id: number, imageUrl?: string | null, averageRating: number, ratingCount: number, price: number, spiceLevel: number, name?: string | null, foodType?: FoodType | null, shef: { __typename?: 'PublicShef', publicName: string, id: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } }> };

export type UpcomingMealPlanGroupOrderFragment = { __typename?: 'GroupOrder', id: string, regionId?: number | null, deliveryDate: string, mealPlanType?: { __typename?: 'MealPlanType', unit: number, numServings: number, weeklyCost: number, format?: MealPlanFormat | null } | null, orders: Array<{ __typename?: 'Order', id: number, groupOrderId: string, deliveryDate: string, orderStatus: OrderStatus, publicShef: { __typename?: 'PublicShef', id: string, publicName: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, foodItem: { __typename?: 'FoodItem', id: number, imageUrl?: string | null, averageRating: number, ratingCount: number, price: number, spiceLevel: number, name?: string | null, foodType?: FoodType | null, shef: { __typename?: 'PublicShef', publicName: string, id: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } }> }>, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number } };

export type MealPlanOrderFragment = { __typename?: 'Order', id: number, groupOrderId: string, deliveryDate: string, orderStatus: OrderStatus };

export type GetMealPlanUpcomingOrderQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetMealPlanUpcomingOrderQuery = { __typename?: 'Query', getMealPlanDeliveries: { __typename?: 'GetMealPlanDeliveriesResponse', deliveryDates: Array<string>, message: string, success: boolean, orders: Array<{ __typename?: 'Order', id: number, groupOrderId: string, deliveryDate: string, orderStatus: OrderStatus }> }, getMealPlanUpcomingOrder?: { __typename?: 'GetMealPlanUpcomingOrderResponse', message: string, success: boolean, mealPlanUpcomingOrder?: { __typename?: 'MealPlanUpcomingOrder', mealPlanOrderStatus?: MealPlanOrderStatus | null, nextDeliveryDate?: string | null, sidesPerWeek: number, mealPlan: { __typename?: 'MealPlan', id: string, status: MealPlanStatus, isReusablePackagingPlan: boolean, mealPlanType: { __typename?: 'MealPlanType', unit: number, numServings: number, format?: MealPlanFormat | null } }, mealPlanGroupOrder: { __typename?: 'GroupOrder', id: string, regionId?: number | null, deliveryDate: string, mealPlanType?: { __typename?: 'MealPlanType', unit: number, numServings: number, weeklyCost: number, format?: MealPlanFormat | null } | null, orders: Array<{ __typename?: 'Order', id: number, groupOrderId: string, deliveryDate: string, orderStatus: OrderStatus, publicShef: { __typename?: 'PublicShef', id: string, publicName: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, foodItem: { __typename?: 'FoodItem', id: number, imageUrl?: string | null, averageRating: number, ratingCount: number, price: number, spiceLevel: number, name?: string | null, foodType?: FoodType | null, shef: { __typename?: 'PublicShef', publicName: string, id: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } }> }>, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number } } } | null } | null };

export type GetUpcomingMealPlanGroupOrdersQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUpcomingMealPlanGroupOrdersQuery = { __typename?: 'Query', getUpcomingMealPlanGroupOrders?: { __typename?: 'GetUpcomingMealPlanGroupOrdersResponse', message: string, success: boolean, groupOrders?: Array<{ __typename?: 'GroupOrder', id: string, regionId?: number | null, deliveryDate: string, mealPlanType?: { __typename?: 'MealPlanType', unit: number, numServings: number, weeklyCost: number, format?: MealPlanFormat | null } | null, orders: Array<{ __typename?: 'Order', id: number, groupOrderId: string, deliveryDate: string, orderStatus: OrderStatus, publicShef: { __typename?: 'PublicShef', id: string, publicName: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, foodItem: { __typename?: 'FoodItem', id: number, imageUrl?: string | null, averageRating: number, ratingCount: number, price: number, spiceLevel: number, name?: string | null, foodType?: FoodType | null, shef: { __typename?: 'PublicShef', publicName: string, id: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } }> }>, timeWindow: { __typename?: 'OrderTimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number } }> | null } | null };

export type ConsumerGroupOrderCancelQueryQueryVariables = Exact<{
  groupOrderId: Scalars['String']['input'];
}>;


export type ConsumerGroupOrderCancelQueryQuery = { __typename?: 'Query', groupOrdersByIds: Array<{ __typename?: 'GroupOrder', id: string, isCancelled: boolean, isFullyRefunded: boolean }> };

export type EditOrderDeliveryFieldsFragment = { __typename?: 'Order', id: number, shefId: string, deliveryDate: string, deliveryNotes?: string | null, deliveryAddressId: number, timeWindowId?: number | null, phone: string, shefProfile: { __typename?: 'ShefProfile', id: number, timeZone: string, primaryRegion?: { __typename?: 'RegionInfo', id: number } | null }, address: { __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, regionId: number, timeWindows: Array<{ __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }> } | null }, possibleDeliveryDates: Array<{ __typename?: 'PossibleDeliveryDate', date: string, possible: DeliveryDateChangePossible, reason?: string | null, unavailableItems: Array<{ __typename?: 'UnavailableFoodItem', quantityAvailable: number, foodItem: { __typename?: 'FoodItem', id: number } }> }> };

export type ConsumerEditOrderDeliveryQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsumerEditOrderDeliveryQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, publicName: string, activeAddresses: Array<{ __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, regionId: number } | null }> } | null };

export type ConsumerModifyOrderMutationVariables = Exact<{
  input: ConsumerModifyGroupOrderInput;
}>;


export type ConsumerModifyOrderMutation = { __typename?: 'Mutation', consumerModifyGroupOrder: { __typename?: 'GroupOrder', id: string } };

export type ConsumerFoodItemAvailabilityFragment = { __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null };

export type ConsumerOrderDishSelectionItemFragment = { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> };

export type ConsumerFoodItemFragment = { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> };

export type ShefDeliveryPricesFragment = { __typename?: 'PublicShef', deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null };

export type OrderShefProfileFragment = { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, coverPhotoUrl?: string | null, specialty?: string | null, cuisineRegion?: CuisineRegion | null, bio?: string | null, videoUrl?: string | null, randomZip?: string | null, cutoffMsBeforeDeliveryDate: number, timeZone: string, dishCapacity: number, mehkoLicenseNumber?: string | null, allowedToChat: boolean, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, fulfillmentOption?: string | null, fhcApprovedAt?: string | null, isBlockedDueToMissingFHC: boolean, previewFoodItem?: { __typename?: 'FoodItem', imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, approximateLocation?: { __typename?: 'Location', latitude: number, longitude: number } | null };

export type OrderShefFragment = { __typename?: 'PublicShef', id: string, flakeId: string, firstName?: string | null, publicName: string, imageUrl?: string | null, isTopShef: boolean, celebrityEventType?: CelebrityEventType | null, totalOrders: number, timeZone: string, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, coverPhotoUrl?: string | null, specialty?: string | null, cuisineRegion?: CuisineRegion | null, bio?: string | null, videoUrl?: string | null, randomZip?: string | null, cutoffMsBeforeDeliveryDate: number, timeZone: string, dishCapacity: number, mehkoLicenseNumber?: string | null, allowedToChat: boolean, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, fulfillmentOption?: string | null, fhcApprovedAt?: string | null, isBlockedDueToMissingFHC: boolean, previewFoodItem?: { __typename?: 'FoodItem', imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, approximateLocation?: { __typename?: 'Location', latitude: number, longitude: number } | null }, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string, isSoldOut: boolean, numDishesAvailable: number }> };

export type ConsumerOrderReviewFragment = { __typename?: 'PublicReviewResult', id: number, createdAt: string, comment?: string | null, deliveryDate: string, user: { __typename?: 'ReviewUser', id: string, publicName: string, imageUrl: string }, dishes: Array<{ __typename?: 'OrderLineItem', rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null } | null }> };

export type ShefMenuSegmentFragment = { __typename?: 'ExploreFoodItemsSegment', cacheKey: string, id: string, layout: ExploreFoodItemsSegmentLayout, displayName: string, icon?: SegmentIcon | null, content: { __typename?: 'ExploreFoodItemsContent', total: number, items: Array<{ __typename?: 'CuisineCategory' } | { __typename?: 'ExploreSegmentShef' } | { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } | { __typename?: 'PublicShef' }> }, preview?: { __typename?: 'ExploreFoodItemsSegmentPreview', seeAllText: string, showAllFiltersWhenExpanded: boolean, seeAllFilter?: { __typename?: 'ExploreFoodItemsPreviewFilter', availabilityDates?: Array<string> | null, cuisineFilters?: Array<string> | null, dietaryFilters?: Array<string> | null, dishTypeFilters?: Array<FoodTypeCoalesced> | null, isEcoFriendlyPackaging?: boolean | null, minDishRating?: number | null, priceLevelFilters?: Array<PriceLevel> | null, proteinFilters?: Array<Protein> | null, spiceLevelFilters?: Array<number> | null } | null } | null };

export type ShefMenuSegmentsQueryQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  availableDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<ExploreFoodItemsFilterInput>;
}>;


export type ShefMenuSegmentsQueryQuery = { __typename?: 'Query', shefMenuSegments: Array<{ __typename?: 'ExploreFoodItemsSegment', cacheKey: string, id: string, layout: ExploreFoodItemsSegmentLayout, displayName: string, icon?: SegmentIcon | null, content: { __typename?: 'ExploreFoodItemsContent', total: number, items: Array<{ __typename?: 'CuisineCategory' } | { __typename?: 'ExploreSegmentShef' } | { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> } | { __typename?: 'PublicShef' }> }, preview?: { __typename?: 'ExploreFoodItemsSegmentPreview', seeAllText: string, showAllFiltersWhenExpanded: boolean, seeAllFilter?: { __typename?: 'ExploreFoodItemsPreviewFilter', availabilityDates?: Array<string> | null, cuisineFilters?: Array<string> | null, dietaryFilters?: Array<string> | null, dishTypeFilters?: Array<FoodTypeCoalesced> | null, isEcoFriendlyPackaging?: boolean | null, minDishRating?: number | null, priceLevelFilters?: Array<PriceLevel> | null, proteinFilters?: Array<Protein> | null, spiceLevelFilters?: Array<number> | null } | null } | null }> };

export type ShefMenuItemsQueryQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  availableDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters: ExploreFoodItemsFilterInput;
}>;


export type ShefMenuItemsQueryQuery = { __typename?: 'Query', shefMenuFilteredItems: { __typename?: 'FilteredFoodItemResults', partialMatches: Array<{ __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }>, perfectMatches: Array<{ __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }> } };

export type ShefOrderQueryQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
  availableDate?: InputMaybe<Scalars['DateTime']['input']>;
  reviews: Scalars['Int']['input'];
}>;


export type ShefOrderQueryQuery = { __typename?: 'Query', validDaysOfWeek: Array<number>, shef: { __typename?: 'PublicShef', id: string, flakeId: string, firstName?: string | null, publicName: string, imageUrl?: string | null, isTopShef: boolean, celebrityEventType?: CelebrityEventType | null, totalOrders: number, timeZone: string, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, coverPhotoUrl?: string | null, specialty?: string | null, cuisineRegion?: CuisineRegion | null, bio?: string | null, videoUrl?: string | null, randomZip?: string | null, cutoffMsBeforeDeliveryDate: number, timeZone: string, dishCapacity: number, mehkoLicenseNumber?: string | null, allowedToChat: boolean, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, fulfillmentOption?: string | null, fhcApprovedAt?: string | null, isBlockedDueToMissingFHC: boolean, previewFoodItem?: { __typename?: 'FoodItem', imageUrl?: string | null } | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, explorePagePromoCode?: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean } | null, approximateLocation?: { __typename?: 'Location', latitude: number, longitude: number } | null }, deliveryPrice?: { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number } | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string, isSoldOut: boolean, numDishesAvailable: number }> }, consumerFoodItems: Array<{ __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug: string, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, servingSize?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, spiceLevel: number, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, ratingCount: number, averageRating: number, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, topPositiveTags: Array<string>, startDate: string, endDate: string, holiday?: Holiday | null, numServings?: number | null, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }>, zipCode?: { __typename?: 'ZipCode', zipCode: string } | null, publicReviews: { __typename?: 'PublicReviewResults', total: number, reviews: Array<{ __typename?: 'PublicReviewResult', id: number, createdAt: string, comment?: string | null, deliveryDate: string, user: { __typename?: 'ReviewUser', id: string, publicName: string, imageUrl: string }, dishes: Array<{ __typename?: 'OrderLineItem', rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null } | null }> }> } };

export type ConsumerOrderDishDescriptionModalFoodItemFragment = { __typename?: 'FoodItem', id: number, userId: string, imageUrl?: string | null, name?: string | null, slug: string, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null };

export type ConsumerOrderFreeDeliveryModalPublicShefFragment = { __typename?: 'PublicShef', id: string, publicName: string, firstName?: string | null, activeFoodItems: Array<{ __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }> };

export type PromoCodeValueQueryQueryVariables = Exact<{
  code: Scalars['String']['input'];
  shefSubtotals?: InputMaybe<Array<ShefSubtotal> | ShefSubtotal>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type PromoCodeValueQueryQuery = { __typename?: 'Query', promoCodeValue?: { __typename?: 'PromoCodeResult', promoCodeString: string, error?: string | null, code?: { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null, organization?: { __typename?: 'Organization', id: number, name: string, address?: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCode: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null } | null } | null };

export type AllPromoCodeValuesQueryVariables = Exact<{
  codes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  shefSubtotals?: InputMaybe<Array<ShefSubtotal> | ShefSubtotal>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllPromoCodeValuesQuery = { __typename?: 'Query', promoCodeValues?: Array<{ __typename?: 'PromoCodeResult', promoCodeString: string, error?: string | null, code?: { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null, organization?: { __typename?: 'Organization', id: number, name: string, address?: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCode: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null } | null }> | null };

export type DishDescriptionFoodItemFragment = { __typename?: 'FoodItem', id: number, name?: string | null, price: number, spiceLevel: number, description?: string | null, vegetarian?: boolean | null, vegan?: boolean | null, glutenFree: boolean, dairyFree: boolean, lowFodmap?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, isPopular?: boolean | null, packaging: Packaging, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, containsNuts: boolean };

export type DishModalFoodItemFragment = { __typename?: 'FoodItem', averageRating: number, ratingCount: number, topPositiveTags: Array<string>, foodItemId: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, shefProfile: { __typename?: 'ShefProfile', isTrialShef: boolean } } };

export type DishModalQueryVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
}>;


export type DishModalQuery = { __typename?: 'Query', foodItem: { __typename?: 'FoodItem', averageRating: number, ratingCount: number, topPositiveTags: Array<string>, foodItemId: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null, shefProfile: { __typename?: 'ShefProfile', isTrialShef: boolean } } } };

export type DishModalReviewsQueryVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type DishModalReviewsQuery = { __typename?: 'Query', foodItemOrderReviews: { __typename?: 'PublicReviewResults', reviews: Array<{ __typename?: 'PublicReviewResult', id: number, orderId: number, createdAt: string, deliveryDate: string, comment?: string | null, user: { __typename?: 'ReviewUser', id: string, flakeId: string, publicName: string }, dishes: Array<{ __typename?: 'OrderLineItem', id: number, name: string, imageUrl: string, rating?: { __typename?: 'FoodItemRating', id: number, ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', id: string, tag: string }> | null } | null }> }> } };

export type PeopleAlsoOrderedQueryVariables = Exact<{
  deliveryDate: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  cartFoodItemIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PeopleAlsoOrderedQuery = { __typename?: 'Query', peopleAlsoOrderedRecommendations: Array<{ __typename?: 'FoodItem', userId: string, name?: string | null, imageUrl?: string | null, description?: string | null, slug: string, price: number, averageRating: number, ratingCount: number, topPositiveTags: Array<string>, foodType?: FoodType | null, vegan?: boolean | null, vegetarian?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, whole30?: boolean | null, glutenFree: boolean, dairyFree: boolean, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isHalal: boolean, isOrganic: boolean, packaging: Packaging, portion?: string | null, servingSize?: string | null, spiceLevel: number, ingredients?: string | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, foodItemId: number, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, shef: { __typename?: 'PublicShef', id: string, firstName?: string | null, publicName: string, imageUrl?: string | null, celebrityEventType?: CelebrityEventType | null, availability: Array<{ __typename?: 'ShefAvailability', availabilityDate: string, isSoldOut: boolean, numDishesAvailable: number }>, shefProfile: { __typename?: 'ShefProfile', id: number, isTrialShef: boolean, timeZone: string, cuisineRegion?: CuisineRegion | null, dishCapacity: number, specialty?: string | null, bio?: string | null, cutoffMsBeforeDeliveryDate: number, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }> }, rating?: { __typename?: 'ShefRating', score: number, count: number } | null } }> };

export type RecentTasteOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentTasteOrdersQuery = { __typename?: 'Query', me?: { __typename?: 'User', recentTasteTests: number, admin: boolean } | null };

export type ModalReviewFragment = { __typename?: 'PublicReviewResult', id: number, comment?: string | null, deliveryDate: string, dishes: Array<{ __typename?: 'OrderLineItem', id: number, name: string, imageUrl: string, slug: string, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }>, user: { __typename?: 'ReviewUser', id: string, publicName: string, imageUrl: string } };

export type ReviewsModalQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ReviewsModalQuery = { __typename?: 'Query', publicReviews: { __typename?: 'PublicReviewResults', total: number, reviews: Array<{ __typename?: 'PublicReviewResult', id: number, comment?: string | null, deliveryDate: string, dishes: Array<{ __typename?: 'OrderLineItem', id: number, name: string, imageUrl: string, slug: string, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }>, user: { __typename?: 'ReviewUser', id: string, publicName: string, imageUrl: string } }> }, shef: { __typename?: 'PublicShef', publicName: string, timeZone: string, totalOrders: number, rating?: { __typename?: 'ShefRating', score: number, count: number } | null } };

export type DietaryDetailsForShefQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type DietaryDetailsForShefQuery = { __typename?: 'Query', dietaryDetailsForShef: Array<{ __typename?: 'DietaryDetails', id: string, name: string, summaryId: string, summaryDisplay: string, summaryExplanation?: string | null, dietaryTag: string, responses: Array<{ __typename?: 'VerifiedDietaryResponse', questionId: string, response: MultiResponse, responseDisplay?: string | null, responseFreeText?: string | null }> }> };

export type SuggestedSidesResultFragment = { __typename?: 'SuggestedItem', foodItemId: number, orderAffinity: number, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } };

export type SuggestedSidesQueryVariables = Exact<{
  foodItemId: Scalars['Int']['input'];
  numMains: Scalars['Int']['input'];
  deliveryDate: Scalars['DateTime']['input'];
  shefTimeZone: Scalars['String']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuggestedSidesQuery = { __typename?: 'Query', suggestedItemsFromMenu: Array<{ __typename?: 'SuggestedItem', foodItemId: number, orderAffinity: number, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } }> };

export type GroupOrderReceiptFieldsFragment = { __typename?: 'GroupOrder', id: string, uuid: string, userId: string, orderType: OrderType, deliveryDate: string, deliveryType: string, deliveryNotes?: string | null, phone: string, timeWindowId?: number | null, deliveryAddressId: number, pickupAddressId?: number | null, pickupDeliveryId?: number | null, dayOfEmailScheduledTaskId?: number | null, subscriptionInvoiceId?: string | null, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, delivery?: { __typename?: 'Delivery', id: string, estimatedDeliveryTime?: string | null, driverName?: string | null, driverPhone?: string | null } | null, pickupAddress?: { __typename?: 'Address', id: number, formattedAddress?: string | null, latitude: number, longitude: number, deliveryNotes?: string | null } | null, deliveryAddress: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, timeZone: string } | null }, promoCodes: Array<{ __typename?: 'PromoCode', id: number, value: number, code: string, promoCodeType: PromoCodeType }>, orders: Array<{ __typename?: 'Order', id: number, createdAt: string, subtotal: number, deliveryDate: string, orderType: OrderType, orderStatus: OrderStatus, consumerOrderStatus: ConsumerOrderStatus, isCancelable: boolean, isDeliveryEditable: boolean, isLineItemsEditable: boolean, deliveryType: string, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, imageUrl: string, flakeId: string }, user: { __typename?: 'User', id: string, firstName: string, lastName: string, publicName: string, email: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, price: number, foodItemSnapshot?: any | null, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, spiceLevel: number, servingSize?: string | null, portion?: string | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', name: string } }> | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', name: string } }> | null, shef: { __typename?: 'PublicShef', id: string, publicName: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', price: number, tier: UpsellTier } | null } }>, addOnItems: Array<{ __typename?: 'OrderAddOnItem', id: number, quantity: number, price: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, price: number, imageUrl: string, displayText: string, addonType: AddOnItemType } }>, address: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCode: string, phone: string, name?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, timeZone: string } | null }, timeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, delivery?: { __typename?: 'Delivery', id: string, estimatedDeliveryTime?: string | null, driverPhone?: string | null, driverName?: string | null } | null, pickupAddress?: { __typename?: 'Address', id: number, latitude: number, longitude: number, formattedAddress?: string | null, deliveryNotes?: string | null, phone: string } | null, promoCode?: { __typename?: 'PromoCode', promoCodeType: PromoCodeType } | null }>, orderTotals: { __typename?: 'ConsumerOrderTotal', promoApplied: number, nonPromoDiscountApplied: number, salesTax: number, deliveryFee: number, smallOrderFee: number, serviceFee: number, shefTip: number, subtotal: number, grandTotal: number } };

export type GroupOrderReceiptQueryVariables = Exact<{
  groupOrderId: Scalars['String']['input'];
}>;


export type GroupOrderReceiptQuery = { __typename?: 'Query', groupOrdersByIds: Array<{ __typename?: 'GroupOrder', id: string, uuid: string, userId: string, orderType: OrderType, deliveryDate: string, deliveryType: string, deliveryNotes?: string | null, phone: string, timeWindowId?: number | null, deliveryAddressId: number, pickupAddressId?: number | null, pickupDeliveryId?: number | null, dayOfEmailScheduledTaskId?: number | null, subscriptionInvoiceId?: string | null, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, delivery?: { __typename?: 'Delivery', id: string, estimatedDeliveryTime?: string | null, driverName?: string | null, driverPhone?: string | null } | null, pickupAddress?: { __typename?: 'Address', id: number, formattedAddress?: string | null, latitude: number, longitude: number, deliveryNotes?: string | null } | null, deliveryAddress: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, timeZone: string } | null }, promoCodes: Array<{ __typename?: 'PromoCode', id: number, value: number, code: string, promoCodeType: PromoCodeType }>, orders: Array<{ __typename?: 'Order', id: number, createdAt: string, subtotal: number, deliveryDate: string, orderType: OrderType, orderStatus: OrderStatus, consumerOrderStatus: ConsumerOrderStatus, isCancelable: boolean, isDeliveryEditable: boolean, isLineItemsEditable: boolean, deliveryType: string, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, imageUrl: string, flakeId: string }, user: { __typename?: 'User', id: string, firstName: string, lastName: string, publicName: string, email: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, price: number, foodItemSnapshot?: any | null, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, spiceLevel: number, servingSize?: string | null, portion?: string | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', name: string } }> | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', name: string } }> | null, shef: { __typename?: 'PublicShef', id: string, publicName: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', price: number, tier: UpsellTier } | null } }>, addOnItems: Array<{ __typename?: 'OrderAddOnItem', id: number, quantity: number, price: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, price: number, imageUrl: string, displayText: string, addonType: AddOnItemType } }>, address: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCode: string, phone: string, name?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, timeZone: string } | null }, timeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, delivery?: { __typename?: 'Delivery', id: string, estimatedDeliveryTime?: string | null, driverPhone?: string | null, driverName?: string | null } | null, pickupAddress?: { __typename?: 'Address', id: number, latitude: number, longitude: number, formattedAddress?: string | null, deliveryNotes?: string | null, phone: string } | null, promoCode?: { __typename?: 'PromoCode', promoCodeType: PromoCodeType } | null }>, orderTotals: { __typename?: 'ConsumerOrderTotal', promoApplied: number, nonPromoDiscountApplied: number, salesTax: number, deliveryFee: number, smallOrderFee: number, serviceFee: number, shefTip: number, subtotal: number, grandTotal: number } }>, me?: { __typename?: 'User', id: string, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, isPercentage: boolean } } | null, upsellPromo?: { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null };

export type ConsumerOrderReceiptDeliveryNameFragment = { __typename?: 'Order', user: { __typename?: 'User', firstName: string, lastName: string, publicName: string }, address: { __typename?: 'Address', name?: string | null } };

export type ConsumerOrderReceiptFoodItemFieldsFragment = { __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, spiceLevel: number, servingSize?: string | null, portion?: string | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', name: string } }> | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', name: string } }> | null, shef: { __typename?: 'PublicShef', id: string, publicName: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', price: number, tier: UpsellTier } | null };

export type ConsumerOrderReceiptLineItemFieldsFragment = { __typename?: 'OrderLineItem', id: number, quantity: number, price: number, foodItemSnapshot?: any | null, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, spiceLevel: number, servingSize?: string | null, portion?: string | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', name: string } }> | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', name: string } }> | null, shef: { __typename?: 'PublicShef', id: string, publicName: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', price: number, tier: UpsellTier } | null } };

export type ConsumerOrderReceiptFieldsFragment = { __typename?: 'Order', id: number, createdAt: string, subtotal: number, deliveryDate: string, orderType: OrderType, orderStatus: OrderStatus, consumerOrderStatus: ConsumerOrderStatus, isCancelable: boolean, isDeliveryEditable: boolean, isLineItemsEditable: boolean, deliveryType: string, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, imageUrl: string, flakeId: string }, user: { __typename?: 'User', id: string, firstName: string, lastName: string, publicName: string, email: string }, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, price: number, foodItemSnapshot?: any | null, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, imageUrl?: string | null, spiceLevel: number, servingSize?: string | null, portion?: string | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', name: string } }> | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', name: string } }> | null, shef: { __typename?: 'PublicShef', id: string, publicName: string }, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, upsell?: { __typename?: 'Upsell', price: number, tier: UpsellTier } | null } }>, addOnItems: Array<{ __typename?: 'OrderAddOnItem', id: number, quantity: number, price: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, price: number, imageUrl: string, displayText: string, addonType: AddOnItemType } }>, address: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCode: string, phone: string, name?: string | null, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, timeZone: string } | null }, timeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number }, delivery?: { __typename?: 'Delivery', id: string, estimatedDeliveryTime?: string | null, driverPhone?: string | null, driverName?: string | null } | null, pickupAddress?: { __typename?: 'Address', id: number, latitude: number, longitude: number, formattedAddress?: string | null, deliveryNotes?: string | null, phone: string } | null, promoCode?: { __typename?: 'PromoCode', promoCodeType: PromoCodeType } | null };

export type ConsumerOrderReceiptStepsFragment = { __typename?: 'Order', id: number, consumerOrderStatus: ConsumerOrderStatus, delivery?: { __typename?: 'Delivery', id: string, estimatedDeliveryTime?: string | null, driverPhone?: string | null, driverName?: string | null } | null, address: { __typename?: 'Address', id: number, formattedAddress?: string | null, phone: string, zipCode: string, zipCodeInfo?: { __typename?: 'ZipCode', zipCode: string, timeZone: string } | null } };

export type ReorderedItemFragment = { __typename?: 'CartLineItem', shefId: string };

export type ReorderAndFetchItemsMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type ReorderAndFetchItemsMutation = { __typename?: 'Mutation', duplicateOrderToCart: { __typename?: 'DuplicateOrderToCartResponse', addedItems: Array<{ __typename?: 'CartLineItem', shefId: string }> } };

export type CreateAvailabilityNotificationMutationVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type CreateAvailabilityNotificationMutation = { __typename?: 'Mutation', createShefAvailabilityNotification: boolean };

export type HasOrderedBeforeQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  shefId: Scalars['String']['input'];
}>;


export type HasOrderedBeforeQuery = { __typename?: 'Query', orders: { __typename?: 'ConsumerOrderResults', count: number } };

export type ClaimPhotoEditRequestMutationVariables = Exact<{
  changeRequestId: Scalars['Int']['input'];
}>;


export type ClaimPhotoEditRequestMutation = { __typename?: 'Mutation', claimPhotoEditRequest: { __typename?: 'PhotoEditRequest', id: string, foodItemChangeRequestId: number } };

export type UnclaimPhotoEditRequestMutationVariables = Exact<{
  changeRequestId: Scalars['Int']['input'];
  unclaimReason: Scalars['String']['input'];
}>;


export type UnclaimPhotoEditRequestMutation = { __typename?: 'Mutation', unclaimPhotoEditRequest: { __typename?: 'PhotoEditRequest', id: string, foodItemChangeRequestId: number } };

export type UpdatePhotoEditRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
}>;


export type UpdatePhotoEditRequestMutation = { __typename?: 'Mutation', updatePhotoEditRequest: { __typename?: 'PhotoEditRequest', id: string } };

export type PhotoEditRequestQueryVariables = Exact<{
  changeRequestId: Scalars['Int']['input'];
}>;


export type PhotoEditRequestQuery = { __typename?: 'Query', photoEditRequest?: { __typename?: 'PhotoEditRequest', id: string, editedImageUrl?: string | null, foodItem: { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, mostRecentOpenChangeRequest?: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, updatedAt: string, foodItem: { __typename?: 'FoodItem', hasUnreadComments: boolean, id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, user?: { __typename?: 'User', publicName: string } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, comments: Array<{ __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }>, lastUpdatedBy: { __typename?: 'User', publicName: string, imageUrl: string, id: string } } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null } } | null, foodItemCustomizationTypes: Array<{ __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string }> };

export type PhotoEditRequestsQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
}>;


export type PhotoEditRequestsQuery = { __typename?: 'Query', photoEditRequests: { __typename?: 'PhotoEditRequestResults', photoEditRequests: Array<{ __typename?: 'PhotoEditRequest', id: string, editorUserId?: string | null, foodItemChangeRequestId: number, status: PhotoEditRequestStatus, editedImageUrl?: string | null, notes?: string | null, foodItemChangeRequest: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, updatedAt: string, foodItem: { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, user: { __typename?: 'User', id: string, firstName: string, shefStatus: ShefStatus }, lastUpdatedBy: { __typename?: 'User', id: string, firstName: string }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }> } }>, pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number } } };

export type ShefFoodItemsQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  availableOn?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ShefFoodItemsQuery = { __typename?: 'Query', shefFoodItems: { __typename?: 'FoodItemResults', foodItems: Array<{ __typename?: 'FoodItem', ingredients?: string | null, id: number, userId: string, name?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, imageUrl?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, endDate: string, startDate: string, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, packaging: Packaging, status: FoodItemStatus, portion?: string | null, servingSize?: string | null, holiday?: Holiday | null, hasUnreadComments: boolean, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, numLabels?: number | null, user?: { __typename?: 'User', id: string, fullName?: string | null, firstName: string, imageUrl: string, publicName: string } | null, mostRecentOpenChangeRequest?: { __typename?: 'FoodItemChangeRequest', id: number, status: RequestStatus, foodItem: { __typename?: 'FoodItem', hasUnreadComments: boolean, id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, ingredients?: string | null, portion?: string | null, servingSize?: string | null, needsSide?: boolean | null, prepInstructions?: string | null, status: FoodItemStatus, numDaysBeforeExpires: number, numServings?: number | null, numLabels?: number | null, startDate: string, endDate: string, prefabFoodItemId?: number | null, packaging: Packaging, updatedAt: string, foodItemPairIds: Array<number>, cuisineCategoryIds: Array<string>, upsellTierId?: number | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, user?: { __typename?: 'User', publicName: string } | null, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, upsell?: { __typename?: 'Upsell', id: number, tier: UpsellTier, price: number } | null }, changesets: Array<{ __typename?: 'FoodItemChangeset', id: number, createdAt: string, name?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, ingredients?: string | null, portion?: string | null, prepInstructions?: string | null, availableMonday?: boolean | null, availableTuesday?: boolean | null, availableWednesday?: boolean | null, availableThursday?: boolean | null, availableFriday?: boolean | null, availableSaturday?: boolean | null, availableSunday?: boolean | null, endDate?: string | null, startDate?: string | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree?: boolean | null, dairyFree?: boolean | null, containsEggs?: boolean | null, containsNuts?: boolean | null, containsShellfish?: boolean | null, containsSoy?: boolean | null, isHalal?: boolean | null, isOrganic?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, lowFodmap?: boolean | null, keto?: boolean | null, kosher?: boolean | null, lowSodium?: boolean | null, spiceLevel?: number | null, foodType?: FoodType | null, numDaysBeforeExpires?: number | null, numServings?: number | null, servingSize?: string | null, needsSide?: boolean | null, packaging?: Packaging | null, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, comments: Array<{ __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } }> } | null, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null }>, pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number } }, shefProfile?: { __typename?: 'ShefProfile', id: number, primaryRegion?: { __typename?: 'RegionInfo', name: string, sundayDelivery: boolean, mondayDelivery: boolean, tuesdayDelivery: boolean, wednesdayDelivery: boolean, thursdayDelivery: boolean, fridayDelivery: boolean, saturdayDelivery: boolean } | null } | null };

export type ShefRouterUserFragment = { __typename?: 'User', shefProfile?: { __typename?: 'ShefProfile', id: number, timeZone: string, approvedAt?: string | null } | null };

export type ShefRouterQueryVariables = Exact<{ [key: string]: never; }>;


export type ShefRouterQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, shefProfile?: { __typename?: 'ShefProfile', id: number, timeZone: string, approvedAt?: string | null } | null } | null };

export type ViewShefApplication2QueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ViewShefApplication2Query = { __typename?: 'Query', shefApplication?: { __typename?: 'ShefApplication', id: number, userId?: string | null, zipcode?: string | null, phone?: string | null, cuisines?: string | null, info?: string | null, workAuthorization?: string | null, howDiscoveredShef?: string | null, isFoodTastingScheduled: boolean, isPickupAddressEnabled: boolean, foodTastingAt?: string | null, foodTastingReceivedAt?: string | null, onboardingCallAt?: string | null, menuWebinarScheduledFor?: string | null, informationSessionCompletedAt?: string | null, initialQuestionsCompletedAt?: string | null, status: ApplicationStatus, menuWebinarCompletedAt?: string | null, region?: string | null, createdAt?: string | null, geographyAllowsNewApplications: boolean, geographyAllowsCuisineType: boolean, calendlyOrientationCallLink?: string | null, regionInfo?: { __typename?: 'RegionInfo', id: number } | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, userId: string, email?: string | null, phone?: string | null, bio?: string | null, notes?: string | null, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, youtubeHandle?: string | null, specialty?: string | null, coverPhotoUrl?: string | null, videoUrl?: string | null, cuisineRegion?: CuisineRegion | null, cuisineCategoryIds: Array<string>, featureShef?: boolean | null, trialStatus?: TrialStatus | null, dishCapacity: number, maxDishCapacity: number, shefAddressId?: number | null, previewFoodItemId?: number | null, cutoffMsBeforeDeliveryDate: number, fhcExpiresAt?: string | null, fhcUploadedAt?: string | null, fhcUploadRequiredBy?: string | null, newOrderNotificationFrequency?: NewOrderNotificationFrequency | null, cancelOrderNotificationFrequency?: CancelOrderNotificationFrequency | null, setBadQualityAt?: string | null, onboardingFormAnsweredAt?: string | null, fulfillmentOption?: string | null, isHubless: boolean, geographyAllowsCuisineType: boolean, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType, isPrimary: boolean }>, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, user: { __typename?: 'User', publicName: string, createdAt: string, id: string, fullName?: string | null, email: string, shefStatus: ShefStatus, firstName: string, lastName: string, imageUrl: string, activeAddresses: Array<{ __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null }>, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number, stripeUserId?: string | null, userId: string, accountType: StripeAccountType, dashboardLoginLink?: string | null, createdAt: string, currentBalance?: { __typename?: 'ShefStripeConnectBalance', available: number, pending: number } | null } | null }, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, name: string, street: string, city: string, province: string, unit?: string | null, pickupInstructions: string, zipCode: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null } | null } | null, possibleDeliveryHubsForShef: Array<{ __typename?: 'DeliveryHub', id: number, name: string, street: string, city: string, province: string, unit?: string | null, pickupInstructions: string, zipCode: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType, isPrimary: boolean }> };

export type ShefApplicationQuestionsCompletedMutationVariables = Exact<{ [key: string]: never; }>;


export type ShefApplicationQuestionsCompletedMutation = { __typename?: 'Mutation', shefApplicationQuestionsCompleted: boolean };

export type UpdateShefApplicationMutationVariables = Exact<{
  applicationId: Scalars['Int']['input'];
  shefApplicationInput: ShefApplicationInputStep2;
}>;


export type UpdateShefApplicationMutation = { __typename?: 'Mutation', editShefApplication: boolean };

export type UpdateShefApplicationCompleteInformationSessionMutationVariables = Exact<{
  applicationId: Scalars['Int']['input'];
}>;


export type UpdateShefApplicationCompleteInformationSessionMutation = { __typename?: 'Mutation', editShefApplicationCompleteInformationSession: boolean };

export type UpdateShefApplicationCancelOrientationCallMutationVariables = Exact<{
  applicationId: Scalars['Int']['input'];
}>;


export type UpdateShefApplicationCancelOrientationCallMutation = { __typename?: 'Mutation', editShefApplicationCancelOrientationCall: boolean };

export type AddShefApplicationMutationVariables = Exact<{
  shefApplicationInput: ShefApplicationInput;
  promoCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddShefApplicationMutation = { __typename?: 'Mutation', addShefApplication: { __typename?: 'ShefApplicationResult', token?: string | null, isExistingUser: boolean, user: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } } };

export type BecomeAShefGetApplicationQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type BecomeAShefGetApplicationQuery = { __typename?: 'Query', shefApplication?: { __typename?: 'ShefApplication', id: number, userId?: string | null, zipcode?: string | null, phone?: string | null, cuisines?: string | null, info?: string | null, workAuthorization?: string | null, howDiscoveredShef?: string | null, isFoodTastingScheduled: boolean, isPickupAddressEnabled: boolean, foodTastingAt?: string | null, foodTastingReceivedAt?: string | null, onboardingCallAt?: string | null, menuWebinarScheduledFor?: string | null, informationSessionCompletedAt?: string | null, initialQuestionsCompletedAt?: string | null, status: ApplicationStatus, menuWebinarCompletedAt?: string | null, region?: string | null, createdAt?: string | null, geographyAllowsNewApplications: boolean, geographyAllowsCuisineType: boolean, calendlyOrientationCallLink?: string | null, regionInfo?: { __typename?: 'RegionInfo', id: number } | null } | null };

export type AddBecomeAShefPhoneNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type AddBecomeAShefPhoneNumberMutation = { __typename?: 'Mutation', addBecomeAShefPhoneNumber: boolean };

export type ShefHeaderQueryQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  dateFrom: Scalars['String']['input'];
}>;


export type ShefHeaderQueryQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', shefAddressId?: number | null, fulfillmentOption?: string | null, primaryRegion?: { __typename?: 'RegionInfo', isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null } | null, shefAvailability: Array<{ __typename?: 'ShefAvailability', id: number, availabilityDate: string, numOrdersPlaced: number } | null> };

export type ShefNavQueryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ShefNavQueryQuery = { __typename?: 'Query', isShefRatingEnabled: boolean, shefApplication?: { __typename?: 'ShefApplication', id: number, userId?: string | null, zipcode?: string | null, phone?: string | null, cuisines?: string | null, info?: string | null, workAuthorization?: string | null, howDiscoveredShef?: string | null, isFoodTastingScheduled: boolean, isPickupAddressEnabled: boolean, foodTastingAt?: string | null, foodTastingReceivedAt?: string | null, onboardingCallAt?: string | null, menuWebinarScheduledFor?: string | null, informationSessionCompletedAt?: string | null, initialQuestionsCompletedAt?: string | null, status: ApplicationStatus, menuWebinarCompletedAt?: string | null, region?: string | null, createdAt?: string | null, geographyAllowsNewApplications: boolean, geographyAllowsCuisineType: boolean, calendlyOrientationCallLink?: string | null, regionInfo?: { __typename?: 'RegionInfo', id: number } | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, userId: string, email?: string | null, phone?: string | null, bio?: string | null, notes?: string | null, businessName?: string | null, websiteUrl?: string | null, facebookHandle?: string | null, instagramHandle?: string | null, twitterHandle?: string | null, tikTokHandle?: string | null, linkedInHandle?: string | null, youtubeHandle?: string | null, specialty?: string | null, coverPhotoUrl?: string | null, videoUrl?: string | null, cuisineRegion?: CuisineRegion | null, cuisineCategoryIds: Array<string>, featureShef?: boolean | null, trialStatus?: TrialStatus | null, dishCapacity: number, maxDishCapacity: number, shefAddressId?: number | null, previewFoodItemId?: number | null, cutoffMsBeforeDeliveryDate: number, fhcExpiresAt?: string | null, fhcUploadedAt?: string | null, fhcUploadRequiredBy?: string | null, newOrderNotificationFrequency?: NewOrderNotificationFrequency | null, cancelOrderNotificationFrequency?: CancelOrderNotificationFrequency | null, setBadQualityAt?: string | null, onboardingFormAnsweredAt?: string | null, fulfillmentOption?: string | null, isHubless: boolean, geographyAllowsCuisineType: boolean, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, user: { __typename?: 'User', publicName: string, createdAt: string, id: string, fullName?: string | null, email: string, shefStatus: ShefStatus, firstName: string, lastName: string, imageUrl: string, activeAddresses: Array<{ __typename?: 'Address', id: number, userId?: string | null, formattedAddress?: string | null, archived: boolean, disabled?: boolean | null, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null }>, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number, stripeUserId?: string | null, userId: string, accountType: StripeAccountType, dashboardLoginLink?: string | null, createdAt: string, currentBalance?: { __typename?: 'ShefStripeConnectBalance', available: number, pending: number } | null } | null }, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, name: string, street: string, city: string, province: string, unit?: string | null, pickupInstructions: string, zipCode: string, dropoffWindowStartTimeMinutesFromMidnight?: number | null, dropoffWindowEndTimeMinutesFromMidnight?: number | null } | null } | null, shefFoodItems: { __typename?: 'FoodItemResults', foodItems: Array<{ __typename?: 'FoodItem', id: number, name?: string | null, hasUnreadComments: boolean }> } };

export type ShefPlatformUsageQuestionnaireQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ShefPlatformUsageQuestionnaireQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', id: number, platformNewDesiredEarnings?: ShefPlatformNewDesiredEarnings | null, platformNewUsage?: ShefPlatformUsage | null, platformRecommendationScore?: number | null, platformNewFormAnsweredAt?: string | null, approvedAt?: string | null } | null };

export type AnswerShefPlatformUsageQuestionnaireMutationVariables = Exact<{
  shefProfileId: Scalars['Int']['input'];
  platformUsage: ShefPlatformUsage;
  platformDesiredEarnings: ShefPlatformNewDesiredEarnings;
  platformRecommendationScore: Scalars['Int']['input'];
}>;


export type AnswerShefPlatformUsageQuestionnaireMutation = { __typename?: 'Mutation', modifyShefProfile: { __typename?: 'ShefProfile', id: number, platformNewFormAnsweredAt?: string | null } };

export type ShefTrackerQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ShefTrackerQuery = { __typename?: 'Query', shefApplicationTracker?: { __typename?: 'ShefApplicationTracker', personalInfo?: ShefApplicationTrackerItemStatus | null, scheduleTasting?: ShefApplicationTrackerItemStatus | null, passTasting?: ShefApplicationTrackerItemStatus | null, informationSession: ShefApplicationTrackerItemStatus, profileImage: ShefApplicationTrackerItemStatus, bio: ShefApplicationTrackerItemStatus, dropOffHub?: ShefApplicationTrackerItemStatus | null, menuItems: ShefApplicationTrackerItemStatus, optionalMenuItems?: ShefApplicationTrackerItemStatus | null, cuisine: ShefApplicationTrackerItemStatus, cuisineCategories?: ShefApplicationTrackerItemStatus | null, addAddress?: ShefApplicationTrackerItemStatus | null, tryShefPromo?: ShefApplicationTrackerItemStatus | null, scheduleCall?: ShefApplicationTrackerItemStatus | null } | null };

export type GetStripeIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripeIdQuery = { __typename?: 'Query', stripeId?: string | null };

export type StripeConnectMutationMutationVariables = Exact<{
  code: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  stripeAccountType: StripeAccountType;
}>;


export type StripeConnectMutationMutation = { __typename?: 'Mutation', createStripeConnect: { __typename?: 'ShefStripeConnect', id: number } };

export type ShefPlatformPercentQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ShefPlatformPercentQuery = { __typename?: 'Query', shef: { __typename?: 'PublicShef', shefProfile: { __typename?: 'ShefProfile', platformPercent: number } } };

export type ShefSelfPromotionPageQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ShefSelfPromotionPageQuery = { __typename?: 'Query', promoCodeCreationEnabled: boolean, shef: { __typename?: 'PublicShef', id: string, shefProfile: { __typename?: 'ShefProfile', id: number, bio?: string | null, timeZone: string }, activeFoodItems: Array<{ __typename?: 'FoodItem', id: number, slug: string, name?: string | null, description?: string | null }> }, me?: { __typename?: 'User', id: string, promoCodes: { __typename?: 'PaginatedPromoCodes', pagination: { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number }, promoCodes: Array<{ __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean, uses: number, promoCodeType: PromoCodeType, maxUses?: number | null, maxUsesPerUser?: number | null, minOrderValue?: number | null, startTimestamp?: string | null, endTimestamp?: string | null, disabledAt?: string | null, disabled: boolean, isExplorePagePromo: boolean }> }, referralCode: { __typename?: 'ReferralCode', id: number, code: string } } | null };

export type ShefS2CCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type ShefS2CCodeQuery = { __typename?: 'Query', s2cCodeValue?: string | null, s2cCodeUsesPerUser?: string | null, s2cGetReward?: string | null };

export type ShefCreatePromoCodeMutationVariables = Exact<{
  promoCodeInput: ShefPromoCodeInput;
}>;


export type ShefCreatePromoCodeMutation = { __typename?: 'Mutation', addShefPromoCode: { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean, uses: number, promoCodeType: PromoCodeType, maxUses?: number | null, maxUsesPerUser?: number | null, minOrderValue?: number | null, startTimestamp?: string | null, endTimestamp?: string | null, disabledAt?: string | null, disabled: boolean, isExplorePagePromo: boolean } };

export type ShefSelfPromotionPageFoodItemFragment = { __typename?: 'FoodItem', id: number, slug: string, name?: string | null, description?: string | null };

export type ShefPromoCodeFragment = { __typename?: 'PromoCode', id: number, code: string, value: number, isPercentage: boolean, uses: number, promoCodeType: PromoCodeType, maxUses?: number | null, maxUsesPerUser?: number | null, minOrderValue?: number | null, startTimestamp?: string | null, endTimestamp?: string | null, disabledAt?: string | null, disabled: boolean, isExplorePagePromo: boolean };

export type ShefInsightsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ShefInsightsPageQuery = { __typename?: 'Query', getShefInsightsDashboardUrl: string };

export type ShefOrdersQueryQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
}>;


export type ShefOrdersQueryQuery = { __typename?: 'Query', shefProfile?: { __typename?: 'ShefProfile', timeZone: string, id: number } | null, orders: { __typename?: 'ConsumerOrderResults', orders: Array<{ __typename?: 'Order', deliveryDate: string, fulfillmentDate: string, subtotal: number, addOnItemsTotal: number, refundType?: RefundType | null, shefPayment: number, reversedShefPaymentAmount: number, orderStatus: OrderStatus }> } };

export type ShefOrderEditQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type ShefOrderEditQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: number, userId: string, phone: string, deliveryAddressId: number, pickupAddressId?: number | null, createdAt: string, updatedAt: string, subtotal: number, deliveryDate: string, orderType: OrderType, orderStatus: OrderStatus, cancelledAt?: string | null, deliveryNotes?: string | null, deliveryFee: number, deliveryType: string, smallOrderFee: number, grandTotal: number, salesTax: number, serviceFee: number, shefTip?: number | null, shefPlatformPercent: number, discountApplied: number, transactionId?: string | null, refundId?: string | null, refundTimestamp?: string | null, refundAmount?: number | null, refundReason?: string | null, refundType?: RefundType | null, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, shef: { __typename?: 'User', id: string, publicName: string, shefProfile?: { __typename?: 'ShefProfile', id: number, formattedAddress?: string | null, timeZone: string, platformPercent: number, fulfillmentOption?: string | null, isMultiFulfillmentShef: boolean } | null }, region: { __typename?: 'RegionInfo', name: string }, user: { __typename?: 'User', id: string, flakeId: string, publicName: string }, delivery?: { __typename?: 'Delivery', externalId?: string | null, type?: string | null, fee?: number | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, name: string, quantity: number, price: number, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, price: number, imageUrl?: string | null, servingSize?: string | null, spiceLevel: number }, customizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, priceFactor: number, priceFactorType: PriceFactorType, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }>, promoCode?: { __typename?: 'PromoCode', code: string, isPercentage: boolean, promoCodeType: PromoCodeType, value: number } | null, address: { __typename?: 'Address', id: number, formattedAddress?: string | null, name?: string | null }, shefFulfillmentTimeWindow: { __typename?: 'OrderTimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number } } | null };

export type PerformanceOrderReviewLineItemFragment = { __typename?: 'OrderLineItem', id: number, name: string, imageUrl: string, rating?: { __typename?: 'FoodItemRating', id: number, ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', id: string, tag: string }> | null } | null };

export type PerformanceOrderReviewResultFragment = { __typename?: 'PublicReviewResult', id: number, orderId: number, createdAt: string, deliveryDate: string, comment?: string | null, user: { __typename?: 'ReviewUser', id: string, flakeId: string, publicName: string }, dishes: Array<{ __typename?: 'OrderLineItem', id: number, name: string, imageUrl: string, rating?: { __typename?: 'FoodItemRating', id: number, ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', id: string, tag: string }> | null } | null }> };

export type ShefOrderReviewResultFragment = { __typename?: 'PublicReviewResult', privateComment?: string | null, id: number, orderId: number, createdAt: string, deliveryDate: string, comment?: string | null, user: { __typename?: 'ReviewUser', id: string, flakeId: string, publicName: string }, dishes: Array<{ __typename?: 'OrderLineItem', id: number, name: string, imageUrl: string, rating?: { __typename?: 'FoodItemRating', id: number, ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', id: string, tag: string }> | null } | null }> };

export type ShefOrderReviewsQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ShefOrderReviewsQuery = { __typename?: 'Query', publicReviews: { __typename?: 'PublicReviewResults', total: number, reviews: Array<{ __typename?: 'PublicReviewResult', privateComment?: string | null, id: number, orderId: number, createdAt: string, deliveryDate: string, comment?: string | null, user: { __typename?: 'ReviewUser', id: string, flakeId: string, publicName: string }, dishes: Array<{ __typename?: 'OrderLineItem', id: number, name: string, imageUrl: string, rating?: { __typename?: 'FoodItemRating', id: number, ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', id: string, tag: string }> | null } | null }> }> } };

export type ShefPerformanceDishesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShefPerformanceDishesQuery = { __typename?: 'Query', categoricalRatings2: { __typename?: 'CategoricalRatingsResults', positiveRatings: Array<{ __typename?: 'CategoricalRatings', name: string, value: number }>, negativeRatings: Array<{ __typename?: 'CategoricalRatings', name: string, value: number }> }, foodItemPopularity: { __typename?: 'FoodItemPopularityResult', results: Array<{ __typename?: 'FoodItemPopularity', id: number, name: string, imageUrl: string, numThumbsUp: number, numThumbsDown: number, tags?: Array<{ __typename?: 'FoodItemTagFrequency', tag: string, count: number, isPositive: boolean }> | null }> } };

export type ShefPerformanceOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type ShefPerformanceOrdersQuery = { __typename?: 'Query', foodItemPopularity: { __typename?: 'FoodItemPopularityResult', results: Array<{ __typename?: 'FoodItemPopularity', id: number, name: string, imageUrl: string, numThumbsUp: number, numThumbsDown: number, tags?: Array<{ __typename?: 'FoodItemTagFrequency', tag: string, count: number, isPositive: boolean }> | null }> } };

export type ShefPerformanceOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type ShefPerformanceOverviewQuery = { __typename?: 'Query', categoricalRatings2: { __typename?: 'CategoricalRatingsResults', positiveRatings: Array<{ __typename?: 'CategoricalRatings', name: string, value: number }>, negativeRatings: Array<{ __typename?: 'CategoricalRatings', name: string, value: number }> }, foodItemPopularity: { __typename?: 'FoodItemPopularityResult', results: Array<{ __typename?: 'FoodItemPopularity', id: number, name: string, imageUrl: string, numThumbsUp: number, numThumbsDown: number, tags?: Array<{ __typename?: 'FoodItemTagFrequency', tag: string, count: number, isPositive: boolean }> | null }> } };

export type FlagRatingForReviewMutationVariables = Exact<{
  ratingId: Scalars['Int']['input'];
}>;


export type FlagRatingForReviewMutation = { __typename?: 'Mutation', flagRatingForReview?: boolean | null };

export type ShefEarningsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ShefEarningsPageQuery = { __typename?: 'Query', getShefEarningsDashboardUrl: string };

export type ShefMenuChecklistQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ShefMenuChecklistQuery = { __typename?: 'Query', shefMenuChecklist: Array<{ __typename?: 'ShefMenuChecklistAction', key: string, label: string, completed: boolean }> };

export type CreateShefPostMutationVariables = Exact<{
  input: ShefPostInput;
}>;


export type CreateShefPostMutation = { __typename?: 'Mutation', createShefPost: boolean };

export type ModifyShefPostMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ShefPostInput;
}>;


export type ModifyShefPostMutation = { __typename?: 'Mutation', modifyShefPost: boolean };

export type DeleteShefPostMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteShefPostMutation = { __typename?: 'Mutation', deleteShefPost: boolean };

export type LikeShefPostMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LikeShefPostMutation = { __typename?: 'Mutation', likeShefPost: boolean };

export type IncrementShefPostClickCountMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type IncrementShefPostClickCountMutation = { __typename?: 'Mutation', incrementShefPostClickCount: boolean };

export type IncrementShefPostViewCountMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type IncrementShefPostViewCountMutation = { __typename?: 'Mutation', incrementShefPostViewCount: boolean };

export type ShefSocialFollowerFragment = { __typename?: 'User', flakeId: string, id: string, imageUrl: string, publicName: string, orderCountFromShef: number };

export type ShefFollowingQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ShefFollowingQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, shefProfile?: { __typename?: 'ShefProfile', followerCount: number, followers: Array<{ __typename?: 'User', flakeId: string, id: string, imageUrl: string, publicName: string, orderCountFromShef: number }> } | null } | null };

export type ShefPostDataFragment = { __typename?: 'ShefPost', id: string, shefId: string, mediaType?: ShefPostMediaType | null, mediaUrl?: string | null, foodItemId?: number | null, clickCount: number, isLikedByUser?: boolean | null, numLikes: number, promoCodeId?: number | null, promoCodeString?: string | null, comment?: string | null, createdAt: string, viewCount: number };

export type ShefPostsQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ShefPostsQuery = { __typename?: 'Query', shefPosts: Array<{ __typename?: 'ShefPost', id: string, shefId: string, mediaType?: ShefPostMediaType | null, mediaUrl?: string | null, foodItemId?: number | null, clickCount: number, isLikedByUser?: boolean | null, numLikes: number, promoCodeId?: number | null, promoCodeString?: string | null, comment?: string | null, createdAt: string, viewCount: number }> };

export type ZipCodeAvailabilityQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type ZipCodeAvailabilityQuery = { __typename?: 'Query', zipCode?: { __typename?: 'ZipCode', zipCode: string, availableToCustomers: boolean, region: { __typename?: 'RegionInfo', id: number, isInWaitlist: boolean } } | null };

export type AdminCreateOrUpdateRegionMutationVariables = Exact<{
  regionInfo: UpdateRegionInput;
}>;


export type AdminCreateOrUpdateRegionMutation = { __typename?: 'Mutation', createOrUpdateRegion?: { __typename?: 'RegionInfo', id: number } | null };

export type ZipDeliveryDaysFragment = { __typename?: 'RegionInfo', sundayDelivery: boolean, mondayDelivery: boolean, tuesdayDelivery: boolean, wednesdayDelivery: boolean, thursdayDelivery: boolean, fridayDelivery: boolean, saturdayDelivery: boolean };

export type GetDeliveryDaysForZipQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type GetDeliveryDaysForZipQuery = { __typename?: 'Query', regionFromZip: { __typename?: 'RegionInfo', sundayDelivery: boolean, mondayDelivery: boolean, tuesdayDelivery: boolean, wednesdayDelivery: boolean, thursdayDelivery: boolean, fridayDelivery: boolean, saturdayDelivery: boolean } };

export type ShefOgTagsQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
}>;


export type ShefOgTagsQuery = { __typename?: 'Query', shef: { __typename?: 'PublicShef', firstName?: string | null, publicName: string, resizedImageUrl?: string | null, shefProfile: { __typename?: 'ShefProfile', id: number, resizedCoverPhotoUrl?: string | null, bio?: string | null }, activeFoodItems: Array<{ __typename?: 'FoodItem', resizedImageUrl?: string | null }> } };

export type DishOgTagsQueryVariables = Exact<{
  shefId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type DishOgTagsQuery = { __typename?: 'Query', sluggedFoodItem?: { __typename?: 'FoodItem', name?: string | null, description?: string | null, resizedImageUrl?: string | null, slug: string, shef: { __typename?: 'PublicShef', firstName?: string | null } } | null };

export type ShefProfileByConsumerReferralQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ShefProfileByConsumerReferralQuery = { __typename?: 'Query', shefProfileByConsumerReferral?: { __typename?: 'ShefProfile', id: number, userId: string, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', adImageUrl?: string | null, code?: { __typename?: 'ReferralCode', code: string } | null }, shef: { __typename?: 'PublicShef', firstName?: string | null } } | null };

export type ShefApplicationFieldsFragment = { __typename?: 'ShefApplication', id: number, userId?: string | null, zipcode?: string | null, phone?: string | null, cuisines?: string | null, info?: string | null, workAuthorization?: string | null, howDiscoveredShef?: string | null, isFoodTastingScheduled: boolean, isPickupAddressEnabled: boolean, foodTastingAt?: string | null, foodTastingReceivedAt?: string | null, onboardingCallAt?: string | null, menuWebinarScheduledFor?: string | null, informationSessionCompletedAt?: string | null, initialQuestionsCompletedAt?: string | null, status: ApplicationStatus, menuWebinarCompletedAt?: string | null, region?: string | null, createdAt?: string | null, geographyAllowsNewApplications: boolean, geographyAllowsCuisineType: boolean, calendlyOrientationCallLink?: string | null, regionInfo?: { __typename?: 'RegionInfo', id: number } | null };

export type PaginationFieldsFragment = { __typename?: 'Pagination', page: number, pageCount: number, resultsPerPage: number };

export type FoodItemTagFieldsFragment = { __typename?: 'FoodItem', vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, packaging: Packaging };

export type AvailabilityFieldsFragment = { __typename?: 'FoodItem', availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string };

export type GenericTableFieldsFragment = { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, price: number, description?: string | null, capacity?: number | null, foodType?: FoodType | null, imageUrl?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, endDate: string, startDate: string, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, packaging: Packaging, user?: { __typename?: 'User', id: string, fullName?: string | null, firstName: string, imageUrl: string, publicName: string } | null };

export type FoodItemDescriptionFieldsFragment = { __typename?: 'FoodItem', id: number, userId: string, imageUrl?: string | null, price: number, foodType?: FoodType | null, slug: string, name?: string | null, description?: string | null, portion?: string | null, ingredients?: string | null, availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, packaging: Packaging };

export type FoodItemCartFieldsFragment = { __typename?: 'FoodItem', id: number, userId: string, name?: string | null, imageUrl?: string | null, price: number, ingredients?: string | null, description?: string | null, portion?: string | null, foodType?: FoodType | null, capacity?: number | null, vegan?: boolean | null, vegetarian?: boolean | null, glutenFree: boolean, dairyFree: boolean, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, containsEggs: boolean, containsNuts: boolean, containsShellfish: boolean, containsSoy: boolean, spiceLevel: number, packaging: Packaging };

export type GenericAddressFieldsFragment = { __typename?: 'Address', id: number, name?: string | null, company?: string | null, unit?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, phone: string, deliveryNotes?: string | null };

export type GenericOrderFieldsFragment = { __typename?: 'Order', id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, createdAt: string, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number };

export type AdminOrderFieldsFragment = { __typename?: 'Order', deliveryType: string, shefTip?: number | null, salesTax: number, serviceFee: number, deliveryFee: number, grandTotal: number, platformFee: number, shefPayment: number, reversedShefPaymentAmount: number, discountApplied: number, platformPayment: number, currency: string, deliveryAddressId: number, transactionId?: string | null, refundId?: string | null, refundTimestamp?: string | null, cancelledAt?: string | null, createdAt: string, notes?: string | null, deliveryNotes?: string | null, phone: string, fulfillmentDate: string, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, delivery?: { __typename?: 'Delivery', id: string, externalId?: string | null } | null, user: { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null }, shef: { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null }, shefProfile: { __typename?: 'ShefProfile', id: number, mehkoLicenseNumber?: string | null, defaultDropoffHub?: { __typename?: 'DeliveryHub', id: number, code: string, name: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, gsinEnabledAt?: string | null, name: string } | null }, promoCode?: { __typename?: 'PromoCode', code: string, isPercentage: boolean, promoCodeType: PromoCodeType, value: number } | null };

export type GenericGroupOrderFieldsFragment = { __typename?: 'GroupOrder', id: string, uuid: string, userId: string, deliveryDate: string, deliveryType: string, orderType: OrderType };

export type GenericAdminUserFieldsFragment = { __typename?: 'User', id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null };

export type AdminUserFieldsFragment = { __typename?: 'User', email: string, lastOrderPhoneNumber?: string | null, imageUrl: string, createdAt: string, shefStatus: ShefStatus, id: string, publicName: string, firstName: string, lastName: string, fullName?: string | null, shefApplication?: { __typename?: 'ShefApplication', id: number } | null };

export type UserMutationMutationVariables = Exact<{
  userInput: UserInput;
}>;


export type UserMutationMutation = { __typename?: 'Mutation', modifyUser: { __typename?: 'User', id: string } };

export type PromoCodeFieldsFragment = { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null };

export type OrganizationFieldsFragment = { __typename?: 'Organization', id: number, name: string, address?: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCode: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null };

export type DeliveryPriceFieldsFragment = { __typename?: 'DeliveryPrice', rawDeliveryCost: number, deliveryDiscount: number, finalDeliveryPrice: number };

export type ShefApplicationTrackerFieldsFragment = { __typename?: 'ShefApplicationTracker', personalInfo?: ShefApplicationTrackerItemStatus | null, scheduleTasting?: ShefApplicationTrackerItemStatus | null, passTasting?: ShefApplicationTrackerItemStatus | null, informationSession: ShefApplicationTrackerItemStatus, profileImage: ShefApplicationTrackerItemStatus, bio: ShefApplicationTrackerItemStatus, dropOffHub?: ShefApplicationTrackerItemStatus | null, menuItems: ShefApplicationTrackerItemStatus, optionalMenuItems?: ShefApplicationTrackerItemStatus | null, cuisine: ShefApplicationTrackerItemStatus, cuisineCategories?: ShefApplicationTrackerItemStatus | null, addAddress?: ShefApplicationTrackerItemStatus | null, tryShefPromo?: ShefApplicationTrackerItemStatus | null, scheduleCall?: ShefApplicationTrackerItemStatus | null };

export type BannerQueryVariables = Exact<{
  name: FeatureName;
}>;


export type BannerQuery = { __typename?: 'Query', banner?: string | null };

export type CommentUserAvatarFragment = { __typename?: 'User', publicName: string, imageUrl: string, id: string };

export type CommentThreadCommentFragment = { __typename?: 'FoodItemChangeRequestComment', id: number, message: string, createdAt: string, user: { __typename?: 'User', publicName: string, imageUrl: string, id: string } };

export type DeliveryAddressInputFragment = { __typename?: 'Address', company?: string | null, unit?: string | null, name?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, streetNumber?: string | null, route?: string | null, googlePlaceId?: string | null };

export type DeliveryAddressFieldsFragment = { __typename?: 'Address', id: number, formattedAddress?: string | null, phone: string, deliveryNotes?: string | null, linkedSubscriptionId?: string | null, company?: string | null, unit?: string | null, name?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, streetNumber?: string | null, route?: string | null, googlePlaceId?: string | null };

export type DeliveryAddressesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DeliveryAddressesQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, publicName: string, activeAddresses: Array<{ __typename?: 'Address', id: number, formattedAddress?: string | null, phone: string, deliveryNotes?: string | null, linkedSubscriptionId?: string | null, company?: string | null, unit?: string | null, name?: string | null, street: string, city: string, province: string, zipCode: string, country: string, latitude: number, longitude: number, streetNumber?: string | null, route?: string | null, googlePlaceId?: string | null }> } | null };

export type SaveDeliveryAddressMutationVariables = Exact<{
  addressInput: AddressInput;
  phone: Scalars['String']['input'];
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveDeliveryAddressMutation = { __typename?: 'Mutation', saveDeliveryAddress: { __typename?: 'Address', id: number } };

export type ModifyDeliveryAddressMutationVariables = Exact<{
  addressId: Scalars['Int']['input'];
  addressInput?: InputMaybe<AddressInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
}>;


export type ModifyDeliveryAddressMutation = { __typename?: 'Mutation', modifyDeliveryAddress: { __typename?: 'Address', id: number } };

export type ArchiveDeliveryAddressMutationVariables = Exact<{
  addressId: Scalars['Int']['input'];
}>;


export type ArchiveDeliveryAddressMutation = { __typename?: 'Mutation', archiveDeliveryAddress?: boolean | null };

export type FileUploadInfoFragment = { __typename?: 'SignedUrl', signedUrl: string, key: string, bucket: string };

export type GetSignedUrlMutationVariables = Exact<{
  input: SignedUrlInput;
}>;


export type GetSignedUrlMutation = { __typename?: 'Mutation', getSignedUrl: { __typename?: 'SignedUrl', signedUrl: string, key: string, bucket: string } };

export type FoodItemAvailabilityFoodItemFragment = { __typename?: 'FoodItem', availableMonday: boolean, availableTuesday: boolean, availableWednesday: boolean, availableThursday: boolean, availableFriday: boolean, availableSaturday: boolean, availableSunday: boolean, startDate: string, endDate: string };

export type PaymentInputSavedCreditCartFragment = { __typename?: 'SavedCreditCard', id: string, lastFourDigits: number, expiresAt: string, brand: string, type: string, lastUsedAt: string };

export type UpdateCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateCurrentUserQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } | null };

export type DontUseThisDirectlyUseTheHookQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type DontUseThisDirectlyUseTheHookQuery = { __typename?: 'Query', getOrCreateShortUrl: { __typename?: 'ShortUrl', shortUrl: string } };

export type OrganizationQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type OrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: number, name: string, address?: { __typename?: 'Address', id: number, formattedAddress?: string | null, zipCode: string } | null, promoCode?: { __typename?: 'PromoCode', id: number, promoCodeType: PromoCodeType, isPercentage: boolean, value: number, code: string, isFreeDelivery: boolean, onlyUsableOnDates?: Array<string | null> | null, maxUsesPerUser?: number | null, firstPromoOnly: boolean, restrictedToShefIds?: Array<string> | null, restrictedToCuisineRegions?: Array<string> | null, restrictedToEmailDomains?: Array<string> | null, maxValue?: number | null, minOrderValue?: number | null, disabled: boolean, usesRemainingForUser?: number | null, isShefToConsumerPromo: boolean, referrer?: { __typename?: 'User', id: string, shefStatus: ShefStatus } | null } | null } | null };

export type ZipCodeQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type ZipCodeQuery = { __typename?: 'Query', zipCode?: { __typename?: 'ZipCode', zipCode: string, timeZone: string, availableToCustomers: boolean } | null };

export type FoodItemLabelFoodItemFragment = { __typename?: 'FoodItem', id: number, name?: string | null, prepInstructions?: string | null, numDaysBeforeExpires: number, numLabels?: number | null, servingSize?: string | null, spiceLevel: number, shef: { __typename?: 'PublicShef', publicName: string }, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string }> | null };

export type FoodItemLabelCustomizationFragment = { __typename?: 'FoodItemCustomization', id: string, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } };

export type FoodItemLabelUserFragment = { __typename?: 'User', imageUrl: string, publicName: string };

export type FoodItemLabelPublicShefFragment = { __typename?: 'PublicShef', id: string, imageUrl?: string | null, publicName: string };

export type GlobalInitialStateQueryVariables = Exact<{
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GlobalInitialStateQuery = { __typename?: 'Query', rateRecentOrderPopupEnabled: boolean, shefRatingEnabled: boolean, appleSignInOnWebEnabled: boolean, upsellsEnabled: boolean, apiSyncEnabled: boolean, profilePaymentMethodsEnabled: boolean, profileDeliveryAddressesEnabled: boolean, giftCardPurchaseEnabled: boolean, disableAdminPages: boolean, holidayMenusEnabled: boolean, foodItemAudits: boolean, shefPlatformUsageQuestionnaire: boolean, dishwasher: boolean, dishFirstNav: boolean, shefDashboardInsights: boolean, requestAppReviewsEnabled: boolean, shefMenuChecklistEnabled: boolean, shefPostsEnabled: boolean, chatEnabled: boolean, shefApplicationAlwaysEnableContinueInformationSessionVideo: boolean, consumerDeleteUserEnabled: boolean, shefGrowYourBusinessEnabled: boolean, personalShefEnabled: boolean, shefSideCustomizations: boolean, fringeOverrideEnabled: boolean, bulkDiscountEnabled: boolean, chatSupportKeywords?: string | null, chatFeedbackKeywords?: string | null, chatCustomizationKeywords?: string | null, chatBusinessRiskKeywords?: string | null, mealPlansEnabled: boolean, mealPlansAllergensEnabled: boolean, mealPlansBrowseAsGuest: boolean, showManageMealPlans: boolean, flexibleSidesEnabled: boolean, isIntakeRevampEnabled: boolean, reusablePackagingEnabled: boolean, shefRosterEnabled: boolean, emptyHeldOrdersEnabled: boolean, mealPlanModificationEnabled: boolean, weeklyShefServiceMenuTemplateEnabled: boolean, me?: { __typename?: 'User', id: string, flakeId: string, email: string, phone?: string | null, firstName: string, lastName: string, fullName?: string | null, shefStatus: ShefStatus, admin: boolean, isPhotoEditor: boolean, isMenuCurator: boolean, imageUrl: string, lastSearchedZipCode?: string | null, lastSearchedZipCodeIsAvailableToCustomers?: boolean | null, lastSearchedRegionId?: number | null, createdAt: string, publicName: string, orderCount: number, lastOrderPhoneNumber?: string | null, lastDetectedAppOpenAt?: string | null, isMealPlanDiscountEligible: boolean, hasActiveMealPlan?: boolean | null, hasActiveSubscription?: boolean | null, visitedMealPlanPreferences?: boolean | null, mealPlanLastFourDigits?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null, shefStripeConnect?: { __typename?: 'ShefStripeConnect', id: number } | null, shefApplication?: { __typename?: 'ShefApplication', id: number, zipcode?: string | null, orientationCallCompletedAt?: string | null, informationSessionCompletedAt?: string | null, informationWebinarAttendedAt?: string | null, isWaitlisted?: boolean | null, calendlyOrientationCallLink?: string | null, menuWebinarScheduledFor?: string | null } | null, shefProfile?: { __typename?: 'ShefProfile', id: number, shefAddressId?: number | null, averageRating?: number | null, totalRatings: number, isHubless: boolean, canOptInToFringe: boolean, shefAddress?: { __typename?: 'Address', zipCode: string } | null, primaryRegion?: { __typename?: 'RegionInfo', id: number, name: string, displayName: string, isDeliveryByShefsEnabled: boolean, isPickupEnabled: boolean } | null, consumerReferralInfo: { __typename?: 'ConsumerReferralInfo', eligibleAt?: string | null, adImageUrl?: string | null, referredCount?: number | null, referredCountUnique?: number | null, earningsInCents?: number | null, code?: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } | null }, freeDeliveryModal: { __typename?: 'FreeDeliveryModal', enabled: boolean, isNashShef: boolean } } | null, unratedGroupOrder?: { __typename?: 'GroupOrder', id: string, deliveryDate: string, orderType: OrderType, canReviewOrder: boolean, isCancelled: boolean, isFullyRefunded: boolean, isPartiallyRefunded: boolean, orderTotals: { __typename?: 'ConsumerOrderTotal', grandTotal: number }, orders: Array<{ __typename?: 'Order', createdAt: string, orderType: OrderType, grandTotal: number, isCancelable: boolean, subscriptionInvoiceId?: string | null, id: number, uuid: string, userId: string, shefId: string, subtotal: number, deliveryDate: string, orderStatus: OrderStatus, groupOrderId: string, groupOrderSize: number, groupOrderItemCount: number, publicShef: { __typename?: 'PublicShef', id: string, imageUrl?: string | null, flakeId: string, publicName: string, timeZone: string, resizedImageUrl?: string | null, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, availability: Array<{ __typename?: 'ShefAvailability', id: number }> }, shefProfile: { __typename?: 'ShefProfile', id: number, allowedToChat: boolean, fulfillmentOption?: string | null }, foodRating?: { __typename?: 'ShefOrderRating', id: number, comment?: string | null, privateComment?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: number, quantity: number, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', id: number, name?: string | null, userId: string, status: FoodItemStatus, imageUrl?: string | null, foodType?: FoodType | null, ratingCount: number }, rating?: { __typename?: 'FoodItemRating', ratingPercent?: number | null, tags?: Array<{ __typename?: 'FoodItemRatingTag', tag: string }> | null } | null }> }>, review: { __typename?: 'GroupOrderReview', status: GroupOrderReviewStatus } } | null, referralCode: { __typename?: 'ReferralCode', id: number, code: string, giveValue: number, getValue: number, maxUsesPerUser?: number | null } } | null, zipCode?: { __typename?: 'ZipCode', zipCode: string, regionId: number, timeZone: string, minimumAmountForDiscountedShipping?: number | null, discountedDeliveryFee: number, deliveryFee?: number | null, upfrontDeliveryFeeEnabled: boolean, region: { __typename?: 'RegionInfo', id: number, name: string } } | null, carts: { __typename?: 'CartResults', recentlyAdded: boolean, foodItems: Array<{ __typename?: 'CartLineItem', id: number, shefId: string, foodItemId: number, quantity: number, createdAt: string, updatedAt: string, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } }>, addOnItems: Array<{ __typename?: 'CartAddOnItem', id: number, userId: string, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string } }> }, availableAddOnItems: Array<{ __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string }> };

export type SaveCartsMutationVariables = Exact<{
  cartLineItemInputs: Array<CartLineItemInput> | CartLineItemInput;
}>;


export type SaveCartsMutation = { __typename?: 'Mutation', setCartItems: Array<{ __typename?: 'CartLineItem', id: number } | null> };

export type CartItemsSaveMutationVariables = Exact<{
  cartLineItemInputs: Array<CartLineItemInput> | CartLineItemInput;
  deliveryDate: Scalars['DateTime']['input'];
}>;


export type CartItemsSaveMutation = { __typename?: 'Mutation', cartSetLineItems: { __typename?: 'CartResults', recentlyAdded: boolean, bulkDiscountTiers: Array<{ __typename?: 'BulkDiscountTier', minSubtotal: number, maxSubtotal?: number | null, discountRate: number }>, foodItems: Array<{ __typename?: 'CartLineItem', id: number, shefId: string, foodItemId: number, quantity: number, createdAt: string, updatedAt: string, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } }>, addOnItems: Array<{ __typename?: 'CartAddOnItem', id: number, userId: string, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string } }> } };

export type CartsClearMutationVariables = Exact<{
  shefIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CartsClearMutation = { __typename?: 'Mutation', cartClearItems: { __typename?: 'CartResults', recentlyAdded: boolean, foodItems: Array<{ __typename?: 'CartLineItem', id: number, shefId: string, foodItemId: number, quantity: number, createdAt: string, updatedAt: string, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } }>, addOnItems: Array<{ __typename?: 'CartAddOnItem', id: number, userId: string, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string } }> } };

export type CartBulkDiscountTierFragment = { __typename?: 'BulkDiscountTier', minSubtotal: number, maxSubtotal?: number | null, discountRate: number };

export type CartFoodItemFragment = { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null };

export type WholeAddOnItemFragment = { __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string };

export type WholeCartAddOnItemFragment = { __typename?: 'CartAddOnItem', id: number, userId: string, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string } };

export type WholeCartLineItemFragment = { __typename?: 'CartLineItem', id: number, shefId: string, foodItemId: number, quantity: number, createdAt: string, updatedAt: string, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } };

export type WholeCartsFragment = { __typename?: 'CartResults', recentlyAdded: boolean, foodItems: Array<{ __typename?: 'CartLineItem', id: number, shefId: string, foodItemId: number, quantity: number, createdAt: string, updatedAt: string, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } }>, addOnItems: Array<{ __typename?: 'CartAddOnItem', id: number, userId: string, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string } }> };

export type CartsQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type CartsQuery = { __typename?: 'Query', carts: { __typename?: 'CartResults', recentlyAdded: boolean, bulkDiscountTiers: Array<{ __typename?: 'BulkDiscountTier', minSubtotal: number, maxSubtotal?: number | null, discountRate: number }>, foodItems: Array<{ __typename?: 'CartLineItem', id: number, shefId: string, foodItemId: number, quantity: number, createdAt: string, updatedAt: string, customizationIds?: Array<string> | null, foodItem: { __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null } }>, addOnItems: Array<{ __typename?: 'CartAddOnItem', id: number, userId: string, addOnItemId: number, quantity: number, addOnItem: { __typename?: 'AddOnItem', id: number, name: string, displayText: string, price: number, extraText?: string | null, addonType: AddOnItemType, imageUrl: string } }> }, exploreFoodItemsFilterOptions?: { __typename?: 'ExploreFoodItemsFilterOptionsResults', availableDeliveryDays: Array<{ __typename?: 'NumberAvailableDishesResult', date: string }> } | null };

export type CartFoodItemsQueryVariables = Exact<{
  foodItemIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CartFoodItemsQuery = { __typename?: 'Query', foodItems: Array<{ __typename?: 'FoodItem', userId: string, foodType?: FoodType | null, slug: string, id: number, imageUrl?: string | null, name?: string | null, portion?: string | null, servingSize?: string | null, description?: string | null, ingredients?: string | null, price: number, spiceLevel: number, vegetarian?: boolean | null, vegan?: boolean | null, lowFodmap?: boolean | null, lowSodium?: boolean | null, keto?: boolean | null, kosher?: boolean | null, paleo?: boolean | null, whole30?: boolean | null, isHalal: boolean, isOrganic: boolean, numServings?: number | null, containsNuts: boolean, containsEggs: boolean, containsShellfish: boolean, containsSoy: boolean, isPopular?: boolean | null, glutenFree: boolean, dairyFree: boolean, packaging: Packaging, capacity?: number | null, availability: Array<{ __typename?: 'FoodItemAvailability', availabilityDate: string, numAvailable?: number | null }>, cuisineCategories: Array<{ __typename?: 'CuisineCategory', id: string, title: string, type: CuisineCategoryType }>, servingSizeCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null, spiceLevelCustomizations?: Array<{ __typename?: 'FoodItemCustomization', id: string, customizationTypeId: string, priceFactor: number, priceFactorType: PriceFactorType, portion?: string | null, customizationType: { __typename?: 'FoodItemCustomizationType', id: string, category: CustomizationCategory, name: string, dataType: string } }> | null }> };

export type CartShefsQueryVariables = Exact<{
  shefIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CartShefsQuery = { __typename?: 'Query', shefs: Array<{ __typename?: 'PublicShef', id: string, firstName?: string | null, timeZone: string, imageUrl?: string | null, celebrityEventType?: CelebrityEventType | null, availability: Array<{ __typename?: 'ShefAvailability', id: number, availabilityDate: string, isSoldOut: boolean, numDishesAvailable: number }>, shefProfile: { __typename?: 'ShefProfile', cuisineRegion?: CuisineRegion | null, businessName?: string | null, cutoffMsBeforeDeliveryDate: number, dishCapacity: number, isTrialShef: boolean } }> };

export type TimeWindowSelectorTimeWindowFragment = { __typename?: 'TimeWindow', id: number, startMsAfterMidnight: number, endMsAfterMidnight: number };

export type StringifiableTimeWindowFragment = { __typename?: 'TimeWindow', startMsAfterMidnight: number, endMsAfterMidnight: number };

export type IngestAnalyticsEventMutationVariables = Exact<{
  eventName: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
}>;


export type IngestAnalyticsEventMutation = { __typename?: 'Mutation', ingestAnalyticsEvent: boolean };

export type FacebookTrackEventMutationVariables = Exact<{
  eventName: Scalars['String']['input'];
  event: FacebookEvent;
}>;


export type FacebookTrackEventMutation = { __typename?: 'Mutation', ingestFacebookEvent: boolean };

export type CachedZipCodeFragment = { __typename?: 'ZipCode', zipCode: string, minimumAmountForDiscountedShipping?: number | null, discountedDeliveryFee: number, availableToCustomers: boolean, deliveryFee?: number | null, deliveryType: string, timeZone: string, isHubless: boolean, region: { __typename?: 'RegionInfo', id: number, isPickupEnabled: boolean, isVerifiedHalalEnabled: boolean, launchedAt: string, isInWaitlist: boolean, ecoPackagingEnabled: boolean } };

export type UseCachedZipCodeQueryVariables = Exact<{
  zipcode: Scalars['String']['input'];
}>;


export type UseCachedZipCodeQuery = { __typename?: 'Query', zipCode?: { __typename?: 'ZipCode', zipCode: string, minimumAmountForDiscountedShipping?: number | null, discountedDeliveryFee: number, availableToCustomers: boolean, deliveryFee?: number | null, deliveryType: string, timeZone: string, isHubless: boolean, region: { __typename?: 'RegionInfo', id: number, isPickupEnabled: boolean, isVerifiedHalalEnabled: boolean, launchedAt: string, isInWaitlist: boolean, ecoPackagingEnabled: boolean } } | null };

export type ModifyUserPhoneMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type ModifyUserPhoneMutation = { __typename?: 'Mutation', modifyUserPhone: { __typename?: 'User', id: string, phone?: string | null } };

export type WaitlistRanksQueryVariables = Exact<{ [key: string]: never; }>;


export type WaitlistRanksQuery = { __typename?: 'Query', waitlistRanks: Array<{ __typename?: 'WaitlistRank', totalUsers: number, rank: number, waitlistType?: WaitlistType | null }> };

export const AddressRadioInputAddressFragmentDoc = gql`
    fragment AddressRadioInputAddress on Address {
  id
  formattedAddress
}
    `;
export const GenericOrderFieldsFragmentDoc = gql`
    fragment GenericOrderFields on Order {
  id
  uuid
  userId
  shefId
  subtotal
  deliveryDate
  orderStatus
  createdAt
  groupOrderId
  groupOrderSize
  groupOrderItemCount
}
    `;
export const UpcomingOrderFieldsFragmentDoc = gql`
    fragment UpcomingOrderFields on Order {
  ...GenericOrderFields
  createdAt
  publicShef {
    id
    imageUrl
    flakeId
    publicName
    timeZone
    resizedImageUrl(width: 24)
    cuisineCategories {
      id
      title
      type
    }
    availability {
      id
    }
  }
  shefProfile {
    id
    allowedToChat
    fulfillmentOption
  }
  orderType
  grandTotal
  isCancelable
  subscriptionInvoiceId
  foodRating {
    id
    comment
    privateComment
  }
  lineItems {
    id
    quantity
    foodItem {
      id
      name
      userId
      status
      imageUrl
      foodType
      ratingCount
    }
    rating {
      ratingPercent
      tags {
        tag
      }
    }
    customizationIds
  }
}
    ${GenericOrderFieldsFragmentDoc}`;
export const ConsumerGroupOrderFieldsFragmentDoc = gql`
    fragment ConsumerGroupOrderFields on GroupOrder {
  id
  deliveryDate
  orderType
  canReviewOrder
  isCancelled
  isFullyRefunded
  isPartiallyRefunded
  orderTotals {
    grandTotal
  }
  orders {
    ...UpcomingOrderFields
  }
  review {
    status
  }
}
    ${UpcomingOrderFieldsFragmentDoc}`;
export const CurrentUserFieldsFragmentDoc = gql`
    fragment CurrentUserFields on User {
  id
  flakeId
  email
  phone
  firstName
  lastName
  fullName
  shefStatus
  admin
  isPhotoEditor
  isMenuCurator
  imageUrl
  lastSearchedZipCode
  lastSearchedZipCodeIsAvailableToCustomers
  lastSearchedRegionId
  organization {
    id
    name
  }
  shefStripeConnect {
    id
  }
  shefApplication {
    id
    zipcode
    orientationCallCompletedAt
    informationSessionCompletedAt
    informationWebinarAttendedAt
    isWaitlisted
    calendlyOrientationCallLink
    menuWebinarScheduledFor
  }
  shefProfile {
    id
    shefAddressId
    shefAddress {
      zipCode
    }
    averageRating
    totalRatings
    primaryRegion {
      id
      name
      displayName
      isDeliveryByShefsEnabled
      isPickupEnabled
    }
    consumerReferralInfo {
      eligibleAt
      adImageUrl
      code {
        id
        code
        giveValue
        getValue
        maxUsesPerUser
      }
      referredCount
      referredCountUnique
      earningsInCents
    }
    freeDeliveryModal {
      enabled
      isNashShef
    }
    isHubless
    canOptInToFringe
  }
  createdAt
  publicName
  unratedGroupOrder {
    ...ConsumerGroupOrderFields
  }
  referralCode {
    id
    code
    giveValue
    getValue
    maxUsesPerUser
  }
  orderCount
  lastOrderPhoneNumber
  lastDetectedAppOpenAt
  isMealPlanDiscountEligible
  phone
  hasActiveMealPlan
  hasActiveSubscription
  visitedMealPlanPreferences
  mealPlanLastFourDigits
}
    ${ConsumerGroupOrderFieldsFragmentDoc}`;
export const AuthResultFieldsFragmentDoc = gql`
    fragment AuthResultFields on AuthResults {
  user {
    ...CurrentUserFields
  }
  token
  isExistingUser
  isImpersonatedUser
}
    ${CurrentUserFieldsFragmentDoc}`;
export const CartOrderTotalFragmentDoc = gql`
    fragment CartOrderTotal on OrderTotals {
  subtotal
  discountApplied
  promoApplied
  nonPromoDiscountApplied
  deliveryFee
  smallOrderFee
  remainingToRemoveSmallOrderFee
  grandTotal
}
    `;
export const OrderShefProfileFragmentDoc = gql`
    fragment OrderShefProfile on ShefProfile {
  id
  isTrialShef
  coverPhotoUrl
  previewFoodItem {
    imageUrl
  }
  specialty
  cuisineRegion
  cuisineCategories {
    id
    title
    type
  }
  bio
  videoUrl
  randomZip
  explorePagePromoCode {
    id
    code
    value
    isPercentage
  }
  cutoffMsBeforeDeliveryDate
  timeZone
  dishCapacity
  mehkoLicenseNumber
  approximateLocation {
    latitude
    longitude
  }
  allowedToChat
  businessName
  websiteUrl
  facebookHandle
  instagramHandle
  twitterHandle
  tikTokHandle
  linkedInHandle
  fulfillmentOption
  fhcApprovedAt
  isBlockedDueToMissingFHC
}
    `;
export const DeliveryPriceFieldsFragmentDoc = gql`
    fragment DeliveryPriceFields on DeliveryPrice {
  rawDeliveryCost
  deliveryDiscount
  finalDeliveryPrice
}
    `;
export const OrderShefFragmentDoc = gql`
    fragment OrderShef on PublicShef {
  id
  flakeId
  firstName
  publicName
  imageUrl
  isTopShef
  shefProfile {
    ...OrderShefProfile
  }
  deliveryPrice(destZipCode: $zipCode) {
    ...DeliveryPriceFields
  }
  rating {
    score
    count
  }
  availability(zipCode: $zipCode) {
    availabilityDate
    isSoldOut
    numDishesAvailable
  }
  celebrityEventType
  totalOrders
  timeZone
}
    ${OrderShefProfileFragmentDoc}
${DeliveryPriceFieldsFragmentDoc}`;
export const DishDescriptionFoodItemFragmentDoc = gql`
    fragment DishDescriptionFoodItem on FoodItem {
  id
  name
  price
  spiceLevel
  description
  vegetarian
  vegan
  glutenFree
  dairyFree
  lowFodmap
  paleo
  whole30
  isHalal
  isOrganic
  isPopular
  packaging
  containsEggs
  containsShellfish
  containsSoy
  containsNuts
}
    `;
export const ConsumerFoodItemAvailabilityFragmentDoc = gql`
    fragment ConsumerFoodItemAvailability on FoodItemAvailability {
  availabilityDate
  numAvailable
}
    `;
export const FoodItemCustomizationTypeFieldsFragmentDoc = gql`
    fragment FoodItemCustomizationTypeFields on FoodItemCustomizationType {
  id
  category
  name
  dataType
}
    `;
export const FoodItemCustomizationFieldsFragmentDoc = gql`
    fragment FoodItemCustomizationFields on FoodItemCustomization {
  id
  customizationTypeId
  customizationType {
    ...FoodItemCustomizationTypeFields
  }
  priceFactor
  priceFactorType
  portion
}
    ${FoodItemCustomizationTypeFieldsFragmentDoc}`;
export const ConsumerOrderDishDescriptionModalFoodItemFragmentDoc = gql`
    fragment ConsumerOrderDishDescriptionModalFoodItem on FoodItem {
  id
  userId
  imageUrl
  name
  slug
  portion
  servingSize
  description
  ingredients
  price
  spiceLevel
  vegetarian
  vegan
  lowFodmap
  lowSodium
  keto
  kosher
  paleo
  whole30
  isHalal
  isOrganic
  numServings
  containsNuts
  containsEggs
  containsShellfish
  containsSoy
  isPopular
  glutenFree
  dairyFree
  packaging
  capacity
  cuisineCategories {
    id
    title
    type
  }
  servingSizeCustomizations {
    ...FoodItemCustomizationFields
  }
  spiceLevelCustomizations {
    ...FoodItemCustomizationFields
  }
}
    ${FoodItemCustomizationFieldsFragmentDoc}`;
export const ConsumerOrderDishSelectionItemFragmentDoc = gql`
    fragment ConsumerOrderDishSelectionItem on FoodItem {
  foodItemId: id
  id
  userId
  name
  imageUrl
  slug
  price
  ingredients
  description
  portion
  servingSize
  foodType
  capacity
  vegan
  vegetarian
  lowFodmap
  lowSodium
  keto
  kosher
  paleo
  whole30
  containsNuts
  containsEggs
  containsShellfish
  containsSoy
  isHalal
  isOrganic
  spiceLevel
  isPopular
  glutenFree
  dairyFree
  packaging
  ratingCount
  averageRating
  availableMonday
  availableTuesday
  availableWednesday
  availableThursday
  availableFriday
  availableSaturday
  availableSunday
  topPositiveTags
  startDate
  endDate
  ...DishDescriptionFoodItem
  availability {
    ...ConsumerFoodItemAvailability
  }
  ...ConsumerOrderDishDescriptionModalFoodItem
  holiday
  servingSizeCustomizations {
    ...FoodItemCustomizationFields
  }
  spiceLevelCustomizations {
    ...FoodItemCustomizationFields
  }
}
    ${DishDescriptionFoodItemFragmentDoc}
${ConsumerFoodItemAvailabilityFragmentDoc}
${ConsumerOrderDishDescriptionModalFoodItemFragmentDoc}
${FoodItemCustomizationFieldsFragmentDoc}`;
export const AvailabilityFieldsFragmentDoc = gql`
    fragment AvailabilityFields on FoodItem {
  availableMonday
  availableTuesday
  availableWednesday
  availableThursday
  availableFriday
  availableSaturday
  availableSunday
  startDate
  endDate
}
    `;
export const FoodItemTagFieldsFragmentDoc = gql`
    fragment FoodItemTagFields on FoodItem {
  vegan
  vegetarian
  glutenFree
  dairyFree
  keto
  kosher
  paleo
  lowFodmap
  lowSodium
  whole30
  isHalal
  isOrganic
  containsEggs
  containsNuts
  containsShellfish
  containsSoy
  spiceLevel
  packaging
}
    `;
export const FoodItemDescriptionFieldsFragmentDoc = gql`
    fragment FoodItemDescriptionFields on FoodItem {
  id
  userId
  imageUrl
  price
  foodType
  slug
  name
  description
  portion
  ingredients
  ...AvailabilityFields
  ...FoodItemTagFields
}
    ${AvailabilityFieldsFragmentDoc}
${FoodItemTagFieldsFragmentDoc}`;
export const ConsumerFoodItemFragmentDoc = gql`
    fragment ConsumerFoodItem on FoodItem {
  ...ConsumerOrderDishSelectionItem
  ...FoodItemDescriptionFields
}
    ${ConsumerOrderDishSelectionItemFragmentDoc}
${FoodItemDescriptionFieldsFragmentDoc}`;
export const PromoCodeFieldsFragmentDoc = gql`
    fragment PromoCodeFields on PromoCode {
  id
  promoCodeType
  isPercentage
  value
  code
  isFreeDelivery
  onlyUsableOnDates
  maxUsesPerUser
  firstPromoOnly
  restrictedToShefIds
  restrictedToCuisineRegions
  restrictedToEmailDomains
  maxValue
  minOrderValue
  disabled
  usesRemainingForUser
  isShefToConsumerPromo
  referrer {
    id
    shefStatus
  }
}
    `;
export const CartFoodItemFragmentDoc = gql`
    fragment CartFoodItem on FoodItem {
  userId
  foodType
  slug
  availability {
    ...ConsumerFoodItemAvailability
  }
  ...ConsumerOrderDishDescriptionModalFoodItem
}
    ${ConsumerFoodItemAvailabilityFragmentDoc}
${ConsumerOrderDishDescriptionModalFoodItemFragmentDoc}`;
export const WholeAddOnItemFragmentDoc = gql`
    fragment WholeAddOnItem on AddOnItem {
  id
  name
  displayText
  price
  extraText
  addonType
  imageUrl
}
    `;
export const GenericAddressFieldsFragmentDoc = gql`
    fragment GenericAddressFields on Address {
  id
  name
  company
  unit
  street
  city
  province
  zipCode
  country
  latitude
  longitude
  phone
  deliveryNotes
}
    `;
export const AddressSelectorAddressFragmentDoc = gql`
    fragment AddressSelectorAddress on Address {
  id
  userId
  formattedAddress
  ...GenericAddressFields
  archived
  disabled
}
    ${GenericAddressFieldsFragmentDoc}`;
export const StringifiableTimeWindowFragmentDoc = gql`
    fragment StringifiableTimeWindow on TimeWindow {
  startMsAfterMidnight
  endMsAfterMidnight
}
    `;
export const TimeWindowSelectorTimeWindowFragmentDoc = gql`
    fragment TimeWindowSelectorTimeWindow on TimeWindow {
  id
  ...StringifiableTimeWindow
}
    ${StringifiableTimeWindowFragmentDoc}`;
export const EditOrderDeliveryFieldsFragmentDoc = gql`
    fragment EditOrderDeliveryFields on Order {
  id
  shefId
  deliveryDate
  deliveryNotes
  deliveryAddressId
  timeWindowId
  phone
  deliveryNotes
  shefProfile {
    id
    timeZone
    primaryRegion {
      id
    }
  }
  address {
    ...AddressSelectorAddress
    zipCodeInfo {
      zipCode
      regionId
      timeWindows {
        ...TimeWindowSelectorTimeWindow
      }
    }
  }
  possibleDeliveryDates {
    date
    possible
    reason
    unavailableItems {
      foodItem {
        id
      }
      quantityAvailable
    }
  }
}
    ${AddressSelectorAddressFragmentDoc}
${TimeWindowSelectorTimeWindowFragmentDoc}`;
export const ConsumerOrderReceiptStepsFragmentDoc = gql`
    fragment ConsumerOrderReceiptSteps on Order {
  id
  consumerOrderStatus
  delivery {
    id
    estimatedDeliveryTime
    driverPhone
    driverName
  }
  address {
    id
    formattedAddress
    phone
    zipCode
    zipCodeInfo {
      zipCode
      timeZone
    }
  }
}
    `;
export const ConsumerOrderReceiptDeliveryNameFragmentDoc = gql`
    fragment ConsumerOrderReceiptDeliveryName on Order {
  user {
    firstName
    lastName
    publicName
  }
  address {
    name
  }
}
    `;
export const ConsumerOrderReceiptFoodItemFieldsFragmentDoc = gql`
    fragment ConsumerOrderReceiptFoodItemFields on FoodItem {
  id
  name
  imageUrl
  spiceLevel
  servingSize
  portion
  spiceLevelCustomizations {
    id
    customizationType {
      name
    }
  }
  servingSizeCustomizations {
    id
    customizationType {
      name
    }
  }
  shef {
    id
    publicName
  }
  cuisineCategories {
    id
    title
    type
  }
  upsell {
    price
    tier
  }
}
    `;
export const ConsumerOrderReceiptLineItemFieldsFragmentDoc = gql`
    fragment ConsumerOrderReceiptLineItemFields on OrderLineItem {
  id
  quantity
  price
  foodItemSnapshot
  foodItem {
    ...ConsumerOrderReceiptFoodItemFields
  }
  customizationIds
}
    ${ConsumerOrderReceiptFoodItemFieldsFragmentDoc}`;
export const ConsumerOrderReceiptFieldsFragmentDoc = gql`
    fragment ConsumerOrderReceiptFields on Order {
  ...ConsumerOrderReceiptSteps
  ...ConsumerOrderReceiptDeliveryName
  id
  shef {
    id
    publicName
    firstName
    imageUrl
    flakeId
  }
  user {
    id
    firstName
    lastName
    publicName
    email
  }
  createdAt
  subtotal
  deliveryDate
  orderType
  orderStatus
  consumerOrderStatus
  isCancelable
  isDeliveryEditable
  isLineItemsEditable
  lineItems {
    ...ConsumerOrderReceiptLineItemFields
  }
  addOnItems {
    id
    quantity
    price
    addOnItem {
      id
      name
      price
      imageUrl
      displayText
      addonType
    }
  }
  address {
    id
    formattedAddress
    zipCode
    zipCodeInfo {
      zipCode
      timeZone
    }
  }
  timeWindow {
    id
    startMsAfterMidnight
    endMsAfterMidnight
  }
  delivery {
    id
  }
  deliveryType
  pickupAddress {
    id
    latitude
    longitude
    formattedAddress
    deliveryNotes
    phone
  }
  promoCode {
    promoCodeType
  }
}
    ${ConsumerOrderReceiptStepsFragmentDoc}
${ConsumerOrderReceiptDeliveryNameFragmentDoc}
${ConsumerOrderReceiptLineItemFieldsFragmentDoc}`;
export const EditableOrderFragmentDoc = gql`
    fragment EditableOrder on Order {
  id
  groupOrderId
  shef {
    id
    publicName
    firstName
  }
  publicShef {
    ...OrderShef
    availability(zipCode: $zipCode) {
      availabilityDate
      numDishesAvailable
    }
    activeFoodItems {
      ...ConsumerFoodItem
    }
  }
  promoCode {
    ...PromoCodeFields
  }
  subtotal
  deliveryDate
  orderType
  orderStatus
  consumerOrderStatus
  discountApplied
  salesTax
  deliveryFee
  deliveryDiscount
  serviceFee
  shefTip
  grandTotal
  isCancelable
  isDeliveryEditable
  isLineItemsEditable
  deliveryType
  lineItems {
    id
    userId
    foodItemId
    quantity
    price
    foodItem {
      ...CartFoodItem
    }
    customizationIds
  }
  addOnItems {
    id
    price
    addOnItemId
    quantity
    addOnItem {
      ...WholeAddOnItem
    }
  }
  ...EditOrderDeliveryFields
  ...ConsumerOrderReceiptFields
  availableAddOnItems {
    ...WholeAddOnItem
  }
}
    ${OrderShefFragmentDoc}
${ConsumerFoodItemFragmentDoc}
${PromoCodeFieldsFragmentDoc}
${CartFoodItemFragmentDoc}
${WholeAddOnItemFragmentDoc}
${EditOrderDeliveryFieldsFragmentDoc}
${ConsumerOrderReceiptFieldsFragmentDoc}`;
export const ExplorePagePromoCodeFragmentDoc = gql`
    fragment ExplorePagePromoCode on PromoCode {
  id
  code
  promoCodeType
  value
}
    `;
export const EntireOrderTotalFragmentDoc = gql`
    fragment EntireOrderTotal on OrderTotals {
  subtotal
  promoApplied
  nonPromoDiscountApplied
  salesTax
  deliveryFee
  smallOrderFee
  remainingToRemoveSmallOrderFee
  serviceFee
  shefTip
  grandTotal
  shefTipOptions {
    value
    label
    percent
  }
}
    `;
export const ConfigFieldsFragmentDoc = gql`
    fragment ConfigFields on Config {
  id
  type
  name
  value
  overrides {
    id
    segment
    segmentValue
    value
  }
}
    `;
export const FoodItemAuditRequestRowFieldsFragmentDoc = gql`
    fragment FoodItemAuditRequestRowFields on FoodItemAuditRequest {
  id
  auditGroupId
  version
  foodItemId
  auditStatus
  auditFitnessScore
  reviewFitnessScore
  foodItem {
    id
    name
    user {
      id
      firstName
    }
  }
  lastCommentedBy {
    id
    firstName
  }
}
    `;
export const EditableFoodItemFragmentDoc = gql`
    fragment EditableFoodItem on FoodItem {
  id
  userId
  name
  imageUrl
  price
  description
  capacity
  foodType
  ingredients
  portion
  servingSize
  needsSide
  imageUrl
  prepInstructions
  status
  numDaysBeforeExpires
  numServings
  numLabels
  startDate
  endDate
  ...AvailabilityFields
  ...FoodItemTagFields
  prefabFoodItemId
  packaging
  updatedAt
  foodItemPairIds
  cuisineCategoryIds
  servingSizeCustomizations {
    id
    customizationTypeId
    customizationType {
      id
      category
      name
      dataType
    }
    priceFactor
    priceFactorType
    portion
  }
  spiceLevelCustomizations {
    id
    customizationTypeId
    customizationType {
      id
      category
      name
      dataType
    }
    priceFactor
    priceFactorType
    portion
  }
  customizations {
    ...FoodItemCustomizationFields
  }
  upsellTierId
  upsell {
    id
    tier
    price
  }
}
    ${AvailabilityFieldsFragmentDoc}
${FoodItemTagFieldsFragmentDoc}
${FoodItemCustomizationFieldsFragmentDoc}`;
export const CommentUserAvatarFragmentDoc = gql`
    fragment CommentUserAvatar on User {
  publicName
  imageUrl
  id
}
    `;
export const ChangesetViewFragmentDoc = gql`
    fragment ChangesetView on FoodItemChangeset {
  id
  createdAt
  name
  imageUrl
  description
  price
  ingredients
  portion
  prepInstructions
  availableMonday
  availableTuesday
  availableWednesday
  availableThursday
  availableFriday
  availableSaturday
  availableSunday
  endDate
  startDate
  capacity
  vegan
  vegetarian
  glutenFree
  dairyFree
  containsEggs
  containsNuts
  containsShellfish
  containsSoy
  isHalal
  isOrganic
  paleo
  whole30
  lowFodmap
  keto
  kosher
  lowSodium
  spiceLevel
  foodType
  numDaysBeforeExpires
  numServings
  servingSize
  needsSide
  user {
    ...CommentUserAvatar
  }
  packaging
  servingSizeCustomizations {
    id
    customizationTypeId
    customizationType {
      id
      category
      name
      dataType
    }
    priceFactor
    priceFactorType
    portion
  }
  spiceLevelCustomizations {
    id
    customizationTypeId
    customizationType {
      id
      category
      name
      dataType
    }
    priceFactor
    priceFactorType
    portion
  }
  customizations {
    id
    customizationTypeId
    customizationType {
      id
      category
      name
      dataType
    }
    priceFactor
    priceFactorType
    portion
  }
}
    ${CommentUserAvatarFragmentDoc}`;
export const CommentThreadCommentFragmentDoc = gql`
    fragment CommentThreadComment on FoodItemChangeRequestComment {
  id
  user {
    ...CommentUserAvatar
  }
  message
  createdAt
}
    ${CommentUserAvatarFragmentDoc}`;
export const ChangeRequestViewFragmentDoc = gql`
    fragment ChangeRequestView on FoodItemChangeRequest {
  id
  status
  foodItem {
    ...EditableFoodItem
    hasUnreadComments
    user {
      publicName
    }
  }
  changesets {
    ...ChangesetView
  }
  comments {
    ...CommentThreadComment
  }
}
    ${EditableFoodItemFragmentDoc}
${ChangesetViewFragmentDoc}
${CommentThreadCommentFragmentDoc}`;
export const FoodItemAuditRequestFieldsFragmentDoc = gql`
    fragment FoodItemAuditRequestFields on FoodItemAuditRequest {
  id
  auditGroupId
  auditStatus
  foodItemChangeRequests {
    ...ChangeRequestView
  }
  startingFoodItem {
    ...EditableFoodItem
  }
  currentFoodItem {
    ...EditableFoodItem
  }
}
    ${ChangeRequestViewFragmentDoc}
${EditableFoodItemFragmentDoc}`;
export const ChangeRequestCommentThreadFragmentDoc = gql`
    fragment ChangeRequestCommentThread on FoodItemChangeRequest {
  id
  status
  changesets {
    ...ChangesetView
  }
  comments {
    ...CommentThreadComment
  }
  lastUpdatedBy {
    ...CommentUserAvatar
  }
  updatedAt
}
    ${ChangesetViewFragmentDoc}
${CommentThreadCommentFragmentDoc}
${CommentUserAvatarFragmentDoc}`;
export const FoodItemLabelUserFragmentDoc = gql`
    fragment FoodItemLabelUser on User {
  imageUrl
  publicName
}
    `;
export const FoodItemLabelFoodItemFragmentDoc = gql`
    fragment FoodItemLabelFoodItem on FoodItem {
  id
  name
  prepInstructions
  numDaysBeforeExpires
  numLabels
  servingSize
  spiceLevel
  shef {
    publicName
  }
  servingSizeCustomizations {
    id
  }
  spiceLevelCustomizations {
    id
  }
}
    `;
export const FoodItemTableFoodItemFragmentDoc = gql`
    fragment FoodItemTableFoodItem on FoodItem {
  id
  user {
    id
    ...FoodItemLabelUser
  }
  name
  imageUrl
  price
  description
  capacity
  foodType
  status
  numDaysBeforeExpires
  portion
  servingSize
  ...AvailabilityFields
  mostRecentOpenChangeRequest {
    ...ChangeRequestView
  }
  ...FoodItemLabelFoodItem
  holiday
  hasUnreadComments
}
    ${FoodItemLabelUserFragmentDoc}
${AvailabilityFieldsFragmentDoc}
${ChangeRequestViewFragmentDoc}
${FoodItemLabelFoodItemFragmentDoc}`;
export const FoodItemLabelCustomizationFragmentDoc = gql`
    fragment FoodItemLabelCustomization on FoodItemCustomization {
  id
  customizationType {
    id
    category
    name
    dataType
  }
}
    `;
export const ShefOrderLabelsOrdersFragmentDoc = gql`
    fragment ShefOrderLabelsOrders on Order {
  id
  groupOrderId
  groupOrderSize
  groupOrderItemCount
  deliveryOrderNumber
  orderStatus
  deliveryNotes
  orderType
  createdAt
  userId
  orderType
  phone
  address {
    id
    name
    company
    street
    unit
    city
    province
    zipCode
    country
    zipCodeInfo {
      zipCode
      orderLabelCode
      hasMilkmanRecycling
      region {
        name
      }
    }
  }
  timeWindow {
    startMsAfterMidnight
    endMsAfterMidnight
  }
  pickupDeliveryHub {
    code
  }
  user {
    id
    fullName
    firstName
    lastName
  }
  lineItems {
    id
    quantity
    name
    foodItem {
      ...FoodItemLabelFoodItem
    }
    customizations {
      ...FoodItemLabelCustomization
    }
  }
  isFirstOrder
  deliveryType
  shefProfile {
    id
    primaryRegion {
      id
      name
      gsinEnabledAt
    }
    defaultDropoffHub {
      id
      code
      name
    }
  }
  isReusablePackaging
}
    ${FoodItemLabelFoodItemFragmentDoc}
${FoodItemLabelCustomizationFragmentDoc}`;
export const ShefOrderLabelsShefFragmentDoc = gql`
    fragment ShefOrderLabelsShef on PublicShef {
  id
  firstName
  publicName
  imageUrl
  shefProfile {
    id
    bio
    defaultDropoffHub {
      id
      code
      name
    }
  }
  activeFoodItems {
    id
    name
    imageUrl
  }
}
    `;
export const GenericGroupOrderFieldsFragmentDoc = gql`
    fragment GenericGroupOrderFields on GroupOrder {
  id
  uuid
  userId
  deliveryDate
  deliveryType
  orderType
}
    `;
export const GenericAdminUserFieldsFragmentDoc = gql`
    fragment GenericAdminUserFields on User {
  id
  publicName
  firstName
  lastName
  fullName
}
    `;
export const AdminOrderFieldsFragmentDoc = gql`
    fragment AdminOrderFields on Order {
  ...GenericOrderFields
  delivery {
    id
    externalId
  }
  deliveryType
  shefTip
  salesTax
  serviceFee
  deliveryFee
  grandTotal
  platformFee
  shefPayment
  reversedShefPaymentAmount
  discountApplied
  platformPayment
  currency
  deliveryAddressId
  transactionId
  refundId
  refundTimestamp
  cancelledAt
  createdAt
  notes
  deliveryNotes
  phone
  fulfillmentDate
  user {
    id
    ...GenericAdminUserFields
  }
  shef {
    id
    ...GenericAdminUserFields
  }
  shefProfile {
    id
    defaultDropoffHub {
      id
      code
      name
    }
    mehkoLicenseNumber
    primaryRegion {
      id
      gsinEnabledAt
      name
    }
  }
  promoCode {
    code
    isPercentage
    promoCodeType
    value
  }
}
    ${GenericOrderFieldsFragmentDoc}
${GenericAdminUserFieldsFragmentDoc}`;
export const AdminOrderLabelsOrderFieldsFragmentDoc = gql`
    fragment AdminOrderLabelsOrderFields on Order {
  ...AdminOrderFields
  isReusablePackaging
  isFirstOrder
  orderType
  timeWindow {
    startMsAfterMidnight
    endMsAfterMidnight
  }
  lineItems {
    id
    name
    foodItemId
    quantity
    price
    foodItem {
      ...FoodItemLabelFoodItem
    }
    customizations {
      ...FoodItemLabelCustomization
    }
  }
  address {
    id
    name
    company
    street
    unit
    city
    province
    zipCode
    country
    zipCodeInfo {
      zipCode
      orderLabelCode
      hasMilkmanRecycling
      region {
        name
      }
    }
  }
  pickupDeliveryHub {
    code
  }
}
    ${AdminOrderFieldsFragmentDoc}
${FoodItemLabelFoodItemFragmentDoc}
${FoodItemLabelCustomizationFragmentDoc}`;
export const AdminOrderLabelFieldsFragmentDoc = gql`
    fragment AdminOrderLabelFields on GroupOrder {
  ...GenericGroupOrderFields
  dayOfEmailScheduledTaskId
  deliveryAddressId
  deliveryNotes
  isCancelled
  isFullyRefunded
  pickupAddressId
  pickupDeliveryId
  phone
  timeWindowId
  subscriptionInvoiceId
  orderNumber
  orders {
    ...AdminOrderLabelsOrderFields
  }
}
    ${GenericGroupOrderFieldsFragmentDoc}
${AdminOrderLabelsOrderFieldsFragmentDoc}`;
export const AdminGroupOrderFieldsFragmentDoc = gql`
    fragment AdminGroupOrderFields on GroupOrder {
  id
  formattedId
  createdAt
  deliveryDate
  deliveryType
  cancelledAt
  skippedAt
  user {
    id
    publicName
    fullName
  }
  phone
  orders {
    id
    shefId
  }
  delivery {
    id
    externalId
  }
  orderTotals {
    deliveryFee
    promoApplied
    nonPromoDiscountApplied
    grandTotal
    refund
    salesTax
    serviceFee
    shefTip
    refundableBalance
    promoBalance
  }
  isFullyRefunded
  isPartiallyRefunded
}
    `;
export const FoodHandlerShefFragmentDoc = gql`
    fragment FoodHandlerShef on User {
  id
  fullName
  admin
  shefProfile {
    id
    foodHandlersCertificate
    fhcUploadedAt
    fhcApprovedAt
  }
}
    `;
export const RegionListFragmentFragmentDoc = gql`
    fragment RegionListFragment on RegionInfo {
  id
  name
}
    `;
export const CuisineCategoryItemFragmentDoc = gql`
    fragment CuisineCategoryItem on CuisineCategory {
  id
  title
  type
  isPrimary
}
    `;
export const ViewChangeRequestFragmentDoc = gql`
    fragment ViewChangeRequest on FoodItemChangeRequest {
  id
  status
  foodItem {
    ...EditableFoodItem
  }
  user {
    id
    firstName
    shefStatus
  }
  updatedAt
  lastUpdatedBy {
    id
    firstName
  }
  changesets {
    ...ChangesetView
  }
}
    ${EditableFoodItemFragmentDoc}
${ChangesetViewFragmentDoc}`;
export const AvailabilityOrderFieldsFragmentDoc = gql`
    fragment AvailabilityOrderFields on Order {
  deliveryDate
  fulfillmentDate
  orderStatus
}
    `;
export const ShefHubInfoFragmentDoc = gql`
    fragment ShefHubInfo on ShefProfile {
  defaultDropoffHub {
    name
    dropoffWindowStartTimeMinutesFromMidnight
    dropoffWindowEndTimeMinutesFromMidnight
  }
}
    `;
export const OrderBreakdownFragmentDoc = gql`
    fragment OrderBreakdown on Order {
  id
  orderStatus
  orderType
  subtotal
  addOnItemsTotal
  grandTotal
  shefTip
  shefPayment
  deliveryNotes
  deliveryType
  createdAt
  userId
  refundReason
  refundAmount
  reversedShefPaymentAmount
  isReusablePackaging
  refundType
  numOrdersFromShef
  groupOrderId
  groupOrderSize
  groupOrderItemCount
  address {
    id
    zipCode
    name
  }
  lineItems {
    id
    foodItemId
    quantity
    name
    price
    foodItem {
      name
      portion
      servingSize
      spiceLevel
    }
    customizations {
      id
      customizationType {
        id
        category
        name
        dataType
      }
      portion
      priceFactor
      priceFactorType
    }
  }
  shefFulfillmentTimeWindow {
    id
    startMsAfterMidnight
    endMsAfterMidnight
  }
  user {
    id
    flakeId
    publicName
    fullName: publicName
  }
  groupOrderId
  groupOrderSize
  correctedRefundReason
  correctedRefundType
}
    `;
export const ShefProfileFulfillmentFlagsFragmentDoc = gql`
    fragment ShefProfileFulfillmentFlags on RegionInfo {
  isDeliveryByShefsEnabled
  isPickupEnabled
}
    `;
export const ShefProfileEditDeliveryHubsFragmentDoc = gql`
    fragment ShefProfileEditDeliveryHubs on DeliveryHub {
  id
  name
  street
  city
  province
  unit
  pickupInstructions
  zipCode
  dropoffWindowStartTimeMinutesFromMidnight
  dropoffWindowEndTimeMinutesFromMidnight
}
    `;
export const ShefProfileEditShefProfileFragmentDoc = gql`
    fragment ShefProfileEditShefProfile on ShefProfile {
  id
  userId
  email
  phone
  bio
  notes
  businessName
  websiteUrl
  facebookHandle
  instagramHandle
  twitterHandle
  tikTokHandle
  linkedInHandle
  youtubeHandle
  specialty
  coverPhotoUrl
  videoUrl
  cuisineRegion
  cuisineCategoryIds
  featureShef
  trialStatus
  dishCapacity
  maxDishCapacity
  shefAddressId
  previewFoodItemId
  primaryRegion {
    id
    name
    ...ShefProfileFulfillmentFlags
  }
  user {
    publicName
    createdAt
    id
    fullName
    email
    shefStatus
    firstName
    lastName
    imageUrl
    activeAddresses {
      ...AddressSelectorAddress
    }
    shefStripeConnect {
      id
      stripeUserId
      userId
      accountType
      currentBalance {
        available
        pending
      }
      dashboardLoginLink
      createdAt
    }
  }
  defaultDropoffHub {
    ...ShefProfileEditDeliveryHubs
  }
  cutoffMsBeforeDeliveryDate
  fhcExpiresAt
  fhcUploadedAt
  fhcUploadRequiredBy
  newOrderNotificationFrequency
  cancelOrderNotificationFrequency
  setBadQualityAt
  onboardingFormAnsweredAt
  fulfillmentOption
  isHubless
  geographyAllowsCuisineType
}
    ${ShefProfileFulfillmentFlagsFragmentDoc}
${AddressSelectorAddressFragmentDoc}
${ShefProfileEditDeliveryHubsFragmentDoc}`;
export const ShefProfilePictureFragmentDoc = gql`
    fragment ShefProfilePicture on ShefApplication {
  profilePhotoOptionA
  profilePhotoOptionB
  profilePhotoOptionC
  profilePhotoSubmittedAt
  profilePhotoRejectedAt
  profilePhotoSubmissionStatus
}
    `;
export const ShefToMessageFragmentDoc = gql`
    fragment ShefToMessage on PublicShef {
  flakeId
  publicName
}
    `;
export const ActiveSubscriptionFieldsFragmentDoc = gql`
    fragment ActiveSubscriptionFields on Subscription {
  id
  recurringPeriodDays
  status
  orderTemplate {
    ...UpcomingOrderFields
  }
}
    ${UpcomingOrderFieldsFragmentDoc}`;
export const ConsumerSavedCardFieldsFragmentDoc = gql`
    fragment ConsumerSavedCardFields on SavedCreditCard {
  id
  lastFourDigits
  expiresAt
  brand
  type
  lastUsedAt
  linkedSubscriptionId
}
    `;
export const TasterFieldsFragmentDoc = gql`
    fragment TasterFields on User {
  isTasteTester
  unlockedTrialShefDiscovery(zipCode: $zipCode, deliveryDates: $deliveryDates)
}
    `;
export const ShefSearchResultFragmentDoc = gql`
    fragment ShefSearchResult on PublicShef {
  id
  publicName
  imageUrl
  rating {
    score
    count
  }
  activeFoodItems(limit: 1) {
    id
    imageUrl
  }
  shefProfile {
    id
    isTrialShef
    cuisineRegion
    specialty
    previewFoodItem {
      id
      imageUrl
    }
    cuisineCategories {
      id
      title
      type
    }
  }
}
    `;
export const ShefSearchResultsFieldsFragmentDoc = gql`
    fragment ShefSearchResultsFields on ShefSearchResults {
  hasMore
  cursor
  results {
    ...ShefSearchResult
  }
}
    ${ShefSearchResultFragmentDoc}`;
export const DishFirstShefProfileFragmentDoc = gql`
    fragment DishFirstShefProfile on ShefProfile {
  id
  isTrialShef
  timeZone
  cuisineRegion
  dishCapacity
  specialty
  bio
  cuisineCategories {
    id
    title
    type
  }
  cutoffMsBeforeDeliveryDate
}
    `;
export const DishSearchResultFragmentDoc = gql`
    fragment DishSearchResult on FoodItem {
  foodItemId: id
  id
  userId
  imageUrl
  name
  slug
  ratingCount
  averageRating
  ...AvailabilityFields
  availability {
    ...ConsumerFoodItemAvailability
  }
  user {
    publicName
  }
  shef {
    id
    firstName
    publicName
    shefProfile {
      ...DishFirstShefProfile
    }
    isTrialShef
  }
  portion
  price
  availability {
    availabilityDate
    numAvailable
  }
  cuisineCategories {
    id
    title
    type
  }
  servingSizeCustomizations {
    id
  }
  spiceLevelCustomizations {
    id
  }
}
    ${AvailabilityFieldsFragmentDoc}
${ConsumerFoodItemAvailabilityFragmentDoc}
${DishFirstShefProfileFragmentDoc}`;
export const DishSearchResultsFieldsFragmentDoc = gql`
    fragment DishSearchResultsFields on DishSearchResults {
  hasMore
  cursor
  results {
    ...DishSearchResult
  }
}
    ${DishSearchResultFragmentDoc}`;
export const CuisineSearchResultFieldsFragmentDoc = gql`
    fragment CuisineSearchResultFields on CuisineSearchResult {
  category {
    id
    title
    type
    ancestorCuisines {
      id
      isPrimary
    }
  }
  numShefs
  numDishes
}
    `;
export const CombinedSearchResultsFragmentDoc = gql`
    fragment CombinedSearchResults on CombinedSearchResults {
  shefResults {
    ...ShefSearchResultsFields
  }
  dishResults {
    ...DishSearchResultsFields
  }
  cuisineResults {
    ...CuisineSearchResultFields
  }
  showGiftCardResult
}
    ${ShefSearchResultsFieldsFragmentDoc}
${DishSearchResultsFieldsFragmentDoc}
${CuisineSearchResultFieldsFragmentDoc}`;
export const DishSearchResultNewFragmentDoc = gql`
    fragment DishSearchResultNew on FoodItem {
  foodItemId: id
  id
  userId
  imageUrl
  name
  slug
  ratingCount
  averageRating
  description
  isPopular
  lastPurchasedAt
  ...AvailabilityFields
  availability {
    ...ConsumerFoodItemAvailability
  }
  user {
    publicName
  }
  shef {
    id
    firstName
    publicName
    shefProfile {
      ...DishFirstShefProfile
    }
    isTopShef
    isTrialShef
  }
  portion
  price
  availability {
    availabilityDate
    numAvailable
  }
  cuisineCategories {
    id
    title
    type
  }
  servingSizeCustomizations {
    id
  }
  spiceLevelCustomizations {
    id
  }
}
    ${AvailabilityFieldsFragmentDoc}
${ConsumerFoodItemAvailabilityFragmentDoc}
${DishFirstShefProfileFragmentDoc}`;
export const SearchResultsFragmentDoc = gql`
    fragment SearchResults on SearchResults {
  shefResults {
    shef {
      id
      publicName
      imageUrl
      rating {
        score
        count
      }
      activeFoodItems(limit: 1) {
        id
        imageUrl
      }
      availability(zipCode: $zipCode) {
        availabilityDate
      }
      shefProfile {
        id
        isTrialShef
        cuisineRegion
        specialty
        previewFoodItem {
          id
          imageUrl
        }
        cuisineCategories {
          id
          title
          type
        }
      }
    }
    dishPreviewImage
  }
  dishResults {
    ...DishSearchResultNew
  }
  cuisineResults {
    ...CuisineSearchResultFields
  }
  searchStateResult {
    paginationState {
      isEnd
      nbHits
      queryIdx
    }
    seenRecordIds
  }
}
    ${DishSearchResultNewFragmentDoc}
${CuisineSearchResultFieldsFragmentDoc}`;
export const CartCardPublicShefFragmentDoc = gql`
    fragment CartCardPublicShef on PublicShef {
  id
  imageUrl
  firstName
  shefProfile {
    id
    specialty
    cuisineCategories {
      id
      title
      type
    }
  }
}
    `;
export const ConsumerCartPublicShefFragmentDoc = gql`
    fragment ConsumerCartPublicShef on PublicShef {
  id
  shefProfile {
    id
    cuisineRegion
  }
  ...CartCardPublicShef
}
    ${CartCardPublicShefFragmentDoc}`;
export const CategoryPageContentFragmentDoc = gql`
    fragment CategoryPageContent on CategoryPageContent {
  pageType
  title
  subTitle
  illustrationUrl
  fadeSegmentBackground
  segmentBackgroundUrl
  segmentBackgroundUrlTablet
  segmentBackgroundUrlDesktop
  heroBackgroundUrl
  heroBackgroundUrlTablet
  heroBackgroundUrlDesktop
  patternedStripUrl
  moreCuisinesBackgroundUrl
  moreCuisinesBackgroundUrlTablet
  moreCuisinesBackgroundUrlDesktop
  referralStripTextColor
  referralStripBackgroundUrl
  referralStripBackgroundUrlTablet
  referralStripBackgroundUrlDesktop
  searchSuggestions {
    display
    searchQuery
  }
}
    `;
export const DishFirstFoodItemPreviewFragmentDoc = gql`
    fragment DishFirstFoodItemPreview on FoodItem {
  foodItemId: id
  name
  imageUrl
  slug
  portion
  servingSize
  ratingCount
  averageRating
  price
  foodType
  isPopular
  lastPurchasedAt
  description @include(if: $loadFoodItemDescription)
  availability {
    ...ConsumerFoodItemAvailability
  }
  cuisineCategories {
    id
    title
    type
  }
  shef {
    id
    firstName
    publicName
    celebrityEventType
    isTopShef
    shefProfile {
      ...DishFirstShefProfile
    }
  }
  servingSizeCustomizations {
    id
  }
  spiceLevelCustomizations {
    id
  }
}
    ${ConsumerFoodItemAvailabilityFragmentDoc}
${DishFirstShefProfileFragmentDoc}`;
export const DishFirstPublicShefFragmentDoc = gql`
    fragment DishFirstPublicShef on PublicShef {
  id
  publicName
  imageUrl
  isTopShef
  deliveryPrice(destZipCode: $zipCode) {
    ...DeliveryPriceFields
  }
  rating {
    score
    count
  }
  activeFoodItems(dishFilters: $filters, limit: 3) {
    id
    imageUrl
    name
  }
  availability(zipCode: $zipCode) {
    availabilityDate
  }
  shefProfile {
    ...DishFirstShefProfile
    isShefFollower
    previewFoodItem {
      id
      imageUrl
    }
    explorePagePromoCode {
      id
      code
      value
      isPercentage
    }
  }
}
    ${DeliveryPriceFieldsFragmentDoc}
${DishFirstShefProfileFragmentDoc}`;
export const DishFirstExploreSegmentShefFragmentDoc = gql`
    fragment DishFirstExploreSegmentShef on ExploreSegmentShef {
  shef {
    ...DishFirstPublicShef
  }
  dishPreviewImage
  numDishes
}
    ${DishFirstPublicShefFragmentDoc}`;
export const DishFirstPreviewFilterFragmentDoc = gql`
    fragment DishFirstPreviewFilter on ExploreFoodItemsPreviewFilter {
  availabilityDates
  cuisineFilters
  dietaryFilters
  dishTypeFilters
  isEcoFriendlyPackaging
  minDishRating
  priceLevelFilters
  proteinFilters
  spiceLevelFilters
}
    `;
export const DishFirstFoodItemsSegmentFragmentDoc = gql`
    fragment DishFirstFoodItemsSegment on ExploreFoodItemsSegment {
  cacheKey
  id
  layout
  categoryPageContent {
    ...CategoryPageContent
  }
  displayName
  subtitle
  icon
  content(filter: $filters) {
    total
    items {
      ... on FoodItem {
        ...DishFirstFoodItemPreview
      }
      ... on ExploreSegmentShef {
        ...DishFirstExploreSegmentShef
      }
    }
  }
  preview {
    seeAllText
    seeAllFilter {
      ...DishFirstPreviewFilter
    }
    showAllFiltersWhenExpanded
  }
}
    ${CategoryPageContentFragmentDoc}
${DishFirstFoodItemPreviewFragmentDoc}
${DishFirstExploreSegmentShefFragmentDoc}
${DishFirstPreviewFilterFragmentDoc}`;
export const DishFirstFoodItemFragmentDoc = gql`
    fragment DishFirstFoodItem on FoodItem {
  foodItemId: id
  userId
  name
  imageUrl
  description
  slug
  price
  averageRating
  ratingCount
  topPositiveTags
  foodType
  vegan
  vegetarian
  paleo
  lowFodmap
  lowSodium
  keto
  kosher
  whole30
  glutenFree
  dairyFree
  containsNuts
  containsEggs
  containsShellfish
  containsSoy
  isHalal
  isOrganic
  packaging
  portion
  servingSize
  spiceLevel
  ingredients
  ...AvailabilityFields
  availability {
    ...ConsumerFoodItemAvailability
  }
  cuisineCategories {
    id
    title
    type
  }
  servingSizeCustomizations {
    ...FoodItemCustomizationFields
  }
  spiceLevelCustomizations {
    ...FoodItemCustomizationFields
  }
  shef {
    id
    firstName
    publicName
    imageUrl
    availability(zipCode: $zipCode) {
      availabilityDate
      isSoldOut
      numDishesAvailable
    }
    shefProfile {
      ...DishFirstShefProfile
    }
    rating {
      score
      count
    }
    celebrityEventType
  }
}
    ${AvailabilityFieldsFragmentDoc}
${ConsumerFoodItemAvailabilityFragmentDoc}
${FoodItemCustomizationFieldsFragmentDoc}
${DishFirstShefProfileFragmentDoc}`;
export const AvailableDeliveryDayFragmentDoc = gql`
    fragment AvailableDeliveryDay on NumberAvailableDishesResult {
  date
  count
}
    `;
export const AvailableCuisineCategoryFragmentDoc = gql`
    fragment AvailableCuisineCategory on CuisineCategory {
  id
  title
  isPrimary
  categoryPageContent {
    ...CategoryPageContent
  }
}
    ${CategoryPageContentFragmentDoc}`;
export const HierarchicalAvailableCuisineCategoryFragmentDoc = gql`
    fragment HierarchicalAvailableCuisineCategory on CuisineCategory {
  ...AvailableCuisineCategory
  ancestorCuisines {
    id
    isPrimary
    title
  }
  subcuisines {
    id
  }
}
    ${AvailableCuisineCategoryFragmentDoc}`;
export const DishFirstFilterOptionsFragmentDoc = gql`
    fragment DishFirstFilterOptions on ExploreFoodItemsFilterOptionsResults {
  availableDeliveryDays {
    ...AvailableDeliveryDay
  }
  availableCuisines {
    ...HierarchicalAvailableCuisineCategory
  }
  isEcoFriendlyFilterAvailable
  totalShefs
}
    ${AvailableDeliveryDayFragmentDoc}
${HierarchicalAvailableCuisineCategoryFragmentDoc}`;
export const ConsumerExploreShefPreviewFoodItemFragmentDoc = gql`
    fragment ConsumerExploreShefPreviewFoodItem on FoodItem {
  id
  name
  imageUrl
  foodType
  ...AvailabilityFields
}
    ${AvailabilityFieldsFragmentDoc}`;
export const ConsumerExploreShefPreviewPublicShefFragmentDoc = gql`
    fragment ConsumerExploreShefPreviewPublicShef on PublicShef {
  id
  firstName
  hasEcoFriendlyPackaging
  activeFoodItems(filters: $filters, limit: $numFoodItems) {
    ...ConsumerExploreShefPreviewFoodItem
  }
  activeHolidayFoodItems(filters: $filters, zipCode: $zipCode) {
    ...ConsumerExploreShefPreviewFoodItem
  }
  deliveryPrice(destZipCode: $zipCode) {
    ...DeliveryPriceFields
  }
  shefProfile {
    id
    isTrialShef
    featureShef
    coverPhotoUrl
    specialty
    timeZone
    cuisineCategories {
      id
      title
      type
    }
    previewFoodItem {
      id
      imageUrl
    }
    cutoffMsBeforeDeliveryDate
    explorePagePromoCode {
      id
      code
      value
      isPercentage
    }
    fulfillmentOption
  }
  publicName
  rating {
    score
    count
  }
  imageUrl
}
    ${ConsumerExploreShefPreviewFoodItemFragmentDoc}
${DeliveryPriceFieldsFragmentDoc}`;
export const CuisineRowPublicShefFragmentDoc = gql`
    fragment CuisineRowPublicShef on PublicShef {
  id
  ...ConsumerExploreShefPreviewPublicShef
}
    ${ConsumerExploreShefPreviewPublicShefFragmentDoc}`;
export const ConsumerExplorePublicShefFragmentDoc = gql`
    fragment ConsumerExplorePublicShef on PublicShef {
  id
  ...CuisineRowPublicShef
  activeFoodItems(filters: $filters, limit: $numFoodItems) {
    ...ConsumerExploreShefPreviewFoodItem
  }
  shefProfile {
    id
    cuisineRegion
    fulfillmentOption
  }
  publicName
}
    ${CuisineRowPublicShefFragmentDoc}
${ConsumerExploreShefPreviewFoodItemFragmentDoc}`;
export const ConsumerExploreFoodItemFragmentDoc = gql`
    fragment ConsumerExploreFoodItem on FoodItem {
  foodItemId: id
  name
  imageUrl
  description
  slug
  price
  isSoldOut(filters: $filters)
  cuisineCategories {
    id
    title
    type
  }
  shef {
    id
    firstName
    publicName
    imageUrl
    shefProfile {
      id
      specialty
      timeZone
      isTrialShef
    }
    rating {
      score
      count
    }
  }
}
    `;
export const ConsumerExplore2ExploreSegmentFragmentDoc = gql`
    fragment ConsumerExplore2ExploreSegment on ExploreSegment {
  cacheKey
  id
  layout
  displayName
  subtitle
  icon
  subcuisineSegmentDetails {
    rootCuisineRegion
    subcuisineId
  }
  preview {
    seeAllText
    showAllFiltersWhenExpanded
  }
  content(filter: $filters) {
    items {
      ... on PublicShef {
        ...ConsumerExplorePublicShef
      }
      ... on FoodItem {
        ...ConsumerExploreFoodItem
      }
    }
    total
    isInPreview
  }
}
    ${ConsumerExplorePublicShefFragmentDoc}
${ConsumerExploreFoodItemFragmentDoc}`;
export const FollowShefInfoFragmentDoc = gql`
    fragment FollowShefInfo on PublicShef {
  id
  publicName
  cuisineCategories {
    title
  }
}
    `;
export const UserPrefsFragmentDoc = gql`
    fragment UserPrefs on TasteProfile {
  userId
  preferredProteins
  cuisinePreferences
  replacementDietaryRestrictions
  menuDietaryRestrictions
  dietType
}
    `;
export const MealPlanDisplayShefFragmentDoc = gql`
    fragment MealPlanDisplayShef on PublicShef {
  id
  publicName
  rating {
    score
    count
  }
  totalOrders
  imageUrl
  shefProfile {
    bio
    fhcApprovedAt
    cuisineCategories {
      id
      title
    }
  }
}
    `;
export const MealPlanDisplayFoodItemFragmentDoc = gql`
    fragment MealPlanDisplayFoodItem on FoodItem {
  id
  name
  ratingCount
  averageRating
  imageUrl
  spiceLevel
  portion
  servingSize
  ingredients
  description
  availability(deliveryDate: $deliveryDate) {
    ...ConsumerFoodItemAvailability
  }
  price
  vegetarian
  vegan
  glutenFree
  dairyFree
  isHalal
  isOrganic
  lowFodmap
  paleo
  whole30
  kosher
  packaging
  slug
  numLabels
  cuisineCategories {
    id
    title
    type
  }
  shef {
    publicName
    id
  }
  upsell {
    id
    tier
    price
  }
}
    ${ConsumerFoodItemAvailabilityFragmentDoc}`;
export const ShefProfileComponentFragmentDoc = gql`
    fragment ShefProfileComponent on PublicShef {
  publicName
  flakeId
  imageUrl
  firstName
  shefProfile {
    bio
    primaryRegion {
      name
    }
  }
  mealPlanFoodItems(
    tasteProfile: $tasteProfile
    deliveryDate: $deliveryDate
    format: $format
    includeSoldOutDishes: $includeSoldOutDishes
  ) {
    ...MealPlanDisplayFoodItem
  }
  shefRosterStatus(
    tasteProfile: $tasteProfile
    deliveryDate: $deliveryDate
    zipCode: $zipCode
    mealPlanTypeId: $mealPlanTypeId
  )
  zipCode
  rating {
    score
    count
  }
  regionalCuisineCategories {
    id
    title
  }
  totalOrders
}
    ${MealPlanDisplayFoodItemFragmentDoc}`;
export const MealPlanPromoCodeAppliedFragmentDoc = gql`
    fragment MealPlanPromoCodeApplied on PromoCode {
  value
  isPercentage
}
    `;
export const ManagePlanScheduleFragmentDoc = gql`
    fragment ManagePlanSchedule on Order {
  timeWindow {
    id
    startMsAfterMidnight
    endMsAfterMidnight
  }
}
    `;
export const MealPlanUpcomingOrderMealPlanFragmentDoc = gql`
    fragment MealPlanUpcomingOrderMealPlan on MealPlan {
  id
  status
  isReusablePackagingPlan
  mealPlanType {
    unit
    numServings
    format
  }
}
    `;
export const MealPlanDishCardFoodItemFragmentDoc = gql`
    fragment MealPlanDishCardFoodItem on FoodItem {
  id
  imageUrl
  shef {
    publicName
    id
  }
  averageRating
  ratingCount
  cuisineCategories {
    id
    title
    type
  }
  price
  spiceLevel
  name
  foodType
  upsell {
    id
    tier
    price
  }
}
    `;
export const MealPlanOliFragmentDoc = gql`
    fragment MealPlanOLI on OrderLineItem {
  id
  quantity
  foodItem {
    ...MealPlanDishCardFoodItem
  }
}
    ${MealPlanDishCardFoodItemFragmentDoc}`;
export const MealPlanUpcomingOrderFragmentDoc = gql`
    fragment MealPlanUpcomingOrder on Order {
  id
  groupOrderId
  deliveryDate
  orderStatus
  publicShef {
    id
    publicName
  }
  lineItems {
    ...MealPlanOLI
  }
}
    ${MealPlanOliFragmentDoc}`;
export const UpcomingMealPlanGroupOrderFragmentDoc = gql`
    fragment UpcomingMealPlanGroupOrder on GroupOrder {
  id
  regionId
  deliveryDate
  mealPlanType {
    unit
    numServings
    weeklyCost
    format
  }
  orders {
    ...MealPlanUpcomingOrder
  }
  timeWindow {
    startMsAfterMidnight
    endMsAfterMidnight
  }
}
    ${MealPlanUpcomingOrderFragmentDoc}`;
export const MealPlanOrderFragmentDoc = gql`
    fragment MealPlanOrder on Order {
  id
  groupOrderId
  deliveryDate
  orderStatus
}
    `;
export const ShefDeliveryPricesFragmentDoc = gql`
    fragment ShefDeliveryPrices on PublicShef {
  deliveryPrice(destZipCode: $zipCode) {
    ...DeliveryPriceFields
  }
}
    ${DeliveryPriceFieldsFragmentDoc}`;
export const ConsumerOrderReviewFragmentDoc = gql`
    fragment ConsumerOrderReview on PublicReviewResult {
  id
  createdAt
  comment
  deliveryDate
  user {
    id
    publicName
    imageUrl
  }
  dishes {
    rating {
      ratingPercent
    }
  }
}
    `;
export const ShefMenuSegmentFragmentDoc = gql`
    fragment ShefMenuSegment on ExploreFoodItemsSegment {
  cacheKey
  id
  layout
  displayName
  icon
  content(filter: $filters) {
    total
    items {
      ... on FoodItem {
        ...ConsumerFoodItem
      }
    }
  }
  preview {
    seeAllText
    seeAllFilter {
      ...DishFirstPreviewFilter
    }
    showAllFiltersWhenExpanded
  }
}
    ${ConsumerFoodItemFragmentDoc}
${DishFirstPreviewFilterFragmentDoc}`;
export const ConsumerOrderFreeDeliveryModalPublicShefFragmentDoc = gql`
    fragment ConsumerOrderFreeDeliveryModalPublicShef on PublicShef {
  id
  activeFoodItems {
    ...CartFoodItem
  }
  publicName
  firstName
}
    ${CartFoodItemFragmentDoc}`;
export const DishModalFoodItemFragmentDoc = gql`
    fragment DishModalFoodItem on FoodItem {
  foodItemId: id
  averageRating
  ratingCount
  topPositiveTags
  cuisineCategories {
    id
    title
    type
  }
  shef {
    id
    firstName
    publicName
    imageUrl
    rating {
      score
      count
    }
    shefProfile {
      isTrialShef
    }
  }
}
    `;
export const ModalReviewFragmentDoc = gql`
    fragment ModalReview on PublicReviewResult {
  id
  comment
  deliveryDate
  dishes {
    id
    name
    imageUrl
    slug
    rating {
      ratingPercent
      tags {
        tag
      }
    }
  }
  user {
    id
    publicName
    imageUrl
  }
}
    `;
export const SuggestedSidesResultFragmentDoc = gql`
    fragment SuggestedSidesResult on SuggestedItem {
  foodItemId
  foodItem {
    ...CartFoodItem
  }
  orderAffinity
}
    ${CartFoodItemFragmentDoc}`;
export const GroupOrderReceiptFieldsFragmentDoc = gql`
    fragment GroupOrderReceiptFields on GroupOrder {
  id
  uuid
  userId
  orderType
  delivery {
    id
    estimatedDeliveryTime
    driverName
    driverPhone
  }
  deliveryDate
  deliveryType
  deliveryNotes
  phone
  timeWindowId
  deliveryAddressId
  pickupAddressId
  pickupAddress {
    id
    formattedAddress
    latitude
    longitude
    deliveryNotes
  }
  pickupDeliveryId
  dayOfEmailScheduledTaskId
  subscriptionInvoiceId
  canReviewOrder
  deliveryAddress {
    id
    formattedAddress
    zipCodeInfo {
      zipCode
      timeZone
    }
  }
  promoCodes {
    id
    value
    code
    promoCodeType
  }
  orders {
    ...ConsumerOrderReceiptFields
  }
  isCancelled
  isFullyRefunded
  orderTotals {
    promoApplied
    nonPromoDiscountApplied
    salesTax
    deliveryFee
    smallOrderFee
    serviceFee
    shefTip
    subtotal
    grandTotal
  }
}
    ${ConsumerOrderReceiptFieldsFragmentDoc}`;
export const ReorderedItemFragmentDoc = gql`
    fragment ReorderedItem on CartLineItem {
  shefId
}
    `;
export const ShefRouterUserFragmentDoc = gql`
    fragment ShefRouterUser on User {
  shefProfile {
    id
    timeZone
    approvedAt
  }
}
    `;
export const ShefSelfPromotionPageFoodItemFragmentDoc = gql`
    fragment ShefSelfPromotionPageFoodItem on FoodItem {
  id
  slug
  name
  description
}
    `;
export const ShefPromoCodeFragmentDoc = gql`
    fragment ShefPromoCode on PromoCode {
  id
  code
  value
  isPercentage
  uses
  promoCodeType
  maxUses
  maxUsesPerUser
  minOrderValue
  startTimestamp
  endTimestamp
  disabledAt
  disabled
  isExplorePagePromo
}
    `;
export const PerformanceOrderReviewLineItemFragmentDoc = gql`
    fragment PerformanceOrderReviewLineItem on OrderLineItem {
  id
  name
  imageUrl
  rating {
    id
    ratingPercent
    tags {
      id
      tag
    }
  }
}
    `;
export const PerformanceOrderReviewResultFragmentDoc = gql`
    fragment PerformanceOrderReviewResult on PublicReviewResult {
  id
  orderId
  createdAt
  deliveryDate
  comment
  user {
    id
    flakeId
    publicName
  }
  dishes {
    ...PerformanceOrderReviewLineItem
  }
}
    ${PerformanceOrderReviewLineItemFragmentDoc}`;
export const ShefOrderReviewResultFragmentDoc = gql`
    fragment ShefOrderReviewResult on PublicReviewResult {
  ...PerformanceOrderReviewResult
  privateComment
}
    ${PerformanceOrderReviewResultFragmentDoc}`;
export const ShefSocialFollowerFragmentDoc = gql`
    fragment ShefSocialFollower on User {
  flakeId
  id
  imageUrl
  publicName
  orderCountFromShef(shefId: $shefId)
}
    `;
export const ShefPostDataFragmentDoc = gql`
    fragment ShefPostData on ShefPost {
  id
  shefId
  mediaType
  mediaUrl
  foodItemId
  clickCount
  isLikedByUser
  numLikes
  promoCodeId
  promoCodeString
  comment
  createdAt
  viewCount
  clickCount
}
    `;
export const ZipDeliveryDaysFragmentDoc = gql`
    fragment ZipDeliveryDays on RegionInfo {
  sundayDelivery
  mondayDelivery
  tuesdayDelivery
  wednesdayDelivery
  thursdayDelivery
  fridayDelivery
  saturdayDelivery
}
    `;
export const ShefApplicationFieldsFragmentDoc = gql`
    fragment ShefApplicationFields on ShefApplication {
  id
  userId
  zipcode
  phone
  cuisines
  info
  workAuthorization
  howDiscoveredShef
  isFoodTastingScheduled
  isPickupAddressEnabled
  foodTastingAt
  foodTastingReceivedAt
  onboardingCallAt
  menuWebinarScheduledFor
  informationSessionCompletedAt
  initialQuestionsCompletedAt
  status
  menuWebinarScheduledFor
  menuWebinarCompletedAt
  regionInfo {
    id
  }
  region
  createdAt
  geographyAllowsNewApplications
  geographyAllowsCuisineType
  calendlyOrientationCallLink
}
    `;
export const PaginationFieldsFragmentDoc = gql`
    fragment PaginationFields on Pagination {
  page
  pageCount
  resultsPerPage
}
    `;
export const GenericTableFieldsFragmentDoc = gql`
    fragment GenericTableFields on FoodItem {
  id
  userId
  name
  price
  description
  capacity
  foodType
  imageUrl
  prepInstructions
  numDaysBeforeExpires
  endDate
  startDate
  ...AvailabilityFields
  ...FoodItemTagFields
  user {
    id
    fullName
    firstName
    imageUrl
    publicName
  }
}
    ${AvailabilityFieldsFragmentDoc}
${FoodItemTagFieldsFragmentDoc}`;
export const FoodItemCartFieldsFragmentDoc = gql`
    fragment FoodItemCartFields on FoodItem {
  id
  userId
  name
  imageUrl
  price
  ingredients
  description
  portion
  foodType
  capacity
  ...FoodItemTagFields
}
    ${FoodItemTagFieldsFragmentDoc}`;
export const AdminUserFieldsFragmentDoc = gql`
    fragment AdminUserFields on User {
  ...GenericAdminUserFields
  email
  lastOrderPhoneNumber
  imageUrl
  createdAt
  shefStatus
  shefApplication {
    id
  }
}
    ${GenericAdminUserFieldsFragmentDoc}`;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  id
  name
  address {
    id
    formattedAddress
    zipCode
  }
  promoCode {
    ...PromoCodeFields
  }
}
    ${PromoCodeFieldsFragmentDoc}`;
export const ShefApplicationTrackerFieldsFragmentDoc = gql`
    fragment ShefApplicationTrackerFields on ShefApplicationTracker {
  personalInfo
  scheduleTasting
  passTasting
  informationSession
  profileImage
  bio
  dropOffHub
  menuItems
  optionalMenuItems
  cuisine
  cuisineCategories
  addAddress
  tryShefPromo
  scheduleCall
}
    `;
export const DeliveryAddressInputFragmentDoc = gql`
    fragment DeliveryAddressInput on Address {
  company
  unit
  name
  street
  city
  province
  zipCode
  country
  latitude
  longitude
  streetNumber
  route
  googlePlaceId
}
    `;
export const DeliveryAddressFieldsFragmentDoc = gql`
    fragment DeliveryAddressFields on Address {
  id
  formattedAddress
  phone
  deliveryNotes
  linkedSubscriptionId
  ...DeliveryAddressInput
}
    ${DeliveryAddressInputFragmentDoc}`;
export const FileUploadInfoFragmentDoc = gql`
    fragment FileUploadInfo on SignedUrl {
  signedUrl
  key
  bucket
}
    `;
export const FoodItemAvailabilityFoodItemFragmentDoc = gql`
    fragment FoodItemAvailabilityFoodItem on FoodItem {
  availableMonday
  availableTuesday
  availableWednesday
  availableThursday
  availableFriday
  availableSaturday
  availableSunday
  startDate
  endDate
}
    `;
export const PaymentInputSavedCreditCartFragmentDoc = gql`
    fragment PaymentInputSavedCreditCart on SavedCreditCard {
  id
  lastFourDigits
  expiresAt
  brand
  type
  lastUsedAt
}
    `;
export const FoodItemLabelPublicShefFragmentDoc = gql`
    fragment FoodItemLabelPublicShef on PublicShef {
  id
  imageUrl
  publicName
}
    `;
export const CartBulkDiscountTierFragmentDoc = gql`
    fragment CartBulkDiscountTier on BulkDiscountTier {
  minSubtotal
  maxSubtotal
  discountRate
}
    `;
export const WholeCartLineItemFragmentDoc = gql`
    fragment WholeCartLineItem on CartLineItem {
  id
  shefId
  foodItemId
  quantity
  foodItem {
    ...CartFoodItem
  }
  createdAt
  updatedAt
  customizationIds
}
    ${CartFoodItemFragmentDoc}`;
export const WholeCartAddOnItemFragmentDoc = gql`
    fragment WholeCartAddOnItem on CartAddOnItem {
  id
  userId
  addOnItemId
  quantity
  addOnItem {
    ...WholeAddOnItem
  }
}
    ${WholeAddOnItemFragmentDoc}`;
export const WholeCartsFragmentDoc = gql`
    fragment WholeCarts on CartResults {
  foodItems {
    ...WholeCartLineItem
  }
  addOnItems {
    ...WholeCartAddOnItem
  }
  recentlyAdded
}
    ${WholeCartLineItemFragmentDoc}
${WholeCartAddOnItemFragmentDoc}`;
export const CachedZipCodeFragmentDoc = gql`
    fragment CachedZipCode on ZipCode {
  zipCode
  minimumAmountForDiscountedShipping
  discountedDeliveryFee
  availableToCustomers
  deliveryFee
  deliveryType
  timeZone
  isHubless
  region {
    id
    isPickupEnabled
    isVerifiedHalalEnabled
    launchedAt
    isInWaitlist
    ecoPackagingEnabled
  }
}
    `;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login: login2(email: $email, password: $password) {
    ...AuthResultFields
  }
}
    ${AuthResultFieldsFragmentDoc}`;
export type LoginMutationFn = ApolloReactCommon.MutationFunction<LoginMutation, LoginMutationVariables>;
export type LoginComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<LoginMutation, LoginMutationVariables>, 'mutation'>;

    export const LoginComponent = (props: LoginComponentProps) => (
      <ApolloReactComponents.Mutation<LoginMutation, LoginMutationVariables> mutation={LoginDocument} {...props} />
    );
    

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = ApolloReactCommon.MutationResult<LoginMutation>;
export type LoginMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($userInput: UserInput!, $utm: UtmInput, $zipCode: String, $promoCode: String, $signUpEntryPoint: String) {
  register: register2(
    userInput: $userInput
    utm: $utm
    zipCode: $zipCode
    promoCode: $promoCode
    signUpEntryPoint: $signUpEntryPoint
  ) {
    ...AuthResultFields
  }
}
    ${AuthResultFieldsFragmentDoc}`;
export type RegisterMutationFn = ApolloReactCommon.MutationFunction<RegisterMutation, RegisterMutationVariables>;
export type RegisterComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RegisterMutation, RegisterMutationVariables>, 'mutation'>;

    export const RegisterComponent = (props: RegisterComponentProps) => (
      <ApolloReactComponents.Mutation<RegisterMutation, RegisterMutationVariables> mutation={RegisterDocument} {...props} />
    );
    

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      utm: // value for 'utm'
 *      zipCode: // value for 'zipCode'
 *      promoCode: // value for 'promoCode'
 *      signUpEntryPoint: // value for 'signUpEntryPoint'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = ApolloReactCommon.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = ApolloReactCommon.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const LoginWithOAuthDocument = gql`
    mutation LoginWithOAuth($oAuthLoginType: OAuthLoginType!, $token: String!, $zipCode: String, $requireZipCode: Boolean, $promoCode: String, $firstName: String, $lastName: String, $phone: String, $hasAcceptedTermsOfService: Boolean, $utm: UtmInput, $signUpEntryPoint: String) {
  login: loginWithOAuth2(
    oAuthLoginType: $oAuthLoginType
    token: $token
    zipCode: $zipCode
    requireZipCode: $requireZipCode
    promoCode: $promoCode
    phone: $phone
    firstName: $firstName
    lastName: $lastName
    hasAcceptedTermsOfService: $hasAcceptedTermsOfService
    utm: $utm
    signUpEntryPoint: $signUpEntryPoint
  ) {
    __typename
    ...AuthResultFields
    ... on OAuthMissingFieldsResult {
      firstName
      firstNameIsMissing
      lastName
      lastNameIsMissing
      zipCodeIsMissing
      needsToAcceptTermsOfService
    }
  }
}
    ${AuthResultFieldsFragmentDoc}`;
export type LoginWithOAuthMutationFn = ApolloReactCommon.MutationFunction<LoginWithOAuthMutation, LoginWithOAuthMutationVariables>;
export type LoginWithOAuthComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<LoginWithOAuthMutation, LoginWithOAuthMutationVariables>, 'mutation'>;

    export const LoginWithOAuthComponent = (props: LoginWithOAuthComponentProps) => (
      <ApolloReactComponents.Mutation<LoginWithOAuthMutation, LoginWithOAuthMutationVariables> mutation={LoginWithOAuthDocument} {...props} />
    );
    

/**
 * __useLoginWithOAuthMutation__
 *
 * To run a mutation, you first call `useLoginWithOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithOAuthMutation, { data, loading, error }] = useLoginWithOAuthMutation({
 *   variables: {
 *      oAuthLoginType: // value for 'oAuthLoginType'
 *      token: // value for 'token'
 *      zipCode: // value for 'zipCode'
 *      requireZipCode: // value for 'requireZipCode'
 *      promoCode: // value for 'promoCode'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      hasAcceptedTermsOfService: // value for 'hasAcceptedTermsOfService'
 *      utm: // value for 'utm'
 *      signUpEntryPoint: // value for 'signUpEntryPoint'
 *   },
 * });
 */
export function useLoginWithOAuthMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginWithOAuthMutation, LoginWithOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginWithOAuthMutation, LoginWithOAuthMutationVariables>(LoginWithOAuthDocument, options);
      }
export type LoginWithOAuthMutationHookResult = ReturnType<typeof useLoginWithOAuthMutation>;
export type LoginWithOAuthMutationResult = ApolloReactCommon.MutationResult<LoginWithOAuthMutation>;
export type LoginWithOAuthMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginWithOAuthMutation, LoginWithOAuthMutationVariables>;
export const ResetPasswordMutationDocument = gql`
    mutation ResetPasswordMutation($email: String!) {
  resetPassword(email: $email)
}
    `;
export type ResetPasswordMutationMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables>;
export type ResetPasswordMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables>, 'mutation'>;

    export const ResetPasswordMutationComponent = (props: ResetPasswordMutationComponentProps) => (
      <ApolloReactComponents.Mutation<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables> mutation={ResetPasswordMutationDocument} {...props} />
    );
    

/**
 * __useResetPasswordMutationMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutationMutation, { data, loading, error }] = useResetPasswordMutationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables>(ResetPasswordMutationDocument, options);
      }
export type ResetPasswordMutationMutationHookResult = ReturnType<typeof useResetPasswordMutationMutation>;
export type ResetPasswordMutationMutationResult = ApolloReactCommon.MutationResult<ResetPasswordMutationMutation>;
export type ResetPasswordMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables>;
export const ResetChangePasswordMutationDocument = gql`
    mutation ResetChangePasswordMutation($resetPasswordToken: String!, $password: String!) {
  resetChangePassword(
    resetPasswordToken: $resetPasswordToken
    password: $password
  )
}
    `;
export type ResetChangePasswordMutationMutationFn = ApolloReactCommon.MutationFunction<ResetChangePasswordMutationMutation, ResetChangePasswordMutationMutationVariables>;
export type ResetChangePasswordMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ResetChangePasswordMutationMutation, ResetChangePasswordMutationMutationVariables>, 'mutation'>;

    export const ResetChangePasswordMutationComponent = (props: ResetChangePasswordMutationComponentProps) => (
      <ApolloReactComponents.Mutation<ResetChangePasswordMutationMutation, ResetChangePasswordMutationMutationVariables> mutation={ResetChangePasswordMutationDocument} {...props} />
    );
    

/**
 * __useResetChangePasswordMutationMutation__
 *
 * To run a mutation, you first call `useResetChangePasswordMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetChangePasswordMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetChangePasswordMutationMutation, { data, loading, error }] = useResetChangePasswordMutationMutation({
 *   variables: {
 *      resetPasswordToken: // value for 'resetPasswordToken'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetChangePasswordMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetChangePasswordMutationMutation, ResetChangePasswordMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetChangePasswordMutationMutation, ResetChangePasswordMutationMutationVariables>(ResetChangePasswordMutationDocument, options);
      }
export type ResetChangePasswordMutationMutationHookResult = ReturnType<typeof useResetChangePasswordMutationMutation>;
export type ResetChangePasswordMutationMutationResult = ApolloReactCommon.MutationResult<ResetChangePasswordMutationMutation>;
export type ResetChangePasswordMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetChangePasswordMutationMutation, ResetChangePasswordMutationMutationVariables>;
export const GetRegisteredEmailDocument = gql`
    query GetRegisteredEmail($email: String!) {
  getRegisteredEmail(email: $email)
}
    `;
export type GetRegisteredEmailComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRegisteredEmailQuery, GetRegisteredEmailQueryVariables>, 'query'> & ({ variables: GetRegisteredEmailQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRegisteredEmailComponent = (props: GetRegisteredEmailComponentProps) => (
      <ApolloReactComponents.Query<GetRegisteredEmailQuery, GetRegisteredEmailQueryVariables> query={GetRegisteredEmailDocument} {...props} />
    );
    

/**
 * __useGetRegisteredEmailQuery__
 *
 * To run a query within a React component, call `useGetRegisteredEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegisteredEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegisteredEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetRegisteredEmailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRegisteredEmailQuery, GetRegisteredEmailQueryVariables> & ({ variables: GetRegisteredEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRegisteredEmailQuery, GetRegisteredEmailQueryVariables>(GetRegisteredEmailDocument, options);
      }
export function useGetRegisteredEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegisteredEmailQuery, GetRegisteredEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRegisteredEmailQuery, GetRegisteredEmailQueryVariables>(GetRegisteredEmailDocument, options);
        }
export function useGetRegisteredEmailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRegisteredEmailQuery, GetRegisteredEmailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRegisteredEmailQuery, GetRegisteredEmailQueryVariables>(GetRegisteredEmailDocument, options);
        }
export type GetRegisteredEmailQueryHookResult = ReturnType<typeof useGetRegisteredEmailQuery>;
export type GetRegisteredEmailLazyQueryHookResult = ReturnType<typeof useGetRegisteredEmailLazyQuery>;
export type GetRegisteredEmailSuspenseQueryHookResult = ReturnType<typeof useGetRegisteredEmailSuspenseQuery>;
export type GetRegisteredEmailQueryResult = ApolloReactCommon.QueryResult<GetRegisteredEmailQuery, GetRegisteredEmailQueryVariables>;
export const ConsumerOrderCartMobileDocument = gql`
    query ConsumerOrderCartMobile($shefId: String!) {
  shef(userId: $shefId) {
    id
    imageUrl
    publicName
    timeZone
    shefProfile {
      id
      isTrialShef
      cuisineRegion
    }
  }
  carts {
    ...WholeCarts
  }
}
    ${WholeCartsFragmentDoc}`;
export type ConsumerOrderCartMobileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerOrderCartMobileQuery, ConsumerOrderCartMobileQueryVariables>, 'query'> & ({ variables: ConsumerOrderCartMobileQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConsumerOrderCartMobileComponent = (props: ConsumerOrderCartMobileComponentProps) => (
      <ApolloReactComponents.Query<ConsumerOrderCartMobileQuery, ConsumerOrderCartMobileQueryVariables> query={ConsumerOrderCartMobileDocument} {...props} />
    );
    

/**
 * __useConsumerOrderCartMobileQuery__
 *
 * To run a query within a React component, call `useConsumerOrderCartMobileQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerOrderCartMobileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerOrderCartMobileQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useConsumerOrderCartMobileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConsumerOrderCartMobileQuery, ConsumerOrderCartMobileQueryVariables> & ({ variables: ConsumerOrderCartMobileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerOrderCartMobileQuery, ConsumerOrderCartMobileQueryVariables>(ConsumerOrderCartMobileDocument, options);
      }
export function useConsumerOrderCartMobileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerOrderCartMobileQuery, ConsumerOrderCartMobileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerOrderCartMobileQuery, ConsumerOrderCartMobileQueryVariables>(ConsumerOrderCartMobileDocument, options);
        }
export function useConsumerOrderCartMobileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerOrderCartMobileQuery, ConsumerOrderCartMobileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerOrderCartMobileQuery, ConsumerOrderCartMobileQueryVariables>(ConsumerOrderCartMobileDocument, options);
        }
export type ConsumerOrderCartMobileQueryHookResult = ReturnType<typeof useConsumerOrderCartMobileQuery>;
export type ConsumerOrderCartMobileLazyQueryHookResult = ReturnType<typeof useConsumerOrderCartMobileLazyQuery>;
export type ConsumerOrderCartMobileSuspenseQueryHookResult = ReturnType<typeof useConsumerOrderCartMobileSuspenseQuery>;
export type ConsumerOrderCartMobileQueryResult = ApolloReactCommon.QueryResult<ConsumerOrderCartMobileQuery, ConsumerOrderCartMobileQueryVariables>;
export const CartTotalsDocument = gql`
    query CartTotals($cartInput: GroupOrderTotalsInput!) {
  cartTotals: groupOrderTotals(groupOrderInput: $cartInput) {
    ...CartOrderTotal
  }
}
    ${CartOrderTotalFragmentDoc}`;
export type CartTotalsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CartTotalsQuery, CartTotalsQueryVariables>, 'query'> & ({ variables: CartTotalsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CartTotalsComponent = (props: CartTotalsComponentProps) => (
      <ApolloReactComponents.Query<CartTotalsQuery, CartTotalsQueryVariables> query={CartTotalsDocument} {...props} />
    );
    

/**
 * __useCartTotalsQuery__
 *
 * To run a query within a React component, call `useCartTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartTotalsQuery({
 *   variables: {
 *      cartInput: // value for 'cartInput'
 *   },
 * });
 */
export function useCartTotalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CartTotalsQuery, CartTotalsQueryVariables> & ({ variables: CartTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CartTotalsQuery, CartTotalsQueryVariables>(CartTotalsDocument, options);
      }
export function useCartTotalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartTotalsQuery, CartTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CartTotalsQuery, CartTotalsQueryVariables>(CartTotalsDocument, options);
        }
export function useCartTotalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CartTotalsQuery, CartTotalsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CartTotalsQuery, CartTotalsQueryVariables>(CartTotalsDocument, options);
        }
export type CartTotalsQueryHookResult = ReturnType<typeof useCartTotalsQuery>;
export type CartTotalsLazyQueryHookResult = ReturnType<typeof useCartTotalsLazyQuery>;
export type CartTotalsSuspenseQueryHookResult = ReturnType<typeof useCartTotalsSuspenseQuery>;
export type CartTotalsQueryResult = ApolloReactCommon.QueryResult<CartTotalsQuery, CartTotalsQueryVariables>;
export const EditableOrderDocument = gql`
    query EditableOrder($orderId: Int!, $zipCode: String) {
  order(orderId: $orderId) {
    ...EditableOrder
  }
}
    ${EditableOrderFragmentDoc}`;
export type EditableOrderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EditableOrderQuery, EditableOrderQueryVariables>, 'query'> & ({ variables: EditableOrderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EditableOrderComponent = (props: EditableOrderComponentProps) => (
      <ApolloReactComponents.Query<EditableOrderQuery, EditableOrderQueryVariables> query={EditableOrderDocument} {...props} />
    );
    

/**
 * __useEditableOrderQuery__
 *
 * To run a query within a React component, call `useEditableOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditableOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditableOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useEditableOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditableOrderQuery, EditableOrderQueryVariables> & ({ variables: EditableOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditableOrderQuery, EditableOrderQueryVariables>(EditableOrderDocument, options);
      }
export function useEditableOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditableOrderQuery, EditableOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditableOrderQuery, EditableOrderQueryVariables>(EditableOrderDocument, options);
        }
export function useEditableOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditableOrderQuery, EditableOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditableOrderQuery, EditableOrderQueryVariables>(EditableOrderDocument, options);
        }
export type EditableOrderQueryHookResult = ReturnType<typeof useEditableOrderQuery>;
export type EditableOrderLazyQueryHookResult = ReturnType<typeof useEditableOrderLazyQuery>;
export type EditableOrderSuspenseQueryHookResult = ReturnType<typeof useEditableOrderSuspenseQuery>;
export type EditableOrderQueryResult = ApolloReactCommon.QueryResult<EditableOrderQuery, EditableOrderQueryVariables>;
export const EditableFoodItemAvailabilityDocument = gql`
    query EditableFoodItemAvailability($shefId: String!) {
  consumerFoodItems(shefId: $shefId) {
    ...ConsumerFoodItem
  }
}
    ${ConsumerFoodItemFragmentDoc}`;
export type EditableFoodItemAvailabilityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EditableFoodItemAvailabilityQuery, EditableFoodItemAvailabilityQueryVariables>, 'query'> & ({ variables: EditableFoodItemAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EditableFoodItemAvailabilityComponent = (props: EditableFoodItemAvailabilityComponentProps) => (
      <ApolloReactComponents.Query<EditableFoodItemAvailabilityQuery, EditableFoodItemAvailabilityQueryVariables> query={EditableFoodItemAvailabilityDocument} {...props} />
    );
    

/**
 * __useEditableFoodItemAvailabilityQuery__
 *
 * To run a query within a React component, call `useEditableFoodItemAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditableFoodItemAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditableFoodItemAvailabilityQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useEditableFoodItemAvailabilityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditableFoodItemAvailabilityQuery, EditableFoodItemAvailabilityQueryVariables> & ({ variables: EditableFoodItemAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditableFoodItemAvailabilityQuery, EditableFoodItemAvailabilityQueryVariables>(EditableFoodItemAvailabilityDocument, options);
      }
export function useEditableFoodItemAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditableFoodItemAvailabilityQuery, EditableFoodItemAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditableFoodItemAvailabilityQuery, EditableFoodItemAvailabilityQueryVariables>(EditableFoodItemAvailabilityDocument, options);
        }
export function useEditableFoodItemAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditableFoodItemAvailabilityQuery, EditableFoodItemAvailabilityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditableFoodItemAvailabilityQuery, EditableFoodItemAvailabilityQueryVariables>(EditableFoodItemAvailabilityDocument, options);
        }
export type EditableFoodItemAvailabilityQueryHookResult = ReturnType<typeof useEditableFoodItemAvailabilityQuery>;
export type EditableFoodItemAvailabilityLazyQueryHookResult = ReturnType<typeof useEditableFoodItemAvailabilityLazyQuery>;
export type EditableFoodItemAvailabilitySuspenseQueryHookResult = ReturnType<typeof useEditableFoodItemAvailabilitySuspenseQuery>;
export type EditableFoodItemAvailabilityQueryResult = ApolloReactCommon.QueryResult<EditableFoodItemAvailabilityQuery, EditableFoodItemAvailabilityQueryVariables>;
export const EditableGroupOrderDocument = gql`
    query EditableGroupOrder($groupOrderId: String!, $zipCode: String) {
  groupOrdersByIds(groupOrderIds: [$groupOrderId]) {
    id
    uuid
    formattedId
    orderType
    userId
    phone
    deliveryAddressId
    user {
      id
      flakeId
      publicName
      email
      activeAddresses {
        ...AddressSelectorAddress
      }
    }
    pickupAddressId
    createdAt
    cancelledAt
    deliveryDate
    orderType
    deliveryNotes
    deliveryType
    refunds {
      id
      orderId
      createdAt
      refundType
      refundReason
      notes
    }
    delivery {
      id
      estimatedDeliveryTime
      driverName
      driverPhone
      externalId
      type
      fee
    }
    pickupAddress {
      id
      formattedAddress
      latitude
      longitude
      deliveryNotes
    }
    pickupDeliveryId
    dayOfEmailScheduledTaskId
    subscriptionInvoiceId
    canReviewOrder
    deliveryAddress {
      id
      formattedAddress
      zipCodeInfo {
        zipCode
        region {
          id
          name
        }
        timeZone
      }
    }
    orders {
      ...EditableOrder
      createdAt
      user {
        id
        firstName
        lastName
        publicName
        email
      }
      timeWindow {
        id
        startMsAfterMidnight
        endMsAfterMidnight
      }
    }
    promoCodes {
      ...PromoCodeFields
    }
    timeWindowId
    timeWindow {
      id
      startMsAfterMidnight
      endMsAfterMidnight
    }
    orderTotals {
      deliveryFee
      promoApplied
      nonPromoDiscountApplied
      grandTotal
      refund
      salesTax
      serviceFee
      shefTip
      smallOrderFee
      subtotal
      refundableBalance
      promoBalance
    }
    isCancelled
    isFullyRefunded
    isPartiallyRefunded
  }
}
    ${AddressSelectorAddressFragmentDoc}
${EditableOrderFragmentDoc}
${PromoCodeFieldsFragmentDoc}`;
export type EditableGroupOrderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EditableGroupOrderQuery, EditableGroupOrderQueryVariables>, 'query'> & ({ variables: EditableGroupOrderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EditableGroupOrderComponent = (props: EditableGroupOrderComponentProps) => (
      <ApolloReactComponents.Query<EditableGroupOrderQuery, EditableGroupOrderQueryVariables> query={EditableGroupOrderDocument} {...props} />
    );
    

/**
 * __useEditableGroupOrderQuery__
 *
 * To run a query within a React component, call `useEditableGroupOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditableGroupOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditableGroupOrderQuery({
 *   variables: {
 *      groupOrderId: // value for 'groupOrderId'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useEditableGroupOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditableGroupOrderQuery, EditableGroupOrderQueryVariables> & ({ variables: EditableGroupOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditableGroupOrderQuery, EditableGroupOrderQueryVariables>(EditableGroupOrderDocument, options);
      }
export function useEditableGroupOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditableGroupOrderQuery, EditableGroupOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditableGroupOrderQuery, EditableGroupOrderQueryVariables>(EditableGroupOrderDocument, options);
        }
export function useEditableGroupOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditableGroupOrderQuery, EditableGroupOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditableGroupOrderQuery, EditableGroupOrderQueryVariables>(EditableGroupOrderDocument, options);
        }
export type EditableGroupOrderQueryHookResult = ReturnType<typeof useEditableGroupOrderQuery>;
export type EditableGroupOrderLazyQueryHookResult = ReturnType<typeof useEditableGroupOrderLazyQuery>;
export type EditableGroupOrderSuspenseQueryHookResult = ReturnType<typeof useEditableGroupOrderSuspenseQuery>;
export type EditableGroupOrderQueryResult = ApolloReactCommon.QueryResult<EditableGroupOrderQuery, EditableGroupOrderQueryVariables>;
export const ZipCodeCelebrityEventDetailsDocument = gql`
    query ZipCodeCelebrityEventDetails($zipCode: String!, $celebrityEventType: CelebrityEventType!) {
  zipCodeCelebrityEventDetails(
    zipCode: $zipCode
    celebrityEventType: $celebrityEventType
  ) {
    shefId
    availabilityDate
  }
}
    `;
export type ZipCodeCelebrityEventDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ZipCodeCelebrityEventDetailsQuery, ZipCodeCelebrityEventDetailsQueryVariables>, 'query'> & ({ variables: ZipCodeCelebrityEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ZipCodeCelebrityEventDetailsComponent = (props: ZipCodeCelebrityEventDetailsComponentProps) => (
      <ApolloReactComponents.Query<ZipCodeCelebrityEventDetailsQuery, ZipCodeCelebrityEventDetailsQueryVariables> query={ZipCodeCelebrityEventDetailsDocument} {...props} />
    );
    

/**
 * __useZipCodeCelebrityEventDetailsQuery__
 *
 * To run a query within a React component, call `useZipCodeCelebrityEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useZipCodeCelebrityEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZipCodeCelebrityEventDetailsQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      celebrityEventType: // value for 'celebrityEventType'
 *   },
 * });
 */
export function useZipCodeCelebrityEventDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ZipCodeCelebrityEventDetailsQuery, ZipCodeCelebrityEventDetailsQueryVariables> & ({ variables: ZipCodeCelebrityEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ZipCodeCelebrityEventDetailsQuery, ZipCodeCelebrityEventDetailsQueryVariables>(ZipCodeCelebrityEventDetailsDocument, options);
      }
export function useZipCodeCelebrityEventDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ZipCodeCelebrityEventDetailsQuery, ZipCodeCelebrityEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ZipCodeCelebrityEventDetailsQuery, ZipCodeCelebrityEventDetailsQueryVariables>(ZipCodeCelebrityEventDetailsDocument, options);
        }
export function useZipCodeCelebrityEventDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ZipCodeCelebrityEventDetailsQuery, ZipCodeCelebrityEventDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ZipCodeCelebrityEventDetailsQuery, ZipCodeCelebrityEventDetailsQueryVariables>(ZipCodeCelebrityEventDetailsDocument, options);
        }
export type ZipCodeCelebrityEventDetailsQueryHookResult = ReturnType<typeof useZipCodeCelebrityEventDetailsQuery>;
export type ZipCodeCelebrityEventDetailsLazyQueryHookResult = ReturnType<typeof useZipCodeCelebrityEventDetailsLazyQuery>;
export type ZipCodeCelebrityEventDetailsSuspenseQueryHookResult = ReturnType<typeof useZipCodeCelebrityEventDetailsSuspenseQuery>;
export type ZipCodeCelebrityEventDetailsQueryResult = ApolloReactCommon.QueryResult<ZipCodeCelebrityEventDetailsQuery, ZipCodeCelebrityEventDetailsQueryVariables>;
export const LatestCelebrityEventForZipCodeDocument = gql`
    query LatestCelebrityEventForZipCode($zipCode: String!) {
  latestCelebrityEventForZipCode(zipCode: $zipCode) {
    shefId
    availabilityDate
    celebrityEventType
  }
}
    `;
export type LatestCelebrityEventForZipCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LatestCelebrityEventForZipCodeQuery, LatestCelebrityEventForZipCodeQueryVariables>, 'query'> & ({ variables: LatestCelebrityEventForZipCodeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LatestCelebrityEventForZipCodeComponent = (props: LatestCelebrityEventForZipCodeComponentProps) => (
      <ApolloReactComponents.Query<LatestCelebrityEventForZipCodeQuery, LatestCelebrityEventForZipCodeQueryVariables> query={LatestCelebrityEventForZipCodeDocument} {...props} />
    );
    

/**
 * __useLatestCelebrityEventForZipCodeQuery__
 *
 * To run a query within a React component, call `useLatestCelebrityEventForZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestCelebrityEventForZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestCelebrityEventForZipCodeQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useLatestCelebrityEventForZipCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LatestCelebrityEventForZipCodeQuery, LatestCelebrityEventForZipCodeQueryVariables> & ({ variables: LatestCelebrityEventForZipCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LatestCelebrityEventForZipCodeQuery, LatestCelebrityEventForZipCodeQueryVariables>(LatestCelebrityEventForZipCodeDocument, options);
      }
export function useLatestCelebrityEventForZipCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LatestCelebrityEventForZipCodeQuery, LatestCelebrityEventForZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LatestCelebrityEventForZipCodeQuery, LatestCelebrityEventForZipCodeQueryVariables>(LatestCelebrityEventForZipCodeDocument, options);
        }
export function useLatestCelebrityEventForZipCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LatestCelebrityEventForZipCodeQuery, LatestCelebrityEventForZipCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LatestCelebrityEventForZipCodeQuery, LatestCelebrityEventForZipCodeQueryVariables>(LatestCelebrityEventForZipCodeDocument, options);
        }
export type LatestCelebrityEventForZipCodeQueryHookResult = ReturnType<typeof useLatestCelebrityEventForZipCodeQuery>;
export type LatestCelebrityEventForZipCodeLazyQueryHookResult = ReturnType<typeof useLatestCelebrityEventForZipCodeLazyQuery>;
export type LatestCelebrityEventForZipCodeSuspenseQueryHookResult = ReturnType<typeof useLatestCelebrityEventForZipCodeSuspenseQuery>;
export type LatestCelebrityEventForZipCodeQueryResult = ApolloReactCommon.QueryResult<LatestCelebrityEventForZipCodeQuery, LatestCelebrityEventForZipCodeQueryVariables>;
export const CelebrityEventPopularShefsDocument = gql`
    query CelebrityEventPopularShefs($zipCode: String, $filters: ExploreFoodItemsFilterInput!) {
  celebrityEventPopularShefs(zipCode: $zipCode, filters: $filters) {
    ...DishFirstExploreSegmentShef
  }
}
    ${DishFirstExploreSegmentShefFragmentDoc}`;
export type CelebrityEventPopularShefsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CelebrityEventPopularShefsQuery, CelebrityEventPopularShefsQueryVariables>, 'query'> & ({ variables: CelebrityEventPopularShefsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CelebrityEventPopularShefsComponent = (props: CelebrityEventPopularShefsComponentProps) => (
      <ApolloReactComponents.Query<CelebrityEventPopularShefsQuery, CelebrityEventPopularShefsQueryVariables> query={CelebrityEventPopularShefsDocument} {...props} />
    );
    

/**
 * __useCelebrityEventPopularShefsQuery__
 *
 * To run a query within a React component, call `useCelebrityEventPopularShefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCelebrityEventPopularShefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCelebrityEventPopularShefsQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCelebrityEventPopularShefsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CelebrityEventPopularShefsQuery, CelebrityEventPopularShefsQueryVariables> & ({ variables: CelebrityEventPopularShefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CelebrityEventPopularShefsQuery, CelebrityEventPopularShefsQueryVariables>(CelebrityEventPopularShefsDocument, options);
      }
export function useCelebrityEventPopularShefsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CelebrityEventPopularShefsQuery, CelebrityEventPopularShefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CelebrityEventPopularShefsQuery, CelebrityEventPopularShefsQueryVariables>(CelebrityEventPopularShefsDocument, options);
        }
export function useCelebrityEventPopularShefsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CelebrityEventPopularShefsQuery, CelebrityEventPopularShefsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CelebrityEventPopularShefsQuery, CelebrityEventPopularShefsQueryVariables>(CelebrityEventPopularShefsDocument, options);
        }
export type CelebrityEventPopularShefsQueryHookResult = ReturnType<typeof useCelebrityEventPopularShefsQuery>;
export type CelebrityEventPopularShefsLazyQueryHookResult = ReturnType<typeof useCelebrityEventPopularShefsLazyQuery>;
export type CelebrityEventPopularShefsSuspenseQueryHookResult = ReturnType<typeof useCelebrityEventPopularShefsSuspenseQuery>;
export type CelebrityEventPopularShefsQueryResult = ApolloReactCommon.QueryResult<CelebrityEventPopularShefsQuery, CelebrityEventPopularShefsQueryVariables>;
export const ChatTokenDocument = gql`
    query ChatToken {
  chatToken
}
    `;
export type ChatTokenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ChatTokenQuery, ChatTokenQueryVariables>, 'query'>;

    export const ChatTokenComponent = (props: ChatTokenComponentProps) => (
      <ApolloReactComponents.Query<ChatTokenQuery, ChatTokenQueryVariables> query={ChatTokenDocument} {...props} />
    );
    

/**
 * __useChatTokenQuery__
 *
 * To run a query within a React component, call `useChatTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChatTokenQuery, ChatTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatTokenQuery, ChatTokenQueryVariables>(ChatTokenDocument, options);
      }
export function useChatTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatTokenQuery, ChatTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatTokenQuery, ChatTokenQueryVariables>(ChatTokenDocument, options);
        }
export function useChatTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatTokenQuery, ChatTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatTokenQuery, ChatTokenQueryVariables>(ChatTokenDocument, options);
        }
export type ChatTokenQueryHookResult = ReturnType<typeof useChatTokenQuery>;
export type ChatTokenLazyQueryHookResult = ReturnType<typeof useChatTokenLazyQuery>;
export type ChatTokenSuspenseQueryHookResult = ReturnType<typeof useChatTokenSuspenseQuery>;
export type ChatTokenQueryResult = ApolloReactCommon.QueryResult<ChatTokenQuery, ChatTokenQueryVariables>;
export const AddOrderDocument = gql`
    mutation AddOrder($input: GroupOrderInput!) {
  addGroupOrder: addGroupOrder2(input: $input) {
    groupOrder {
      id
      orders {
        id
        uuid
      }
    }
  }
}
    `;
export type AddOrderMutationFn = ApolloReactCommon.MutationFunction<AddOrderMutation, AddOrderMutationVariables>;
export type AddOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddOrderMutation, AddOrderMutationVariables>, 'mutation'>;

    export const AddOrderComponent = (props: AddOrderComponentProps) => (
      <ApolloReactComponents.Mutation<AddOrderMutation, AddOrderMutationVariables> mutation={AddOrderDocument} {...props} />
    );
    

/**
 * __useAddOrderMutation__
 *
 * To run a mutation, you first call `useAddOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderMutation, { data, loading, error }] = useAddOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddOrderMutation, AddOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddOrderMutation, AddOrderMutationVariables>(AddOrderDocument, options);
      }
export type AddOrderMutationHookResult = ReturnType<typeof useAddOrderMutation>;
export type AddOrderMutationResult = ApolloReactCommon.MutationResult<AddOrderMutation>;
export type AddOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<AddOrderMutation, AddOrderMutationVariables>;
export const ConsumerOrderFinalizeDocument = gql`
    query ConsumerOrderFinalize($shefId: String!, $shefIds: [String!]!, $deliveryDate: String!, $userId: String!, $noCurrentUser: Boolean!) {
  me {
    hasDiscountedSubtotalFromExperiment(shefId: $shefId)
    id
    fullName
    publicName
    phone
    tosLastAcceptedAt
    lastOrder {
      id
      deliveryAddressId
      deliveryNotes
      phone
      timeWindow {
        id
      }
    }
    lastOrderByFulfillmentDate(deliveryDate: $deliveryDate, shefId: $shefId) {
      timeWindowId
    }
    savedCreditCards {
      id
      lastFourDigits
      expiresAt
      brand
      type
      lastUsedAt
    }
    activeAddresses(shefId: $shefId, deliveryDate: $deliveryDate) {
      id
      ...AddressSelectorAddress
      timeWindows(deliveryDate: $deliveryDate) {
        ...TimeWindowSelectorTimeWindow
      }
      zipCodeInfo {
        zipCode
        regionId
      }
    }
  }
  shefs(userIds: $shefIds) {
    id
    shefProfile {
      id
      cuisineRegion
      primaryRegion {
        id
      }
      explorePagePromoCode {
        ...ExplorePagePromoCode
      }
      approximateLocation {
        latitude
        longitude
      }
      pickupTimeWindows {
        ...TimeWindowSelectorTimeWindow
      }
      fulfillmentOption
    }
    publicName
    firstName
    imageUrl
    timeZone
    celebrityEventType
  }
  carts {
    ...WholeCarts
  }
  applePayEnabled: isFeatureOn(name: APPLE_PAY)
  googlePayEnabled: isFeatureOn(name: GOOGLE_PAY)
  userNotificationSettings(userId: $userId) @skip(if: $noCurrentUser) {
    userId
    type
    category
    enabled
  }
}
    ${AddressSelectorAddressFragmentDoc}
${TimeWindowSelectorTimeWindowFragmentDoc}
${ExplorePagePromoCodeFragmentDoc}
${WholeCartsFragmentDoc}`;
export type ConsumerOrderFinalizeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerOrderFinalizeQuery, ConsumerOrderFinalizeQueryVariables>, 'query'> & ({ variables: ConsumerOrderFinalizeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConsumerOrderFinalizeComponent = (props: ConsumerOrderFinalizeComponentProps) => (
      <ApolloReactComponents.Query<ConsumerOrderFinalizeQuery, ConsumerOrderFinalizeQueryVariables> query={ConsumerOrderFinalizeDocument} {...props} />
    );
    

/**
 * __useConsumerOrderFinalizeQuery__
 *
 * To run a query within a React component, call `useConsumerOrderFinalizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerOrderFinalizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerOrderFinalizeQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      shefIds: // value for 'shefIds'
 *      deliveryDate: // value for 'deliveryDate'
 *      userId: // value for 'userId'
 *      noCurrentUser: // value for 'noCurrentUser'
 *   },
 * });
 */
export function useConsumerOrderFinalizeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConsumerOrderFinalizeQuery, ConsumerOrderFinalizeQueryVariables> & ({ variables: ConsumerOrderFinalizeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerOrderFinalizeQuery, ConsumerOrderFinalizeQueryVariables>(ConsumerOrderFinalizeDocument, options);
      }
export function useConsumerOrderFinalizeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerOrderFinalizeQuery, ConsumerOrderFinalizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerOrderFinalizeQuery, ConsumerOrderFinalizeQueryVariables>(ConsumerOrderFinalizeDocument, options);
        }
export function useConsumerOrderFinalizeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerOrderFinalizeQuery, ConsumerOrderFinalizeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerOrderFinalizeQuery, ConsumerOrderFinalizeQueryVariables>(ConsumerOrderFinalizeDocument, options);
        }
export type ConsumerOrderFinalizeQueryHookResult = ReturnType<typeof useConsumerOrderFinalizeQuery>;
export type ConsumerOrderFinalizeLazyQueryHookResult = ReturnType<typeof useConsumerOrderFinalizeLazyQuery>;
export type ConsumerOrderFinalizeSuspenseQueryHookResult = ReturnType<typeof useConsumerOrderFinalizeSuspenseQuery>;
export type ConsumerOrderFinalizeQueryResult = ApolloReactCommon.QueryResult<ConsumerOrderFinalizeQuery, ConsumerOrderFinalizeQueryVariables>;
export const NewAddressZipInfoDocument = gql`
    query NewAddressZipInfo($shefId: String!, $zipCode: String!, $deliveryDate: String) {
  validDaysOfWeek(zipCode: $zipCode)
  shefProfile(userId: $shefId) {
    pickupTimeWindows {
      ...TimeWindowSelectorTimeWindow
    }
  }
  zipCode(zipCode: $zipCode) {
    zipCode
    regionId
    timeWindows(deliveryDate: $deliveryDate) {
      ...TimeWindowSelectorTimeWindow
    }
    shefServesZipCode(shefId: $shefId, deliveryDate: $deliveryDate)
    isHubless
  }
}
    ${TimeWindowSelectorTimeWindowFragmentDoc}`;
export type NewAddressZipInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NewAddressZipInfoQuery, NewAddressZipInfoQueryVariables>, 'query'> & ({ variables: NewAddressZipInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NewAddressZipInfoComponent = (props: NewAddressZipInfoComponentProps) => (
      <ApolloReactComponents.Query<NewAddressZipInfoQuery, NewAddressZipInfoQueryVariables> query={NewAddressZipInfoDocument} {...props} />
    );
    

/**
 * __useNewAddressZipInfoQuery__
 *
 * To run a query within a React component, call `useNewAddressZipInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewAddressZipInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewAddressZipInfoQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      zipCode: // value for 'zipCode'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useNewAddressZipInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NewAddressZipInfoQuery, NewAddressZipInfoQueryVariables> & ({ variables: NewAddressZipInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NewAddressZipInfoQuery, NewAddressZipInfoQueryVariables>(NewAddressZipInfoDocument, options);
      }
export function useNewAddressZipInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewAddressZipInfoQuery, NewAddressZipInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NewAddressZipInfoQuery, NewAddressZipInfoQueryVariables>(NewAddressZipInfoDocument, options);
        }
export function useNewAddressZipInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NewAddressZipInfoQuery, NewAddressZipInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NewAddressZipInfoQuery, NewAddressZipInfoQueryVariables>(NewAddressZipInfoDocument, options);
        }
export type NewAddressZipInfoQueryHookResult = ReturnType<typeof useNewAddressZipInfoQuery>;
export type NewAddressZipInfoLazyQueryHookResult = ReturnType<typeof useNewAddressZipInfoLazyQuery>;
export type NewAddressZipInfoSuspenseQueryHookResult = ReturnType<typeof useNewAddressZipInfoSuspenseQuery>;
export type NewAddressZipInfoQueryResult = ApolloReactCommon.QueryResult<NewAddressZipInfoQuery, NewAddressZipInfoQueryVariables>;
export const ConsumerCheckoutExitIntentPromoCodeDocument = gql`
    query ConsumerCheckoutExitIntentPromoCode($zipCode: String, $shefId: String!, $deliveryDate: String!, $subtotal: Int!) {
  checkoutExitIntentPromoCode(
    zipCode: $zipCode
    shefId: $shefId
    deliveryDate: $deliveryDate
    subtotal: $subtotal
  ) {
    ...PromoCodeFields
  }
}
    ${PromoCodeFieldsFragmentDoc}`;
export type ConsumerCheckoutExitIntentPromoCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerCheckoutExitIntentPromoCodeQuery, ConsumerCheckoutExitIntentPromoCodeQueryVariables>, 'query'> & ({ variables: ConsumerCheckoutExitIntentPromoCodeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConsumerCheckoutExitIntentPromoCodeComponent = (props: ConsumerCheckoutExitIntentPromoCodeComponentProps) => (
      <ApolloReactComponents.Query<ConsumerCheckoutExitIntentPromoCodeQuery, ConsumerCheckoutExitIntentPromoCodeQueryVariables> query={ConsumerCheckoutExitIntentPromoCodeDocument} {...props} />
    );
    

/**
 * __useConsumerCheckoutExitIntentPromoCodeQuery__
 *
 * To run a query within a React component, call `useConsumerCheckoutExitIntentPromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerCheckoutExitIntentPromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerCheckoutExitIntentPromoCodeQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      shefId: // value for 'shefId'
 *      deliveryDate: // value for 'deliveryDate'
 *      subtotal: // value for 'subtotal'
 *   },
 * });
 */
export function useConsumerCheckoutExitIntentPromoCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConsumerCheckoutExitIntentPromoCodeQuery, ConsumerCheckoutExitIntentPromoCodeQueryVariables> & ({ variables: ConsumerCheckoutExitIntentPromoCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerCheckoutExitIntentPromoCodeQuery, ConsumerCheckoutExitIntentPromoCodeQueryVariables>(ConsumerCheckoutExitIntentPromoCodeDocument, options);
      }
export function useConsumerCheckoutExitIntentPromoCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerCheckoutExitIntentPromoCodeQuery, ConsumerCheckoutExitIntentPromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerCheckoutExitIntentPromoCodeQuery, ConsumerCheckoutExitIntentPromoCodeQueryVariables>(ConsumerCheckoutExitIntentPromoCodeDocument, options);
        }
export function useConsumerCheckoutExitIntentPromoCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerCheckoutExitIntentPromoCodeQuery, ConsumerCheckoutExitIntentPromoCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerCheckoutExitIntentPromoCodeQuery, ConsumerCheckoutExitIntentPromoCodeQueryVariables>(ConsumerCheckoutExitIntentPromoCodeDocument, options);
        }
export type ConsumerCheckoutExitIntentPromoCodeQueryHookResult = ReturnType<typeof useConsumerCheckoutExitIntentPromoCodeQuery>;
export type ConsumerCheckoutExitIntentPromoCodeLazyQueryHookResult = ReturnType<typeof useConsumerCheckoutExitIntentPromoCodeLazyQuery>;
export type ConsumerCheckoutExitIntentPromoCodeSuspenseQueryHookResult = ReturnType<typeof useConsumerCheckoutExitIntentPromoCodeSuspenseQuery>;
export type ConsumerCheckoutExitIntentPromoCodeQueryResult = ApolloReactCommon.QueryResult<ConsumerCheckoutExitIntentPromoCodeQuery, ConsumerCheckoutExitIntentPromoCodeQueryVariables>;
export const RecurringSubscriptionAvailabilityDocument = gql`
    query RecurringSubscriptionAvailability($shefId: String!) {
  recurringSubscriptionAvailability(shefId: $shefId) {
    subscriptionOptions {
      recurringPeriod
      displayText
      promoCode {
        ...PromoCodeFields
      }
    }
  }
}
    ${PromoCodeFieldsFragmentDoc}`;
export type RecurringSubscriptionAvailabilityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecurringSubscriptionAvailabilityQuery, RecurringSubscriptionAvailabilityQueryVariables>, 'query'> & ({ variables: RecurringSubscriptionAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RecurringSubscriptionAvailabilityComponent = (props: RecurringSubscriptionAvailabilityComponentProps) => (
      <ApolloReactComponents.Query<RecurringSubscriptionAvailabilityQuery, RecurringSubscriptionAvailabilityQueryVariables> query={RecurringSubscriptionAvailabilityDocument} {...props} />
    );
    

/**
 * __useRecurringSubscriptionAvailabilityQuery__
 *
 * To run a query within a React component, call `useRecurringSubscriptionAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringSubscriptionAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringSubscriptionAvailabilityQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useRecurringSubscriptionAvailabilityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RecurringSubscriptionAvailabilityQuery, RecurringSubscriptionAvailabilityQueryVariables> & ({ variables: RecurringSubscriptionAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecurringSubscriptionAvailabilityQuery, RecurringSubscriptionAvailabilityQueryVariables>(RecurringSubscriptionAvailabilityDocument, options);
      }
export function useRecurringSubscriptionAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecurringSubscriptionAvailabilityQuery, RecurringSubscriptionAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecurringSubscriptionAvailabilityQuery, RecurringSubscriptionAvailabilityQueryVariables>(RecurringSubscriptionAvailabilityDocument, options);
        }
export function useRecurringSubscriptionAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RecurringSubscriptionAvailabilityQuery, RecurringSubscriptionAvailabilityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RecurringSubscriptionAvailabilityQuery, RecurringSubscriptionAvailabilityQueryVariables>(RecurringSubscriptionAvailabilityDocument, options);
        }
export type RecurringSubscriptionAvailabilityQueryHookResult = ReturnType<typeof useRecurringSubscriptionAvailabilityQuery>;
export type RecurringSubscriptionAvailabilityLazyQueryHookResult = ReturnType<typeof useRecurringSubscriptionAvailabilityLazyQuery>;
export type RecurringSubscriptionAvailabilitySuspenseQueryHookResult = ReturnType<typeof useRecurringSubscriptionAvailabilitySuspenseQuery>;
export type RecurringSubscriptionAvailabilityQueryResult = ApolloReactCommon.QueryResult<RecurringSubscriptionAvailabilityQuery, RecurringSubscriptionAvailabilityQueryVariables>;
export const GroupOrderTotalsDocument = gql`
    query GroupOrderTotals($groupOrderInput: GroupOrderTotalsInput!) {
  groupOrderTotals(groupOrderInput: $groupOrderInput) {
    ...EntireOrderTotal
  }
}
    ${EntireOrderTotalFragmentDoc}`;
export type GroupOrderTotalsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupOrderTotalsQuery, GroupOrderTotalsQueryVariables>, 'query'> & ({ variables: GroupOrderTotalsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GroupOrderTotalsComponent = (props: GroupOrderTotalsComponentProps) => (
      <ApolloReactComponents.Query<GroupOrderTotalsQuery, GroupOrderTotalsQueryVariables> query={GroupOrderTotalsDocument} {...props} />
    );
    

/**
 * __useGroupOrderTotalsQuery__
 *
 * To run a query within a React component, call `useGroupOrderTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupOrderTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupOrderTotalsQuery({
 *   variables: {
 *      groupOrderInput: // value for 'groupOrderInput'
 *   },
 * });
 */
export function useGroupOrderTotalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupOrderTotalsQuery, GroupOrderTotalsQueryVariables> & ({ variables: GroupOrderTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupOrderTotalsQuery, GroupOrderTotalsQueryVariables>(GroupOrderTotalsDocument, options);
      }
export function useGroupOrderTotalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupOrderTotalsQuery, GroupOrderTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupOrderTotalsQuery, GroupOrderTotalsQueryVariables>(GroupOrderTotalsDocument, options);
        }
export function useGroupOrderTotalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupOrderTotalsQuery, GroupOrderTotalsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupOrderTotalsQuery, GroupOrderTotalsQueryVariables>(GroupOrderTotalsDocument, options);
        }
export type GroupOrderTotalsQueryHookResult = ReturnType<typeof useGroupOrderTotalsQuery>;
export type GroupOrderTotalsLazyQueryHookResult = ReturnType<typeof useGroupOrderTotalsLazyQuery>;
export type GroupOrderTotalsSuspenseQueryHookResult = ReturnType<typeof useGroupOrderTotalsSuspenseQuery>;
export type GroupOrderTotalsQueryResult = ApolloReactCommon.QueryResult<GroupOrderTotalsQuery, GroupOrderTotalsQueryVariables>;
export const ModifiedGroupOrderTotalsDocument = gql`
    query ModifiedGroupOrderTotals($input: ConsumerModifyGroupOrderInput!) {
  modifiedGroupOrderTotals(input: $input) {
    ...EntireOrderTotal
  }
}
    ${EntireOrderTotalFragmentDoc}`;
export type ModifiedGroupOrderTotalsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ModifiedGroupOrderTotalsQuery, ModifiedGroupOrderTotalsQueryVariables>, 'query'> & ({ variables: ModifiedGroupOrderTotalsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ModifiedGroupOrderTotalsComponent = (props: ModifiedGroupOrderTotalsComponentProps) => (
      <ApolloReactComponents.Query<ModifiedGroupOrderTotalsQuery, ModifiedGroupOrderTotalsQueryVariables> query={ModifiedGroupOrderTotalsDocument} {...props} />
    );
    

/**
 * __useModifiedGroupOrderTotalsQuery__
 *
 * To run a query within a React component, call `useModifiedGroupOrderTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModifiedGroupOrderTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModifiedGroupOrderTotalsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifiedGroupOrderTotalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModifiedGroupOrderTotalsQuery, ModifiedGroupOrderTotalsQueryVariables> & ({ variables: ModifiedGroupOrderTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModifiedGroupOrderTotalsQuery, ModifiedGroupOrderTotalsQueryVariables>(ModifiedGroupOrderTotalsDocument, options);
      }
export function useModifiedGroupOrderTotalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModifiedGroupOrderTotalsQuery, ModifiedGroupOrderTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModifiedGroupOrderTotalsQuery, ModifiedGroupOrderTotalsQueryVariables>(ModifiedGroupOrderTotalsDocument, options);
        }
export function useModifiedGroupOrderTotalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModifiedGroupOrderTotalsQuery, ModifiedGroupOrderTotalsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModifiedGroupOrderTotalsQuery, ModifiedGroupOrderTotalsQueryVariables>(ModifiedGroupOrderTotalsDocument, options);
        }
export type ModifiedGroupOrderTotalsQueryHookResult = ReturnType<typeof useModifiedGroupOrderTotalsQuery>;
export type ModifiedGroupOrderTotalsLazyQueryHookResult = ReturnType<typeof useModifiedGroupOrderTotalsLazyQuery>;
export type ModifiedGroupOrderTotalsSuspenseQueryHookResult = ReturnType<typeof useModifiedGroupOrderTotalsSuspenseQuery>;
export type ModifiedGroupOrderTotalsQueryResult = ApolloReactCommon.QueryResult<ModifiedGroupOrderTotalsQuery, ModifiedGroupOrderTotalsQueryVariables>;
export const MealPlanOrderSalesTaxDocument = gql`
    query MealPlanOrderSalesTax($mealPlanOrderSalesTaxInput: MealPlanOrderSalesTaxInput!) {
  mealPlanOrderSalesTax(mealPlanOrderSalesTaxInput: $mealPlanOrderSalesTaxInput) {
    salesTax
  }
}
    `;
export type MealPlanOrderSalesTaxComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MealPlanOrderSalesTaxQuery, MealPlanOrderSalesTaxQueryVariables>, 'query'> & ({ variables: MealPlanOrderSalesTaxQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MealPlanOrderSalesTaxComponent = (props: MealPlanOrderSalesTaxComponentProps) => (
      <ApolloReactComponents.Query<MealPlanOrderSalesTaxQuery, MealPlanOrderSalesTaxQueryVariables> query={MealPlanOrderSalesTaxDocument} {...props} />
    );
    

/**
 * __useMealPlanOrderSalesTaxQuery__
 *
 * To run a query within a React component, call `useMealPlanOrderSalesTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useMealPlanOrderSalesTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMealPlanOrderSalesTaxQuery({
 *   variables: {
 *      mealPlanOrderSalesTaxInput: // value for 'mealPlanOrderSalesTaxInput'
 *   },
 * });
 */
export function useMealPlanOrderSalesTaxQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MealPlanOrderSalesTaxQuery, MealPlanOrderSalesTaxQueryVariables> & ({ variables: MealPlanOrderSalesTaxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MealPlanOrderSalesTaxQuery, MealPlanOrderSalesTaxQueryVariables>(MealPlanOrderSalesTaxDocument, options);
      }
export function useMealPlanOrderSalesTaxLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MealPlanOrderSalesTaxQuery, MealPlanOrderSalesTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MealPlanOrderSalesTaxQuery, MealPlanOrderSalesTaxQueryVariables>(MealPlanOrderSalesTaxDocument, options);
        }
export function useMealPlanOrderSalesTaxSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MealPlanOrderSalesTaxQuery, MealPlanOrderSalesTaxQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MealPlanOrderSalesTaxQuery, MealPlanOrderSalesTaxQueryVariables>(MealPlanOrderSalesTaxDocument, options);
        }
export type MealPlanOrderSalesTaxQueryHookResult = ReturnType<typeof useMealPlanOrderSalesTaxQuery>;
export type MealPlanOrderSalesTaxLazyQueryHookResult = ReturnType<typeof useMealPlanOrderSalesTaxLazyQuery>;
export type MealPlanOrderSalesTaxSuspenseQueryHookResult = ReturnType<typeof useMealPlanOrderSalesTaxSuspenseQuery>;
export type MealPlanOrderSalesTaxQueryResult = ApolloReactCommon.QueryResult<MealPlanOrderSalesTaxQuery, MealPlanOrderSalesTaxQueryVariables>;
export const AdminCreateOrUpdateDeliveryHubDocument = gql`
    mutation AdminCreateOrUpdateDeliveryHub($deliveryHubInput: UpdateDeliveryHubInput!) {
  createOrUpdateDeliveryHub(deliveryHubInput: $deliveryHubInput) {
    id
  }
}
    `;
export type AdminCreateOrUpdateDeliveryHubMutationFn = ApolloReactCommon.MutationFunction<AdminCreateOrUpdateDeliveryHubMutation, AdminCreateOrUpdateDeliveryHubMutationVariables>;
export type AdminCreateOrUpdateDeliveryHubComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminCreateOrUpdateDeliveryHubMutation, AdminCreateOrUpdateDeliveryHubMutationVariables>, 'mutation'>;

    export const AdminCreateOrUpdateDeliveryHubComponent = (props: AdminCreateOrUpdateDeliveryHubComponentProps) => (
      <ApolloReactComponents.Mutation<AdminCreateOrUpdateDeliveryHubMutation, AdminCreateOrUpdateDeliveryHubMutationVariables> mutation={AdminCreateOrUpdateDeliveryHubDocument} {...props} />
    );
    

/**
 * __useAdminCreateOrUpdateDeliveryHubMutation__
 *
 * To run a mutation, you first call `useAdminCreateOrUpdateDeliveryHubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateOrUpdateDeliveryHubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateOrUpdateDeliveryHubMutation, { data, loading, error }] = useAdminCreateOrUpdateDeliveryHubMutation({
 *   variables: {
 *      deliveryHubInput: // value for 'deliveryHubInput'
 *   },
 * });
 */
export function useAdminCreateOrUpdateDeliveryHubMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateOrUpdateDeliveryHubMutation, AdminCreateOrUpdateDeliveryHubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateOrUpdateDeliveryHubMutation, AdminCreateOrUpdateDeliveryHubMutationVariables>(AdminCreateOrUpdateDeliveryHubDocument, options);
      }
export type AdminCreateOrUpdateDeliveryHubMutationHookResult = ReturnType<typeof useAdminCreateOrUpdateDeliveryHubMutation>;
export type AdminCreateOrUpdateDeliveryHubMutationResult = ApolloReactCommon.MutationResult<AdminCreateOrUpdateDeliveryHubMutation>;
export type AdminCreateOrUpdateDeliveryHubMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminCreateOrUpdateDeliveryHubMutation, AdminCreateOrUpdateDeliveryHubMutationVariables>;
export const GroupOrderIdForOrderDocument = gql`
    query GroupOrderIdForOrder($orderId: Int, $orderUuid: String) {
  order(orderId: $orderId, orderUuid: $orderUuid) {
    groupOrderId
  }
}
    `;
export type GroupOrderIdForOrderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupOrderIdForOrderQuery, GroupOrderIdForOrderQueryVariables>, 'query'>;

    export const GroupOrderIdForOrderComponent = (props: GroupOrderIdForOrderComponentProps) => (
      <ApolloReactComponents.Query<GroupOrderIdForOrderQuery, GroupOrderIdForOrderQueryVariables> query={GroupOrderIdForOrderDocument} {...props} />
    );
    

/**
 * __useGroupOrderIdForOrderQuery__
 *
 * To run a query within a React component, call `useGroupOrderIdForOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupOrderIdForOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupOrderIdForOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      orderUuid: // value for 'orderUuid'
 *   },
 * });
 */
export function useGroupOrderIdForOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GroupOrderIdForOrderQuery, GroupOrderIdForOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupOrderIdForOrderQuery, GroupOrderIdForOrderQueryVariables>(GroupOrderIdForOrderDocument, options);
      }
export function useGroupOrderIdForOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupOrderIdForOrderQuery, GroupOrderIdForOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupOrderIdForOrderQuery, GroupOrderIdForOrderQueryVariables>(GroupOrderIdForOrderDocument, options);
        }
export function useGroupOrderIdForOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupOrderIdForOrderQuery, GroupOrderIdForOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupOrderIdForOrderQuery, GroupOrderIdForOrderQueryVariables>(GroupOrderIdForOrderDocument, options);
        }
export type GroupOrderIdForOrderQueryHookResult = ReturnType<typeof useGroupOrderIdForOrderQuery>;
export type GroupOrderIdForOrderLazyQueryHookResult = ReturnType<typeof useGroupOrderIdForOrderLazyQuery>;
export type GroupOrderIdForOrderSuspenseQueryHookResult = ReturnType<typeof useGroupOrderIdForOrderSuspenseQuery>;
export type GroupOrderIdForOrderQueryResult = ApolloReactCommon.QueryResult<GroupOrderIdForOrderQuery, GroupOrderIdForOrderQueryVariables>;
export const AdminListConfigsDocument = gql`
    query AdminListConfigs {
  configs {
    ...ConfigFields
  }
  allOverrideSegments
}
    ${ConfigFieldsFragmentDoc}`;
export type AdminListConfigsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminListConfigsQuery, AdminListConfigsQueryVariables>, 'query'>;

    export const AdminListConfigsComponent = (props: AdminListConfigsComponentProps) => (
      <ApolloReactComponents.Query<AdminListConfigsQuery, AdminListConfigsQueryVariables> query={AdminListConfigsDocument} {...props} />
    );
    

/**
 * __useAdminListConfigsQuery__
 *
 * To run a query within a React component, call `useAdminListConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminListConfigsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminListConfigsQuery, AdminListConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminListConfigsQuery, AdminListConfigsQueryVariables>(AdminListConfigsDocument, options);
      }
export function useAdminListConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminListConfigsQuery, AdminListConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminListConfigsQuery, AdminListConfigsQueryVariables>(AdminListConfigsDocument, options);
        }
export function useAdminListConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminListConfigsQuery, AdminListConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminListConfigsQuery, AdminListConfigsQueryVariables>(AdminListConfigsDocument, options);
        }
export type AdminListConfigsQueryHookResult = ReturnType<typeof useAdminListConfigsQuery>;
export type AdminListConfigsLazyQueryHookResult = ReturnType<typeof useAdminListConfigsLazyQuery>;
export type AdminListConfigsSuspenseQueryHookResult = ReturnType<typeof useAdminListConfigsSuspenseQuery>;
export type AdminListConfigsQueryResult = ApolloReactCommon.QueryResult<AdminListConfigsQuery, AdminListConfigsQueryVariables>;
export const AdminUpdateConfigDocument = gql`
    mutation AdminUpdateConfig($name: FeatureName!, $value: String!, $overrides: [ConfigOverrideInput!]!) {
  updateConfig(name: $name, value: $value, overrides: $overrides) {
    ...ConfigFields
  }
}
    ${ConfigFieldsFragmentDoc}`;
export type AdminUpdateConfigMutationFn = ApolloReactCommon.MutationFunction<AdminUpdateConfigMutation, AdminUpdateConfigMutationVariables>;
export type AdminUpdateConfigComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminUpdateConfigMutation, AdminUpdateConfigMutationVariables>, 'mutation'>;

    export const AdminUpdateConfigComponent = (props: AdminUpdateConfigComponentProps) => (
      <ApolloReactComponents.Mutation<AdminUpdateConfigMutation, AdminUpdateConfigMutationVariables> mutation={AdminUpdateConfigDocument} {...props} />
    );
    

/**
 * __useAdminUpdateConfigMutation__
 *
 * To run a mutation, you first call `useAdminUpdateConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateConfigMutation, { data, loading, error }] = useAdminUpdateConfigMutation({
 *   variables: {
 *      name: // value for 'name'
 *      value: // value for 'value'
 *      overrides: // value for 'overrides'
 *   },
 * });
 */
export function useAdminUpdateConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateConfigMutation, AdminUpdateConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateConfigMutation, AdminUpdateConfigMutationVariables>(AdminUpdateConfigDocument, options);
      }
export type AdminUpdateConfigMutationHookResult = ReturnType<typeof useAdminUpdateConfigMutation>;
export type AdminUpdateConfigMutationResult = ApolloReactCommon.MutationResult<AdminUpdateConfigMutation>;
export type AdminUpdateConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminUpdateConfigMutation, AdminUpdateConfigMutationVariables>;
export const FoodItemAuditRequestsDocument = gql`
    query FoodItemAuditRequests($filterAuditStatus: AuditStatus, $page: Int) {
  foodItemAuditRequests(filterAuditStatus: $filterAuditStatus, page: $page) {
    auditRequests {
      ...FoodItemAuditRequestRowFields
    }
    pagination {
      ...PaginationFields
    }
  }
}
    ${FoodItemAuditRequestRowFieldsFragmentDoc}
${PaginationFieldsFragmentDoc}`;
export type FoodItemAuditRequestsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FoodItemAuditRequestsQuery, FoodItemAuditRequestsQueryVariables>, 'query'>;

    export const FoodItemAuditRequestsComponent = (props: FoodItemAuditRequestsComponentProps) => (
      <ApolloReactComponents.Query<FoodItemAuditRequestsQuery, FoodItemAuditRequestsQueryVariables> query={FoodItemAuditRequestsDocument} {...props} />
    );
    

/**
 * __useFoodItemAuditRequestsQuery__
 *
 * To run a query within a React component, call `useFoodItemAuditRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodItemAuditRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodItemAuditRequestsQuery({
 *   variables: {
 *      filterAuditStatus: // value for 'filterAuditStatus'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useFoodItemAuditRequestsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FoodItemAuditRequestsQuery, FoodItemAuditRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FoodItemAuditRequestsQuery, FoodItemAuditRequestsQueryVariables>(FoodItemAuditRequestsDocument, options);
      }
export function useFoodItemAuditRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FoodItemAuditRequestsQuery, FoodItemAuditRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FoodItemAuditRequestsQuery, FoodItemAuditRequestsQueryVariables>(FoodItemAuditRequestsDocument, options);
        }
export function useFoodItemAuditRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FoodItemAuditRequestsQuery, FoodItemAuditRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FoodItemAuditRequestsQuery, FoodItemAuditRequestsQueryVariables>(FoodItemAuditRequestsDocument, options);
        }
export type FoodItemAuditRequestsQueryHookResult = ReturnType<typeof useFoodItemAuditRequestsQuery>;
export type FoodItemAuditRequestsLazyQueryHookResult = ReturnType<typeof useFoodItemAuditRequestsLazyQuery>;
export type FoodItemAuditRequestsSuspenseQueryHookResult = ReturnType<typeof useFoodItemAuditRequestsSuspenseQuery>;
export type FoodItemAuditRequestsQueryResult = ApolloReactCommon.QueryResult<FoodItemAuditRequestsQuery, FoodItemAuditRequestsQueryVariables>;
export const FoodItemAuditRequestDocument = gql`
    query FoodItemAuditRequest($id: String!) {
  foodItemAuditRequest(id: $id) {
    ...FoodItemAuditRequestFields
  }
  foodItemCustomizationTypes {
    ...FoodItemCustomizationTypeFields
  }
}
    ${FoodItemAuditRequestFieldsFragmentDoc}
${FoodItemCustomizationTypeFieldsFragmentDoc}`;
export type FoodItemAuditRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FoodItemAuditRequestQuery, FoodItemAuditRequestQueryVariables>, 'query'> & ({ variables: FoodItemAuditRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FoodItemAuditRequestComponent = (props: FoodItemAuditRequestComponentProps) => (
      <ApolloReactComponents.Query<FoodItemAuditRequestQuery, FoodItemAuditRequestQueryVariables> query={FoodItemAuditRequestDocument} {...props} />
    );
    

/**
 * __useFoodItemAuditRequestQuery__
 *
 * To run a query within a React component, call `useFoodItemAuditRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodItemAuditRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodItemAuditRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFoodItemAuditRequestQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FoodItemAuditRequestQuery, FoodItemAuditRequestQueryVariables> & ({ variables: FoodItemAuditRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FoodItemAuditRequestQuery, FoodItemAuditRequestQueryVariables>(FoodItemAuditRequestDocument, options);
      }
export function useFoodItemAuditRequestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FoodItemAuditRequestQuery, FoodItemAuditRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FoodItemAuditRequestQuery, FoodItemAuditRequestQueryVariables>(FoodItemAuditRequestDocument, options);
        }
export function useFoodItemAuditRequestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FoodItemAuditRequestQuery, FoodItemAuditRequestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FoodItemAuditRequestQuery, FoodItemAuditRequestQueryVariables>(FoodItemAuditRequestDocument, options);
        }
export type FoodItemAuditRequestQueryHookResult = ReturnType<typeof useFoodItemAuditRequestQuery>;
export type FoodItemAuditRequestLazyQueryHookResult = ReturnType<typeof useFoodItemAuditRequestLazyQuery>;
export type FoodItemAuditRequestSuspenseQueryHookResult = ReturnType<typeof useFoodItemAuditRequestSuspenseQuery>;
export type FoodItemAuditRequestQueryResult = ApolloReactCommon.QueryResult<FoodItemAuditRequestQuery, FoodItemAuditRequestQueryVariables>;
export const FoodItemCommentsDocument = gql`
    query FoodItemComments($foodItemId: Int!) {
  foodItemComments(foodItemId: $foodItemId) {
    id
    foodItemId
    auditId
    senderId
    commentText
    createdAt
  }
}
    `;
export type FoodItemCommentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FoodItemCommentsQuery, FoodItemCommentsQueryVariables>, 'query'> & ({ variables: FoodItemCommentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FoodItemCommentsComponent = (props: FoodItemCommentsComponentProps) => (
      <ApolloReactComponents.Query<FoodItemCommentsQuery, FoodItemCommentsQueryVariables> query={FoodItemCommentsDocument} {...props} />
    );
    

/**
 * __useFoodItemCommentsQuery__
 *
 * To run a query within a React component, call `useFoodItemCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodItemCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodItemCommentsQuery({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *   },
 * });
 */
export function useFoodItemCommentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FoodItemCommentsQuery, FoodItemCommentsQueryVariables> & ({ variables: FoodItemCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FoodItemCommentsQuery, FoodItemCommentsQueryVariables>(FoodItemCommentsDocument, options);
      }
export function useFoodItemCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FoodItemCommentsQuery, FoodItemCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FoodItemCommentsQuery, FoodItemCommentsQueryVariables>(FoodItemCommentsDocument, options);
        }
export function useFoodItemCommentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FoodItemCommentsQuery, FoodItemCommentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FoodItemCommentsQuery, FoodItemCommentsQueryVariables>(FoodItemCommentsDocument, options);
        }
export type FoodItemCommentsQueryHookResult = ReturnType<typeof useFoodItemCommentsQuery>;
export type FoodItemCommentsLazyQueryHookResult = ReturnType<typeof useFoodItemCommentsLazyQuery>;
export type FoodItemCommentsSuspenseQueryHookResult = ReturnType<typeof useFoodItemCommentsSuspenseQuery>;
export type FoodItemCommentsQueryResult = ApolloReactCommon.QueryResult<FoodItemCommentsQuery, FoodItemCommentsQueryVariables>;
export const UpdateAuditStatusDocument = gql`
    mutation UpdateAuditStatus($auditGroupId: String!, $status: AuditStatus!) {
  updateAuditStatus(auditGroupId: $auditGroupId, status: $status)
}
    `;
export type UpdateAuditStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateAuditStatusMutation, UpdateAuditStatusMutationVariables>;
export type UpdateAuditStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAuditStatusMutation, UpdateAuditStatusMutationVariables>, 'mutation'>;

    export const UpdateAuditStatusComponent = (props: UpdateAuditStatusComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAuditStatusMutation, UpdateAuditStatusMutationVariables> mutation={UpdateAuditStatusDocument} {...props} />
    );
    

/**
 * __useUpdateAuditStatusMutation__
 *
 * To run a mutation, you first call `useUpdateAuditStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuditStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuditStatusMutation, { data, loading, error }] = useUpdateAuditStatusMutation({
 *   variables: {
 *      auditGroupId: // value for 'auditGroupId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateAuditStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAuditStatusMutation, UpdateAuditStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAuditStatusMutation, UpdateAuditStatusMutationVariables>(UpdateAuditStatusDocument, options);
      }
export type UpdateAuditStatusMutationHookResult = ReturnType<typeof useUpdateAuditStatusMutation>;
export type UpdateAuditStatusMutationResult = ApolloReactCommon.MutationResult<UpdateAuditStatusMutation>;
export type UpdateAuditStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAuditStatusMutation, UpdateAuditStatusMutationVariables>;
export const BulkAddFoodItemCommentsDocument = gql`
    mutation BulkAddFoodItemComments($comments: [FoodItemCommentInput!]!) {
  bulkAddFoodItemComments(comments: $comments)
}
    `;
export type BulkAddFoodItemCommentsMutationFn = ApolloReactCommon.MutationFunction<BulkAddFoodItemCommentsMutation, BulkAddFoodItemCommentsMutationVariables>;
export type BulkAddFoodItemCommentsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BulkAddFoodItemCommentsMutation, BulkAddFoodItemCommentsMutationVariables>, 'mutation'>;

    export const BulkAddFoodItemCommentsComponent = (props: BulkAddFoodItemCommentsComponentProps) => (
      <ApolloReactComponents.Mutation<BulkAddFoodItemCommentsMutation, BulkAddFoodItemCommentsMutationVariables> mutation={BulkAddFoodItemCommentsDocument} {...props} />
    );
    

/**
 * __useBulkAddFoodItemCommentsMutation__
 *
 * To run a mutation, you first call `useBulkAddFoodItemCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddFoodItemCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddFoodItemCommentsMutation, { data, loading, error }] = useBulkAddFoodItemCommentsMutation({
 *   variables: {
 *      comments: // value for 'comments'
 *   },
 * });
 */
export function useBulkAddFoodItemCommentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkAddFoodItemCommentsMutation, BulkAddFoodItemCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkAddFoodItemCommentsMutation, BulkAddFoodItemCommentsMutationVariables>(BulkAddFoodItemCommentsDocument, options);
      }
export type BulkAddFoodItemCommentsMutationHookResult = ReturnType<typeof useBulkAddFoodItemCommentsMutation>;
export type BulkAddFoodItemCommentsMutationResult = ApolloReactCommon.MutationResult<BulkAddFoodItemCommentsMutation>;
export type BulkAddFoodItemCommentsMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkAddFoodItemCommentsMutation, BulkAddFoodItemCommentsMutationVariables>;
export const BulkReadFoodItemCommentsForFoodItemDocument = gql`
    mutation BulkReadFoodItemCommentsForFoodItem($foodItemId: Int!) {
  bulkReadFoodItemCommentsForFoodItem(foodItemId: $foodItemId)
}
    `;
export type BulkReadFoodItemCommentsForFoodItemMutationFn = ApolloReactCommon.MutationFunction<BulkReadFoodItemCommentsForFoodItemMutation, BulkReadFoodItemCommentsForFoodItemMutationVariables>;
export type BulkReadFoodItemCommentsForFoodItemComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BulkReadFoodItemCommentsForFoodItemMutation, BulkReadFoodItemCommentsForFoodItemMutationVariables>, 'mutation'>;

    export const BulkReadFoodItemCommentsForFoodItemComponent = (props: BulkReadFoodItemCommentsForFoodItemComponentProps) => (
      <ApolloReactComponents.Mutation<BulkReadFoodItemCommentsForFoodItemMutation, BulkReadFoodItemCommentsForFoodItemMutationVariables> mutation={BulkReadFoodItemCommentsForFoodItemDocument} {...props} />
    );
    

/**
 * __useBulkReadFoodItemCommentsForFoodItemMutation__
 *
 * To run a mutation, you first call `useBulkReadFoodItemCommentsForFoodItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkReadFoodItemCommentsForFoodItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkReadFoodItemCommentsForFoodItemMutation, { data, loading, error }] = useBulkReadFoodItemCommentsForFoodItemMutation({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *   },
 * });
 */
export function useBulkReadFoodItemCommentsForFoodItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkReadFoodItemCommentsForFoodItemMutation, BulkReadFoodItemCommentsForFoodItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkReadFoodItemCommentsForFoodItemMutation, BulkReadFoodItemCommentsForFoodItemMutationVariables>(BulkReadFoodItemCommentsForFoodItemDocument, options);
      }
export type BulkReadFoodItemCommentsForFoodItemMutationHookResult = ReturnType<typeof useBulkReadFoodItemCommentsForFoodItemMutation>;
export type BulkReadFoodItemCommentsForFoodItemMutationResult = ApolloReactCommon.MutationResult<BulkReadFoodItemCommentsForFoodItemMutation>;
export type BulkReadFoodItemCommentsForFoodItemMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkReadFoodItemCommentsForFoodItemMutation, BulkReadFoodItemCommentsForFoodItemMutationVariables>;
export const AdminModifyFoodItemDocument = gql`
    mutation AdminModifyFoodItem($foodItemId: Int!, $changeset: FoodItemChangesetInput!, $makeLive: Boolean, $autoApproveIfPossible: Boolean!) {
  createFoodItemChangeRequest(
    foodItemId: $foodItemId
    changeset: $changeset
    makeLive: $makeLive
    autoApproveIfPossible: $autoApproveIfPossible
  ) {
    id
    status
  }
}
    `;
export type AdminModifyFoodItemMutationFn = ApolloReactCommon.MutationFunction<AdminModifyFoodItemMutation, AdminModifyFoodItemMutationVariables>;
export type AdminModifyFoodItemComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminModifyFoodItemMutation, AdminModifyFoodItemMutationVariables>, 'mutation'>;

    export const AdminModifyFoodItemComponent = (props: AdminModifyFoodItemComponentProps) => (
      <ApolloReactComponents.Mutation<AdminModifyFoodItemMutation, AdminModifyFoodItemMutationVariables> mutation={AdminModifyFoodItemDocument} {...props} />
    );
    

/**
 * __useAdminModifyFoodItemMutation__
 *
 * To run a mutation, you first call `useAdminModifyFoodItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminModifyFoodItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminModifyFoodItemMutation, { data, loading, error }] = useAdminModifyFoodItemMutation({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *      changeset: // value for 'changeset'
 *      makeLive: // value for 'makeLive'
 *      autoApproveIfPossible: // value for 'autoApproveIfPossible'
 *   },
 * });
 */
export function useAdminModifyFoodItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminModifyFoodItemMutation, AdminModifyFoodItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminModifyFoodItemMutation, AdminModifyFoodItemMutationVariables>(AdminModifyFoodItemDocument, options);
      }
export type AdminModifyFoodItemMutationHookResult = ReturnType<typeof useAdminModifyFoodItemMutation>;
export type AdminModifyFoodItemMutationResult = ApolloReactCommon.MutationResult<AdminModifyFoodItemMutation>;
export type AdminModifyFoodItemMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminModifyFoodItemMutation, AdminModifyFoodItemMutationVariables>;
export const MakeFoodItemNotLiveDocument = gql`
    mutation MakeFoodItemNotLive($foodItemId: Int!) {
  makeFoodItemDraftStatus(foodItemId: $foodItemId)
}
    `;
export type MakeFoodItemNotLiveMutationFn = ApolloReactCommon.MutationFunction<MakeFoodItemNotLiveMutation, MakeFoodItemNotLiveMutationVariables>;
export type MakeFoodItemNotLiveComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MakeFoodItemNotLiveMutation, MakeFoodItemNotLiveMutationVariables>, 'mutation'>;

    export const MakeFoodItemNotLiveComponent = (props: MakeFoodItemNotLiveComponentProps) => (
      <ApolloReactComponents.Mutation<MakeFoodItemNotLiveMutation, MakeFoodItemNotLiveMutationVariables> mutation={MakeFoodItemNotLiveDocument} {...props} />
    );
    

/**
 * __useMakeFoodItemNotLiveMutation__
 *
 * To run a mutation, you first call `useMakeFoodItemNotLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeFoodItemNotLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeFoodItemNotLiveMutation, { data, loading, error }] = useMakeFoodItemNotLiveMutation({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *   },
 * });
 */
export function useMakeFoodItemNotLiveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MakeFoodItemNotLiveMutation, MakeFoodItemNotLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MakeFoodItemNotLiveMutation, MakeFoodItemNotLiveMutationVariables>(MakeFoodItemNotLiveDocument, options);
      }
export type MakeFoodItemNotLiveMutationHookResult = ReturnType<typeof useMakeFoodItemNotLiveMutation>;
export type MakeFoodItemNotLiveMutationResult = ApolloReactCommon.MutationResult<MakeFoodItemNotLiveMutation>;
export type MakeFoodItemNotLiveMutationOptions = ApolloReactCommon.BaseMutationOptions<MakeFoodItemNotLiveMutation, MakeFoodItemNotLiveMutationVariables>;
export const PriceBreakdownDocument = gql`
    query PriceBreakdown($shefId: String!) {
  shef(userId: $shefId) {
    id
    shefProfile {
      id
      platformPercent
      fulfillmentOption
    }
  }
}
    `;
export type PriceBreakdownComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PriceBreakdownQuery, PriceBreakdownQueryVariables>, 'query'> & ({ variables: PriceBreakdownQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PriceBreakdownComponent = (props: PriceBreakdownComponentProps) => (
      <ApolloReactComponents.Query<PriceBreakdownQuery, PriceBreakdownQueryVariables> query={PriceBreakdownDocument} {...props} />
    );
    

/**
 * __usePriceBreakdownQuery__
 *
 * To run a query within a React component, call `usePriceBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceBreakdownQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function usePriceBreakdownQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PriceBreakdownQuery, PriceBreakdownQueryVariables> & ({ variables: PriceBreakdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PriceBreakdownQuery, PriceBreakdownQueryVariables>(PriceBreakdownDocument, options);
      }
export function usePriceBreakdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PriceBreakdownQuery, PriceBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PriceBreakdownQuery, PriceBreakdownQueryVariables>(PriceBreakdownDocument, options);
        }
export function usePriceBreakdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PriceBreakdownQuery, PriceBreakdownQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PriceBreakdownQuery, PriceBreakdownQueryVariables>(PriceBreakdownDocument, options);
        }
export type PriceBreakdownQueryHookResult = ReturnType<typeof usePriceBreakdownQuery>;
export type PriceBreakdownLazyQueryHookResult = ReturnType<typeof usePriceBreakdownLazyQuery>;
export type PriceBreakdownSuspenseQueryHookResult = ReturnType<typeof usePriceBreakdownSuspenseQuery>;
export type PriceBreakdownQueryResult = ApolloReactCommon.QueryResult<PriceBreakdownQuery, PriceBreakdownQueryVariables>;
export const AdminAllChangeRequestsDocument = gql`
    query AdminAllChangeRequests($page: Int!, $filterUserType: ChangeRequestUserTypeFilter, $filterChangeType: ChangeRequestChangeTypeFilter, $filterPhotoStatus: ChangeRequestPhotoStatusFilter, $filterFoodType: ChangeRequestFoodTypeFilter, $filterShefType: ChangeRequestShefTypeFilter, $filterSearch: String) {
  foodItemChangeRequests(
    filterUserType: $filterUserType
    filterChangeType: $filterChangeType
    filterPhotoStatus: $filterPhotoStatus
    filterFoodType: $filterFoodType
    filterShefType: $filterShefType
    filterSearch: $filterSearch
    page: $page
  ) {
    pagination {
      ...PaginationFields
    }
    changeRequests {
      ...ViewChangeRequest
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${ViewChangeRequestFragmentDoc}`;
export type AdminAllChangeRequestsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminAllChangeRequestsQuery, AdminAllChangeRequestsQueryVariables>, 'query'> & ({ variables: AdminAllChangeRequestsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AdminAllChangeRequestsComponent = (props: AdminAllChangeRequestsComponentProps) => (
      <ApolloReactComponents.Query<AdminAllChangeRequestsQuery, AdminAllChangeRequestsQueryVariables> query={AdminAllChangeRequestsDocument} {...props} />
    );
    

/**
 * __useAdminAllChangeRequestsQuery__
 *
 * To run a query within a React component, call `useAdminAllChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAllChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAllChangeRequestsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filterUserType: // value for 'filterUserType'
 *      filterChangeType: // value for 'filterChangeType'
 *      filterPhotoStatus: // value for 'filterPhotoStatus'
 *      filterFoodType: // value for 'filterFoodType'
 *      filterShefType: // value for 'filterShefType'
 *      filterSearch: // value for 'filterSearch'
 *   },
 * });
 */
export function useAdminAllChangeRequestsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminAllChangeRequestsQuery, AdminAllChangeRequestsQueryVariables> & ({ variables: AdminAllChangeRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminAllChangeRequestsQuery, AdminAllChangeRequestsQueryVariables>(AdminAllChangeRequestsDocument, options);
      }
export function useAdminAllChangeRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminAllChangeRequestsQuery, AdminAllChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminAllChangeRequestsQuery, AdminAllChangeRequestsQueryVariables>(AdminAllChangeRequestsDocument, options);
        }
export function useAdminAllChangeRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminAllChangeRequestsQuery, AdminAllChangeRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminAllChangeRequestsQuery, AdminAllChangeRequestsQueryVariables>(AdminAllChangeRequestsDocument, options);
        }
export type AdminAllChangeRequestsQueryHookResult = ReturnType<typeof useAdminAllChangeRequestsQuery>;
export type AdminAllChangeRequestsLazyQueryHookResult = ReturnType<typeof useAdminAllChangeRequestsLazyQuery>;
export type AdminAllChangeRequestsSuspenseQueryHookResult = ReturnType<typeof useAdminAllChangeRequestsSuspenseQuery>;
export type AdminAllChangeRequestsQueryResult = ApolloReactCommon.QueryResult<AdminAllChangeRequestsQuery, AdminAllChangeRequestsQueryVariables>;
export const AdminApproveChangeRequestDocument = gql`
    mutation AdminApproveChangeRequest($foodItemChangeRequestId: Int!, $changeset: FoodItemChangesetInput, $comment: String!) {
  updateFoodItemChangeRequest(
    foodItemChangeRequestId: $foodItemChangeRequestId
    changeset: $changeset
    comment: $comment
    status: CLOSED_APPROVED_MANUAL
  ) {
    id
    status
  }
}
    `;
export type AdminApproveChangeRequestMutationFn = ApolloReactCommon.MutationFunction<AdminApproveChangeRequestMutation, AdminApproveChangeRequestMutationVariables>;
export type AdminApproveChangeRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminApproveChangeRequestMutation, AdminApproveChangeRequestMutationVariables>, 'mutation'>;

    export const AdminApproveChangeRequestComponent = (props: AdminApproveChangeRequestComponentProps) => (
      <ApolloReactComponents.Mutation<AdminApproveChangeRequestMutation, AdminApproveChangeRequestMutationVariables> mutation={AdminApproveChangeRequestDocument} {...props} />
    );
    

/**
 * __useAdminApproveChangeRequestMutation__
 *
 * To run a mutation, you first call `useAdminApproveChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminApproveChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminApproveChangeRequestMutation, { data, loading, error }] = useAdminApproveChangeRequestMutation({
 *   variables: {
 *      foodItemChangeRequestId: // value for 'foodItemChangeRequestId'
 *      changeset: // value for 'changeset'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAdminApproveChangeRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminApproveChangeRequestMutation, AdminApproveChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminApproveChangeRequestMutation, AdminApproveChangeRequestMutationVariables>(AdminApproveChangeRequestDocument, options);
      }
export type AdminApproveChangeRequestMutationHookResult = ReturnType<typeof useAdminApproveChangeRequestMutation>;
export type AdminApproveChangeRequestMutationResult = ApolloReactCommon.MutationResult<AdminApproveChangeRequestMutation>;
export type AdminApproveChangeRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminApproveChangeRequestMutation, AdminApproveChangeRequestMutationVariables>;
export const AdminRejectChangeRequestDocument = gql`
    mutation AdminRejectChangeRequest($foodItemChangeRequestId: Int!, $changeset: FoodItemChangesetInput, $comment: String!) {
  updateFoodItemChangeRequest(
    foodItemChangeRequestId: $foodItemChangeRequestId
    changeset: $changeset
    comment: $comment
    status: CLOSED_REJECTED
  ) {
    id
    status
  }
}
    `;
export type AdminRejectChangeRequestMutationFn = ApolloReactCommon.MutationFunction<AdminRejectChangeRequestMutation, AdminRejectChangeRequestMutationVariables>;
export type AdminRejectChangeRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminRejectChangeRequestMutation, AdminRejectChangeRequestMutationVariables>, 'mutation'>;

    export const AdminRejectChangeRequestComponent = (props: AdminRejectChangeRequestComponentProps) => (
      <ApolloReactComponents.Mutation<AdminRejectChangeRequestMutation, AdminRejectChangeRequestMutationVariables> mutation={AdminRejectChangeRequestDocument} {...props} />
    );
    

/**
 * __useAdminRejectChangeRequestMutation__
 *
 * To run a mutation, you first call `useAdminRejectChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRejectChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRejectChangeRequestMutation, { data, loading, error }] = useAdminRejectChangeRequestMutation({
 *   variables: {
 *      foodItemChangeRequestId: // value for 'foodItemChangeRequestId'
 *      changeset: // value for 'changeset'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAdminRejectChangeRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRejectChangeRequestMutation, AdminRejectChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRejectChangeRequestMutation, AdminRejectChangeRequestMutationVariables>(AdminRejectChangeRequestDocument, options);
      }
export type AdminRejectChangeRequestMutationHookResult = ReturnType<typeof useAdminRejectChangeRequestMutation>;
export type AdminRejectChangeRequestMutationResult = ApolloReactCommon.MutationResult<AdminRejectChangeRequestMutation>;
export type AdminRejectChangeRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminRejectChangeRequestMutation, AdminRejectChangeRequestMutationVariables>;
export const AdminBulkUpdatePhotoEditingStatusDocument = gql`
    mutation AdminBulkUpdatePhotoEditingStatus($foodItemChangeRequestIds: [Int!]!, $status: RequestStatus, $comment: String) {
  adminBulkUpdateFoodItemChangeRequests(
    foodItemChangeRequestIds: $foodItemChangeRequestIds
    status: $status
    comment: $comment
  ) {
    id
    status
  }
}
    `;
export type AdminBulkUpdatePhotoEditingStatusMutationFn = ApolloReactCommon.MutationFunction<AdminBulkUpdatePhotoEditingStatusMutation, AdminBulkUpdatePhotoEditingStatusMutationVariables>;
export type AdminBulkUpdatePhotoEditingStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminBulkUpdatePhotoEditingStatusMutation, AdminBulkUpdatePhotoEditingStatusMutationVariables>, 'mutation'>;

    export const AdminBulkUpdatePhotoEditingStatusComponent = (props: AdminBulkUpdatePhotoEditingStatusComponentProps) => (
      <ApolloReactComponents.Mutation<AdminBulkUpdatePhotoEditingStatusMutation, AdminBulkUpdatePhotoEditingStatusMutationVariables> mutation={AdminBulkUpdatePhotoEditingStatusDocument} {...props} />
    );
    

/**
 * __useAdminBulkUpdatePhotoEditingStatusMutation__
 *
 * To run a mutation, you first call `useAdminBulkUpdatePhotoEditingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBulkUpdatePhotoEditingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBulkUpdatePhotoEditingStatusMutation, { data, loading, error }] = useAdminBulkUpdatePhotoEditingStatusMutation({
 *   variables: {
 *      foodItemChangeRequestIds: // value for 'foodItemChangeRequestIds'
 *      status: // value for 'status'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAdminBulkUpdatePhotoEditingStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminBulkUpdatePhotoEditingStatusMutation, AdminBulkUpdatePhotoEditingStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminBulkUpdatePhotoEditingStatusMutation, AdminBulkUpdatePhotoEditingStatusMutationVariables>(AdminBulkUpdatePhotoEditingStatusDocument, options);
      }
export type AdminBulkUpdatePhotoEditingStatusMutationHookResult = ReturnType<typeof useAdminBulkUpdatePhotoEditingStatusMutation>;
export type AdminBulkUpdatePhotoEditingStatusMutationResult = ApolloReactCommon.MutationResult<AdminBulkUpdatePhotoEditingStatusMutation>;
export type AdminBulkUpdatePhotoEditingStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminBulkUpdatePhotoEditingStatusMutation, AdminBulkUpdatePhotoEditingStatusMutationVariables>;
export const AdminUpdatePhotoEditingStatusDocument = gql`
    mutation AdminUpdatePhotoEditingStatus($foodItemChangeRequestId: Int!, $status: RequestStatus, $notes: String) {
  updateFoodItemChangeRequest(
    foodItemChangeRequestId: $foodItemChangeRequestId
    status: $status
    photoEditRequestNotes: $notes
  ) {
    id
    status
  }
}
    `;
export type AdminUpdatePhotoEditingStatusMutationFn = ApolloReactCommon.MutationFunction<AdminUpdatePhotoEditingStatusMutation, AdminUpdatePhotoEditingStatusMutationVariables>;
export type AdminUpdatePhotoEditingStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminUpdatePhotoEditingStatusMutation, AdminUpdatePhotoEditingStatusMutationVariables>, 'mutation'>;

    export const AdminUpdatePhotoEditingStatusComponent = (props: AdminUpdatePhotoEditingStatusComponentProps) => (
      <ApolloReactComponents.Mutation<AdminUpdatePhotoEditingStatusMutation, AdminUpdatePhotoEditingStatusMutationVariables> mutation={AdminUpdatePhotoEditingStatusDocument} {...props} />
    );
    

/**
 * __useAdminUpdatePhotoEditingStatusMutation__
 *
 * To run a mutation, you first call `useAdminUpdatePhotoEditingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePhotoEditingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePhotoEditingStatusMutation, { data, loading, error }] = useAdminUpdatePhotoEditingStatusMutation({
 *   variables: {
 *      foodItemChangeRequestId: // value for 'foodItemChangeRequestId'
 *      status: // value for 'status'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useAdminUpdatePhotoEditingStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdatePhotoEditingStatusMutation, AdminUpdatePhotoEditingStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdatePhotoEditingStatusMutation, AdminUpdatePhotoEditingStatusMutationVariables>(AdminUpdatePhotoEditingStatusDocument, options);
      }
export type AdminUpdatePhotoEditingStatusMutationHookResult = ReturnType<typeof useAdminUpdatePhotoEditingStatusMutation>;
export type AdminUpdatePhotoEditingStatusMutationResult = ApolloReactCommon.MutationResult<AdminUpdatePhotoEditingStatusMutation>;
export type AdminUpdatePhotoEditingStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminUpdatePhotoEditingStatusMutation, AdminUpdatePhotoEditingStatusMutationVariables>;
export const FoodItemQueryDocument = gql`
    query FoodItemQuery($foodItemId: Int!) {
  foodItem(foodItemId: $foodItemId) {
    ...EditableFoodItem
    user {
      id
      publicName
      fullName
      shefProfile {
        id
        cuisineRegion
        cuisineCategoryIds
        primaryRegion {
          id
        }
      }
    }
  }
  foodItemCustomizationTypes {
    ...FoodItemCustomizationTypeFields
  }
}
    ${EditableFoodItemFragmentDoc}
${FoodItemCustomizationTypeFieldsFragmentDoc}`;
export type FoodItemQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FoodItemQueryQuery, FoodItemQueryQueryVariables>, 'query'> & ({ variables: FoodItemQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FoodItemQueryComponent = (props: FoodItemQueryComponentProps) => (
      <ApolloReactComponents.Query<FoodItemQueryQuery, FoodItemQueryQueryVariables> query={FoodItemQueryDocument} {...props} />
    );
    

/**
 * __useFoodItemQueryQuery__
 *
 * To run a query within a React component, call `useFoodItemQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodItemQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodItemQueryQuery({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *   },
 * });
 */
export function useFoodItemQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FoodItemQueryQuery, FoodItemQueryQueryVariables> & ({ variables: FoodItemQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FoodItemQueryQuery, FoodItemQueryQueryVariables>(FoodItemQueryDocument, options);
      }
export function useFoodItemQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FoodItemQueryQuery, FoodItemQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FoodItemQueryQuery, FoodItemQueryQueryVariables>(FoodItemQueryDocument, options);
        }
export function useFoodItemQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FoodItemQueryQuery, FoodItemQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FoodItemQueryQuery, FoodItemQueryQueryVariables>(FoodItemQueryDocument, options);
        }
export type FoodItemQueryQueryHookResult = ReturnType<typeof useFoodItemQueryQuery>;
export type FoodItemQueryLazyQueryHookResult = ReturnType<typeof useFoodItemQueryLazyQuery>;
export type FoodItemQuerySuspenseQueryHookResult = ReturnType<typeof useFoodItemQuerySuspenseQuery>;
export type FoodItemQueryQueryResult = ApolloReactCommon.QueryResult<FoodItemQueryQuery, FoodItemQueryQueryVariables>;
export const PhotoEditDocument = gql`
    query PhotoEdit {
  dishwasherApiUrl: getConfigValue(name: DISHWASHER_API_URL)
}
    `;
export type PhotoEditComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PhotoEditQuery, PhotoEditQueryVariables>, 'query'>;

    export const PhotoEditComponent = (props: PhotoEditComponentProps) => (
      <ApolloReactComponents.Query<PhotoEditQuery, PhotoEditQueryVariables> query={PhotoEditDocument} {...props} />
    );
    

/**
 * __usePhotoEditQuery__
 *
 * To run a query within a React component, call `usePhotoEditQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoEditQuery({
 *   variables: {
 *   },
 * });
 */
export function usePhotoEditQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PhotoEditQuery, PhotoEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PhotoEditQuery, PhotoEditQueryVariables>(PhotoEditDocument, options);
      }
export function usePhotoEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhotoEditQuery, PhotoEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PhotoEditQuery, PhotoEditQueryVariables>(PhotoEditDocument, options);
        }
export function usePhotoEditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PhotoEditQuery, PhotoEditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PhotoEditQuery, PhotoEditQueryVariables>(PhotoEditDocument, options);
        }
export type PhotoEditQueryHookResult = ReturnType<typeof usePhotoEditQuery>;
export type PhotoEditLazyQueryHookResult = ReturnType<typeof usePhotoEditLazyQuery>;
export type PhotoEditSuspenseQueryHookResult = ReturnType<typeof usePhotoEditSuspenseQuery>;
export type PhotoEditQueryResult = ApolloReactCommon.QueryResult<PhotoEditQuery, PhotoEditQueryVariables>;
export const DeleteFoodItemDocument = gql`
    mutation deleteFoodItem($foodItemId: Int!) {
  deleteFoodItem(foodItemId: $foodItemId)
}
    `;
export type DeleteFoodItemMutationFn = ApolloReactCommon.MutationFunction<DeleteFoodItemMutation, DeleteFoodItemMutationVariables>;
export type DeleteFoodItemComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteFoodItemMutation, DeleteFoodItemMutationVariables>, 'mutation'>;

    export const DeleteFoodItemComponent = (props: DeleteFoodItemComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteFoodItemMutation, DeleteFoodItemMutationVariables> mutation={DeleteFoodItemDocument} {...props} />
    );
    

/**
 * __useDeleteFoodItemMutation__
 *
 * To run a mutation, you first call `useDeleteFoodItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFoodItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFoodItemMutation, { data, loading, error }] = useDeleteFoodItemMutation({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *   },
 * });
 */
export function useDeleteFoodItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFoodItemMutation, DeleteFoodItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFoodItemMutation, DeleteFoodItemMutationVariables>(DeleteFoodItemDocument, options);
      }
export type DeleteFoodItemMutationHookResult = ReturnType<typeof useDeleteFoodItemMutation>;
export type DeleteFoodItemMutationResult = ApolloReactCommon.MutationResult<DeleteFoodItemMutation>;
export type DeleteFoodItemMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFoodItemMutation, DeleteFoodItemMutationVariables>;
export const ChangeRequestDocument = gql`
    query ChangeRequest($id: Int!) {
  me {
    ...CurrentUserFields
  }
  foodItemChangeRequest(id: $id) {
    ...ChangeRequestView
    ...ChangeRequestCommentThread
  }
  photoEditRequest(changeRequestId: $id) {
    id
    editedImageUrl
    editorUserId
  }
  foodItemCustomizationTypes {
    ...FoodItemCustomizationTypeFields
  }
}
    ${CurrentUserFieldsFragmentDoc}
${ChangeRequestViewFragmentDoc}
${ChangeRequestCommentThreadFragmentDoc}
${FoodItemCustomizationTypeFieldsFragmentDoc}`;
export type ChangeRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ChangeRequestQuery, ChangeRequestQueryVariables>, 'query'> & ({ variables: ChangeRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ChangeRequestComponent = (props: ChangeRequestComponentProps) => (
      <ApolloReactComponents.Query<ChangeRequestQuery, ChangeRequestQueryVariables> query={ChangeRequestDocument} {...props} />
    );
    

/**
 * __useChangeRequestQuery__
 *
 * To run a query within a React component, call `useChangeRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeRequestQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChangeRequestQuery, ChangeRequestQueryVariables> & ({ variables: ChangeRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeRequestQuery, ChangeRequestQueryVariables>(ChangeRequestDocument, options);
      }
export function useChangeRequestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeRequestQuery, ChangeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeRequestQuery, ChangeRequestQueryVariables>(ChangeRequestDocument, options);
        }
export function useChangeRequestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeRequestQuery, ChangeRequestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeRequestQuery, ChangeRequestQueryVariables>(ChangeRequestDocument, options);
        }
export type ChangeRequestQueryHookResult = ReturnType<typeof useChangeRequestQuery>;
export type ChangeRequestLazyQueryHookResult = ReturnType<typeof useChangeRequestLazyQuery>;
export type ChangeRequestSuspenseQueryHookResult = ReturnType<typeof useChangeRequestSuspenseQuery>;
export type ChangeRequestQueryResult = ApolloReactCommon.QueryResult<ChangeRequestQuery, ChangeRequestQueryVariables>;
export const UpdateChangeRequestDocument = gql`
    mutation UpdateChangeRequest($foodItemChangeRequestId: Int!, $changeset: FoodItemChangesetInput, $comment: String!, $autoApproveIfPossible: Boolean) {
  updateFoodItemChangeRequest(
    foodItemChangeRequestId: $foodItemChangeRequestId
    changeset: $changeset
    comment: $comment
    autoApproveIfPossible: $autoApproveIfPossible
  ) {
    id
    status
  }
}
    `;
export type UpdateChangeRequestMutationFn = ApolloReactCommon.MutationFunction<UpdateChangeRequestMutation, UpdateChangeRequestMutationVariables>;
export type UpdateChangeRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateChangeRequestMutation, UpdateChangeRequestMutationVariables>, 'mutation'>;

    export const UpdateChangeRequestComponent = (props: UpdateChangeRequestComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateChangeRequestMutation, UpdateChangeRequestMutationVariables> mutation={UpdateChangeRequestDocument} {...props} />
    );
    

/**
 * __useUpdateChangeRequestMutation__
 *
 * To run a mutation, you first call `useUpdateChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChangeRequestMutation, { data, loading, error }] = useUpdateChangeRequestMutation({
 *   variables: {
 *      foodItemChangeRequestId: // value for 'foodItemChangeRequestId'
 *      changeset: // value for 'changeset'
 *      comment: // value for 'comment'
 *      autoApproveIfPossible: // value for 'autoApproveIfPossible'
 *   },
 * });
 */
export function useUpdateChangeRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChangeRequestMutation, UpdateChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChangeRequestMutation, UpdateChangeRequestMutationVariables>(UpdateChangeRequestDocument, options);
      }
export type UpdateChangeRequestMutationHookResult = ReturnType<typeof useUpdateChangeRequestMutation>;
export type UpdateChangeRequestMutationResult = ApolloReactCommon.MutationResult<UpdateChangeRequestMutation>;
export type UpdateChangeRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChangeRequestMutation, UpdateChangeRequestMutationVariables>;
export const CustomizationTypesDocument = gql`
    query CustomizationTypes {
  foodItemCustomizationTypes {
    category
    id
    name
  }
}
    `;
export type CustomizationTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CustomizationTypesQuery, CustomizationTypesQueryVariables>, 'query'>;

    export const CustomizationTypesComponent = (props: CustomizationTypesComponentProps) => (
      <ApolloReactComponents.Query<CustomizationTypesQuery, CustomizationTypesQueryVariables> query={CustomizationTypesDocument} {...props} />
    );
    

/**
 * __useCustomizationTypesQuery__
 *
 * To run a query within a React component, call `useCustomizationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomizationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomizationTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomizationTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CustomizationTypesQuery, CustomizationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomizationTypesQuery, CustomizationTypesQueryVariables>(CustomizationTypesDocument, options);
      }
export function useCustomizationTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomizationTypesQuery, CustomizationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomizationTypesQuery, CustomizationTypesQueryVariables>(CustomizationTypesDocument, options);
        }
export function useCustomizationTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomizationTypesQuery, CustomizationTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CustomizationTypesQuery, CustomizationTypesQueryVariables>(CustomizationTypesDocument, options);
        }
export type CustomizationTypesQueryHookResult = ReturnType<typeof useCustomizationTypesQuery>;
export type CustomizationTypesLazyQueryHookResult = ReturnType<typeof useCustomizationTypesLazyQuery>;
export type CustomizationTypesSuspenseQueryHookResult = ReturnType<typeof useCustomizationTypesSuspenseQuery>;
export type CustomizationTypesQueryResult = ApolloReactCommon.QueryResult<CustomizationTypesQuery, CustomizationTypesQueryVariables>;
export const CuisineCategoriesDocument = gql`
    query CuisineCategories($shefId: String!) {
  shefProfile(userId: $shefId) {
    id
    shef {
      id
      activeFoodItems {
        id
        imageUrl
        name
        foodType
        pairings {
          id
        }
      }
    }
  }
  cuisineCategories {
    id
    title
    type
  }
}
    `;
export type CuisineCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CuisineCategoriesQuery, CuisineCategoriesQueryVariables>, 'query'> & ({ variables: CuisineCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CuisineCategoriesComponent = (props: CuisineCategoriesComponentProps) => (
      <ApolloReactComponents.Query<CuisineCategoriesQuery, CuisineCategoriesQueryVariables> query={CuisineCategoriesDocument} {...props} />
    );
    

/**
 * __useCuisineCategoriesQuery__
 *
 * To run a query within a React component, call `useCuisineCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCuisineCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCuisineCategoriesQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useCuisineCategoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CuisineCategoriesQuery, CuisineCategoriesQueryVariables> & ({ variables: CuisineCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CuisineCategoriesQuery, CuisineCategoriesQueryVariables>(CuisineCategoriesDocument, options);
      }
export function useCuisineCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CuisineCategoriesQuery, CuisineCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CuisineCategoriesQuery, CuisineCategoriesQueryVariables>(CuisineCategoriesDocument, options);
        }
export function useCuisineCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CuisineCategoriesQuery, CuisineCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CuisineCategoriesQuery, CuisineCategoriesQueryVariables>(CuisineCategoriesDocument, options);
        }
export type CuisineCategoriesQueryHookResult = ReturnType<typeof useCuisineCategoriesQuery>;
export type CuisineCategoriesLazyQueryHookResult = ReturnType<typeof useCuisineCategoriesLazyQuery>;
export type CuisineCategoriesSuspenseQueryHookResult = ReturnType<typeof useCuisineCategoriesSuspenseQuery>;
export type CuisineCategoriesQueryResult = ApolloReactCommon.QueryResult<CuisineCategoriesQuery, CuisineCategoriesQueryVariables>;
export const DietaryAnalysisDocument = gql`
    query DietaryAnalysis($ingredients: String!) {
  dietaryAnalysis(ingredients: $ingredients) {
    vegan
    vegetarian
    paleo
    lowFodmap
    whole30
    glutenFree
    dairyFree
    containsNuts
  }
}
    `;
export type DietaryAnalysisComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DietaryAnalysisQuery, DietaryAnalysisQueryVariables>, 'query'> & ({ variables: DietaryAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DietaryAnalysisComponent = (props: DietaryAnalysisComponentProps) => (
      <ApolloReactComponents.Query<DietaryAnalysisQuery, DietaryAnalysisQueryVariables> query={DietaryAnalysisDocument} {...props} />
    );
    

/**
 * __useDietaryAnalysisQuery__
 *
 * To run a query within a React component, call `useDietaryAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useDietaryAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDietaryAnalysisQuery({
 *   variables: {
 *      ingredients: // value for 'ingredients'
 *   },
 * });
 */
export function useDietaryAnalysisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DietaryAnalysisQuery, DietaryAnalysisQueryVariables> & ({ variables: DietaryAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DietaryAnalysisQuery, DietaryAnalysisQueryVariables>(DietaryAnalysisDocument, options);
      }
export function useDietaryAnalysisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DietaryAnalysisQuery, DietaryAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DietaryAnalysisQuery, DietaryAnalysisQueryVariables>(DietaryAnalysisDocument, options);
        }
export function useDietaryAnalysisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DietaryAnalysisQuery, DietaryAnalysisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DietaryAnalysisQuery, DietaryAnalysisQueryVariables>(DietaryAnalysisDocument, options);
        }
export type DietaryAnalysisQueryHookResult = ReturnType<typeof useDietaryAnalysisQuery>;
export type DietaryAnalysisLazyQueryHookResult = ReturnType<typeof useDietaryAnalysisLazyQuery>;
export type DietaryAnalysisSuspenseQueryHookResult = ReturnType<typeof useDietaryAnalysisSuspenseQuery>;
export type DietaryAnalysisQueryResult = ApolloReactCommon.QueryResult<DietaryAnalysisQuery, DietaryAnalysisQueryVariables>;
export const PriceRecommendationDocument = gql`
    query PriceRecommendation($foodItemInput: FoodItemPriceRecommendationInput!) {
  foodItemPriceRecommendations(foodItemInput: $foodItemInput) {
    recommendedPrice
    lowerPriceRange
    upperPriceRange
  }
}
    `;
export type PriceRecommendationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PriceRecommendationQuery, PriceRecommendationQueryVariables>, 'query'> & ({ variables: PriceRecommendationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PriceRecommendationComponent = (props: PriceRecommendationComponentProps) => (
      <ApolloReactComponents.Query<PriceRecommendationQuery, PriceRecommendationQueryVariables> query={PriceRecommendationDocument} {...props} />
    );
    

/**
 * __usePriceRecommendationQuery__
 *
 * To run a query within a React component, call `usePriceRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceRecommendationQuery({
 *   variables: {
 *      foodItemInput: // value for 'foodItemInput'
 *   },
 * });
 */
export function usePriceRecommendationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PriceRecommendationQuery, PriceRecommendationQueryVariables> & ({ variables: PriceRecommendationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PriceRecommendationQuery, PriceRecommendationQueryVariables>(PriceRecommendationDocument, options);
      }
export function usePriceRecommendationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PriceRecommendationQuery, PriceRecommendationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PriceRecommendationQuery, PriceRecommendationQueryVariables>(PriceRecommendationDocument, options);
        }
export function usePriceRecommendationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PriceRecommendationQuery, PriceRecommendationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PriceRecommendationQuery, PriceRecommendationQueryVariables>(PriceRecommendationDocument, options);
        }
export type PriceRecommendationQueryHookResult = ReturnType<typeof usePriceRecommendationQuery>;
export type PriceRecommendationLazyQueryHookResult = ReturnType<typeof usePriceRecommendationLazyQuery>;
export type PriceRecommendationSuspenseQueryHookResult = ReturnType<typeof usePriceRecommendationSuspenseQuery>;
export type PriceRecommendationQueryResult = ApolloReactCommon.QueryResult<PriceRecommendationQuery, PriceRecommendationQueryVariables>;
export const GetPrefabFoodItemDocument = gql`
    query GetPrefabFoodItem($foodItemId: Int!) {
  foodItem(foodItemId: $foodItemId) {
    ...EditableFoodItem
  }
}
    ${EditableFoodItemFragmentDoc}`;
export type GetPrefabFoodItemComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPrefabFoodItemQuery, GetPrefabFoodItemQueryVariables>, 'query'> & ({ variables: GetPrefabFoodItemQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPrefabFoodItemComponent = (props: GetPrefabFoodItemComponentProps) => (
      <ApolloReactComponents.Query<GetPrefabFoodItemQuery, GetPrefabFoodItemQueryVariables> query={GetPrefabFoodItemDocument} {...props} />
    );
    

/**
 * __useGetPrefabFoodItemQuery__
 *
 * To run a query within a React component, call `useGetPrefabFoodItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrefabFoodItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrefabFoodItemQuery({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *   },
 * });
 */
export function useGetPrefabFoodItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPrefabFoodItemQuery, GetPrefabFoodItemQueryVariables> & ({ variables: GetPrefabFoodItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPrefabFoodItemQuery, GetPrefabFoodItemQueryVariables>(GetPrefabFoodItemDocument, options);
      }
export function useGetPrefabFoodItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPrefabFoodItemQuery, GetPrefabFoodItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPrefabFoodItemQuery, GetPrefabFoodItemQueryVariables>(GetPrefabFoodItemDocument, options);
        }
export function useGetPrefabFoodItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPrefabFoodItemQuery, GetPrefabFoodItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPrefabFoodItemQuery, GetPrefabFoodItemQueryVariables>(GetPrefabFoodItemDocument, options);
        }
export type GetPrefabFoodItemQueryHookResult = ReturnType<typeof useGetPrefabFoodItemQuery>;
export type GetPrefabFoodItemLazyQueryHookResult = ReturnType<typeof useGetPrefabFoodItemLazyQuery>;
export type GetPrefabFoodItemSuspenseQueryHookResult = ReturnType<typeof useGetPrefabFoodItemSuspenseQuery>;
export type GetPrefabFoodItemQueryResult = ApolloReactCommon.QueryResult<GetPrefabFoodItemQuery, GetPrefabFoodItemQueryVariables>;
export const FoodItemSuggestionsDocument = gql`
    query FoodItemSuggestions($shefId: String!, $limit: Int) {
  foodItemSuggestions(shefId: $shefId, limit: $limit) {
    ...EditableFoodItem
  }
}
    ${EditableFoodItemFragmentDoc}`;
export type FoodItemSuggestionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FoodItemSuggestionsQuery, FoodItemSuggestionsQueryVariables>, 'query'> & ({ variables: FoodItemSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FoodItemSuggestionsComponent = (props: FoodItemSuggestionsComponentProps) => (
      <ApolloReactComponents.Query<FoodItemSuggestionsQuery, FoodItemSuggestionsQueryVariables> query={FoodItemSuggestionsDocument} {...props} />
    );
    

/**
 * __useFoodItemSuggestionsQuery__
 *
 * To run a query within a React component, call `useFoodItemSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodItemSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodItemSuggestionsQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFoodItemSuggestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FoodItemSuggestionsQuery, FoodItemSuggestionsQueryVariables> & ({ variables: FoodItemSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FoodItemSuggestionsQuery, FoodItemSuggestionsQueryVariables>(FoodItemSuggestionsDocument, options);
      }
export function useFoodItemSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FoodItemSuggestionsQuery, FoodItemSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FoodItemSuggestionsQuery, FoodItemSuggestionsQueryVariables>(FoodItemSuggestionsDocument, options);
        }
export function useFoodItemSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FoodItemSuggestionsQuery, FoodItemSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FoodItemSuggestionsQuery, FoodItemSuggestionsQueryVariables>(FoodItemSuggestionsDocument, options);
        }
export type FoodItemSuggestionsQueryHookResult = ReturnType<typeof useFoodItemSuggestionsQuery>;
export type FoodItemSuggestionsLazyQueryHookResult = ReturnType<typeof useFoodItemSuggestionsLazyQuery>;
export type FoodItemSuggestionsSuspenseQueryHookResult = ReturnType<typeof useFoodItemSuggestionsSuspenseQuery>;
export type FoodItemSuggestionsQueryResult = ApolloReactCommon.QueryResult<FoodItemSuggestionsQuery, FoodItemSuggestionsQueryVariables>;
export const FoodItemEditNewDocument = gql`
    query FoodItemEditNew($foodItemId: Int!) {
  foodItem(foodItemId: $foodItemId) {
    slug
    hasUnreadComments
    ...EditableFoodItem
    mostRecentOpenChangeRequest {
      ...ChangeRequestView
      ...ChangeRequestCommentThread
    }
    user {
      id
      shefProfile {
        id
        cuisineRegion
        cuisineCategoryIds
        primaryRegion {
          id
        }
      }
    }
  }
  foodItemCustomizationTypes {
    ...FoodItemCustomizationTypeFields
  }
}
    ${EditableFoodItemFragmentDoc}
${ChangeRequestViewFragmentDoc}
${ChangeRequestCommentThreadFragmentDoc}
${FoodItemCustomizationTypeFieldsFragmentDoc}`;
export type FoodItemEditNewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FoodItemEditNewQuery, FoodItemEditNewQueryVariables>, 'query'> & ({ variables: FoodItemEditNewQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FoodItemEditNewComponent = (props: FoodItemEditNewComponentProps) => (
      <ApolloReactComponents.Query<FoodItemEditNewQuery, FoodItemEditNewQueryVariables> query={FoodItemEditNewDocument} {...props} />
    );
    

/**
 * __useFoodItemEditNewQuery__
 *
 * To run a query within a React component, call `useFoodItemEditNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodItemEditNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodItemEditNewQuery({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *   },
 * });
 */
export function useFoodItemEditNewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FoodItemEditNewQuery, FoodItemEditNewQueryVariables> & ({ variables: FoodItemEditNewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FoodItemEditNewQuery, FoodItemEditNewQueryVariables>(FoodItemEditNewDocument, options);
      }
export function useFoodItemEditNewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FoodItemEditNewQuery, FoodItemEditNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FoodItemEditNewQuery, FoodItemEditNewQueryVariables>(FoodItemEditNewDocument, options);
        }
export function useFoodItemEditNewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FoodItemEditNewQuery, FoodItemEditNewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FoodItemEditNewQuery, FoodItemEditNewQueryVariables>(FoodItemEditNewDocument, options);
        }
export type FoodItemEditNewQueryHookResult = ReturnType<typeof useFoodItemEditNewQuery>;
export type FoodItemEditNewLazyQueryHookResult = ReturnType<typeof useFoodItemEditNewLazyQuery>;
export type FoodItemEditNewSuspenseQueryHookResult = ReturnType<typeof useFoodItemEditNewSuspenseQuery>;
export type FoodItemEditNewQueryResult = ApolloReactCommon.QueryResult<FoodItemEditNewQuery, FoodItemEditNewQueryVariables>;
export const ShefCreateChangeRequestDocument = gql`
    mutation ShefCreateChangeRequest($foodItemId: Int!, $changeset: FoodItemChangesetInput!, $comment: String) {
  createFoodItemChangeRequest(
    foodItemId: $foodItemId
    changeset: $changeset
    comment: $comment
    autoApproveIfPossible: true
    makeLive: true
  ) {
    id
    status
  }
}
    `;
export type ShefCreateChangeRequestMutationFn = ApolloReactCommon.MutationFunction<ShefCreateChangeRequestMutation, ShefCreateChangeRequestMutationVariables>;
export type ShefCreateChangeRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShefCreateChangeRequestMutation, ShefCreateChangeRequestMutationVariables>, 'mutation'>;

    export const ShefCreateChangeRequestComponent = (props: ShefCreateChangeRequestComponentProps) => (
      <ApolloReactComponents.Mutation<ShefCreateChangeRequestMutation, ShefCreateChangeRequestMutationVariables> mutation={ShefCreateChangeRequestDocument} {...props} />
    );
    

/**
 * __useShefCreateChangeRequestMutation__
 *
 * To run a mutation, you first call `useShefCreateChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShefCreateChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shefCreateChangeRequestMutation, { data, loading, error }] = useShefCreateChangeRequestMutation({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *      changeset: // value for 'changeset'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useShefCreateChangeRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShefCreateChangeRequestMutation, ShefCreateChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShefCreateChangeRequestMutation, ShefCreateChangeRequestMutationVariables>(ShefCreateChangeRequestDocument, options);
      }
export type ShefCreateChangeRequestMutationHookResult = ReturnType<typeof useShefCreateChangeRequestMutation>;
export type ShefCreateChangeRequestMutationResult = ApolloReactCommon.MutationResult<ShefCreateChangeRequestMutation>;
export type ShefCreateChangeRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<ShefCreateChangeRequestMutation, ShefCreateChangeRequestMutationVariables>;
export const ShefUpdateChangeRequestDocument = gql`
    mutation ShefUpdateChangeRequest($foodItemChangeRequestId: Int!, $changeset: FoodItemChangesetInput, $comment: String) {
  updateFoodItemChangeRequest(
    foodItemChangeRequestId: $foodItemChangeRequestId
    changeset: $changeset
    comment: $comment
  ) {
    id
    status
  }
}
    `;
export type ShefUpdateChangeRequestMutationFn = ApolloReactCommon.MutationFunction<ShefUpdateChangeRequestMutation, ShefUpdateChangeRequestMutationVariables>;
export type ShefUpdateChangeRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShefUpdateChangeRequestMutation, ShefUpdateChangeRequestMutationVariables>, 'mutation'>;

    export const ShefUpdateChangeRequestComponent = (props: ShefUpdateChangeRequestComponentProps) => (
      <ApolloReactComponents.Mutation<ShefUpdateChangeRequestMutation, ShefUpdateChangeRequestMutationVariables> mutation={ShefUpdateChangeRequestDocument} {...props} />
    );
    

/**
 * __useShefUpdateChangeRequestMutation__
 *
 * To run a mutation, you first call `useShefUpdateChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShefUpdateChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shefUpdateChangeRequestMutation, { data, loading, error }] = useShefUpdateChangeRequestMutation({
 *   variables: {
 *      foodItemChangeRequestId: // value for 'foodItemChangeRequestId'
 *      changeset: // value for 'changeset'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useShefUpdateChangeRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShefUpdateChangeRequestMutation, ShefUpdateChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShefUpdateChangeRequestMutation, ShefUpdateChangeRequestMutationVariables>(ShefUpdateChangeRequestDocument, options);
      }
export type ShefUpdateChangeRequestMutationHookResult = ReturnType<typeof useShefUpdateChangeRequestMutation>;
export type ShefUpdateChangeRequestMutationResult = ApolloReactCommon.MutationResult<ShefUpdateChangeRequestMutation>;
export type ShefUpdateChangeRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<ShefUpdateChangeRequestMutation, ShefUpdateChangeRequestMutationVariables>;
export const ShefAbandonChangeRequestDocument = gql`
    mutation ShefAbandonChangeRequest($foodItemChangeRequestId: Int!, $changeset: FoodItemChangesetInput, $comment: String) {
  updateFoodItemChangeRequest(
    foodItemChangeRequestId: $foodItemChangeRequestId
    changeset: $changeset
    comment: $comment
    status: CLOSED_ABANDONED
  ) {
    id
    status
  }
}
    `;
export type ShefAbandonChangeRequestMutationFn = ApolloReactCommon.MutationFunction<ShefAbandonChangeRequestMutation, ShefAbandonChangeRequestMutationVariables>;
export type ShefAbandonChangeRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShefAbandonChangeRequestMutation, ShefAbandonChangeRequestMutationVariables>, 'mutation'>;

    export const ShefAbandonChangeRequestComponent = (props: ShefAbandonChangeRequestComponentProps) => (
      <ApolloReactComponents.Mutation<ShefAbandonChangeRequestMutation, ShefAbandonChangeRequestMutationVariables> mutation={ShefAbandonChangeRequestDocument} {...props} />
    );
    

/**
 * __useShefAbandonChangeRequestMutation__
 *
 * To run a mutation, you first call `useShefAbandonChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShefAbandonChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shefAbandonChangeRequestMutation, { data, loading, error }] = useShefAbandonChangeRequestMutation({
 *   variables: {
 *      foodItemChangeRequestId: // value for 'foodItemChangeRequestId'
 *      changeset: // value for 'changeset'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useShefAbandonChangeRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShefAbandonChangeRequestMutation, ShefAbandonChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShefAbandonChangeRequestMutation, ShefAbandonChangeRequestMutationVariables>(ShefAbandonChangeRequestDocument, options);
      }
export type ShefAbandonChangeRequestMutationHookResult = ReturnType<typeof useShefAbandonChangeRequestMutation>;
export type ShefAbandonChangeRequestMutationResult = ApolloReactCommon.MutationResult<ShefAbandonChangeRequestMutation>;
export type ShefAbandonChangeRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<ShefAbandonChangeRequestMutation, ShefAbandonChangeRequestMutationVariables>;
export const ShefModifyFoodItemDocument = gql`
    mutation ShefModifyFoodItem($foodItemId: Int!, $changeset: FoodItemChangesetInput!) {
  createFoodItemChangeRequest(foodItemId: $foodItemId, changeset: $changeset) {
    id
    status
  }
}
    `;
export type ShefModifyFoodItemMutationFn = ApolloReactCommon.MutationFunction<ShefModifyFoodItemMutation, ShefModifyFoodItemMutationVariables>;
export type ShefModifyFoodItemComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShefModifyFoodItemMutation, ShefModifyFoodItemMutationVariables>, 'mutation'>;

    export const ShefModifyFoodItemComponent = (props: ShefModifyFoodItemComponentProps) => (
      <ApolloReactComponents.Mutation<ShefModifyFoodItemMutation, ShefModifyFoodItemMutationVariables> mutation={ShefModifyFoodItemDocument} {...props} />
    );
    

/**
 * __useShefModifyFoodItemMutation__
 *
 * To run a mutation, you first call `useShefModifyFoodItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShefModifyFoodItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shefModifyFoodItemMutation, { data, loading, error }] = useShefModifyFoodItemMutation({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *      changeset: // value for 'changeset'
 *   },
 * });
 */
export function useShefModifyFoodItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShefModifyFoodItemMutation, ShefModifyFoodItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShefModifyFoodItemMutation, ShefModifyFoodItemMutationVariables>(ShefModifyFoodItemDocument, options);
      }
export type ShefModifyFoodItemMutationHookResult = ReturnType<typeof useShefModifyFoodItemMutation>;
export type ShefModifyFoodItemMutationResult = ApolloReactCommon.MutationResult<ShefModifyFoodItemMutation>;
export type ShefModifyFoodItemMutationOptions = ApolloReactCommon.BaseMutationOptions<ShefModifyFoodItemMutation, ShefModifyFoodItemMutationVariables>;
export const AddFoodItemDocument = gql`
    mutation AddFoodItem($shefId: String!) {
  addFoodItem(shefId: $shefId) {
    id
  }
}
    `;
export type AddFoodItemMutationFn = ApolloReactCommon.MutationFunction<AddFoodItemMutation, AddFoodItemMutationVariables>;
export type AddFoodItemComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddFoodItemMutation, AddFoodItemMutationVariables>, 'mutation'>;

    export const AddFoodItemComponent = (props: AddFoodItemComponentProps) => (
      <ApolloReactComponents.Mutation<AddFoodItemMutation, AddFoodItemMutationVariables> mutation={AddFoodItemDocument} {...props} />
    );
    

/**
 * __useAddFoodItemMutation__
 *
 * To run a mutation, you first call `useAddFoodItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFoodItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFoodItemMutation, { data, loading, error }] = useAddFoodItemMutation({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useAddFoodItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddFoodItemMutation, AddFoodItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddFoodItemMutation, AddFoodItemMutationVariables>(AddFoodItemDocument, options);
      }
export type AddFoodItemMutationHookResult = ReturnType<typeof useAddFoodItemMutation>;
export type AddFoodItemMutationResult = ApolloReactCommon.MutationResult<AddFoodItemMutation>;
export type AddFoodItemMutationOptions = ApolloReactCommon.BaseMutationOptions<AddFoodItemMutation, AddFoodItemMutationVariables>;
export const ModifyFoodItemHolidayMenuDocument = gql`
    mutation ModifyFoodItemHolidayMenu($foodItemId: Int!, $holiday: Holiday) {
  modifyFoodItemHolidayMenu(foodItemId: $foodItemId, holiday: $holiday)
}
    `;
export type ModifyFoodItemHolidayMenuMutationFn = ApolloReactCommon.MutationFunction<ModifyFoodItemHolidayMenuMutation, ModifyFoodItemHolidayMenuMutationVariables>;
export type ModifyFoodItemHolidayMenuComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ModifyFoodItemHolidayMenuMutation, ModifyFoodItemHolidayMenuMutationVariables>, 'mutation'>;

    export const ModifyFoodItemHolidayMenuComponent = (props: ModifyFoodItemHolidayMenuComponentProps) => (
      <ApolloReactComponents.Mutation<ModifyFoodItemHolidayMenuMutation, ModifyFoodItemHolidayMenuMutationVariables> mutation={ModifyFoodItemHolidayMenuDocument} {...props} />
    );
    

/**
 * __useModifyFoodItemHolidayMenuMutation__
 *
 * To run a mutation, you first call `useModifyFoodItemHolidayMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyFoodItemHolidayMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyFoodItemHolidayMenuMutation, { data, loading, error }] = useModifyFoodItemHolidayMenuMutation({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *      holiday: // value for 'holiday'
 *   },
 * });
 */
export function useModifyFoodItemHolidayMenuMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ModifyFoodItemHolidayMenuMutation, ModifyFoodItemHolidayMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ModifyFoodItemHolidayMenuMutation, ModifyFoodItemHolidayMenuMutationVariables>(ModifyFoodItemHolidayMenuDocument, options);
      }
export type ModifyFoodItemHolidayMenuMutationHookResult = ReturnType<typeof useModifyFoodItemHolidayMenuMutation>;
export type ModifyFoodItemHolidayMenuMutationResult = ApolloReactCommon.MutationResult<ModifyFoodItemHolidayMenuMutation>;
export type ModifyFoodItemHolidayMenuMutationOptions = ApolloReactCommon.BaseMutationOptions<ModifyFoodItemHolidayMenuMutation, ModifyFoodItemHolidayMenuMutationVariables>;
export const ShefOrderLabelsDocument = gql`
    query ShefOrderLabels($shefId: String!, $deliveryDateString: String!) {
  ordersByDate: ordersByFulfillmentDate(
    shefId: $shefId
    fulfillmentDate: $deliveryDateString
  ) {
    ...ShefOrderLabelsOrders
  }
  shef(userId: $shefId) {
    ...ShefOrderLabelsShef
  }
}
    ${ShefOrderLabelsOrdersFragmentDoc}
${ShefOrderLabelsShefFragmentDoc}`;
export type ShefOrderLabelsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefOrderLabelsQuery, ShefOrderLabelsQueryVariables>, 'query'> & ({ variables: ShefOrderLabelsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefOrderLabelsComponent = (props: ShefOrderLabelsComponentProps) => (
      <ApolloReactComponents.Query<ShefOrderLabelsQuery, ShefOrderLabelsQueryVariables> query={ShefOrderLabelsDocument} {...props} />
    );
    

/**
 * __useShefOrderLabelsQuery__
 *
 * To run a query within a React component, call `useShefOrderLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefOrderLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefOrderLabelsQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      deliveryDateString: // value for 'deliveryDateString'
 *   },
 * });
 */
export function useShefOrderLabelsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefOrderLabelsQuery, ShefOrderLabelsQueryVariables> & ({ variables: ShefOrderLabelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefOrderLabelsQuery, ShefOrderLabelsQueryVariables>(ShefOrderLabelsDocument, options);
      }
export function useShefOrderLabelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefOrderLabelsQuery, ShefOrderLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefOrderLabelsQuery, ShefOrderLabelsQueryVariables>(ShefOrderLabelsDocument, options);
        }
export function useShefOrderLabelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefOrderLabelsQuery, ShefOrderLabelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefOrderLabelsQuery, ShefOrderLabelsQueryVariables>(ShefOrderLabelsDocument, options);
        }
export type ShefOrderLabelsQueryHookResult = ReturnType<typeof useShefOrderLabelsQuery>;
export type ShefOrderLabelsLazyQueryHookResult = ReturnType<typeof useShefOrderLabelsLazyQuery>;
export type ShefOrderLabelsSuspenseQueryHookResult = ReturnType<typeof useShefOrderLabelsSuspenseQuery>;
export type ShefOrderLabelsQueryResult = ApolloReactCommon.QueryResult<ShefOrderLabelsQuery, ShefOrderLabelsQueryVariables>;
export const SingleOrderLabelDocument = gql`
    query SingleOrderLabel($orderId: Int!) {
  order(orderId: $orderId) {
    ...ShefOrderLabelsOrders
    deliveryDate
    shefProfile {
      id
      shef {
        ...ShefOrderLabelsShef
      }
    }
  }
}
    ${ShefOrderLabelsOrdersFragmentDoc}
${ShefOrderLabelsShefFragmentDoc}`;
export type SingleOrderLabelComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SingleOrderLabelQuery, SingleOrderLabelQueryVariables>, 'query'> & ({ variables: SingleOrderLabelQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SingleOrderLabelComponent = (props: SingleOrderLabelComponentProps) => (
      <ApolloReactComponents.Query<SingleOrderLabelQuery, SingleOrderLabelQueryVariables> query={SingleOrderLabelDocument} {...props} />
    );
    

/**
 * __useSingleOrderLabelQuery__
 *
 * To run a query within a React component, call `useSingleOrderLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleOrderLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleOrderLabelQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSingleOrderLabelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SingleOrderLabelQuery, SingleOrderLabelQueryVariables> & ({ variables: SingleOrderLabelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SingleOrderLabelQuery, SingleOrderLabelQueryVariables>(SingleOrderLabelDocument, options);
      }
export function useSingleOrderLabelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SingleOrderLabelQuery, SingleOrderLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SingleOrderLabelQuery, SingleOrderLabelQueryVariables>(SingleOrderLabelDocument, options);
        }
export function useSingleOrderLabelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleOrderLabelQuery, SingleOrderLabelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SingleOrderLabelQuery, SingleOrderLabelQueryVariables>(SingleOrderLabelDocument, options);
        }
export type SingleOrderLabelQueryHookResult = ReturnType<typeof useSingleOrderLabelQuery>;
export type SingleOrderLabelLazyQueryHookResult = ReturnType<typeof useSingleOrderLabelLazyQuery>;
export type SingleOrderLabelSuspenseQueryHookResult = ReturnType<typeof useSingleOrderLabelSuspenseQuery>;
export type SingleOrderLabelQueryResult = ApolloReactCommon.QueryResult<SingleOrderLabelQuery, SingleOrderLabelQueryVariables>;
export const SingleGroupOrderLabelDocument = gql`
    query SingleGroupOrderLabel($groupOrderId: String!) {
  groupOrdersByIds(groupOrderIds: [$groupOrderId]) {
    ...AdminOrderLabelFields
  }
}
    ${AdminOrderLabelFieldsFragmentDoc}`;
export type SingleGroupOrderLabelComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SingleGroupOrderLabelQuery, SingleGroupOrderLabelQueryVariables>, 'query'> & ({ variables: SingleGroupOrderLabelQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SingleGroupOrderLabelComponent = (props: SingleGroupOrderLabelComponentProps) => (
      <ApolloReactComponents.Query<SingleGroupOrderLabelQuery, SingleGroupOrderLabelQueryVariables> query={SingleGroupOrderLabelDocument} {...props} />
    );
    

/**
 * __useSingleGroupOrderLabelQuery__
 *
 * To run a query within a React component, call `useSingleGroupOrderLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleGroupOrderLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleGroupOrderLabelQuery({
 *   variables: {
 *      groupOrderId: // value for 'groupOrderId'
 *   },
 * });
 */
export function useSingleGroupOrderLabelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SingleGroupOrderLabelQuery, SingleGroupOrderLabelQueryVariables> & ({ variables: SingleGroupOrderLabelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SingleGroupOrderLabelQuery, SingleGroupOrderLabelQueryVariables>(SingleGroupOrderLabelDocument, options);
      }
export function useSingleGroupOrderLabelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SingleGroupOrderLabelQuery, SingleGroupOrderLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SingleGroupOrderLabelQuery, SingleGroupOrderLabelQueryVariables>(SingleGroupOrderLabelDocument, options);
        }
export function useSingleGroupOrderLabelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleGroupOrderLabelQuery, SingleGroupOrderLabelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SingleGroupOrderLabelQuery, SingleGroupOrderLabelQueryVariables>(SingleGroupOrderLabelDocument, options);
        }
export type SingleGroupOrderLabelQueryHookResult = ReturnType<typeof useSingleGroupOrderLabelQuery>;
export type SingleGroupOrderLabelLazyQueryHookResult = ReturnType<typeof useSingleGroupOrderLabelLazyQuery>;
export type SingleGroupOrderLabelSuspenseQueryHookResult = ReturnType<typeof useSingleGroupOrderLabelSuspenseQuery>;
export type SingleGroupOrderLabelQueryResult = ApolloReactCommon.QueryResult<SingleGroupOrderLabelQuery, SingleGroupOrderLabelQueryVariables>;
export const AdminFoodItemsDocument = gql`
    query AdminFoodItems($searchString: String!, $page: Int) {
  adminFoodItems(searchString: $searchString, page: $page) {
    foodItems {
      ...GenericTableFields
      ...FoodItemTagFields
      ...FoodItemTableFoodItem
    }
    pagination {
      ...PaginationFields
    }
  }
}
    ${GenericTableFieldsFragmentDoc}
${FoodItemTagFieldsFragmentDoc}
${FoodItemTableFoodItemFragmentDoc}
${PaginationFieldsFragmentDoc}`;
export type AdminFoodItemsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminFoodItemsQuery, AdminFoodItemsQueryVariables>, 'query'> & ({ variables: AdminFoodItemsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AdminFoodItemsComponent = (props: AdminFoodItemsComponentProps) => (
      <ApolloReactComponents.Query<AdminFoodItemsQuery, AdminFoodItemsQueryVariables> query={AdminFoodItemsDocument} {...props} />
    );
    

/**
 * __useAdminFoodItemsQuery__
 *
 * To run a query within a React component, call `useAdminFoodItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFoodItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFoodItemsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAdminFoodItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminFoodItemsQuery, AdminFoodItemsQueryVariables> & ({ variables: AdminFoodItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminFoodItemsQuery, AdminFoodItemsQueryVariables>(AdminFoodItemsDocument, options);
      }
export function useAdminFoodItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminFoodItemsQuery, AdminFoodItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminFoodItemsQuery, AdminFoodItemsQueryVariables>(AdminFoodItemsDocument, options);
        }
export function useAdminFoodItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminFoodItemsQuery, AdminFoodItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminFoodItemsQuery, AdminFoodItemsQueryVariables>(AdminFoodItemsDocument, options);
        }
export type AdminFoodItemsQueryHookResult = ReturnType<typeof useAdminFoodItemsQuery>;
export type AdminFoodItemsLazyQueryHookResult = ReturnType<typeof useAdminFoodItemsLazyQuery>;
export type AdminFoodItemsSuspenseQueryHookResult = ReturnType<typeof useAdminFoodItemsSuspenseQuery>;
export type AdminFoodItemsQueryResult = ApolloReactCommon.QueryResult<AdminFoodItemsQuery, AdminFoodItemsQueryVariables>;
export const AdminOrderLabelsDocument = gql`
    query AdminOrderLabels($page: Int, $resultsPerPage: Int, $search: String, $deliveryHubIds: [Int], $deliveryDate: String) {
  adminGroupOrders(
    page: $page
    resultsPerPage: $resultsPerPage
    search: $search
    deliveryHubIds: $deliveryHubIds
    deliveryDate: $deliveryDate
  ) {
    pagination {
      ...PaginationFields
    }
    groupOrders {
      ...AdminOrderLabelFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${AdminOrderLabelFieldsFragmentDoc}`;
export type AdminOrderLabelsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminOrderLabelsQuery, AdminOrderLabelsQueryVariables>, 'query'>;

    export const AdminOrderLabelsComponent = (props: AdminOrderLabelsComponentProps) => (
      <ApolloReactComponents.Query<AdminOrderLabelsQuery, AdminOrderLabelsQueryVariables> query={AdminOrderLabelsDocument} {...props} />
    );
    

/**
 * __useAdminOrderLabelsQuery__
 *
 * To run a query within a React component, call `useAdminOrderLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrderLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrderLabelsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      search: // value for 'search'
 *      deliveryHubIds: // value for 'deliveryHubIds'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useAdminOrderLabelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminOrderLabelsQuery, AdminOrderLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminOrderLabelsQuery, AdminOrderLabelsQueryVariables>(AdminOrderLabelsDocument, options);
      }
export function useAdminOrderLabelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminOrderLabelsQuery, AdminOrderLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminOrderLabelsQuery, AdminOrderLabelsQueryVariables>(AdminOrderLabelsDocument, options);
        }
export function useAdminOrderLabelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminOrderLabelsQuery, AdminOrderLabelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminOrderLabelsQuery, AdminOrderLabelsQueryVariables>(AdminOrderLabelsDocument, options);
        }
export type AdminOrderLabelsQueryHookResult = ReturnType<typeof useAdminOrderLabelsQuery>;
export type AdminOrderLabelsLazyQueryHookResult = ReturnType<typeof useAdminOrderLabelsLazyQuery>;
export type AdminOrderLabelsSuspenseQueryHookResult = ReturnType<typeof useAdminOrderLabelsSuspenseQuery>;
export type AdminOrderLabelsQueryResult = ApolloReactCommon.QueryResult<AdminOrderLabelsQuery, AdminOrderLabelsQueryVariables>;
export const DeliveryHubsDocument = gql`
    query DeliveryHubs {
  deliveryHubs {
    id
    code
    name
    street
    city
    province
    unit
    pickupInstructions
    zipCode
    dropoffWindowStartTimeMinutesFromMidnight
    dropoffWindowEndTimeMinutesFromMidnight
  }
}
    `;
export type DeliveryHubsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DeliveryHubsQuery, DeliveryHubsQueryVariables>, 'query'>;

    export const DeliveryHubsComponent = (props: DeliveryHubsComponentProps) => (
      <ApolloReactComponents.Query<DeliveryHubsQuery, DeliveryHubsQueryVariables> query={DeliveryHubsDocument} {...props} />
    );
    

/**
 * __useDeliveryHubsQuery__
 *
 * To run a query within a React component, call `useDeliveryHubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryHubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryHubsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeliveryHubsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DeliveryHubsQuery, DeliveryHubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeliveryHubsQuery, DeliveryHubsQueryVariables>(DeliveryHubsDocument, options);
      }
export function useDeliveryHubsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeliveryHubsQuery, DeliveryHubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeliveryHubsQuery, DeliveryHubsQueryVariables>(DeliveryHubsDocument, options);
        }
export function useDeliveryHubsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeliveryHubsQuery, DeliveryHubsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DeliveryHubsQuery, DeliveryHubsQueryVariables>(DeliveryHubsDocument, options);
        }
export type DeliveryHubsQueryHookResult = ReturnType<typeof useDeliveryHubsQuery>;
export type DeliveryHubsLazyQueryHookResult = ReturnType<typeof useDeliveryHubsLazyQuery>;
export type DeliveryHubsSuspenseQueryHookResult = ReturnType<typeof useDeliveryHubsSuspenseQuery>;
export type DeliveryHubsQueryResult = ApolloReactCommon.QueryResult<DeliveryHubsQuery, DeliveryHubsQueryVariables>;
export const AdminGroupOrdersDocument = gql`
    query AdminGroupOrders($page: Int, $search: String) {
  adminGroupOrders(page: $page, search: $search) {
    pagination {
      ...PaginationFields
    }
    groupOrders {
      ...AdminGroupOrderFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${AdminGroupOrderFieldsFragmentDoc}`;
export type AdminGroupOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminGroupOrdersQuery, AdminGroupOrdersQueryVariables>, 'query'>;

    export const AdminGroupOrdersComponent = (props: AdminGroupOrdersComponentProps) => (
      <ApolloReactComponents.Query<AdminGroupOrdersQuery, AdminGroupOrdersQueryVariables> query={AdminGroupOrdersDocument} {...props} />
    );
    

/**
 * __useAdminGroupOrdersQuery__
 *
 * To run a query within a React component, call `useAdminGroupOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGroupOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGroupOrdersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminGroupOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminGroupOrdersQuery, AdminGroupOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminGroupOrdersQuery, AdminGroupOrdersQueryVariables>(AdminGroupOrdersDocument, options);
      }
export function useAdminGroupOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminGroupOrdersQuery, AdminGroupOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminGroupOrdersQuery, AdminGroupOrdersQueryVariables>(AdminGroupOrdersDocument, options);
        }
export function useAdminGroupOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminGroupOrdersQuery, AdminGroupOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminGroupOrdersQuery, AdminGroupOrdersQueryVariables>(AdminGroupOrdersDocument, options);
        }
export type AdminGroupOrdersQueryHookResult = ReturnType<typeof useAdminGroupOrdersQuery>;
export type AdminGroupOrdersLazyQueryHookResult = ReturnType<typeof useAdminGroupOrdersLazyQuery>;
export type AdminGroupOrdersSuspenseQueryHookResult = ReturnType<typeof useAdminGroupOrdersSuspenseQuery>;
export type AdminGroupOrdersQueryResult = ApolloReactCommon.QueryResult<AdminGroupOrdersQuery, AdminGroupOrdersQueryVariables>;
export const AdminGroupOrderEditDocument = gql`
    query AdminGroupOrderEdit($id: String!) {
  groupOrdersByIds(groupOrderIds: [$id]) {
    id
    formattedId
    userId
    phone
    deliveryAddressId
    user {
      id
      flakeId
      publicName
      email
      activeAddresses {
        ...AddressSelectorAddress
      }
    }
    pickupAddressId
    createdAt
    cancelledAt
    skippedAt
    deliveryDate
    orderType
    deliveryNotes
    deliveryType
    refunds {
      id
      orderId
      createdAt
      refundType
      refundReason
      notes
    }
    delivery {
      externalId
      type
      fee
    }
    pickupAddress {
      id
      formattedAddress
    }
    deliveryAddress {
      id
      formattedAddress
      zipCodeInfo {
        zipCode
        region {
          id
          name
        }
        timeZone
      }
    }
    orders {
      id
      shefId
      promoCode {
        code
        isPercentage
        promoCodeType
        value
      }
      lineItems {
        id
        name
        quantity
        price
        foodItem {
          id
          name
          price
          imageUrl
        }
      }
      grandTotal
    }
    timeWindowId
    timeWindow {
      id
      startMsAfterMidnight
      endMsAfterMidnight
    }
    transactions {
      id
      type
      status
      createdAt
      statusChangedAt
      transactionLineItems {
        id
        type
        amount
      }
    }
    orderTotals {
      deliveryFee
      promoApplied
      nonPromoDiscountApplied
      grandTotal
      refund
      salesTax
      serviceFee
      shefTip
      smallOrderFee
      subtotal
      refundableBalance
      promoBalance
    }
    isFullyRefunded
    isPartiallyRefunded
  }
  timeWindowsForGroupOrder(groupOrderId: $id) {
    id
    startMsAfterMidnight
    endMsAfterMidnight
  }
}
    ${AddressSelectorAddressFragmentDoc}`;
export type AdminGroupOrderEditComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminGroupOrderEditQuery, AdminGroupOrderEditQueryVariables>, 'query'> & ({ variables: AdminGroupOrderEditQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AdminGroupOrderEditComponent = (props: AdminGroupOrderEditComponentProps) => (
      <ApolloReactComponents.Query<AdminGroupOrderEditQuery, AdminGroupOrderEditQueryVariables> query={AdminGroupOrderEditDocument} {...props} />
    );
    

/**
 * __useAdminGroupOrderEditQuery__
 *
 * To run a query within a React component, call `useAdminGroupOrderEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGroupOrderEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGroupOrderEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGroupOrderEditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminGroupOrderEditQuery, AdminGroupOrderEditQueryVariables> & ({ variables: AdminGroupOrderEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminGroupOrderEditQuery, AdminGroupOrderEditQueryVariables>(AdminGroupOrderEditDocument, options);
      }
export function useAdminGroupOrderEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminGroupOrderEditQuery, AdminGroupOrderEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminGroupOrderEditQuery, AdminGroupOrderEditQueryVariables>(AdminGroupOrderEditDocument, options);
        }
export function useAdminGroupOrderEditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminGroupOrderEditQuery, AdminGroupOrderEditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminGroupOrderEditQuery, AdminGroupOrderEditQueryVariables>(AdminGroupOrderEditDocument, options);
        }
export type AdminGroupOrderEditQueryHookResult = ReturnType<typeof useAdminGroupOrderEditQuery>;
export type AdminGroupOrderEditLazyQueryHookResult = ReturnType<typeof useAdminGroupOrderEditLazyQuery>;
export type AdminGroupOrderEditSuspenseQueryHookResult = ReturnType<typeof useAdminGroupOrderEditSuspenseQuery>;
export type AdminGroupOrderEditQueryResult = ApolloReactCommon.QueryResult<AdminGroupOrderEditQuery, AdminGroupOrderEditQueryVariables>;
export const AdminModifyGroupOrderMutationDocument = gql`
    mutation AdminModifyGroupOrderMutation($input: AdminModifyGroupOrderInput!) {
  adminModifyGroupOrder(input: $input) {
    id
    timeWindowId
    phone
    deliveryDate
    deliveryAddressId
  }
}
    `;
export type AdminModifyGroupOrderMutationMutationFn = ApolloReactCommon.MutationFunction<AdminModifyGroupOrderMutationMutation, AdminModifyGroupOrderMutationMutationVariables>;
export type AdminModifyGroupOrderMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminModifyGroupOrderMutationMutation, AdminModifyGroupOrderMutationMutationVariables>, 'mutation'>;

    export const AdminModifyGroupOrderMutationComponent = (props: AdminModifyGroupOrderMutationComponentProps) => (
      <ApolloReactComponents.Mutation<AdminModifyGroupOrderMutationMutation, AdminModifyGroupOrderMutationMutationVariables> mutation={AdminModifyGroupOrderMutationDocument} {...props} />
    );
    

/**
 * __useAdminModifyGroupOrderMutationMutation__
 *
 * To run a mutation, you first call `useAdminModifyGroupOrderMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminModifyGroupOrderMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminModifyGroupOrderMutationMutation, { data, loading, error }] = useAdminModifyGroupOrderMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminModifyGroupOrderMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminModifyGroupOrderMutationMutation, AdminModifyGroupOrderMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminModifyGroupOrderMutationMutation, AdminModifyGroupOrderMutationMutationVariables>(AdminModifyGroupOrderMutationDocument, options);
      }
export type AdminModifyGroupOrderMutationMutationHookResult = ReturnType<typeof useAdminModifyGroupOrderMutationMutation>;
export type AdminModifyGroupOrderMutationMutationResult = ApolloReactCommon.MutationResult<AdminModifyGroupOrderMutationMutation>;
export type AdminModifyGroupOrderMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminModifyGroupOrderMutationMutation, AdminModifyGroupOrderMutationMutationVariables>;
export const AdminRefundGroupOrderMutationDocument = gql`
    mutation AdminRefundGroupOrderMutation($input: GroupOrderLevelRefundInput!) {
  refundGroupOrder2(input: $input) {
    id
  }
}
    `;
export type AdminRefundGroupOrderMutationMutationFn = ApolloReactCommon.MutationFunction<AdminRefundGroupOrderMutationMutation, AdminRefundGroupOrderMutationMutationVariables>;
export type AdminRefundGroupOrderMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminRefundGroupOrderMutationMutation, AdminRefundGroupOrderMutationMutationVariables>, 'mutation'>;

    export const AdminRefundGroupOrderMutationComponent = (props: AdminRefundGroupOrderMutationComponentProps) => (
      <ApolloReactComponents.Mutation<AdminRefundGroupOrderMutationMutation, AdminRefundGroupOrderMutationMutationVariables> mutation={AdminRefundGroupOrderMutationDocument} {...props} />
    );
    

/**
 * __useAdminRefundGroupOrderMutationMutation__
 *
 * To run a mutation, you first call `useAdminRefundGroupOrderMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRefundGroupOrderMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRefundGroupOrderMutationMutation, { data, loading, error }] = useAdminRefundGroupOrderMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminRefundGroupOrderMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRefundGroupOrderMutationMutation, AdminRefundGroupOrderMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRefundGroupOrderMutationMutation, AdminRefundGroupOrderMutationMutationVariables>(AdminRefundGroupOrderMutationDocument, options);
      }
export type AdminRefundGroupOrderMutationMutationHookResult = ReturnType<typeof useAdminRefundGroupOrderMutationMutation>;
export type AdminRefundGroupOrderMutationMutationResult = ApolloReactCommon.MutationResult<AdminRefundGroupOrderMutationMutation>;
export type AdminRefundGroupOrderMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminRefundGroupOrderMutationMutation, AdminRefundGroupOrderMutationMutationVariables>;
export const AdminAddGroupOrderMutationDocument = gql`
    mutation AdminAddGroupOrderMutation($input: GroupOrderInput!) {
  adminAddGroupOrder(input: $input) {
    message
    success
  }
}
    `;
export type AdminAddGroupOrderMutationMutationFn = ApolloReactCommon.MutationFunction<AdminAddGroupOrderMutationMutation, AdminAddGroupOrderMutationMutationVariables>;
export type AdminAddGroupOrderMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminAddGroupOrderMutationMutation, AdminAddGroupOrderMutationMutationVariables>, 'mutation'>;

    export const AdminAddGroupOrderMutationComponent = (props: AdminAddGroupOrderMutationComponentProps) => (
      <ApolloReactComponents.Mutation<AdminAddGroupOrderMutationMutation, AdminAddGroupOrderMutationMutationVariables> mutation={AdminAddGroupOrderMutationDocument} {...props} />
    );
    

/**
 * __useAdminAddGroupOrderMutationMutation__
 *
 * To run a mutation, you first call `useAdminAddGroupOrderMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddGroupOrderMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddGroupOrderMutationMutation, { data, loading, error }] = useAdminAddGroupOrderMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminAddGroupOrderMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminAddGroupOrderMutationMutation, AdminAddGroupOrderMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminAddGroupOrderMutationMutation, AdminAddGroupOrderMutationMutationVariables>(AdminAddGroupOrderMutationDocument, options);
      }
export type AdminAddGroupOrderMutationMutationHookResult = ReturnType<typeof useAdminAddGroupOrderMutationMutation>;
export type AdminAddGroupOrderMutationMutationResult = ApolloReactCommon.MutationResult<AdminAddGroupOrderMutationMutation>;
export type AdminAddGroupOrderMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminAddGroupOrderMutationMutation, AdminAddGroupOrderMutationMutationVariables>;
export const DisablePromoButtonDocument = gql`
    mutation DisablePromoButton($promoCodeId: Int!) {
  disablePromoCode(promoCodeId: $promoCodeId) {
    id
    disabled
    disabledAt
  }
}
    `;
export type DisablePromoButtonMutationFn = ApolloReactCommon.MutationFunction<DisablePromoButtonMutation, DisablePromoButtonMutationVariables>;
export type DisablePromoButtonComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DisablePromoButtonMutation, DisablePromoButtonMutationVariables>, 'mutation'>;

    export const DisablePromoButtonComponent = (props: DisablePromoButtonComponentProps) => (
      <ApolloReactComponents.Mutation<DisablePromoButtonMutation, DisablePromoButtonMutationVariables> mutation={DisablePromoButtonDocument} {...props} />
    );
    

/**
 * __useDisablePromoButtonMutation__
 *
 * To run a mutation, you first call `useDisablePromoButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisablePromoButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disablePromoButtonMutation, { data, loading, error }] = useDisablePromoButtonMutation({
 *   variables: {
 *      promoCodeId: // value for 'promoCodeId'
 *   },
 * });
 */
export function useDisablePromoButtonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisablePromoButtonMutation, DisablePromoButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisablePromoButtonMutation, DisablePromoButtonMutationVariables>(DisablePromoButtonDocument, options);
      }
export type DisablePromoButtonMutationHookResult = ReturnType<typeof useDisablePromoButtonMutation>;
export type DisablePromoButtonMutationResult = ApolloReactCommon.MutationResult<DisablePromoButtonMutation>;
export type DisablePromoButtonMutationOptions = ApolloReactCommon.BaseMutationOptions<DisablePromoButtonMutation, DisablePromoButtonMutationVariables>;
export const UpdateExplorePagePromoToggleDocument = gql`
    mutation UpdateExplorePagePromoToggle($shefId: String!, $promoCodeId: Int) {
  updateExplorePagePromoCode(shefId: $shefId, promoCodeId: $promoCodeId) {
    id
    isExplorePagePromo
  }
}
    `;
export type UpdateExplorePagePromoToggleMutationFn = ApolloReactCommon.MutationFunction<UpdateExplorePagePromoToggleMutation, UpdateExplorePagePromoToggleMutationVariables>;
export type UpdateExplorePagePromoToggleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateExplorePagePromoToggleMutation, UpdateExplorePagePromoToggleMutationVariables>, 'mutation'>;

    export const UpdateExplorePagePromoToggleComponent = (props: UpdateExplorePagePromoToggleComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateExplorePagePromoToggleMutation, UpdateExplorePagePromoToggleMutationVariables> mutation={UpdateExplorePagePromoToggleDocument} {...props} />
    );
    

/**
 * __useUpdateExplorePagePromoToggleMutation__
 *
 * To run a mutation, you first call `useUpdateExplorePagePromoToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExplorePagePromoToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExplorePagePromoToggleMutation, { data, loading, error }] = useUpdateExplorePagePromoToggleMutation({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      promoCodeId: // value for 'promoCodeId'
 *   },
 * });
 */
export function useUpdateExplorePagePromoToggleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateExplorePagePromoToggleMutation, UpdateExplorePagePromoToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExplorePagePromoToggleMutation, UpdateExplorePagePromoToggleMutationVariables>(UpdateExplorePagePromoToggleDocument, options);
      }
export type UpdateExplorePagePromoToggleMutationHookResult = ReturnType<typeof useUpdateExplorePagePromoToggleMutation>;
export type UpdateExplorePagePromoToggleMutationResult = ApolloReactCommon.MutationResult<UpdateExplorePagePromoToggleMutation>;
export type UpdateExplorePagePromoToggleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateExplorePagePromoToggleMutation, UpdateExplorePagePromoToggleMutationVariables>;
export const AdminConsumersQueryDocument = gql`
    query AdminConsumersQuery($page: Int, $search: String) {
  adminUsers(page: $page, search: $search) {
    pagination {
      ...PaginationFields
    }
    users {
      ...AdminUserFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${AdminUserFieldsFragmentDoc}`;
export type AdminConsumersQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminConsumersQueryQuery, AdminConsumersQueryQueryVariables>, 'query'>;

    export const AdminConsumersQueryComponent = (props: AdminConsumersQueryComponentProps) => (
      <ApolloReactComponents.Query<AdminConsumersQueryQuery, AdminConsumersQueryQueryVariables> query={AdminConsumersQueryDocument} {...props} />
    );
    

/**
 * __useAdminConsumersQueryQuery__
 *
 * To run a query within a React component, call `useAdminConsumersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminConsumersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminConsumersQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminConsumersQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminConsumersQueryQuery, AdminConsumersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminConsumersQueryQuery, AdminConsumersQueryQueryVariables>(AdminConsumersQueryDocument, options);
      }
export function useAdminConsumersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminConsumersQueryQuery, AdminConsumersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminConsumersQueryQuery, AdminConsumersQueryQueryVariables>(AdminConsumersQueryDocument, options);
        }
export function useAdminConsumersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminConsumersQueryQuery, AdminConsumersQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminConsumersQueryQuery, AdminConsumersQueryQueryVariables>(AdminConsumersQueryDocument, options);
        }
export type AdminConsumersQueryQueryHookResult = ReturnType<typeof useAdminConsumersQueryQuery>;
export type AdminConsumersQueryLazyQueryHookResult = ReturnType<typeof useAdminConsumersQueryLazyQuery>;
export type AdminConsumersQuerySuspenseQueryHookResult = ReturnType<typeof useAdminConsumersQuerySuspenseQuery>;
export type AdminConsumersQueryQueryResult = ApolloReactCommon.QueryResult<AdminConsumersQueryQuery, AdminConsumersQueryQueryVariables>;
export const AdminFoodhandlersDocument = gql`
    query AdminFoodhandlers($idFilter: String, $approved: Boolean, $page: Int) {
  adminShefFoodhandlers(idFilter: $idFilter, approved: $approved, page: $page) {
    pagination {
      ...PaginationFields
    }
    shefs {
      ...FoodHandlerShef
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${FoodHandlerShefFragmentDoc}`;
export type AdminFoodhandlersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminFoodhandlersQuery, AdminFoodhandlersQueryVariables>, 'query'>;

    export const AdminFoodhandlersComponent = (props: AdminFoodhandlersComponentProps) => (
      <ApolloReactComponents.Query<AdminFoodhandlersQuery, AdminFoodhandlersQueryVariables> query={AdminFoodhandlersDocument} {...props} />
    );
    

/**
 * __useAdminFoodhandlersQuery__
 *
 * To run a query within a React component, call `useAdminFoodhandlersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFoodhandlersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFoodhandlersQuery({
 *   variables: {
 *      idFilter: // value for 'idFilter'
 *      approved: // value for 'approved'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAdminFoodhandlersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminFoodhandlersQuery, AdminFoodhandlersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminFoodhandlersQuery, AdminFoodhandlersQueryVariables>(AdminFoodhandlersDocument, options);
      }
export function useAdminFoodhandlersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminFoodhandlersQuery, AdminFoodhandlersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminFoodhandlersQuery, AdminFoodhandlersQueryVariables>(AdminFoodhandlersDocument, options);
        }
export function useAdminFoodhandlersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminFoodhandlersQuery, AdminFoodhandlersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminFoodhandlersQuery, AdminFoodhandlersQueryVariables>(AdminFoodhandlersDocument, options);
        }
export type AdminFoodhandlersQueryHookResult = ReturnType<typeof useAdminFoodhandlersQuery>;
export type AdminFoodhandlersLazyQueryHookResult = ReturnType<typeof useAdminFoodhandlersLazyQuery>;
export type AdminFoodhandlersSuspenseQueryHookResult = ReturnType<typeof useAdminFoodhandlersSuspenseQuery>;
export type AdminFoodhandlersQueryResult = ApolloReactCommon.QueryResult<AdminFoodhandlersQuery, AdminFoodhandlersQueryVariables>;
export const ApproveFhcDocument = gql`
    mutation ApproveFHC($shefId: String!) {
  approveFoodHandlerCertificate(userId: $shefId)
}
    `;
export type ApproveFhcMutationFn = ApolloReactCommon.MutationFunction<ApproveFhcMutation, ApproveFhcMutationVariables>;
export type ApproveFhcComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ApproveFhcMutation, ApproveFhcMutationVariables>, 'mutation'>;

    export const ApproveFhcComponent = (props: ApproveFhcComponentProps) => (
      <ApolloReactComponents.Mutation<ApproveFhcMutation, ApproveFhcMutationVariables> mutation={ApproveFhcDocument} {...props} />
    );
    

/**
 * __useApproveFhcMutation__
 *
 * To run a mutation, you first call `useApproveFhcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveFhcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveFhcMutation, { data, loading, error }] = useApproveFhcMutation({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useApproveFhcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApproveFhcMutation, ApproveFhcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApproveFhcMutation, ApproveFhcMutationVariables>(ApproveFhcDocument, options);
      }
export type ApproveFhcMutationHookResult = ReturnType<typeof useApproveFhcMutation>;
export type ApproveFhcMutationResult = ApolloReactCommon.MutationResult<ApproveFhcMutation>;
export type ApproveFhcMutationOptions = ApolloReactCommon.BaseMutationOptions<ApproveFhcMutation, ApproveFhcMutationVariables>;
export const AdminShefTotalsDocument = gql`
    query AdminShefTotals($userId: String!) {
  shefProfile(userId: $userId) {
    id
    timeZone
  }
}
    `;
export type AdminShefTotalsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminShefTotalsQuery, AdminShefTotalsQueryVariables>, 'query'> & ({ variables: AdminShefTotalsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AdminShefTotalsComponent = (props: AdminShefTotalsComponentProps) => (
      <ApolloReactComponents.Query<AdminShefTotalsQuery, AdminShefTotalsQueryVariables> query={AdminShefTotalsDocument} {...props} />
    );
    

/**
 * __useAdminShefTotalsQuery__
 *
 * To run a query within a React component, call `useAdminShefTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShefTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShefTotalsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminShefTotalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminShefTotalsQuery, AdminShefTotalsQueryVariables> & ({ variables: AdminShefTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminShefTotalsQuery, AdminShefTotalsQueryVariables>(AdminShefTotalsDocument, options);
      }
export function useAdminShefTotalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminShefTotalsQuery, AdminShefTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminShefTotalsQuery, AdminShefTotalsQueryVariables>(AdminShefTotalsDocument, options);
        }
export function useAdminShefTotalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminShefTotalsQuery, AdminShefTotalsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminShefTotalsQuery, AdminShefTotalsQueryVariables>(AdminShefTotalsDocument, options);
        }
export type AdminShefTotalsQueryHookResult = ReturnType<typeof useAdminShefTotalsQuery>;
export type AdminShefTotalsLazyQueryHookResult = ReturnType<typeof useAdminShefTotalsLazyQuery>;
export type AdminShefTotalsSuspenseQueryHookResult = ReturnType<typeof useAdminShefTotalsSuspenseQuery>;
export type AdminShefTotalsQueryResult = ApolloReactCommon.QueryResult<AdminShefTotalsQuery, AdminShefTotalsQueryVariables>;
export const AdminShefsQueryDocument = gql`
    query AdminShefsQuery($shefStatus: ShefStatus, $page: Int, $search: String) {
  adminShefs(shefStatus: $shefStatus, page: $page, filter: $search) {
    pagination {
      ...PaginationFields
    }
    shefs {
      id
      fullName
      imageUrl
      shefApplication {
        id
      }
      shefProfile {
        id
        email
        formattedAddress
        phone
        bio
        notes
        dishCapacity
        primaryRegion {
          displayName
        }
      }
      foodItemCount
    }
  }
}
    ${PaginationFieldsFragmentDoc}`;
export type AdminShefsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminShefsQueryQuery, AdminShefsQueryQueryVariables>, 'query'>;

    export const AdminShefsQueryComponent = (props: AdminShefsQueryComponentProps) => (
      <ApolloReactComponents.Query<AdminShefsQueryQuery, AdminShefsQueryQueryVariables> query={AdminShefsQueryDocument} {...props} />
    );
    

/**
 * __useAdminShefsQueryQuery__
 *
 * To run a query within a React component, call `useAdminShefsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShefsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShefsQueryQuery({
 *   variables: {
 *      shefStatus: // value for 'shefStatus'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminShefsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminShefsQueryQuery, AdminShefsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminShefsQueryQuery, AdminShefsQueryQueryVariables>(AdminShefsQueryDocument, options);
      }
export function useAdminShefsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminShefsQueryQuery, AdminShefsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminShefsQueryQuery, AdminShefsQueryQueryVariables>(AdminShefsQueryDocument, options);
        }
export function useAdminShefsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminShefsQueryQuery, AdminShefsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminShefsQueryQuery, AdminShefsQueryQueryVariables>(AdminShefsQueryDocument, options);
        }
export type AdminShefsQueryQueryHookResult = ReturnType<typeof useAdminShefsQueryQuery>;
export type AdminShefsQueryLazyQueryHookResult = ReturnType<typeof useAdminShefsQueryLazyQuery>;
export type AdminShefsQuerySuspenseQueryHookResult = ReturnType<typeof useAdminShefsQuerySuspenseQuery>;
export type AdminShefsQueryQueryResult = ApolloReactCommon.QueryResult<AdminShefsQueryQuery, AdminShefsQueryQueryVariables>;
export const AdminUserQueryDocument = gql`
    query AdminUserQuery($userId: String!) {
  user(userId: $userId) {
    id
    email
    publicName
    firstName
    lastName
    fullName
    createdAt
    imageUrl
    videoUrl
    banned
    banReason
    bannedAt
    groupOrders {
      ...AdminGroupOrderFields
    }
  }
}
    ${AdminGroupOrderFieldsFragmentDoc}`;
export type AdminUserQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminUserQueryQuery, AdminUserQueryQueryVariables>, 'query'> & ({ variables: AdminUserQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AdminUserQueryComponent = (props: AdminUserQueryComponentProps) => (
      <ApolloReactComponents.Query<AdminUserQueryQuery, AdminUserQueryQueryVariables> query={AdminUserQueryDocument} {...props} />
    );
    

/**
 * __useAdminUserQueryQuery__
 *
 * To run a query within a React component, call `useAdminUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminUserQueryQuery, AdminUserQueryQueryVariables> & ({ variables: AdminUserQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminUserQueryQuery, AdminUserQueryQueryVariables>(AdminUserQueryDocument, options);
      }
export function useAdminUserQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminUserQueryQuery, AdminUserQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminUserQueryQuery, AdminUserQueryQueryVariables>(AdminUserQueryDocument, options);
        }
export function useAdminUserQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminUserQueryQuery, AdminUserQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminUserQueryQuery, AdminUserQueryQueryVariables>(AdminUserQueryDocument, options);
        }
export type AdminUserQueryQueryHookResult = ReturnType<typeof useAdminUserQueryQuery>;
export type AdminUserQueryLazyQueryHookResult = ReturnType<typeof useAdminUserQueryLazyQuery>;
export type AdminUserQuerySuspenseQueryHookResult = ReturnType<typeof useAdminUserQuerySuspenseQuery>;
export type AdminUserQueryQueryResult = ApolloReactCommon.QueryResult<AdminUserQueryQuery, AdminUserQueryQueryVariables>;
export const AdminUserResetPasswordMutationDocument = gql`
    mutation AdminUserResetPasswordMutation($userId: String!, $password: String!) {
  adminResetPassword(userId: $userId, password: $password) {
    id
  }
}
    `;
export type AdminUserResetPasswordMutationMutationFn = ApolloReactCommon.MutationFunction<AdminUserResetPasswordMutationMutation, AdminUserResetPasswordMutationMutationVariables>;
export type AdminUserResetPasswordMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminUserResetPasswordMutationMutation, AdminUserResetPasswordMutationMutationVariables>, 'mutation'>;

    export const AdminUserResetPasswordMutationComponent = (props: AdminUserResetPasswordMutationComponentProps) => (
      <ApolloReactComponents.Mutation<AdminUserResetPasswordMutationMutation, AdminUserResetPasswordMutationMutationVariables> mutation={AdminUserResetPasswordMutationDocument} {...props} />
    );
    

/**
 * __useAdminUserResetPasswordMutationMutation__
 *
 * To run a mutation, you first call `useAdminUserResetPasswordMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUserResetPasswordMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUserResetPasswordMutationMutation, { data, loading, error }] = useAdminUserResetPasswordMutationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAdminUserResetPasswordMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUserResetPasswordMutationMutation, AdminUserResetPasswordMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUserResetPasswordMutationMutation, AdminUserResetPasswordMutationMutationVariables>(AdminUserResetPasswordMutationDocument, options);
      }
export type AdminUserResetPasswordMutationMutationHookResult = ReturnType<typeof useAdminUserResetPasswordMutationMutation>;
export type AdminUserResetPasswordMutationMutationResult = ApolloReactCommon.MutationResult<AdminUserResetPasswordMutationMutation>;
export type AdminUserResetPasswordMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminUserResetPasswordMutationMutation, AdminUserResetPasswordMutationMutationVariables>;
export const AdminDeleteUserDocument = gql`
    mutation AdminDeleteUser($userId: String!, $confirmationCode: String!) {
  adminDeleteUser(userId: $userId, confirmationCode: $confirmationCode) {
    id
  }
}
    `;
export type AdminDeleteUserMutationFn = ApolloReactCommon.MutationFunction<AdminDeleteUserMutation, AdminDeleteUserMutationVariables>;
export type AdminDeleteUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminDeleteUserMutation, AdminDeleteUserMutationVariables>, 'mutation'>;

    export const AdminDeleteUserComponent = (props: AdminDeleteUserComponentProps) => (
      <ApolloReactComponents.Mutation<AdminDeleteUserMutation, AdminDeleteUserMutationVariables> mutation={AdminDeleteUserDocument} {...props} />
    );
    

/**
 * __useAdminDeleteUserMutation__
 *
 * To run a mutation, you first call `useAdminDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteUserMutation, { data, loading, error }] = useAdminDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      confirmationCode: // value for 'confirmationCode'
 *   },
 * });
 */
export function useAdminDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteUserMutation, AdminDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDeleteUserMutation, AdminDeleteUserMutationVariables>(AdminDeleteUserDocument, options);
      }
export type AdminDeleteUserMutationHookResult = ReturnType<typeof useAdminDeleteUserMutation>;
export type AdminDeleteUserMutationResult = ApolloReactCommon.MutationResult<AdminDeleteUserMutation>;
export type AdminDeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminDeleteUserMutation, AdminDeleteUserMutationVariables>;
export const AdminImpersonateUserDocument = gql`
    mutation AdminImpersonateUser($userId: String!) {
  adminImpersonateUser(userId: $userId) {
    ...AuthResultFields
  }
}
    ${AuthResultFieldsFragmentDoc}`;
export type AdminImpersonateUserMutationFn = ApolloReactCommon.MutationFunction<AdminImpersonateUserMutation, AdminImpersonateUserMutationVariables>;
export type AdminImpersonateUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminImpersonateUserMutation, AdminImpersonateUserMutationVariables>, 'mutation'>;

    export const AdminImpersonateUserComponent = (props: AdminImpersonateUserComponentProps) => (
      <ApolloReactComponents.Mutation<AdminImpersonateUserMutation, AdminImpersonateUserMutationVariables> mutation={AdminImpersonateUserDocument} {...props} />
    );
    

/**
 * __useAdminImpersonateUserMutation__
 *
 * To run a mutation, you first call `useAdminImpersonateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminImpersonateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminImpersonateUserMutation, { data, loading, error }] = useAdminImpersonateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminImpersonateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminImpersonateUserMutation, AdminImpersonateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminImpersonateUserMutation, AdminImpersonateUserMutationVariables>(AdminImpersonateUserDocument, options);
      }
export type AdminImpersonateUserMutationHookResult = ReturnType<typeof useAdminImpersonateUserMutation>;
export type AdminImpersonateUserMutationResult = ApolloReactCommon.MutationResult<AdminImpersonateUserMutation>;
export type AdminImpersonateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminImpersonateUserMutation, AdminImpersonateUserMutationVariables>;
export const AdminBanUserDocument = gql`
    mutation AdminBanUser($userId: String!, $reason: String!) {
  adminBanUser(userId: $userId, reason: $reason)
}
    `;
export type AdminBanUserMutationFn = ApolloReactCommon.MutationFunction<AdminBanUserMutation, AdminBanUserMutationVariables>;
export type AdminBanUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminBanUserMutation, AdminBanUserMutationVariables>, 'mutation'>;

    export const AdminBanUserComponent = (props: AdminBanUserComponentProps) => (
      <ApolloReactComponents.Mutation<AdminBanUserMutation, AdminBanUserMutationVariables> mutation={AdminBanUserDocument} {...props} />
    );
    

/**
 * __useAdminBanUserMutation__
 *
 * To run a mutation, you first call `useAdminBanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBanUserMutation, { data, loading, error }] = useAdminBanUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminBanUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminBanUserMutation, AdminBanUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminBanUserMutation, AdminBanUserMutationVariables>(AdminBanUserDocument, options);
      }
export type AdminBanUserMutationHookResult = ReturnType<typeof useAdminBanUserMutation>;
export type AdminBanUserMutationResult = ApolloReactCommon.MutationResult<AdminBanUserMutation>;
export type AdminBanUserMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminBanUserMutation, AdminBanUserMutationVariables>;
export const AdminUnbanUserDocument = gql`
    mutation AdminUnbanUser($userId: String!) {
  adminUnbanUser(userId: $userId)
}
    `;
export type AdminUnbanUserMutationFn = ApolloReactCommon.MutationFunction<AdminUnbanUserMutation, AdminUnbanUserMutationVariables>;
export type AdminUnbanUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminUnbanUserMutation, AdminUnbanUserMutationVariables>, 'mutation'>;

    export const AdminUnbanUserComponent = (props: AdminUnbanUserComponentProps) => (
      <ApolloReactComponents.Mutation<AdminUnbanUserMutation, AdminUnbanUserMutationVariables> mutation={AdminUnbanUserDocument} {...props} />
    );
    

/**
 * __useAdminUnbanUserMutation__
 *
 * To run a mutation, you first call `useAdminUnbanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUnbanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUnbanUserMutation, { data, loading, error }] = useAdminUnbanUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUnbanUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUnbanUserMutation, AdminUnbanUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUnbanUserMutation, AdminUnbanUserMutationVariables>(AdminUnbanUserDocument, options);
      }
export type AdminUnbanUserMutationHookResult = ReturnType<typeof useAdminUnbanUserMutation>;
export type AdminUnbanUserMutationResult = ApolloReactCommon.MutationResult<AdminUnbanUserMutation>;
export type AdminUnbanUserMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminUnbanUserMutation, AdminUnbanUserMutationVariables>;
export const AdminShefProfileQueryDocument = gql`
    query AdminShefProfileQuery($userId: String!) {
  shefProfile(userId: $userId) {
    ...ShefProfileEditShefProfile
    foodHandlersCertificate
    cuisineCategoryIds
    primaryRegion {
      id
      name
    }
  }
  cuisineCategories {
    ...CuisineCategoryItem
  }
  possibleDeliveryHubsForShef(input: {shefId: $userId}) {
    ...ShefProfileEditDeliveryHubs
  }
}
    ${ShefProfileEditShefProfileFragmentDoc}
${CuisineCategoryItemFragmentDoc}
${ShefProfileEditDeliveryHubsFragmentDoc}`;
export type AdminShefProfileQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AdminShefProfileQueryQuery, AdminShefProfileQueryQueryVariables>, 'query'> & ({ variables: AdminShefProfileQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AdminShefProfileQueryComponent = (props: AdminShefProfileQueryComponentProps) => (
      <ApolloReactComponents.Query<AdminShefProfileQueryQuery, AdminShefProfileQueryQueryVariables> query={AdminShefProfileQueryDocument} {...props} />
    );
    

/**
 * __useAdminShefProfileQueryQuery__
 *
 * To run a query within a React component, call `useAdminShefProfileQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShefProfileQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShefProfileQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminShefProfileQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminShefProfileQueryQuery, AdminShefProfileQueryQueryVariables> & ({ variables: AdminShefProfileQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminShefProfileQueryQuery, AdminShefProfileQueryQueryVariables>(AdminShefProfileQueryDocument, options);
      }
export function useAdminShefProfileQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminShefProfileQueryQuery, AdminShefProfileQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminShefProfileQueryQuery, AdminShefProfileQueryQueryVariables>(AdminShefProfileQueryDocument, options);
        }
export function useAdminShefProfileQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminShefProfileQueryQuery, AdminShefProfileQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminShefProfileQueryQuery, AdminShefProfileQueryQueryVariables>(AdminShefProfileQueryDocument, options);
        }
export type AdminShefProfileQueryQueryHookResult = ReturnType<typeof useAdminShefProfileQueryQuery>;
export type AdminShefProfileQueryLazyQueryHookResult = ReturnType<typeof useAdminShefProfileQueryLazyQuery>;
export type AdminShefProfileQuerySuspenseQueryHookResult = ReturnType<typeof useAdminShefProfileQuerySuspenseQuery>;
export type AdminShefProfileQueryQueryResult = ApolloReactCommon.QueryResult<AdminShefProfileQueryQuery, AdminShefProfileQueryQueryVariables>;
export const FhcInfoDocument = gql`
    query FHCInfo($shefId: String!) {
  shefProfile(userId: $shefId) {
    fhcExpiresAt
  }
}
    `;
export type FhcInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FhcInfoQuery, FhcInfoQueryVariables>, 'query'> & ({ variables: FhcInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FhcInfoComponent = (props: FhcInfoComponentProps) => (
      <ApolloReactComponents.Query<FhcInfoQuery, FhcInfoQueryVariables> query={FhcInfoDocument} {...props} />
    );
    

/**
 * __useFhcInfoQuery__
 *
 * To run a query within a React component, call `useFhcInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFhcInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFhcInfoQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useFhcInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FhcInfoQuery, FhcInfoQueryVariables> & ({ variables: FhcInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FhcInfoQuery, FhcInfoQueryVariables>(FhcInfoDocument, options);
      }
export function useFhcInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FhcInfoQuery, FhcInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FhcInfoQuery, FhcInfoQueryVariables>(FhcInfoDocument, options);
        }
export function useFhcInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FhcInfoQuery, FhcInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FhcInfoQuery, FhcInfoQueryVariables>(FhcInfoDocument, options);
        }
export type FhcInfoQueryHookResult = ReturnType<typeof useFhcInfoQuery>;
export type FhcInfoLazyQueryHookResult = ReturnType<typeof useFhcInfoLazyQuery>;
export type FhcInfoSuspenseQueryHookResult = ReturnType<typeof useFhcInfoSuspenseQuery>;
export type FhcInfoQueryResult = ApolloReactCommon.QueryResult<FhcInfoQuery, FhcInfoQueryVariables>;
export const ShefAvailabilityQueryDocument = gql`
    query ShefAvailabilityQuery($shefId: String!, $startDate: String!, $endDate: String!, $currentDate: String!) {
  shefProfile(userId: $shefId) {
    approvedAt
    timeZone
    cutoffMsBeforeDeliveryDate
    maxDishCapacity
    primaryRegion {
      mondayDelivery
      tuesdayDelivery
      wednesdayDelivery
      thursdayDelivery
      fridayDelivery
      saturdayDelivery
      sundayDelivery
      deliveryEnabledAt
      name
    }
    ...ShefHubInfo
    isTrialShef
  }
  shefAvailability(shefId: $shefId, dateFrom: $startDate, dateTo: $endDate) {
    id
    availabilityDate
    shefId
  }
  orders(shefId: $shefId, dateFrom: $startDate, dateTo: $endDate) {
    orders {
      ...AvailabilityOrderFields
    }
  }
  shefAvailabilityRules(shefId: $shefId, startDate: $startDate, endDate: $endDate) {
    id
    dateRange {
      begin
      end
      bounds
    }
    recurrenceRule
    isAvailable
    durationInMs
  }
  shefUnavailabilityRules: shefAvailabilityRules(
    shefId: $shefId
    startDate: $currentDate
    endDate: "2999-01-01"
    unavailable: true
  ) {
    id
    dateRange {
      begin
      end
      bounds
    }
    recurrenceRule
    isAvailable
    durationInMs
  }
  shefDaysOfWeekAvailabilityRule(shefId: $shefId) {
    id
    daysOfWeek {
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
    isPast
  }
}
    ${ShefHubInfoFragmentDoc}
${AvailabilityOrderFieldsFragmentDoc}`;
export type ShefAvailabilityQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefAvailabilityQueryQuery, ShefAvailabilityQueryQueryVariables>, 'query'> & ({ variables: ShefAvailabilityQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefAvailabilityQueryComponent = (props: ShefAvailabilityQueryComponentProps) => (
      <ApolloReactComponents.Query<ShefAvailabilityQueryQuery, ShefAvailabilityQueryQueryVariables> query={ShefAvailabilityQueryDocument} {...props} />
    );
    

/**
 * __useShefAvailabilityQueryQuery__
 *
 * To run a query within a React component, call `useShefAvailabilityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefAvailabilityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefAvailabilityQueryQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      currentDate: // value for 'currentDate'
 *   },
 * });
 */
export function useShefAvailabilityQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefAvailabilityQueryQuery, ShefAvailabilityQueryQueryVariables> & ({ variables: ShefAvailabilityQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefAvailabilityQueryQuery, ShefAvailabilityQueryQueryVariables>(ShefAvailabilityQueryDocument, options);
      }
export function useShefAvailabilityQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefAvailabilityQueryQuery, ShefAvailabilityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefAvailabilityQueryQuery, ShefAvailabilityQueryQueryVariables>(ShefAvailabilityQueryDocument, options);
        }
export function useShefAvailabilityQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefAvailabilityQueryQuery, ShefAvailabilityQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefAvailabilityQueryQuery, ShefAvailabilityQueryQueryVariables>(ShefAvailabilityQueryDocument, options);
        }
export type ShefAvailabilityQueryQueryHookResult = ReturnType<typeof useShefAvailabilityQueryQuery>;
export type ShefAvailabilityQueryLazyQueryHookResult = ReturnType<typeof useShefAvailabilityQueryLazyQuery>;
export type ShefAvailabilityQuerySuspenseQueryHookResult = ReturnType<typeof useShefAvailabilityQuerySuspenseQuery>;
export type ShefAvailabilityQueryQueryResult = ApolloReactCommon.QueryResult<ShefAvailabilityQueryQuery, ShefAvailabilityQueryQueryVariables>;
export const ModifyShefAvailabilityRulesMutationDocument = gql`
    mutation ModifyShefAvailabilityRulesMutation($shefId: String!, $daysOfWeek: ShefAvailabilityRuleDaysOfWeekInput, $add: [ShefAvailabilityRuleInput!], $end: [String!], $unavailableDates: [String!]) {
  modifyShefAvailabilityRules(
    shefId: $shefId
    daysOfWeek: $daysOfWeek
    add: $add
    end: $end
    unavailableDates: $unavailableDates
  )
}
    `;
export type ModifyShefAvailabilityRulesMutationMutationFn = ApolloReactCommon.MutationFunction<ModifyShefAvailabilityRulesMutationMutation, ModifyShefAvailabilityRulesMutationMutationVariables>;
export type ModifyShefAvailabilityRulesMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ModifyShefAvailabilityRulesMutationMutation, ModifyShefAvailabilityRulesMutationMutationVariables>, 'mutation'>;

    export const ModifyShefAvailabilityRulesMutationComponent = (props: ModifyShefAvailabilityRulesMutationComponentProps) => (
      <ApolloReactComponents.Mutation<ModifyShefAvailabilityRulesMutationMutation, ModifyShefAvailabilityRulesMutationMutationVariables> mutation={ModifyShefAvailabilityRulesMutationDocument} {...props} />
    );
    

/**
 * __useModifyShefAvailabilityRulesMutationMutation__
 *
 * To run a mutation, you first call `useModifyShefAvailabilityRulesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyShefAvailabilityRulesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyShefAvailabilityRulesMutationMutation, { data, loading, error }] = useModifyShefAvailabilityRulesMutationMutation({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      daysOfWeek: // value for 'daysOfWeek'
 *      add: // value for 'add'
 *      end: // value for 'end'
 *      unavailableDates: // value for 'unavailableDates'
 *   },
 * });
 */
export function useModifyShefAvailabilityRulesMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ModifyShefAvailabilityRulesMutationMutation, ModifyShefAvailabilityRulesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ModifyShefAvailabilityRulesMutationMutation, ModifyShefAvailabilityRulesMutationMutationVariables>(ModifyShefAvailabilityRulesMutationDocument, options);
      }
export type ModifyShefAvailabilityRulesMutationMutationHookResult = ReturnType<typeof useModifyShefAvailabilityRulesMutationMutation>;
export type ModifyShefAvailabilityRulesMutationMutationResult = ApolloReactCommon.MutationResult<ModifyShefAvailabilityRulesMutationMutation>;
export type ModifyShefAvailabilityRulesMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ModifyShefAvailabilityRulesMutationMutation, ModifyShefAvailabilityRulesMutationMutationVariables>;
export const ShefOrderBreakdownsDocument = gql`
    query ShefOrderBreakdowns($shefId: String!, $deliveryDateString: String!, $includeRefunded: Boolean!) {
  ordersByDate: ordersByFulfillmentDate(
    shefId: $shefId
    fulfillmentDate: $deliveryDateString
    includeRefunded: $includeRefunded
  ) {
    promoCode {
      code
      isPercentage
      promoCodeType
      value
    }
    ...OrderBreakdown
  }
  shef(userId: $shefId) {
    id
    shefProfile {
      id
      cutoffMsBeforeDeliveryDate
    }
  }
}
    ${OrderBreakdownFragmentDoc}`;
export type ShefOrderBreakdownsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefOrderBreakdownsQuery, ShefOrderBreakdownsQueryVariables>, 'query'> & ({ variables: ShefOrderBreakdownsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefOrderBreakdownsComponent = (props: ShefOrderBreakdownsComponentProps) => (
      <ApolloReactComponents.Query<ShefOrderBreakdownsQuery, ShefOrderBreakdownsQueryVariables> query={ShefOrderBreakdownsDocument} {...props} />
    );
    

/**
 * __useShefOrderBreakdownsQuery__
 *
 * To run a query within a React component, call `useShefOrderBreakdownsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefOrderBreakdownsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefOrderBreakdownsQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      deliveryDateString: // value for 'deliveryDateString'
 *      includeRefunded: // value for 'includeRefunded'
 *   },
 * });
 */
export function useShefOrderBreakdownsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefOrderBreakdownsQuery, ShefOrderBreakdownsQueryVariables> & ({ variables: ShefOrderBreakdownsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefOrderBreakdownsQuery, ShefOrderBreakdownsQueryVariables>(ShefOrderBreakdownsDocument, options);
      }
export function useShefOrderBreakdownsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefOrderBreakdownsQuery, ShefOrderBreakdownsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefOrderBreakdownsQuery, ShefOrderBreakdownsQueryVariables>(ShefOrderBreakdownsDocument, options);
        }
export function useShefOrderBreakdownsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefOrderBreakdownsQuery, ShefOrderBreakdownsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefOrderBreakdownsQuery, ShefOrderBreakdownsQueryVariables>(ShefOrderBreakdownsDocument, options);
        }
export type ShefOrderBreakdownsQueryHookResult = ReturnType<typeof useShefOrderBreakdownsQuery>;
export type ShefOrderBreakdownsLazyQueryHookResult = ReturnType<typeof useShefOrderBreakdownsLazyQuery>;
export type ShefOrderBreakdownsSuspenseQueryHookResult = ReturnType<typeof useShefOrderBreakdownsSuspenseQuery>;
export type ShefOrderBreakdownsQueryResult = ApolloReactCommon.QueryResult<ShefOrderBreakdownsQuery, ShefOrderBreakdownsQueryVariables>;
export const ShefOrderBreakdownsByFulfillmentDateDocument = gql`
    query ShefOrderBreakdownsByFulfillmentDate($shefId: String!, $fulfillmentDate: String!, $includeRefunded: Boolean!) {
  ordersByDate: ordersByFulfillmentDate(
    shefId: $shefId
    fulfillmentDate: $fulfillmentDate
    includeRefunded: $includeRefunded
  ) {
    promoCode {
      code
      isPercentage
      promoCodeType
      value
    }
    ...OrderBreakdown
  }
  shef(userId: $shefId) {
    id
    shefProfile {
      id
      cutoffMsBeforeDeliveryDate
      isMultiFulfillmentShef
      ...ShefHubInfo
    }
  }
}
    ${OrderBreakdownFragmentDoc}
${ShefHubInfoFragmentDoc}`;
export type ShefOrderBreakdownsByFulfillmentDateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefOrderBreakdownsByFulfillmentDateQuery, ShefOrderBreakdownsByFulfillmentDateQueryVariables>, 'query'> & ({ variables: ShefOrderBreakdownsByFulfillmentDateQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefOrderBreakdownsByFulfillmentDateComponent = (props: ShefOrderBreakdownsByFulfillmentDateComponentProps) => (
      <ApolloReactComponents.Query<ShefOrderBreakdownsByFulfillmentDateQuery, ShefOrderBreakdownsByFulfillmentDateQueryVariables> query={ShefOrderBreakdownsByFulfillmentDateDocument} {...props} />
    );
    

/**
 * __useShefOrderBreakdownsByFulfillmentDateQuery__
 *
 * To run a query within a React component, call `useShefOrderBreakdownsByFulfillmentDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefOrderBreakdownsByFulfillmentDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefOrderBreakdownsByFulfillmentDateQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      fulfillmentDate: // value for 'fulfillmentDate'
 *      includeRefunded: // value for 'includeRefunded'
 *   },
 * });
 */
export function useShefOrderBreakdownsByFulfillmentDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefOrderBreakdownsByFulfillmentDateQuery, ShefOrderBreakdownsByFulfillmentDateQueryVariables> & ({ variables: ShefOrderBreakdownsByFulfillmentDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefOrderBreakdownsByFulfillmentDateQuery, ShefOrderBreakdownsByFulfillmentDateQueryVariables>(ShefOrderBreakdownsByFulfillmentDateDocument, options);
      }
export function useShefOrderBreakdownsByFulfillmentDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefOrderBreakdownsByFulfillmentDateQuery, ShefOrderBreakdownsByFulfillmentDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefOrderBreakdownsByFulfillmentDateQuery, ShefOrderBreakdownsByFulfillmentDateQueryVariables>(ShefOrderBreakdownsByFulfillmentDateDocument, options);
        }
export function useShefOrderBreakdownsByFulfillmentDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefOrderBreakdownsByFulfillmentDateQuery, ShefOrderBreakdownsByFulfillmentDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefOrderBreakdownsByFulfillmentDateQuery, ShefOrderBreakdownsByFulfillmentDateQueryVariables>(ShefOrderBreakdownsByFulfillmentDateDocument, options);
        }
export type ShefOrderBreakdownsByFulfillmentDateQueryHookResult = ReturnType<typeof useShefOrderBreakdownsByFulfillmentDateQuery>;
export type ShefOrderBreakdownsByFulfillmentDateLazyQueryHookResult = ReturnType<typeof useShefOrderBreakdownsByFulfillmentDateLazyQuery>;
export type ShefOrderBreakdownsByFulfillmentDateSuspenseQueryHookResult = ReturnType<typeof useShefOrderBreakdownsByFulfillmentDateSuspenseQuery>;
export type ShefOrderBreakdownsByFulfillmentDateQueryResult = ApolloReactCommon.QueryResult<ShefOrderBreakdownsByFulfillmentDateQuery, ShefOrderBreakdownsByFulfillmentDateQueryVariables>;
export const ShefProfileDocument = gql`
    query ShefProfile($shefId: String!) {
  shefProfile(userId: $shefId) {
    id
    shef {
      id
      activeFoodItems {
        id
        imageUrl
        name
      }
    }
    ...ShefProfileEditShefProfile
  }
  shefApplication(userId: $shefId) {
    ...ShefProfilePicture
    isPickupAddressEnabled
  }
  possibleDeliveryHubsForShef(input: {shefId: $shefId}) {
    ...ShefProfileEditDeliveryHubs
  }
  cuisineCategories {
    id
    title
    type
  }
}
    ${ShefProfileEditShefProfileFragmentDoc}
${ShefProfilePictureFragmentDoc}
${ShefProfileEditDeliveryHubsFragmentDoc}`;
export type ShefProfileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefProfileQuery, ShefProfileQueryVariables>, 'query'> & ({ variables: ShefProfileQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefProfileComponent = (props: ShefProfileComponentProps) => (
      <ApolloReactComponents.Query<ShefProfileQuery, ShefProfileQueryVariables> query={ShefProfileDocument} {...props} />
    );
    

/**
 * __useShefProfileQuery__
 *
 * To run a query within a React component, call `useShefProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefProfileQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useShefProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefProfileQuery, ShefProfileQueryVariables> & ({ variables: ShefProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefProfileQuery, ShefProfileQueryVariables>(ShefProfileDocument, options);
      }
export function useShefProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefProfileQuery, ShefProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefProfileQuery, ShefProfileQueryVariables>(ShefProfileDocument, options);
        }
export function useShefProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefProfileQuery, ShefProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefProfileQuery, ShefProfileQueryVariables>(ShefProfileDocument, options);
        }
export type ShefProfileQueryHookResult = ReturnType<typeof useShefProfileQuery>;
export type ShefProfileLazyQueryHookResult = ReturnType<typeof useShefProfileLazyQuery>;
export type ShefProfileSuspenseQueryHookResult = ReturnType<typeof useShefProfileSuspenseQuery>;
export type ShefProfileQueryResult = ApolloReactCommon.QueryResult<ShefProfileQuery, ShefProfileQueryVariables>;
export const ShefProfileMutationDocument = gql`
    mutation ShefProfileMutation($shefProfileInput: ShefProfileInput!) {
  modifyShefProfile(shefProfileInput: $shefProfileInput) {
    id
  }
}
    `;
export type ShefProfileMutationMutationFn = ApolloReactCommon.MutationFunction<ShefProfileMutationMutation, ShefProfileMutationMutationVariables>;
export type ShefProfileMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShefProfileMutationMutation, ShefProfileMutationMutationVariables>, 'mutation'>;

    export const ShefProfileMutationComponent = (props: ShefProfileMutationComponentProps) => (
      <ApolloReactComponents.Mutation<ShefProfileMutationMutation, ShefProfileMutationMutationVariables> mutation={ShefProfileMutationDocument} {...props} />
    );
    

/**
 * __useShefProfileMutationMutation__
 *
 * To run a mutation, you first call `useShefProfileMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShefProfileMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shefProfileMutationMutation, { data, loading, error }] = useShefProfileMutationMutation({
 *   variables: {
 *      shefProfileInput: // value for 'shefProfileInput'
 *   },
 * });
 */
export function useShefProfileMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShefProfileMutationMutation, ShefProfileMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShefProfileMutationMutation, ShefProfileMutationMutationVariables>(ShefProfileMutationDocument, options);
      }
export type ShefProfileMutationMutationHookResult = ReturnType<typeof useShefProfileMutationMutation>;
export type ShefProfileMutationMutationResult = ApolloReactCommon.MutationResult<ShefProfileMutationMutation>;
export type ShefProfileMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ShefProfileMutationMutation, ShefProfileMutationMutationVariables>;
export const AdminDisconnectShefStripeDocument = gql`
    mutation AdminDisconnectShefStripe($userId: String!) {
  adminDisconnectShefStripe(userId: $userId)
}
    `;
export type AdminDisconnectShefStripeMutationFn = ApolloReactCommon.MutationFunction<AdminDisconnectShefStripeMutation, AdminDisconnectShefStripeMutationVariables>;
export type AdminDisconnectShefStripeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminDisconnectShefStripeMutation, AdminDisconnectShefStripeMutationVariables>, 'mutation'>;

    export const AdminDisconnectShefStripeComponent = (props: AdminDisconnectShefStripeComponentProps) => (
      <ApolloReactComponents.Mutation<AdminDisconnectShefStripeMutation, AdminDisconnectShefStripeMutationVariables> mutation={AdminDisconnectShefStripeDocument} {...props} />
    );
    

/**
 * __useAdminDisconnectShefStripeMutation__
 *
 * To run a mutation, you first call `useAdminDisconnectShefStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDisconnectShefStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDisconnectShefStripeMutation, { data, loading, error }] = useAdminDisconnectShefStripeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminDisconnectShefStripeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDisconnectShefStripeMutation, AdminDisconnectShefStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDisconnectShefStripeMutation, AdminDisconnectShefStripeMutationVariables>(AdminDisconnectShefStripeDocument, options);
      }
export type AdminDisconnectShefStripeMutationHookResult = ReturnType<typeof useAdminDisconnectShefStripeMutation>;
export type AdminDisconnectShefStripeMutationResult = ApolloReactCommon.MutationResult<AdminDisconnectShefStripeMutation>;
export type AdminDisconnectShefStripeMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminDisconnectShefStripeMutation, AdminDisconnectShefStripeMutationVariables>;
export const DisableFringeDocument = gql`
    mutation DisableFringe {
  disableFringe
}
    `;
export type DisableFringeMutationFn = ApolloReactCommon.MutationFunction<DisableFringeMutation, DisableFringeMutationVariables>;
export type DisableFringeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DisableFringeMutation, DisableFringeMutationVariables>, 'mutation'>;

    export const DisableFringeComponent = (props: DisableFringeComponentProps) => (
      <ApolloReactComponents.Mutation<DisableFringeMutation, DisableFringeMutationVariables> mutation={DisableFringeDocument} {...props} />
    );
    

/**
 * __useDisableFringeMutation__
 *
 * To run a mutation, you first call `useDisableFringeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableFringeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableFringeMutation, { data, loading, error }] = useDisableFringeMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableFringeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableFringeMutation, DisableFringeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableFringeMutation, DisableFringeMutationVariables>(DisableFringeDocument, options);
      }
export type DisableFringeMutationHookResult = ReturnType<typeof useDisableFringeMutation>;
export type DisableFringeMutationResult = ApolloReactCommon.MutationResult<DisableFringeMutation>;
export type DisableFringeMutationOptions = ApolloReactCommon.BaseMutationOptions<DisableFringeMutation, DisableFringeMutationVariables>;
export const UpdateShefApplicationProfileImagesDocument = gql`
    mutation UpdateShefApplicationProfileImages($shefId: String!, $profileImageInput: ShefApplicationProfileInput!) {
  updateShefApplicationProfileImages(
    shefId: $shefId
    profileImageInput: $profileImageInput
  )
}
    `;
export type UpdateShefApplicationProfileImagesMutationFn = ApolloReactCommon.MutationFunction<UpdateShefApplicationProfileImagesMutation, UpdateShefApplicationProfileImagesMutationVariables>;
export type UpdateShefApplicationProfileImagesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateShefApplicationProfileImagesMutation, UpdateShefApplicationProfileImagesMutationVariables>, 'mutation'>;

    export const UpdateShefApplicationProfileImagesComponent = (props: UpdateShefApplicationProfileImagesComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateShefApplicationProfileImagesMutation, UpdateShefApplicationProfileImagesMutationVariables> mutation={UpdateShefApplicationProfileImagesDocument} {...props} />
    );
    

/**
 * __useUpdateShefApplicationProfileImagesMutation__
 *
 * To run a mutation, you first call `useUpdateShefApplicationProfileImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShefApplicationProfileImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShefApplicationProfileImagesMutation, { data, loading, error }] = useUpdateShefApplicationProfileImagesMutation({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      profileImageInput: // value for 'profileImageInput'
 *   },
 * });
 */
export function useUpdateShefApplicationProfileImagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShefApplicationProfileImagesMutation, UpdateShefApplicationProfileImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateShefApplicationProfileImagesMutation, UpdateShefApplicationProfileImagesMutationVariables>(UpdateShefApplicationProfileImagesDocument, options);
      }
export type UpdateShefApplicationProfileImagesMutationHookResult = ReturnType<typeof useUpdateShefApplicationProfileImagesMutation>;
export type UpdateShefApplicationProfileImagesMutationResult = ApolloReactCommon.MutationResult<UpdateShefApplicationProfileImagesMutation>;
export type UpdateShefApplicationProfileImagesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateShefApplicationProfileImagesMutation, UpdateShefApplicationProfileImagesMutationVariables>;
export const GetNewLocationInfoDocument = gql`
    query GetNewLocationInfo($zipCode: String!) {
  zipCode(zipCode: $zipCode) {
    zipCode
    regionId
    region {
      isHubless
      displayName
      launchedAt
    }
  }
}
    `;
export type GetNewLocationInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNewLocationInfoQuery, GetNewLocationInfoQueryVariables>, 'query'> & ({ variables: GetNewLocationInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNewLocationInfoComponent = (props: GetNewLocationInfoComponentProps) => (
      <ApolloReactComponents.Query<GetNewLocationInfoQuery, GetNewLocationInfoQueryVariables> query={GetNewLocationInfoDocument} {...props} />
    );
    

/**
 * __useGetNewLocationInfoQuery__
 *
 * To run a query within a React component, call `useGetNewLocationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewLocationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewLocationInfoQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useGetNewLocationInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNewLocationInfoQuery, GetNewLocationInfoQueryVariables> & ({ variables: GetNewLocationInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNewLocationInfoQuery, GetNewLocationInfoQueryVariables>(GetNewLocationInfoDocument, options);
      }
export function useGetNewLocationInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewLocationInfoQuery, GetNewLocationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNewLocationInfoQuery, GetNewLocationInfoQueryVariables>(GetNewLocationInfoDocument, options);
        }
export function useGetNewLocationInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNewLocationInfoQuery, GetNewLocationInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNewLocationInfoQuery, GetNewLocationInfoQueryVariables>(GetNewLocationInfoDocument, options);
        }
export type GetNewLocationInfoQueryHookResult = ReturnType<typeof useGetNewLocationInfoQuery>;
export type GetNewLocationInfoLazyQueryHookResult = ReturnType<typeof useGetNewLocationInfoLazyQuery>;
export type GetNewLocationInfoSuspenseQueryHookResult = ReturnType<typeof useGetNewLocationInfoSuspenseQuery>;
export type GetNewLocationInfoQueryResult = ApolloReactCommon.QueryResult<GetNewLocationInfoQuery, GetNewLocationInfoQueryVariables>;
export const UpdateShefLocationDocument = gql`
    mutation UpdateShefLocation($zipCode: String!) {
  updateShefZipCode(newZipCode: $zipCode)
}
    `;
export type UpdateShefLocationMutationFn = ApolloReactCommon.MutationFunction<UpdateShefLocationMutation, UpdateShefLocationMutationVariables>;
export type UpdateShefLocationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateShefLocationMutation, UpdateShefLocationMutationVariables>, 'mutation'>;

    export const UpdateShefLocationComponent = (props: UpdateShefLocationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateShefLocationMutation, UpdateShefLocationMutationVariables> mutation={UpdateShefLocationDocument} {...props} />
    );
    

/**
 * __useUpdateShefLocationMutation__
 *
 * To run a mutation, you first call `useUpdateShefLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShefLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShefLocationMutation, { data, loading, error }] = useUpdateShefLocationMutation({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useUpdateShefLocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShefLocationMutation, UpdateShefLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateShefLocationMutation, UpdateShefLocationMutationVariables>(UpdateShefLocationDocument, options);
      }
export type UpdateShefLocationMutationHookResult = ReturnType<typeof useUpdateShefLocationMutation>;
export type UpdateShefLocationMutationResult = ApolloReactCommon.MutationResult<UpdateShefLocationMutation>;
export type UpdateShefLocationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateShefLocationMutation, UpdateShefLocationMutationVariables>;
export const FringeDeliveryOptInDocument = gql`
    query FringeDeliveryOptIn {
  shefProfile {
    canOptInToFringe
    timeWindowOptionsForShef {
      id
      startMsAfterMidnight
      endMsAfterMidnight
    }
  }
}
    `;
export type FringeDeliveryOptInComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FringeDeliveryOptInQuery, FringeDeliveryOptInQueryVariables>, 'query'>;

    export const FringeDeliveryOptInComponent = (props: FringeDeliveryOptInComponentProps) => (
      <ApolloReactComponents.Query<FringeDeliveryOptInQuery, FringeDeliveryOptInQueryVariables> query={FringeDeliveryOptInDocument} {...props} />
    );
    

/**
 * __useFringeDeliveryOptInQuery__
 *
 * To run a query within a React component, call `useFringeDeliveryOptInQuery` and pass it any options that fit your needs.
 * When your component renders, `useFringeDeliveryOptInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFringeDeliveryOptInQuery({
 *   variables: {
 *   },
 * });
 */
export function useFringeDeliveryOptInQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FringeDeliveryOptInQuery, FringeDeliveryOptInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FringeDeliveryOptInQuery, FringeDeliveryOptInQueryVariables>(FringeDeliveryOptInDocument, options);
      }
export function useFringeDeliveryOptInLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FringeDeliveryOptInQuery, FringeDeliveryOptInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FringeDeliveryOptInQuery, FringeDeliveryOptInQueryVariables>(FringeDeliveryOptInDocument, options);
        }
export function useFringeDeliveryOptInSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FringeDeliveryOptInQuery, FringeDeliveryOptInQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FringeDeliveryOptInQuery, FringeDeliveryOptInQueryVariables>(FringeDeliveryOptInDocument, options);
        }
export type FringeDeliveryOptInQueryHookResult = ReturnType<typeof useFringeDeliveryOptInQuery>;
export type FringeDeliveryOptInLazyQueryHookResult = ReturnType<typeof useFringeDeliveryOptInLazyQuery>;
export type FringeDeliveryOptInSuspenseQueryHookResult = ReturnType<typeof useFringeDeliveryOptInSuspenseQuery>;
export type FringeDeliveryOptInQueryResult = ApolloReactCommon.QueryResult<FringeDeliveryOptInQuery, FringeDeliveryOptInQueryVariables>;
export const ShefFulfillmentInfoDocument = gql`
    query ShefFulfillmentInfo {
  shefProfile {
    fulfillmentOption
    shefAddress {
      ...GenericAddressFields
      googlePlaceId
    }
    timeWindowOptionsForShef {
      id
      startMsAfterMidnight
      endMsAfterMidnight
    }
    timeWindowsSelectedByShef {
      id
      startMsAfterMidnight
      endMsAfterMidnight
    }
    availableFulfillmentOptions
    canOptOutOfFringe
    canOptInToFringe
    primaryRegion {
      id
    }
  }
}
    ${GenericAddressFieldsFragmentDoc}`;
export type ShefFulfillmentInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefFulfillmentInfoQuery, ShefFulfillmentInfoQueryVariables>, 'query'>;

    export const ShefFulfillmentInfoComponent = (props: ShefFulfillmentInfoComponentProps) => (
      <ApolloReactComponents.Query<ShefFulfillmentInfoQuery, ShefFulfillmentInfoQueryVariables> query={ShefFulfillmentInfoDocument} {...props} />
    );
    

/**
 * __useShefFulfillmentInfoQuery__
 *
 * To run a query within a React component, call `useShefFulfillmentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefFulfillmentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefFulfillmentInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useShefFulfillmentInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShefFulfillmentInfoQuery, ShefFulfillmentInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefFulfillmentInfoQuery, ShefFulfillmentInfoQueryVariables>(ShefFulfillmentInfoDocument, options);
      }
export function useShefFulfillmentInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefFulfillmentInfoQuery, ShefFulfillmentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefFulfillmentInfoQuery, ShefFulfillmentInfoQueryVariables>(ShefFulfillmentInfoDocument, options);
        }
export function useShefFulfillmentInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefFulfillmentInfoQuery, ShefFulfillmentInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefFulfillmentInfoQuery, ShefFulfillmentInfoQueryVariables>(ShefFulfillmentInfoDocument, options);
        }
export type ShefFulfillmentInfoQueryHookResult = ReturnType<typeof useShefFulfillmentInfoQuery>;
export type ShefFulfillmentInfoLazyQueryHookResult = ReturnType<typeof useShefFulfillmentInfoLazyQuery>;
export type ShefFulfillmentInfoSuspenseQueryHookResult = ReturnType<typeof useShefFulfillmentInfoSuspenseQuery>;
export type ShefFulfillmentInfoQueryResult = ApolloReactCommon.QueryResult<ShefFulfillmentInfoQuery, ShefFulfillmentInfoQueryVariables>;
export const ModifyShefFulfillmentInfoDocument = gql`
    mutation ModifyShefFulfillmentInfo($input: FulfillmentInput!) {
  modifyShefFulfillmentInfo(input: $input)
}
    `;
export type ModifyShefFulfillmentInfoMutationFn = ApolloReactCommon.MutationFunction<ModifyShefFulfillmentInfoMutation, ModifyShefFulfillmentInfoMutationVariables>;
export type ModifyShefFulfillmentInfoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ModifyShefFulfillmentInfoMutation, ModifyShefFulfillmentInfoMutationVariables>, 'mutation'>;

    export const ModifyShefFulfillmentInfoComponent = (props: ModifyShefFulfillmentInfoComponentProps) => (
      <ApolloReactComponents.Mutation<ModifyShefFulfillmentInfoMutation, ModifyShefFulfillmentInfoMutationVariables> mutation={ModifyShefFulfillmentInfoDocument} {...props} />
    );
    

/**
 * __useModifyShefFulfillmentInfoMutation__
 *
 * To run a mutation, you first call `useModifyShefFulfillmentInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyShefFulfillmentInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyShefFulfillmentInfoMutation, { data, loading, error }] = useModifyShefFulfillmentInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyShefFulfillmentInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ModifyShefFulfillmentInfoMutation, ModifyShefFulfillmentInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ModifyShefFulfillmentInfoMutation, ModifyShefFulfillmentInfoMutationVariables>(ModifyShefFulfillmentInfoDocument, options);
      }
export type ModifyShefFulfillmentInfoMutationHookResult = ReturnType<typeof useModifyShefFulfillmentInfoMutation>;
export type ModifyShefFulfillmentInfoMutationResult = ApolloReactCommon.MutationResult<ModifyShefFulfillmentInfoMutation>;
export type ModifyShefFulfillmentInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<ModifyShefFulfillmentInfoMutation, ModifyShefFulfillmentInfoMutationVariables>;
export const ShefRegionDocument = gql`
    query ShefRegion($shefId: String!) {
  shefProfile(userId: $shefId) {
    id
    primaryRegion {
      id
      isPickupEnabled
    }
  }
}
    `;
export type ShefRegionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefRegionQuery, ShefRegionQueryVariables>, 'query'> & ({ variables: ShefRegionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefRegionComponent = (props: ShefRegionComponentProps) => (
      <ApolloReactComponents.Query<ShefRegionQuery, ShefRegionQueryVariables> query={ShefRegionDocument} {...props} />
    );
    

/**
 * __useShefRegionQuery__
 *
 * To run a query within a React component, call `useShefRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefRegionQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useShefRegionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefRegionQuery, ShefRegionQueryVariables> & ({ variables: ShefRegionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefRegionQuery, ShefRegionQueryVariables>(ShefRegionDocument, options);
      }
export function useShefRegionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefRegionQuery, ShefRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefRegionQuery, ShefRegionQueryVariables>(ShefRegionDocument, options);
        }
export function useShefRegionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefRegionQuery, ShefRegionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefRegionQuery, ShefRegionQueryVariables>(ShefRegionDocument, options);
        }
export type ShefRegionQueryHookResult = ReturnType<typeof useShefRegionQuery>;
export type ShefRegionLazyQueryHookResult = ReturnType<typeof useShefRegionLazyQuery>;
export type ShefRegionSuspenseQueryHookResult = ReturnType<typeof useShefRegionSuspenseQuery>;
export type ShefRegionQueryResult = ApolloReactCommon.QueryResult<ShefRegionQuery, ShefRegionQueryVariables>;
export const ConsumerGroupOrderRatingDocument = gql`
    query ConsumerGroupOrderRating($groupOrderIds: [String!]!) {
  groupOrdersByIds(groupOrderIds: $groupOrderIds) {
    ...ConsumerGroupOrderFields
  }
  tagsForConsumer {
    positiveFoodTags
    negativeFoodTags
    ignoreFoodTags
  }
}
    ${ConsumerGroupOrderFieldsFragmentDoc}`;
export type ConsumerGroupOrderRatingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerGroupOrderRatingQuery, ConsumerGroupOrderRatingQueryVariables>, 'query'> & ({ variables: ConsumerGroupOrderRatingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConsumerGroupOrderRatingComponent = (props: ConsumerGroupOrderRatingComponentProps) => (
      <ApolloReactComponents.Query<ConsumerGroupOrderRatingQuery, ConsumerGroupOrderRatingQueryVariables> query={ConsumerGroupOrderRatingDocument} {...props} />
    );
    

/**
 * __useConsumerGroupOrderRatingQuery__
 *
 * To run a query within a React component, call `useConsumerGroupOrderRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerGroupOrderRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerGroupOrderRatingQuery({
 *   variables: {
 *      groupOrderIds: // value for 'groupOrderIds'
 *   },
 * });
 */
export function useConsumerGroupOrderRatingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConsumerGroupOrderRatingQuery, ConsumerGroupOrderRatingQueryVariables> & ({ variables: ConsumerGroupOrderRatingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerGroupOrderRatingQuery, ConsumerGroupOrderRatingQueryVariables>(ConsumerGroupOrderRatingDocument, options);
      }
export function useConsumerGroupOrderRatingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerGroupOrderRatingQuery, ConsumerGroupOrderRatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerGroupOrderRatingQuery, ConsumerGroupOrderRatingQueryVariables>(ConsumerGroupOrderRatingDocument, options);
        }
export function useConsumerGroupOrderRatingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerGroupOrderRatingQuery, ConsumerGroupOrderRatingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerGroupOrderRatingQuery, ConsumerGroupOrderRatingQueryVariables>(ConsumerGroupOrderRatingDocument, options);
        }
export type ConsumerGroupOrderRatingQueryHookResult = ReturnType<typeof useConsumerGroupOrderRatingQuery>;
export type ConsumerGroupOrderRatingLazyQueryHookResult = ReturnType<typeof useConsumerGroupOrderRatingLazyQuery>;
export type ConsumerGroupOrderRatingSuspenseQueryHookResult = ReturnType<typeof useConsumerGroupOrderRatingSuspenseQuery>;
export type ConsumerGroupOrderRatingQueryResult = ApolloReactCommon.QueryResult<ConsumerGroupOrderRatingQuery, ConsumerGroupOrderRatingQueryVariables>;
export const ConsumerSubmitGroupOrderRatingDocument = gql`
    mutation ConsumerSubmitGroupOrderRating($input: GroupOrderRatingInput!) {
  addGroupOrderRating(input: $input) {
    groupOrder {
      id
      review {
        status
      }
      orders {
        ...UpcomingOrderFields
      }
    }
  }
}
    ${UpcomingOrderFieldsFragmentDoc}`;
export type ConsumerSubmitGroupOrderRatingMutationFn = ApolloReactCommon.MutationFunction<ConsumerSubmitGroupOrderRatingMutation, ConsumerSubmitGroupOrderRatingMutationVariables>;
export type ConsumerSubmitGroupOrderRatingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConsumerSubmitGroupOrderRatingMutation, ConsumerSubmitGroupOrderRatingMutationVariables>, 'mutation'>;

    export const ConsumerSubmitGroupOrderRatingComponent = (props: ConsumerSubmitGroupOrderRatingComponentProps) => (
      <ApolloReactComponents.Mutation<ConsumerSubmitGroupOrderRatingMutation, ConsumerSubmitGroupOrderRatingMutationVariables> mutation={ConsumerSubmitGroupOrderRatingDocument} {...props} />
    );
    

/**
 * __useConsumerSubmitGroupOrderRatingMutation__
 *
 * To run a mutation, you first call `useConsumerSubmitGroupOrderRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerSubmitGroupOrderRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerSubmitGroupOrderRatingMutation, { data, loading, error }] = useConsumerSubmitGroupOrderRatingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerSubmitGroupOrderRatingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConsumerSubmitGroupOrderRatingMutation, ConsumerSubmitGroupOrderRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConsumerSubmitGroupOrderRatingMutation, ConsumerSubmitGroupOrderRatingMutationVariables>(ConsumerSubmitGroupOrderRatingDocument, options);
      }
export type ConsumerSubmitGroupOrderRatingMutationHookResult = ReturnType<typeof useConsumerSubmitGroupOrderRatingMutation>;
export type ConsumerSubmitGroupOrderRatingMutationResult = ApolloReactCommon.MutationResult<ConsumerSubmitGroupOrderRatingMutation>;
export type ConsumerSubmitGroupOrderRatingMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumerSubmitGroupOrderRatingMutation, ConsumerSubmitGroupOrderRatingMutationVariables>;
export const ConsumerDeliveryAddressesDocument = gql`
    query ConsumerDeliveryAddresses {
  me {
    id
    activeAddresses {
      ...DeliveryAddressFields
    }
    publicName
  }
}
    ${DeliveryAddressFieldsFragmentDoc}`;
export type ConsumerDeliveryAddressesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerDeliveryAddressesQuery, ConsumerDeliveryAddressesQueryVariables>, 'query'>;

    export const ConsumerDeliveryAddressesComponent = (props: ConsumerDeliveryAddressesComponentProps) => (
      <ApolloReactComponents.Query<ConsumerDeliveryAddressesQuery, ConsumerDeliveryAddressesQueryVariables> query={ConsumerDeliveryAddressesDocument} {...props} />
    );
    

/**
 * __useConsumerDeliveryAddressesQuery__
 *
 * To run a query within a React component, call `useConsumerDeliveryAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerDeliveryAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerDeliveryAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsumerDeliveryAddressesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConsumerDeliveryAddressesQuery, ConsumerDeliveryAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerDeliveryAddressesQuery, ConsumerDeliveryAddressesQueryVariables>(ConsumerDeliveryAddressesDocument, options);
      }
export function useConsumerDeliveryAddressesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerDeliveryAddressesQuery, ConsumerDeliveryAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerDeliveryAddressesQuery, ConsumerDeliveryAddressesQueryVariables>(ConsumerDeliveryAddressesDocument, options);
        }
export function useConsumerDeliveryAddressesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerDeliveryAddressesQuery, ConsumerDeliveryAddressesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerDeliveryAddressesQuery, ConsumerDeliveryAddressesQueryVariables>(ConsumerDeliveryAddressesDocument, options);
        }
export type ConsumerDeliveryAddressesQueryHookResult = ReturnType<typeof useConsumerDeliveryAddressesQuery>;
export type ConsumerDeliveryAddressesLazyQueryHookResult = ReturnType<typeof useConsumerDeliveryAddressesLazyQuery>;
export type ConsumerDeliveryAddressesSuspenseQueryHookResult = ReturnType<typeof useConsumerDeliveryAddressesSuspenseQuery>;
export type ConsumerDeliveryAddressesQueryResult = ApolloReactCommon.QueryResult<ConsumerDeliveryAddressesQuery, ConsumerDeliveryAddressesQueryVariables>;
export const ConsumerArchiveDeliveryAddressDocument = gql`
    mutation ConsumerArchiveDeliveryAddress($addressId: Int!) {
  archiveDeliveryAddress(addressId: $addressId)
}
    `;
export type ConsumerArchiveDeliveryAddressMutationFn = ApolloReactCommon.MutationFunction<ConsumerArchiveDeliveryAddressMutation, ConsumerArchiveDeliveryAddressMutationVariables>;
export type ConsumerArchiveDeliveryAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConsumerArchiveDeliveryAddressMutation, ConsumerArchiveDeliveryAddressMutationVariables>, 'mutation'>;

    export const ConsumerArchiveDeliveryAddressComponent = (props: ConsumerArchiveDeliveryAddressComponentProps) => (
      <ApolloReactComponents.Mutation<ConsumerArchiveDeliveryAddressMutation, ConsumerArchiveDeliveryAddressMutationVariables> mutation={ConsumerArchiveDeliveryAddressDocument} {...props} />
    );
    

/**
 * __useConsumerArchiveDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useConsumerArchiveDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerArchiveDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerArchiveDeliveryAddressMutation, { data, loading, error }] = useConsumerArchiveDeliveryAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useConsumerArchiveDeliveryAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConsumerArchiveDeliveryAddressMutation, ConsumerArchiveDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConsumerArchiveDeliveryAddressMutation, ConsumerArchiveDeliveryAddressMutationVariables>(ConsumerArchiveDeliveryAddressDocument, options);
      }
export type ConsumerArchiveDeliveryAddressMutationHookResult = ReturnType<typeof useConsumerArchiveDeliveryAddressMutation>;
export type ConsumerArchiveDeliveryAddressMutationResult = ApolloReactCommon.MutationResult<ConsumerArchiveDeliveryAddressMutation>;
export type ConsumerArchiveDeliveryAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumerArchiveDeliveryAddressMutation, ConsumerArchiveDeliveryAddressMutationVariables>;
export const GetShefToMessageDocument = gql`
    query GetShefToMessage($shefId: String!) {
  shef(userId: $shefId) {
    ...ShefToMessage
  }
}
    ${ShefToMessageFragmentDoc}`;
export type GetShefToMessageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShefToMessageQuery, GetShefToMessageQueryVariables>, 'query'> & ({ variables: GetShefToMessageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetShefToMessageComponent = (props: GetShefToMessageComponentProps) => (
      <ApolloReactComponents.Query<GetShefToMessageQuery, GetShefToMessageQueryVariables> query={GetShefToMessageDocument} {...props} />
    );
    

/**
 * __useGetShefToMessageQuery__
 *
 * To run a query within a React component, call `useGetShefToMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShefToMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShefToMessageQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useGetShefToMessageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetShefToMessageQuery, GetShefToMessageQueryVariables> & ({ variables: GetShefToMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetShefToMessageQuery, GetShefToMessageQueryVariables>(GetShefToMessageDocument, options);
      }
export function useGetShefToMessageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShefToMessageQuery, GetShefToMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetShefToMessageQuery, GetShefToMessageQueryVariables>(GetShefToMessageDocument, options);
        }
export function useGetShefToMessageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetShefToMessageQuery, GetShefToMessageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetShefToMessageQuery, GetShefToMessageQueryVariables>(GetShefToMessageDocument, options);
        }
export type GetShefToMessageQueryHookResult = ReturnType<typeof useGetShefToMessageQuery>;
export type GetShefToMessageLazyQueryHookResult = ReturnType<typeof useGetShefToMessageLazyQuery>;
export type GetShefToMessageSuspenseQueryHookResult = ReturnType<typeof useGetShefToMessageSuspenseQuery>;
export type GetShefToMessageQueryResult = ApolloReactCommon.QueryResult<GetShefToMessageQuery, GetShefToMessageQueryVariables>;
export const RegionAvailabilityForDeliveryDateDocument = gql`
    query RegionAvailabilityForDeliveryDate($regionId: Int!, $deliveryDate: String!) {
  regionAvailabilityForDeliveryDate(
    regionId: $regionId
    deliveryDate: $deliveryDate
  ) {
    startDate
    endDate
    isAvailable
  }
}
    `;
export type RegionAvailabilityForDeliveryDateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RegionAvailabilityForDeliveryDateQuery, RegionAvailabilityForDeliveryDateQueryVariables>, 'query'> & ({ variables: RegionAvailabilityForDeliveryDateQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegionAvailabilityForDeliveryDateComponent = (props: RegionAvailabilityForDeliveryDateComponentProps) => (
      <ApolloReactComponents.Query<RegionAvailabilityForDeliveryDateQuery, RegionAvailabilityForDeliveryDateQueryVariables> query={RegionAvailabilityForDeliveryDateDocument} {...props} />
    );
    

/**
 * __useRegionAvailabilityForDeliveryDateQuery__
 *
 * To run a query within a React component, call `useRegionAvailabilityForDeliveryDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionAvailabilityForDeliveryDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionAvailabilityForDeliveryDateQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useRegionAvailabilityForDeliveryDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegionAvailabilityForDeliveryDateQuery, RegionAvailabilityForDeliveryDateQueryVariables> & ({ variables: RegionAvailabilityForDeliveryDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegionAvailabilityForDeliveryDateQuery, RegionAvailabilityForDeliveryDateQueryVariables>(RegionAvailabilityForDeliveryDateDocument, options);
      }
export function useRegionAvailabilityForDeliveryDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegionAvailabilityForDeliveryDateQuery, RegionAvailabilityForDeliveryDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegionAvailabilityForDeliveryDateQuery, RegionAvailabilityForDeliveryDateQueryVariables>(RegionAvailabilityForDeliveryDateDocument, options);
        }
export function useRegionAvailabilityForDeliveryDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegionAvailabilityForDeliveryDateQuery, RegionAvailabilityForDeliveryDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegionAvailabilityForDeliveryDateQuery, RegionAvailabilityForDeliveryDateQueryVariables>(RegionAvailabilityForDeliveryDateDocument, options);
        }
export type RegionAvailabilityForDeliveryDateQueryHookResult = ReturnType<typeof useRegionAvailabilityForDeliveryDateQuery>;
export type RegionAvailabilityForDeliveryDateLazyQueryHookResult = ReturnType<typeof useRegionAvailabilityForDeliveryDateLazyQuery>;
export type RegionAvailabilityForDeliveryDateSuspenseQueryHookResult = ReturnType<typeof useRegionAvailabilityForDeliveryDateSuspenseQuery>;
export type RegionAvailabilityForDeliveryDateQueryResult = ApolloReactCommon.QueryResult<RegionAvailabilityForDeliveryDateQuery, RegionAvailabilityForDeliveryDateQueryVariables>;
export const UpcomingOrdersDocument = gql`
    query UpcomingOrders($userId: String) {
  orders(userId: $userId) {
    orders {
      ...UpcomingOrderFields
    }
  }
}
    ${UpcomingOrderFieldsFragmentDoc}`;
export type UpcomingOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UpcomingOrdersQuery, UpcomingOrdersQueryVariables>, 'query'>;

    export const UpcomingOrdersComponent = (props: UpcomingOrdersComponentProps) => (
      <ApolloReactComponents.Query<UpcomingOrdersQuery, UpcomingOrdersQueryVariables> query={UpcomingOrdersDocument} {...props} />
    );
    

/**
 * __useUpcomingOrdersQuery__
 *
 * To run a query within a React component, call `useUpcomingOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingOrdersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpcomingOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UpcomingOrdersQuery, UpcomingOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UpcomingOrdersQuery, UpcomingOrdersQueryVariables>(UpcomingOrdersDocument, options);
      }
export function useUpcomingOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UpcomingOrdersQuery, UpcomingOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UpcomingOrdersQuery, UpcomingOrdersQueryVariables>(UpcomingOrdersDocument, options);
        }
export function useUpcomingOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UpcomingOrdersQuery, UpcomingOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UpcomingOrdersQuery, UpcomingOrdersQueryVariables>(UpcomingOrdersDocument, options);
        }
export type UpcomingOrdersQueryHookResult = ReturnType<typeof useUpcomingOrdersQuery>;
export type UpcomingOrdersLazyQueryHookResult = ReturnType<typeof useUpcomingOrdersLazyQuery>;
export type UpcomingOrdersSuspenseQueryHookResult = ReturnType<typeof useUpcomingOrdersSuspenseQuery>;
export type UpcomingOrdersQueryResult = ApolloReactCommon.QueryResult<UpcomingOrdersQuery, UpcomingOrdersQueryVariables>;
export const PreviousGroupOrdersDocument = gql`
    query PreviousGroupOrders($first: Int! = 10, $after: ID) {
  previousGroupOrders(first: $first, after: $after) {
    edges {
      node {
        ...ConsumerGroupOrderFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    ${ConsumerGroupOrderFieldsFragmentDoc}`;
export type PreviousGroupOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PreviousGroupOrdersQuery, PreviousGroupOrdersQueryVariables>, 'query'>;

    export const PreviousGroupOrdersComponent = (props: PreviousGroupOrdersComponentProps) => (
      <ApolloReactComponents.Query<PreviousGroupOrdersQuery, PreviousGroupOrdersQueryVariables> query={PreviousGroupOrdersDocument} {...props} />
    );
    

/**
 * __usePreviousGroupOrdersQuery__
 *
 * To run a query within a React component, call `usePreviousGroupOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviousGroupOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviousGroupOrdersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePreviousGroupOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PreviousGroupOrdersQuery, PreviousGroupOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PreviousGroupOrdersQuery, PreviousGroupOrdersQueryVariables>(PreviousGroupOrdersDocument, options);
      }
export function usePreviousGroupOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PreviousGroupOrdersQuery, PreviousGroupOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PreviousGroupOrdersQuery, PreviousGroupOrdersQueryVariables>(PreviousGroupOrdersDocument, options);
        }
export function usePreviousGroupOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PreviousGroupOrdersQuery, PreviousGroupOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PreviousGroupOrdersQuery, PreviousGroupOrdersQueryVariables>(PreviousGroupOrdersDocument, options);
        }
export type PreviousGroupOrdersQueryHookResult = ReturnType<typeof usePreviousGroupOrdersQuery>;
export type PreviousGroupOrdersLazyQueryHookResult = ReturnType<typeof usePreviousGroupOrdersLazyQuery>;
export type PreviousGroupOrdersSuspenseQueryHookResult = ReturnType<typeof usePreviousGroupOrdersSuspenseQuery>;
export type PreviousGroupOrdersQueryResult = ApolloReactCommon.QueryResult<PreviousGroupOrdersQuery, PreviousGroupOrdersQueryVariables>;
export const UpcomingGroupOrdersDocument = gql`
    query UpcomingGroupOrders($first: Int! = 10, $after: ID) {
  upcomingGroupOrders(first: $first, after: $after) {
    edges {
      node {
        ...ConsumerGroupOrderFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    ${ConsumerGroupOrderFieldsFragmentDoc}`;
export type UpcomingGroupOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UpcomingGroupOrdersQuery, UpcomingGroupOrdersQueryVariables>, 'query'>;

    export const UpcomingGroupOrdersComponent = (props: UpcomingGroupOrdersComponentProps) => (
      <ApolloReactComponents.Query<UpcomingGroupOrdersQuery, UpcomingGroupOrdersQueryVariables> query={UpcomingGroupOrdersDocument} {...props} />
    );
    

/**
 * __useUpcomingGroupOrdersQuery__
 *
 * To run a query within a React component, call `useUpcomingGroupOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingGroupOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingGroupOrdersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUpcomingGroupOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UpcomingGroupOrdersQuery, UpcomingGroupOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UpcomingGroupOrdersQuery, UpcomingGroupOrdersQueryVariables>(UpcomingGroupOrdersDocument, options);
      }
export function useUpcomingGroupOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UpcomingGroupOrdersQuery, UpcomingGroupOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UpcomingGroupOrdersQuery, UpcomingGroupOrdersQueryVariables>(UpcomingGroupOrdersDocument, options);
        }
export function useUpcomingGroupOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UpcomingGroupOrdersQuery, UpcomingGroupOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UpcomingGroupOrdersQuery, UpcomingGroupOrdersQueryVariables>(UpcomingGroupOrdersDocument, options);
        }
export type UpcomingGroupOrdersQueryHookResult = ReturnType<typeof useUpcomingGroupOrdersQuery>;
export type UpcomingGroupOrdersLazyQueryHookResult = ReturnType<typeof useUpcomingGroupOrdersLazyQuery>;
export type UpcomingGroupOrdersSuspenseQueryHookResult = ReturnType<typeof useUpcomingGroupOrdersSuspenseQuery>;
export type UpcomingGroupOrdersQueryResult = ApolloReactCommon.QueryResult<UpcomingGroupOrdersQuery, UpcomingGroupOrdersQueryVariables>;
export const ActiveMealPlanDocument = gql`
    query ActiveMealPlan {
  getActiveMealPlanForUser {
    id
    status
    mealPlanType {
      unit
      numServings
      weeklyCost
      format
    }
  }
}
    `;
export type ActiveMealPlanComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ActiveMealPlanQuery, ActiveMealPlanQueryVariables>, 'query'>;

    export const ActiveMealPlanComponent = (props: ActiveMealPlanComponentProps) => (
      <ApolloReactComponents.Query<ActiveMealPlanQuery, ActiveMealPlanQueryVariables> query={ActiveMealPlanDocument} {...props} />
    );
    

/**
 * __useActiveMealPlanQuery__
 *
 * To run a query within a React component, call `useActiveMealPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveMealPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveMealPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveMealPlanQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveMealPlanQuery, ActiveMealPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveMealPlanQuery, ActiveMealPlanQueryVariables>(ActiveMealPlanDocument, options);
      }
export function useActiveMealPlanLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveMealPlanQuery, ActiveMealPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveMealPlanQuery, ActiveMealPlanQueryVariables>(ActiveMealPlanDocument, options);
        }
export function useActiveMealPlanSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActiveMealPlanQuery, ActiveMealPlanQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActiveMealPlanQuery, ActiveMealPlanQueryVariables>(ActiveMealPlanDocument, options);
        }
export type ActiveMealPlanQueryHookResult = ReturnType<typeof useActiveMealPlanQuery>;
export type ActiveMealPlanLazyQueryHookResult = ReturnType<typeof useActiveMealPlanLazyQuery>;
export type ActiveMealPlanSuspenseQueryHookResult = ReturnType<typeof useActiveMealPlanSuspenseQuery>;
export type ActiveMealPlanQueryResult = ApolloReactCommon.QueryResult<ActiveMealPlanQuery, ActiveMealPlanQueryVariables>;
export const ActiveSubscriptionsDocument = gql`
    query ActiveSubscriptions($first: Int! = 10, $after: ID) {
  activeSubscriptions(first: $first, after: $after) {
    edges {
      node {
        ...ActiveSubscriptionFields
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    ${ActiveSubscriptionFieldsFragmentDoc}`;
export type ActiveSubscriptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ActiveSubscriptionsQuery, ActiveSubscriptionsQueryVariables>, 'query'>;

    export const ActiveSubscriptionsComponent = (props: ActiveSubscriptionsComponentProps) => (
      <ApolloReactComponents.Query<ActiveSubscriptionsQuery, ActiveSubscriptionsQueryVariables> query={ActiveSubscriptionsDocument} {...props} />
    );
    

/**
 * __useActiveSubscriptionsQuery__
 *
 * To run a query within a React component, call `useActiveSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveSubscriptionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useActiveSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveSubscriptionsQuery, ActiveSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveSubscriptionsQuery, ActiveSubscriptionsQueryVariables>(ActiveSubscriptionsDocument, options);
      }
export function useActiveSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveSubscriptionsQuery, ActiveSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveSubscriptionsQuery, ActiveSubscriptionsQueryVariables>(ActiveSubscriptionsDocument, options);
        }
export function useActiveSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActiveSubscriptionsQuery, ActiveSubscriptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActiveSubscriptionsQuery, ActiveSubscriptionsQueryVariables>(ActiveSubscriptionsDocument, options);
        }
export type ActiveSubscriptionsQueryHookResult = ReturnType<typeof useActiveSubscriptionsQuery>;
export type ActiveSubscriptionsLazyQueryHookResult = ReturnType<typeof useActiveSubscriptionsLazyQuery>;
export type ActiveSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useActiveSubscriptionsSuspenseQuery>;
export type ActiveSubscriptionsQueryResult = ApolloReactCommon.QueryResult<ActiveSubscriptionsQuery, ActiveSubscriptionsQueryVariables>;
export const ConsumerCancelOrderDocument = gql`
    mutation ConsumerCancelOrder($groupOrderId: String!) {
  cancelGroupOrder(groupOrderId: $groupOrderId) {
    id
    orders {
      id
      orderStatus
    }
  }
}
    `;
export type ConsumerCancelOrderMutationFn = ApolloReactCommon.MutationFunction<ConsumerCancelOrderMutation, ConsumerCancelOrderMutationVariables>;
export type ConsumerCancelOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConsumerCancelOrderMutation, ConsumerCancelOrderMutationVariables>, 'mutation'>;

    export const ConsumerCancelOrderComponent = (props: ConsumerCancelOrderComponentProps) => (
      <ApolloReactComponents.Mutation<ConsumerCancelOrderMutation, ConsumerCancelOrderMutationVariables> mutation={ConsumerCancelOrderDocument} {...props} />
    );
    

/**
 * __useConsumerCancelOrderMutation__
 *
 * To run a mutation, you first call `useConsumerCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerCancelOrderMutation, { data, loading, error }] = useConsumerCancelOrderMutation({
 *   variables: {
 *      groupOrderId: // value for 'groupOrderId'
 *   },
 * });
 */
export function useConsumerCancelOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConsumerCancelOrderMutation, ConsumerCancelOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConsumerCancelOrderMutation, ConsumerCancelOrderMutationVariables>(ConsumerCancelOrderDocument, options);
      }
export type ConsumerCancelOrderMutationHookResult = ReturnType<typeof useConsumerCancelOrderMutation>;
export type ConsumerCancelOrderMutationResult = ApolloReactCommon.MutationResult<ConsumerCancelOrderMutation>;
export type ConsumerCancelOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumerCancelOrderMutation, ConsumerCancelOrderMutationVariables>;
export const ReorderDocument = gql`
    mutation Reorder($orderId: Int!) {
  duplicateOrderToCart(orderId: $orderId) {
    success
  }
}
    `;
export type ReorderMutationFn = ApolloReactCommon.MutationFunction<ReorderMutation, ReorderMutationVariables>;
export type ReorderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ReorderMutation, ReorderMutationVariables>, 'mutation'>;

    export const ReorderComponent = (props: ReorderComponentProps) => (
      <ApolloReactComponents.Mutation<ReorderMutation, ReorderMutationVariables> mutation={ReorderDocument} {...props} />
    );
    

/**
 * __useReorderMutation__
 *
 * To run a mutation, you first call `useReorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderMutation, { data, loading, error }] = useReorderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useReorderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderMutation, ReorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderMutation, ReorderMutationVariables>(ReorderDocument, options);
      }
export type ReorderMutationHookResult = ReturnType<typeof useReorderMutation>;
export type ReorderMutationResult = ApolloReactCommon.MutationResult<ReorderMutation>;
export type ReorderMutationOptions = ApolloReactCommon.BaseMutationOptions<ReorderMutation, ReorderMutationVariables>;
export const ConsumerPaymentMethodsDocument = gql`
    query ConsumerPaymentMethods {
  me {
    id
    savedCreditCards {
      ...ConsumerSavedCardFields
    }
  }
}
    ${ConsumerSavedCardFieldsFragmentDoc}`;
export type ConsumerPaymentMethodsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerPaymentMethodsQuery, ConsumerPaymentMethodsQueryVariables>, 'query'>;

    export const ConsumerPaymentMethodsComponent = (props: ConsumerPaymentMethodsComponentProps) => (
      <ApolloReactComponents.Query<ConsumerPaymentMethodsQuery, ConsumerPaymentMethodsQueryVariables> query={ConsumerPaymentMethodsDocument} {...props} />
    );
    

/**
 * __useConsumerPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useConsumerPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsumerPaymentMethodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConsumerPaymentMethodsQuery, ConsumerPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerPaymentMethodsQuery, ConsumerPaymentMethodsQueryVariables>(ConsumerPaymentMethodsDocument, options);
      }
export function useConsumerPaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerPaymentMethodsQuery, ConsumerPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerPaymentMethodsQuery, ConsumerPaymentMethodsQueryVariables>(ConsumerPaymentMethodsDocument, options);
        }
export function useConsumerPaymentMethodsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerPaymentMethodsQuery, ConsumerPaymentMethodsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerPaymentMethodsQuery, ConsumerPaymentMethodsQueryVariables>(ConsumerPaymentMethodsDocument, options);
        }
export type ConsumerPaymentMethodsQueryHookResult = ReturnType<typeof useConsumerPaymentMethodsQuery>;
export type ConsumerPaymentMethodsLazyQueryHookResult = ReturnType<typeof useConsumerPaymentMethodsLazyQuery>;
export type ConsumerPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useConsumerPaymentMethodsSuspenseQuery>;
export type ConsumerPaymentMethodsQueryResult = ApolloReactCommon.QueryResult<ConsumerPaymentMethodsQuery, ConsumerPaymentMethodsQueryVariables>;
export const ConsumerSaveCardDocument = gql`
    mutation ConsumerSaveCard($creditCardInput: SavedCreditCardInput) {
  saveCreditCard(creditCardInput: $creditCardInput) {
    id
  }
}
    `;
export type ConsumerSaveCardMutationFn = ApolloReactCommon.MutationFunction<ConsumerSaveCardMutation, ConsumerSaveCardMutationVariables>;
export type ConsumerSaveCardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConsumerSaveCardMutation, ConsumerSaveCardMutationVariables>, 'mutation'>;

    export const ConsumerSaveCardComponent = (props: ConsumerSaveCardComponentProps) => (
      <ApolloReactComponents.Mutation<ConsumerSaveCardMutation, ConsumerSaveCardMutationVariables> mutation={ConsumerSaveCardDocument} {...props} />
    );
    

/**
 * __useConsumerSaveCardMutation__
 *
 * To run a mutation, you first call `useConsumerSaveCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerSaveCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerSaveCardMutation, { data, loading, error }] = useConsumerSaveCardMutation({
 *   variables: {
 *      creditCardInput: // value for 'creditCardInput'
 *   },
 * });
 */
export function useConsumerSaveCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConsumerSaveCardMutation, ConsumerSaveCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConsumerSaveCardMutation, ConsumerSaveCardMutationVariables>(ConsumerSaveCardDocument, options);
      }
export type ConsumerSaveCardMutationHookResult = ReturnType<typeof useConsumerSaveCardMutation>;
export type ConsumerSaveCardMutationResult = ApolloReactCommon.MutationResult<ConsumerSaveCardMutation>;
export type ConsumerSaveCardMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumerSaveCardMutation, ConsumerSaveCardMutationVariables>;
export const ConsumerRemoveCardDocument = gql`
    mutation ConsumerRemoveCard($cardId: String) {
  removeCreditCard(cardId: $cardId)
}
    `;
export type ConsumerRemoveCardMutationFn = ApolloReactCommon.MutationFunction<ConsumerRemoveCardMutation, ConsumerRemoveCardMutationVariables>;
export type ConsumerRemoveCardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConsumerRemoveCardMutation, ConsumerRemoveCardMutationVariables>, 'mutation'>;

    export const ConsumerRemoveCardComponent = (props: ConsumerRemoveCardComponentProps) => (
      <ApolloReactComponents.Mutation<ConsumerRemoveCardMutation, ConsumerRemoveCardMutationVariables> mutation={ConsumerRemoveCardDocument} {...props} />
    );
    

/**
 * __useConsumerRemoveCardMutation__
 *
 * To run a mutation, you first call `useConsumerRemoveCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerRemoveCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerRemoveCardMutation, { data, loading, error }] = useConsumerRemoveCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useConsumerRemoveCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConsumerRemoveCardMutation, ConsumerRemoveCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConsumerRemoveCardMutation, ConsumerRemoveCardMutationVariables>(ConsumerRemoveCardDocument, options);
      }
export type ConsumerRemoveCardMutationHookResult = ReturnType<typeof useConsumerRemoveCardMutation>;
export type ConsumerRemoveCardMutationResult = ApolloReactCommon.MutationResult<ConsumerRemoveCardMutation>;
export type ConsumerRemoveCardMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumerRemoveCardMutation, ConsumerRemoveCardMutationVariables>;
export const ConsumerDeleteUserDocument = gql`
    mutation ConsumerDeleteUser {
  deleteUser
}
    `;
export type ConsumerDeleteUserMutationFn = ApolloReactCommon.MutationFunction<ConsumerDeleteUserMutation, ConsumerDeleteUserMutationVariables>;
export type ConsumerDeleteUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConsumerDeleteUserMutation, ConsumerDeleteUserMutationVariables>, 'mutation'>;

    export const ConsumerDeleteUserComponent = (props: ConsumerDeleteUserComponentProps) => (
      <ApolloReactComponents.Mutation<ConsumerDeleteUserMutation, ConsumerDeleteUserMutationVariables> mutation={ConsumerDeleteUserDocument} {...props} />
    );
    

/**
 * __useConsumerDeleteUserMutation__
 *
 * To run a mutation, you first call `useConsumerDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerDeleteUserMutation, { data, loading, error }] = useConsumerDeleteUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useConsumerDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConsumerDeleteUserMutation, ConsumerDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConsumerDeleteUserMutation, ConsumerDeleteUserMutationVariables>(ConsumerDeleteUserDocument, options);
      }
export type ConsumerDeleteUserMutationHookResult = ReturnType<typeof useConsumerDeleteUserMutation>;
export type ConsumerDeleteUserMutationResult = ApolloReactCommon.MutationResult<ConsumerDeleteUserMutation>;
export type ConsumerDeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumerDeleteUserMutation, ConsumerDeleteUserMutationVariables>;
export const ConsumerUpcomingOrdersDocument = gql`
    query ConsumerUpcomingOrders {
  upcomingOrders {
    id
  }
}
    `;
export type ConsumerUpcomingOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerUpcomingOrdersQuery, ConsumerUpcomingOrdersQueryVariables>, 'query'>;

    export const ConsumerUpcomingOrdersComponent = (props: ConsumerUpcomingOrdersComponentProps) => (
      <ApolloReactComponents.Query<ConsumerUpcomingOrdersQuery, ConsumerUpcomingOrdersQueryVariables> query={ConsumerUpcomingOrdersDocument} {...props} />
    );
    

/**
 * __useConsumerUpcomingOrdersQuery__
 *
 * To run a query within a React component, call `useConsumerUpcomingOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerUpcomingOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerUpcomingOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsumerUpcomingOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConsumerUpcomingOrdersQuery, ConsumerUpcomingOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerUpcomingOrdersQuery, ConsumerUpcomingOrdersQueryVariables>(ConsumerUpcomingOrdersDocument, options);
      }
export function useConsumerUpcomingOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerUpcomingOrdersQuery, ConsumerUpcomingOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerUpcomingOrdersQuery, ConsumerUpcomingOrdersQueryVariables>(ConsumerUpcomingOrdersDocument, options);
        }
export function useConsumerUpcomingOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerUpcomingOrdersQuery, ConsumerUpcomingOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerUpcomingOrdersQuery, ConsumerUpcomingOrdersQueryVariables>(ConsumerUpcomingOrdersDocument, options);
        }
export type ConsumerUpcomingOrdersQueryHookResult = ReturnType<typeof useConsumerUpcomingOrdersQuery>;
export type ConsumerUpcomingOrdersLazyQueryHookResult = ReturnType<typeof useConsumerUpcomingOrdersLazyQuery>;
export type ConsumerUpcomingOrdersSuspenseQueryHookResult = ReturnType<typeof useConsumerUpcomingOrdersSuspenseQuery>;
export type ConsumerUpcomingOrdersQueryResult = ApolloReactCommon.QueryResult<ConsumerUpcomingOrdersQuery, ConsumerUpcomingOrdersQueryVariables>;
export const ConsumerNotificationSettingsDocument = gql`
    query ConsumerNotificationSettings($userId: String!) {
  userNotificationSettings(userId: $userId) {
    userId
    type
    category
    enabled
  }
}
    `;
export type ConsumerNotificationSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerNotificationSettingsQuery, ConsumerNotificationSettingsQueryVariables>, 'query'> & ({ variables: ConsumerNotificationSettingsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConsumerNotificationSettingsComponent = (props: ConsumerNotificationSettingsComponentProps) => (
      <ApolloReactComponents.Query<ConsumerNotificationSettingsQuery, ConsumerNotificationSettingsQueryVariables> query={ConsumerNotificationSettingsDocument} {...props} />
    );
    

/**
 * __useConsumerNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useConsumerNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerNotificationSettingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useConsumerNotificationSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConsumerNotificationSettingsQuery, ConsumerNotificationSettingsQueryVariables> & ({ variables: ConsumerNotificationSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerNotificationSettingsQuery, ConsumerNotificationSettingsQueryVariables>(ConsumerNotificationSettingsDocument, options);
      }
export function useConsumerNotificationSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerNotificationSettingsQuery, ConsumerNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerNotificationSettingsQuery, ConsumerNotificationSettingsQueryVariables>(ConsumerNotificationSettingsDocument, options);
        }
export function useConsumerNotificationSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerNotificationSettingsQuery, ConsumerNotificationSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerNotificationSettingsQuery, ConsumerNotificationSettingsQueryVariables>(ConsumerNotificationSettingsDocument, options);
        }
export type ConsumerNotificationSettingsQueryHookResult = ReturnType<typeof useConsumerNotificationSettingsQuery>;
export type ConsumerNotificationSettingsLazyQueryHookResult = ReturnType<typeof useConsumerNotificationSettingsLazyQuery>;
export type ConsumerNotificationSettingsSuspenseQueryHookResult = ReturnType<typeof useConsumerNotificationSettingsSuspenseQuery>;
export type ConsumerNotificationSettingsQueryResult = ApolloReactCommon.QueryResult<ConsumerNotificationSettingsQuery, ConsumerNotificationSettingsQueryVariables>;
export const ConsumerUpdateUserNotificationSettingsDocument = gql`
    mutation ConsumerUpdateUserNotificationSettings($input: UserNotificationSettingUpdate!) {
  updateUserNotificationSettings(input: $input) {
    userId
    type
    category
    enabled
  }
}
    `;
export type ConsumerUpdateUserNotificationSettingsMutationFn = ApolloReactCommon.MutationFunction<ConsumerUpdateUserNotificationSettingsMutation, ConsumerUpdateUserNotificationSettingsMutationVariables>;
export type ConsumerUpdateUserNotificationSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConsumerUpdateUserNotificationSettingsMutation, ConsumerUpdateUserNotificationSettingsMutationVariables>, 'mutation'>;

    export const ConsumerUpdateUserNotificationSettingsComponent = (props: ConsumerUpdateUserNotificationSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<ConsumerUpdateUserNotificationSettingsMutation, ConsumerUpdateUserNotificationSettingsMutationVariables> mutation={ConsumerUpdateUserNotificationSettingsDocument} {...props} />
    );
    

/**
 * __useConsumerUpdateUserNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useConsumerUpdateUserNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerUpdateUserNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerUpdateUserNotificationSettingsMutation, { data, loading, error }] = useConsumerUpdateUserNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerUpdateUserNotificationSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConsumerUpdateUserNotificationSettingsMutation, ConsumerUpdateUserNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConsumerUpdateUserNotificationSettingsMutation, ConsumerUpdateUserNotificationSettingsMutationVariables>(ConsumerUpdateUserNotificationSettingsDocument, options);
      }
export type ConsumerUpdateUserNotificationSettingsMutationHookResult = ReturnType<typeof useConsumerUpdateUserNotificationSettingsMutation>;
export type ConsumerUpdateUserNotificationSettingsMutationResult = ApolloReactCommon.MutationResult<ConsumerUpdateUserNotificationSettingsMutation>;
export type ConsumerUpdateUserNotificationSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumerUpdateUserNotificationSettingsMutation, ConsumerUpdateUserNotificationSettingsMutationVariables>;
export const ConsumerUpdateSubscriptionDocument = gql`
    mutation ConsumerUpdateSubscription($input: SubscriptionModifyInput!) {
  modifySubscription(input: $input) {
    subscription {
      id
      status
    }
  }
}
    `;
export type ConsumerUpdateSubscriptionMutationFn = ApolloReactCommon.MutationFunction<ConsumerUpdateSubscriptionMutation, ConsumerUpdateSubscriptionMutationVariables>;
export type ConsumerUpdateSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConsumerUpdateSubscriptionMutation, ConsumerUpdateSubscriptionMutationVariables>, 'mutation'>;

    export const ConsumerUpdateSubscriptionComponent = (props: ConsumerUpdateSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<ConsumerUpdateSubscriptionMutation, ConsumerUpdateSubscriptionMutationVariables> mutation={ConsumerUpdateSubscriptionDocument} {...props} />
    );
    

/**
 * __useConsumerUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useConsumerUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerUpdateSubscriptionMutation, { data, loading, error }] = useConsumerUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerUpdateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConsumerUpdateSubscriptionMutation, ConsumerUpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConsumerUpdateSubscriptionMutation, ConsumerUpdateSubscriptionMutationVariables>(ConsumerUpdateSubscriptionDocument, options);
      }
export type ConsumerUpdateSubscriptionMutationHookResult = ReturnType<typeof useConsumerUpdateSubscriptionMutation>;
export type ConsumerUpdateSubscriptionMutationResult = ApolloReactCommon.MutationResult<ConsumerUpdateSubscriptionMutation>;
export type ConsumerUpdateSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumerUpdateSubscriptionMutation, ConsumerUpdateSubscriptionMutationVariables>;
export const ReferralRewardsDocument = gql`
    query ReferralRewards {
  me {
    id
    shefStatus
    referralRewards {
      id
      code
      value
      isUsed
      createdAt
      referee {
        id
        firstName
      }
    }
    pendingReferralRewards {
      id
      userId
      referee {
        id
        firstName
      }
      promoCode {
        id
        value
        promoCodeType
      }
      createdAt
    }
  }
}
    `;
export type ReferralRewardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReferralRewardsQuery, ReferralRewardsQueryVariables>, 'query'>;

    export const ReferralRewardsComponent = (props: ReferralRewardsComponentProps) => (
      <ApolloReactComponents.Query<ReferralRewardsQuery, ReferralRewardsQueryVariables> query={ReferralRewardsDocument} {...props} />
    );
    

/**
 * __useReferralRewardsQuery__
 *
 * To run a query within a React component, call `useReferralRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralRewardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReferralRewardsQuery, ReferralRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReferralRewardsQuery, ReferralRewardsQueryVariables>(ReferralRewardsDocument, options);
      }
export function useReferralRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReferralRewardsQuery, ReferralRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReferralRewardsQuery, ReferralRewardsQueryVariables>(ReferralRewardsDocument, options);
        }
export function useReferralRewardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReferralRewardsQuery, ReferralRewardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReferralRewardsQuery, ReferralRewardsQueryVariables>(ReferralRewardsDocument, options);
        }
export type ReferralRewardsQueryHookResult = ReturnType<typeof useReferralRewardsQuery>;
export type ReferralRewardsLazyQueryHookResult = ReturnType<typeof useReferralRewardsLazyQuery>;
export type ReferralRewardsSuspenseQueryHookResult = ReturnType<typeof useReferralRewardsSuspenseQuery>;
export type ReferralRewardsQueryResult = ApolloReactCommon.QueryResult<ReferralRewardsQuery, ReferralRewardsQueryVariables>;
export const ReferShefDocument = gql`
    query ReferShef($shefId: String!) {
  shef(userId: $shefId) {
    id
    imageUrl
    firstName
  }
}
    `;
export type ReferShefComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReferShefQuery, ReferShefQueryVariables>, 'query'> & ({ variables: ReferShefQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ReferShefComponent = (props: ReferShefComponentProps) => (
      <ApolloReactComponents.Query<ReferShefQuery, ReferShefQueryVariables> query={ReferShefDocument} {...props} />
    );
    

/**
 * __useReferShefQuery__
 *
 * To run a query within a React component, call `useReferShefQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferShefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferShefQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useReferShefQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReferShefQuery, ReferShefQueryVariables> & ({ variables: ReferShefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReferShefQuery, ReferShefQueryVariables>(ReferShefDocument, options);
      }
export function useReferShefLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReferShefQuery, ReferShefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReferShefQuery, ReferShefQueryVariables>(ReferShefDocument, options);
        }
export function useReferShefSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReferShefQuery, ReferShefQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReferShefQuery, ReferShefQueryVariables>(ReferShefDocument, options);
        }
export type ReferShefQueryHookResult = ReturnType<typeof useReferShefQuery>;
export type ReferShefLazyQueryHookResult = ReturnType<typeof useReferShefLazyQuery>;
export type ReferShefSuspenseQueryHookResult = ReturnType<typeof useReferShefSuspenseQuery>;
export type ReferShefQueryResult = ApolloReactCommon.QueryResult<ReferShefQuery, ReferShefQueryVariables>;
export const ReferFoodItemDocument = gql`
    query ReferFoodItem($shefId: String!, $slug: String!) {
  sluggedFoodItem(shefId: $shefId, slug: $slug) {
    id
    name
    imageUrl
    slug
    shef {
      id
      firstName
      cuisineCategories {
        title
      }
    }
  }
}
    `;
export type ReferFoodItemComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReferFoodItemQuery, ReferFoodItemQueryVariables>, 'query'> & ({ variables: ReferFoodItemQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ReferFoodItemComponent = (props: ReferFoodItemComponentProps) => (
      <ApolloReactComponents.Query<ReferFoodItemQuery, ReferFoodItemQueryVariables> query={ReferFoodItemDocument} {...props} />
    );
    

/**
 * __useReferFoodItemQuery__
 *
 * To run a query within a React component, call `useReferFoodItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferFoodItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferFoodItemQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useReferFoodItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReferFoodItemQuery, ReferFoodItemQueryVariables> & ({ variables: ReferFoodItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReferFoodItemQuery, ReferFoodItemQueryVariables>(ReferFoodItemDocument, options);
      }
export function useReferFoodItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReferFoodItemQuery, ReferFoodItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReferFoodItemQuery, ReferFoodItemQueryVariables>(ReferFoodItemDocument, options);
        }
export function useReferFoodItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReferFoodItemQuery, ReferFoodItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReferFoodItemQuery, ReferFoodItemQueryVariables>(ReferFoodItemDocument, options);
        }
export type ReferFoodItemQueryHookResult = ReturnType<typeof useReferFoodItemQuery>;
export type ReferFoodItemLazyQueryHookResult = ReturnType<typeof useReferFoodItemLazyQuery>;
export type ReferFoodItemSuspenseQueryHookResult = ReturnType<typeof useReferFoodItemSuspenseQuery>;
export type ReferFoodItemQueryResult = ApolloReactCommon.QueryResult<ReferFoodItemQuery, ReferFoodItemQueryVariables>;
export const ReferOrderDocument = gql`
    query ReferOrder($orderId: Int, $orderUuid: String, $userId: String!) {
  publicOrderByUser(orderId: $orderId, orderUuid: $orderUuid, userId: $userId) {
    id
    uuid
    userId
    user {
      publicName
    }
    deliveryDate
    lineItems {
      name
      quantity
      foodItem {
        ...ConsumerOrderDishDescriptionModalFoodItem
        resizedImageUrl(width: 1200)
        shef {
          id
          publicName
          imageUrl
        }
        deletedAt
      }
    }
  }
}
    ${ConsumerOrderDishDescriptionModalFoodItemFragmentDoc}`;
export type ReferOrderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReferOrderQuery, ReferOrderQueryVariables>, 'query'> & ({ variables: ReferOrderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ReferOrderComponent = (props: ReferOrderComponentProps) => (
      <ApolloReactComponents.Query<ReferOrderQuery, ReferOrderQueryVariables> query={ReferOrderDocument} {...props} />
    );
    

/**
 * __useReferOrderQuery__
 *
 * To run a query within a React component, call `useReferOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      orderUuid: // value for 'orderUuid'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useReferOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReferOrderQuery, ReferOrderQueryVariables> & ({ variables: ReferOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReferOrderQuery, ReferOrderQueryVariables>(ReferOrderDocument, options);
      }
export function useReferOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReferOrderQuery, ReferOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReferOrderQuery, ReferOrderQueryVariables>(ReferOrderDocument, options);
        }
export function useReferOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReferOrderQuery, ReferOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReferOrderQuery, ReferOrderQueryVariables>(ReferOrderDocument, options);
        }
export type ReferOrderQueryHookResult = ReturnType<typeof useReferOrderQuery>;
export type ReferOrderLazyQueryHookResult = ReturnType<typeof useReferOrderLazyQuery>;
export type ReferOrderSuspenseQueryHookResult = ReturnType<typeof useReferOrderSuspenseQuery>;
export type ReferOrderQueryResult = ApolloReactCommon.QueryResult<ReferOrderQuery, ReferOrderQueryVariables>;
export const BecomeATasterInfoDocument = gql`
    query BecomeATasterInfo($zipCode: String, $deliveryDates: [String!]) {
  me {
    id
    ...TasterFields
  }
}
    ${TasterFieldsFragmentDoc}`;
export type BecomeATasterInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BecomeATasterInfoQuery, BecomeATasterInfoQueryVariables>, 'query'>;

    export const BecomeATasterInfoComponent = (props: BecomeATasterInfoComponentProps) => (
      <ApolloReactComponents.Query<BecomeATasterInfoQuery, BecomeATasterInfoQueryVariables> query={BecomeATasterInfoDocument} {...props} />
    );
    

/**
 * __useBecomeATasterInfoQuery__
 *
 * To run a query within a React component, call `useBecomeATasterInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBecomeATasterInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBecomeATasterInfoQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      deliveryDates: // value for 'deliveryDates'
 *   },
 * });
 */
export function useBecomeATasterInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BecomeATasterInfoQuery, BecomeATasterInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BecomeATasterInfoQuery, BecomeATasterInfoQueryVariables>(BecomeATasterInfoDocument, options);
      }
export function useBecomeATasterInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BecomeATasterInfoQuery, BecomeATasterInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BecomeATasterInfoQuery, BecomeATasterInfoQueryVariables>(BecomeATasterInfoDocument, options);
        }
export function useBecomeATasterInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BecomeATasterInfoQuery, BecomeATasterInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BecomeATasterInfoQuery, BecomeATasterInfoQueryVariables>(BecomeATasterInfoDocument, options);
        }
export type BecomeATasterInfoQueryHookResult = ReturnType<typeof useBecomeATasterInfoQuery>;
export type BecomeATasterInfoLazyQueryHookResult = ReturnType<typeof useBecomeATasterInfoLazyQuery>;
export type BecomeATasterInfoSuspenseQueryHookResult = ReturnType<typeof useBecomeATasterInfoSuspenseQuery>;
export type BecomeATasterInfoQueryResult = ApolloReactCommon.QueryResult<BecomeATasterInfoQuery, BecomeATasterInfoQueryVariables>;
export const BecomeATasterDocument = gql`
    mutation BecomeATaster {
  becomeATaster {
    ...CurrentUserFields
  }
}
    ${CurrentUserFieldsFragmentDoc}`;
export type BecomeATasterMutationFn = ApolloReactCommon.MutationFunction<BecomeATasterMutation, BecomeATasterMutationVariables>;
export type BecomeATasterComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BecomeATasterMutation, BecomeATasterMutationVariables>, 'mutation'>;

    export const BecomeATasterComponent = (props: BecomeATasterComponentProps) => (
      <ApolloReactComponents.Mutation<BecomeATasterMutation, BecomeATasterMutationVariables> mutation={BecomeATasterDocument} {...props} />
    );
    

/**
 * __useBecomeATasterMutation__
 *
 * To run a mutation, you first call `useBecomeATasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBecomeATasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [becomeATasterMutation, { data, loading, error }] = useBecomeATasterMutation({
 *   variables: {
 *   },
 * });
 */
export function useBecomeATasterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BecomeATasterMutation, BecomeATasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BecomeATasterMutation, BecomeATasterMutationVariables>(BecomeATasterDocument, options);
      }
export type BecomeATasterMutationHookResult = ReturnType<typeof useBecomeATasterMutation>;
export type BecomeATasterMutationResult = ApolloReactCommon.MutationResult<BecomeATasterMutation>;
export type BecomeATasterMutationOptions = ApolloReactCommon.BaseMutationOptions<BecomeATasterMutation, BecomeATasterMutationVariables>;
export const GetAvailablePromoCodesForUserDocument = gql`
    query getAvailablePromoCodesForUser {
  getAvailablePromoCodesForUser {
    ...PromoCodeFields
  }
}
    ${PromoCodeFieldsFragmentDoc}`;
export type GetAvailablePromoCodesForUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAvailablePromoCodesForUserQuery, GetAvailablePromoCodesForUserQueryVariables>, 'query'>;

    export const GetAvailablePromoCodesForUserComponent = (props: GetAvailablePromoCodesForUserComponentProps) => (
      <ApolloReactComponents.Query<GetAvailablePromoCodesForUserQuery, GetAvailablePromoCodesForUserQueryVariables> query={GetAvailablePromoCodesForUserDocument} {...props} />
    );
    

/**
 * __useGetAvailablePromoCodesForUserQuery__
 *
 * To run a query within a React component, call `useGetAvailablePromoCodesForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailablePromoCodesForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailablePromoCodesForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailablePromoCodesForUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAvailablePromoCodesForUserQuery, GetAvailablePromoCodesForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAvailablePromoCodesForUserQuery, GetAvailablePromoCodesForUserQueryVariables>(GetAvailablePromoCodesForUserDocument, options);
      }
export function useGetAvailablePromoCodesForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAvailablePromoCodesForUserQuery, GetAvailablePromoCodesForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAvailablePromoCodesForUserQuery, GetAvailablePromoCodesForUserQueryVariables>(GetAvailablePromoCodesForUserDocument, options);
        }
export function useGetAvailablePromoCodesForUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAvailablePromoCodesForUserQuery, GetAvailablePromoCodesForUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAvailablePromoCodesForUserQuery, GetAvailablePromoCodesForUserQueryVariables>(GetAvailablePromoCodesForUserDocument, options);
        }
export type GetAvailablePromoCodesForUserQueryHookResult = ReturnType<typeof useGetAvailablePromoCodesForUserQuery>;
export type GetAvailablePromoCodesForUserLazyQueryHookResult = ReturnType<typeof useGetAvailablePromoCodesForUserLazyQuery>;
export type GetAvailablePromoCodesForUserSuspenseQueryHookResult = ReturnType<typeof useGetAvailablePromoCodesForUserSuspenseQuery>;
export type GetAvailablePromoCodesForUserQueryResult = ApolloReactCommon.QueryResult<GetAvailablePromoCodesForUserQuery, GetAvailablePromoCodesForUserQueryVariables>;
export const GetNewUserPromoCodeDocument = gql`
    query getNewUserPromoCode {
  newUserPromoCode {
    ...PromoCodeFields
  }
}
    ${PromoCodeFieldsFragmentDoc}`;
export type GetNewUserPromoCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNewUserPromoCodeQuery, GetNewUserPromoCodeQueryVariables>, 'query'>;

    export const GetNewUserPromoCodeComponent = (props: GetNewUserPromoCodeComponentProps) => (
      <ApolloReactComponents.Query<GetNewUserPromoCodeQuery, GetNewUserPromoCodeQueryVariables> query={GetNewUserPromoCodeDocument} {...props} />
    );
    

/**
 * __useGetNewUserPromoCodeQuery__
 *
 * To run a query within a React component, call `useGetNewUserPromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewUserPromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewUserPromoCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewUserPromoCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewUserPromoCodeQuery, GetNewUserPromoCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNewUserPromoCodeQuery, GetNewUserPromoCodeQueryVariables>(GetNewUserPromoCodeDocument, options);
      }
export function useGetNewUserPromoCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewUserPromoCodeQuery, GetNewUserPromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNewUserPromoCodeQuery, GetNewUserPromoCodeQueryVariables>(GetNewUserPromoCodeDocument, options);
        }
export function useGetNewUserPromoCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNewUserPromoCodeQuery, GetNewUserPromoCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNewUserPromoCodeQuery, GetNewUserPromoCodeQueryVariables>(GetNewUserPromoCodeDocument, options);
        }
export type GetNewUserPromoCodeQueryHookResult = ReturnType<typeof useGetNewUserPromoCodeQuery>;
export type GetNewUserPromoCodeLazyQueryHookResult = ReturnType<typeof useGetNewUserPromoCodeLazyQuery>;
export type GetNewUserPromoCodeSuspenseQueryHookResult = ReturnType<typeof useGetNewUserPromoCodeSuspenseQuery>;
export type GetNewUserPromoCodeQueryResult = ApolloReactCommon.QueryResult<GetNewUserPromoCodeQuery, GetNewUserPromoCodeQueryVariables>;
export const HeaderZipCodeDocument = gql`
    query HeaderZipCode($zipCode: String!) {
  zipCode(zipCode: $zipCode) {
    zipCode
    availableToCustomers
    region {
      id
      isPickupEnabled
    }
  }
}
    `;
export type HeaderZipCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HeaderZipCodeQuery, HeaderZipCodeQueryVariables>, 'query'> & ({ variables: HeaderZipCodeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HeaderZipCodeComponent = (props: HeaderZipCodeComponentProps) => (
      <ApolloReactComponents.Query<HeaderZipCodeQuery, HeaderZipCodeQueryVariables> query={HeaderZipCodeDocument} {...props} />
    );
    

/**
 * __useHeaderZipCodeQuery__
 *
 * To run a query within a React component, call `useHeaderZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderZipCodeQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useHeaderZipCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HeaderZipCodeQuery, HeaderZipCodeQueryVariables> & ({ variables: HeaderZipCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HeaderZipCodeQuery, HeaderZipCodeQueryVariables>(HeaderZipCodeDocument, options);
      }
export function useHeaderZipCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HeaderZipCodeQuery, HeaderZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HeaderZipCodeQuery, HeaderZipCodeQueryVariables>(HeaderZipCodeDocument, options);
        }
export function useHeaderZipCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HeaderZipCodeQuery, HeaderZipCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HeaderZipCodeQuery, HeaderZipCodeQueryVariables>(HeaderZipCodeDocument, options);
        }
export type HeaderZipCodeQueryHookResult = ReturnType<typeof useHeaderZipCodeQuery>;
export type HeaderZipCodeLazyQueryHookResult = ReturnType<typeof useHeaderZipCodeLazyQuery>;
export type HeaderZipCodeSuspenseQueryHookResult = ReturnType<typeof useHeaderZipCodeSuspenseQuery>;
export type HeaderZipCodeQueryResult = ApolloReactCommon.QueryResult<HeaderZipCodeQuery, HeaderZipCodeQueryVariables>;
export const TrendingSearchesDocument = gql`
    query TrendingSearches($zipCode: String!) {
  getTrendingSearches(zipCode: $zipCode)
}
    `;
export type TrendingSearchesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TrendingSearchesQuery, TrendingSearchesQueryVariables>, 'query'> & ({ variables: TrendingSearchesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TrendingSearchesComponent = (props: TrendingSearchesComponentProps) => (
      <ApolloReactComponents.Query<TrendingSearchesQuery, TrendingSearchesQueryVariables> query={TrendingSearchesDocument} {...props} />
    );
    

/**
 * __useTrendingSearchesQuery__
 *
 * To run a query within a React component, call `useTrendingSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendingSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendingSearchesQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useTrendingSearchesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrendingSearchesQuery, TrendingSearchesQueryVariables> & ({ variables: TrendingSearchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrendingSearchesQuery, TrendingSearchesQueryVariables>(TrendingSearchesDocument, options);
      }
export function useTrendingSearchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrendingSearchesQuery, TrendingSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrendingSearchesQuery, TrendingSearchesQueryVariables>(TrendingSearchesDocument, options);
        }
export function useTrendingSearchesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrendingSearchesQuery, TrendingSearchesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrendingSearchesQuery, TrendingSearchesQueryVariables>(TrendingSearchesDocument, options);
        }
export type TrendingSearchesQueryHookResult = ReturnType<typeof useTrendingSearchesQuery>;
export type TrendingSearchesLazyQueryHookResult = ReturnType<typeof useTrendingSearchesLazyQuery>;
export type TrendingSearchesSuspenseQueryHookResult = ReturnType<typeof useTrendingSearchesSuspenseQuery>;
export type TrendingSearchesQueryResult = ApolloReactCommon.QueryResult<TrendingSearchesQuery, TrendingSearchesQueryVariables>;
export const SearchDocument = gql`
    query Search($searchInput: SearchInput!) {
  combinedSearch(searchInput: $searchInput) {
    ...CombinedSearchResults
  }
}
    ${CombinedSearchResultsFragmentDoc}`;
export type SearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchQuery, SearchQueryVariables>, 'query'> & ({ variables: SearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchComponent = (props: SearchComponentProps) => (
      <ApolloReactComponents.Query<SearchQuery, SearchQueryVariables> query={SearchDocument} {...props} />
    );
    

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchQuery, SearchQueryVariables> & ({ variables: SearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export function useSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<typeof useSearchSuspenseQuery>;
export type SearchQueryResult = ApolloReactCommon.QueryResult<SearchQuery, SearchQueryVariables>;
export const GetSearchResultsDocument = gql`
    query GetSearchResults($query: String!, $deliveryDate: String!, $zipCode: String!, $isPartialQuery: Boolean!, $filters: ExploreFoodItemsFilterInput!, $searchState: SearchStateInput!, $offset: Int!, $limit: Int) {
  getSearchResults(
    query: $query
    deliveryDate: $deliveryDate
    zipCode: $zipCode
    isPartialQuery: $isPartialQuery
    filters: $filters
    searchState: $searchState
    offset: $offset
    limit: $limit
  ) {
    ...SearchResults
  }
}
    ${SearchResultsFragmentDoc}`;
export type GetSearchResultsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>, 'query'> & ({ variables: GetSearchResultsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSearchResultsComponent = (props: GetSearchResultsComponentProps) => (
      <ApolloReactComponents.Query<GetSearchResultsQuery, GetSearchResultsQueryVariables> query={GetSearchResultsDocument} {...props} />
    );
    

/**
 * __useGetSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      deliveryDate: // value for 'deliveryDate'
 *      zipCode: // value for 'zipCode'
 *      isPartialQuery: // value for 'isPartialQuery'
 *      filters: // value for 'filters'
 *      searchState: // value for 'searchState'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSearchResultsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables> & ({ variables: GetSearchResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(GetSearchResultsDocument, options);
      }
export function useGetSearchResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(GetSearchResultsDocument, options);
        }
export function useGetSearchResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(GetSearchResultsDocument, options);
        }
export type GetSearchResultsQueryHookResult = ReturnType<typeof useGetSearchResultsQuery>;
export type GetSearchResultsLazyQueryHookResult = ReturnType<typeof useGetSearchResultsLazyQuery>;
export type GetSearchResultsSuspenseQueryHookResult = ReturnType<typeof useGetSearchResultsSuspenseQuery>;
export type GetSearchResultsQueryResult = ApolloReactCommon.QueryResult<GetSearchResultsQuery, GetSearchResultsQueryVariables>;
export const LocalCartShefsDocument = gql`
    query LocalCartShefs($userIds: [String!]!) {
  shefs(userIds: $userIds) {
    ...ConsumerCartPublicShef
  }
}
    ${ConsumerCartPublicShefFragmentDoc}`;
export type LocalCartShefsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LocalCartShefsQuery, LocalCartShefsQueryVariables>, 'query'> & ({ variables: LocalCartShefsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LocalCartShefsComponent = (props: LocalCartShefsComponentProps) => (
      <ApolloReactComponents.Query<LocalCartShefsQuery, LocalCartShefsQueryVariables> query={LocalCartShefsDocument} {...props} />
    );
    

/**
 * __useLocalCartShefsQuery__
 *
 * To run a query within a React component, call `useLocalCartShefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalCartShefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalCartShefsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useLocalCartShefsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LocalCartShefsQuery, LocalCartShefsQueryVariables> & ({ variables: LocalCartShefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocalCartShefsQuery, LocalCartShefsQueryVariables>(LocalCartShefsDocument, options);
      }
export function useLocalCartShefsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocalCartShefsQuery, LocalCartShefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocalCartShefsQuery, LocalCartShefsQueryVariables>(LocalCartShefsDocument, options);
        }
export function useLocalCartShefsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocalCartShefsQuery, LocalCartShefsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocalCartShefsQuery, LocalCartShefsQueryVariables>(LocalCartShefsDocument, options);
        }
export type LocalCartShefsQueryHookResult = ReturnType<typeof useLocalCartShefsQuery>;
export type LocalCartShefsLazyQueryHookResult = ReturnType<typeof useLocalCartShefsLazyQuery>;
export type LocalCartShefsSuspenseQueryHookResult = ReturnType<typeof useLocalCartShefsSuspenseQuery>;
export type LocalCartShefsQueryResult = ApolloReactCommon.QueryResult<LocalCartShefsQuery, LocalCartShefsQueryVariables>;
export const ConsumerExploreDishFirstDocument = gql`
    query ConsumerExploreDishFirst($zipCode: String!, $limit: Int, $offset: Int!, $numVisiblePerSegment: Int!, $filters: ExploreFoodItemsFilterInput!, $loadFoodItemDescription: Boolean!, $useDynamicPreviewImage: Boolean) {
  exploreFoodItems(
    zipCode: $zipCode
    limit: $limit
    offset: $offset
    numVisiblePerSegment: $numVisiblePerSegment
    filters: $filters
    useDynamicPreviewImage: $useDynamicPreviewImage
  ) {
    ...DishFirstFoodItemsSegment
  }
}
    ${DishFirstFoodItemsSegmentFragmentDoc}`;
export type ConsumerExploreDishFirstComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerExploreDishFirstQuery, ConsumerExploreDishFirstQueryVariables>, 'query'> & ({ variables: ConsumerExploreDishFirstQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConsumerExploreDishFirstComponent = (props: ConsumerExploreDishFirstComponentProps) => (
      <ApolloReactComponents.Query<ConsumerExploreDishFirstQuery, ConsumerExploreDishFirstQueryVariables> query={ConsumerExploreDishFirstDocument} {...props} />
    );
    

/**
 * __useConsumerExploreDishFirstQuery__
 *
 * To run a query within a React component, call `useConsumerExploreDishFirstQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerExploreDishFirstQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerExploreDishFirstQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      numVisiblePerSegment: // value for 'numVisiblePerSegment'
 *      filters: // value for 'filters'
 *      loadFoodItemDescription: // value for 'loadFoodItemDescription'
 *      useDynamicPreviewImage: // value for 'useDynamicPreviewImage'
 *   },
 * });
 */
export function useConsumerExploreDishFirstQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConsumerExploreDishFirstQuery, ConsumerExploreDishFirstQueryVariables> & ({ variables: ConsumerExploreDishFirstQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerExploreDishFirstQuery, ConsumerExploreDishFirstQueryVariables>(ConsumerExploreDishFirstDocument, options);
      }
export function useConsumerExploreDishFirstLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerExploreDishFirstQuery, ConsumerExploreDishFirstQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerExploreDishFirstQuery, ConsumerExploreDishFirstQueryVariables>(ConsumerExploreDishFirstDocument, options);
        }
export function useConsumerExploreDishFirstSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerExploreDishFirstQuery, ConsumerExploreDishFirstQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerExploreDishFirstQuery, ConsumerExploreDishFirstQueryVariables>(ConsumerExploreDishFirstDocument, options);
        }
export type ConsumerExploreDishFirstQueryHookResult = ReturnType<typeof useConsumerExploreDishFirstQuery>;
export type ConsumerExploreDishFirstLazyQueryHookResult = ReturnType<typeof useConsumerExploreDishFirstLazyQuery>;
export type ConsumerExploreDishFirstSuspenseQueryHookResult = ReturnType<typeof useConsumerExploreDishFirstSuspenseQuery>;
export type ConsumerExploreDishFirstQueryResult = ApolloReactCommon.QueryResult<ConsumerExploreDishFirstQuery, ConsumerExploreDishFirstQueryVariables>;
export const ConsumerExploreDishFirstFiltersDocument = gql`
    query ConsumerExploreDishFirstFilters($zipCode: String!, $filters: ExploreFoodItemsFilterInput!, $query: String, $shefId: String) {
  exploreFoodItemsFilterOptions(
    zipCode: $zipCode
    filters: $filters
    query: $query
    shefId: $shefId
  ) {
    ...DishFirstFilterOptions
  }
}
    ${DishFirstFilterOptionsFragmentDoc}`;
export type ConsumerExploreDishFirstFiltersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerExploreDishFirstFiltersQuery, ConsumerExploreDishFirstFiltersQueryVariables>, 'query'> & ({ variables: ConsumerExploreDishFirstFiltersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConsumerExploreDishFirstFiltersComponent = (props: ConsumerExploreDishFirstFiltersComponentProps) => (
      <ApolloReactComponents.Query<ConsumerExploreDishFirstFiltersQuery, ConsumerExploreDishFirstFiltersQueryVariables> query={ConsumerExploreDishFirstFiltersDocument} {...props} />
    );
    

/**
 * __useConsumerExploreDishFirstFiltersQuery__
 *
 * To run a query within a React component, call `useConsumerExploreDishFirstFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerExploreDishFirstFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerExploreDishFirstFiltersQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      filters: // value for 'filters'
 *      query: // value for 'query'
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useConsumerExploreDishFirstFiltersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConsumerExploreDishFirstFiltersQuery, ConsumerExploreDishFirstFiltersQueryVariables> & ({ variables: ConsumerExploreDishFirstFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerExploreDishFirstFiltersQuery, ConsumerExploreDishFirstFiltersQueryVariables>(ConsumerExploreDishFirstFiltersDocument, options);
      }
export function useConsumerExploreDishFirstFiltersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerExploreDishFirstFiltersQuery, ConsumerExploreDishFirstFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerExploreDishFirstFiltersQuery, ConsumerExploreDishFirstFiltersQueryVariables>(ConsumerExploreDishFirstFiltersDocument, options);
        }
export function useConsumerExploreDishFirstFiltersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerExploreDishFirstFiltersQuery, ConsumerExploreDishFirstFiltersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerExploreDishFirstFiltersQuery, ConsumerExploreDishFirstFiltersQueryVariables>(ConsumerExploreDishFirstFiltersDocument, options);
        }
export type ConsumerExploreDishFirstFiltersQueryHookResult = ReturnType<typeof useConsumerExploreDishFirstFiltersQuery>;
export type ConsumerExploreDishFirstFiltersLazyQueryHookResult = ReturnType<typeof useConsumerExploreDishFirstFiltersLazyQuery>;
export type ConsumerExploreDishFirstFiltersSuspenseQueryHookResult = ReturnType<typeof useConsumerExploreDishFirstFiltersSuspenseQuery>;
export type ConsumerExploreDishFirstFiltersQueryResult = ApolloReactCommon.QueryResult<ConsumerExploreDishFirstFiltersQuery, ConsumerExploreDishFirstFiltersQueryVariables>;
export const ConsumerExploreDishFirstZipCodeDocument = gql`
    query ConsumerExploreDishFirstZipCode($zipCode: String!) {
  zipCode(zipCode: $zipCode) {
    zipCode
    timeZone
    availableToCustomers
    region {
      id
      isVerifiedHalalEnabled
    }
  }
}
    `;
export type ConsumerExploreDishFirstZipCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerExploreDishFirstZipCodeQuery, ConsumerExploreDishFirstZipCodeQueryVariables>, 'query'> & ({ variables: ConsumerExploreDishFirstZipCodeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConsumerExploreDishFirstZipCodeComponent = (props: ConsumerExploreDishFirstZipCodeComponentProps) => (
      <ApolloReactComponents.Query<ConsumerExploreDishFirstZipCodeQuery, ConsumerExploreDishFirstZipCodeQueryVariables> query={ConsumerExploreDishFirstZipCodeDocument} {...props} />
    );
    

/**
 * __useConsumerExploreDishFirstZipCodeQuery__
 *
 * To run a query within a React component, call `useConsumerExploreDishFirstZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerExploreDishFirstZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerExploreDishFirstZipCodeQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useConsumerExploreDishFirstZipCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConsumerExploreDishFirstZipCodeQuery, ConsumerExploreDishFirstZipCodeQueryVariables> & ({ variables: ConsumerExploreDishFirstZipCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerExploreDishFirstZipCodeQuery, ConsumerExploreDishFirstZipCodeQueryVariables>(ConsumerExploreDishFirstZipCodeDocument, options);
      }
export function useConsumerExploreDishFirstZipCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerExploreDishFirstZipCodeQuery, ConsumerExploreDishFirstZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerExploreDishFirstZipCodeQuery, ConsumerExploreDishFirstZipCodeQueryVariables>(ConsumerExploreDishFirstZipCodeDocument, options);
        }
export function useConsumerExploreDishFirstZipCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerExploreDishFirstZipCodeQuery, ConsumerExploreDishFirstZipCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerExploreDishFirstZipCodeQuery, ConsumerExploreDishFirstZipCodeQueryVariables>(ConsumerExploreDishFirstZipCodeDocument, options);
        }
export type ConsumerExploreDishFirstZipCodeQueryHookResult = ReturnType<typeof useConsumerExploreDishFirstZipCodeQuery>;
export type ConsumerExploreDishFirstZipCodeLazyQueryHookResult = ReturnType<typeof useConsumerExploreDishFirstZipCodeLazyQuery>;
export type ConsumerExploreDishFirstZipCodeSuspenseQueryHookResult = ReturnType<typeof useConsumerExploreDishFirstZipCodeSuspenseQuery>;
export type ConsumerExploreDishFirstZipCodeQueryResult = ApolloReactCommon.QueryResult<ConsumerExploreDishFirstZipCodeQuery, ConsumerExploreDishFirstZipCodeQueryVariables>;
export const MoreDishesFromShefDocument = gql`
    query MoreDishesFromShef($shefId: String!, $availableDate: DateTime, $zipCode: String) {
  consumerFoodItems(
    shefId: $shefId
    availableDate: $availableDate
    zipCode: $zipCode
  ) {
    ...DishFirstFoodItem
  }
}
    ${DishFirstFoodItemFragmentDoc}`;
export type MoreDishesFromShefComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MoreDishesFromShefQuery, MoreDishesFromShefQueryVariables>, 'query'> & ({ variables: MoreDishesFromShefQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MoreDishesFromShefComponent = (props: MoreDishesFromShefComponentProps) => (
      <ApolloReactComponents.Query<MoreDishesFromShefQuery, MoreDishesFromShefQueryVariables> query={MoreDishesFromShefDocument} {...props} />
    );
    

/**
 * __useMoreDishesFromShefQuery__
 *
 * To run a query within a React component, call `useMoreDishesFromShefQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoreDishesFromShefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoreDishesFromShefQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      availableDate: // value for 'availableDate'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useMoreDishesFromShefQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MoreDishesFromShefQuery, MoreDishesFromShefQueryVariables> & ({ variables: MoreDishesFromShefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MoreDishesFromShefQuery, MoreDishesFromShefQueryVariables>(MoreDishesFromShefDocument, options);
      }
export function useMoreDishesFromShefLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MoreDishesFromShefQuery, MoreDishesFromShefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MoreDishesFromShefQuery, MoreDishesFromShefQueryVariables>(MoreDishesFromShefDocument, options);
        }
export function useMoreDishesFromShefSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MoreDishesFromShefQuery, MoreDishesFromShefQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MoreDishesFromShefQuery, MoreDishesFromShefQueryVariables>(MoreDishesFromShefDocument, options);
        }
export type MoreDishesFromShefQueryHookResult = ReturnType<typeof useMoreDishesFromShefQuery>;
export type MoreDishesFromShefLazyQueryHookResult = ReturnType<typeof useMoreDishesFromShefLazyQuery>;
export type MoreDishesFromShefSuspenseQueryHookResult = ReturnType<typeof useMoreDishesFromShefSuspenseQuery>;
export type MoreDishesFromShefQueryResult = ApolloReactCommon.QueryResult<MoreDishesFromShefQuery, MoreDishesFromShefQueryVariables>;
export const GetFoodItemDocument = gql`
    query GetFoodItem($shefId: String!, $slug: String!, $zipCode: String) {
  sluggedFoodItem(shefId: $shefId, slug: $slug) {
    ...DishFirstFoodItem
  }
}
    ${DishFirstFoodItemFragmentDoc}`;
export type GetFoodItemComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFoodItemQuery, GetFoodItemQueryVariables>, 'query'> & ({ variables: GetFoodItemQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFoodItemComponent = (props: GetFoodItemComponentProps) => (
      <ApolloReactComponents.Query<GetFoodItemQuery, GetFoodItemQueryVariables> query={GetFoodItemDocument} {...props} />
    );
    

/**
 * __useGetFoodItemQuery__
 *
 * To run a query within a React component, call `useGetFoodItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoodItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoodItemQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      slug: // value for 'slug'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useGetFoodItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFoodItemQuery, GetFoodItemQueryVariables> & ({ variables: GetFoodItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFoodItemQuery, GetFoodItemQueryVariables>(GetFoodItemDocument, options);
      }
export function useGetFoodItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFoodItemQuery, GetFoodItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFoodItemQuery, GetFoodItemQueryVariables>(GetFoodItemDocument, options);
        }
export function useGetFoodItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFoodItemQuery, GetFoodItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFoodItemQuery, GetFoodItemQueryVariables>(GetFoodItemDocument, options);
        }
export type GetFoodItemQueryHookResult = ReturnType<typeof useGetFoodItemQuery>;
export type GetFoodItemLazyQueryHookResult = ReturnType<typeof useGetFoodItemLazyQuery>;
export type GetFoodItemSuspenseQueryHookResult = ReturnType<typeof useGetFoodItemSuspenseQuery>;
export type GetFoodItemQueryResult = ApolloReactCommon.QueryResult<GetFoodItemQuery, GetFoodItemQueryVariables>;
export const PreCheckoutUpsellSuggestionsDocument = gql`
    query PreCheckoutUpsellSuggestions($deliveryDate: String!, $zipCode: String!, $cartFoodItemIds: [Int!]!, $dietaryFilters: [String!]) {
  preCheckoutOrderUpsellRecommendations(
    deliveryDate: $deliveryDate
    zipCode: $zipCode
    cartFoodItemIds: $cartFoodItemIds
    dietaryFilters: $dietaryFilters
  ) {
    ...DishFirstFoodItem
  }
}
    ${DishFirstFoodItemFragmentDoc}`;
export type PreCheckoutUpsellSuggestionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PreCheckoutUpsellSuggestionsQuery, PreCheckoutUpsellSuggestionsQueryVariables>, 'query'> & ({ variables: PreCheckoutUpsellSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PreCheckoutUpsellSuggestionsComponent = (props: PreCheckoutUpsellSuggestionsComponentProps) => (
      <ApolloReactComponents.Query<PreCheckoutUpsellSuggestionsQuery, PreCheckoutUpsellSuggestionsQueryVariables> query={PreCheckoutUpsellSuggestionsDocument} {...props} />
    );
    

/**
 * __usePreCheckoutUpsellSuggestionsQuery__
 *
 * To run a query within a React component, call `usePreCheckoutUpsellSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreCheckoutUpsellSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreCheckoutUpsellSuggestionsQuery({
 *   variables: {
 *      deliveryDate: // value for 'deliveryDate'
 *      zipCode: // value for 'zipCode'
 *      cartFoodItemIds: // value for 'cartFoodItemIds'
 *      dietaryFilters: // value for 'dietaryFilters'
 *   },
 * });
 */
export function usePreCheckoutUpsellSuggestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PreCheckoutUpsellSuggestionsQuery, PreCheckoutUpsellSuggestionsQueryVariables> & ({ variables: PreCheckoutUpsellSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PreCheckoutUpsellSuggestionsQuery, PreCheckoutUpsellSuggestionsQueryVariables>(PreCheckoutUpsellSuggestionsDocument, options);
      }
export function usePreCheckoutUpsellSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PreCheckoutUpsellSuggestionsQuery, PreCheckoutUpsellSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PreCheckoutUpsellSuggestionsQuery, PreCheckoutUpsellSuggestionsQueryVariables>(PreCheckoutUpsellSuggestionsDocument, options);
        }
export function usePreCheckoutUpsellSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PreCheckoutUpsellSuggestionsQuery, PreCheckoutUpsellSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PreCheckoutUpsellSuggestionsQuery, PreCheckoutUpsellSuggestionsQueryVariables>(PreCheckoutUpsellSuggestionsDocument, options);
        }
export type PreCheckoutUpsellSuggestionsQueryHookResult = ReturnType<typeof usePreCheckoutUpsellSuggestionsQuery>;
export type PreCheckoutUpsellSuggestionsLazyQueryHookResult = ReturnType<typeof usePreCheckoutUpsellSuggestionsLazyQuery>;
export type PreCheckoutUpsellSuggestionsSuspenseQueryHookResult = ReturnType<typeof usePreCheckoutUpsellSuggestionsSuspenseQuery>;
export type PreCheckoutUpsellSuggestionsQueryResult = ApolloReactCommon.QueryResult<PreCheckoutUpsellSuggestionsQuery, PreCheckoutUpsellSuggestionsQueryVariables>;
export const CategoryPageRecentReviewsDocument = gql`
    query CategoryPageRecentReviews($regionId: Int!) {
  categoryPageRecentReviews(regionId: $regionId) {
    recentReviews {
      user {
        firstName
      }
      review {
        comment
        createdAt
      }
      shef {
        firstName
        imageUrl
        id
      }
    }
  }
}
    `;
export type CategoryPageRecentReviewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CategoryPageRecentReviewsQuery, CategoryPageRecentReviewsQueryVariables>, 'query'> & ({ variables: CategoryPageRecentReviewsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CategoryPageRecentReviewsComponent = (props: CategoryPageRecentReviewsComponentProps) => (
      <ApolloReactComponents.Query<CategoryPageRecentReviewsQuery, CategoryPageRecentReviewsQueryVariables> query={CategoryPageRecentReviewsDocument} {...props} />
    );
    

/**
 * __useCategoryPageRecentReviewsQuery__
 *
 * To run a query within a React component, call `useCategoryPageRecentReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryPageRecentReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryPageRecentReviewsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCategoryPageRecentReviewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CategoryPageRecentReviewsQuery, CategoryPageRecentReviewsQueryVariables> & ({ variables: CategoryPageRecentReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CategoryPageRecentReviewsQuery, CategoryPageRecentReviewsQueryVariables>(CategoryPageRecentReviewsDocument, options);
      }
export function useCategoryPageRecentReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CategoryPageRecentReviewsQuery, CategoryPageRecentReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CategoryPageRecentReviewsQuery, CategoryPageRecentReviewsQueryVariables>(CategoryPageRecentReviewsDocument, options);
        }
export function useCategoryPageRecentReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CategoryPageRecentReviewsQuery, CategoryPageRecentReviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CategoryPageRecentReviewsQuery, CategoryPageRecentReviewsQueryVariables>(CategoryPageRecentReviewsDocument, options);
        }
export type CategoryPageRecentReviewsQueryHookResult = ReturnType<typeof useCategoryPageRecentReviewsQuery>;
export type CategoryPageRecentReviewsLazyQueryHookResult = ReturnType<typeof useCategoryPageRecentReviewsLazyQuery>;
export type CategoryPageRecentReviewsSuspenseQueryHookResult = ReturnType<typeof useCategoryPageRecentReviewsSuspenseQuery>;
export type CategoryPageRecentReviewsQueryResult = ApolloReactCommon.QueryResult<CategoryPageRecentReviewsQuery, CategoryPageRecentReviewsQueryVariables>;
export const ExploreCuisineDocument = gql`
    query ExploreCuisine($zipCode: String!, $cuisineTitle: String!, $seed: String!, $filters: ExploreSegmentsFilterInput!, $numFoodItems: Int!) {
  exploreCuisine(cuisineTitle: $cuisineTitle, seed: $seed, filters: $filters) {
    availableDeliveryDays
    segments {
      ...ConsumerExplore2ExploreSegment
    }
    ancestorCuisinesAvailability {
      ...CuisineSearchResultFields
    }
  }
  zipCode(zipCode: $zipCode) {
    zipCode
    timeZone
    availableToCustomers
    region {
      id
    }
  }
}
    ${ConsumerExplore2ExploreSegmentFragmentDoc}
${CuisineSearchResultFieldsFragmentDoc}`;
export type ExploreCuisineComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExploreCuisineQuery, ExploreCuisineQueryVariables>, 'query'> & ({ variables: ExploreCuisineQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExploreCuisineComponent = (props: ExploreCuisineComponentProps) => (
      <ApolloReactComponents.Query<ExploreCuisineQuery, ExploreCuisineQueryVariables> query={ExploreCuisineDocument} {...props} />
    );
    

/**
 * __useExploreCuisineQuery__
 *
 * To run a query within a React component, call `useExploreCuisineQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreCuisineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreCuisineQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      cuisineTitle: // value for 'cuisineTitle'
 *      seed: // value for 'seed'
 *      filters: // value for 'filters'
 *      numFoodItems: // value for 'numFoodItems'
 *   },
 * });
 */
export function useExploreCuisineQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExploreCuisineQuery, ExploreCuisineQueryVariables> & ({ variables: ExploreCuisineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExploreCuisineQuery, ExploreCuisineQueryVariables>(ExploreCuisineDocument, options);
      }
export function useExploreCuisineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExploreCuisineQuery, ExploreCuisineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExploreCuisineQuery, ExploreCuisineQueryVariables>(ExploreCuisineDocument, options);
        }
export function useExploreCuisineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExploreCuisineQuery, ExploreCuisineQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExploreCuisineQuery, ExploreCuisineQueryVariables>(ExploreCuisineDocument, options);
        }
export type ExploreCuisineQueryHookResult = ReturnType<typeof useExploreCuisineQuery>;
export type ExploreCuisineLazyQueryHookResult = ReturnType<typeof useExploreCuisineLazyQuery>;
export type ExploreCuisineSuspenseQueryHookResult = ReturnType<typeof useExploreCuisineSuspenseQuery>;
export type ExploreCuisineQueryResult = ApolloReactCommon.QueryResult<ExploreCuisineQuery, ExploreCuisineQueryVariables>;
export const ExploreMerchandiseDocument = gql`
    query ExploreMerchandise($zipCode: String!, $seed: String!, $slug: String!, $filters: ExploreSegmentsFilterInput!, $numFoodItems: Int!) {
  exploreMerchandise(seed: $seed, slug: $slug, filters: $filters) {
    availableDeliveryDays
    segments {
      ...ConsumerExplore2ExploreSegment
    }
  }
  zipCode(zipCode: $zipCode) {
    zipCode
    timeZone
    availableToCustomers
    region {
      id
    }
  }
}
    ${ConsumerExplore2ExploreSegmentFragmentDoc}`;
export type ExploreMerchandiseComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExploreMerchandiseQuery, ExploreMerchandiseQueryVariables>, 'query'> & ({ variables: ExploreMerchandiseQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExploreMerchandiseComponent = (props: ExploreMerchandiseComponentProps) => (
      <ApolloReactComponents.Query<ExploreMerchandiseQuery, ExploreMerchandiseQueryVariables> query={ExploreMerchandiseDocument} {...props} />
    );
    

/**
 * __useExploreMerchandiseQuery__
 *
 * To run a query within a React component, call `useExploreMerchandiseQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreMerchandiseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreMerchandiseQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      seed: // value for 'seed'
 *      slug: // value for 'slug'
 *      filters: // value for 'filters'
 *      numFoodItems: // value for 'numFoodItems'
 *   },
 * });
 */
export function useExploreMerchandiseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExploreMerchandiseQuery, ExploreMerchandiseQueryVariables> & ({ variables: ExploreMerchandiseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExploreMerchandiseQuery, ExploreMerchandiseQueryVariables>(ExploreMerchandiseDocument, options);
      }
export function useExploreMerchandiseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExploreMerchandiseQuery, ExploreMerchandiseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExploreMerchandiseQuery, ExploreMerchandiseQueryVariables>(ExploreMerchandiseDocument, options);
        }
export function useExploreMerchandiseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExploreMerchandiseQuery, ExploreMerchandiseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExploreMerchandiseQuery, ExploreMerchandiseQueryVariables>(ExploreMerchandiseDocument, options);
        }
export type ExploreMerchandiseQueryHookResult = ReturnType<typeof useExploreMerchandiseQuery>;
export type ExploreMerchandiseLazyQueryHookResult = ReturnType<typeof useExploreMerchandiseLazyQuery>;
export type ExploreMerchandiseSuspenseQueryHookResult = ReturnType<typeof useExploreMerchandiseSuspenseQuery>;
export type ExploreMerchandiseQueryResult = ApolloReactCommon.QueryResult<ExploreMerchandiseQuery, ExploreMerchandiseQueryVariables>;
export const ExploreMerchandisePageDocument = gql`
    query ExploreMerchandisePage($slug: String!) {
  exploreMerchandisePage(slug: $slug) {
    id
    slug
    title
    subtitle
    pageName
    heroPhotoUrl
  }
}
    `;
export type ExploreMerchandisePageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExploreMerchandisePageQuery, ExploreMerchandisePageQueryVariables>, 'query'> & ({ variables: ExploreMerchandisePageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExploreMerchandisePageComponent = (props: ExploreMerchandisePageComponentProps) => (
      <ApolloReactComponents.Query<ExploreMerchandisePageQuery, ExploreMerchandisePageQueryVariables> query={ExploreMerchandisePageDocument} {...props} />
    );
    

/**
 * __useExploreMerchandisePageQuery__
 *
 * To run a query within a React component, call `useExploreMerchandisePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreMerchandisePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreMerchandisePageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useExploreMerchandisePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExploreMerchandisePageQuery, ExploreMerchandisePageQueryVariables> & ({ variables: ExploreMerchandisePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExploreMerchandisePageQuery, ExploreMerchandisePageQueryVariables>(ExploreMerchandisePageDocument, options);
      }
export function useExploreMerchandisePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExploreMerchandisePageQuery, ExploreMerchandisePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExploreMerchandisePageQuery, ExploreMerchandisePageQueryVariables>(ExploreMerchandisePageDocument, options);
        }
export function useExploreMerchandisePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExploreMerchandisePageQuery, ExploreMerchandisePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExploreMerchandisePageQuery, ExploreMerchandisePageQueryVariables>(ExploreMerchandisePageDocument, options);
        }
export type ExploreMerchandisePageQueryHookResult = ReturnType<typeof useExploreMerchandisePageQuery>;
export type ExploreMerchandisePageLazyQueryHookResult = ReturnType<typeof useExploreMerchandisePageLazyQuery>;
export type ExploreMerchandisePageSuspenseQueryHookResult = ReturnType<typeof useExploreMerchandisePageSuspenseQuery>;
export type ExploreMerchandisePageQueryResult = ApolloReactCommon.QueryResult<ExploreMerchandisePageQuery, ExploreMerchandisePageQueryVariables>;
export const FollowShefDocument = gql`
    mutation FollowShef($shefId: String!, $canRefollow: Boolean) {
  followShef(shefId: $shefId, canRefollow: $canRefollow) {
    ...FollowShefInfo
  }
}
    ${FollowShefInfoFragmentDoc}`;
export type FollowShefMutationFn = ApolloReactCommon.MutationFunction<FollowShefMutation, FollowShefMutationVariables>;
export type FollowShefComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<FollowShefMutation, FollowShefMutationVariables>, 'mutation'>;

    export const FollowShefComponent = (props: FollowShefComponentProps) => (
      <ApolloReactComponents.Mutation<FollowShefMutation, FollowShefMutationVariables> mutation={FollowShefDocument} {...props} />
    );
    

/**
 * __useFollowShefMutation__
 *
 * To run a mutation, you first call `useFollowShefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowShefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followShefMutation, { data, loading, error }] = useFollowShefMutation({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      canRefollow: // value for 'canRefollow'
 *   },
 * });
 */
export function useFollowShefMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FollowShefMutation, FollowShefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FollowShefMutation, FollowShefMutationVariables>(FollowShefDocument, options);
      }
export type FollowShefMutationHookResult = ReturnType<typeof useFollowShefMutation>;
export type FollowShefMutationResult = ApolloReactCommon.MutationResult<FollowShefMutation>;
export type FollowShefMutationOptions = ApolloReactCommon.BaseMutationOptions<FollowShefMutation, FollowShefMutationVariables>;
export const UnfollowShefDocument = gql`
    mutation UnfollowShef($shefId: String!) {
  unfollowShef(shefId: $shefId)
}
    `;
export type UnfollowShefMutationFn = ApolloReactCommon.MutationFunction<UnfollowShefMutation, UnfollowShefMutationVariables>;
export type UnfollowShefComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnfollowShefMutation, UnfollowShefMutationVariables>, 'mutation'>;

    export const UnfollowShefComponent = (props: UnfollowShefComponentProps) => (
      <ApolloReactComponents.Mutation<UnfollowShefMutation, UnfollowShefMutationVariables> mutation={UnfollowShefDocument} {...props} />
    );
    

/**
 * __useUnfollowShefMutation__
 *
 * To run a mutation, you first call `useUnfollowShefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowShefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowShefMutation, { data, loading, error }] = useUnfollowShefMutation({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useUnfollowShefMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnfollowShefMutation, UnfollowShefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnfollowShefMutation, UnfollowShefMutationVariables>(UnfollowShefDocument, options);
      }
export type UnfollowShefMutationHookResult = ReturnType<typeof useUnfollowShefMutation>;
export type UnfollowShefMutationResult = ApolloReactCommon.MutationResult<UnfollowShefMutation>;
export type UnfollowShefMutationOptions = ApolloReactCommon.BaseMutationOptions<UnfollowShefMutation, UnfollowShefMutationVariables>;
export const FollowedShefsDocument = gql`
    query FollowedShefs {
  me {
    followedShefs {
      ...FollowShefInfo
    }
  }
}
    ${FollowShefInfoFragmentDoc}`;
export type FollowedShefsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FollowedShefsQuery, FollowedShefsQueryVariables>, 'query'>;

    export const FollowedShefsComponent = (props: FollowedShefsComponentProps) => (
      <ApolloReactComponents.Query<FollowedShefsQuery, FollowedShefsQueryVariables> query={FollowedShefsDocument} {...props} />
    );
    

/**
 * __useFollowedShefsQuery__
 *
 * To run a query within a React component, call `useFollowedShefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowedShefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowedShefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFollowedShefsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FollowedShefsQuery, FollowedShefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FollowedShefsQuery, FollowedShefsQueryVariables>(FollowedShefsDocument, options);
      }
export function useFollowedShefsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FollowedShefsQuery, FollowedShefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FollowedShefsQuery, FollowedShefsQueryVariables>(FollowedShefsDocument, options);
        }
export function useFollowedShefsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FollowedShefsQuery, FollowedShefsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FollowedShefsQuery, FollowedShefsQueryVariables>(FollowedShefsDocument, options);
        }
export type FollowedShefsQueryHookResult = ReturnType<typeof useFollowedShefsQuery>;
export type FollowedShefsLazyQueryHookResult = ReturnType<typeof useFollowedShefsLazyQuery>;
export type FollowedShefsSuspenseQueryHookResult = ReturnType<typeof useFollowedShefsSuspenseQuery>;
export type FollowedShefsQueryResult = ApolloReactCommon.QueryResult<FollowedShefsQuery, FollowedShefsQueryVariables>;
export const FollowingPostsDocument = gql`
    query FollowingPosts($userId: String!, $page: Int, $resultsPerPage: Int) {
  followingPosts(userId: $userId, page: $page, resultsPerPage: $resultsPerPage) {
    ...ShefPostData
  }
}
    ${ShefPostDataFragmentDoc}`;
export type FollowingPostsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FollowingPostsQuery, FollowingPostsQueryVariables>, 'query'> & ({ variables: FollowingPostsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FollowingPostsComponent = (props: FollowingPostsComponentProps) => (
      <ApolloReactComponents.Query<FollowingPostsQuery, FollowingPostsQueryVariables> query={FollowingPostsDocument} {...props} />
    );
    

/**
 * __useFollowingPostsQuery__
 *
 * To run a query within a React component, call `useFollowingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowingPostsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      resultsPerPage: // value for 'resultsPerPage'
 *   },
 * });
 */
export function useFollowingPostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FollowingPostsQuery, FollowingPostsQueryVariables> & ({ variables: FollowingPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FollowingPostsQuery, FollowingPostsQueryVariables>(FollowingPostsDocument, options);
      }
export function useFollowingPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FollowingPostsQuery, FollowingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FollowingPostsQuery, FollowingPostsQueryVariables>(FollowingPostsDocument, options);
        }
export function useFollowingPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FollowingPostsQuery, FollowingPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FollowingPostsQuery, FollowingPostsQueryVariables>(FollowingPostsDocument, options);
        }
export type FollowingPostsQueryHookResult = ReturnType<typeof useFollowingPostsQuery>;
export type FollowingPostsLazyQueryHookResult = ReturnType<typeof useFollowingPostsLazyQuery>;
export type FollowingPostsSuspenseQueryHookResult = ReturnType<typeof useFollowingPostsSuspenseQuery>;
export type FollowingPostsQueryResult = ApolloReactCommon.QueryResult<FollowingPostsQuery, FollowingPostsQueryVariables>;
export const FollowedShefsListDocument = gql`
    query FollowedShefsList {
  me {
    followedShefs {
      flakeId
      id
      imageUrl
      publicName
      resizedImageUrl(width: 1200)
      rating {
        count
        score
      }
      activeFoodItems {
        id
        resizedImageUrl(width: 1200)
      }
      shefProfile {
        id
        coverPhotoUrl
        resizedCoverPhotoUrl(width: 1200)
        previewFoodItem {
          id
          imageUrl
          resizedImageUrl(width: 1200)
        }
      }
      cuisineCategories {
        id
        title
        type
      }
    }
  }
}
    `;
export type FollowedShefsListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FollowedShefsListQuery, FollowedShefsListQueryVariables>, 'query'>;

    export const FollowedShefsListComponent = (props: FollowedShefsListComponentProps) => (
      <ApolloReactComponents.Query<FollowedShefsListQuery, FollowedShefsListQueryVariables> query={FollowedShefsListDocument} {...props} />
    );
    

/**
 * __useFollowedShefsListQuery__
 *
 * To run a query within a React component, call `useFollowedShefsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowedShefsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowedShefsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFollowedShefsListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FollowedShefsListQuery, FollowedShefsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FollowedShefsListQuery, FollowedShefsListQueryVariables>(FollowedShefsListDocument, options);
      }
export function useFollowedShefsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FollowedShefsListQuery, FollowedShefsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FollowedShefsListQuery, FollowedShefsListQueryVariables>(FollowedShefsListDocument, options);
        }
export function useFollowedShefsListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FollowedShefsListQuery, FollowedShefsListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FollowedShefsListQuery, FollowedShefsListQueryVariables>(FollowedShefsListDocument, options);
        }
export type FollowedShefsListQueryHookResult = ReturnType<typeof useFollowedShefsListQuery>;
export type FollowedShefsListLazyQueryHookResult = ReturnType<typeof useFollowedShefsListLazyQuery>;
export type FollowedShefsListSuspenseQueryHookResult = ReturnType<typeof useFollowedShefsListSuspenseQuery>;
export type FollowedShefsListQueryResult = ApolloReactCommon.QueryResult<FollowedShefsListQuery, FollowedShefsListQueryVariables>;
export const GetCuisineCategoriesDocument = gql`
    query GetCuisineCategories {
  cuisineCategories {
    id
    parentId
    subcuisines {
      id
    }
  }
}
    `;
export type GetCuisineCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCuisineCategoriesQuery, GetCuisineCategoriesQueryVariables>, 'query'>;

    export const GetCuisineCategoriesComponent = (props: GetCuisineCategoriesComponentProps) => (
      <ApolloReactComponents.Query<GetCuisineCategoriesQuery, GetCuisineCategoriesQueryVariables> query={GetCuisineCategoriesDocument} {...props} />
    );
    

/**
 * __useGetCuisineCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCuisineCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCuisineCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCuisineCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCuisineCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCuisineCategoriesQuery, GetCuisineCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCuisineCategoriesQuery, GetCuisineCategoriesQueryVariables>(GetCuisineCategoriesDocument, options);
      }
export function useGetCuisineCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCuisineCategoriesQuery, GetCuisineCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCuisineCategoriesQuery, GetCuisineCategoriesQueryVariables>(GetCuisineCategoriesDocument, options);
        }
export function useGetCuisineCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCuisineCategoriesQuery, GetCuisineCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCuisineCategoriesQuery, GetCuisineCategoriesQueryVariables>(GetCuisineCategoriesDocument, options);
        }
export type GetCuisineCategoriesQueryHookResult = ReturnType<typeof useGetCuisineCategoriesQuery>;
export type GetCuisineCategoriesLazyQueryHookResult = ReturnType<typeof useGetCuisineCategoriesLazyQuery>;
export type GetCuisineCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCuisineCategoriesSuspenseQuery>;
export type GetCuisineCategoriesQueryResult = ApolloReactCommon.QueryResult<GetCuisineCategoriesQuery, GetCuisineCategoriesQueryVariables>;
export const GetRegionalShefCuisineCategoriesDocument = gql`
    query GetRegionalShefCuisineCategories {
  regionalShefCuisineCategories {
    cuisineCategoryId
  }
}
    `;
export type GetRegionalShefCuisineCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRegionalShefCuisineCategoriesQuery, GetRegionalShefCuisineCategoriesQueryVariables>, 'query'>;

    export const GetRegionalShefCuisineCategoriesComponent = (props: GetRegionalShefCuisineCategoriesComponentProps) => (
      <ApolloReactComponents.Query<GetRegionalShefCuisineCategoriesQuery, GetRegionalShefCuisineCategoriesQueryVariables> query={GetRegionalShefCuisineCategoriesDocument} {...props} />
    );
    

/**
 * __useGetRegionalShefCuisineCategoriesQuery__
 *
 * To run a query within a React component, call `useGetRegionalShefCuisineCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionalShefCuisineCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionalShefCuisineCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionalShefCuisineCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegionalShefCuisineCategoriesQuery, GetRegionalShefCuisineCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRegionalShefCuisineCategoriesQuery, GetRegionalShefCuisineCategoriesQueryVariables>(GetRegionalShefCuisineCategoriesDocument, options);
      }
export function useGetRegionalShefCuisineCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegionalShefCuisineCategoriesQuery, GetRegionalShefCuisineCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRegionalShefCuisineCategoriesQuery, GetRegionalShefCuisineCategoriesQueryVariables>(GetRegionalShefCuisineCategoriesDocument, options);
        }
export function useGetRegionalShefCuisineCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRegionalShefCuisineCategoriesQuery, GetRegionalShefCuisineCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRegionalShefCuisineCategoriesQuery, GetRegionalShefCuisineCategoriesQueryVariables>(GetRegionalShefCuisineCategoriesDocument, options);
        }
export type GetRegionalShefCuisineCategoriesQueryHookResult = ReturnType<typeof useGetRegionalShefCuisineCategoriesQuery>;
export type GetRegionalShefCuisineCategoriesLazyQueryHookResult = ReturnType<typeof useGetRegionalShefCuisineCategoriesLazyQuery>;
export type GetRegionalShefCuisineCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetRegionalShefCuisineCategoriesSuspenseQuery>;
export type GetRegionalShefCuisineCategoriesQueryResult = ApolloReactCommon.QueryResult<GetRegionalShefCuisineCategoriesQuery, GetRegionalShefCuisineCategoriesQueryVariables>;
export const GetMealPlanTypeDocument = gql`
    query GetMealPlanType($id: Int!) {
  getMealPlanType(mealPlanTypeId: $id) {
    displayName
    unit
    weeklyCost
    pricePerUnit
    numServings
  }
}
    `;
export type GetMealPlanTypeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMealPlanTypeQuery, GetMealPlanTypeQueryVariables>, 'query'> & ({ variables: GetMealPlanTypeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMealPlanTypeComponent = (props: GetMealPlanTypeComponentProps) => (
      <ApolloReactComponents.Query<GetMealPlanTypeQuery, GetMealPlanTypeQueryVariables> query={GetMealPlanTypeDocument} {...props} />
    );
    

/**
 * __useGetMealPlanTypeQuery__
 *
 * To run a query within a React component, call `useGetMealPlanTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMealPlanTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMealPlanTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMealPlanTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMealPlanTypeQuery, GetMealPlanTypeQueryVariables> & ({ variables: GetMealPlanTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMealPlanTypeQuery, GetMealPlanTypeQueryVariables>(GetMealPlanTypeDocument, options);
      }
export function useGetMealPlanTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMealPlanTypeQuery, GetMealPlanTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMealPlanTypeQuery, GetMealPlanTypeQueryVariables>(GetMealPlanTypeDocument, options);
        }
export function useGetMealPlanTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMealPlanTypeQuery, GetMealPlanTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMealPlanTypeQuery, GetMealPlanTypeQueryVariables>(GetMealPlanTypeDocument, options);
        }
export type GetMealPlanTypeQueryHookResult = ReturnType<typeof useGetMealPlanTypeQuery>;
export type GetMealPlanTypeLazyQueryHookResult = ReturnType<typeof useGetMealPlanTypeLazyQuery>;
export type GetMealPlanTypeSuspenseQueryHookResult = ReturnType<typeof useGetMealPlanTypeSuspenseQuery>;
export type GetMealPlanTypeQueryResult = ApolloReactCommon.QueryResult<GetMealPlanTypeQuery, GetMealPlanTypeQueryVariables>;
export const GetShefRosterDocument = gql`
    query GetShefRoster($tasteProfile: TasteProfileInput!, $zipCode: String!, $deliveryDate: String!, $mealPlanTypeId: Int!) {
  getShefRoster(
    tasteProfile: $tasteProfile
    zipCode: $zipCode
    deliveryDate: $deliveryDate
    mealPlanTypeId: $mealPlanTypeId
  ) {
    shefs {
      id
      firstName
      imageUrl
      shefRosterStatus(
        tasteProfile: $tasteProfile
        deliveryDate: $deliveryDate
        zipCode: $zipCode
        mealPlanTypeId: $mealPlanTypeId
      )
    }
  }
}
    `;
export type GetShefRosterComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShefRosterQuery, GetShefRosterQueryVariables>, 'query'> & ({ variables: GetShefRosterQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetShefRosterComponent = (props: GetShefRosterComponentProps) => (
      <ApolloReactComponents.Query<GetShefRosterQuery, GetShefRosterQueryVariables> query={GetShefRosterDocument} {...props} />
    );
    

/**
 * __useGetShefRosterQuery__
 *
 * To run a query within a React component, call `useGetShefRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShefRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShefRosterQuery({
 *   variables: {
 *      tasteProfile: // value for 'tasteProfile'
 *      zipCode: // value for 'zipCode'
 *      deliveryDate: // value for 'deliveryDate'
 *      mealPlanTypeId: // value for 'mealPlanTypeId'
 *   },
 * });
 */
export function useGetShefRosterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetShefRosterQuery, GetShefRosterQueryVariables> & ({ variables: GetShefRosterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetShefRosterQuery, GetShefRosterQueryVariables>(GetShefRosterDocument, options);
      }
export function useGetShefRosterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShefRosterQuery, GetShefRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetShefRosterQuery, GetShefRosterQueryVariables>(GetShefRosterDocument, options);
        }
export function useGetShefRosterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetShefRosterQuery, GetShefRosterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetShefRosterQuery, GetShefRosterQueryVariables>(GetShefRosterDocument, options);
        }
export type GetShefRosterQueryHookResult = ReturnType<typeof useGetShefRosterQuery>;
export type GetShefRosterLazyQueryHookResult = ReturnType<typeof useGetShefRosterLazyQuery>;
export type GetShefRosterSuspenseQueryHookResult = ReturnType<typeof useGetShefRosterSuspenseQuery>;
export type GetShefRosterQueryResult = ApolloReactCommon.QueryResult<GetShefRosterQuery, GetShefRosterQueryVariables>;
export const GetShefInfoForProfilePageDocument = gql`
    query GetShefInfoForProfilePage($shefId: String!, $tasteProfile: TasteProfileInput, $deliveryDate: String, $zipCode: String, $format: MealPlanFormat, $mealPlanTypeId: Int, $includeSoldOutDishes: Boolean) {
  shef(userId: $shefId) {
    ...ShefProfileComponent
  }
  publicReviews(shefId: $shefId, limit: 40, offset: 0, requireComments: true) {
    total
    reviews {
      ...ConsumerOrderReview
    }
  }
}
    ${ShefProfileComponentFragmentDoc}
${ConsumerOrderReviewFragmentDoc}`;
export type GetShefInfoForProfilePageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShefInfoForProfilePageQuery, GetShefInfoForProfilePageQueryVariables>, 'query'> & ({ variables: GetShefInfoForProfilePageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetShefInfoForProfilePageComponent = (props: GetShefInfoForProfilePageComponentProps) => (
      <ApolloReactComponents.Query<GetShefInfoForProfilePageQuery, GetShefInfoForProfilePageQueryVariables> query={GetShefInfoForProfilePageDocument} {...props} />
    );
    

/**
 * __useGetShefInfoForProfilePageQuery__
 *
 * To run a query within a React component, call `useGetShefInfoForProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShefInfoForProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShefInfoForProfilePageQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      tasteProfile: // value for 'tasteProfile'
 *      deliveryDate: // value for 'deliveryDate'
 *      zipCode: // value for 'zipCode'
 *      format: // value for 'format'
 *      mealPlanTypeId: // value for 'mealPlanTypeId'
 *      includeSoldOutDishes: // value for 'includeSoldOutDishes'
 *   },
 * });
 */
export function useGetShefInfoForProfilePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetShefInfoForProfilePageQuery, GetShefInfoForProfilePageQueryVariables> & ({ variables: GetShefInfoForProfilePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetShefInfoForProfilePageQuery, GetShefInfoForProfilePageQueryVariables>(GetShefInfoForProfilePageDocument, options);
      }
export function useGetShefInfoForProfilePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShefInfoForProfilePageQuery, GetShefInfoForProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetShefInfoForProfilePageQuery, GetShefInfoForProfilePageQueryVariables>(GetShefInfoForProfilePageDocument, options);
        }
export function useGetShefInfoForProfilePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetShefInfoForProfilePageQuery, GetShefInfoForProfilePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetShefInfoForProfilePageQuery, GetShefInfoForProfilePageQueryVariables>(GetShefInfoForProfilePageDocument, options);
        }
export type GetShefInfoForProfilePageQueryHookResult = ReturnType<typeof useGetShefInfoForProfilePageQuery>;
export type GetShefInfoForProfilePageLazyQueryHookResult = ReturnType<typeof useGetShefInfoForProfilePageLazyQuery>;
export type GetShefInfoForProfilePageSuspenseQueryHookResult = ReturnType<typeof useGetShefInfoForProfilePageSuspenseQuery>;
export type GetShefInfoForProfilePageQueryResult = ApolloReactCommon.QueryResult<GetShefInfoForProfilePageQuery, GetShefInfoForProfilePageQueryVariables>;
export const GetMealPlanningMenuDocument = gql`
    query GetMealPlanningMenu($zipCode: String!, $deliveryDate: String!, $mealPlanTypeId: Int, $dietType: DietType, $preferredProteins: [Protein!], $menuDietaryRestrictions: [String!], $includeFullCapacityShefs: Boolean) {
  getMealPlanningMenu(
    zipCode: $zipCode
    deliveryDate: $deliveryDate
    mealPlanTypeId: $mealPlanTypeId
    dietType: $dietType
    preferredProteins: $preferredProteins
    menuDietaryRestrictions: $menuDietaryRestrictions
    includeFullCapacityShefs: $includeFullCapacityShefs
  ) {
    shefSegments {
      shefRemainingAvailability
      shef {
        flakeId
        ...MealPlanDisplayShef
      }
      foodItems {
        ...MealPlanDisplayFoodItem
      }
    }
    mains {
      shefRemainingAvailability
      shef {
        flakeId
        ...MealPlanDisplayShef
      }
      foodItems {
        ...MealPlanDisplayFoodItem
      }
    }
    sides {
      shefRemainingAvailability
      shef {
        flakeId
        ...MealPlanDisplayShef
      }
      foodItems {
        ...MealPlanDisplayFoodItem
      }
    }
    userPrefs {
      ...UserPrefs
    }
  }
}
    ${MealPlanDisplayShefFragmentDoc}
${MealPlanDisplayFoodItemFragmentDoc}
${UserPrefsFragmentDoc}`;
export type GetMealPlanningMenuComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMealPlanningMenuQuery, GetMealPlanningMenuQueryVariables>, 'query'> & ({ variables: GetMealPlanningMenuQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMealPlanningMenuComponent = (props: GetMealPlanningMenuComponentProps) => (
      <ApolloReactComponents.Query<GetMealPlanningMenuQuery, GetMealPlanningMenuQueryVariables> query={GetMealPlanningMenuDocument} {...props} />
    );
    

/**
 * __useGetMealPlanningMenuQuery__
 *
 * To run a query within a React component, call `useGetMealPlanningMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMealPlanningMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMealPlanningMenuQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      deliveryDate: // value for 'deliveryDate'
 *      mealPlanTypeId: // value for 'mealPlanTypeId'
 *      dietType: // value for 'dietType'
 *      preferredProteins: // value for 'preferredProteins'
 *      menuDietaryRestrictions: // value for 'menuDietaryRestrictions'
 *      includeFullCapacityShefs: // value for 'includeFullCapacityShefs'
 *   },
 * });
 */
export function useGetMealPlanningMenuQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMealPlanningMenuQuery, GetMealPlanningMenuQueryVariables> & ({ variables: GetMealPlanningMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMealPlanningMenuQuery, GetMealPlanningMenuQueryVariables>(GetMealPlanningMenuDocument, options);
      }
export function useGetMealPlanningMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMealPlanningMenuQuery, GetMealPlanningMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMealPlanningMenuQuery, GetMealPlanningMenuQueryVariables>(GetMealPlanningMenuDocument, options);
        }
export function useGetMealPlanningMenuSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMealPlanningMenuQuery, GetMealPlanningMenuQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMealPlanningMenuQuery, GetMealPlanningMenuQueryVariables>(GetMealPlanningMenuDocument, options);
        }
export type GetMealPlanningMenuQueryHookResult = ReturnType<typeof useGetMealPlanningMenuQuery>;
export type GetMealPlanningMenuLazyQueryHookResult = ReturnType<typeof useGetMealPlanningMenuLazyQuery>;
export type GetMealPlanningMenuSuspenseQueryHookResult = ReturnType<typeof useGetMealPlanningMenuSuspenseQuery>;
export type GetMealPlanningMenuQueryResult = ApolloReactCommon.QueryResult<GetMealPlanningMenuQuery, GetMealPlanningMenuQueryVariables>;
export const MealPlanningPurchaseAttemptDocument = gql`
    mutation MealPlanningPurchaseAttempt($input: MealPlanningPurchaseInput!) {
  attemptMealPlanningPurchase(input: $input)
}
    `;
export type MealPlanningPurchaseAttemptMutationFn = ApolloReactCommon.MutationFunction<MealPlanningPurchaseAttemptMutation, MealPlanningPurchaseAttemptMutationVariables>;
export type MealPlanningPurchaseAttemptComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MealPlanningPurchaseAttemptMutation, MealPlanningPurchaseAttemptMutationVariables>, 'mutation'>;

    export const MealPlanningPurchaseAttemptComponent = (props: MealPlanningPurchaseAttemptComponentProps) => (
      <ApolloReactComponents.Mutation<MealPlanningPurchaseAttemptMutation, MealPlanningPurchaseAttemptMutationVariables> mutation={MealPlanningPurchaseAttemptDocument} {...props} />
    );
    

/**
 * __useMealPlanningPurchaseAttemptMutation__
 *
 * To run a mutation, you first call `useMealPlanningPurchaseAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMealPlanningPurchaseAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mealPlanningPurchaseAttemptMutation, { data, loading, error }] = useMealPlanningPurchaseAttemptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMealPlanningPurchaseAttemptMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MealPlanningPurchaseAttemptMutation, MealPlanningPurchaseAttemptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MealPlanningPurchaseAttemptMutation, MealPlanningPurchaseAttemptMutationVariables>(MealPlanningPurchaseAttemptDocument, options);
      }
export type MealPlanningPurchaseAttemptMutationHookResult = ReturnType<typeof useMealPlanningPurchaseAttemptMutation>;
export type MealPlanningPurchaseAttemptMutationResult = ApolloReactCommon.MutationResult<MealPlanningPurchaseAttemptMutation>;
export type MealPlanningPurchaseAttemptMutationOptions = ApolloReactCommon.BaseMutationOptions<MealPlanningPurchaseAttemptMutation, MealPlanningPurchaseAttemptMutationVariables>;
export const InitializeMealPlanDocument = gql`
    mutation InitializeMealPlan($input: InitializeMealPlanInput!) {
  initializeMealPlan(input: $input) {
    success
    message
    groupOrderId
  }
}
    `;
export type InitializeMealPlanMutationFn = ApolloReactCommon.MutationFunction<InitializeMealPlanMutation, InitializeMealPlanMutationVariables>;
export type InitializeMealPlanComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InitializeMealPlanMutation, InitializeMealPlanMutationVariables>, 'mutation'>;

    export const InitializeMealPlanComponent = (props: InitializeMealPlanComponentProps) => (
      <ApolloReactComponents.Mutation<InitializeMealPlanMutation, InitializeMealPlanMutationVariables> mutation={InitializeMealPlanDocument} {...props} />
    );
    

/**
 * __useInitializeMealPlanMutation__
 *
 * To run a mutation, you first call `useInitializeMealPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeMealPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeMealPlanMutation, { data, loading, error }] = useInitializeMealPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitializeMealPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitializeMealPlanMutation, InitializeMealPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InitializeMealPlanMutation, InitializeMealPlanMutationVariables>(InitializeMealPlanDocument, options);
      }
export type InitializeMealPlanMutationHookResult = ReturnType<typeof useInitializeMealPlanMutation>;
export type InitializeMealPlanMutationResult = ApolloReactCommon.MutationResult<InitializeMealPlanMutation>;
export type InitializeMealPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<InitializeMealPlanMutation, InitializeMealPlanMutationVariables>;
export const ModifyHeldGroupOrderDocument = gql`
    mutation ModifyHeldGroupOrder($input: ModifyHeldGroupOrderInput!) {
  modifyHeldGroupOrder(input: $input) {
    orders {
      id
    }
    success
    message
  }
}
    `;
export type ModifyHeldGroupOrderMutationFn = ApolloReactCommon.MutationFunction<ModifyHeldGroupOrderMutation, ModifyHeldGroupOrderMutationVariables>;
export type ModifyHeldGroupOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ModifyHeldGroupOrderMutation, ModifyHeldGroupOrderMutationVariables>, 'mutation'>;

    export const ModifyHeldGroupOrderComponent = (props: ModifyHeldGroupOrderComponentProps) => (
      <ApolloReactComponents.Mutation<ModifyHeldGroupOrderMutation, ModifyHeldGroupOrderMutationVariables> mutation={ModifyHeldGroupOrderDocument} {...props} />
    );
    

/**
 * __useModifyHeldGroupOrderMutation__
 *
 * To run a mutation, you first call `useModifyHeldGroupOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyHeldGroupOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyHeldGroupOrderMutation, { data, loading, error }] = useModifyHeldGroupOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyHeldGroupOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ModifyHeldGroupOrderMutation, ModifyHeldGroupOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ModifyHeldGroupOrderMutation, ModifyHeldGroupOrderMutationVariables>(ModifyHeldGroupOrderDocument, options);
      }
export type ModifyHeldGroupOrderMutationHookResult = ReturnType<typeof useModifyHeldGroupOrderMutation>;
export type ModifyHeldGroupOrderMutationResult = ApolloReactCommon.MutationResult<ModifyHeldGroupOrderMutation>;
export type ModifyHeldGroupOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<ModifyHeldGroupOrderMutation, ModifyHeldGroupOrderMutationVariables>;
export const GetSubscriptionDocument = gql`
    query GetSubscription($userId: String!) {
  getMealPlanForUser(userId: $userId) {
    mealPlan {
      id
      isReusablePackagingPlan
      mealPlanType {
        unit
        pricePerUnit
        weeklyCost
        numServings
        id
        displayName
        format
        regionId
      }
    }
    nextDeliveryDate
    mealPlanRegionId
    mealPlanZipCode
  }
  getTasteProfile(input: {userId: $userId}) {
    tasteProfile {
      id
      dietType
      replacementDietaryRestrictions
      menuDietaryRestrictions
      preferredProteins
      cuisinePreferences
      numAdults
      numLittleEaters
      numBigEaters
    }
  }
}
    `;
export type GetSubscriptionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>, 'query'> & ({ variables: GetSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSubscriptionComponent = (props: GetSubscriptionComponentProps) => (
      <ApolloReactComponents.Query<GetSubscriptionQuery, GetSubscriptionQueryVariables> query={GetSubscriptionDocument} {...props} />
    );
    

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables> & ({ variables: GetSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export function useGetSubscriptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionSuspenseQuery>;
export type GetSubscriptionQueryResult = ApolloReactCommon.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const MarkUserVisitedPreferencesPageDocument = gql`
    mutation markUserVisitedPreferencesPage {
  markUserVisitedPreferencesPage {
    id
  }
}
    `;
export type MarkUserVisitedPreferencesPageMutationFn = ApolloReactCommon.MutationFunction<MarkUserVisitedPreferencesPageMutation, MarkUserVisitedPreferencesPageMutationVariables>;
export type MarkUserVisitedPreferencesPageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MarkUserVisitedPreferencesPageMutation, MarkUserVisitedPreferencesPageMutationVariables>, 'mutation'>;

    export const MarkUserVisitedPreferencesPageComponent = (props: MarkUserVisitedPreferencesPageComponentProps) => (
      <ApolloReactComponents.Mutation<MarkUserVisitedPreferencesPageMutation, MarkUserVisitedPreferencesPageMutationVariables> mutation={MarkUserVisitedPreferencesPageDocument} {...props} />
    );
    

/**
 * __useMarkUserVisitedPreferencesPageMutation__
 *
 * To run a mutation, you first call `useMarkUserVisitedPreferencesPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUserVisitedPreferencesPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUserVisitedPreferencesPageMutation, { data, loading, error }] = useMarkUserVisitedPreferencesPageMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkUserVisitedPreferencesPageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkUserVisitedPreferencesPageMutation, MarkUserVisitedPreferencesPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkUserVisitedPreferencesPageMutation, MarkUserVisitedPreferencesPageMutationVariables>(MarkUserVisitedPreferencesPageDocument, options);
      }
export type MarkUserVisitedPreferencesPageMutationHookResult = ReturnType<typeof useMarkUserVisitedPreferencesPageMutation>;
export type MarkUserVisitedPreferencesPageMutationResult = ApolloReactCommon.MutationResult<MarkUserVisitedPreferencesPageMutation>;
export type MarkUserVisitedPreferencesPageMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkUserVisitedPreferencesPageMutation, MarkUserVisitedPreferencesPageMutationVariables>;
export const UpdateTasteProfileDocument = gql`
    mutation updateTasteProfile($input: TasteProfileMutationInput!) {
  updateTasteProfile(input: $input) {
    tasteProfile {
      dietType
      replacementDietaryRestrictions
      menuDietaryRestrictions
      preferredProteins
      cuisinePreferences
    }
  }
}
    `;
export type UpdateTasteProfileMutationFn = ApolloReactCommon.MutationFunction<UpdateTasteProfileMutation, UpdateTasteProfileMutationVariables>;
export type UpdateTasteProfileComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateTasteProfileMutation, UpdateTasteProfileMutationVariables>, 'mutation'>;

    export const UpdateTasteProfileComponent = (props: UpdateTasteProfileComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateTasteProfileMutation, UpdateTasteProfileMutationVariables> mutation={UpdateTasteProfileDocument} {...props} />
    );
    

/**
 * __useUpdateTasteProfileMutation__
 *
 * To run a mutation, you first call `useUpdateTasteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTasteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTasteProfileMutation, { data, loading, error }] = useUpdateTasteProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTasteProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTasteProfileMutation, UpdateTasteProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTasteProfileMutation, UpdateTasteProfileMutationVariables>(UpdateTasteProfileDocument, options);
      }
export type UpdateTasteProfileMutationHookResult = ReturnType<typeof useUpdateTasteProfileMutation>;
export type UpdateTasteProfileMutationResult = ApolloReactCommon.MutationResult<UpdateTasteProfileMutation>;
export type UpdateTasteProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTasteProfileMutation, UpdateTasteProfileMutationVariables>;
export const GetTasteProfileDocument = gql`
    query getTasteProfile($input: GetTasteProfileInput!) {
  getTasteProfile(input: $input) {
    tasteProfile {
      id
      dietType
      replacementDietaryRestrictions
      menuDietaryRestrictions
      preferredProteins
      cuisinePreferences
    }
  }
}
    `;
export type GetTasteProfileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTasteProfileQuery, GetTasteProfileQueryVariables>, 'query'> & ({ variables: GetTasteProfileQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetTasteProfileComponent = (props: GetTasteProfileComponentProps) => (
      <ApolloReactComponents.Query<GetTasteProfileQuery, GetTasteProfileQueryVariables> query={GetTasteProfileDocument} {...props} />
    );
    

/**
 * __useGetTasteProfileQuery__
 *
 * To run a query within a React component, call `useGetTasteProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasteProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasteProfileQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTasteProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTasteProfileQuery, GetTasteProfileQueryVariables> & ({ variables: GetTasteProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTasteProfileQuery, GetTasteProfileQueryVariables>(GetTasteProfileDocument, options);
      }
export function useGetTasteProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTasteProfileQuery, GetTasteProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTasteProfileQuery, GetTasteProfileQueryVariables>(GetTasteProfileDocument, options);
        }
export function useGetTasteProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTasteProfileQuery, GetTasteProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTasteProfileQuery, GetTasteProfileQueryVariables>(GetTasteProfileDocument, options);
        }
export type GetTasteProfileQueryHookResult = ReturnType<typeof useGetTasteProfileQuery>;
export type GetTasteProfileLazyQueryHookResult = ReturnType<typeof useGetTasteProfileLazyQuery>;
export type GetTasteProfileSuspenseQueryHookResult = ReturnType<typeof useGetTasteProfileSuspenseQuery>;
export type GetTasteProfileQueryResult = ApolloReactCommon.QueryResult<GetTasteProfileQuery, GetTasteProfileQueryVariables>;
export const GetMealEditDataDocument = gql`
    query GetMealEditData($userId: String!) {
  getTasteProfile(input: {userId: $userId}) {
    tasteProfile {
      id
      cuisinePreferences
      menuDietaryRestrictions
      dietType
      preferredProteins
    }
  }
  getMealPlanUpcomingOrder(userId: $userId) {
    mealPlanUpcomingOrder {
      promoCodeApplied {
        ...MealPlanPromoCodeApplied
      }
      sidesPerWeek
      mealPlanOrderStatus
      mealPlanGroupOrderId
      mealPlanGroupOrder {
        ...UpcomingMealPlanGroupOrder
      }
      mainDishes {
        id
      }
      sideDishes {
        id
      }
    }
  }
}
    ${MealPlanPromoCodeAppliedFragmentDoc}
${UpcomingMealPlanGroupOrderFragmentDoc}`;
export type GetMealEditDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMealEditDataQuery, GetMealEditDataQueryVariables>, 'query'> & ({ variables: GetMealEditDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMealEditDataComponent = (props: GetMealEditDataComponentProps) => (
      <ApolloReactComponents.Query<GetMealEditDataQuery, GetMealEditDataQueryVariables> query={GetMealEditDataDocument} {...props} />
    );
    

/**
 * __useGetMealEditDataQuery__
 *
 * To run a query within a React component, call `useGetMealEditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMealEditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMealEditDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMealEditDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMealEditDataQuery, GetMealEditDataQueryVariables> & ({ variables: GetMealEditDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMealEditDataQuery, GetMealEditDataQueryVariables>(GetMealEditDataDocument, options);
      }
export function useGetMealEditDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMealEditDataQuery, GetMealEditDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMealEditDataQuery, GetMealEditDataQueryVariables>(GetMealEditDataDocument, options);
        }
export function useGetMealEditDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMealEditDataQuery, GetMealEditDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMealEditDataQuery, GetMealEditDataQueryVariables>(GetMealEditDataDocument, options);
        }
export type GetMealEditDataQueryHookResult = ReturnType<typeof useGetMealEditDataQuery>;
export type GetMealEditDataLazyQueryHookResult = ReturnType<typeof useGetMealEditDataLazyQuery>;
export type GetMealEditDataSuspenseQueryHookResult = ReturnType<typeof useGetMealEditDataSuspenseQuery>;
export type GetMealEditDataQueryResult = ApolloReactCommon.QueryResult<GetMealEditDataQuery, GetMealEditDataQueryVariables>;
export const GetShefCountForRegionDocument = gql`
    query GetShefCountForRegion($regionId: Int!, $mealPlanType: String!) {
  countMealPlanShefsForRegionId(regionId: $regionId, mealPlanType: $mealPlanType) {
    shefCount
  }
}
    `;
export type GetShefCountForRegionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShefCountForRegionQuery, GetShefCountForRegionQueryVariables>, 'query'> & ({ variables: GetShefCountForRegionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetShefCountForRegionComponent = (props: GetShefCountForRegionComponentProps) => (
      <ApolloReactComponents.Query<GetShefCountForRegionQuery, GetShefCountForRegionQueryVariables> query={GetShefCountForRegionDocument} {...props} />
    );
    

/**
 * __useGetShefCountForRegionQuery__
 *
 * To run a query within a React component, call `useGetShefCountForRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShefCountForRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShefCountForRegionQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      mealPlanType: // value for 'mealPlanType'
 *   },
 * });
 */
export function useGetShefCountForRegionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetShefCountForRegionQuery, GetShefCountForRegionQueryVariables> & ({ variables: GetShefCountForRegionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetShefCountForRegionQuery, GetShefCountForRegionQueryVariables>(GetShefCountForRegionDocument, options);
      }
export function useGetShefCountForRegionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShefCountForRegionQuery, GetShefCountForRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetShefCountForRegionQuery, GetShefCountForRegionQueryVariables>(GetShefCountForRegionDocument, options);
        }
export function useGetShefCountForRegionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetShefCountForRegionQuery, GetShefCountForRegionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetShefCountForRegionQuery, GetShefCountForRegionQueryVariables>(GetShefCountForRegionDocument, options);
        }
export type GetShefCountForRegionQueryHookResult = ReturnType<typeof useGetShefCountForRegionQuery>;
export type GetShefCountForRegionLazyQueryHookResult = ReturnType<typeof useGetShefCountForRegionLazyQuery>;
export type GetShefCountForRegionSuspenseQueryHookResult = ReturnType<typeof useGetShefCountForRegionSuspenseQuery>;
export type GetShefCountForRegionQueryResult = ApolloReactCommon.QueryResult<GetShefCountForRegionQuery, GetShefCountForRegionQueryVariables>;
export const SkipMealPlanGroupOrderDocument = gql`
    mutation SkipMealPlanGroupOrder($deliveryDate: String!, $groupOrderId: String) {
  skipMealPlanGroupOrder(
    input: {deliveryDate: $deliveryDate, groupOrderId: $groupOrderId}
  ) {
    groupOrderId
    success
    message
  }
}
    `;
export type SkipMealPlanGroupOrderMutationFn = ApolloReactCommon.MutationFunction<SkipMealPlanGroupOrderMutation, SkipMealPlanGroupOrderMutationVariables>;
export type SkipMealPlanGroupOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SkipMealPlanGroupOrderMutation, SkipMealPlanGroupOrderMutationVariables>, 'mutation'>;

    export const SkipMealPlanGroupOrderComponent = (props: SkipMealPlanGroupOrderComponentProps) => (
      <ApolloReactComponents.Mutation<SkipMealPlanGroupOrderMutation, SkipMealPlanGroupOrderMutationVariables> mutation={SkipMealPlanGroupOrderDocument} {...props} />
    );
    

/**
 * __useSkipMealPlanGroupOrderMutation__
 *
 * To run a mutation, you first call `useSkipMealPlanGroupOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipMealPlanGroupOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipMealPlanGroupOrderMutation, { data, loading, error }] = useSkipMealPlanGroupOrderMutation({
 *   variables: {
 *      deliveryDate: // value for 'deliveryDate'
 *      groupOrderId: // value for 'groupOrderId'
 *   },
 * });
 */
export function useSkipMealPlanGroupOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SkipMealPlanGroupOrderMutation, SkipMealPlanGroupOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SkipMealPlanGroupOrderMutation, SkipMealPlanGroupOrderMutationVariables>(SkipMealPlanGroupOrderDocument, options);
      }
export type SkipMealPlanGroupOrderMutationHookResult = ReturnType<typeof useSkipMealPlanGroupOrderMutation>;
export type SkipMealPlanGroupOrderMutationResult = ApolloReactCommon.MutationResult<SkipMealPlanGroupOrderMutation>;
export type SkipMealPlanGroupOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<SkipMealPlanGroupOrderMutation, SkipMealPlanGroupOrderMutationVariables>;
export const UnskipMealPlanGroupOrderDocument = gql`
    mutation UnskipMealPlanGroupOrder($groupOrderId: String!) {
  unskipMealPlanGroupOrder(input: {groupOrderId: $groupOrderId}) {
    success
    message
  }
}
    `;
export type UnskipMealPlanGroupOrderMutationFn = ApolloReactCommon.MutationFunction<UnskipMealPlanGroupOrderMutation, UnskipMealPlanGroupOrderMutationVariables>;
export type UnskipMealPlanGroupOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnskipMealPlanGroupOrderMutation, UnskipMealPlanGroupOrderMutationVariables>, 'mutation'>;

    export const UnskipMealPlanGroupOrderComponent = (props: UnskipMealPlanGroupOrderComponentProps) => (
      <ApolloReactComponents.Mutation<UnskipMealPlanGroupOrderMutation, UnskipMealPlanGroupOrderMutationVariables> mutation={UnskipMealPlanGroupOrderDocument} {...props} />
    );
    

/**
 * __useUnskipMealPlanGroupOrderMutation__
 *
 * To run a mutation, you first call `useUnskipMealPlanGroupOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnskipMealPlanGroupOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unskipMealPlanGroupOrderMutation, { data, loading, error }] = useUnskipMealPlanGroupOrderMutation({
 *   variables: {
 *      groupOrderId: // value for 'groupOrderId'
 *   },
 * });
 */
export function useUnskipMealPlanGroupOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnskipMealPlanGroupOrderMutation, UnskipMealPlanGroupOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnskipMealPlanGroupOrderMutation, UnskipMealPlanGroupOrderMutationVariables>(UnskipMealPlanGroupOrderDocument, options);
      }
export type UnskipMealPlanGroupOrderMutationHookResult = ReturnType<typeof useUnskipMealPlanGroupOrderMutation>;
export type UnskipMealPlanGroupOrderMutationResult = ApolloReactCommon.MutationResult<UnskipMealPlanGroupOrderMutation>;
export type UnskipMealPlanGroupOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<UnskipMealPlanGroupOrderMutation, UnskipMealPlanGroupOrderMutationVariables>;
export const ConsumerModifyMealPlanDocument = gql`
    mutation ConsumerModifyMealPlan($input: ModifyMealPlanInput!) {
  modifyMealPlan(input: $input) {
    success
    message
  }
}
    `;
export type ConsumerModifyMealPlanMutationFn = ApolloReactCommon.MutationFunction<ConsumerModifyMealPlanMutation, ConsumerModifyMealPlanMutationVariables>;
export type ConsumerModifyMealPlanComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConsumerModifyMealPlanMutation, ConsumerModifyMealPlanMutationVariables>, 'mutation'>;

    export const ConsumerModifyMealPlanComponent = (props: ConsumerModifyMealPlanComponentProps) => (
      <ApolloReactComponents.Mutation<ConsumerModifyMealPlanMutation, ConsumerModifyMealPlanMutationVariables> mutation={ConsumerModifyMealPlanDocument} {...props} />
    );
    

/**
 * __useConsumerModifyMealPlanMutation__
 *
 * To run a mutation, you first call `useConsumerModifyMealPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerModifyMealPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerModifyMealPlanMutation, { data, loading, error }] = useConsumerModifyMealPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerModifyMealPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConsumerModifyMealPlanMutation, ConsumerModifyMealPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConsumerModifyMealPlanMutation, ConsumerModifyMealPlanMutationVariables>(ConsumerModifyMealPlanDocument, options);
      }
export type ConsumerModifyMealPlanMutationHookResult = ReturnType<typeof useConsumerModifyMealPlanMutation>;
export type ConsumerModifyMealPlanMutationResult = ApolloReactCommon.MutationResult<ConsumerModifyMealPlanMutation>;
export type ConsumerModifyMealPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumerModifyMealPlanMutation, ConsumerModifyMealPlanMutationVariables>;
export const GetManageMealPlanPageDocument = gql`
    query GetManageMealPlanPage {
  getActiveMealPlanForUser {
    id
    mondayDelivery
    tuesdayDelivery
    wednesdayDelivery
    thursdayDelivery
    fridayDelivery
    saturdayDelivery
    sundayDelivery
  }
}
    `;
export type GetManageMealPlanPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetManageMealPlanPageQuery, GetManageMealPlanPageQueryVariables>, 'query'>;

    export const GetManageMealPlanPageComponent = (props: GetManageMealPlanPageComponentProps) => (
      <ApolloReactComponents.Query<GetManageMealPlanPageQuery, GetManageMealPlanPageQueryVariables> query={GetManageMealPlanPageDocument} {...props} />
    );
    

/**
 * __useGetManageMealPlanPageQuery__
 *
 * To run a query within a React component, call `useGetManageMealPlanPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageMealPlanPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageMealPlanPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManageMealPlanPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetManageMealPlanPageQuery, GetManageMealPlanPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetManageMealPlanPageQuery, GetManageMealPlanPageQueryVariables>(GetManageMealPlanPageDocument, options);
      }
export function useGetManageMealPlanPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetManageMealPlanPageQuery, GetManageMealPlanPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetManageMealPlanPageQuery, GetManageMealPlanPageQueryVariables>(GetManageMealPlanPageDocument, options);
        }
export function useGetManageMealPlanPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetManageMealPlanPageQuery, GetManageMealPlanPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetManageMealPlanPageQuery, GetManageMealPlanPageQueryVariables>(GetManageMealPlanPageDocument, options);
        }
export type GetManageMealPlanPageQueryHookResult = ReturnType<typeof useGetManageMealPlanPageQuery>;
export type GetManageMealPlanPageLazyQueryHookResult = ReturnType<typeof useGetManageMealPlanPageLazyQuery>;
export type GetManageMealPlanPageSuspenseQueryHookResult = ReturnType<typeof useGetManageMealPlanPageSuspenseQuery>;
export type GetManageMealPlanPageQueryResult = ApolloReactCommon.QueryResult<GetManageMealPlanPageQuery, GetManageMealPlanPageQueryVariables>;
export const ModifyMealPlanPageDocument = gql`
    query ModifyMealPlanPage($userId: String!) {
  getMealPlanUpcomingOrder(userId: $userId) {
    mealPlanUpcomingOrder {
      nextDeliveryDate
      mealPlanOrderStatus
      promoCodeApplied {
        ...MealPlanPromoCodeApplied
      }
      sidesPerWeek
    }
  }
}
    ${MealPlanPromoCodeAppliedFragmentDoc}`;
export type ModifyMealPlanPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ModifyMealPlanPageQuery, ModifyMealPlanPageQueryVariables>, 'query'> & ({ variables: ModifyMealPlanPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ModifyMealPlanPageComponent = (props: ModifyMealPlanPageComponentProps) => (
      <ApolloReactComponents.Query<ModifyMealPlanPageQuery, ModifyMealPlanPageQueryVariables> query={ModifyMealPlanPageDocument} {...props} />
    );
    

/**
 * __useModifyMealPlanPageQuery__
 *
 * To run a query within a React component, call `useModifyMealPlanPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useModifyMealPlanPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModifyMealPlanPageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useModifyMealPlanPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModifyMealPlanPageQuery, ModifyMealPlanPageQueryVariables> & ({ variables: ModifyMealPlanPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModifyMealPlanPageQuery, ModifyMealPlanPageQueryVariables>(ModifyMealPlanPageDocument, options);
      }
export function useModifyMealPlanPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModifyMealPlanPageQuery, ModifyMealPlanPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModifyMealPlanPageQuery, ModifyMealPlanPageQueryVariables>(ModifyMealPlanPageDocument, options);
        }
export function useModifyMealPlanPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModifyMealPlanPageQuery, ModifyMealPlanPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModifyMealPlanPageQuery, ModifyMealPlanPageQueryVariables>(ModifyMealPlanPageDocument, options);
        }
export type ModifyMealPlanPageQueryHookResult = ReturnType<typeof useModifyMealPlanPageQuery>;
export type ModifyMealPlanPageLazyQueryHookResult = ReturnType<typeof useModifyMealPlanPageLazyQuery>;
export type ModifyMealPlanPageSuspenseQueryHookResult = ReturnType<typeof useModifyMealPlanPageSuspenseQuery>;
export type ModifyMealPlanPageQueryResult = ApolloReactCommon.QueryResult<ModifyMealPlanPageQuery, ModifyMealPlanPageQueryVariables>;
export const GetManagePlanDeliveryScheduleDocument = gql`
    query GetManagePlanDeliverySchedule($zipCode: String!, $filters: ExploreFoodItemsFilterInput!, $deliveryDate: String!, $query: String, $shefId: String) {
  upcomingOrders {
    timeWindow {
      id
      startMsAfterMidnight
      endMsAfterMidnight
    }
  }
  exploreFoodItemsFilterOptions(
    zipCode: $zipCode
    filters: $filters
    query: $query
    shefId: $shefId
  ) {
    ...DishFirstFilterOptions
  }
  zipCode(zipCode: $zipCode) {
    zipCode
    timeWindows(deliveryDate: $deliveryDate) {
      ...TimeWindowSelectorTimeWindow
    }
  }
  getUpcomingMealPlanGroupOrders(userId: "") {
    groupOrders {
      deliveryDate
    }
  }
  getActiveMealPlanForUser {
    id
    mondayDelivery
    tuesdayDelivery
    wednesdayDelivery
    thursdayDelivery
    fridayDelivery
    saturdayDelivery
    sundayDelivery
  }
}
    ${DishFirstFilterOptionsFragmentDoc}
${TimeWindowSelectorTimeWindowFragmentDoc}`;
export type GetManagePlanDeliveryScheduleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetManagePlanDeliveryScheduleQuery, GetManagePlanDeliveryScheduleQueryVariables>, 'query'> & ({ variables: GetManagePlanDeliveryScheduleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetManagePlanDeliveryScheduleComponent = (props: GetManagePlanDeliveryScheduleComponentProps) => (
      <ApolloReactComponents.Query<GetManagePlanDeliveryScheduleQuery, GetManagePlanDeliveryScheduleQueryVariables> query={GetManagePlanDeliveryScheduleDocument} {...props} />
    );
    

/**
 * __useGetManagePlanDeliveryScheduleQuery__
 *
 * To run a query within a React component, call `useGetManagePlanDeliveryScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagePlanDeliveryScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagePlanDeliveryScheduleQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      filters: // value for 'filters'
 *      deliveryDate: // value for 'deliveryDate'
 *      query: // value for 'query'
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useGetManagePlanDeliveryScheduleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetManagePlanDeliveryScheduleQuery, GetManagePlanDeliveryScheduleQueryVariables> & ({ variables: GetManagePlanDeliveryScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetManagePlanDeliveryScheduleQuery, GetManagePlanDeliveryScheduleQueryVariables>(GetManagePlanDeliveryScheduleDocument, options);
      }
export function useGetManagePlanDeliveryScheduleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetManagePlanDeliveryScheduleQuery, GetManagePlanDeliveryScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetManagePlanDeliveryScheduleQuery, GetManagePlanDeliveryScheduleQueryVariables>(GetManagePlanDeliveryScheduleDocument, options);
        }
export function useGetManagePlanDeliveryScheduleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetManagePlanDeliveryScheduleQuery, GetManagePlanDeliveryScheduleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetManagePlanDeliveryScheduleQuery, GetManagePlanDeliveryScheduleQueryVariables>(GetManagePlanDeliveryScheduleDocument, options);
        }
export type GetManagePlanDeliveryScheduleQueryHookResult = ReturnType<typeof useGetManagePlanDeliveryScheduleQuery>;
export type GetManagePlanDeliveryScheduleLazyQueryHookResult = ReturnType<typeof useGetManagePlanDeliveryScheduleLazyQuery>;
export type GetManagePlanDeliveryScheduleSuspenseQueryHookResult = ReturnType<typeof useGetManagePlanDeliveryScheduleSuspenseQuery>;
export type GetManagePlanDeliveryScheduleQueryResult = ApolloReactCommon.QueryResult<GetManagePlanDeliveryScheduleQuery, GetManagePlanDeliveryScheduleQueryVariables>;
export const GetManagePlanServingsPageDocument = gql`
    query GetManagePlanServingsPage($userId: String!) {
  getMealPlanUpcomingOrder(userId: $userId) {
    mealPlanUpcomingOrder {
      nextDeliveryDate
      mealPlanOrderStatus
      promoCodeApplied {
        ...MealPlanPromoCodeApplied
      }
      sidesPerWeek
    }
  }
  getMealPlanTypeOptions {
    mealPlanType {
      id
      displayName
      unit
      weeklyCost
      pricePerUnit
      numServings
      format
      regionId
    }
  }
  getActiveMealPlanForUser {
    id
    status
    mealPlanType {
      displayName
      id
      pricePerUnit
      unit
      numServings
      weeklyCost
      format
    }
  }
  getTasteProfile(input: {userId: $userId}) {
    tasteProfile {
      id
      dietType
      replacementDietaryRestrictions
      menuDietaryRestrictions
      preferredProteins
      cuisinePreferences
      numAdults
      numLittleEaters
      numBigEaters
    }
  }
  getUpcomingMealPlanGroupOrders(userId: $userId) {
    groupOrders {
      deliveryDate
      mealPlanType {
        unit
        numServings
        weeklyCost
        format
      }
    }
  }
}
    ${MealPlanPromoCodeAppliedFragmentDoc}`;
export type GetManagePlanServingsPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetManagePlanServingsPageQuery, GetManagePlanServingsPageQueryVariables>, 'query'> & ({ variables: GetManagePlanServingsPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetManagePlanServingsPageComponent = (props: GetManagePlanServingsPageComponentProps) => (
      <ApolloReactComponents.Query<GetManagePlanServingsPageQuery, GetManagePlanServingsPageQueryVariables> query={GetManagePlanServingsPageDocument} {...props} />
    );
    

/**
 * __useGetManagePlanServingsPageQuery__
 *
 * To run a query within a React component, call `useGetManagePlanServingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagePlanServingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagePlanServingsPageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetManagePlanServingsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetManagePlanServingsPageQuery, GetManagePlanServingsPageQueryVariables> & ({ variables: GetManagePlanServingsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetManagePlanServingsPageQuery, GetManagePlanServingsPageQueryVariables>(GetManagePlanServingsPageDocument, options);
      }
export function useGetManagePlanServingsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetManagePlanServingsPageQuery, GetManagePlanServingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetManagePlanServingsPageQuery, GetManagePlanServingsPageQueryVariables>(GetManagePlanServingsPageDocument, options);
        }
export function useGetManagePlanServingsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetManagePlanServingsPageQuery, GetManagePlanServingsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetManagePlanServingsPageQuery, GetManagePlanServingsPageQueryVariables>(GetManagePlanServingsPageDocument, options);
        }
export type GetManagePlanServingsPageQueryHookResult = ReturnType<typeof useGetManagePlanServingsPageQuery>;
export type GetManagePlanServingsPageLazyQueryHookResult = ReturnType<typeof useGetManagePlanServingsPageLazyQuery>;
export type GetManagePlanServingsPageSuspenseQueryHookResult = ReturnType<typeof useGetManagePlanServingsPageSuspenseQuery>;
export type GetManagePlanServingsPageQueryResult = ApolloReactCommon.QueryResult<GetManagePlanServingsPageQuery, GetManagePlanServingsPageQueryVariables>;
export const GetDeliveryWindowsForZipCodeAndDateDocument = gql`
    query GetDeliveryWindowsForZipCodeAndDate($zipCode: String!, $deliveryDate: String!) {
  zipCode(zipCode: $zipCode) {
    zipCode
    timeWindows(deliveryDate: $deliveryDate) {
      ...TimeWindowSelectorTimeWindow
    }
  }
}
    ${TimeWindowSelectorTimeWindowFragmentDoc}`;
export type GetDeliveryWindowsForZipCodeAndDateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDeliveryWindowsForZipCodeAndDateQuery, GetDeliveryWindowsForZipCodeAndDateQueryVariables>, 'query'> & ({ variables: GetDeliveryWindowsForZipCodeAndDateQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDeliveryWindowsForZipCodeAndDateComponent = (props: GetDeliveryWindowsForZipCodeAndDateComponentProps) => (
      <ApolloReactComponents.Query<GetDeliveryWindowsForZipCodeAndDateQuery, GetDeliveryWindowsForZipCodeAndDateQueryVariables> query={GetDeliveryWindowsForZipCodeAndDateDocument} {...props} />
    );
    

/**
 * __useGetDeliveryWindowsForZipCodeAndDateQuery__
 *
 * To run a query within a React component, call `useGetDeliveryWindowsForZipCodeAndDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryWindowsForZipCodeAndDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryWindowsForZipCodeAndDateQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useGetDeliveryWindowsForZipCodeAndDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDeliveryWindowsForZipCodeAndDateQuery, GetDeliveryWindowsForZipCodeAndDateQueryVariables> & ({ variables: GetDeliveryWindowsForZipCodeAndDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDeliveryWindowsForZipCodeAndDateQuery, GetDeliveryWindowsForZipCodeAndDateQueryVariables>(GetDeliveryWindowsForZipCodeAndDateDocument, options);
      }
export function useGetDeliveryWindowsForZipCodeAndDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDeliveryWindowsForZipCodeAndDateQuery, GetDeliveryWindowsForZipCodeAndDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDeliveryWindowsForZipCodeAndDateQuery, GetDeliveryWindowsForZipCodeAndDateQueryVariables>(GetDeliveryWindowsForZipCodeAndDateDocument, options);
        }
export function useGetDeliveryWindowsForZipCodeAndDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDeliveryWindowsForZipCodeAndDateQuery, GetDeliveryWindowsForZipCodeAndDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDeliveryWindowsForZipCodeAndDateQuery, GetDeliveryWindowsForZipCodeAndDateQueryVariables>(GetDeliveryWindowsForZipCodeAndDateDocument, options);
        }
export type GetDeliveryWindowsForZipCodeAndDateQueryHookResult = ReturnType<typeof useGetDeliveryWindowsForZipCodeAndDateQuery>;
export type GetDeliveryWindowsForZipCodeAndDateLazyQueryHookResult = ReturnType<typeof useGetDeliveryWindowsForZipCodeAndDateLazyQuery>;
export type GetDeliveryWindowsForZipCodeAndDateSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryWindowsForZipCodeAndDateSuspenseQuery>;
export type GetDeliveryWindowsForZipCodeAndDateQueryResult = ApolloReactCommon.QueryResult<GetDeliveryWindowsForZipCodeAndDateQuery, GetDeliveryWindowsForZipCodeAndDateQueryVariables>;
export const AddTasteProfileDocument = gql`
    mutation addTasteProfile($input: TasteProfileMutationInput!) {
  addTasteProfile(input: $input) {
    message
    success
  }
}
    `;
export type AddTasteProfileMutationFn = ApolloReactCommon.MutationFunction<AddTasteProfileMutation, AddTasteProfileMutationVariables>;
export type AddTasteProfileComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddTasteProfileMutation, AddTasteProfileMutationVariables>, 'mutation'>;

    export const AddTasteProfileComponent = (props: AddTasteProfileComponentProps) => (
      <ApolloReactComponents.Mutation<AddTasteProfileMutation, AddTasteProfileMutationVariables> mutation={AddTasteProfileDocument} {...props} />
    );
    

/**
 * __useAddTasteProfileMutation__
 *
 * To run a mutation, you first call `useAddTasteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTasteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTasteProfileMutation, { data, loading, error }] = useAddTasteProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTasteProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTasteProfileMutation, AddTasteProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTasteProfileMutation, AddTasteProfileMutationVariables>(AddTasteProfileDocument, options);
      }
export type AddTasteProfileMutationHookResult = ReturnType<typeof useAddTasteProfileMutation>;
export type AddTasteProfileMutationResult = ApolloReactCommon.MutationResult<AddTasteProfileMutation>;
export type AddTasteProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<AddTasteProfileMutation, AddTasteProfileMutationVariables>;
export const GetMealPlanTypeOptionsDocument = gql`
    query getMealPlanTypeOptions($adults: Int, $littleEaters: Int, $format: String) {
  getMealPlanTypeOptions(
    adults: $adults
    littleEaters: $littleEaters
    format: $format
  ) {
    mealPlanType {
      unit
      pricePerUnit
      weeklyCost
      numServings
      id
      displayName
      format
      regionId
    }
    title
    subtitle
    isRecommended
    isDisabled
  }
}
    `;
export type GetMealPlanTypeOptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMealPlanTypeOptionsQuery, GetMealPlanTypeOptionsQueryVariables>, 'query'>;

    export const GetMealPlanTypeOptionsComponent = (props: GetMealPlanTypeOptionsComponentProps) => (
      <ApolloReactComponents.Query<GetMealPlanTypeOptionsQuery, GetMealPlanTypeOptionsQueryVariables> query={GetMealPlanTypeOptionsDocument} {...props} />
    );
    

/**
 * __useGetMealPlanTypeOptionsQuery__
 *
 * To run a query within a React component, call `useGetMealPlanTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMealPlanTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMealPlanTypeOptionsQuery({
 *   variables: {
 *      adults: // value for 'adults'
 *      littleEaters: // value for 'littleEaters'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useGetMealPlanTypeOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMealPlanTypeOptionsQuery, GetMealPlanTypeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMealPlanTypeOptionsQuery, GetMealPlanTypeOptionsQueryVariables>(GetMealPlanTypeOptionsDocument, options);
      }
export function useGetMealPlanTypeOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMealPlanTypeOptionsQuery, GetMealPlanTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMealPlanTypeOptionsQuery, GetMealPlanTypeOptionsQueryVariables>(GetMealPlanTypeOptionsDocument, options);
        }
export function useGetMealPlanTypeOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMealPlanTypeOptionsQuery, GetMealPlanTypeOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMealPlanTypeOptionsQuery, GetMealPlanTypeOptionsQueryVariables>(GetMealPlanTypeOptionsDocument, options);
        }
export type GetMealPlanTypeOptionsQueryHookResult = ReturnType<typeof useGetMealPlanTypeOptionsQuery>;
export type GetMealPlanTypeOptionsLazyQueryHookResult = ReturnType<typeof useGetMealPlanTypeOptionsLazyQuery>;
export type GetMealPlanTypeOptionsSuspenseQueryHookResult = ReturnType<typeof useGetMealPlanTypeOptionsSuspenseQuery>;
export type GetMealPlanTypeOptionsQueryResult = ApolloReactCommon.QueryResult<GetMealPlanTypeOptionsQuery, GetMealPlanTypeOptionsQueryVariables>;
export const GetMealPlanUpcomingOrderDocument = gql`
    query GetMealPlanUpcomingOrder($userId: String!) {
  getMealPlanDeliveries(input: {userId: $userId}) {
    deliveryDates
    orders {
      ...MealPlanOrder
    }
    message
    success
  }
  getMealPlanUpcomingOrder(userId: $userId) {
    mealPlanUpcomingOrder {
      mealPlan {
        ...MealPlanUpcomingOrderMealPlan
      }
      mealPlanGroupOrder {
        ...UpcomingMealPlanGroupOrder
      }
      mealPlanOrderStatus
      nextDeliveryDate
      sidesPerWeek
    }
    message
    success
  }
}
    ${MealPlanOrderFragmentDoc}
${MealPlanUpcomingOrderMealPlanFragmentDoc}
${UpcomingMealPlanGroupOrderFragmentDoc}`;
export type GetMealPlanUpcomingOrderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMealPlanUpcomingOrderQuery, GetMealPlanUpcomingOrderQueryVariables>, 'query'> & ({ variables: GetMealPlanUpcomingOrderQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMealPlanUpcomingOrderComponent = (props: GetMealPlanUpcomingOrderComponentProps) => (
      <ApolloReactComponents.Query<GetMealPlanUpcomingOrderQuery, GetMealPlanUpcomingOrderQueryVariables> query={GetMealPlanUpcomingOrderDocument} {...props} />
    );
    

/**
 * __useGetMealPlanUpcomingOrderQuery__
 *
 * To run a query within a React component, call `useGetMealPlanUpcomingOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMealPlanUpcomingOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMealPlanUpcomingOrderQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMealPlanUpcomingOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMealPlanUpcomingOrderQuery, GetMealPlanUpcomingOrderQueryVariables> & ({ variables: GetMealPlanUpcomingOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMealPlanUpcomingOrderQuery, GetMealPlanUpcomingOrderQueryVariables>(GetMealPlanUpcomingOrderDocument, options);
      }
export function useGetMealPlanUpcomingOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMealPlanUpcomingOrderQuery, GetMealPlanUpcomingOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMealPlanUpcomingOrderQuery, GetMealPlanUpcomingOrderQueryVariables>(GetMealPlanUpcomingOrderDocument, options);
        }
export function useGetMealPlanUpcomingOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMealPlanUpcomingOrderQuery, GetMealPlanUpcomingOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMealPlanUpcomingOrderQuery, GetMealPlanUpcomingOrderQueryVariables>(GetMealPlanUpcomingOrderDocument, options);
        }
export type GetMealPlanUpcomingOrderQueryHookResult = ReturnType<typeof useGetMealPlanUpcomingOrderQuery>;
export type GetMealPlanUpcomingOrderLazyQueryHookResult = ReturnType<typeof useGetMealPlanUpcomingOrderLazyQuery>;
export type GetMealPlanUpcomingOrderSuspenseQueryHookResult = ReturnType<typeof useGetMealPlanUpcomingOrderSuspenseQuery>;
export type GetMealPlanUpcomingOrderQueryResult = ApolloReactCommon.QueryResult<GetMealPlanUpcomingOrderQuery, GetMealPlanUpcomingOrderQueryVariables>;
export const GetUpcomingMealPlanGroupOrdersDocument = gql`
    query GetUpcomingMealPlanGroupOrders($userId: String!) {
  getUpcomingMealPlanGroupOrders(userId: $userId) {
    groupOrders {
      ...UpcomingMealPlanGroupOrder
    }
    message
    success
  }
}
    ${UpcomingMealPlanGroupOrderFragmentDoc}`;
export type GetUpcomingMealPlanGroupOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUpcomingMealPlanGroupOrdersQuery, GetUpcomingMealPlanGroupOrdersQueryVariables>, 'query'> & ({ variables: GetUpcomingMealPlanGroupOrdersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUpcomingMealPlanGroupOrdersComponent = (props: GetUpcomingMealPlanGroupOrdersComponentProps) => (
      <ApolloReactComponents.Query<GetUpcomingMealPlanGroupOrdersQuery, GetUpcomingMealPlanGroupOrdersQueryVariables> query={GetUpcomingMealPlanGroupOrdersDocument} {...props} />
    );
    

/**
 * __useGetUpcomingMealPlanGroupOrdersQuery__
 *
 * To run a query within a React component, call `useGetUpcomingMealPlanGroupOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingMealPlanGroupOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingMealPlanGroupOrdersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUpcomingMealPlanGroupOrdersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUpcomingMealPlanGroupOrdersQuery, GetUpcomingMealPlanGroupOrdersQueryVariables> & ({ variables: GetUpcomingMealPlanGroupOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUpcomingMealPlanGroupOrdersQuery, GetUpcomingMealPlanGroupOrdersQueryVariables>(GetUpcomingMealPlanGroupOrdersDocument, options);
      }
export function useGetUpcomingMealPlanGroupOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUpcomingMealPlanGroupOrdersQuery, GetUpcomingMealPlanGroupOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUpcomingMealPlanGroupOrdersQuery, GetUpcomingMealPlanGroupOrdersQueryVariables>(GetUpcomingMealPlanGroupOrdersDocument, options);
        }
export function useGetUpcomingMealPlanGroupOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUpcomingMealPlanGroupOrdersQuery, GetUpcomingMealPlanGroupOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUpcomingMealPlanGroupOrdersQuery, GetUpcomingMealPlanGroupOrdersQueryVariables>(GetUpcomingMealPlanGroupOrdersDocument, options);
        }
export type GetUpcomingMealPlanGroupOrdersQueryHookResult = ReturnType<typeof useGetUpcomingMealPlanGroupOrdersQuery>;
export type GetUpcomingMealPlanGroupOrdersLazyQueryHookResult = ReturnType<typeof useGetUpcomingMealPlanGroupOrdersLazyQuery>;
export type GetUpcomingMealPlanGroupOrdersSuspenseQueryHookResult = ReturnType<typeof useGetUpcomingMealPlanGroupOrdersSuspenseQuery>;
export type GetUpcomingMealPlanGroupOrdersQueryResult = ApolloReactCommon.QueryResult<GetUpcomingMealPlanGroupOrdersQuery, GetUpcomingMealPlanGroupOrdersQueryVariables>;
export const ConsumerGroupOrderCancelQueryDocument = gql`
    query ConsumerGroupOrderCancelQuery($groupOrderId: String!) {
  groupOrdersByIds(groupOrderIds: [$groupOrderId]) {
    id
    isCancelled
    isFullyRefunded
  }
}
    `;
export type ConsumerGroupOrderCancelQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerGroupOrderCancelQueryQuery, ConsumerGroupOrderCancelQueryQueryVariables>, 'query'> & ({ variables: ConsumerGroupOrderCancelQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConsumerGroupOrderCancelQueryComponent = (props: ConsumerGroupOrderCancelQueryComponentProps) => (
      <ApolloReactComponents.Query<ConsumerGroupOrderCancelQueryQuery, ConsumerGroupOrderCancelQueryQueryVariables> query={ConsumerGroupOrderCancelQueryDocument} {...props} />
    );
    

/**
 * __useConsumerGroupOrderCancelQueryQuery__
 *
 * To run a query within a React component, call `useConsumerGroupOrderCancelQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerGroupOrderCancelQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerGroupOrderCancelQueryQuery({
 *   variables: {
 *      groupOrderId: // value for 'groupOrderId'
 *   },
 * });
 */
export function useConsumerGroupOrderCancelQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConsumerGroupOrderCancelQueryQuery, ConsumerGroupOrderCancelQueryQueryVariables> & ({ variables: ConsumerGroupOrderCancelQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerGroupOrderCancelQueryQuery, ConsumerGroupOrderCancelQueryQueryVariables>(ConsumerGroupOrderCancelQueryDocument, options);
      }
export function useConsumerGroupOrderCancelQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerGroupOrderCancelQueryQuery, ConsumerGroupOrderCancelQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerGroupOrderCancelQueryQuery, ConsumerGroupOrderCancelQueryQueryVariables>(ConsumerGroupOrderCancelQueryDocument, options);
        }
export function useConsumerGroupOrderCancelQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerGroupOrderCancelQueryQuery, ConsumerGroupOrderCancelQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerGroupOrderCancelQueryQuery, ConsumerGroupOrderCancelQueryQueryVariables>(ConsumerGroupOrderCancelQueryDocument, options);
        }
export type ConsumerGroupOrderCancelQueryQueryHookResult = ReturnType<typeof useConsumerGroupOrderCancelQueryQuery>;
export type ConsumerGroupOrderCancelQueryLazyQueryHookResult = ReturnType<typeof useConsumerGroupOrderCancelQueryLazyQuery>;
export type ConsumerGroupOrderCancelQuerySuspenseQueryHookResult = ReturnType<typeof useConsumerGroupOrderCancelQuerySuspenseQuery>;
export type ConsumerGroupOrderCancelQueryQueryResult = ApolloReactCommon.QueryResult<ConsumerGroupOrderCancelQueryQuery, ConsumerGroupOrderCancelQueryQueryVariables>;
export const ConsumerEditOrderDeliveryDocument = gql`
    query ConsumerEditOrderDelivery {
  me {
    id
    publicName
    activeAddresses {
      ...AddressSelectorAddress
      zipCodeInfo {
        zipCode
        regionId
      }
    }
  }
}
    ${AddressSelectorAddressFragmentDoc}`;
export type ConsumerEditOrderDeliveryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ConsumerEditOrderDeliveryQuery, ConsumerEditOrderDeliveryQueryVariables>, 'query'>;

    export const ConsumerEditOrderDeliveryComponent = (props: ConsumerEditOrderDeliveryComponentProps) => (
      <ApolloReactComponents.Query<ConsumerEditOrderDeliveryQuery, ConsumerEditOrderDeliveryQueryVariables> query={ConsumerEditOrderDeliveryDocument} {...props} />
    );
    

/**
 * __useConsumerEditOrderDeliveryQuery__
 *
 * To run a query within a React component, call `useConsumerEditOrderDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerEditOrderDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerEditOrderDeliveryQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsumerEditOrderDeliveryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConsumerEditOrderDeliveryQuery, ConsumerEditOrderDeliveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConsumerEditOrderDeliveryQuery, ConsumerEditOrderDeliveryQueryVariables>(ConsumerEditOrderDeliveryDocument, options);
      }
export function useConsumerEditOrderDeliveryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConsumerEditOrderDeliveryQuery, ConsumerEditOrderDeliveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConsumerEditOrderDeliveryQuery, ConsumerEditOrderDeliveryQueryVariables>(ConsumerEditOrderDeliveryDocument, options);
        }
export function useConsumerEditOrderDeliverySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConsumerEditOrderDeliveryQuery, ConsumerEditOrderDeliveryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConsumerEditOrderDeliveryQuery, ConsumerEditOrderDeliveryQueryVariables>(ConsumerEditOrderDeliveryDocument, options);
        }
export type ConsumerEditOrderDeliveryQueryHookResult = ReturnType<typeof useConsumerEditOrderDeliveryQuery>;
export type ConsumerEditOrderDeliveryLazyQueryHookResult = ReturnType<typeof useConsumerEditOrderDeliveryLazyQuery>;
export type ConsumerEditOrderDeliverySuspenseQueryHookResult = ReturnType<typeof useConsumerEditOrderDeliverySuspenseQuery>;
export type ConsumerEditOrderDeliveryQueryResult = ApolloReactCommon.QueryResult<ConsumerEditOrderDeliveryQuery, ConsumerEditOrderDeliveryQueryVariables>;
export const ConsumerModifyOrderDocument = gql`
    mutation ConsumerModifyOrder($input: ConsumerModifyGroupOrderInput!) {
  consumerModifyGroupOrder(input: $input) {
    id
  }
}
    `;
export type ConsumerModifyOrderMutationFn = ApolloReactCommon.MutationFunction<ConsumerModifyOrderMutation, ConsumerModifyOrderMutationVariables>;
export type ConsumerModifyOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ConsumerModifyOrderMutation, ConsumerModifyOrderMutationVariables>, 'mutation'>;

    export const ConsumerModifyOrderComponent = (props: ConsumerModifyOrderComponentProps) => (
      <ApolloReactComponents.Mutation<ConsumerModifyOrderMutation, ConsumerModifyOrderMutationVariables> mutation={ConsumerModifyOrderDocument} {...props} />
    );
    

/**
 * __useConsumerModifyOrderMutation__
 *
 * To run a mutation, you first call `useConsumerModifyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerModifyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerModifyOrderMutation, { data, loading, error }] = useConsumerModifyOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumerModifyOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConsumerModifyOrderMutation, ConsumerModifyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConsumerModifyOrderMutation, ConsumerModifyOrderMutationVariables>(ConsumerModifyOrderDocument, options);
      }
export type ConsumerModifyOrderMutationHookResult = ReturnType<typeof useConsumerModifyOrderMutation>;
export type ConsumerModifyOrderMutationResult = ApolloReactCommon.MutationResult<ConsumerModifyOrderMutation>;
export type ConsumerModifyOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<ConsumerModifyOrderMutation, ConsumerModifyOrderMutationVariables>;
export const ShefMenuSegmentsQueryDocument = gql`
    query ShefMenuSegmentsQuery($shefId: String!, $availableDate: DateTime, $filters: ExploreFoodItemsFilterInput) {
  shefMenuSegments(
    shefId: $shefId
    availableDate: $availableDate
    filters: $filters
    loadFoodItemDescription: true
  ) {
    ...ShefMenuSegment
  }
}
    ${ShefMenuSegmentFragmentDoc}`;
export type ShefMenuSegmentsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefMenuSegmentsQueryQuery, ShefMenuSegmentsQueryQueryVariables>, 'query'> & ({ variables: ShefMenuSegmentsQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefMenuSegmentsQueryComponent = (props: ShefMenuSegmentsQueryComponentProps) => (
      <ApolloReactComponents.Query<ShefMenuSegmentsQueryQuery, ShefMenuSegmentsQueryQueryVariables> query={ShefMenuSegmentsQueryDocument} {...props} />
    );
    

/**
 * __useShefMenuSegmentsQueryQuery__
 *
 * To run a query within a React component, call `useShefMenuSegmentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefMenuSegmentsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefMenuSegmentsQueryQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      availableDate: // value for 'availableDate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useShefMenuSegmentsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefMenuSegmentsQueryQuery, ShefMenuSegmentsQueryQueryVariables> & ({ variables: ShefMenuSegmentsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefMenuSegmentsQueryQuery, ShefMenuSegmentsQueryQueryVariables>(ShefMenuSegmentsQueryDocument, options);
      }
export function useShefMenuSegmentsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefMenuSegmentsQueryQuery, ShefMenuSegmentsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefMenuSegmentsQueryQuery, ShefMenuSegmentsQueryQueryVariables>(ShefMenuSegmentsQueryDocument, options);
        }
export function useShefMenuSegmentsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefMenuSegmentsQueryQuery, ShefMenuSegmentsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefMenuSegmentsQueryQuery, ShefMenuSegmentsQueryQueryVariables>(ShefMenuSegmentsQueryDocument, options);
        }
export type ShefMenuSegmentsQueryQueryHookResult = ReturnType<typeof useShefMenuSegmentsQueryQuery>;
export type ShefMenuSegmentsQueryLazyQueryHookResult = ReturnType<typeof useShefMenuSegmentsQueryLazyQuery>;
export type ShefMenuSegmentsQuerySuspenseQueryHookResult = ReturnType<typeof useShefMenuSegmentsQuerySuspenseQuery>;
export type ShefMenuSegmentsQueryQueryResult = ApolloReactCommon.QueryResult<ShefMenuSegmentsQueryQuery, ShefMenuSegmentsQueryQueryVariables>;
export const ShefMenuItemsQueryDocument = gql`
    query ShefMenuItemsQuery($shefId: String!, $availableDate: DateTime, $filters: ExploreFoodItemsFilterInput!) {
  shefMenuFilteredItems(
    shefId: $shefId
    availableDate: $availableDate
    filters: $filters
  ) {
    partialMatches {
      ...ConsumerFoodItem
    }
    perfectMatches {
      ...ConsumerFoodItem
    }
  }
}
    ${ConsumerFoodItemFragmentDoc}`;
export type ShefMenuItemsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefMenuItemsQueryQuery, ShefMenuItemsQueryQueryVariables>, 'query'> & ({ variables: ShefMenuItemsQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefMenuItemsQueryComponent = (props: ShefMenuItemsQueryComponentProps) => (
      <ApolloReactComponents.Query<ShefMenuItemsQueryQuery, ShefMenuItemsQueryQueryVariables> query={ShefMenuItemsQueryDocument} {...props} />
    );
    

/**
 * __useShefMenuItemsQueryQuery__
 *
 * To run a query within a React component, call `useShefMenuItemsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefMenuItemsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefMenuItemsQueryQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      availableDate: // value for 'availableDate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useShefMenuItemsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefMenuItemsQueryQuery, ShefMenuItemsQueryQueryVariables> & ({ variables: ShefMenuItemsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefMenuItemsQueryQuery, ShefMenuItemsQueryQueryVariables>(ShefMenuItemsQueryDocument, options);
      }
export function useShefMenuItemsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefMenuItemsQueryQuery, ShefMenuItemsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefMenuItemsQueryQuery, ShefMenuItemsQueryQueryVariables>(ShefMenuItemsQueryDocument, options);
        }
export function useShefMenuItemsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefMenuItemsQueryQuery, ShefMenuItemsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefMenuItemsQueryQuery, ShefMenuItemsQueryQueryVariables>(ShefMenuItemsQueryDocument, options);
        }
export type ShefMenuItemsQueryQueryHookResult = ReturnType<typeof useShefMenuItemsQueryQuery>;
export type ShefMenuItemsQueryLazyQueryHookResult = ReturnType<typeof useShefMenuItemsQueryLazyQuery>;
export type ShefMenuItemsQuerySuspenseQueryHookResult = ReturnType<typeof useShefMenuItemsQuerySuspenseQuery>;
export type ShefMenuItemsQueryQueryResult = ApolloReactCommon.QueryResult<ShefMenuItemsQueryQuery, ShefMenuItemsQueryQueryVariables>;
export const ShefOrderQueryDocument = gql`
    query ShefOrderQuery($shefId: String!, $zipCode: String, $availableDate: DateTime, $reviews: Int!) {
  shef(userId: $shefId) {
    ...OrderShef
    ...ShefDeliveryPrices
  }
  consumerFoodItems(
    shefId: $shefId
    availableDate: $availableDate
    zipCode: $zipCode
  ) {
    ...ConsumerFoodItem
  }
  validDaysOfWeek(zipCode: $zipCode)
  zipCode(zipCode: $zipCode) {
    zipCode
  }
  publicReviews(
    shefId: $shefId
    limit: $reviews
    offset: 0
    requireComments: true
  ) {
    total
    reviews {
      ...ConsumerOrderReview
    }
  }
}
    ${OrderShefFragmentDoc}
${ShefDeliveryPricesFragmentDoc}
${ConsumerFoodItemFragmentDoc}
${ConsumerOrderReviewFragmentDoc}`;
export type ShefOrderQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefOrderQueryQuery, ShefOrderQueryQueryVariables>, 'query'> & ({ variables: ShefOrderQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefOrderQueryComponent = (props: ShefOrderQueryComponentProps) => (
      <ApolloReactComponents.Query<ShefOrderQueryQuery, ShefOrderQueryQueryVariables> query={ShefOrderQueryDocument} {...props} />
    );
    

/**
 * __useShefOrderQueryQuery__
 *
 * To run a query within a React component, call `useShefOrderQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefOrderQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefOrderQueryQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      zipCode: // value for 'zipCode'
 *      availableDate: // value for 'availableDate'
 *      reviews: // value for 'reviews'
 *   },
 * });
 */
export function useShefOrderQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefOrderQueryQuery, ShefOrderQueryQueryVariables> & ({ variables: ShefOrderQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefOrderQueryQuery, ShefOrderQueryQueryVariables>(ShefOrderQueryDocument, options);
      }
export function useShefOrderQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefOrderQueryQuery, ShefOrderQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefOrderQueryQuery, ShefOrderQueryQueryVariables>(ShefOrderQueryDocument, options);
        }
export function useShefOrderQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefOrderQueryQuery, ShefOrderQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefOrderQueryQuery, ShefOrderQueryQueryVariables>(ShefOrderQueryDocument, options);
        }
export type ShefOrderQueryQueryHookResult = ReturnType<typeof useShefOrderQueryQuery>;
export type ShefOrderQueryLazyQueryHookResult = ReturnType<typeof useShefOrderQueryLazyQuery>;
export type ShefOrderQuerySuspenseQueryHookResult = ReturnType<typeof useShefOrderQuerySuspenseQuery>;
export type ShefOrderQueryQueryResult = ApolloReactCommon.QueryResult<ShefOrderQueryQuery, ShefOrderQueryQueryVariables>;
export const PromoCodeValueQueryDocument = gql`
    query PromoCodeValueQuery($code: String!, $shefSubtotals: [ShefSubtotal!], $deliveryDate: String) {
  promoCodeValue(
    code: $code
    shefSubtotals: $shefSubtotals
    deliveryDate: $deliveryDate
  ) {
    promoCodeString
    code {
      ...PromoCodeFields
    }
    organization {
      ...OrganizationFields
    }
    error
  }
}
    ${PromoCodeFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;
export type PromoCodeValueQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PromoCodeValueQueryQuery, PromoCodeValueQueryQueryVariables>, 'query'> & ({ variables: PromoCodeValueQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PromoCodeValueQueryComponent = (props: PromoCodeValueQueryComponentProps) => (
      <ApolloReactComponents.Query<PromoCodeValueQueryQuery, PromoCodeValueQueryQueryVariables> query={PromoCodeValueQueryDocument} {...props} />
    );
    

/**
 * __usePromoCodeValueQueryQuery__
 *
 * To run a query within a React component, call `usePromoCodeValueQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoCodeValueQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoCodeValueQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *      shefSubtotals: // value for 'shefSubtotals'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function usePromoCodeValueQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PromoCodeValueQueryQuery, PromoCodeValueQueryQueryVariables> & ({ variables: PromoCodeValueQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PromoCodeValueQueryQuery, PromoCodeValueQueryQueryVariables>(PromoCodeValueQueryDocument, options);
      }
export function usePromoCodeValueQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PromoCodeValueQueryQuery, PromoCodeValueQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PromoCodeValueQueryQuery, PromoCodeValueQueryQueryVariables>(PromoCodeValueQueryDocument, options);
        }
export function usePromoCodeValueQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PromoCodeValueQueryQuery, PromoCodeValueQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PromoCodeValueQueryQuery, PromoCodeValueQueryQueryVariables>(PromoCodeValueQueryDocument, options);
        }
export type PromoCodeValueQueryQueryHookResult = ReturnType<typeof usePromoCodeValueQueryQuery>;
export type PromoCodeValueQueryLazyQueryHookResult = ReturnType<typeof usePromoCodeValueQueryLazyQuery>;
export type PromoCodeValueQuerySuspenseQueryHookResult = ReturnType<typeof usePromoCodeValueQuerySuspenseQuery>;
export type PromoCodeValueQueryQueryResult = ApolloReactCommon.QueryResult<PromoCodeValueQueryQuery, PromoCodeValueQueryQueryVariables>;
export const AllPromoCodeValuesDocument = gql`
    query AllPromoCodeValues($codes: [String!]!, $shefSubtotals: [ShefSubtotal!], $deliveryDate: String) {
  promoCodeValues(
    codes: $codes
    shefSubtotals: $shefSubtotals
    deliveryDate: $deliveryDate
  ) {
    promoCodeString
    code {
      ...PromoCodeFields
    }
    organization {
      ...OrganizationFields
    }
    error
  }
}
    ${PromoCodeFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;
export type AllPromoCodeValuesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllPromoCodeValuesQuery, AllPromoCodeValuesQueryVariables>, 'query'> & ({ variables: AllPromoCodeValuesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AllPromoCodeValuesComponent = (props: AllPromoCodeValuesComponentProps) => (
      <ApolloReactComponents.Query<AllPromoCodeValuesQuery, AllPromoCodeValuesQueryVariables> query={AllPromoCodeValuesDocument} {...props} />
    );
    

/**
 * __useAllPromoCodeValuesQuery__
 *
 * To run a query within a React component, call `useAllPromoCodeValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPromoCodeValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPromoCodeValuesQuery({
 *   variables: {
 *      codes: // value for 'codes'
 *      shefSubtotals: // value for 'shefSubtotals'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useAllPromoCodeValuesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllPromoCodeValuesQuery, AllPromoCodeValuesQueryVariables> & ({ variables: AllPromoCodeValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllPromoCodeValuesQuery, AllPromoCodeValuesQueryVariables>(AllPromoCodeValuesDocument, options);
      }
export function useAllPromoCodeValuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllPromoCodeValuesQuery, AllPromoCodeValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllPromoCodeValuesQuery, AllPromoCodeValuesQueryVariables>(AllPromoCodeValuesDocument, options);
        }
export function useAllPromoCodeValuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllPromoCodeValuesQuery, AllPromoCodeValuesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllPromoCodeValuesQuery, AllPromoCodeValuesQueryVariables>(AllPromoCodeValuesDocument, options);
        }
export type AllPromoCodeValuesQueryHookResult = ReturnType<typeof useAllPromoCodeValuesQuery>;
export type AllPromoCodeValuesLazyQueryHookResult = ReturnType<typeof useAllPromoCodeValuesLazyQuery>;
export type AllPromoCodeValuesSuspenseQueryHookResult = ReturnType<typeof useAllPromoCodeValuesSuspenseQuery>;
export type AllPromoCodeValuesQueryResult = ApolloReactCommon.QueryResult<AllPromoCodeValuesQuery, AllPromoCodeValuesQueryVariables>;
export const DishModalDocument = gql`
    query DishModal($foodItemId: Int!) {
  foodItem(foodItemId: $foodItemId) {
    ...DishModalFoodItem
  }
}
    ${DishModalFoodItemFragmentDoc}`;
export type DishModalComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DishModalQuery, DishModalQueryVariables>, 'query'> & ({ variables: DishModalQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DishModalComponent = (props: DishModalComponentProps) => (
      <ApolloReactComponents.Query<DishModalQuery, DishModalQueryVariables> query={DishModalDocument} {...props} />
    );
    

/**
 * __useDishModalQuery__
 *
 * To run a query within a React component, call `useDishModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useDishModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDishModalQuery({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *   },
 * });
 */
export function useDishModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DishModalQuery, DishModalQueryVariables> & ({ variables: DishModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DishModalQuery, DishModalQueryVariables>(DishModalDocument, options);
      }
export function useDishModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DishModalQuery, DishModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DishModalQuery, DishModalQueryVariables>(DishModalDocument, options);
        }
export function useDishModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DishModalQuery, DishModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DishModalQuery, DishModalQueryVariables>(DishModalDocument, options);
        }
export type DishModalQueryHookResult = ReturnType<typeof useDishModalQuery>;
export type DishModalLazyQueryHookResult = ReturnType<typeof useDishModalLazyQuery>;
export type DishModalSuspenseQueryHookResult = ReturnType<typeof useDishModalSuspenseQuery>;
export type DishModalQueryResult = ApolloReactCommon.QueryResult<DishModalQuery, DishModalQueryVariables>;
export const DishModalReviewsDocument = gql`
    query DishModalReviews($foodItemId: Int!, $offset: Int!, $limit: Int!) {
  foodItemOrderReviews(foodItemId: $foodItemId, offset: $offset, limit: $limit) {
    reviews {
      ...PerformanceOrderReviewResult
    }
  }
}
    ${PerformanceOrderReviewResultFragmentDoc}`;
export type DishModalReviewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DishModalReviewsQuery, DishModalReviewsQueryVariables>, 'query'> & ({ variables: DishModalReviewsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DishModalReviewsComponent = (props: DishModalReviewsComponentProps) => (
      <ApolloReactComponents.Query<DishModalReviewsQuery, DishModalReviewsQueryVariables> query={DishModalReviewsDocument} {...props} />
    );
    

/**
 * __useDishModalReviewsQuery__
 *
 * To run a query within a React component, call `useDishModalReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDishModalReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDishModalReviewsQuery({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDishModalReviewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DishModalReviewsQuery, DishModalReviewsQueryVariables> & ({ variables: DishModalReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DishModalReviewsQuery, DishModalReviewsQueryVariables>(DishModalReviewsDocument, options);
      }
export function useDishModalReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DishModalReviewsQuery, DishModalReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DishModalReviewsQuery, DishModalReviewsQueryVariables>(DishModalReviewsDocument, options);
        }
export function useDishModalReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DishModalReviewsQuery, DishModalReviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DishModalReviewsQuery, DishModalReviewsQueryVariables>(DishModalReviewsDocument, options);
        }
export type DishModalReviewsQueryHookResult = ReturnType<typeof useDishModalReviewsQuery>;
export type DishModalReviewsLazyQueryHookResult = ReturnType<typeof useDishModalReviewsLazyQuery>;
export type DishModalReviewsSuspenseQueryHookResult = ReturnType<typeof useDishModalReviewsSuspenseQuery>;
export type DishModalReviewsQueryResult = ApolloReactCommon.QueryResult<DishModalReviewsQuery, DishModalReviewsQueryVariables>;
export const PeopleAlsoOrderedDocument = gql`
    query PeopleAlsoOrdered($deliveryDate: String!, $zipCode: String!, $cartFoodItemIds: [Int!]!, $dietaryFilters: [String!]) {
  peopleAlsoOrderedRecommendations(
    deliveryDate: $deliveryDate
    zipCode: $zipCode
    cartFoodItemIds: $cartFoodItemIds
    dietaryFilters: $dietaryFilters
  ) {
    ...DishFirstFoodItem
  }
}
    ${DishFirstFoodItemFragmentDoc}`;
export type PeopleAlsoOrderedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PeopleAlsoOrderedQuery, PeopleAlsoOrderedQueryVariables>, 'query'> & ({ variables: PeopleAlsoOrderedQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PeopleAlsoOrderedComponent = (props: PeopleAlsoOrderedComponentProps) => (
      <ApolloReactComponents.Query<PeopleAlsoOrderedQuery, PeopleAlsoOrderedQueryVariables> query={PeopleAlsoOrderedDocument} {...props} />
    );
    

/**
 * __usePeopleAlsoOrderedQuery__
 *
 * To run a query within a React component, call `usePeopleAlsoOrderedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleAlsoOrderedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleAlsoOrderedQuery({
 *   variables: {
 *      deliveryDate: // value for 'deliveryDate'
 *      zipCode: // value for 'zipCode'
 *      cartFoodItemIds: // value for 'cartFoodItemIds'
 *      dietaryFilters: // value for 'dietaryFilters'
 *   },
 * });
 */
export function usePeopleAlsoOrderedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PeopleAlsoOrderedQuery, PeopleAlsoOrderedQueryVariables> & ({ variables: PeopleAlsoOrderedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PeopleAlsoOrderedQuery, PeopleAlsoOrderedQueryVariables>(PeopleAlsoOrderedDocument, options);
      }
export function usePeopleAlsoOrderedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PeopleAlsoOrderedQuery, PeopleAlsoOrderedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PeopleAlsoOrderedQuery, PeopleAlsoOrderedQueryVariables>(PeopleAlsoOrderedDocument, options);
        }
export function usePeopleAlsoOrderedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleAlsoOrderedQuery, PeopleAlsoOrderedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PeopleAlsoOrderedQuery, PeopleAlsoOrderedQueryVariables>(PeopleAlsoOrderedDocument, options);
        }
export type PeopleAlsoOrderedQueryHookResult = ReturnType<typeof usePeopleAlsoOrderedQuery>;
export type PeopleAlsoOrderedLazyQueryHookResult = ReturnType<typeof usePeopleAlsoOrderedLazyQuery>;
export type PeopleAlsoOrderedSuspenseQueryHookResult = ReturnType<typeof usePeopleAlsoOrderedSuspenseQuery>;
export type PeopleAlsoOrderedQueryResult = ApolloReactCommon.QueryResult<PeopleAlsoOrderedQuery, PeopleAlsoOrderedQueryVariables>;
export const RecentTasteOrdersDocument = gql`
    query RecentTasteOrders {
  me {
    recentTasteTests
    admin
  }
}
    `;
export type RecentTasteOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecentTasteOrdersQuery, RecentTasteOrdersQueryVariables>, 'query'>;

    export const RecentTasteOrdersComponent = (props: RecentTasteOrdersComponentProps) => (
      <ApolloReactComponents.Query<RecentTasteOrdersQuery, RecentTasteOrdersQueryVariables> query={RecentTasteOrdersDocument} {...props} />
    );
    

/**
 * __useRecentTasteOrdersQuery__
 *
 * To run a query within a React component, call `useRecentTasteOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentTasteOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentTasteOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentTasteOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecentTasteOrdersQuery, RecentTasteOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecentTasteOrdersQuery, RecentTasteOrdersQueryVariables>(RecentTasteOrdersDocument, options);
      }
export function useRecentTasteOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentTasteOrdersQuery, RecentTasteOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecentTasteOrdersQuery, RecentTasteOrdersQueryVariables>(RecentTasteOrdersDocument, options);
        }
export function useRecentTasteOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RecentTasteOrdersQuery, RecentTasteOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RecentTasteOrdersQuery, RecentTasteOrdersQueryVariables>(RecentTasteOrdersDocument, options);
        }
export type RecentTasteOrdersQueryHookResult = ReturnType<typeof useRecentTasteOrdersQuery>;
export type RecentTasteOrdersLazyQueryHookResult = ReturnType<typeof useRecentTasteOrdersLazyQuery>;
export type RecentTasteOrdersSuspenseQueryHookResult = ReturnType<typeof useRecentTasteOrdersSuspenseQuery>;
export type RecentTasteOrdersQueryResult = ApolloReactCommon.QueryResult<RecentTasteOrdersQuery, RecentTasteOrdersQueryVariables>;
export const ReviewsModalDocument = gql`
    query ReviewsModal($shefId: String!, $limit: Int!, $offset: Int!) {
  publicReviews(shefId: $shefId, offset: $offset, limit: $limit) {
    total
    reviews {
      ...ModalReview
    }
  }
  shef(userId: $shefId) {
    publicName
    timeZone
    rating {
      score
      count
    }
    totalOrders
  }
}
    ${ModalReviewFragmentDoc}`;
export type ReviewsModalComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReviewsModalQuery, ReviewsModalQueryVariables>, 'query'> & ({ variables: ReviewsModalQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ReviewsModalComponent = (props: ReviewsModalComponentProps) => (
      <ApolloReactComponents.Query<ReviewsModalQuery, ReviewsModalQueryVariables> query={ReviewsModalDocument} {...props} />
    );
    

/**
 * __useReviewsModalQuery__
 *
 * To run a query within a React component, call `useReviewsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsModalQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useReviewsModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewsModalQuery, ReviewsModalQueryVariables> & ({ variables: ReviewsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewsModalQuery, ReviewsModalQueryVariables>(ReviewsModalDocument, options);
      }
export function useReviewsModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewsModalQuery, ReviewsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewsModalQuery, ReviewsModalQueryVariables>(ReviewsModalDocument, options);
        }
export function useReviewsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewsModalQuery, ReviewsModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewsModalQuery, ReviewsModalQueryVariables>(ReviewsModalDocument, options);
        }
export type ReviewsModalQueryHookResult = ReturnType<typeof useReviewsModalQuery>;
export type ReviewsModalLazyQueryHookResult = ReturnType<typeof useReviewsModalLazyQuery>;
export type ReviewsModalSuspenseQueryHookResult = ReturnType<typeof useReviewsModalSuspenseQuery>;
export type ReviewsModalQueryResult = ApolloReactCommon.QueryResult<ReviewsModalQuery, ReviewsModalQueryVariables>;
export const DietaryDetailsForShefDocument = gql`
    query DietaryDetailsForShef($shefId: String!) {
  dietaryDetailsForShef(shefId: $shefId) {
    id
    name
    summaryId
    summaryDisplay
    summaryExplanation
    dietaryTag
    responses {
      questionId
      response
      responseDisplay
      responseFreeText
    }
  }
}
    `;
export type DietaryDetailsForShefComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DietaryDetailsForShefQuery, DietaryDetailsForShefQueryVariables>, 'query'> & ({ variables: DietaryDetailsForShefQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DietaryDetailsForShefComponent = (props: DietaryDetailsForShefComponentProps) => (
      <ApolloReactComponents.Query<DietaryDetailsForShefQuery, DietaryDetailsForShefQueryVariables> query={DietaryDetailsForShefDocument} {...props} />
    );
    

/**
 * __useDietaryDetailsForShefQuery__
 *
 * To run a query within a React component, call `useDietaryDetailsForShefQuery` and pass it any options that fit your needs.
 * When your component renders, `useDietaryDetailsForShefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDietaryDetailsForShefQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useDietaryDetailsForShefQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DietaryDetailsForShefQuery, DietaryDetailsForShefQueryVariables> & ({ variables: DietaryDetailsForShefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DietaryDetailsForShefQuery, DietaryDetailsForShefQueryVariables>(DietaryDetailsForShefDocument, options);
      }
export function useDietaryDetailsForShefLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DietaryDetailsForShefQuery, DietaryDetailsForShefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DietaryDetailsForShefQuery, DietaryDetailsForShefQueryVariables>(DietaryDetailsForShefDocument, options);
        }
export function useDietaryDetailsForShefSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DietaryDetailsForShefQuery, DietaryDetailsForShefQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DietaryDetailsForShefQuery, DietaryDetailsForShefQueryVariables>(DietaryDetailsForShefDocument, options);
        }
export type DietaryDetailsForShefQueryHookResult = ReturnType<typeof useDietaryDetailsForShefQuery>;
export type DietaryDetailsForShefLazyQueryHookResult = ReturnType<typeof useDietaryDetailsForShefLazyQuery>;
export type DietaryDetailsForShefSuspenseQueryHookResult = ReturnType<typeof useDietaryDetailsForShefSuspenseQuery>;
export type DietaryDetailsForShefQueryResult = ApolloReactCommon.QueryResult<DietaryDetailsForShefQuery, DietaryDetailsForShefQueryVariables>;
export const SuggestedSidesDocument = gql`
    query SuggestedSides($foodItemId: Int!, $numMains: Int!, $deliveryDate: DateTime!, $shefTimeZone: String!, $dietaryFilters: [String!], $zipCode: String) {
  suggestedItemsFromMenu(
    foodItemId: $foodItemId
    numMains: $numMains
    deliveryDate: $deliveryDate
    shefTimeZone: $shefTimeZone
    dietaryFilters: $dietaryFilters
    zipCode: $zipCode
  ) {
    ...SuggestedSidesResult
  }
}
    ${SuggestedSidesResultFragmentDoc}`;
export type SuggestedSidesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SuggestedSidesQuery, SuggestedSidesQueryVariables>, 'query'> & ({ variables: SuggestedSidesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SuggestedSidesComponent = (props: SuggestedSidesComponentProps) => (
      <ApolloReactComponents.Query<SuggestedSidesQuery, SuggestedSidesQueryVariables> query={SuggestedSidesDocument} {...props} />
    );
    

/**
 * __useSuggestedSidesQuery__
 *
 * To run a query within a React component, call `useSuggestedSidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedSidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedSidesQuery({
 *   variables: {
 *      foodItemId: // value for 'foodItemId'
 *      numMains: // value for 'numMains'
 *      deliveryDate: // value for 'deliveryDate'
 *      shefTimeZone: // value for 'shefTimeZone'
 *      dietaryFilters: // value for 'dietaryFilters'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useSuggestedSidesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuggestedSidesQuery, SuggestedSidesQueryVariables> & ({ variables: SuggestedSidesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuggestedSidesQuery, SuggestedSidesQueryVariables>(SuggestedSidesDocument, options);
      }
export function useSuggestedSidesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuggestedSidesQuery, SuggestedSidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuggestedSidesQuery, SuggestedSidesQueryVariables>(SuggestedSidesDocument, options);
        }
export function useSuggestedSidesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuggestedSidesQuery, SuggestedSidesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuggestedSidesQuery, SuggestedSidesQueryVariables>(SuggestedSidesDocument, options);
        }
export type SuggestedSidesQueryHookResult = ReturnType<typeof useSuggestedSidesQuery>;
export type SuggestedSidesLazyQueryHookResult = ReturnType<typeof useSuggestedSidesLazyQuery>;
export type SuggestedSidesSuspenseQueryHookResult = ReturnType<typeof useSuggestedSidesSuspenseQuery>;
export type SuggestedSidesQueryResult = ApolloReactCommon.QueryResult<SuggestedSidesQuery, SuggestedSidesQueryVariables>;
export const GroupOrderReceiptDocument = gql`
    query GroupOrderReceipt($groupOrderId: String!) {
  groupOrdersByIds(groupOrderIds: [$groupOrderId]) {
    ...GroupOrderReceiptFields
  }
  me {
    id
    referralCode {
      id
      code
      giveValue
      getValue
      isPercentage
    }
  }
  upsellPromo(groupOrderId: $groupOrderId) {
    ...PromoCodeFields
  }
}
    ${GroupOrderReceiptFieldsFragmentDoc}
${PromoCodeFieldsFragmentDoc}`;
export type GroupOrderReceiptComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GroupOrderReceiptQuery, GroupOrderReceiptQueryVariables>, 'query'> & ({ variables: GroupOrderReceiptQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GroupOrderReceiptComponent = (props: GroupOrderReceiptComponentProps) => (
      <ApolloReactComponents.Query<GroupOrderReceiptQuery, GroupOrderReceiptQueryVariables> query={GroupOrderReceiptDocument} {...props} />
    );
    

/**
 * __useGroupOrderReceiptQuery__
 *
 * To run a query within a React component, call `useGroupOrderReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupOrderReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupOrderReceiptQuery({
 *   variables: {
 *      groupOrderId: // value for 'groupOrderId'
 *   },
 * });
 */
export function useGroupOrderReceiptQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupOrderReceiptQuery, GroupOrderReceiptQueryVariables> & ({ variables: GroupOrderReceiptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupOrderReceiptQuery, GroupOrderReceiptQueryVariables>(GroupOrderReceiptDocument, options);
      }
export function useGroupOrderReceiptLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupOrderReceiptQuery, GroupOrderReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupOrderReceiptQuery, GroupOrderReceiptQueryVariables>(GroupOrderReceiptDocument, options);
        }
export function useGroupOrderReceiptSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupOrderReceiptQuery, GroupOrderReceiptQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupOrderReceiptQuery, GroupOrderReceiptQueryVariables>(GroupOrderReceiptDocument, options);
        }
export type GroupOrderReceiptQueryHookResult = ReturnType<typeof useGroupOrderReceiptQuery>;
export type GroupOrderReceiptLazyQueryHookResult = ReturnType<typeof useGroupOrderReceiptLazyQuery>;
export type GroupOrderReceiptSuspenseQueryHookResult = ReturnType<typeof useGroupOrderReceiptSuspenseQuery>;
export type GroupOrderReceiptQueryResult = ApolloReactCommon.QueryResult<GroupOrderReceiptQuery, GroupOrderReceiptQueryVariables>;
export const ReorderAndFetchItemsDocument = gql`
    mutation ReorderAndFetchItems($orderId: Int!) {
  duplicateOrderToCart(orderId: $orderId) {
    addedItems {
      ...ReorderedItem
    }
  }
}
    ${ReorderedItemFragmentDoc}`;
export type ReorderAndFetchItemsMutationFn = ApolloReactCommon.MutationFunction<ReorderAndFetchItemsMutation, ReorderAndFetchItemsMutationVariables>;
export type ReorderAndFetchItemsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ReorderAndFetchItemsMutation, ReorderAndFetchItemsMutationVariables>, 'mutation'>;

    export const ReorderAndFetchItemsComponent = (props: ReorderAndFetchItemsComponentProps) => (
      <ApolloReactComponents.Mutation<ReorderAndFetchItemsMutation, ReorderAndFetchItemsMutationVariables> mutation={ReorderAndFetchItemsDocument} {...props} />
    );
    

/**
 * __useReorderAndFetchItemsMutation__
 *
 * To run a mutation, you first call `useReorderAndFetchItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderAndFetchItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderAndFetchItemsMutation, { data, loading, error }] = useReorderAndFetchItemsMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useReorderAndFetchItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderAndFetchItemsMutation, ReorderAndFetchItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderAndFetchItemsMutation, ReorderAndFetchItemsMutationVariables>(ReorderAndFetchItemsDocument, options);
      }
export type ReorderAndFetchItemsMutationHookResult = ReturnType<typeof useReorderAndFetchItemsMutation>;
export type ReorderAndFetchItemsMutationResult = ApolloReactCommon.MutationResult<ReorderAndFetchItemsMutation>;
export type ReorderAndFetchItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<ReorderAndFetchItemsMutation, ReorderAndFetchItemsMutationVariables>;
export const CreateAvailabilityNotificationDocument = gql`
    mutation CreateAvailabilityNotification($shefId: String!) {
  createShefAvailabilityNotification(shefId: $shefId)
}
    `;
export type CreateAvailabilityNotificationMutationFn = ApolloReactCommon.MutationFunction<CreateAvailabilityNotificationMutation, CreateAvailabilityNotificationMutationVariables>;
export type CreateAvailabilityNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAvailabilityNotificationMutation, CreateAvailabilityNotificationMutationVariables>, 'mutation'>;

    export const CreateAvailabilityNotificationComponent = (props: CreateAvailabilityNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAvailabilityNotificationMutation, CreateAvailabilityNotificationMutationVariables> mutation={CreateAvailabilityNotificationDocument} {...props} />
    );
    

/**
 * __useCreateAvailabilityNotificationMutation__
 *
 * To run a mutation, you first call `useCreateAvailabilityNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAvailabilityNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAvailabilityNotificationMutation, { data, loading, error }] = useCreateAvailabilityNotificationMutation({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useCreateAvailabilityNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAvailabilityNotificationMutation, CreateAvailabilityNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAvailabilityNotificationMutation, CreateAvailabilityNotificationMutationVariables>(CreateAvailabilityNotificationDocument, options);
      }
export type CreateAvailabilityNotificationMutationHookResult = ReturnType<typeof useCreateAvailabilityNotificationMutation>;
export type CreateAvailabilityNotificationMutationResult = ApolloReactCommon.MutationResult<CreateAvailabilityNotificationMutation>;
export type CreateAvailabilityNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAvailabilityNotificationMutation, CreateAvailabilityNotificationMutationVariables>;
export const HasOrderedBeforeDocument = gql`
    query HasOrderedBefore($userId: String!, $shefId: String!) {
  orders(userId: $userId, shefId: $shefId, includeRefunded: false) {
    count
  }
}
    `;
export type HasOrderedBeforeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HasOrderedBeforeQuery, HasOrderedBeforeQueryVariables>, 'query'> & ({ variables: HasOrderedBeforeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HasOrderedBeforeComponent = (props: HasOrderedBeforeComponentProps) => (
      <ApolloReactComponents.Query<HasOrderedBeforeQuery, HasOrderedBeforeQueryVariables> query={HasOrderedBeforeDocument} {...props} />
    );
    

/**
 * __useHasOrderedBeforeQuery__
 *
 * To run a query within a React component, call `useHasOrderedBeforeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasOrderedBeforeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasOrderedBeforeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useHasOrderedBeforeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HasOrderedBeforeQuery, HasOrderedBeforeQueryVariables> & ({ variables: HasOrderedBeforeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HasOrderedBeforeQuery, HasOrderedBeforeQueryVariables>(HasOrderedBeforeDocument, options);
      }
export function useHasOrderedBeforeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HasOrderedBeforeQuery, HasOrderedBeforeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HasOrderedBeforeQuery, HasOrderedBeforeQueryVariables>(HasOrderedBeforeDocument, options);
        }
export function useHasOrderedBeforeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HasOrderedBeforeQuery, HasOrderedBeforeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HasOrderedBeforeQuery, HasOrderedBeforeQueryVariables>(HasOrderedBeforeDocument, options);
        }
export type HasOrderedBeforeQueryHookResult = ReturnType<typeof useHasOrderedBeforeQuery>;
export type HasOrderedBeforeLazyQueryHookResult = ReturnType<typeof useHasOrderedBeforeLazyQuery>;
export type HasOrderedBeforeSuspenseQueryHookResult = ReturnType<typeof useHasOrderedBeforeSuspenseQuery>;
export type HasOrderedBeforeQueryResult = ApolloReactCommon.QueryResult<HasOrderedBeforeQuery, HasOrderedBeforeQueryVariables>;
export const ClaimPhotoEditRequestDocument = gql`
    mutation claimPhotoEditRequest($changeRequestId: Int!) {
  claimPhotoEditRequest(changeRequestId: $changeRequestId) {
    id
    foodItemChangeRequestId
  }
}
    `;
export type ClaimPhotoEditRequestMutationFn = ApolloReactCommon.MutationFunction<ClaimPhotoEditRequestMutation, ClaimPhotoEditRequestMutationVariables>;
export type ClaimPhotoEditRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ClaimPhotoEditRequestMutation, ClaimPhotoEditRequestMutationVariables>, 'mutation'>;

    export const ClaimPhotoEditRequestComponent = (props: ClaimPhotoEditRequestComponentProps) => (
      <ApolloReactComponents.Mutation<ClaimPhotoEditRequestMutation, ClaimPhotoEditRequestMutationVariables> mutation={ClaimPhotoEditRequestDocument} {...props} />
    );
    

/**
 * __useClaimPhotoEditRequestMutation__
 *
 * To run a mutation, you first call `useClaimPhotoEditRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimPhotoEditRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimPhotoEditRequestMutation, { data, loading, error }] = useClaimPhotoEditRequestMutation({
 *   variables: {
 *      changeRequestId: // value for 'changeRequestId'
 *   },
 * });
 */
export function useClaimPhotoEditRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClaimPhotoEditRequestMutation, ClaimPhotoEditRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClaimPhotoEditRequestMutation, ClaimPhotoEditRequestMutationVariables>(ClaimPhotoEditRequestDocument, options);
      }
export type ClaimPhotoEditRequestMutationHookResult = ReturnType<typeof useClaimPhotoEditRequestMutation>;
export type ClaimPhotoEditRequestMutationResult = ApolloReactCommon.MutationResult<ClaimPhotoEditRequestMutation>;
export type ClaimPhotoEditRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<ClaimPhotoEditRequestMutation, ClaimPhotoEditRequestMutationVariables>;
export const UnclaimPhotoEditRequestDocument = gql`
    mutation unclaimPhotoEditRequest($changeRequestId: Int!, $unclaimReason: String!) {
  unclaimPhotoEditRequest(
    changeRequestId: $changeRequestId
    unclaimReason: $unclaimReason
  ) {
    id
    foodItemChangeRequestId
  }
}
    `;
export type UnclaimPhotoEditRequestMutationFn = ApolloReactCommon.MutationFunction<UnclaimPhotoEditRequestMutation, UnclaimPhotoEditRequestMutationVariables>;
export type UnclaimPhotoEditRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnclaimPhotoEditRequestMutation, UnclaimPhotoEditRequestMutationVariables>, 'mutation'>;

    export const UnclaimPhotoEditRequestComponent = (props: UnclaimPhotoEditRequestComponentProps) => (
      <ApolloReactComponents.Mutation<UnclaimPhotoEditRequestMutation, UnclaimPhotoEditRequestMutationVariables> mutation={UnclaimPhotoEditRequestDocument} {...props} />
    );
    

/**
 * __useUnclaimPhotoEditRequestMutation__
 *
 * To run a mutation, you first call `useUnclaimPhotoEditRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnclaimPhotoEditRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unclaimPhotoEditRequestMutation, { data, loading, error }] = useUnclaimPhotoEditRequestMutation({
 *   variables: {
 *      changeRequestId: // value for 'changeRequestId'
 *      unclaimReason: // value for 'unclaimReason'
 *   },
 * });
 */
export function useUnclaimPhotoEditRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnclaimPhotoEditRequestMutation, UnclaimPhotoEditRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnclaimPhotoEditRequestMutation, UnclaimPhotoEditRequestMutationVariables>(UnclaimPhotoEditRequestDocument, options);
      }
export type UnclaimPhotoEditRequestMutationHookResult = ReturnType<typeof useUnclaimPhotoEditRequestMutation>;
export type UnclaimPhotoEditRequestMutationResult = ApolloReactCommon.MutationResult<UnclaimPhotoEditRequestMutation>;
export type UnclaimPhotoEditRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<UnclaimPhotoEditRequestMutation, UnclaimPhotoEditRequestMutationVariables>;
export const UpdatePhotoEditRequestDocument = gql`
    mutation updatePhotoEditRequest($id: String!, $imageUrl: String!) {
  updatePhotoEditRequest(id: $id, imageUrl: $imageUrl) {
    id
  }
}
    `;
export type UpdatePhotoEditRequestMutationFn = ApolloReactCommon.MutationFunction<UpdatePhotoEditRequestMutation, UpdatePhotoEditRequestMutationVariables>;
export type UpdatePhotoEditRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdatePhotoEditRequestMutation, UpdatePhotoEditRequestMutationVariables>, 'mutation'>;

    export const UpdatePhotoEditRequestComponent = (props: UpdatePhotoEditRequestComponentProps) => (
      <ApolloReactComponents.Mutation<UpdatePhotoEditRequestMutation, UpdatePhotoEditRequestMutationVariables> mutation={UpdatePhotoEditRequestDocument} {...props} />
    );
    

/**
 * __useUpdatePhotoEditRequestMutation__
 *
 * To run a mutation, you first call `useUpdatePhotoEditRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhotoEditRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhotoEditRequestMutation, { data, loading, error }] = useUpdatePhotoEditRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageUrl: // value for 'imageUrl'
 *   },
 * });
 */
export function useUpdatePhotoEditRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePhotoEditRequestMutation, UpdatePhotoEditRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePhotoEditRequestMutation, UpdatePhotoEditRequestMutationVariables>(UpdatePhotoEditRequestDocument, options);
      }
export type UpdatePhotoEditRequestMutationHookResult = ReturnType<typeof useUpdatePhotoEditRequestMutation>;
export type UpdatePhotoEditRequestMutationResult = ApolloReactCommon.MutationResult<UpdatePhotoEditRequestMutation>;
export type UpdatePhotoEditRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePhotoEditRequestMutation, UpdatePhotoEditRequestMutationVariables>;
export const PhotoEditRequestDocument = gql`
    query photoEditRequest($changeRequestId: Int!) {
  photoEditRequest(changeRequestId: $changeRequestId) {
    id
    editedImageUrl
    foodItem {
      ...EditableFoodItem
      mostRecentOpenChangeRequest {
        ...ChangeRequestView
        ...ChangeRequestCommentThread
      }
    }
  }
  foodItemCustomizationTypes {
    ...FoodItemCustomizationTypeFields
  }
}
    ${EditableFoodItemFragmentDoc}
${ChangeRequestViewFragmentDoc}
${ChangeRequestCommentThreadFragmentDoc}
${FoodItemCustomizationTypeFieldsFragmentDoc}`;
export type PhotoEditRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PhotoEditRequestQuery, PhotoEditRequestQueryVariables>, 'query'> & ({ variables: PhotoEditRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PhotoEditRequestComponent = (props: PhotoEditRequestComponentProps) => (
      <ApolloReactComponents.Query<PhotoEditRequestQuery, PhotoEditRequestQueryVariables> query={PhotoEditRequestDocument} {...props} />
    );
    

/**
 * __usePhotoEditRequestQuery__
 *
 * To run a query within a React component, call `usePhotoEditRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoEditRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoEditRequestQuery({
 *   variables: {
 *      changeRequestId: // value for 'changeRequestId'
 *   },
 * });
 */
export function usePhotoEditRequestQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PhotoEditRequestQuery, PhotoEditRequestQueryVariables> & ({ variables: PhotoEditRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PhotoEditRequestQuery, PhotoEditRequestQueryVariables>(PhotoEditRequestDocument, options);
      }
export function usePhotoEditRequestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhotoEditRequestQuery, PhotoEditRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PhotoEditRequestQuery, PhotoEditRequestQueryVariables>(PhotoEditRequestDocument, options);
        }
export function usePhotoEditRequestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PhotoEditRequestQuery, PhotoEditRequestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PhotoEditRequestQuery, PhotoEditRequestQueryVariables>(PhotoEditRequestDocument, options);
        }
export type PhotoEditRequestQueryHookResult = ReturnType<typeof usePhotoEditRequestQuery>;
export type PhotoEditRequestLazyQueryHookResult = ReturnType<typeof usePhotoEditRequestLazyQuery>;
export type PhotoEditRequestSuspenseQueryHookResult = ReturnType<typeof usePhotoEditRequestSuspenseQuery>;
export type PhotoEditRequestQueryResult = ApolloReactCommon.QueryResult<PhotoEditRequestQuery, PhotoEditRequestQueryVariables>;
export const PhotoEditRequestsDocument = gql`
    query photoEditRequests($searchString: String, $page: Int!) {
  photoEditRequests(searchString: $searchString, page: $page, resultsPerPage: 20) {
    photoEditRequests {
      id
      editorUserId
      foodItemChangeRequestId
      status
      editedImageUrl
      notes
      foodItemChangeRequest {
        ...ViewChangeRequest
      }
    }
    pagination {
      ...PaginationFields
    }
  }
}
    ${ViewChangeRequestFragmentDoc}
${PaginationFieldsFragmentDoc}`;
export type PhotoEditRequestsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PhotoEditRequestsQuery, PhotoEditRequestsQueryVariables>, 'query'> & ({ variables: PhotoEditRequestsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PhotoEditRequestsComponent = (props: PhotoEditRequestsComponentProps) => (
      <ApolloReactComponents.Query<PhotoEditRequestsQuery, PhotoEditRequestsQueryVariables> query={PhotoEditRequestsDocument} {...props} />
    );
    

/**
 * __usePhotoEditRequestsQuery__
 *
 * To run a query within a React component, call `usePhotoEditRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoEditRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoEditRequestsQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePhotoEditRequestsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PhotoEditRequestsQuery, PhotoEditRequestsQueryVariables> & ({ variables: PhotoEditRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PhotoEditRequestsQuery, PhotoEditRequestsQueryVariables>(PhotoEditRequestsDocument, options);
      }
export function usePhotoEditRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhotoEditRequestsQuery, PhotoEditRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PhotoEditRequestsQuery, PhotoEditRequestsQueryVariables>(PhotoEditRequestsDocument, options);
        }
export function usePhotoEditRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PhotoEditRequestsQuery, PhotoEditRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PhotoEditRequestsQuery, PhotoEditRequestsQueryVariables>(PhotoEditRequestsDocument, options);
        }
export type PhotoEditRequestsQueryHookResult = ReturnType<typeof usePhotoEditRequestsQuery>;
export type PhotoEditRequestsLazyQueryHookResult = ReturnType<typeof usePhotoEditRequestsLazyQuery>;
export type PhotoEditRequestsSuspenseQueryHookResult = ReturnType<typeof usePhotoEditRequestsSuspenseQuery>;
export type PhotoEditRequestsQueryResult = ApolloReactCommon.QueryResult<PhotoEditRequestsQuery, PhotoEditRequestsQueryVariables>;
export const ShefFoodItemsDocument = gql`
    query ShefFoodItems($shefId: String!, $availableOn: String, $page: Int) {
  shefFoodItems(shefId: $shefId, availableOn: $availableOn, page: $page) {
    foodItems {
      ...GenericTableFields
      ...FoodItemTagFields
      ...FoodItemTableFoodItem
      ingredients
    }
    pagination {
      ...PaginationFields
    }
  }
  shefProfile(userId: $shefId) {
    id
    primaryRegion {
      name
      sundayDelivery
      mondayDelivery
      tuesdayDelivery
      wednesdayDelivery
      thursdayDelivery
      fridayDelivery
      saturdayDelivery
    }
  }
}
    ${GenericTableFieldsFragmentDoc}
${FoodItemTagFieldsFragmentDoc}
${FoodItemTableFoodItemFragmentDoc}
${PaginationFieldsFragmentDoc}`;
export type ShefFoodItemsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefFoodItemsQuery, ShefFoodItemsQueryVariables>, 'query'> & ({ variables: ShefFoodItemsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefFoodItemsComponent = (props: ShefFoodItemsComponentProps) => (
      <ApolloReactComponents.Query<ShefFoodItemsQuery, ShefFoodItemsQueryVariables> query={ShefFoodItemsDocument} {...props} />
    );
    

/**
 * __useShefFoodItemsQuery__
 *
 * To run a query within a React component, call `useShefFoodItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefFoodItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefFoodItemsQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      availableOn: // value for 'availableOn'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useShefFoodItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefFoodItemsQuery, ShefFoodItemsQueryVariables> & ({ variables: ShefFoodItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefFoodItemsQuery, ShefFoodItemsQueryVariables>(ShefFoodItemsDocument, options);
      }
export function useShefFoodItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefFoodItemsQuery, ShefFoodItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefFoodItemsQuery, ShefFoodItemsQueryVariables>(ShefFoodItemsDocument, options);
        }
export function useShefFoodItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefFoodItemsQuery, ShefFoodItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefFoodItemsQuery, ShefFoodItemsQueryVariables>(ShefFoodItemsDocument, options);
        }
export type ShefFoodItemsQueryHookResult = ReturnType<typeof useShefFoodItemsQuery>;
export type ShefFoodItemsLazyQueryHookResult = ReturnType<typeof useShefFoodItemsLazyQuery>;
export type ShefFoodItemsSuspenseQueryHookResult = ReturnType<typeof useShefFoodItemsSuspenseQuery>;
export type ShefFoodItemsQueryResult = ApolloReactCommon.QueryResult<ShefFoodItemsQuery, ShefFoodItemsQueryVariables>;
export const ShefRouterDocument = gql`
    query ShefRouter {
  me {
    id
    ...ShefRouterUser
  }
}
    ${ShefRouterUserFragmentDoc}`;
export type ShefRouterComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefRouterQuery, ShefRouterQueryVariables>, 'query'>;

    export const ShefRouterComponent = (props: ShefRouterComponentProps) => (
      <ApolloReactComponents.Query<ShefRouterQuery, ShefRouterQueryVariables> query={ShefRouterDocument} {...props} />
    );
    

/**
 * __useShefRouterQuery__
 *
 * To run a query within a React component, call `useShefRouterQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefRouterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefRouterQuery({
 *   variables: {
 *   },
 * });
 */
export function useShefRouterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShefRouterQuery, ShefRouterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefRouterQuery, ShefRouterQueryVariables>(ShefRouterDocument, options);
      }
export function useShefRouterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefRouterQuery, ShefRouterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefRouterQuery, ShefRouterQueryVariables>(ShefRouterDocument, options);
        }
export function useShefRouterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefRouterQuery, ShefRouterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefRouterQuery, ShefRouterQueryVariables>(ShefRouterDocument, options);
        }
export type ShefRouterQueryHookResult = ReturnType<typeof useShefRouterQuery>;
export type ShefRouterLazyQueryHookResult = ReturnType<typeof useShefRouterLazyQuery>;
export type ShefRouterSuspenseQueryHookResult = ReturnType<typeof useShefRouterSuspenseQuery>;
export type ShefRouterQueryResult = ApolloReactCommon.QueryResult<ShefRouterQuery, ShefRouterQueryVariables>;
export const ViewShefApplication2Document = gql`
    query ViewShefApplication2($userId: String!) {
  shefApplication(userId: $userId) {
    ...ShefApplicationFields
  }
  shefProfile(userId: $userId) {
    ...ShefProfileEditShefProfile
    cuisineCategories {
      ...CuisineCategoryItem
    }
  }
  possibleDeliveryHubsForShef(input: {shefId: $userId}) {
    ...ShefProfileEditDeliveryHubs
  }
  cuisineCategories {
    ...CuisineCategoryItem
  }
}
    ${ShefApplicationFieldsFragmentDoc}
${ShefProfileEditShefProfileFragmentDoc}
${CuisineCategoryItemFragmentDoc}
${ShefProfileEditDeliveryHubsFragmentDoc}`;
export type ViewShefApplication2ComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ViewShefApplication2Query, ViewShefApplication2QueryVariables>, 'query'> & ({ variables: ViewShefApplication2QueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ViewShefApplication2Component = (props: ViewShefApplication2ComponentProps) => (
      <ApolloReactComponents.Query<ViewShefApplication2Query, ViewShefApplication2QueryVariables> query={ViewShefApplication2Document} {...props} />
    );
    

/**
 * __useViewShefApplication2Query__
 *
 * To run a query within a React component, call `useViewShefApplication2Query` and pass it any options that fit your needs.
 * When your component renders, `useViewShefApplication2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewShefApplication2Query({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useViewShefApplication2Query(baseOptions: ApolloReactHooks.QueryHookOptions<ViewShefApplication2Query, ViewShefApplication2QueryVariables> & ({ variables: ViewShefApplication2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewShefApplication2Query, ViewShefApplication2QueryVariables>(ViewShefApplication2Document, options);
      }
export function useViewShefApplication2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewShefApplication2Query, ViewShefApplication2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewShefApplication2Query, ViewShefApplication2QueryVariables>(ViewShefApplication2Document, options);
        }
export function useViewShefApplication2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewShefApplication2Query, ViewShefApplication2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewShefApplication2Query, ViewShefApplication2QueryVariables>(ViewShefApplication2Document, options);
        }
export type ViewShefApplication2QueryHookResult = ReturnType<typeof useViewShefApplication2Query>;
export type ViewShefApplication2LazyQueryHookResult = ReturnType<typeof useViewShefApplication2LazyQuery>;
export type ViewShefApplication2SuspenseQueryHookResult = ReturnType<typeof useViewShefApplication2SuspenseQuery>;
export type ViewShefApplication2QueryResult = ApolloReactCommon.QueryResult<ViewShefApplication2Query, ViewShefApplication2QueryVariables>;
export const ShefApplicationQuestionsCompletedDocument = gql`
    mutation ShefApplicationQuestionsCompleted {
  shefApplicationQuestionsCompleted
}
    `;
export type ShefApplicationQuestionsCompletedMutationFn = ApolloReactCommon.MutationFunction<ShefApplicationQuestionsCompletedMutation, ShefApplicationQuestionsCompletedMutationVariables>;
export type ShefApplicationQuestionsCompletedComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShefApplicationQuestionsCompletedMutation, ShefApplicationQuestionsCompletedMutationVariables>, 'mutation'>;

    export const ShefApplicationQuestionsCompletedComponent = (props: ShefApplicationQuestionsCompletedComponentProps) => (
      <ApolloReactComponents.Mutation<ShefApplicationQuestionsCompletedMutation, ShefApplicationQuestionsCompletedMutationVariables> mutation={ShefApplicationQuestionsCompletedDocument} {...props} />
    );
    

/**
 * __useShefApplicationQuestionsCompletedMutation__
 *
 * To run a mutation, you first call `useShefApplicationQuestionsCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShefApplicationQuestionsCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shefApplicationQuestionsCompletedMutation, { data, loading, error }] = useShefApplicationQuestionsCompletedMutation({
 *   variables: {
 *   },
 * });
 */
export function useShefApplicationQuestionsCompletedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShefApplicationQuestionsCompletedMutation, ShefApplicationQuestionsCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShefApplicationQuestionsCompletedMutation, ShefApplicationQuestionsCompletedMutationVariables>(ShefApplicationQuestionsCompletedDocument, options);
      }
export type ShefApplicationQuestionsCompletedMutationHookResult = ReturnType<typeof useShefApplicationQuestionsCompletedMutation>;
export type ShefApplicationQuestionsCompletedMutationResult = ApolloReactCommon.MutationResult<ShefApplicationQuestionsCompletedMutation>;
export type ShefApplicationQuestionsCompletedMutationOptions = ApolloReactCommon.BaseMutationOptions<ShefApplicationQuestionsCompletedMutation, ShefApplicationQuestionsCompletedMutationVariables>;
export const UpdateShefApplicationDocument = gql`
    mutation UpdateShefApplication($applicationId: Int!, $shefApplicationInput: ShefApplicationInputStep2!) {
  editShefApplication(
    applicationId: $applicationId
    shefApplicationInput: $shefApplicationInput
  )
}
    `;
export type UpdateShefApplicationMutationFn = ApolloReactCommon.MutationFunction<UpdateShefApplicationMutation, UpdateShefApplicationMutationVariables>;
export type UpdateShefApplicationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateShefApplicationMutation, UpdateShefApplicationMutationVariables>, 'mutation'>;

    export const UpdateShefApplicationComponent = (props: UpdateShefApplicationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateShefApplicationMutation, UpdateShefApplicationMutationVariables> mutation={UpdateShefApplicationDocument} {...props} />
    );
    

/**
 * __useUpdateShefApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateShefApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShefApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShefApplicationMutation, { data, loading, error }] = useUpdateShefApplicationMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      shefApplicationInput: // value for 'shefApplicationInput'
 *   },
 * });
 */
export function useUpdateShefApplicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShefApplicationMutation, UpdateShefApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateShefApplicationMutation, UpdateShefApplicationMutationVariables>(UpdateShefApplicationDocument, options);
      }
export type UpdateShefApplicationMutationHookResult = ReturnType<typeof useUpdateShefApplicationMutation>;
export type UpdateShefApplicationMutationResult = ApolloReactCommon.MutationResult<UpdateShefApplicationMutation>;
export type UpdateShefApplicationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateShefApplicationMutation, UpdateShefApplicationMutationVariables>;
export const UpdateShefApplicationCompleteInformationSessionDocument = gql`
    mutation UpdateShefApplicationCompleteInformationSession($applicationId: Int!) {
  editShefApplicationCompleteInformationSession(applicationId: $applicationId)
}
    `;
export type UpdateShefApplicationCompleteInformationSessionMutationFn = ApolloReactCommon.MutationFunction<UpdateShefApplicationCompleteInformationSessionMutation, UpdateShefApplicationCompleteInformationSessionMutationVariables>;
export type UpdateShefApplicationCompleteInformationSessionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateShefApplicationCompleteInformationSessionMutation, UpdateShefApplicationCompleteInformationSessionMutationVariables>, 'mutation'>;

    export const UpdateShefApplicationCompleteInformationSessionComponent = (props: UpdateShefApplicationCompleteInformationSessionComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateShefApplicationCompleteInformationSessionMutation, UpdateShefApplicationCompleteInformationSessionMutationVariables> mutation={UpdateShefApplicationCompleteInformationSessionDocument} {...props} />
    );
    

/**
 * __useUpdateShefApplicationCompleteInformationSessionMutation__
 *
 * To run a mutation, you first call `useUpdateShefApplicationCompleteInformationSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShefApplicationCompleteInformationSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShefApplicationCompleteInformationSessionMutation, { data, loading, error }] = useUpdateShefApplicationCompleteInformationSessionMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useUpdateShefApplicationCompleteInformationSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShefApplicationCompleteInformationSessionMutation, UpdateShefApplicationCompleteInformationSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateShefApplicationCompleteInformationSessionMutation, UpdateShefApplicationCompleteInformationSessionMutationVariables>(UpdateShefApplicationCompleteInformationSessionDocument, options);
      }
export type UpdateShefApplicationCompleteInformationSessionMutationHookResult = ReturnType<typeof useUpdateShefApplicationCompleteInformationSessionMutation>;
export type UpdateShefApplicationCompleteInformationSessionMutationResult = ApolloReactCommon.MutationResult<UpdateShefApplicationCompleteInformationSessionMutation>;
export type UpdateShefApplicationCompleteInformationSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateShefApplicationCompleteInformationSessionMutation, UpdateShefApplicationCompleteInformationSessionMutationVariables>;
export const UpdateShefApplicationCancelOrientationCallDocument = gql`
    mutation UpdateShefApplicationCancelOrientationCall($applicationId: Int!) {
  editShefApplicationCancelOrientationCall(applicationId: $applicationId)
}
    `;
export type UpdateShefApplicationCancelOrientationCallMutationFn = ApolloReactCommon.MutationFunction<UpdateShefApplicationCancelOrientationCallMutation, UpdateShefApplicationCancelOrientationCallMutationVariables>;
export type UpdateShefApplicationCancelOrientationCallComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateShefApplicationCancelOrientationCallMutation, UpdateShefApplicationCancelOrientationCallMutationVariables>, 'mutation'>;

    export const UpdateShefApplicationCancelOrientationCallComponent = (props: UpdateShefApplicationCancelOrientationCallComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateShefApplicationCancelOrientationCallMutation, UpdateShefApplicationCancelOrientationCallMutationVariables> mutation={UpdateShefApplicationCancelOrientationCallDocument} {...props} />
    );
    

/**
 * __useUpdateShefApplicationCancelOrientationCallMutation__
 *
 * To run a mutation, you first call `useUpdateShefApplicationCancelOrientationCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShefApplicationCancelOrientationCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShefApplicationCancelOrientationCallMutation, { data, loading, error }] = useUpdateShefApplicationCancelOrientationCallMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useUpdateShefApplicationCancelOrientationCallMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShefApplicationCancelOrientationCallMutation, UpdateShefApplicationCancelOrientationCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateShefApplicationCancelOrientationCallMutation, UpdateShefApplicationCancelOrientationCallMutationVariables>(UpdateShefApplicationCancelOrientationCallDocument, options);
      }
export type UpdateShefApplicationCancelOrientationCallMutationHookResult = ReturnType<typeof useUpdateShefApplicationCancelOrientationCallMutation>;
export type UpdateShefApplicationCancelOrientationCallMutationResult = ApolloReactCommon.MutationResult<UpdateShefApplicationCancelOrientationCallMutation>;
export type UpdateShefApplicationCancelOrientationCallMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateShefApplicationCancelOrientationCallMutation, UpdateShefApplicationCancelOrientationCallMutationVariables>;
export const AddShefApplicationDocument = gql`
    mutation AddShefApplication($shefApplicationInput: ShefApplicationInput!, $promoCode: String) {
  addShefApplication(
    shefApplicationInput: $shefApplicationInput
    promoCode: $promoCode
  ) {
    user {
      ...CurrentUserFields
    }
    token
    isExistingUser
  }
}
    ${CurrentUserFieldsFragmentDoc}`;
export type AddShefApplicationMutationFn = ApolloReactCommon.MutationFunction<AddShefApplicationMutation, AddShefApplicationMutationVariables>;
export type AddShefApplicationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddShefApplicationMutation, AddShefApplicationMutationVariables>, 'mutation'>;

    export const AddShefApplicationComponent = (props: AddShefApplicationComponentProps) => (
      <ApolloReactComponents.Mutation<AddShefApplicationMutation, AddShefApplicationMutationVariables> mutation={AddShefApplicationDocument} {...props} />
    );
    

/**
 * __useAddShefApplicationMutation__
 *
 * To run a mutation, you first call `useAddShefApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShefApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShefApplicationMutation, { data, loading, error }] = useAddShefApplicationMutation({
 *   variables: {
 *      shefApplicationInput: // value for 'shefApplicationInput'
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useAddShefApplicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddShefApplicationMutation, AddShefApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddShefApplicationMutation, AddShefApplicationMutationVariables>(AddShefApplicationDocument, options);
      }
export type AddShefApplicationMutationHookResult = ReturnType<typeof useAddShefApplicationMutation>;
export type AddShefApplicationMutationResult = ApolloReactCommon.MutationResult<AddShefApplicationMutation>;
export type AddShefApplicationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddShefApplicationMutation, AddShefApplicationMutationVariables>;
export const BecomeAShefGetApplicationDocument = gql`
    query BecomeAShefGetApplication($userId: String!) {
  shefApplication(userId: $userId) {
    ...ShefApplicationFields
  }
}
    ${ShefApplicationFieldsFragmentDoc}`;
export type BecomeAShefGetApplicationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BecomeAShefGetApplicationQuery, BecomeAShefGetApplicationQueryVariables>, 'query'> & ({ variables: BecomeAShefGetApplicationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BecomeAShefGetApplicationComponent = (props: BecomeAShefGetApplicationComponentProps) => (
      <ApolloReactComponents.Query<BecomeAShefGetApplicationQuery, BecomeAShefGetApplicationQueryVariables> query={BecomeAShefGetApplicationDocument} {...props} />
    );
    

/**
 * __useBecomeAShefGetApplicationQuery__
 *
 * To run a query within a React component, call `useBecomeAShefGetApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBecomeAShefGetApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBecomeAShefGetApplicationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBecomeAShefGetApplicationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BecomeAShefGetApplicationQuery, BecomeAShefGetApplicationQueryVariables> & ({ variables: BecomeAShefGetApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BecomeAShefGetApplicationQuery, BecomeAShefGetApplicationQueryVariables>(BecomeAShefGetApplicationDocument, options);
      }
export function useBecomeAShefGetApplicationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BecomeAShefGetApplicationQuery, BecomeAShefGetApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BecomeAShefGetApplicationQuery, BecomeAShefGetApplicationQueryVariables>(BecomeAShefGetApplicationDocument, options);
        }
export function useBecomeAShefGetApplicationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BecomeAShefGetApplicationQuery, BecomeAShefGetApplicationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BecomeAShefGetApplicationQuery, BecomeAShefGetApplicationQueryVariables>(BecomeAShefGetApplicationDocument, options);
        }
export type BecomeAShefGetApplicationQueryHookResult = ReturnType<typeof useBecomeAShefGetApplicationQuery>;
export type BecomeAShefGetApplicationLazyQueryHookResult = ReturnType<typeof useBecomeAShefGetApplicationLazyQuery>;
export type BecomeAShefGetApplicationSuspenseQueryHookResult = ReturnType<typeof useBecomeAShefGetApplicationSuspenseQuery>;
export type BecomeAShefGetApplicationQueryResult = ApolloReactCommon.QueryResult<BecomeAShefGetApplicationQuery, BecomeAShefGetApplicationQueryVariables>;
export const AddBecomeAShefPhoneNumberDocument = gql`
    mutation AddBecomeAShefPhoneNumber($phoneNumber: String!) {
  addBecomeAShefPhoneNumber(phoneNumber: $phoneNumber)
}
    `;
export type AddBecomeAShefPhoneNumberMutationFn = ApolloReactCommon.MutationFunction<AddBecomeAShefPhoneNumberMutation, AddBecomeAShefPhoneNumberMutationVariables>;
export type AddBecomeAShefPhoneNumberComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddBecomeAShefPhoneNumberMutation, AddBecomeAShefPhoneNumberMutationVariables>, 'mutation'>;

    export const AddBecomeAShefPhoneNumberComponent = (props: AddBecomeAShefPhoneNumberComponentProps) => (
      <ApolloReactComponents.Mutation<AddBecomeAShefPhoneNumberMutation, AddBecomeAShefPhoneNumberMutationVariables> mutation={AddBecomeAShefPhoneNumberDocument} {...props} />
    );
    

/**
 * __useAddBecomeAShefPhoneNumberMutation__
 *
 * To run a mutation, you first call `useAddBecomeAShefPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBecomeAShefPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBecomeAShefPhoneNumberMutation, { data, loading, error }] = useAddBecomeAShefPhoneNumberMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useAddBecomeAShefPhoneNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddBecomeAShefPhoneNumberMutation, AddBecomeAShefPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddBecomeAShefPhoneNumberMutation, AddBecomeAShefPhoneNumberMutationVariables>(AddBecomeAShefPhoneNumberDocument, options);
      }
export type AddBecomeAShefPhoneNumberMutationHookResult = ReturnType<typeof useAddBecomeAShefPhoneNumberMutation>;
export type AddBecomeAShefPhoneNumberMutationResult = ApolloReactCommon.MutationResult<AddBecomeAShefPhoneNumberMutation>;
export type AddBecomeAShefPhoneNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<AddBecomeAShefPhoneNumberMutation, AddBecomeAShefPhoneNumberMutationVariables>;
export const ShefHeaderQueryDocument = gql`
    query ShefHeaderQuery($shefId: String!, $dateFrom: String!) {
  shefProfile(userId: $shefId) {
    shefAddressId
    fulfillmentOption
    primaryRegion {
      ...ShefProfileFulfillmentFlags
    }
  }
  shefAvailability(shefId: $shefId, dateFrom: $dateFrom, limit: 1) {
    id
    availabilityDate
    numOrdersPlaced
  }
}
    ${ShefProfileFulfillmentFlagsFragmentDoc}`;
export type ShefHeaderQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefHeaderQueryQuery, ShefHeaderQueryQueryVariables>, 'query'> & ({ variables: ShefHeaderQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefHeaderQueryComponent = (props: ShefHeaderQueryComponentProps) => (
      <ApolloReactComponents.Query<ShefHeaderQueryQuery, ShefHeaderQueryQueryVariables> query={ShefHeaderQueryDocument} {...props} />
    );
    

/**
 * __useShefHeaderQueryQuery__
 *
 * To run a query within a React component, call `useShefHeaderQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefHeaderQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefHeaderQueryQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      dateFrom: // value for 'dateFrom'
 *   },
 * });
 */
export function useShefHeaderQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefHeaderQueryQuery, ShefHeaderQueryQueryVariables> & ({ variables: ShefHeaderQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefHeaderQueryQuery, ShefHeaderQueryQueryVariables>(ShefHeaderQueryDocument, options);
      }
export function useShefHeaderQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefHeaderQueryQuery, ShefHeaderQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefHeaderQueryQuery, ShefHeaderQueryQueryVariables>(ShefHeaderQueryDocument, options);
        }
export function useShefHeaderQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefHeaderQueryQuery, ShefHeaderQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefHeaderQueryQuery, ShefHeaderQueryQueryVariables>(ShefHeaderQueryDocument, options);
        }
export type ShefHeaderQueryQueryHookResult = ReturnType<typeof useShefHeaderQueryQuery>;
export type ShefHeaderQueryLazyQueryHookResult = ReturnType<typeof useShefHeaderQueryLazyQuery>;
export type ShefHeaderQuerySuspenseQueryHookResult = ReturnType<typeof useShefHeaderQuerySuspenseQuery>;
export type ShefHeaderQueryQueryResult = ApolloReactCommon.QueryResult<ShefHeaderQueryQuery, ShefHeaderQueryQueryVariables>;
export const ShefNavQueryDocument = gql`
    query ShefNavQuery($userId: String!) {
  shefApplication(userId: $userId) {
    ...ShefApplicationFields
  }
  shefProfile(userId: $userId) {
    ...ShefProfileEditShefProfile
  }
  shefFoodItems(shefId: $userId) {
    foodItems {
      id
      name
      hasUnreadComments
    }
  }
  isShefRatingEnabled: isFeatureOn(name: SHEF_RATING)
}
    ${ShefApplicationFieldsFragmentDoc}
${ShefProfileEditShefProfileFragmentDoc}`;
export type ShefNavQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefNavQueryQuery, ShefNavQueryQueryVariables>, 'query'> & ({ variables: ShefNavQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefNavQueryComponent = (props: ShefNavQueryComponentProps) => (
      <ApolloReactComponents.Query<ShefNavQueryQuery, ShefNavQueryQueryVariables> query={ShefNavQueryDocument} {...props} />
    );
    

/**
 * __useShefNavQueryQuery__
 *
 * To run a query within a React component, call `useShefNavQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefNavQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefNavQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useShefNavQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefNavQueryQuery, ShefNavQueryQueryVariables> & ({ variables: ShefNavQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefNavQueryQuery, ShefNavQueryQueryVariables>(ShefNavQueryDocument, options);
      }
export function useShefNavQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefNavQueryQuery, ShefNavQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefNavQueryQuery, ShefNavQueryQueryVariables>(ShefNavQueryDocument, options);
        }
export function useShefNavQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefNavQueryQuery, ShefNavQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefNavQueryQuery, ShefNavQueryQueryVariables>(ShefNavQueryDocument, options);
        }
export type ShefNavQueryQueryHookResult = ReturnType<typeof useShefNavQueryQuery>;
export type ShefNavQueryLazyQueryHookResult = ReturnType<typeof useShefNavQueryLazyQuery>;
export type ShefNavQuerySuspenseQueryHookResult = ReturnType<typeof useShefNavQuerySuspenseQuery>;
export type ShefNavQueryQueryResult = ApolloReactCommon.QueryResult<ShefNavQueryQuery, ShefNavQueryQueryVariables>;
export const ShefPlatformUsageQuestionnaireDocument = gql`
    query ShefPlatformUsageQuestionnaire($shefId: String!) {
  shefProfile(userId: $shefId) {
    id
    platformNewDesiredEarnings
    platformNewUsage
    platformRecommendationScore
    platformNewFormAnsweredAt
    approvedAt
  }
}
    `;
export type ShefPlatformUsageQuestionnaireComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefPlatformUsageQuestionnaireQuery, ShefPlatformUsageQuestionnaireQueryVariables>, 'query'> & ({ variables: ShefPlatformUsageQuestionnaireQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefPlatformUsageQuestionnaireComponent = (props: ShefPlatformUsageQuestionnaireComponentProps) => (
      <ApolloReactComponents.Query<ShefPlatformUsageQuestionnaireQuery, ShefPlatformUsageQuestionnaireQueryVariables> query={ShefPlatformUsageQuestionnaireDocument} {...props} />
    );
    

/**
 * __useShefPlatformUsageQuestionnaireQuery__
 *
 * To run a query within a React component, call `useShefPlatformUsageQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefPlatformUsageQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefPlatformUsageQuestionnaireQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useShefPlatformUsageQuestionnaireQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefPlatformUsageQuestionnaireQuery, ShefPlatformUsageQuestionnaireQueryVariables> & ({ variables: ShefPlatformUsageQuestionnaireQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefPlatformUsageQuestionnaireQuery, ShefPlatformUsageQuestionnaireQueryVariables>(ShefPlatformUsageQuestionnaireDocument, options);
      }
export function useShefPlatformUsageQuestionnaireLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefPlatformUsageQuestionnaireQuery, ShefPlatformUsageQuestionnaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefPlatformUsageQuestionnaireQuery, ShefPlatformUsageQuestionnaireQueryVariables>(ShefPlatformUsageQuestionnaireDocument, options);
        }
export function useShefPlatformUsageQuestionnaireSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefPlatformUsageQuestionnaireQuery, ShefPlatformUsageQuestionnaireQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefPlatformUsageQuestionnaireQuery, ShefPlatformUsageQuestionnaireQueryVariables>(ShefPlatformUsageQuestionnaireDocument, options);
        }
export type ShefPlatformUsageQuestionnaireQueryHookResult = ReturnType<typeof useShefPlatformUsageQuestionnaireQuery>;
export type ShefPlatformUsageQuestionnaireLazyQueryHookResult = ReturnType<typeof useShefPlatformUsageQuestionnaireLazyQuery>;
export type ShefPlatformUsageQuestionnaireSuspenseQueryHookResult = ReturnType<typeof useShefPlatformUsageQuestionnaireSuspenseQuery>;
export type ShefPlatformUsageQuestionnaireQueryResult = ApolloReactCommon.QueryResult<ShefPlatformUsageQuestionnaireQuery, ShefPlatformUsageQuestionnaireQueryVariables>;
export const AnswerShefPlatformUsageQuestionnaireDocument = gql`
    mutation AnswerShefPlatformUsageQuestionnaire($shefProfileId: Int!, $platformUsage: ShefPlatformUsage!, $platformDesiredEarnings: ShefPlatformNewDesiredEarnings!, $platformRecommendationScore: Int!) {
  modifyShefProfile(
    shefProfileInput: {id: $shefProfileId, platformNewUsage: $platformUsage, platformNewDesiredEarnings: $platformDesiredEarnings, platformRecommendationScore: $platformRecommendationScore}
  ) {
    id
    platformNewFormAnsweredAt
  }
}
    `;
export type AnswerShefPlatformUsageQuestionnaireMutationFn = ApolloReactCommon.MutationFunction<AnswerShefPlatformUsageQuestionnaireMutation, AnswerShefPlatformUsageQuestionnaireMutationVariables>;
export type AnswerShefPlatformUsageQuestionnaireComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AnswerShefPlatformUsageQuestionnaireMutation, AnswerShefPlatformUsageQuestionnaireMutationVariables>, 'mutation'>;

    export const AnswerShefPlatformUsageQuestionnaireComponent = (props: AnswerShefPlatformUsageQuestionnaireComponentProps) => (
      <ApolloReactComponents.Mutation<AnswerShefPlatformUsageQuestionnaireMutation, AnswerShefPlatformUsageQuestionnaireMutationVariables> mutation={AnswerShefPlatformUsageQuestionnaireDocument} {...props} />
    );
    

/**
 * __useAnswerShefPlatformUsageQuestionnaireMutation__
 *
 * To run a mutation, you first call `useAnswerShefPlatformUsageQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerShefPlatformUsageQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerShefPlatformUsageQuestionnaireMutation, { data, loading, error }] = useAnswerShefPlatformUsageQuestionnaireMutation({
 *   variables: {
 *      shefProfileId: // value for 'shefProfileId'
 *      platformUsage: // value for 'platformUsage'
 *      platformDesiredEarnings: // value for 'platformDesiredEarnings'
 *      platformRecommendationScore: // value for 'platformRecommendationScore'
 *   },
 * });
 */
export function useAnswerShefPlatformUsageQuestionnaireMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerShefPlatformUsageQuestionnaireMutation, AnswerShefPlatformUsageQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerShefPlatformUsageQuestionnaireMutation, AnswerShefPlatformUsageQuestionnaireMutationVariables>(AnswerShefPlatformUsageQuestionnaireDocument, options);
      }
export type AnswerShefPlatformUsageQuestionnaireMutationHookResult = ReturnType<typeof useAnswerShefPlatformUsageQuestionnaireMutation>;
export type AnswerShefPlatformUsageQuestionnaireMutationResult = ApolloReactCommon.MutationResult<AnswerShefPlatformUsageQuestionnaireMutation>;
export type AnswerShefPlatformUsageQuestionnaireMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerShefPlatformUsageQuestionnaireMutation, AnswerShefPlatformUsageQuestionnaireMutationVariables>;
export const ShefTrackerDocument = gql`
    query ShefTracker($userId: String!) {
  shefApplicationTracker(userId: $userId) {
    ...ShefApplicationTrackerFields
  }
}
    ${ShefApplicationTrackerFieldsFragmentDoc}`;
export type ShefTrackerComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefTrackerQuery, ShefTrackerQueryVariables>, 'query'> & ({ variables: ShefTrackerQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefTrackerComponent = (props: ShefTrackerComponentProps) => (
      <ApolloReactComponents.Query<ShefTrackerQuery, ShefTrackerQueryVariables> query={ShefTrackerDocument} {...props} />
    );
    

/**
 * __useShefTrackerQuery__
 *
 * To run a query within a React component, call `useShefTrackerQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefTrackerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefTrackerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useShefTrackerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefTrackerQuery, ShefTrackerQueryVariables> & ({ variables: ShefTrackerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefTrackerQuery, ShefTrackerQueryVariables>(ShefTrackerDocument, options);
      }
export function useShefTrackerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefTrackerQuery, ShefTrackerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefTrackerQuery, ShefTrackerQueryVariables>(ShefTrackerDocument, options);
        }
export function useShefTrackerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefTrackerQuery, ShefTrackerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefTrackerQuery, ShefTrackerQueryVariables>(ShefTrackerDocument, options);
        }
export type ShefTrackerQueryHookResult = ReturnType<typeof useShefTrackerQuery>;
export type ShefTrackerLazyQueryHookResult = ReturnType<typeof useShefTrackerLazyQuery>;
export type ShefTrackerSuspenseQueryHookResult = ReturnType<typeof useShefTrackerSuspenseQuery>;
export type ShefTrackerQueryResult = ApolloReactCommon.QueryResult<ShefTrackerQuery, ShefTrackerQueryVariables>;
export const GetStripeIdDocument = gql`
    query GetStripeId {
  stripeId
}
    `;
export type GetStripeIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetStripeIdQuery, GetStripeIdQueryVariables>, 'query'>;

    export const GetStripeIdComponent = (props: GetStripeIdComponentProps) => (
      <ApolloReactComponents.Query<GetStripeIdQuery, GetStripeIdQueryVariables> query={GetStripeIdDocument} {...props} />
    );
    

/**
 * __useGetStripeIdQuery__
 *
 * To run a query within a React component, call `useGetStripeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStripeIdQuery, GetStripeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStripeIdQuery, GetStripeIdQueryVariables>(GetStripeIdDocument, options);
      }
export function useGetStripeIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStripeIdQuery, GetStripeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStripeIdQuery, GetStripeIdQueryVariables>(GetStripeIdDocument, options);
        }
export function useGetStripeIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStripeIdQuery, GetStripeIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStripeIdQuery, GetStripeIdQueryVariables>(GetStripeIdDocument, options);
        }
export type GetStripeIdQueryHookResult = ReturnType<typeof useGetStripeIdQuery>;
export type GetStripeIdLazyQueryHookResult = ReturnType<typeof useGetStripeIdLazyQuery>;
export type GetStripeIdSuspenseQueryHookResult = ReturnType<typeof useGetStripeIdSuspenseQuery>;
export type GetStripeIdQueryResult = ApolloReactCommon.QueryResult<GetStripeIdQuery, GetStripeIdQueryVariables>;
export const StripeConnectMutationDocument = gql`
    mutation StripeConnectMutation($code: String!, $userId: String!, $stripeAccountType: StripeAccountType!) {
  createStripeConnect(
    code: $code
    userId: $userId
    stripeAccountType: $stripeAccountType
  ) {
    id
  }
}
    `;
export type StripeConnectMutationMutationFn = ApolloReactCommon.MutationFunction<StripeConnectMutationMutation, StripeConnectMutationMutationVariables>;
export type StripeConnectMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<StripeConnectMutationMutation, StripeConnectMutationMutationVariables>, 'mutation'>;

    export const StripeConnectMutationComponent = (props: StripeConnectMutationComponentProps) => (
      <ApolloReactComponents.Mutation<StripeConnectMutationMutation, StripeConnectMutationMutationVariables> mutation={StripeConnectMutationDocument} {...props} />
    );
    

/**
 * __useStripeConnectMutationMutation__
 *
 * To run a mutation, you first call `useStripeConnectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeConnectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeConnectMutationMutation, { data, loading, error }] = useStripeConnectMutationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      userId: // value for 'userId'
 *      stripeAccountType: // value for 'stripeAccountType'
 *   },
 * });
 */
export function useStripeConnectMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StripeConnectMutationMutation, StripeConnectMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StripeConnectMutationMutation, StripeConnectMutationMutationVariables>(StripeConnectMutationDocument, options);
      }
export type StripeConnectMutationMutationHookResult = ReturnType<typeof useStripeConnectMutationMutation>;
export type StripeConnectMutationMutationResult = ApolloReactCommon.MutationResult<StripeConnectMutationMutation>;
export type StripeConnectMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<StripeConnectMutationMutation, StripeConnectMutationMutationVariables>;
export const ShefPlatformPercentDocument = gql`
    query ShefPlatformPercent($shefId: String!) {
  shef(userId: $shefId) {
    shefProfile {
      platformPercent
    }
  }
}
    `;
export type ShefPlatformPercentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefPlatformPercentQuery, ShefPlatformPercentQueryVariables>, 'query'> & ({ variables: ShefPlatformPercentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefPlatformPercentComponent = (props: ShefPlatformPercentComponentProps) => (
      <ApolloReactComponents.Query<ShefPlatformPercentQuery, ShefPlatformPercentQueryVariables> query={ShefPlatformPercentDocument} {...props} />
    );
    

/**
 * __useShefPlatformPercentQuery__
 *
 * To run a query within a React component, call `useShefPlatformPercentQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefPlatformPercentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefPlatformPercentQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useShefPlatformPercentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefPlatformPercentQuery, ShefPlatformPercentQueryVariables> & ({ variables: ShefPlatformPercentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefPlatformPercentQuery, ShefPlatformPercentQueryVariables>(ShefPlatformPercentDocument, options);
      }
export function useShefPlatformPercentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefPlatformPercentQuery, ShefPlatformPercentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefPlatformPercentQuery, ShefPlatformPercentQueryVariables>(ShefPlatformPercentDocument, options);
        }
export function useShefPlatformPercentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefPlatformPercentQuery, ShefPlatformPercentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefPlatformPercentQuery, ShefPlatformPercentQueryVariables>(ShefPlatformPercentDocument, options);
        }
export type ShefPlatformPercentQueryHookResult = ReturnType<typeof useShefPlatformPercentQuery>;
export type ShefPlatformPercentLazyQueryHookResult = ReturnType<typeof useShefPlatformPercentLazyQuery>;
export type ShefPlatformPercentSuspenseQueryHookResult = ReturnType<typeof useShefPlatformPercentSuspenseQuery>;
export type ShefPlatformPercentQueryResult = ApolloReactCommon.QueryResult<ShefPlatformPercentQuery, ShefPlatformPercentQueryVariables>;
export const ShefSelfPromotionPageDocument = gql`
    query ShefSelfPromotionPage($shefId: String!) {
  shef(userId: $shefId) {
    id
    shefProfile {
      id
      bio
      timeZone
    }
    activeFoodItems {
      ...ShefSelfPromotionPageFoodItem
    }
  }
  me {
    id
    promoCodes {
      pagination {
        page
        pageCount
        resultsPerPage
      }
      promoCodes {
        ...ShefPromoCode
      }
    }
    referralCode {
      id
      code
    }
  }
  promoCodeCreationEnabled: isFeatureOn(name: SHEF_PROMO_CODE_CREATION)
}
    ${ShefSelfPromotionPageFoodItemFragmentDoc}
${ShefPromoCodeFragmentDoc}`;
export type ShefSelfPromotionPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefSelfPromotionPageQuery, ShefSelfPromotionPageQueryVariables>, 'query'> & ({ variables: ShefSelfPromotionPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefSelfPromotionPageComponent = (props: ShefSelfPromotionPageComponentProps) => (
      <ApolloReactComponents.Query<ShefSelfPromotionPageQuery, ShefSelfPromotionPageQueryVariables> query={ShefSelfPromotionPageDocument} {...props} />
    );
    

/**
 * __useShefSelfPromotionPageQuery__
 *
 * To run a query within a React component, call `useShefSelfPromotionPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefSelfPromotionPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefSelfPromotionPageQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useShefSelfPromotionPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefSelfPromotionPageQuery, ShefSelfPromotionPageQueryVariables> & ({ variables: ShefSelfPromotionPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefSelfPromotionPageQuery, ShefSelfPromotionPageQueryVariables>(ShefSelfPromotionPageDocument, options);
      }
export function useShefSelfPromotionPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefSelfPromotionPageQuery, ShefSelfPromotionPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefSelfPromotionPageQuery, ShefSelfPromotionPageQueryVariables>(ShefSelfPromotionPageDocument, options);
        }
export function useShefSelfPromotionPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefSelfPromotionPageQuery, ShefSelfPromotionPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefSelfPromotionPageQuery, ShefSelfPromotionPageQueryVariables>(ShefSelfPromotionPageDocument, options);
        }
export type ShefSelfPromotionPageQueryHookResult = ReturnType<typeof useShefSelfPromotionPageQuery>;
export type ShefSelfPromotionPageLazyQueryHookResult = ReturnType<typeof useShefSelfPromotionPageLazyQuery>;
export type ShefSelfPromotionPageSuspenseQueryHookResult = ReturnType<typeof useShefSelfPromotionPageSuspenseQuery>;
export type ShefSelfPromotionPageQueryResult = ApolloReactCommon.QueryResult<ShefSelfPromotionPageQuery, ShefSelfPromotionPageQueryVariables>;
export const ShefS2CCodeDocument = gql`
    query ShefS2CCode {
  s2cCodeValue: getConfigValue(name: S2C_CODE_VALUE)
  s2cCodeUsesPerUser: getConfigValue(name: S2C_CODE_USES_PER_USER)
  s2cGetReward: getConfigValue(name: S2C_REWARD_VALUE)
}
    `;
export type ShefS2CCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefS2CCodeQuery, ShefS2CCodeQueryVariables>, 'query'>;

    export const ShefS2CCodeComponent = (props: ShefS2CCodeComponentProps) => (
      <ApolloReactComponents.Query<ShefS2CCodeQuery, ShefS2CCodeQueryVariables> query={ShefS2CCodeDocument} {...props} />
    );
    

/**
 * __useShefS2CCodeQuery__
 *
 * To run a query within a React component, call `useShefS2CCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefS2CCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefS2CCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useShefS2CCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShefS2CCodeQuery, ShefS2CCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefS2CCodeQuery, ShefS2CCodeQueryVariables>(ShefS2CCodeDocument, options);
      }
export function useShefS2CCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefS2CCodeQuery, ShefS2CCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefS2CCodeQuery, ShefS2CCodeQueryVariables>(ShefS2CCodeDocument, options);
        }
export function useShefS2CCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefS2CCodeQuery, ShefS2CCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefS2CCodeQuery, ShefS2CCodeQueryVariables>(ShefS2CCodeDocument, options);
        }
export type ShefS2CCodeQueryHookResult = ReturnType<typeof useShefS2CCodeQuery>;
export type ShefS2CCodeLazyQueryHookResult = ReturnType<typeof useShefS2CCodeLazyQuery>;
export type ShefS2CCodeSuspenseQueryHookResult = ReturnType<typeof useShefS2CCodeSuspenseQuery>;
export type ShefS2CCodeQueryResult = ApolloReactCommon.QueryResult<ShefS2CCodeQuery, ShefS2CCodeQueryVariables>;
export const ShefCreatePromoCodeDocument = gql`
    mutation ShefCreatePromoCode($promoCodeInput: ShefPromoCodeInput!) {
  addShefPromoCode(promoCodeInput: $promoCodeInput) {
    ...ShefPromoCode
  }
}
    ${ShefPromoCodeFragmentDoc}`;
export type ShefCreatePromoCodeMutationFn = ApolloReactCommon.MutationFunction<ShefCreatePromoCodeMutation, ShefCreatePromoCodeMutationVariables>;
export type ShefCreatePromoCodeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ShefCreatePromoCodeMutation, ShefCreatePromoCodeMutationVariables>, 'mutation'>;

    export const ShefCreatePromoCodeComponent = (props: ShefCreatePromoCodeComponentProps) => (
      <ApolloReactComponents.Mutation<ShefCreatePromoCodeMutation, ShefCreatePromoCodeMutationVariables> mutation={ShefCreatePromoCodeDocument} {...props} />
    );
    

/**
 * __useShefCreatePromoCodeMutation__
 *
 * To run a mutation, you first call `useShefCreatePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShefCreatePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shefCreatePromoCodeMutation, { data, loading, error }] = useShefCreatePromoCodeMutation({
 *   variables: {
 *      promoCodeInput: // value for 'promoCodeInput'
 *   },
 * });
 */
export function useShefCreatePromoCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShefCreatePromoCodeMutation, ShefCreatePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShefCreatePromoCodeMutation, ShefCreatePromoCodeMutationVariables>(ShefCreatePromoCodeDocument, options);
      }
export type ShefCreatePromoCodeMutationHookResult = ReturnType<typeof useShefCreatePromoCodeMutation>;
export type ShefCreatePromoCodeMutationResult = ApolloReactCommon.MutationResult<ShefCreatePromoCodeMutation>;
export type ShefCreatePromoCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<ShefCreatePromoCodeMutation, ShefCreatePromoCodeMutationVariables>;
export const ShefInsightsPageDocument = gql`
    query ShefInsightsPage {
  getShefInsightsDashboardUrl
}
    `;
export type ShefInsightsPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefInsightsPageQuery, ShefInsightsPageQueryVariables>, 'query'>;

    export const ShefInsightsPageComponent = (props: ShefInsightsPageComponentProps) => (
      <ApolloReactComponents.Query<ShefInsightsPageQuery, ShefInsightsPageQueryVariables> query={ShefInsightsPageDocument} {...props} />
    );
    

/**
 * __useShefInsightsPageQuery__
 *
 * To run a query within a React component, call `useShefInsightsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefInsightsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefInsightsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useShefInsightsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShefInsightsPageQuery, ShefInsightsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefInsightsPageQuery, ShefInsightsPageQueryVariables>(ShefInsightsPageDocument, options);
      }
export function useShefInsightsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefInsightsPageQuery, ShefInsightsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefInsightsPageQuery, ShefInsightsPageQueryVariables>(ShefInsightsPageDocument, options);
        }
export function useShefInsightsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefInsightsPageQuery, ShefInsightsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefInsightsPageQuery, ShefInsightsPageQueryVariables>(ShefInsightsPageDocument, options);
        }
export type ShefInsightsPageQueryHookResult = ReturnType<typeof useShefInsightsPageQuery>;
export type ShefInsightsPageLazyQueryHookResult = ReturnType<typeof useShefInsightsPageLazyQuery>;
export type ShefInsightsPageSuspenseQueryHookResult = ReturnType<typeof useShefInsightsPageSuspenseQuery>;
export type ShefInsightsPageQueryResult = ApolloReactCommon.QueryResult<ShefInsightsPageQuery, ShefInsightsPageQueryVariables>;
export const ShefOrdersQueryDocument = gql`
    query ShefOrdersQuery($shefId: String!, $dateFrom: String!, $dateTo: String!) {
  shefProfile(userId: $shefId) {
    timeZone
    id
  }
  orders(shefId: $shefId, dateFrom: $dateFrom, dateTo: $dateTo) {
    orders {
      deliveryDate
      fulfillmentDate
      subtotal
      addOnItemsTotal
      refundType
      shefPayment
      reversedShefPaymentAmount
      orderStatus
    }
  }
}
    `;
export type ShefOrdersQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefOrdersQueryQuery, ShefOrdersQueryQueryVariables>, 'query'> & ({ variables: ShefOrdersQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefOrdersQueryComponent = (props: ShefOrdersQueryComponentProps) => (
      <ApolloReactComponents.Query<ShefOrdersQueryQuery, ShefOrdersQueryQueryVariables> query={ShefOrdersQueryDocument} {...props} />
    );
    

/**
 * __useShefOrdersQueryQuery__
 *
 * To run a query within a React component, call `useShefOrdersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefOrdersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefOrdersQueryQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useShefOrdersQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefOrdersQueryQuery, ShefOrdersQueryQueryVariables> & ({ variables: ShefOrdersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefOrdersQueryQuery, ShefOrdersQueryQueryVariables>(ShefOrdersQueryDocument, options);
      }
export function useShefOrdersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefOrdersQueryQuery, ShefOrdersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefOrdersQueryQuery, ShefOrdersQueryQueryVariables>(ShefOrdersQueryDocument, options);
        }
export function useShefOrdersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefOrdersQueryQuery, ShefOrdersQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefOrdersQueryQuery, ShefOrdersQueryQueryVariables>(ShefOrdersQueryDocument, options);
        }
export type ShefOrdersQueryQueryHookResult = ReturnType<typeof useShefOrdersQueryQuery>;
export type ShefOrdersQueryLazyQueryHookResult = ReturnType<typeof useShefOrdersQueryLazyQuery>;
export type ShefOrdersQuerySuspenseQueryHookResult = ReturnType<typeof useShefOrdersQuerySuspenseQuery>;
export type ShefOrdersQueryQueryResult = ApolloReactCommon.QueryResult<ShefOrdersQueryQuery, ShefOrdersQueryQueryVariables>;
export const ShefOrderEditDocument = gql`
    query ShefOrderEdit($orderId: Int!) {
  order(orderId: $orderId) {
    id
    userId
    phone
    deliveryAddressId
    shef {
      id
      publicName
      shefProfile {
        id
        formattedAddress
        timeZone
        platformPercent
        fulfillmentOption
        isMultiFulfillmentShef
      }
    }
    region {
      name
    }
    user {
      id
      flakeId
      publicName
    }
    pickupAddressId
    createdAt
    updatedAt
    subtotal
    deliveryDate
    orderType
    orderStatus
    cancelledAt
    deliveryNotes
    deliveryFee
    deliveryType
    smallOrderFee
    grandTotal
    salesTax
    serviceFee
    shefTip
    shefPlatformPercent
    discountApplied
    transactionId
    refundId
    refundTimestamp
    refundAmount
    refundReason
    refundType
    delivery {
      externalId
      type
      fee
    }
    lineItems {
      id
      name
      quantity
      price
      foodItem {
        id
        name
        price
        imageUrl
        servingSize
        spiceLevel
      }
      customizations {
        id
        customizationType {
          id
          category
          name
          dataType
        }
        priceFactor
        priceFactorType
      }
    }
    promoCode {
      code
      isPercentage
      promoCodeType
      value
    }
    address {
      id
      formattedAddress
      name
    }
    shefFulfillmentTimeWindow {
      id
      startMsAfterMidnight
      endMsAfterMidnight
    }
    groupOrderId
    groupOrderSize
    groupOrderItemCount
  }
}
    `;
export type ShefOrderEditComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefOrderEditQuery, ShefOrderEditQueryVariables>, 'query'> & ({ variables: ShefOrderEditQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefOrderEditComponent = (props: ShefOrderEditComponentProps) => (
      <ApolloReactComponents.Query<ShefOrderEditQuery, ShefOrderEditQueryVariables> query={ShefOrderEditDocument} {...props} />
    );
    

/**
 * __useShefOrderEditQuery__
 *
 * To run a query within a React component, call `useShefOrderEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefOrderEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefOrderEditQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useShefOrderEditQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefOrderEditQuery, ShefOrderEditQueryVariables> & ({ variables: ShefOrderEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefOrderEditQuery, ShefOrderEditQueryVariables>(ShefOrderEditDocument, options);
      }
export function useShefOrderEditLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefOrderEditQuery, ShefOrderEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefOrderEditQuery, ShefOrderEditQueryVariables>(ShefOrderEditDocument, options);
        }
export function useShefOrderEditSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefOrderEditQuery, ShefOrderEditQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefOrderEditQuery, ShefOrderEditQueryVariables>(ShefOrderEditDocument, options);
        }
export type ShefOrderEditQueryHookResult = ReturnType<typeof useShefOrderEditQuery>;
export type ShefOrderEditLazyQueryHookResult = ReturnType<typeof useShefOrderEditLazyQuery>;
export type ShefOrderEditSuspenseQueryHookResult = ReturnType<typeof useShefOrderEditSuspenseQuery>;
export type ShefOrderEditQueryResult = ApolloReactCommon.QueryResult<ShefOrderEditQuery, ShefOrderEditQueryVariables>;
export const ShefOrderReviewsDocument = gql`
    query ShefOrderReviews($shefId: String!, $offset: Int!, $limit: Int!) {
  publicReviews(shefId: $shefId, offset: $offset, limit: $limit) {
    total
    reviews {
      ...ShefOrderReviewResult
    }
  }
}
    ${ShefOrderReviewResultFragmentDoc}`;
export type ShefOrderReviewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefOrderReviewsQuery, ShefOrderReviewsQueryVariables>, 'query'> & ({ variables: ShefOrderReviewsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefOrderReviewsComponent = (props: ShefOrderReviewsComponentProps) => (
      <ApolloReactComponents.Query<ShefOrderReviewsQuery, ShefOrderReviewsQueryVariables> query={ShefOrderReviewsDocument} {...props} />
    );
    

/**
 * __useShefOrderReviewsQuery__
 *
 * To run a query within a React component, call `useShefOrderReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefOrderReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefOrderReviewsQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useShefOrderReviewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefOrderReviewsQuery, ShefOrderReviewsQueryVariables> & ({ variables: ShefOrderReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefOrderReviewsQuery, ShefOrderReviewsQueryVariables>(ShefOrderReviewsDocument, options);
      }
export function useShefOrderReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefOrderReviewsQuery, ShefOrderReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefOrderReviewsQuery, ShefOrderReviewsQueryVariables>(ShefOrderReviewsDocument, options);
        }
export function useShefOrderReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefOrderReviewsQuery, ShefOrderReviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefOrderReviewsQuery, ShefOrderReviewsQueryVariables>(ShefOrderReviewsDocument, options);
        }
export type ShefOrderReviewsQueryHookResult = ReturnType<typeof useShefOrderReviewsQuery>;
export type ShefOrderReviewsLazyQueryHookResult = ReturnType<typeof useShefOrderReviewsLazyQuery>;
export type ShefOrderReviewsSuspenseQueryHookResult = ReturnType<typeof useShefOrderReviewsSuspenseQuery>;
export type ShefOrderReviewsQueryResult = ApolloReactCommon.QueryResult<ShefOrderReviewsQuery, ShefOrderReviewsQueryVariables>;
export const ShefPerformanceDishesDocument = gql`
    query ShefPerformanceDishes {
  categoricalRatings2(limit: 3) {
    positiveRatings {
      name
      value
    }
    negativeRatings {
      name
      value
    }
  }
  foodItemPopularity {
    results {
      id
      name
      imageUrl
      numThumbsUp
      numThumbsDown
      tags {
        tag
        count
        isPositive
      }
    }
  }
}
    `;
export type ShefPerformanceDishesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefPerformanceDishesQuery, ShefPerformanceDishesQueryVariables>, 'query'>;

    export const ShefPerformanceDishesComponent = (props: ShefPerformanceDishesComponentProps) => (
      <ApolloReactComponents.Query<ShefPerformanceDishesQuery, ShefPerformanceDishesQueryVariables> query={ShefPerformanceDishesDocument} {...props} />
    );
    

/**
 * __useShefPerformanceDishesQuery__
 *
 * To run a query within a React component, call `useShefPerformanceDishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefPerformanceDishesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefPerformanceDishesQuery({
 *   variables: {
 *   },
 * });
 */
export function useShefPerformanceDishesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShefPerformanceDishesQuery, ShefPerformanceDishesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefPerformanceDishesQuery, ShefPerformanceDishesQueryVariables>(ShefPerformanceDishesDocument, options);
      }
export function useShefPerformanceDishesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefPerformanceDishesQuery, ShefPerformanceDishesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefPerformanceDishesQuery, ShefPerformanceDishesQueryVariables>(ShefPerformanceDishesDocument, options);
        }
export function useShefPerformanceDishesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefPerformanceDishesQuery, ShefPerformanceDishesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefPerformanceDishesQuery, ShefPerformanceDishesQueryVariables>(ShefPerformanceDishesDocument, options);
        }
export type ShefPerformanceDishesQueryHookResult = ReturnType<typeof useShefPerformanceDishesQuery>;
export type ShefPerformanceDishesLazyQueryHookResult = ReturnType<typeof useShefPerformanceDishesLazyQuery>;
export type ShefPerformanceDishesSuspenseQueryHookResult = ReturnType<typeof useShefPerformanceDishesSuspenseQuery>;
export type ShefPerformanceDishesQueryResult = ApolloReactCommon.QueryResult<ShefPerformanceDishesQuery, ShefPerformanceDishesQueryVariables>;
export const ShefPerformanceOrdersDocument = gql`
    query ShefPerformanceOrders {
  foodItemPopularity(sqlLimit: 250) {
    results {
      id
      name
      imageUrl
      numThumbsUp
      numThumbsDown
      tags {
        tag
        count
        isPositive
      }
    }
  }
}
    `;
export type ShefPerformanceOrdersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefPerformanceOrdersQuery, ShefPerformanceOrdersQueryVariables>, 'query'>;

    export const ShefPerformanceOrdersComponent = (props: ShefPerformanceOrdersComponentProps) => (
      <ApolloReactComponents.Query<ShefPerformanceOrdersQuery, ShefPerformanceOrdersQueryVariables> query={ShefPerformanceOrdersDocument} {...props} />
    );
    

/**
 * __useShefPerformanceOrdersQuery__
 *
 * To run a query within a React component, call `useShefPerformanceOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefPerformanceOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefPerformanceOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useShefPerformanceOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShefPerformanceOrdersQuery, ShefPerformanceOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefPerformanceOrdersQuery, ShefPerformanceOrdersQueryVariables>(ShefPerformanceOrdersDocument, options);
      }
export function useShefPerformanceOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefPerformanceOrdersQuery, ShefPerformanceOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefPerformanceOrdersQuery, ShefPerformanceOrdersQueryVariables>(ShefPerformanceOrdersDocument, options);
        }
export function useShefPerformanceOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefPerformanceOrdersQuery, ShefPerformanceOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefPerformanceOrdersQuery, ShefPerformanceOrdersQueryVariables>(ShefPerformanceOrdersDocument, options);
        }
export type ShefPerformanceOrdersQueryHookResult = ReturnType<typeof useShefPerformanceOrdersQuery>;
export type ShefPerformanceOrdersLazyQueryHookResult = ReturnType<typeof useShefPerformanceOrdersLazyQuery>;
export type ShefPerformanceOrdersSuspenseQueryHookResult = ReturnType<typeof useShefPerformanceOrdersSuspenseQuery>;
export type ShefPerformanceOrdersQueryResult = ApolloReactCommon.QueryResult<ShefPerformanceOrdersQuery, ShefPerformanceOrdersQueryVariables>;
export const ShefPerformanceOverviewDocument = gql`
    query ShefPerformanceOverview {
  categoricalRatings2(limit: 3, sqlLimit: 250) {
    positiveRatings {
      name
      value
    }
    negativeRatings {
      name
      value
    }
  }
  foodItemPopularity(sqlLimit: 250) {
    results {
      id
      name
      imageUrl
      numThumbsUp
      numThumbsDown
      tags {
        tag
        count
        isPositive
      }
    }
  }
}
    `;
export type ShefPerformanceOverviewComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefPerformanceOverviewQuery, ShefPerformanceOverviewQueryVariables>, 'query'>;

    export const ShefPerformanceOverviewComponent = (props: ShefPerformanceOverviewComponentProps) => (
      <ApolloReactComponents.Query<ShefPerformanceOverviewQuery, ShefPerformanceOverviewQueryVariables> query={ShefPerformanceOverviewDocument} {...props} />
    );
    

/**
 * __useShefPerformanceOverviewQuery__
 *
 * To run a query within a React component, call `useShefPerformanceOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefPerformanceOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefPerformanceOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useShefPerformanceOverviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShefPerformanceOverviewQuery, ShefPerformanceOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefPerformanceOverviewQuery, ShefPerformanceOverviewQueryVariables>(ShefPerformanceOverviewDocument, options);
      }
export function useShefPerformanceOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefPerformanceOverviewQuery, ShefPerformanceOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefPerformanceOverviewQuery, ShefPerformanceOverviewQueryVariables>(ShefPerformanceOverviewDocument, options);
        }
export function useShefPerformanceOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefPerformanceOverviewQuery, ShefPerformanceOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefPerformanceOverviewQuery, ShefPerformanceOverviewQueryVariables>(ShefPerformanceOverviewDocument, options);
        }
export type ShefPerformanceOverviewQueryHookResult = ReturnType<typeof useShefPerformanceOverviewQuery>;
export type ShefPerformanceOverviewLazyQueryHookResult = ReturnType<typeof useShefPerformanceOverviewLazyQuery>;
export type ShefPerformanceOverviewSuspenseQueryHookResult = ReturnType<typeof useShefPerformanceOverviewSuspenseQuery>;
export type ShefPerformanceOverviewQueryResult = ApolloReactCommon.QueryResult<ShefPerformanceOverviewQuery, ShefPerformanceOverviewQueryVariables>;
export const FlagRatingForReviewDocument = gql`
    mutation FlagRatingForReview($ratingId: Int!) {
  flagRatingForReview(ratingId: $ratingId)
}
    `;
export type FlagRatingForReviewMutationFn = ApolloReactCommon.MutationFunction<FlagRatingForReviewMutation, FlagRatingForReviewMutationVariables>;
export type FlagRatingForReviewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<FlagRatingForReviewMutation, FlagRatingForReviewMutationVariables>, 'mutation'>;

    export const FlagRatingForReviewComponent = (props: FlagRatingForReviewComponentProps) => (
      <ApolloReactComponents.Mutation<FlagRatingForReviewMutation, FlagRatingForReviewMutationVariables> mutation={FlagRatingForReviewDocument} {...props} />
    );
    

/**
 * __useFlagRatingForReviewMutation__
 *
 * To run a mutation, you first call `useFlagRatingForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagRatingForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagRatingForReviewMutation, { data, loading, error }] = useFlagRatingForReviewMutation({
 *   variables: {
 *      ratingId: // value for 'ratingId'
 *   },
 * });
 */
export function useFlagRatingForReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FlagRatingForReviewMutation, FlagRatingForReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FlagRatingForReviewMutation, FlagRatingForReviewMutationVariables>(FlagRatingForReviewDocument, options);
      }
export type FlagRatingForReviewMutationHookResult = ReturnType<typeof useFlagRatingForReviewMutation>;
export type FlagRatingForReviewMutationResult = ApolloReactCommon.MutationResult<FlagRatingForReviewMutation>;
export type FlagRatingForReviewMutationOptions = ApolloReactCommon.BaseMutationOptions<FlagRatingForReviewMutation, FlagRatingForReviewMutationVariables>;
export const ShefEarningsPageDocument = gql`
    query ShefEarningsPage {
  getShefEarningsDashboardUrl
}
    `;
export type ShefEarningsPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefEarningsPageQuery, ShefEarningsPageQueryVariables>, 'query'>;

    export const ShefEarningsPageComponent = (props: ShefEarningsPageComponentProps) => (
      <ApolloReactComponents.Query<ShefEarningsPageQuery, ShefEarningsPageQueryVariables> query={ShefEarningsPageDocument} {...props} />
    );
    

/**
 * __useShefEarningsPageQuery__
 *
 * To run a query within a React component, call `useShefEarningsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefEarningsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefEarningsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useShefEarningsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShefEarningsPageQuery, ShefEarningsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefEarningsPageQuery, ShefEarningsPageQueryVariables>(ShefEarningsPageDocument, options);
      }
export function useShefEarningsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefEarningsPageQuery, ShefEarningsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefEarningsPageQuery, ShefEarningsPageQueryVariables>(ShefEarningsPageDocument, options);
        }
export function useShefEarningsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefEarningsPageQuery, ShefEarningsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefEarningsPageQuery, ShefEarningsPageQueryVariables>(ShefEarningsPageDocument, options);
        }
export type ShefEarningsPageQueryHookResult = ReturnType<typeof useShefEarningsPageQuery>;
export type ShefEarningsPageLazyQueryHookResult = ReturnType<typeof useShefEarningsPageLazyQuery>;
export type ShefEarningsPageSuspenseQueryHookResult = ReturnType<typeof useShefEarningsPageSuspenseQuery>;
export type ShefEarningsPageQueryResult = ApolloReactCommon.QueryResult<ShefEarningsPageQuery, ShefEarningsPageQueryVariables>;
export const ShefMenuChecklistDocument = gql`
    query ShefMenuChecklist($shefId: String!) {
  shefMenuChecklist(shefId: $shefId) {
    key
    label
    completed
  }
}
    `;
export type ShefMenuChecklistComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefMenuChecklistQuery, ShefMenuChecklistQueryVariables>, 'query'> & ({ variables: ShefMenuChecklistQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefMenuChecklistComponent = (props: ShefMenuChecklistComponentProps) => (
      <ApolloReactComponents.Query<ShefMenuChecklistQuery, ShefMenuChecklistQueryVariables> query={ShefMenuChecklistDocument} {...props} />
    );
    

/**
 * __useShefMenuChecklistQuery__
 *
 * To run a query within a React component, call `useShefMenuChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefMenuChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefMenuChecklistQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useShefMenuChecklistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefMenuChecklistQuery, ShefMenuChecklistQueryVariables> & ({ variables: ShefMenuChecklistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefMenuChecklistQuery, ShefMenuChecklistQueryVariables>(ShefMenuChecklistDocument, options);
      }
export function useShefMenuChecklistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefMenuChecklistQuery, ShefMenuChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefMenuChecklistQuery, ShefMenuChecklistQueryVariables>(ShefMenuChecklistDocument, options);
        }
export function useShefMenuChecklistSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefMenuChecklistQuery, ShefMenuChecklistQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefMenuChecklistQuery, ShefMenuChecklistQueryVariables>(ShefMenuChecklistDocument, options);
        }
export type ShefMenuChecklistQueryHookResult = ReturnType<typeof useShefMenuChecklistQuery>;
export type ShefMenuChecklistLazyQueryHookResult = ReturnType<typeof useShefMenuChecklistLazyQuery>;
export type ShefMenuChecklistSuspenseQueryHookResult = ReturnType<typeof useShefMenuChecklistSuspenseQuery>;
export type ShefMenuChecklistQueryResult = ApolloReactCommon.QueryResult<ShefMenuChecklistQuery, ShefMenuChecklistQueryVariables>;
export const CreateShefPostDocument = gql`
    mutation CreateShefPost($input: ShefPostInput!) {
  createShefPost(input: $input)
}
    `;
export type CreateShefPostMutationFn = ApolloReactCommon.MutationFunction<CreateShefPostMutation, CreateShefPostMutationVariables>;
export type CreateShefPostComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateShefPostMutation, CreateShefPostMutationVariables>, 'mutation'>;

    export const CreateShefPostComponent = (props: CreateShefPostComponentProps) => (
      <ApolloReactComponents.Mutation<CreateShefPostMutation, CreateShefPostMutationVariables> mutation={CreateShefPostDocument} {...props} />
    );
    

/**
 * __useCreateShefPostMutation__
 *
 * To run a mutation, you first call `useCreateShefPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShefPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShefPostMutation, { data, loading, error }] = useCreateShefPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShefPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateShefPostMutation, CreateShefPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateShefPostMutation, CreateShefPostMutationVariables>(CreateShefPostDocument, options);
      }
export type CreateShefPostMutationHookResult = ReturnType<typeof useCreateShefPostMutation>;
export type CreateShefPostMutationResult = ApolloReactCommon.MutationResult<CreateShefPostMutation>;
export type CreateShefPostMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateShefPostMutation, CreateShefPostMutationVariables>;
export const ModifyShefPostDocument = gql`
    mutation ModifyShefPost($id: String!, $input: ShefPostInput!) {
  modifyShefPost(id: $id, input: $input)
}
    `;
export type ModifyShefPostMutationFn = ApolloReactCommon.MutationFunction<ModifyShefPostMutation, ModifyShefPostMutationVariables>;
export type ModifyShefPostComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ModifyShefPostMutation, ModifyShefPostMutationVariables>, 'mutation'>;

    export const ModifyShefPostComponent = (props: ModifyShefPostComponentProps) => (
      <ApolloReactComponents.Mutation<ModifyShefPostMutation, ModifyShefPostMutationVariables> mutation={ModifyShefPostDocument} {...props} />
    );
    

/**
 * __useModifyShefPostMutation__
 *
 * To run a mutation, you first call `useModifyShefPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyShefPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyShefPostMutation, { data, loading, error }] = useModifyShefPostMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyShefPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ModifyShefPostMutation, ModifyShefPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ModifyShefPostMutation, ModifyShefPostMutationVariables>(ModifyShefPostDocument, options);
      }
export type ModifyShefPostMutationHookResult = ReturnType<typeof useModifyShefPostMutation>;
export type ModifyShefPostMutationResult = ApolloReactCommon.MutationResult<ModifyShefPostMutation>;
export type ModifyShefPostMutationOptions = ApolloReactCommon.BaseMutationOptions<ModifyShefPostMutation, ModifyShefPostMutationVariables>;
export const DeleteShefPostDocument = gql`
    mutation DeleteShefPost($id: String!) {
  deleteShefPost(id: $id)
}
    `;
export type DeleteShefPostMutationFn = ApolloReactCommon.MutationFunction<DeleteShefPostMutation, DeleteShefPostMutationVariables>;
export type DeleteShefPostComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteShefPostMutation, DeleteShefPostMutationVariables>, 'mutation'>;

    export const DeleteShefPostComponent = (props: DeleteShefPostComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteShefPostMutation, DeleteShefPostMutationVariables> mutation={DeleteShefPostDocument} {...props} />
    );
    

/**
 * __useDeleteShefPostMutation__
 *
 * To run a mutation, you first call `useDeleteShefPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShefPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShefPostMutation, { data, loading, error }] = useDeleteShefPostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteShefPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteShefPostMutation, DeleteShefPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteShefPostMutation, DeleteShefPostMutationVariables>(DeleteShefPostDocument, options);
      }
export type DeleteShefPostMutationHookResult = ReturnType<typeof useDeleteShefPostMutation>;
export type DeleteShefPostMutationResult = ApolloReactCommon.MutationResult<DeleteShefPostMutation>;
export type DeleteShefPostMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteShefPostMutation, DeleteShefPostMutationVariables>;
export const LikeShefPostDocument = gql`
    mutation LikeShefPost($id: String!) {
  likeShefPost(id: $id)
}
    `;
export type LikeShefPostMutationFn = ApolloReactCommon.MutationFunction<LikeShefPostMutation, LikeShefPostMutationVariables>;
export type LikeShefPostComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<LikeShefPostMutation, LikeShefPostMutationVariables>, 'mutation'>;

    export const LikeShefPostComponent = (props: LikeShefPostComponentProps) => (
      <ApolloReactComponents.Mutation<LikeShefPostMutation, LikeShefPostMutationVariables> mutation={LikeShefPostDocument} {...props} />
    );
    

/**
 * __useLikeShefPostMutation__
 *
 * To run a mutation, you first call `useLikeShefPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeShefPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeShefPostMutation, { data, loading, error }] = useLikeShefPostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLikeShefPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LikeShefPostMutation, LikeShefPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LikeShefPostMutation, LikeShefPostMutationVariables>(LikeShefPostDocument, options);
      }
export type LikeShefPostMutationHookResult = ReturnType<typeof useLikeShefPostMutation>;
export type LikeShefPostMutationResult = ApolloReactCommon.MutationResult<LikeShefPostMutation>;
export type LikeShefPostMutationOptions = ApolloReactCommon.BaseMutationOptions<LikeShefPostMutation, LikeShefPostMutationVariables>;
export const IncrementShefPostClickCountDocument = gql`
    mutation IncrementShefPostClickCount($id: String!) {
  incrementShefPostClickCount(id: $id)
}
    `;
export type IncrementShefPostClickCountMutationFn = ApolloReactCommon.MutationFunction<IncrementShefPostClickCountMutation, IncrementShefPostClickCountMutationVariables>;
export type IncrementShefPostClickCountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<IncrementShefPostClickCountMutation, IncrementShefPostClickCountMutationVariables>, 'mutation'>;

    export const IncrementShefPostClickCountComponent = (props: IncrementShefPostClickCountComponentProps) => (
      <ApolloReactComponents.Mutation<IncrementShefPostClickCountMutation, IncrementShefPostClickCountMutationVariables> mutation={IncrementShefPostClickCountDocument} {...props} />
    );
    

/**
 * __useIncrementShefPostClickCountMutation__
 *
 * To run a mutation, you first call `useIncrementShefPostClickCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementShefPostClickCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementShefPostClickCountMutation, { data, loading, error }] = useIncrementShefPostClickCountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIncrementShefPostClickCountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IncrementShefPostClickCountMutation, IncrementShefPostClickCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IncrementShefPostClickCountMutation, IncrementShefPostClickCountMutationVariables>(IncrementShefPostClickCountDocument, options);
      }
export type IncrementShefPostClickCountMutationHookResult = ReturnType<typeof useIncrementShefPostClickCountMutation>;
export type IncrementShefPostClickCountMutationResult = ApolloReactCommon.MutationResult<IncrementShefPostClickCountMutation>;
export type IncrementShefPostClickCountMutationOptions = ApolloReactCommon.BaseMutationOptions<IncrementShefPostClickCountMutation, IncrementShefPostClickCountMutationVariables>;
export const IncrementShefPostViewCountDocument = gql`
    mutation IncrementShefPostViewCount($id: String!) {
  incrementShefPostViewCount(id: $id)
}
    `;
export type IncrementShefPostViewCountMutationFn = ApolloReactCommon.MutationFunction<IncrementShefPostViewCountMutation, IncrementShefPostViewCountMutationVariables>;
export type IncrementShefPostViewCountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<IncrementShefPostViewCountMutation, IncrementShefPostViewCountMutationVariables>, 'mutation'>;

    export const IncrementShefPostViewCountComponent = (props: IncrementShefPostViewCountComponentProps) => (
      <ApolloReactComponents.Mutation<IncrementShefPostViewCountMutation, IncrementShefPostViewCountMutationVariables> mutation={IncrementShefPostViewCountDocument} {...props} />
    );
    

/**
 * __useIncrementShefPostViewCountMutation__
 *
 * To run a mutation, you first call `useIncrementShefPostViewCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementShefPostViewCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementShefPostViewCountMutation, { data, loading, error }] = useIncrementShefPostViewCountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIncrementShefPostViewCountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IncrementShefPostViewCountMutation, IncrementShefPostViewCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IncrementShefPostViewCountMutation, IncrementShefPostViewCountMutationVariables>(IncrementShefPostViewCountDocument, options);
      }
export type IncrementShefPostViewCountMutationHookResult = ReturnType<typeof useIncrementShefPostViewCountMutation>;
export type IncrementShefPostViewCountMutationResult = ApolloReactCommon.MutationResult<IncrementShefPostViewCountMutation>;
export type IncrementShefPostViewCountMutationOptions = ApolloReactCommon.BaseMutationOptions<IncrementShefPostViewCountMutation, IncrementShefPostViewCountMutationVariables>;
export const ShefFollowingDocument = gql`
    query ShefFollowing($shefId: String!) {
  me {
    id
    shefProfile {
      followerCount
      followers {
        ...ShefSocialFollower
      }
    }
  }
}
    ${ShefSocialFollowerFragmentDoc}`;
export type ShefFollowingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefFollowingQuery, ShefFollowingQueryVariables>, 'query'> & ({ variables: ShefFollowingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefFollowingComponent = (props: ShefFollowingComponentProps) => (
      <ApolloReactComponents.Query<ShefFollowingQuery, ShefFollowingQueryVariables> query={ShefFollowingDocument} {...props} />
    );
    

/**
 * __useShefFollowingQuery__
 *
 * To run a query within a React component, call `useShefFollowingQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefFollowingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefFollowingQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useShefFollowingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefFollowingQuery, ShefFollowingQueryVariables> & ({ variables: ShefFollowingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefFollowingQuery, ShefFollowingQueryVariables>(ShefFollowingDocument, options);
      }
export function useShefFollowingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefFollowingQuery, ShefFollowingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefFollowingQuery, ShefFollowingQueryVariables>(ShefFollowingDocument, options);
        }
export function useShefFollowingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefFollowingQuery, ShefFollowingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefFollowingQuery, ShefFollowingQueryVariables>(ShefFollowingDocument, options);
        }
export type ShefFollowingQueryHookResult = ReturnType<typeof useShefFollowingQuery>;
export type ShefFollowingLazyQueryHookResult = ReturnType<typeof useShefFollowingLazyQuery>;
export type ShefFollowingSuspenseQueryHookResult = ReturnType<typeof useShefFollowingSuspenseQuery>;
export type ShefFollowingQueryResult = ApolloReactCommon.QueryResult<ShefFollowingQuery, ShefFollowingQueryVariables>;
export const ShefPostsDocument = gql`
    query ShefPosts($shefId: String!, $page: Int, $resultsPerPage: Int) {
  shefPosts(shefId: $shefId, page: $page, resultsPerPage: $resultsPerPage) {
    ...ShefPostData
  }
}
    ${ShefPostDataFragmentDoc}`;
export type ShefPostsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefPostsQuery, ShefPostsQueryVariables>, 'query'> & ({ variables: ShefPostsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefPostsComponent = (props: ShefPostsComponentProps) => (
      <ApolloReactComponents.Query<ShefPostsQuery, ShefPostsQueryVariables> query={ShefPostsDocument} {...props} />
    );
    

/**
 * __useShefPostsQuery__
 *
 * To run a query within a React component, call `useShefPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefPostsQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      page: // value for 'page'
 *      resultsPerPage: // value for 'resultsPerPage'
 *   },
 * });
 */
export function useShefPostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefPostsQuery, ShefPostsQueryVariables> & ({ variables: ShefPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefPostsQuery, ShefPostsQueryVariables>(ShefPostsDocument, options);
      }
export function useShefPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefPostsQuery, ShefPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefPostsQuery, ShefPostsQueryVariables>(ShefPostsDocument, options);
        }
export function useShefPostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefPostsQuery, ShefPostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefPostsQuery, ShefPostsQueryVariables>(ShefPostsDocument, options);
        }
export type ShefPostsQueryHookResult = ReturnType<typeof useShefPostsQuery>;
export type ShefPostsLazyQueryHookResult = ReturnType<typeof useShefPostsLazyQuery>;
export type ShefPostsSuspenseQueryHookResult = ReturnType<typeof useShefPostsSuspenseQuery>;
export type ShefPostsQueryResult = ApolloReactCommon.QueryResult<ShefPostsQuery, ShefPostsQueryVariables>;
export const ZipCodeAvailabilityDocument = gql`
    query ZipCodeAvailability($zipCode: String!) {
  zipCode(zipCode: $zipCode) {
    zipCode
    availableToCustomers
    region {
      id
      isInWaitlist
    }
  }
}
    `;
export type ZipCodeAvailabilityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ZipCodeAvailabilityQuery, ZipCodeAvailabilityQueryVariables>, 'query'> & ({ variables: ZipCodeAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ZipCodeAvailabilityComponent = (props: ZipCodeAvailabilityComponentProps) => (
      <ApolloReactComponents.Query<ZipCodeAvailabilityQuery, ZipCodeAvailabilityQueryVariables> query={ZipCodeAvailabilityDocument} {...props} />
    );
    

/**
 * __useZipCodeAvailabilityQuery__
 *
 * To run a query within a React component, call `useZipCodeAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useZipCodeAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZipCodeAvailabilityQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useZipCodeAvailabilityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ZipCodeAvailabilityQuery, ZipCodeAvailabilityQueryVariables> & ({ variables: ZipCodeAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ZipCodeAvailabilityQuery, ZipCodeAvailabilityQueryVariables>(ZipCodeAvailabilityDocument, options);
      }
export function useZipCodeAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ZipCodeAvailabilityQuery, ZipCodeAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ZipCodeAvailabilityQuery, ZipCodeAvailabilityQueryVariables>(ZipCodeAvailabilityDocument, options);
        }
export function useZipCodeAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ZipCodeAvailabilityQuery, ZipCodeAvailabilityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ZipCodeAvailabilityQuery, ZipCodeAvailabilityQueryVariables>(ZipCodeAvailabilityDocument, options);
        }
export type ZipCodeAvailabilityQueryHookResult = ReturnType<typeof useZipCodeAvailabilityQuery>;
export type ZipCodeAvailabilityLazyQueryHookResult = ReturnType<typeof useZipCodeAvailabilityLazyQuery>;
export type ZipCodeAvailabilitySuspenseQueryHookResult = ReturnType<typeof useZipCodeAvailabilitySuspenseQuery>;
export type ZipCodeAvailabilityQueryResult = ApolloReactCommon.QueryResult<ZipCodeAvailabilityQuery, ZipCodeAvailabilityQueryVariables>;
export const AdminCreateOrUpdateRegionDocument = gql`
    mutation AdminCreateOrUpdateRegion($regionInfo: UpdateRegionInput!) {
  createOrUpdateRegion(regionInfo: $regionInfo) {
    id
  }
}
    `;
export type AdminCreateOrUpdateRegionMutationFn = ApolloReactCommon.MutationFunction<AdminCreateOrUpdateRegionMutation, AdminCreateOrUpdateRegionMutationVariables>;
export type AdminCreateOrUpdateRegionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AdminCreateOrUpdateRegionMutation, AdminCreateOrUpdateRegionMutationVariables>, 'mutation'>;

    export const AdminCreateOrUpdateRegionComponent = (props: AdminCreateOrUpdateRegionComponentProps) => (
      <ApolloReactComponents.Mutation<AdminCreateOrUpdateRegionMutation, AdminCreateOrUpdateRegionMutationVariables> mutation={AdminCreateOrUpdateRegionDocument} {...props} />
    );
    

/**
 * __useAdminCreateOrUpdateRegionMutation__
 *
 * To run a mutation, you first call `useAdminCreateOrUpdateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateOrUpdateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateOrUpdateRegionMutation, { data, loading, error }] = useAdminCreateOrUpdateRegionMutation({
 *   variables: {
 *      regionInfo: // value for 'regionInfo'
 *   },
 * });
 */
export function useAdminCreateOrUpdateRegionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateOrUpdateRegionMutation, AdminCreateOrUpdateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateOrUpdateRegionMutation, AdminCreateOrUpdateRegionMutationVariables>(AdminCreateOrUpdateRegionDocument, options);
      }
export type AdminCreateOrUpdateRegionMutationHookResult = ReturnType<typeof useAdminCreateOrUpdateRegionMutation>;
export type AdminCreateOrUpdateRegionMutationResult = ApolloReactCommon.MutationResult<AdminCreateOrUpdateRegionMutation>;
export type AdminCreateOrUpdateRegionMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminCreateOrUpdateRegionMutation, AdminCreateOrUpdateRegionMutationVariables>;
export const GetDeliveryDaysForZipDocument = gql`
    query GetDeliveryDaysForZip($zipCode: String!) {
  regionFromZip(zipCode: $zipCode) {
    ...ZipDeliveryDays
  }
}
    ${ZipDeliveryDaysFragmentDoc}`;
export type GetDeliveryDaysForZipComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDeliveryDaysForZipQuery, GetDeliveryDaysForZipQueryVariables>, 'query'> & ({ variables: GetDeliveryDaysForZipQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDeliveryDaysForZipComponent = (props: GetDeliveryDaysForZipComponentProps) => (
      <ApolloReactComponents.Query<GetDeliveryDaysForZipQuery, GetDeliveryDaysForZipQueryVariables> query={GetDeliveryDaysForZipDocument} {...props} />
    );
    

/**
 * __useGetDeliveryDaysForZipQuery__
 *
 * To run a query within a React component, call `useGetDeliveryDaysForZipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryDaysForZipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryDaysForZipQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useGetDeliveryDaysForZipQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDeliveryDaysForZipQuery, GetDeliveryDaysForZipQueryVariables> & ({ variables: GetDeliveryDaysForZipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDeliveryDaysForZipQuery, GetDeliveryDaysForZipQueryVariables>(GetDeliveryDaysForZipDocument, options);
      }
export function useGetDeliveryDaysForZipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDeliveryDaysForZipQuery, GetDeliveryDaysForZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDeliveryDaysForZipQuery, GetDeliveryDaysForZipQueryVariables>(GetDeliveryDaysForZipDocument, options);
        }
export function useGetDeliveryDaysForZipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDeliveryDaysForZipQuery, GetDeliveryDaysForZipQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDeliveryDaysForZipQuery, GetDeliveryDaysForZipQueryVariables>(GetDeliveryDaysForZipDocument, options);
        }
export type GetDeliveryDaysForZipQueryHookResult = ReturnType<typeof useGetDeliveryDaysForZipQuery>;
export type GetDeliveryDaysForZipLazyQueryHookResult = ReturnType<typeof useGetDeliveryDaysForZipLazyQuery>;
export type GetDeliveryDaysForZipSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryDaysForZipSuspenseQuery>;
export type GetDeliveryDaysForZipQueryResult = ApolloReactCommon.QueryResult<GetDeliveryDaysForZipQuery, GetDeliveryDaysForZipQueryVariables>;
export const ShefOgTagsDocument = gql`
    query ShefOGTags($shefId: String!) {
  shef(userId: $shefId) {
    firstName
    publicName
    resizedImageUrl(width: 1200)
    shefProfile {
      id
      resizedCoverPhotoUrl(width: 1200)
      bio
    }
    activeFoodItems(limit: 1) {
      resizedImageUrl(width: 1200)
    }
  }
}
    `;
export type ShefOgTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefOgTagsQuery, ShefOgTagsQueryVariables>, 'query'> & ({ variables: ShefOgTagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefOgTagsComponent = (props: ShefOgTagsComponentProps) => (
      <ApolloReactComponents.Query<ShefOgTagsQuery, ShefOgTagsQueryVariables> query={ShefOgTagsDocument} {...props} />
    );
    

/**
 * __useShefOgTagsQuery__
 *
 * To run a query within a React component, call `useShefOgTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefOgTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefOgTagsQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *   },
 * });
 */
export function useShefOgTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefOgTagsQuery, ShefOgTagsQueryVariables> & ({ variables: ShefOgTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefOgTagsQuery, ShefOgTagsQueryVariables>(ShefOgTagsDocument, options);
      }
export function useShefOgTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefOgTagsQuery, ShefOgTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefOgTagsQuery, ShefOgTagsQueryVariables>(ShefOgTagsDocument, options);
        }
export function useShefOgTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefOgTagsQuery, ShefOgTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefOgTagsQuery, ShefOgTagsQueryVariables>(ShefOgTagsDocument, options);
        }
export type ShefOgTagsQueryHookResult = ReturnType<typeof useShefOgTagsQuery>;
export type ShefOgTagsLazyQueryHookResult = ReturnType<typeof useShefOgTagsLazyQuery>;
export type ShefOgTagsSuspenseQueryHookResult = ReturnType<typeof useShefOgTagsSuspenseQuery>;
export type ShefOgTagsQueryResult = ApolloReactCommon.QueryResult<ShefOgTagsQuery, ShefOgTagsQueryVariables>;
export const DishOgTagsDocument = gql`
    query DishOGTags($shefId: String!, $slug: String!) {
  sluggedFoodItem(shefId: $shefId, slug: $slug) {
    name
    description
    resizedImageUrl(width: 1200)
    slug
    shef {
      firstName
    }
  }
}
    `;
export type DishOgTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DishOgTagsQuery, DishOgTagsQueryVariables>, 'query'> & ({ variables: DishOgTagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DishOgTagsComponent = (props: DishOgTagsComponentProps) => (
      <ApolloReactComponents.Query<DishOgTagsQuery, DishOgTagsQueryVariables> query={DishOgTagsDocument} {...props} />
    );
    

/**
 * __useDishOgTagsQuery__
 *
 * To run a query within a React component, call `useDishOgTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDishOgTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDishOgTagsQuery({
 *   variables: {
 *      shefId: // value for 'shefId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useDishOgTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DishOgTagsQuery, DishOgTagsQueryVariables> & ({ variables: DishOgTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DishOgTagsQuery, DishOgTagsQueryVariables>(DishOgTagsDocument, options);
      }
export function useDishOgTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DishOgTagsQuery, DishOgTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DishOgTagsQuery, DishOgTagsQueryVariables>(DishOgTagsDocument, options);
        }
export function useDishOgTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DishOgTagsQuery, DishOgTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DishOgTagsQuery, DishOgTagsQueryVariables>(DishOgTagsDocument, options);
        }
export type DishOgTagsQueryHookResult = ReturnType<typeof useDishOgTagsQuery>;
export type DishOgTagsLazyQueryHookResult = ReturnType<typeof useDishOgTagsLazyQuery>;
export type DishOgTagsSuspenseQueryHookResult = ReturnType<typeof useDishOgTagsSuspenseQuery>;
export type DishOgTagsQueryResult = ApolloReactCommon.QueryResult<DishOgTagsQuery, DishOgTagsQueryVariables>;
export const ShefProfileByConsumerReferralDocument = gql`
    query ShefProfileByConsumerReferral($code: String!) {
  shefProfileByConsumerReferral(code: $code) {
    id
    userId
    consumerReferralInfo {
      adImageUrl
      code {
        code
      }
    }
    shef {
      firstName
    }
  }
}
    `;
export type ShefProfileByConsumerReferralComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShefProfileByConsumerReferralQuery, ShefProfileByConsumerReferralQueryVariables>, 'query'> & ({ variables: ShefProfileByConsumerReferralQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ShefProfileByConsumerReferralComponent = (props: ShefProfileByConsumerReferralComponentProps) => (
      <ApolloReactComponents.Query<ShefProfileByConsumerReferralQuery, ShefProfileByConsumerReferralQueryVariables> query={ShefProfileByConsumerReferralDocument} {...props} />
    );
    

/**
 * __useShefProfileByConsumerReferralQuery__
 *
 * To run a query within a React component, call `useShefProfileByConsumerReferralQuery` and pass it any options that fit your needs.
 * When your component renders, `useShefProfileByConsumerReferralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShefProfileByConsumerReferralQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useShefProfileByConsumerReferralQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShefProfileByConsumerReferralQuery, ShefProfileByConsumerReferralQueryVariables> & ({ variables: ShefProfileByConsumerReferralQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShefProfileByConsumerReferralQuery, ShefProfileByConsumerReferralQueryVariables>(ShefProfileByConsumerReferralDocument, options);
      }
export function useShefProfileByConsumerReferralLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShefProfileByConsumerReferralQuery, ShefProfileByConsumerReferralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShefProfileByConsumerReferralQuery, ShefProfileByConsumerReferralQueryVariables>(ShefProfileByConsumerReferralDocument, options);
        }
export function useShefProfileByConsumerReferralSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShefProfileByConsumerReferralQuery, ShefProfileByConsumerReferralQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShefProfileByConsumerReferralQuery, ShefProfileByConsumerReferralQueryVariables>(ShefProfileByConsumerReferralDocument, options);
        }
export type ShefProfileByConsumerReferralQueryHookResult = ReturnType<typeof useShefProfileByConsumerReferralQuery>;
export type ShefProfileByConsumerReferralLazyQueryHookResult = ReturnType<typeof useShefProfileByConsumerReferralLazyQuery>;
export type ShefProfileByConsumerReferralSuspenseQueryHookResult = ReturnType<typeof useShefProfileByConsumerReferralSuspenseQuery>;
export type ShefProfileByConsumerReferralQueryResult = ApolloReactCommon.QueryResult<ShefProfileByConsumerReferralQuery, ShefProfileByConsumerReferralQueryVariables>;
export const UserMutationDocument = gql`
    mutation UserMutation($userInput: UserInput!) {
  modifyUser(userInput: $userInput) {
    id
  }
}
    `;
export type UserMutationMutationFn = ApolloReactCommon.MutationFunction<UserMutationMutation, UserMutationMutationVariables>;
export type UserMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UserMutationMutation, UserMutationMutationVariables>, 'mutation'>;

    export const UserMutationComponent = (props: UserMutationComponentProps) => (
      <ApolloReactComponents.Mutation<UserMutationMutation, UserMutationMutationVariables> mutation={UserMutationDocument} {...props} />
    );
    

/**
 * __useUserMutationMutation__
 *
 * To run a mutation, you first call `useUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userMutationMutation, { data, loading, error }] = useUserMutationMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUserMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserMutationMutation, UserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserMutationMutation, UserMutationMutationVariables>(UserMutationDocument, options);
      }
export type UserMutationMutationHookResult = ReturnType<typeof useUserMutationMutation>;
export type UserMutationMutationResult = ApolloReactCommon.MutationResult<UserMutationMutation>;
export type UserMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UserMutationMutation, UserMutationMutationVariables>;
export const BannerDocument = gql`
    query Banner($name: FeatureName!) {
  banner: getConfigValue(name: $name)
}
    `;
export type BannerComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BannerQuery, BannerQueryVariables>, 'query'> & ({ variables: BannerQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BannerComponent = (props: BannerComponentProps) => (
      <ApolloReactComponents.Query<BannerQuery, BannerQueryVariables> query={BannerDocument} {...props} />
    );
    

/**
 * __useBannerQuery__
 *
 * To run a query within a React component, call `useBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannerQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useBannerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BannerQuery, BannerQueryVariables> & ({ variables: BannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BannerQuery, BannerQueryVariables>(BannerDocument, options);
      }
export function useBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BannerQuery, BannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BannerQuery, BannerQueryVariables>(BannerDocument, options);
        }
export function useBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BannerQuery, BannerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BannerQuery, BannerQueryVariables>(BannerDocument, options);
        }
export type BannerQueryHookResult = ReturnType<typeof useBannerQuery>;
export type BannerLazyQueryHookResult = ReturnType<typeof useBannerLazyQuery>;
export type BannerSuspenseQueryHookResult = ReturnType<typeof useBannerSuspenseQuery>;
export type BannerQueryResult = ApolloReactCommon.QueryResult<BannerQuery, BannerQueryVariables>;
export const DeliveryAddressesDocument = gql`
    query DeliveryAddresses($userId: String!) {
  user(userId: $userId) {
    id
    publicName
    activeAddresses {
      ...DeliveryAddressFields
    }
  }
}
    ${DeliveryAddressFieldsFragmentDoc}`;
export type DeliveryAddressesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>, 'query'> & ({ variables: DeliveryAddressesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DeliveryAddressesComponent = (props: DeliveryAddressesComponentProps) => (
      <ApolloReactComponents.Query<DeliveryAddressesQuery, DeliveryAddressesQueryVariables> query={DeliveryAddressesDocument} {...props} />
    );
    

/**
 * __useDeliveryAddressesQuery__
 *
 * To run a query within a React component, call `useDeliveryAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryAddressesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeliveryAddressesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeliveryAddressesQuery, DeliveryAddressesQueryVariables> & ({ variables: DeliveryAddressesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>(DeliveryAddressesDocument, options);
      }
export function useDeliveryAddressesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>(DeliveryAddressesDocument, options);
        }
export function useDeliveryAddressesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>(DeliveryAddressesDocument, options);
        }
export type DeliveryAddressesQueryHookResult = ReturnType<typeof useDeliveryAddressesQuery>;
export type DeliveryAddressesLazyQueryHookResult = ReturnType<typeof useDeliveryAddressesLazyQuery>;
export type DeliveryAddressesSuspenseQueryHookResult = ReturnType<typeof useDeliveryAddressesSuspenseQuery>;
export type DeliveryAddressesQueryResult = ApolloReactCommon.QueryResult<DeliveryAddressesQuery, DeliveryAddressesQueryVariables>;
export const SaveDeliveryAddressDocument = gql`
    mutation SaveDeliveryAddress($addressInput: AddressInput!, $phone: String!, $deliveryNotes: String, $userId: String) {
  saveDeliveryAddress(
    addressInput: $addressInput
    phone: $phone
    deliveryNotes: $deliveryNotes
    userId: $userId
  ) {
    id
  }
}
    `;
export type SaveDeliveryAddressMutationFn = ApolloReactCommon.MutationFunction<SaveDeliveryAddressMutation, SaveDeliveryAddressMutationVariables>;
export type SaveDeliveryAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveDeliveryAddressMutation, SaveDeliveryAddressMutationVariables>, 'mutation'>;

    export const SaveDeliveryAddressComponent = (props: SaveDeliveryAddressComponentProps) => (
      <ApolloReactComponents.Mutation<SaveDeliveryAddressMutation, SaveDeliveryAddressMutationVariables> mutation={SaveDeliveryAddressDocument} {...props} />
    );
    

/**
 * __useSaveDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useSaveDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDeliveryAddressMutation, { data, loading, error }] = useSaveDeliveryAddressMutation({
 *   variables: {
 *      addressInput: // value for 'addressInput'
 *      phone: // value for 'phone'
 *      deliveryNotes: // value for 'deliveryNotes'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSaveDeliveryAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDeliveryAddressMutation, SaveDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDeliveryAddressMutation, SaveDeliveryAddressMutationVariables>(SaveDeliveryAddressDocument, options);
      }
export type SaveDeliveryAddressMutationHookResult = ReturnType<typeof useSaveDeliveryAddressMutation>;
export type SaveDeliveryAddressMutationResult = ApolloReactCommon.MutationResult<SaveDeliveryAddressMutation>;
export type SaveDeliveryAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveDeliveryAddressMutation, SaveDeliveryAddressMutationVariables>;
export const ModifyDeliveryAddressDocument = gql`
    mutation ModifyDeliveryAddress($addressId: Int!, $addressInput: AddressInput, $phone: String, $deliveryNotes: String) {
  modifyDeliveryAddress(
    addressId: $addressId
    addressInput: $addressInput
    phone: $phone
    deliveryNotes: $deliveryNotes
  ) {
    id
  }
}
    `;
export type ModifyDeliveryAddressMutationFn = ApolloReactCommon.MutationFunction<ModifyDeliveryAddressMutation, ModifyDeliveryAddressMutationVariables>;
export type ModifyDeliveryAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ModifyDeliveryAddressMutation, ModifyDeliveryAddressMutationVariables>, 'mutation'>;

    export const ModifyDeliveryAddressComponent = (props: ModifyDeliveryAddressComponentProps) => (
      <ApolloReactComponents.Mutation<ModifyDeliveryAddressMutation, ModifyDeliveryAddressMutationVariables> mutation={ModifyDeliveryAddressDocument} {...props} />
    );
    

/**
 * __useModifyDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useModifyDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyDeliveryAddressMutation, { data, loading, error }] = useModifyDeliveryAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      addressInput: // value for 'addressInput'
 *      phone: // value for 'phone'
 *      deliveryNotes: // value for 'deliveryNotes'
 *   },
 * });
 */
export function useModifyDeliveryAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ModifyDeliveryAddressMutation, ModifyDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ModifyDeliveryAddressMutation, ModifyDeliveryAddressMutationVariables>(ModifyDeliveryAddressDocument, options);
      }
export type ModifyDeliveryAddressMutationHookResult = ReturnType<typeof useModifyDeliveryAddressMutation>;
export type ModifyDeliveryAddressMutationResult = ApolloReactCommon.MutationResult<ModifyDeliveryAddressMutation>;
export type ModifyDeliveryAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<ModifyDeliveryAddressMutation, ModifyDeliveryAddressMutationVariables>;
export const ArchiveDeliveryAddressDocument = gql`
    mutation ArchiveDeliveryAddress($addressId: Int!) {
  archiveDeliveryAddress(addressId: $addressId)
}
    `;
export type ArchiveDeliveryAddressMutationFn = ApolloReactCommon.MutationFunction<ArchiveDeliveryAddressMutation, ArchiveDeliveryAddressMutationVariables>;
export type ArchiveDeliveryAddressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ArchiveDeliveryAddressMutation, ArchiveDeliveryAddressMutationVariables>, 'mutation'>;

    export const ArchiveDeliveryAddressComponent = (props: ArchiveDeliveryAddressComponentProps) => (
      <ApolloReactComponents.Mutation<ArchiveDeliveryAddressMutation, ArchiveDeliveryAddressMutationVariables> mutation={ArchiveDeliveryAddressDocument} {...props} />
    );
    

/**
 * __useArchiveDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useArchiveDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDeliveryAddressMutation, { data, loading, error }] = useArchiveDeliveryAddressMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function useArchiveDeliveryAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveDeliveryAddressMutation, ArchiveDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveDeliveryAddressMutation, ArchiveDeliveryAddressMutationVariables>(ArchiveDeliveryAddressDocument, options);
      }
export type ArchiveDeliveryAddressMutationHookResult = ReturnType<typeof useArchiveDeliveryAddressMutation>;
export type ArchiveDeliveryAddressMutationResult = ApolloReactCommon.MutationResult<ArchiveDeliveryAddressMutation>;
export type ArchiveDeliveryAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveDeliveryAddressMutation, ArchiveDeliveryAddressMutationVariables>;
export const GetSignedUrlDocument = gql`
    mutation GetSignedUrl($input: SignedUrlInput!) {
  getSignedUrl(input: $input) {
    ...FileUploadInfo
  }
}
    ${FileUploadInfoFragmentDoc}`;
export type GetSignedUrlMutationFn = ApolloReactCommon.MutationFunction<GetSignedUrlMutation, GetSignedUrlMutationVariables>;
export type GetSignedUrlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<GetSignedUrlMutation, GetSignedUrlMutationVariables>, 'mutation'>;

    export const GetSignedUrlComponent = (props: GetSignedUrlComponentProps) => (
      <ApolloReactComponents.Mutation<GetSignedUrlMutation, GetSignedUrlMutationVariables> mutation={GetSignedUrlDocument} {...props} />
    );
    

/**
 * __useGetSignedUrlMutation__
 *
 * To run a mutation, you first call `useGetSignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSignedUrlMutation, { data, loading, error }] = useGetSignedUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSignedUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GetSignedUrlMutation, GetSignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GetSignedUrlMutation, GetSignedUrlMutationVariables>(GetSignedUrlDocument, options);
      }
export type GetSignedUrlMutationHookResult = ReturnType<typeof useGetSignedUrlMutation>;
export type GetSignedUrlMutationResult = ApolloReactCommon.MutationResult<GetSignedUrlMutation>;
export type GetSignedUrlMutationOptions = ApolloReactCommon.BaseMutationOptions<GetSignedUrlMutation, GetSignedUrlMutationVariables>;
export const UpdateCurrentUserDocument = gql`
    query UpdateCurrentUser {
  me {
    ...CurrentUserFields
  }
}
    ${CurrentUserFieldsFragmentDoc}`;
export type UpdateCurrentUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UpdateCurrentUserQuery, UpdateCurrentUserQueryVariables>, 'query'>;

    export const UpdateCurrentUserComponent = (props: UpdateCurrentUserComponentProps) => (
      <ApolloReactComponents.Query<UpdateCurrentUserQuery, UpdateCurrentUserQueryVariables> query={UpdateCurrentUserDocument} {...props} />
    );
    

/**
 * __useUpdateCurrentUserQuery__
 *
 * To run a query within a React component, call `useUpdateCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UpdateCurrentUserQuery, UpdateCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UpdateCurrentUserQuery, UpdateCurrentUserQueryVariables>(UpdateCurrentUserDocument, options);
      }
export function useUpdateCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UpdateCurrentUserQuery, UpdateCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UpdateCurrentUserQuery, UpdateCurrentUserQueryVariables>(UpdateCurrentUserDocument, options);
        }
export function useUpdateCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UpdateCurrentUserQuery, UpdateCurrentUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UpdateCurrentUserQuery, UpdateCurrentUserQueryVariables>(UpdateCurrentUserDocument, options);
        }
export type UpdateCurrentUserQueryHookResult = ReturnType<typeof useUpdateCurrentUserQuery>;
export type UpdateCurrentUserLazyQueryHookResult = ReturnType<typeof useUpdateCurrentUserLazyQuery>;
export type UpdateCurrentUserSuspenseQueryHookResult = ReturnType<typeof useUpdateCurrentUserSuspenseQuery>;
export type UpdateCurrentUserQueryResult = ApolloReactCommon.QueryResult<UpdateCurrentUserQuery, UpdateCurrentUserQueryVariables>;
export const DontUseThisDirectlyUseTheHookDocument = gql`
    query DontUseThisDirectlyUseTheHook($url: String!) {
  getOrCreateShortUrl(fullUrl: $url) {
    shortUrl
  }
}
    `;
export type DontUseThisDirectlyUseTheHookComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DontUseThisDirectlyUseTheHookQuery, DontUseThisDirectlyUseTheHookQueryVariables>, 'query'> & ({ variables: DontUseThisDirectlyUseTheHookQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DontUseThisDirectlyUseTheHookComponent = (props: DontUseThisDirectlyUseTheHookComponentProps) => (
      <ApolloReactComponents.Query<DontUseThisDirectlyUseTheHookQuery, DontUseThisDirectlyUseTheHookQueryVariables> query={DontUseThisDirectlyUseTheHookDocument} {...props} />
    );
    

/**
 * __useDontUseThisDirectlyUseTheHookQuery__
 *
 * To run a query within a React component, call `useDontUseThisDirectlyUseTheHookQuery` and pass it any options that fit your needs.
 * When your component renders, `useDontUseThisDirectlyUseTheHookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDontUseThisDirectlyUseTheHookQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useDontUseThisDirectlyUseTheHookQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DontUseThisDirectlyUseTheHookQuery, DontUseThisDirectlyUseTheHookQueryVariables> & ({ variables: DontUseThisDirectlyUseTheHookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DontUseThisDirectlyUseTheHookQuery, DontUseThisDirectlyUseTheHookQueryVariables>(DontUseThisDirectlyUseTheHookDocument, options);
      }
export function useDontUseThisDirectlyUseTheHookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DontUseThisDirectlyUseTheHookQuery, DontUseThisDirectlyUseTheHookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DontUseThisDirectlyUseTheHookQuery, DontUseThisDirectlyUseTheHookQueryVariables>(DontUseThisDirectlyUseTheHookDocument, options);
        }
export function useDontUseThisDirectlyUseTheHookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DontUseThisDirectlyUseTheHookQuery, DontUseThisDirectlyUseTheHookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DontUseThisDirectlyUseTheHookQuery, DontUseThisDirectlyUseTheHookQueryVariables>(DontUseThisDirectlyUseTheHookDocument, options);
        }
export type DontUseThisDirectlyUseTheHookQueryHookResult = ReturnType<typeof useDontUseThisDirectlyUseTheHookQuery>;
export type DontUseThisDirectlyUseTheHookLazyQueryHookResult = ReturnType<typeof useDontUseThisDirectlyUseTheHookLazyQuery>;
export type DontUseThisDirectlyUseTheHookSuspenseQueryHookResult = ReturnType<typeof useDontUseThisDirectlyUseTheHookSuspenseQuery>;
export type DontUseThisDirectlyUseTheHookQueryResult = ApolloReactCommon.QueryResult<DontUseThisDirectlyUseTheHookQuery, DontUseThisDirectlyUseTheHookQueryVariables>;
export const OrganizationDocument = gql`
    query Organization($slug: String!) {
  organization(slug: $slug) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type OrganizationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrganizationQuery, OrganizationQueryVariables>, 'query'> & ({ variables: OrganizationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrganizationComponent = (props: OrganizationComponentProps) => (
      <ApolloReactComponents.Query<OrganizationQuery, OrganizationQueryVariables> query={OrganizationDocument} {...props} />
    );
    

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables> & ({ variables: OrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export function useOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationSuspenseQueryHookResult = ReturnType<typeof useOrganizationSuspenseQuery>;
export type OrganizationQueryResult = ApolloReactCommon.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const ZipCodeDocument = gql`
    query ZipCode($zipCode: String!) {
  zipCode(zipCode: $zipCode) {
    zipCode
    timeZone
    availableToCustomers
  }
}
    `;
export type ZipCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ZipCodeQuery, ZipCodeQueryVariables>, 'query'> & ({ variables: ZipCodeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ZipCodeComponent = (props: ZipCodeComponentProps) => (
      <ApolloReactComponents.Query<ZipCodeQuery, ZipCodeQueryVariables> query={ZipCodeDocument} {...props} />
    );
    

/**
 * __useZipCodeQuery__
 *
 * To run a query within a React component, call `useZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZipCodeQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useZipCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ZipCodeQuery, ZipCodeQueryVariables> & ({ variables: ZipCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ZipCodeQuery, ZipCodeQueryVariables>(ZipCodeDocument, options);
      }
export function useZipCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ZipCodeQuery, ZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ZipCodeQuery, ZipCodeQueryVariables>(ZipCodeDocument, options);
        }
export function useZipCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ZipCodeQuery, ZipCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ZipCodeQuery, ZipCodeQueryVariables>(ZipCodeDocument, options);
        }
export type ZipCodeQueryHookResult = ReturnType<typeof useZipCodeQuery>;
export type ZipCodeLazyQueryHookResult = ReturnType<typeof useZipCodeLazyQuery>;
export type ZipCodeSuspenseQueryHookResult = ReturnType<typeof useZipCodeSuspenseQuery>;
export type ZipCodeQueryResult = ApolloReactCommon.QueryResult<ZipCodeQuery, ZipCodeQueryVariables>;
export const GlobalInitialStateDocument = gql`
    query GlobalInitialState($zipCode: String) {
  me {
    ...CurrentUserFields
  }
  zipCode(zipCode: $zipCode) {
    zipCode
    regionId
    timeZone
    minimumAmountForDiscountedShipping
    discountedDeliveryFee
    deliveryFee
    region {
      id
      name
    }
    upfrontDeliveryFeeEnabled
  }
  carts {
    ...WholeCarts
  }
  availableAddOnItems(zipCode: $zipCode) {
    ...WholeAddOnItem
  }
  rateRecentOrderPopupEnabled: isFeatureOn(
    name: RATE_RECENT_ORDER_POPUP_ENABLED
    zipCode: $zipCode
  )
  shefRatingEnabled: isFeatureOn(name: SHEF_RATING, zipCode: $zipCode)
  appleSignInOnWebEnabled: isFeatureOn(name: APPLE_SIGN_IN_ON_WEB_ENABLED)
  upsellsEnabled: isFeatureOn(name: UPSELLS_ENABLED)
  apiSyncEnabled: isFeatureOn(name: API_SYNC_ENABLED, zipCode: $zipCode)
  profilePaymentMethodsEnabled: isFeatureOn(
    name: PROFILE_PAYMENT_METHODS_ENABLED
    zipCode: $zipCode
  )
  profileDeliveryAddressesEnabled: isFeatureOn(
    name: PROFILE_DELIVERY_ADDRESSES_ENABLED
    zipCode: $zipCode
  )
  giftCardPurchaseEnabled: isFeatureOn(
    name: GIFT_CARD_PURCHASE_ENABLED
    zipCode: $zipCode
  )
  disableAdminPages: isFeatureOn(name: DISABLE_ADMIN_PAGES)
  holidayMenusEnabled: isFeatureOn(name: HOLIDAY_MENUS_ENABLED)
  foodItemAudits: isFeatureOn(name: FOOD_ITEM_AUDITS, zipCode: $zipCode)
  shefPlatformUsageQuestionnaire: isFeatureOn(
    name: SHEF_PLATFORM_USAGE_QUESTIONNAIRE
  )
  dishwasher: isFeatureOn(name: DISHWASHER_ENABLED)
  dishFirstNav: isFeatureOn(name: DISH_FIRST_NAV_ENABLED, zipCode: $zipCode)
  shefDashboardInsights: isFeatureOn(name: SHEF_DASHBOARD_INSIGHTS)
  requestAppReviewsEnabled: isFeatureOn(name: REQUEST_APP_REVIEWS_ENABLED)
  shefMenuChecklistEnabled: isFeatureOn(name: SHEF_MENU_CHECKLIST_ENABLED)
  shefPostsEnabled: isFeatureOn(name: SHEF_POSTS_ENABLED)
  chatEnabled: isFeatureOn(name: CHAT_ENABLED)
  shefApplicationAlwaysEnableContinueInformationSessionVideo: isFeatureOn(
    name: SHEF_APPLICATION_ALWAYS_ENABLE_CONTINUE_INFORMATION_SESSION_VIDEO
  )
  consumerDeleteUserEnabled: isFeatureOn(name: CONSUMER_DELETE_USER_ENABLED)
  shefGrowYourBusinessEnabled: isFeatureOn(name: SHEF_GROW_YOUR_BUSINESS_ENABLED)
  personalShefEnabled: isFeatureOn(name: PERSONAL_SHEF_ENABLED)
  shefSideCustomizations: isFeatureOn(name: SHEF_SIDE_CUSTOMIZATIONS)
  fringeOverrideEnabled: isFeatureOn(name: FRINGE_OVERRIDE_ENABLED)
  bulkDiscountEnabled: isFeatureOn(name: BULK_DISCOUNT_ENABLED)
  chatSupportKeywords: getConfigValue(name: CHAT_SUPPORT_KEYWORDS)
  chatFeedbackKeywords: getConfigValue(name: CHAT_FEEDBACK_KEYWORDS)
  chatCustomizationKeywords: getConfigValue(name: CHAT_CUSTOMIZATION_KEYWORDS)
  chatBusinessRiskKeywords: getConfigValue(name: CHAT_BUSINESS_RISK_KEYWORDS)
  mealPlansEnabled: isFeatureOn(name: MEAL_PLANS_ENABLED)
  mealPlansAllergensEnabled: isFeatureOn(name: MEAL_PLANS_ALLERGENS_ENABLED)
  mealPlansBrowseAsGuest: isFeatureOn(name: MEAL_PLANS_BROWSE_AS_GUEST)
  showManageMealPlans: isFeatureOn(name: SHOW_MANAGE_MEAL_PLANS)
  flexibleSidesEnabled: isFeatureOn(name: FLEXIBLE_SIDES_ENABLED)
  isIntakeRevampEnabled: isFeatureOn(name: IS_INTAKE_REVAMP_ENABLED)
  reusablePackagingEnabled: isFeatureOn(name: REUSABLE_PACKAGING_ENABLED)
  shefRosterEnabled: isFeatureOn(name: SHEF_ROSTER_ENABLED)
  emptyHeldOrdersEnabled: isFeatureOn(name: EMPTY_HELD_ORDERS_ENABLED)
  mealPlanModificationEnabled: isFeatureOn(name: MEAL_PLAN_MODIFICATION_ENABLED)
  weeklyShefServiceMenuTemplateEnabled: isFeatureOn(
    name: WEEKLY_SHEF_SERVICE_MENU_TEMPLATE_ENABLED
  )
}
    ${CurrentUserFieldsFragmentDoc}
${WholeCartsFragmentDoc}
${WholeAddOnItemFragmentDoc}`;
export type GlobalInitialStateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GlobalInitialStateQuery, GlobalInitialStateQueryVariables>, 'query'>;

    export const GlobalInitialStateComponent = (props: GlobalInitialStateComponentProps) => (
      <ApolloReactComponents.Query<GlobalInitialStateQuery, GlobalInitialStateQueryVariables> query={GlobalInitialStateDocument} {...props} />
    );
    

/**
 * __useGlobalInitialStateQuery__
 *
 * To run a query within a React component, call `useGlobalInitialStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalInitialStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalInitialStateQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useGlobalInitialStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalInitialStateQuery, GlobalInitialStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalInitialStateQuery, GlobalInitialStateQueryVariables>(GlobalInitialStateDocument, options);
      }
export function useGlobalInitialStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalInitialStateQuery, GlobalInitialStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalInitialStateQuery, GlobalInitialStateQueryVariables>(GlobalInitialStateDocument, options);
        }
export function useGlobalInitialStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalInitialStateQuery, GlobalInitialStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalInitialStateQuery, GlobalInitialStateQueryVariables>(GlobalInitialStateDocument, options);
        }
export type GlobalInitialStateQueryHookResult = ReturnType<typeof useGlobalInitialStateQuery>;
export type GlobalInitialStateLazyQueryHookResult = ReturnType<typeof useGlobalInitialStateLazyQuery>;
export type GlobalInitialStateSuspenseQueryHookResult = ReturnType<typeof useGlobalInitialStateSuspenseQuery>;
export type GlobalInitialStateQueryResult = ApolloReactCommon.QueryResult<GlobalInitialStateQuery, GlobalInitialStateQueryVariables>;
export const SaveCartsDocument = gql`
    mutation SaveCarts($cartLineItemInputs: [CartLineItemInput!]!) {
  setCartItems(cartLineItemInputs: $cartLineItemInputs) {
    id
  }
}
    `;
export type SaveCartsMutationFn = ApolloReactCommon.MutationFunction<SaveCartsMutation, SaveCartsMutationVariables>;
export type SaveCartsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SaveCartsMutation, SaveCartsMutationVariables>, 'mutation'>;

    export const SaveCartsComponent = (props: SaveCartsComponentProps) => (
      <ApolloReactComponents.Mutation<SaveCartsMutation, SaveCartsMutationVariables> mutation={SaveCartsDocument} {...props} />
    );
    

/**
 * __useSaveCartsMutation__
 *
 * To run a mutation, you first call `useSaveCartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCartsMutation, { data, loading, error }] = useSaveCartsMutation({
 *   variables: {
 *      cartLineItemInputs: // value for 'cartLineItemInputs'
 *   },
 * });
 */
export function useSaveCartsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCartsMutation, SaveCartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCartsMutation, SaveCartsMutationVariables>(SaveCartsDocument, options);
      }
export type SaveCartsMutationHookResult = ReturnType<typeof useSaveCartsMutation>;
export type SaveCartsMutationResult = ApolloReactCommon.MutationResult<SaveCartsMutation>;
export type SaveCartsMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveCartsMutation, SaveCartsMutationVariables>;
export const CartItemsSaveDocument = gql`
    mutation CartItemsSave($cartLineItemInputs: [CartLineItemInput!]!, $deliveryDate: DateTime!) {
  cartSetLineItems(
    cartLineItemInputs: $cartLineItemInputs
    deliveryDate: $deliveryDate
  ) {
    ...WholeCarts
    bulkDiscountTiers {
      ...CartBulkDiscountTier
    }
  }
}
    ${WholeCartsFragmentDoc}
${CartBulkDiscountTierFragmentDoc}`;
export type CartItemsSaveMutationFn = ApolloReactCommon.MutationFunction<CartItemsSaveMutation, CartItemsSaveMutationVariables>;
export type CartItemsSaveComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CartItemsSaveMutation, CartItemsSaveMutationVariables>, 'mutation'>;

    export const CartItemsSaveComponent = (props: CartItemsSaveComponentProps) => (
      <ApolloReactComponents.Mutation<CartItemsSaveMutation, CartItemsSaveMutationVariables> mutation={CartItemsSaveDocument} {...props} />
    );
    

/**
 * __useCartItemsSaveMutation__
 *
 * To run a mutation, you first call `useCartItemsSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartItemsSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartItemsSaveMutation, { data, loading, error }] = useCartItemsSaveMutation({
 *   variables: {
 *      cartLineItemInputs: // value for 'cartLineItemInputs'
 *      deliveryDate: // value for 'deliveryDate'
 *   },
 * });
 */
export function useCartItemsSaveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CartItemsSaveMutation, CartItemsSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CartItemsSaveMutation, CartItemsSaveMutationVariables>(CartItemsSaveDocument, options);
      }
export type CartItemsSaveMutationHookResult = ReturnType<typeof useCartItemsSaveMutation>;
export type CartItemsSaveMutationResult = ApolloReactCommon.MutationResult<CartItemsSaveMutation>;
export type CartItemsSaveMutationOptions = ApolloReactCommon.BaseMutationOptions<CartItemsSaveMutation, CartItemsSaveMutationVariables>;
export const CartsClearDocument = gql`
    mutation CartsClear($shefIds: [String!]!) {
  cartClearItems(shefIds: $shefIds) {
    ...WholeCarts
  }
}
    ${WholeCartsFragmentDoc}`;
export type CartsClearMutationFn = ApolloReactCommon.MutationFunction<CartsClearMutation, CartsClearMutationVariables>;
export type CartsClearComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CartsClearMutation, CartsClearMutationVariables>, 'mutation'>;

    export const CartsClearComponent = (props: CartsClearComponentProps) => (
      <ApolloReactComponents.Mutation<CartsClearMutation, CartsClearMutationVariables> mutation={CartsClearDocument} {...props} />
    );
    

/**
 * __useCartsClearMutation__
 *
 * To run a mutation, you first call `useCartsClearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartsClearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartsClearMutation, { data, loading, error }] = useCartsClearMutation({
 *   variables: {
 *      shefIds: // value for 'shefIds'
 *   },
 * });
 */
export function useCartsClearMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CartsClearMutation, CartsClearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CartsClearMutation, CartsClearMutationVariables>(CartsClearDocument, options);
      }
export type CartsClearMutationHookResult = ReturnType<typeof useCartsClearMutation>;
export type CartsClearMutationResult = ApolloReactCommon.MutationResult<CartsClearMutation>;
export type CartsClearMutationOptions = ApolloReactCommon.BaseMutationOptions<CartsClearMutation, CartsClearMutationVariables>;
export const CartsDocument = gql`
    query Carts($zipCode: String!) {
  carts {
    ...WholeCarts
    bulkDiscountTiers {
      ...CartBulkDiscountTier
    }
  }
  exploreFoodItemsFilterOptions(zipCode: $zipCode, filters: {}) {
    availableDeliveryDays {
      date
    }
  }
}
    ${WholeCartsFragmentDoc}
${CartBulkDiscountTierFragmentDoc}`;
export type CartsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CartsQuery, CartsQueryVariables>, 'query'> & ({ variables: CartsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CartsComponent = (props: CartsComponentProps) => (
      <ApolloReactComponents.Query<CartsQuery, CartsQueryVariables> query={CartsDocument} {...props} />
    );
    

/**
 * __useCartsQuery__
 *
 * To run a query within a React component, call `useCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartsQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useCartsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CartsQuery, CartsQueryVariables> & ({ variables: CartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CartsQuery, CartsQueryVariables>(CartsDocument, options);
      }
export function useCartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartsQuery, CartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CartsQuery, CartsQueryVariables>(CartsDocument, options);
        }
export function useCartsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CartsQuery, CartsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CartsQuery, CartsQueryVariables>(CartsDocument, options);
        }
export type CartsQueryHookResult = ReturnType<typeof useCartsQuery>;
export type CartsLazyQueryHookResult = ReturnType<typeof useCartsLazyQuery>;
export type CartsSuspenseQueryHookResult = ReturnType<typeof useCartsSuspenseQuery>;
export type CartsQueryResult = ApolloReactCommon.QueryResult<CartsQuery, CartsQueryVariables>;
export const CartFoodItemsDocument = gql`
    query CartFoodItems($foodItemIds: [Int!]!) {
  foodItems(foodItemIds: $foodItemIds) {
    ...CartFoodItem
  }
}
    ${CartFoodItemFragmentDoc}`;
export type CartFoodItemsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CartFoodItemsQuery, CartFoodItemsQueryVariables>, 'query'> & ({ variables: CartFoodItemsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CartFoodItemsComponent = (props: CartFoodItemsComponentProps) => (
      <ApolloReactComponents.Query<CartFoodItemsQuery, CartFoodItemsQueryVariables> query={CartFoodItemsDocument} {...props} />
    );
    

/**
 * __useCartFoodItemsQuery__
 *
 * To run a query within a React component, call `useCartFoodItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartFoodItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartFoodItemsQuery({
 *   variables: {
 *      foodItemIds: // value for 'foodItemIds'
 *   },
 * });
 */
export function useCartFoodItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CartFoodItemsQuery, CartFoodItemsQueryVariables> & ({ variables: CartFoodItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CartFoodItemsQuery, CartFoodItemsQueryVariables>(CartFoodItemsDocument, options);
      }
export function useCartFoodItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartFoodItemsQuery, CartFoodItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CartFoodItemsQuery, CartFoodItemsQueryVariables>(CartFoodItemsDocument, options);
        }
export function useCartFoodItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CartFoodItemsQuery, CartFoodItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CartFoodItemsQuery, CartFoodItemsQueryVariables>(CartFoodItemsDocument, options);
        }
export type CartFoodItemsQueryHookResult = ReturnType<typeof useCartFoodItemsQuery>;
export type CartFoodItemsLazyQueryHookResult = ReturnType<typeof useCartFoodItemsLazyQuery>;
export type CartFoodItemsSuspenseQueryHookResult = ReturnType<typeof useCartFoodItemsSuspenseQuery>;
export type CartFoodItemsQueryResult = ApolloReactCommon.QueryResult<CartFoodItemsQuery, CartFoodItemsQueryVariables>;
export const CartShefsDocument = gql`
    query CartShefs($shefIds: [String!]!) {
  shefs(userIds: $shefIds) {
    id
    firstName
    timeZone
    imageUrl
    celebrityEventType
    availability {
      id
      availabilityDate
      isSoldOut
      numDishesAvailable
    }
    shefProfile {
      cuisineRegion
      businessName
      cutoffMsBeforeDeliveryDate
      dishCapacity
      isTrialShef
    }
  }
}
    `;
export type CartShefsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CartShefsQuery, CartShefsQueryVariables>, 'query'> & ({ variables: CartShefsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CartShefsComponent = (props: CartShefsComponentProps) => (
      <ApolloReactComponents.Query<CartShefsQuery, CartShefsQueryVariables> query={CartShefsDocument} {...props} />
    );
    

/**
 * __useCartShefsQuery__
 *
 * To run a query within a React component, call `useCartShefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartShefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartShefsQuery({
 *   variables: {
 *      shefIds: // value for 'shefIds'
 *   },
 * });
 */
export function useCartShefsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CartShefsQuery, CartShefsQueryVariables> & ({ variables: CartShefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CartShefsQuery, CartShefsQueryVariables>(CartShefsDocument, options);
      }
export function useCartShefsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartShefsQuery, CartShefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CartShefsQuery, CartShefsQueryVariables>(CartShefsDocument, options);
        }
export function useCartShefsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CartShefsQuery, CartShefsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CartShefsQuery, CartShefsQueryVariables>(CartShefsDocument, options);
        }
export type CartShefsQueryHookResult = ReturnType<typeof useCartShefsQuery>;
export type CartShefsLazyQueryHookResult = ReturnType<typeof useCartShefsLazyQuery>;
export type CartShefsSuspenseQueryHookResult = ReturnType<typeof useCartShefsSuspenseQuery>;
export type CartShefsQueryResult = ApolloReactCommon.QueryResult<CartShefsQuery, CartShefsQueryVariables>;
export const IngestAnalyticsEventDocument = gql`
    mutation IngestAnalyticsEvent($eventName: String!, $data: String) {
  ingestAnalyticsEvent(eventName: $eventName, data: $data)
}
    `;
export type IngestAnalyticsEventMutationFn = ApolloReactCommon.MutationFunction<IngestAnalyticsEventMutation, IngestAnalyticsEventMutationVariables>;
export type IngestAnalyticsEventComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<IngestAnalyticsEventMutation, IngestAnalyticsEventMutationVariables>, 'mutation'>;

    export const IngestAnalyticsEventComponent = (props: IngestAnalyticsEventComponentProps) => (
      <ApolloReactComponents.Mutation<IngestAnalyticsEventMutation, IngestAnalyticsEventMutationVariables> mutation={IngestAnalyticsEventDocument} {...props} />
    );
    

/**
 * __useIngestAnalyticsEventMutation__
 *
 * To run a mutation, you first call `useIngestAnalyticsEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIngestAnalyticsEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ingestAnalyticsEventMutation, { data, loading, error }] = useIngestAnalyticsEventMutation({
 *   variables: {
 *      eventName: // value for 'eventName'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useIngestAnalyticsEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IngestAnalyticsEventMutation, IngestAnalyticsEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IngestAnalyticsEventMutation, IngestAnalyticsEventMutationVariables>(IngestAnalyticsEventDocument, options);
      }
export type IngestAnalyticsEventMutationHookResult = ReturnType<typeof useIngestAnalyticsEventMutation>;
export type IngestAnalyticsEventMutationResult = ApolloReactCommon.MutationResult<IngestAnalyticsEventMutation>;
export type IngestAnalyticsEventMutationOptions = ApolloReactCommon.BaseMutationOptions<IngestAnalyticsEventMutation, IngestAnalyticsEventMutationVariables>;
export const FacebookTrackEventDocument = gql`
    mutation FacebookTrackEvent($eventName: String!, $event: FacebookEvent!) {
  ingestFacebookEvent(eventName: $eventName, event: $event)
}
    `;
export type FacebookTrackEventMutationFn = ApolloReactCommon.MutationFunction<FacebookTrackEventMutation, FacebookTrackEventMutationVariables>;
export type FacebookTrackEventComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<FacebookTrackEventMutation, FacebookTrackEventMutationVariables>, 'mutation'>;

    export const FacebookTrackEventComponent = (props: FacebookTrackEventComponentProps) => (
      <ApolloReactComponents.Mutation<FacebookTrackEventMutation, FacebookTrackEventMutationVariables> mutation={FacebookTrackEventDocument} {...props} />
    );
    

/**
 * __useFacebookTrackEventMutation__
 *
 * To run a mutation, you first call `useFacebookTrackEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFacebookTrackEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [facebookTrackEventMutation, { data, loading, error }] = useFacebookTrackEventMutation({
 *   variables: {
 *      eventName: // value for 'eventName'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useFacebookTrackEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FacebookTrackEventMutation, FacebookTrackEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FacebookTrackEventMutation, FacebookTrackEventMutationVariables>(FacebookTrackEventDocument, options);
      }
export type FacebookTrackEventMutationHookResult = ReturnType<typeof useFacebookTrackEventMutation>;
export type FacebookTrackEventMutationResult = ApolloReactCommon.MutationResult<FacebookTrackEventMutation>;
export type FacebookTrackEventMutationOptions = ApolloReactCommon.BaseMutationOptions<FacebookTrackEventMutation, FacebookTrackEventMutationVariables>;
export const UseCachedZipCodeDocument = gql`
    query UseCachedZipCode($zipcode: String!) {
  zipCode(zipCode: $zipcode) {
    ...CachedZipCode
  }
}
    ${CachedZipCodeFragmentDoc}`;
export type UseCachedZipCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UseCachedZipCodeQuery, UseCachedZipCodeQueryVariables>, 'query'> & ({ variables: UseCachedZipCodeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UseCachedZipCodeComponent = (props: UseCachedZipCodeComponentProps) => (
      <ApolloReactComponents.Query<UseCachedZipCodeQuery, UseCachedZipCodeQueryVariables> query={UseCachedZipCodeDocument} {...props} />
    );
    

/**
 * __useUseCachedZipCodeQuery__
 *
 * To run a query within a React component, call `useUseCachedZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseCachedZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseCachedZipCodeQuery({
 *   variables: {
 *      zipcode: // value for 'zipcode'
 *   },
 * });
 */
export function useUseCachedZipCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UseCachedZipCodeQuery, UseCachedZipCodeQueryVariables> & ({ variables: UseCachedZipCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UseCachedZipCodeQuery, UseCachedZipCodeQueryVariables>(UseCachedZipCodeDocument, options);
      }
export function useUseCachedZipCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UseCachedZipCodeQuery, UseCachedZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UseCachedZipCodeQuery, UseCachedZipCodeQueryVariables>(UseCachedZipCodeDocument, options);
        }
export function useUseCachedZipCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UseCachedZipCodeQuery, UseCachedZipCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UseCachedZipCodeQuery, UseCachedZipCodeQueryVariables>(UseCachedZipCodeDocument, options);
        }
export type UseCachedZipCodeQueryHookResult = ReturnType<typeof useUseCachedZipCodeQuery>;
export type UseCachedZipCodeLazyQueryHookResult = ReturnType<typeof useUseCachedZipCodeLazyQuery>;
export type UseCachedZipCodeSuspenseQueryHookResult = ReturnType<typeof useUseCachedZipCodeSuspenseQuery>;
export type UseCachedZipCodeQueryResult = ApolloReactCommon.QueryResult<UseCachedZipCodeQuery, UseCachedZipCodeQueryVariables>;
export const ModifyUserPhoneDocument = gql`
    mutation modifyUserPhone($phone: String!) {
  modifyUserPhone(phone: $phone) {
    id
    phone
  }
}
    `;
export type ModifyUserPhoneMutationFn = ApolloReactCommon.MutationFunction<ModifyUserPhoneMutation, ModifyUserPhoneMutationVariables>;
export type ModifyUserPhoneComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ModifyUserPhoneMutation, ModifyUserPhoneMutationVariables>, 'mutation'>;

    export const ModifyUserPhoneComponent = (props: ModifyUserPhoneComponentProps) => (
      <ApolloReactComponents.Mutation<ModifyUserPhoneMutation, ModifyUserPhoneMutationVariables> mutation={ModifyUserPhoneDocument} {...props} />
    );
    

/**
 * __useModifyUserPhoneMutation__
 *
 * To run a mutation, you first call `useModifyUserPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyUserPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyUserPhoneMutation, { data, loading, error }] = useModifyUserPhoneMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useModifyUserPhoneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ModifyUserPhoneMutation, ModifyUserPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ModifyUserPhoneMutation, ModifyUserPhoneMutationVariables>(ModifyUserPhoneDocument, options);
      }
export type ModifyUserPhoneMutationHookResult = ReturnType<typeof useModifyUserPhoneMutation>;
export type ModifyUserPhoneMutationResult = ApolloReactCommon.MutationResult<ModifyUserPhoneMutation>;
export type ModifyUserPhoneMutationOptions = ApolloReactCommon.BaseMutationOptions<ModifyUserPhoneMutation, ModifyUserPhoneMutationVariables>;
export const WaitlistRanksDocument = gql`
    query WaitlistRanks {
  waitlistRanks {
    totalUsers
    rank
    waitlistType
  }
}
    `;
export type WaitlistRanksComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WaitlistRanksQuery, WaitlistRanksQueryVariables>, 'query'>;

    export const WaitlistRanksComponent = (props: WaitlistRanksComponentProps) => (
      <ApolloReactComponents.Query<WaitlistRanksQuery, WaitlistRanksQueryVariables> query={WaitlistRanksDocument} {...props} />
    );
    

/**
 * __useWaitlistRanksQuery__
 *
 * To run a query within a React component, call `useWaitlistRanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitlistRanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitlistRanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useWaitlistRanksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WaitlistRanksQuery, WaitlistRanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WaitlistRanksQuery, WaitlistRanksQueryVariables>(WaitlistRanksDocument, options);
      }
export function useWaitlistRanksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WaitlistRanksQuery, WaitlistRanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WaitlistRanksQuery, WaitlistRanksQueryVariables>(WaitlistRanksDocument, options);
        }
export function useWaitlistRanksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WaitlistRanksQuery, WaitlistRanksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WaitlistRanksQuery, WaitlistRanksQueryVariables>(WaitlistRanksDocument, options);
        }
export type WaitlistRanksQueryHookResult = ReturnType<typeof useWaitlistRanksQuery>;
export type WaitlistRanksLazyQueryHookResult = ReturnType<typeof useWaitlistRanksLazyQuery>;
export type WaitlistRanksSuspenseQueryHookResult = ReturnType<typeof useWaitlistRanksSuspenseQuery>;
export type WaitlistRanksQueryResult = ApolloReactCommon.QueryResult<WaitlistRanksQuery, WaitlistRanksQueryVariables>;